/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		56: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"0":"5a80e7fb","1":"1777a9cd","2":"cdeaf38c","3":"c93b99d1","4":"f6a31274","5":"c8ed18a9","6":"34308fa4","7":"b482baeb","8":"05bb19ec","9":"a3bc5f2c","10":"72fdc2ce","11":"4543f6af","12":"dd423d56","13":"9cc84e3c","14":"2586f88d","15":"3df25e54","16":"4081e577","17":"786661fe","18":"ec48f7f6","19":"0ae9976e","20":"7c24d239","21":"28639a86","22":"23d086c7","23":"08a2421a","24":"7c17779b","25":"26d5089e","26":"ce18f6e0","27":"a1a5d43b","28":"b52ecb72","29":"c8169a5f","30":"f09bdc5d","31":"628f6163","32":"f4dfde80","33":"5a190baf","34":"ec90eeef","35":"fb4a0662","36":"156a038e","37":"758c4930","38":"de10b555","39":"d218e384","40":"8f46399b","41":"67767a6c","42":"e24830cd","43":"7b43c9ed","44":"a87e746f","45":"ec900f54","46":"bd60be68","47":"cbefd6ea","48":"89ab3ab1","49":"39a0f58e","50":"2eefaa8b","51":"81cbbf77","52":"6c503d84","53":"a4dc2c59","54":"9c7b3c27","55":"7664503d"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 286);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(340);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(348)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(439);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Alert", function() { return Alert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Container", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Row", function() { return Row; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Col", function() { return Col; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Navbar", function() { return Navbar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavbarBrand", function() { return NavbarBrand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavbarToggler", function() { return NavbarToggler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Nav", function() { return Nav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavItem", function() { return NavItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavDropdown", function() { return NavDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return NavLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumb", function() { return Breadcrumb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BreadcrumbItem", function() { return BreadcrumbItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonDropdown", function() { return ButtonDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return ButtonGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonToolbar", function() { return ButtonToolbar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Dropdown", function() { return Dropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownItem", function() { return DropdownItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownMenu", function() { return DropdownMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownToggle", function() { return DropdownToggle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Fade", function() { return Fade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return Badge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Card", function() { return Card; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardLink", function() { return CardLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardGroup", function() { return CardGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardDeck", function() { return CardDeck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardColumns", function() { return CardColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardBody", function() { return CardBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardBlock", function() { return CardBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardFooter", function() { return CardFooter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardHeader", function() { return CardHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardImg", function() { return CardImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardImgOverlay", function() { return CardImgOverlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Carousel", function() { return Carousel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledCarousel", function() { return UncontrolledCarousel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselControl", function() { return CarouselControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselItem", function() { return CarouselItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselIndicators", function() { return CarouselIndicators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselCaption", function() { return CarouselCaption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardSubtitle", function() { return CardSubtitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardText", function() { return CardText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CardTitle", function() { return CardTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Popover", function() { return Popover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverContent", function() { return PopoverContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverBody", function() { return PopoverBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverTitle", function() { return PopoverTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverHeader", function() { return PopoverHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Progress", function() { return Progress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return Modal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModalHeader", function() { return ModalHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModalBody", function() { return ModalBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModalFooter", function() { return ModalFooter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopperContent", function() { return PopperContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopperTargetHelper", function() { return PopperTargetHelper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return Tooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return Table; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroup", function() { return ListGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return Form; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormFeedback", function() { return FormFeedback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return FormGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormText", function() { return FormText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return Input; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroup", function() { return InputGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroupAddon", function() { return InputGroupAddon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroupButton", function() { return InputGroupButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroupButtonDropdown", function() { return InputGroupButtonDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroupText", function() { return InputGroupText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomInput", function() { return CustomInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Media", function() { return Media; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Pagination", function() { return Pagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationItem", function() { return PaginationItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationLink", function() { return PaginationLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TabContent", function() { return TabContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TabPane", function() { return TabPane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Jumbotron", function() { return Jumbotron; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Collapse", function() { return Collapse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroupItem", function() { return ListGroupItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroupItemText", function() { return ListGroupItemText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroupItemHeading", function() { return ListGroupItemHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledAlert", function() { return UncontrolledAlert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledButtonDropdown", function() { return UncontrolledButtonDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledCollapse", function() { return UncontrolledCollapse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledDropdown", function() { return UncontrolledDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledNavDropdown", function() { return UncontrolledNavDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UncontrolledTooltip", function() { return UncontrolledTooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Util", function() { return utils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isobject__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isobject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_popper__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_tonumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__ = __webpack_require__(97);










// https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443
function getScrollbarWidth() {
  var scrollDiv = document.createElement('div');
  // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

function setScrollbarWidth(padding) {
  document.body.style.paddingRight = padding > 0 ? padding + 'px' : null;
}

function isBodyOverflowing() {
  return document.body.clientWidth < window.innerWidth;
}

function getOriginalBodyPadding() {
  var style = window.getComputedStyle(document.body, null);

  return parseInt(style && style.getPropertyValue('padding-right') || 0, 10);
}

function conditionallyUpdateScrollbar() {
  var scrollbarWidth = getScrollbarWidth();
  // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433
  var fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
  var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;

  if (isBodyOverflowing()) {
    setScrollbarWidth(bodyPadding + scrollbarWidth);
  }
}

var globalCssModule = void 0;

function setGlobalCssModule(cssModule) {
  globalCssModule = cssModule;
}

function mapToCssModules() {
  var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var cssModule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalCssModule;

  if (!cssModule) return className;
  return className.split(' ').map(function (c) {
    return cssModule[c] || c;
  }).join(' ');
}

/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */
function omit(obj, omitKeys) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (omitKeys.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}

/**
 * Returns a filtered copy of an object with only the specified keys.
 */
function pick(obj, keys) {
  var pickKeys = Array.isArray(keys) ? keys : [keys];
  var length = pickKeys.length;
  var key = void 0;
  var result = {};

  while (length > 0) {
    length -= 1;
    key = pickKeys[length];
    result[key] = obj[key];
  }
  return result;
}

var warned = {};

function warnOnce(message) {
  if (!warned[message]) {
    /* istanbul ignore else */
    if (typeof console !== 'undefined') {
      console.error(message); // eslint-disable-line no-console
    }
    warned[message] = true;
  }
}

function deprecated(propType, explanation) {
  return function validate(props, propName, componentName) {
    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
      warnOnce('"' + propName + '" property of "' + componentName + '" has been deprecated.\n' + explanation);
    }

    for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(undefined, [props, propName, componentName].concat(rest));
  };
}

function DOMElement(props, propName, componentName) {
  if (!(props[propName] instanceof Element)) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
  }
}

/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */
// These are all setup to match what is in the bootstrap _variables.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss
var TransitionTimeouts = {
  Fade: 150, // $transition-fade
  Collapse: 350, // $transition-collapse
  Modal: 300, // $modal-transition
  Carousel: 600 // $carousel-transition
};

// Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.
var TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];

var TransitionStatuses = {
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
  EXITED: 'exited'
};

var keyCodes = {
  esc: 27,
  space: 32,
  tab: 9,
  up: 38,
  down: 40
};

var PopperPlacements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function findDOMElements(target) {
  if (__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default()(target)) {
    return target();
  }
  if (typeof target === 'string' && canUseDOM) {
    var selection = document.querySelectorAll(target);
    if (!selection.length) {
      selection = document.querySelectorAll('#' + target);
    }
    if (!selection.length) {
      throw new Error('The target \'' + target + '\' could not be identified in the dom, tip: check spelling');
    }
    return selection;
  }
  return target;
}

function isArrayOrNodeList(els) {
  return Array.isArray(els) || canUseDOM && typeof els.length === 'number';
}

function getTarget(target) {
  var els = findDOMElements(target);
  if (isArrayOrNodeList(els)) {
    return els[0];
  }
  return els;
}

var defaultToggleEvents = ['touchstart', 'click'];

function addMultipleEventListeners(_els, handler, _events) {
  var els = _els;
  if (!isArrayOrNodeList(els)) {
    els = [els];
  }

  var events = _events;
  if (typeof events === 'string') {
    events = events.split(/\s+/);
  }

  if (!isArrayOrNodeList(els) || typeof handler !== 'function' || !Array.isArray(events)) {
    throw new Error('\n      The first argument of this function must be DOM node or an array on DOM nodes or NodeList.\n      The second must be a function.\n      The third is a string or an array of strings that represents DOM events\n    ');
  }
  events.forEach(function (event) {
    els.forEach(function (el) {
      el.addEventListener(event, handler);
    });
  });
  return function removeEvents() {
    events.forEach(function (event) {
      els.forEach(function (el) {
        el.removeEventListener(event, handler);
      });
    });
  };
}

var utils = Object.freeze({
	getScrollbarWidth: getScrollbarWidth,
	setScrollbarWidth: setScrollbarWidth,
	isBodyOverflowing: isBodyOverflowing,
	getOriginalBodyPadding: getOriginalBodyPadding,
	conditionallyUpdateScrollbar: conditionallyUpdateScrollbar,
	setGlobalCssModule: setGlobalCssModule,
	mapToCssModules: mapToCssModules,
	omit: omit,
	pick: pick,
	warnOnce: warnOnce,
	deprecated: deprecated,
	DOMElement: DOMElement,
	TransitionTimeouts: TransitionTimeouts,
	TransitionPropTypeKeys: TransitionPropTypeKeys,
	TransitionStatuses: TransitionStatuses,
	keyCodes: keyCodes,
	PopperPlacements: PopperPlacements,
	canUseDOM: canUseDOM,
	findDOMElements: findDOMElements,
	isArrayOrNodeList: isArrayOrNodeList,
	getTarget: getTarget,
	defaultToggleEvents: defaultToggleEvents,
	addMultipleEventListeners: addMultipleEventListeners
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  fluid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps = {
  tag: 'div'
};

var Container = function Container(props) {
  var className = props.className,
      cssModule = props.cssModule,
      fluid = props.fluid,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'fluid', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, fluid ? 'container-fluid' : 'container'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Container.propTypes = propTypes;
Container.defaultProps = defaultProps;

var propTypes$1 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  noGutters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$1 = {
  tag: 'div'
};

var Row = function Row(props) {
  var className = props.className,
      cssModule = props.cssModule,
      noGutters = props.noGutters,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'noGutters', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, noGutters ? 'no-gutters' : null, 'row'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Row.propTypes = propTypes$1;
Row.defaultProps = defaultProps$1;

var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
var stringOrNumberProp = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]);

var columnProps = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  push: deprecated(stringOrNumberProp, 'Please use the prop "order"'),
  pull: deprecated(stringOrNumberProp, 'Please use the prop "order"'),
  order: stringOrNumberProp,
  offset: stringOrNumberProp
})]);

var propTypes$2 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  widths: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var defaultProps$2 = {
  tag: 'div',
  widths: colWidths
};

var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : 'col-' + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : 'col-' + colWidth + '-auto';
  }

  return isXs ? 'col-' + colSize : 'col-' + colWidth + '-' + colSize;
};

var Col = function Col(props) {
  var className = props.className,
      cssModule = props.cssModule,
      widths = props.widths,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'widths', 'tag']);

  var colClasses = [];

  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];

    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : '-' + colWidth + '-';
      var colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);

      colClasses.push(mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, defineProperty(_classNames, colClass, columnProp.size || columnProp.size === ''), defineProperty(_classNames, 'order' + colSizeInterfix + columnProp.order, columnProp.order || columnProp.order === 0), defineProperty(_classNames, 'offset' + colSizeInterfix + columnProp.offset, columnProp.offset || columnProp.offset === 0), _classNames)), cssModule));
    } else {
      var _colClass = getColumnSizeClass(isXs, colWidth, columnProp);
      colClasses.push(_colClass);
    }
  });

  if (!colClasses.length) {
    colClasses.push('col');
  }

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, colClasses), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Col.propTypes = propTypes$2;
Col.defaultProps = defaultProps$2;

var propTypes$3 = {
  light: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dark: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "dark"'),
  full: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  sticky: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggleable: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]), 'Please use the prop "expand"'),
  expand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$3 = {
  tag: 'nav',
  expand: false
};

var getExpandClass = function getExpandClass(expand) {
  if (expand === false) {
    return false;
  } else if (expand === true || expand === 'xs') {
    return 'navbar-expand';
  }

  return 'navbar-expand-' + expand;
};

// To better maintain backwards compatibility while toggleable is deprecated.
// We must map breakpoints to the next breakpoint so that toggleable and expand do the same things at the same breakpoint.
var toggleableToExpand = {
  xs: 'sm',
  sm: 'md',
  md: 'lg',
  lg: 'xl'
};

var getToggleableClass = function getToggleableClass(toggleable) {
  if (toggleable === undefined || toggleable === 'xl') {
    return false;
  } else if (toggleable === false) {
    return 'navbar-expand';
  }

  return 'navbar-expand-' + (toggleable === true ? 'sm' : toggleableToExpand[toggleable] || toggleable);
};

var Navbar = function Navbar(props) {
  var _classNames;

  var toggleable = props.toggleable,
      expand = props.expand,
      className = props.className,
      cssModule = props.cssModule,
      light = props.light,
      dark = props.dark,
      inverse = props.inverse,
      fixed = props.fixed,
      sticky = props.sticky,
      color = props.color,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['toggleable', 'expand', 'className', 'cssModule', 'light', 'dark', 'inverse', 'fixed', 'sticky', 'color', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar', getExpandClass(expand) || getToggleableClass(toggleable), (_classNames = {
    'navbar-light': light,
    'navbar-dark': inverse || dark
  }, defineProperty(_classNames, 'bg-' + color, color), defineProperty(_classNames, 'fixed-' + fixed, fixed), defineProperty(_classNames, 'sticky-' + sticky, sticky), _classNames)), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Navbar.propTypes = propTypes$3;
Navbar.defaultProps = defaultProps$3;

var propTypes$4 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$4 = {
  tag: 'a'
};

var NavbarBrand = function NavbarBrand(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-brand'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

NavbarBrand.propTypes = propTypes$4;
NavbarBrand.defaultProps = defaultProps$4;

var propTypes$5 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var defaultProps$5 = {
  tag: 'button',
  type: 'button'
};

var NavbarToggler = function NavbarToggler(props) {
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'children', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-toggler'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, { className: classes }),
    children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: mapToCssModules('navbar-toggler-icon', cssModule) })
  );
};

NavbarToggler.propTypes = propTypes$5;
NavbarToggler.defaultProps = defaultProps$5;

var propTypes$6 = {
  tabs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pills: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  horizontal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  justified: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  navbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  card: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$6 = {
  tag: 'ul',
  vertical: false
};

var getVerticalClass = function getVerticalClass(vertical) {
  if (vertical === false) {
    return false;
  } else if (vertical === true || vertical === 'xs') {
    return 'flex-column';
  }

  return 'flex-' + vertical + '-column';
};

var Nav = function Nav(props) {
  var className = props.className,
      cssModule = props.cssModule,
      tabs = props.tabs,
      pills = props.pills,
      vertical = props.vertical,
      horizontal = props.horizontal,
      justified = props.justified,
      fill = props.fill,
      navbar = props.navbar,
      card = props.card,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tabs', 'pills', 'vertical', 'horizontal', 'justified', 'fill', 'navbar', 'card', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, navbar ? 'navbar-nav' : 'nav', horizontal ? 'justify-content-' + horizontal : false, getVerticalClass(vertical), {
    'nav-tabs': tabs,
    'card-header-tabs': card && tabs,
    'nav-pills': pills,
    'card-header-pills': card && pills,
    'nav-justified': justified,
    'nav-fill': fill
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Nav.propTypes = propTypes$6;
Nav.defaultProps = defaultProps$6;

var propTypes$7 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$7 = {
  tag: 'li'
};

var NavItem = function NavItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'active', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'nav-item', active ? 'active' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

NavItem.propTypes = propTypes$7;
NavItem.defaultProps = defaultProps$7;

/* eslint react/no-find-dom-node: 0 */
// https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md

var propTypes$8 = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropup: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "direction" with the value "up".'),
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']),
  group: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append'])]),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  setActiveFromChild: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$8 = {
  isOpen: false,
  direction: 'down',
  nav: false,
  active: false,
  addonType: false,
  inNavbar: false,
  setActiveFromChild: false
};

var childContextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']).isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var Dropdown = function (_React$Component) {
  inherits(Dropdown, _React$Component);

  function Dropdown(props) {
    classCallCheck(this, Dropdown);

    var _this = possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.addEvents = _this.addEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.removeEvents = _this.removeEvents.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(Dropdown, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        toggle: this.props.toggle,
        isOpen: this.props.isOpen,
        direction: this.props.direction === 'down' && this.props.dropup ? 'up' : this.props.direction,
        inNavbar: this.props.inNavbar
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.handleProps();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeEvents();
    }
  }, {
    key: 'getContainer',
    value: function getContainer() {
      return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      var _this2 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      var _this3 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e && (e.which === 3 || e.type === 'keyup' && e.which !== keyCodes.tab)) return;
      var container = this.getContainer();

      if (container.contains(e.target) && container !== e.target && (e.type !== 'keyup' || e.which === keyCodes.tab)) {
        return;
      }

      this.toggle(e);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      if ([keyCodes.esc, keyCodes.up, keyCodes.down, keyCodes.space].indexOf(e.which) === -1 || /button/i.test(e.target.tagName) && e.which === keyCodes.space || /input|textarea/i.test(e.target.tagName)) {
        return;
      }

      e.preventDefault();
      if (this.props.disabled) return;

      var container = this.getContainer();

      if (e.which === keyCodes.space && this.props.isOpen && container !== e.target) {
        e.target.click();
      }

      if (e.which === keyCodes.esc || !this.props.isOpen) {
        this.toggle(e);
        container.querySelector('[aria-expanded]').focus();
        return;
      }

      var menuClass = mapToCssModules('dropdown-menu', this.props.cssModule);
      var itemClass = mapToCssModules('dropdown-item', this.props.cssModule);
      var disabledClass = mapToCssModules('disabled', this.props.cssModule);

      var items = container.querySelectorAll('.' + menuClass + ' .' + itemClass + ':not(.' + disabledClass + ')');

      if (!items.length) return;

      var index = -1;
      for (var i = 0; i < items.length; i += 1) {
        if (items[i] === e.target) {
          index = i;
          break;
        }
      }

      if (e.which === keyCodes.up && index > 0) {
        index -= 1;
      }

      if (e.which === keyCodes.down && index < items.length - 1) {
        index += 1;
      }

      if (index < 0) {
        index = 0;
      }

      items[index].focus();
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.isOpen) {
        this.addEvents();
      } else {
        this.removeEvents();
      }
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _omit = omit(this.props, ['toggle', 'disabled', 'inNavbar', 'direction']),
          className = _omit.className,
          cssModule = _omit.cssModule,
          dropup = _omit.dropup,
          isOpen = _omit.isOpen,
          group = _omit.group,
          size = _omit.size,
          nav = _omit.nav,
          setActiveFromChild = _omit.setActiveFromChild,
          active = _omit.active,
          addonType = _omit.addonType,
          attrs = objectWithoutProperties(_omit, ['className', 'cssModule', 'dropup', 'isOpen', 'group', 'size', 'nav', 'setActiveFromChild', 'active', 'addonType']);

      var direction = this.props.direction === 'down' && dropup ? 'up' : this.props.direction;

      attrs.tag = attrs.tag || (nav ? 'li' : 'div');

      var subItemIsActive = false;
      if (setActiveFromChild) {
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(this.props.children[1].props.children, function (dropdownItem) {
          if (dropdownItem.props.active) subItemIsActive = true;
        });
      }

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, direction !== 'down' && 'drop' + direction, nav && active ? 'active' : false, setActiveFromChild && subItemIsActive ? 'active' : false, (_classNames = {}, defineProperty(_classNames, 'input-group-' + addonType, addonType), defineProperty(_classNames, 'btn-group', group), defineProperty(_classNames, 'btn-group-' + size, !!size), defineProperty(_classNames, 'dropdown', !group && !addonType), defineProperty(_classNames, 'show', isOpen), defineProperty(_classNames, 'nav-item', nav), _classNames)), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["Manager"], _extends({}, attrs, { className: classes, onKeyDown: this.handleKeyDown }));
    }
  }]);
  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Dropdown.propTypes = propTypes$8;
Dropdown.defaultProps = defaultProps$8;
Dropdown.childContextTypes = childContextTypes;

function NavDropdown(props) {
  warnOnce('The "NavDropdown" component has been deprecated.\nPlease use component "Dropdown" with nav prop.');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ nav: true }, props));
}

var propTypes$9 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$9 = {
  tag: 'a'
};

var NavLink = function (_React$Component) {
  inherits(NavLink, _React$Component);

  function NavLink(props) {
    classCallCheck(this, NavLink);

    var _this = possibleConstructorReturn(this, (NavLink.__proto__ || Object.getPrototypeOf(NavLink)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(NavLink, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.href === '#') {
        e.preventDefault();
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          active = _props.active,
          Tag = _props.tag,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'active', 'tag', 'innerRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'nav-link', {
        disabled: attributes.disabled,
        active: active
      }), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, onClick: this.onClick, className: classes }));
    }
  }]);
  return NavLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NavLink.propTypes = propTypes$9;
NavLink.defaultProps = defaultProps$9;

var propTypes$10 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  listTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  listClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$10 = {
  tag: 'nav',
  listTag: 'ol',
  'aria-label': 'breadcrumb'
};

var Breadcrumb = function Breadcrumb(props) {
  var className = props.className,
      listClassName = props.listClassName,
      cssModule = props.cssModule,
      children = props.children,
      Tag = props.tag,
      ListTag = props.listTag,
      label = props['aria-label'],
      attributes = objectWithoutProperties(props, ['className', 'listClassName', 'cssModule', 'children', 'tag', 'listTag', 'aria-label']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className), cssModule);

  var listClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('breadcrumb', listClassName), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, { className: classes, 'aria-label': label }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ListTag,
      { className: listClasses },
      children
    )
  );
};

Breadcrumb.propTypes = propTypes$10;
Breadcrumb.defaultProps = defaultProps$10;

var propTypes$11 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$11 = {
  tag: 'li'
};

var BreadcrumbItem = function BreadcrumbItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'active', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, active ? 'active' : false, 'breadcrumb-item'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes, 'aria-current': active ? 'page' : undefined }));
};

BreadcrumbItem.propTypes = propTypes$11;
BreadcrumbItem.defaultProps = defaultProps$11;

var propTypes$12 = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$12 = {
  color: 'secondary',
  tag: 'button'
};

var Button = function (_React$Component) {
  inherits(Button, _React$Component);

  function Button(props) {
    classCallCheck(this, Button);

    var _this = possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(Button, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          block = _props.block,
          className = _props.className,
          cssModule = _props.cssModule,
          color = _props.color,
          outline = _props.outline,
          size = _props.size,
          Tag = _props.tag,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['active', 'block', 'className', 'cssModule', 'color', 'outline', 'size', 'tag', 'innerRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'btn', 'btn' + (outline ? '-outline' : '') + '-' + color, size ? 'btn-' + size : false, block ? 'btn-block' : false, { active: active, disabled: this.props.disabled }), cssModule);

      if (attributes.href && Tag === 'button') {
        Tag = 'a';
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
        type: Tag === 'button' && attributes.onClick ? 'button' : undefined
      }, attributes, {
        className: classes,
        ref: innerRef,
        onClick: this.onClick
      }));
    }
  }]);
  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Button.propTypes = propTypes$12;
Button.defaultProps = defaultProps$12;

var propTypes$13 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var ButtonDropdown = function ButtonDropdown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ group: true }, props));
};

ButtonDropdown.propTypes = propTypes$13;

var propTypes$14 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$13 = {
  tag: 'div',
  role: 'group'
};

var ButtonGroup = function ButtonGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      vertical = props.vertical,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'vertical', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, size ? 'btn-group-' + size : false, vertical ? 'btn-group-vertical' : 'btn-group'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ButtonGroup.propTypes = propTypes$14;
ButtonGroup.defaultProps = defaultProps$13;

var propTypes$15 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$14 = {
  tag: 'div',
  role: 'toolbar'
};

var ButtonToolbar = function ButtonToolbar(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'btn-toolbar'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ButtonToolbar.propTypes = propTypes$15;
ButtonToolbar.defaultProps = defaultProps$14;

var propTypes$16 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  divider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var contextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var defaultProps$15 = {
  tag: 'button',
  toggle: true
};

var DropdownItem = function (_React$Component) {
  inherits(DropdownItem, _React$Component);

  function DropdownItem(props) {
    classCallCheck(this, DropdownItem);

    var _this = possibleConstructorReturn(this, (DropdownItem.__proto__ || Object.getPrototypeOf(DropdownItem)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    _this.getTabIndex = _this.getTabIndex.bind(_this);
    return _this;
  }

  createClass(DropdownItem, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled || this.props.header || this.props.divider) {
        e.preventDefault();
        return;
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }

      if (this.props.toggle) {
        this.context.toggle(e);
      }
    }
  }, {
    key: 'getTabIndex',
    value: function getTabIndex() {
      if (this.props.disabled || this.props.header || this.props.divider) {
        return '-1';
      }

      return '0';
    }
  }, {
    key: 'render',
    value: function render() {
      var tabIndex = this.getTabIndex();

      var _omit = omit(this.props, ['toggle']),
          className = _omit.className,
          cssModule = _omit.cssModule,
          divider = _omit.divider,
          Tag = _omit.tag,
          header = _omit.header,
          active = _omit.active,
          props = objectWithoutProperties(_omit, ['className', 'cssModule', 'divider', 'tag', 'header', 'active']);

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
        disabled: props.disabled,
        'dropdown-item': !divider && !header,
        active: active,
        'dropdown-header': header,
        'dropdown-divider': divider
      }), cssModule);

      if (Tag === 'button') {
        if (header) {
          Tag = 'h6';
        } else if (divider) {
          Tag = 'div';
        } else if (props.href) {
          Tag = 'a';
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
        type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
      }, props, {
        tabIndex: tabIndex,
        className: classes,
        onClick: this.onClick
      }));
    }
  }]);
  return DropdownItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DropdownItem.propTypes = propTypes$16;
DropdownItem.defaultProps = defaultProps$15;
DropdownItem.contextTypes = contextTypes;

var propTypes$17 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  persist: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$16 = {
  tag: 'div',
  flip: true
};

var contextTypes$1 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']).isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var noFlipModifier = { flip: { enabled: false } };

var directionPositionMap = {
  up: 'top',
  left: 'left',
  right: 'right',
  down: 'bottom'
};

var DropdownMenu = function DropdownMenu(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      right = props.right,
      tag = props.tag,
      flip = props.flip,
      modifiers = props.modifiers,
      persist = props.persist,
      attrs = objectWithoutProperties(props, ['className', 'cssModule', 'right', 'tag', 'flip', 'modifiers', 'persist']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'dropdown-menu', {
    'dropdown-menu-right': right,
    show: context.isOpen
  }), cssModule);

  var Tag = tag;

  if (persist || context.isOpen && !context.inNavbar) {
    Tag = __WEBPACK_IMPORTED_MODULE_6_react_popper__["Popper"];

    var position1 = directionPositionMap[context.direction] || 'bottom';
    var position2 = right ? 'end' : 'start';
    attrs.placement = position1 + '-' + position2;
    attrs.component = tag;
    attrs.modifiers = !flip ? _extends({}, modifiers, noFlipModifier) : modifiers;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
    tabIndex: '-1',
    role: 'menu'
  }, attrs, {
    'aria-hidden': !context.isOpen,
    className: classes,
    'x-placement': attrs.placement
  }));
};

DropdownMenu.propTypes = propTypes$17;
DropdownMenu.defaultProps = defaultProps$16;
DropdownMenu.contextTypes = contextTypes$1;

var propTypes$18 = {
  caret: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  'aria-haspopup': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  split: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$17 = {
  'aria-haspopup': true,
  color: 'secondary'
};

var contextTypes$2 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var DropdownToggle = function (_React$Component) {
  inherits(DropdownToggle, _React$Component);

  function DropdownToggle(props) {
    classCallCheck(this, DropdownToggle);

    var _this = possibleConstructorReturn(this, (DropdownToggle.__proto__ || Object.getPrototypeOf(DropdownToggle)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(DropdownToggle, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.nav && !this.props.tag) {
        e.preventDefault();
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }

      this.context.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          color = _props.color,
          cssModule = _props.cssModule,
          caret = _props.caret,
          split = _props.split,
          nav = _props.nav,
          tag = _props.tag,
          props = objectWithoutProperties(_props, ['className', 'color', 'cssModule', 'caret', 'split', 'nav', 'tag']);

      var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
        'dropdown-toggle': caret || split,
        'dropdown-toggle-split': split,
        'nav-link': nav
      }), cssModule);
      var children = props.children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        ariaLabel
      );

      var Tag = void 0;

      if (nav && !tag) {
        Tag = 'a';
        props.href = '#';
      } else if (!tag) {
        Tag = Button;
        props.color = color;
        props.cssModule = cssModule;
      } else {
        Tag = tag;
      }

      if (this.context.inNavbar) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, props, {
          className: classes,
          onClick: this.onClick,
          'aria-expanded': this.context.isOpen,
          children: children
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["Target"], _extends({}, props, {
        className: classes,
        component: Tag,
        onClick: this.onClick,
        'aria-expanded': this.context.isOpen,
        children: children
      }));
    }
  }]);
  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DropdownToggle.propTypes = propTypes$18;
DropdownToggle.defaultProps = defaultProps$17;
DropdownToggle.contextTypes = contextTypes$2;

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var PropTypes$1 = createCommonjsModule(function (module, exports) {
  'use strict';

  exports.__esModule = true;
  exports.classNamesShape = exports.timeoutsShape = undefined;
  exports.transitionTimeout = transitionTimeout;

  var _propTypes2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function transitionTimeout(transitionType) {
    var timeoutPropName = 'transition' + transitionType + 'Timeout';
    var enabledPropName = 'transition' + transitionType;

    return function (props) {
      // If the transition is enabled
      if (props[enabledPropName]) {
        // If no timeout duration is provided
        if (props[timeoutPropName] == null) {
          return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

          // If the duration isn't a number
        } else if (typeof props[timeoutPropName] !== 'number') {
          return new Error(timeoutPropName + ' must be a number (in milliseconds)');
        }
      }

      return null;
    };
  }

  var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
    enter: _propTypes2.default.number,
    exit: _propTypes2.default.number
  }).isRequired]);

  var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    enter: _propTypes2.default.string,
    exit: _propTypes2.default.string,
    active: _propTypes2.default.string
  }), _propTypes2.default.shape({
    enter: _propTypes2.default.string,
    enterDone: _propTypes2.default.string,
    enterActive: _propTypes2.default.string,
    exit: _propTypes2.default.string,
    exitDone: _propTypes2.default.string,
    exitActive: _propTypes2.default.string
  })]);
});

unwrapExports(PropTypes$1);

var Transition_1 = createCommonjsModule(function (module, exports) {
  'use strict';

  exports.__esModule = true;
  exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

  var PropTypes$$1 = _interopRequireWildcard(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a);

  var _react2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_0_react___default.a);

  var _reactDom2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }newObj.default = obj;return newObj;
    }
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
  var EXITED = exports.EXITED = 'exited';
  var ENTERING = exports.ENTERING = 'entering';
  var ENTERED = exports.ENTERED = 'entered';
  var EXITING = exports.EXITING = 'exiting';

  /**
   * The Transition component lets you describe a transition from one component
   * state to another _over time_ with a simple declarative API. Most commonly
   * it's used to animate the mounting and unmounting of a component, but can also
   * be used to describe in-place transition states as well.
   *
   * By default the `Transition` component does not alter the behavior of the
   * component it renders, it only tracks "enter" and "exit" states for the components.
   * It's up to you to give meaning and effect to those states. For example we can
   * add styles to a component when it enters or exits:
   *
   * ```jsx
   * import Transition from 'react-transition-group/Transition';
   *
   * const duration = 300;
   *
   * const defaultStyle = {
   *   transition: `opacity ${duration}ms ease-in-out`,
   *   opacity: 0,
   * }
   *
   * const transitionStyles = {
   *   entering: { opacity: 0 },
   *   entered:  { opacity: 1 },
   * };
   *
   * const Fade = ({ in: inProp }) => (
   *   <Transition in={inProp} timeout={duration}>
   *     {(state) => (
   *       <div style={{
   *         ...defaultStyle,
   *         ...transitionStyles[state]
   *       }}>
   *         I'm a fade Transition!
   *       </div>
   *     )}
   *   </Transition>
   * );
   * ```
   *
   * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
   * What it does do is track transition states over time so you can update the
   * component (such as by adding styles or classes) when it changes states.
   *
   * There are 4 main states a Transition can be in:
   *  - `'entering'`
   *  - `'entered'`
   *  - `'exiting'`
   *  - `'exited'`
   *
   * Transition state is toggled via the `in` prop. When `true` the component begins the
   * "Enter" stage. During this stage, the component will shift from its current transition state,
   * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
   * it's complete. Let's take the following example:
   *
   * ```jsx
   * state = { in: false };
   *
   * toggleEnterState = () => {
   *   this.setState({ in: true });
   * }
   *
   * render() {
   *   return (
   *     <div>
   *       <Transition in={this.state.in} timeout={500} />
   *       <button onClick={this.toggleEnterState}>Click to Enter</button>
   *     </div>
   *   );
   * }
   * ```
   *
   * When the button is clicked the component will shift to the `'entering'` state and
   * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
   *
   * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
   *
   * ## Timing
   *
   * Timing is often the trickiest part of animation, mistakes can result in slight delays
   * that are hard to pin down. A common example is when you want to add an exit transition,
   * you should set the desired final styles when the state is `'exiting'`. That's when the
   * transition to those styles will start and, if you matched the `timeout` prop with the
   * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
   *
   * > **Note**: For simpler transitions the `Transition` component might be enough, but
   * > take into account that it's platform-agnostic, while the `CSSTransition` component
   * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
   * > in order to make more complex transitions more predictable. For example, even though
   * > classes `example-enter` and `example-enter-active` are applied immediately one after
   * > another, you can still transition from one to the other because of the forced reflow
   * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
   * > for more info). Take this into account when choosing between `Transition` and
   * > `CSSTransition`.
   *
   * ## Example
   *
   * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
   *
   */

  var Transition = function (_React$Component) {
    _inherits(Transition, _React$Component);

    function Transition(props, context) {
      _classCallCheck(this, Transition);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      var parentGroup = context.transitionGroup;
      // In the context of a TransitionGroup all enters are really appears
      var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

      var initialStatus = void 0;
      _this.nextStatus = null;

      if (props.in) {
        if (appear) {
          initialStatus = EXITED;
          _this.nextStatus = ENTERING;
        } else {
          initialStatus = ENTERED;
        }
      } else {
        if (props.unmountOnExit || props.mountOnEnter) {
          initialStatus = UNMOUNTED;
        } else {
          initialStatus = EXITED;
        }
      }

      _this.state = { status: initialStatus };

      _this.nextCallback = null;
      return _this;
    }

    Transition.prototype.getChildContext = function getChildContext() {
      return { transitionGroup: null }; // allows for nested Transitions
    };

    Transition.prototype.componentDidMount = function componentDidMount() {
      this.updateStatus(true);
    };

    Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _ref = this.pendingState || this.state,
          status = _ref.status;

      if (nextProps.in) {
        if (status === UNMOUNTED) {
          this.setState({ status: EXITED });
        }
        if (status !== ENTERING && status !== ENTERED) {
          this.nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          this.nextStatus = EXITING;
        }
      }
    };

    Transition.prototype.componentDidUpdate = function componentDidUpdate() {
      this.updateStatus();
    };

    Transition.prototype.componentWillUnmount = function componentWillUnmount() {
      this.cancelNextCallback();
    };

    Transition.prototype.getTimeouts = function getTimeouts() {
      var timeout = this.props.timeout;

      var exit = void 0,
          enter = void 0,
          appear = void 0;

      exit = enter = appear = timeout;

      if (timeout != null && typeof timeout !== 'number') {
        exit = timeout.exit;
        enter = timeout.enter;
        appear = timeout.appear;
      }
      return { exit: exit, enter: enter, appear: appear };
    };

    Transition.prototype.updateStatus = function updateStatus() {
      var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var nextStatus = this.nextStatus;

      if (nextStatus !== null) {
        this.nextStatus = null;
        // nextStatus will always be ENTERING or EXITING.
        this.cancelNextCallback();
        var node = _reactDom2.default.findDOMNode(this);

        if (nextStatus === ENTERING) {
          this.performEnter(node, mounting);
        } else {
          this.performExit(node);
        }
      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
        this.setState({ status: UNMOUNTED });
      }
    };

    Transition.prototype.performEnter = function performEnter(node, mounting) {
      var _this2 = this;

      var enter = this.props.enter;

      var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

      var timeouts = this.getTimeouts();

      // no enter animation skip right to ENTERED
      // if we are mounting and running this it means appear _must_ be set
      if (!mounting && !enter) {
        this.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node);
        });
        return;
      }

      this.props.onEnter(node, appearing);

      this.safeSetState({ status: ENTERING }, function () {
        _this2.props.onEntering(node, appearing);

        // FIXME: appear timeout?
        _this2.onTransitionEnd(node, timeouts.enter, function () {
          _this2.safeSetState({ status: ENTERED }, function () {
            _this2.props.onEntered(node, appearing);
          });
        });
      });
    };

    Transition.prototype.performExit = function performExit(node) {
      var _this3 = this;

      var exit = this.props.exit;

      var timeouts = this.getTimeouts();

      // no exit animation skip right to EXITED
      if (!exit) {
        this.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
        return;
      }
      this.props.onExit(node);

      this.safeSetState({ status: EXITING }, function () {
        _this3.props.onExiting(node);

        _this3.onTransitionEnd(node, timeouts.exit, function () {
          _this3.safeSetState({ status: EXITED }, function () {
            _this3.props.onExited(node);
          });
        });
      });
    };

    Transition.prototype.cancelNextCallback = function cancelNextCallback() {
      if (this.nextCallback !== null) {
        this.nextCallback.cancel();
        this.nextCallback = null;
      }
    };

    Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
      var _this4 = this;

      // We need to track pending updates for instances where a cWRP fires quickly
      // after cDM and before the state flushes, which would double trigger a
      // transition
      this.pendingState = nextState;

      // This shouldn't be necessary, but there are weird race conditions with
      // setState callbacks and unmounting in testing, so always make sure that
      // we can cancel any pending setState callbacks after we unmount.
      callback = this.setNextCallback(callback);
      this.setState(nextState, function () {
        _this4.pendingState = null;
        callback();
      });
    };

    Transition.prototype.setNextCallback = function setNextCallback(callback) {
      var _this5 = this;

      var active = true;

      this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this5.nextCallback = null;

          callback(event);
        }
      };

      this.nextCallback.cancel = function () {
        active = false;
      };

      return this.nextCallback;
    };

    Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
      this.setNextCallback(handler);

      if (node) {
        if (this.props.addEndListener) {
          this.props.addEndListener(node, this.nextCallback);
        }
        if (timeout != null) {
          setTimeout(this.nextCallback, timeout);
        }
      } else {
        setTimeout(this.nextCallback, 0);
      }
    };

    Transition.prototype.render = function render() {
      var status = this.state.status;
      if (status === UNMOUNTED) {
        return null;
      }

      var _props = this.props,
          children = _props.children,
          childProps = _objectWithoutProperties(_props, ['children']);
      // filter props for Transtition


      delete childProps.in;
      delete childProps.mountOnEnter;
      delete childProps.unmountOnExit;
      delete childProps.appear;
      delete childProps.enter;
      delete childProps.exit;
      delete childProps.timeout;
      delete childProps.addEndListener;
      delete childProps.onEnter;
      delete childProps.onEntering;
      delete childProps.onEntered;
      delete childProps.onExit;
      delete childProps.onExiting;
      delete childProps.onExited;

      if (typeof children === 'function') {
        return children(status, childProps);
      }

      var child = _react2.default.Children.only(children);
      return _react2.default.cloneElement(child, childProps);
    };

    return Transition;
  }(_react2.default.Component);

  Transition.contextTypes = {
    transitionGroup: PropTypes$$1.object
  };
  Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
  };

  Transition.propTypes =  false ? {
    /**
     * A `function` child can be used instead of a React element.
     * This function is called with the current transition status
     * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
     * to apply context specific props to a component.
     *
     * ```jsx
     * <Transition timeout={150}>
     *   {(status) => (
     *     <MyComponent className={`fade fade-${status}`} />
     *   )}
     * </Transition>
     * ```
     */
    children: PropTypes$$1.oneOfType([PropTypes$$1.func.isRequired, PropTypes$$1.element.isRequired]).isRequired,

    /**
     * Show the component; triggers the enter or exit states
     */
    in: PropTypes$$1.bool,

    /**
     * By default the child component is mounted immediately along with
     * the parent `Transition` component. If you want to "lazy mount" the component on the
     * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
     * mounted, even on "exited", unless you also specify `unmountOnExit`.
     */
    mountOnEnter: PropTypes$$1.bool,

    /**
     * By default the child component stays mounted after it reaches the `'exited'` state.
     * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
     */
    unmountOnExit: PropTypes$$1.bool,

    /**
     * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
     * If you want to transition on the first mount set `appear` to `true`, and the
     * component will transition in as soon as the `<Transition>` mounts.
     *
     * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
     */
    appear: PropTypes$$1.bool,

    /**
     * Enable or disable enter transitions.
     */
    enter: PropTypes$$1.bool,

    /**
     * Enable or disable exit transitions.
     */
    exit: PropTypes$$1.bool,

    /**
     * The duration of the transition, in milliseconds.
     * Required unless `addEndListener` is provided
     *
     * You may specify a single timeout for all transitions like: `timeout={500}`,
     * or individually like:
     *
     * ```jsx
     * timeout={{
     *  enter: 300,
     *  exit: 500,
     * }}
     * ```
     *
     * @type {number | { enter?: number, exit?: number }}
     */
    timeout: function timeout(props) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var pt = PropTypes$1.timeoutsShape;
      if (!props.addEndListener) pt = pt.isRequired;
      return pt.apply(undefined, [props].concat(args));
    },

    /**
     * Add a custom transition end trigger. Called with the transitioning
     * DOM node and a `done` callback. Allows for more fine grained transition end
     * logic. **Note:** Timeouts are still used as a fallback if provided.
     *
     * ```jsx
     * addEndListener={(node, done) => {
     *   // use the css transitionend event to mark the finish of a transition
     *   node.addEventListener('transitionend', done, false);
     * }}
     * ```
     */
    addEndListener: PropTypes$$1.func,

    /**
     * Callback fired before the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEnter: PropTypes$$1.func,

    /**
     * Callback fired after the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool)
     */
    onEntering: PropTypes$$1.func,

    /**
     * Callback fired after the "entered" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEntered: PropTypes$$1.func,

    /**
     * Callback fired before the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExit: PropTypes$$1.func,

    /**
     * Callback fired after the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExiting: PropTypes$$1.func,

    /**
     * Callback fired after the "exited" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExited: PropTypes$$1.func
  } : {};

  // Name the function so it is clearer in the documentation
  function noop() {}

  Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,

    onEnter: noop,
    onEntering: noop,
    onEntered: noop,

    onExit: noop,
    onExiting: noop,
    onExited: noop
  };

  Transition.UNMOUNTED = 0;
  Transition.EXITED = 1;
  Transition.ENTERING = 2;
  Transition.ENTERED = 3;
  Transition.EXITING = 4;

  exports.default = Transition;
});

var Transition = unwrapExports(Transition_1);

var propTypes$19 = _extends({}, Transition.propTypes, {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  baseClassActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
});

var defaultProps$18 = _extends({}, Transition.defaultProps, {
  tag: 'div',
  baseClass: 'fade',
  baseClassActive: 'show',
  timeout: TransitionTimeouts.Fade,
  appear: true,
  enter: true,
  exit: true,
  in: true
});

function Fade(props) {
  var Tag = props.tag,
      baseClass = props.baseClass,
      baseClassActive = props.baseClassActive,
      className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      innerRef = props.innerRef,
      otherProps = objectWithoutProperties(props, ['tag', 'baseClass', 'baseClassActive', 'className', 'cssModule', 'children', 'innerRef']);

  // In NODE_ENV=production the Transition.propTypes are wrapped which results in an
  // empty object "{}". This is the result of the `react-transition-group` babel
  // configuration settings. Therefore, to ensure that production builds work without
  // error, we can either explicitly define keys or use the Transition.defaultProps.
  // Using the Transition.defaultProps excludes any required props. Thus, the best
  // solution is to explicitly define required props in our utilities and reference these.
  // This also gives us more flexibility in the future to remove the prop-types
  // dependency in distribution builds (Similar to how `react-transition-group` does).
  // Note: Without omitting the `react-transition-group` props, the resulting child
  // Tag component would inherit the Transition properties as attributes for the HTML
  // element which results in errors/warnings for non-valid attributes.

  var transitionProps = pick(otherProps, TransitionPropTypeKeys);
  var childProps = omit(otherProps, TransitionPropTypeKeys);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Transition,
    transitionProps,
    function (status) {
      var isActive = status === 'entered';
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, baseClass, isActive && baseClassActive), cssModule);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Tag,
        _extends({ className: classes }, childProps, { ref: innerRef }),
        children
      );
    }
  );
}

Fade.propTypes = propTypes$19;
Fade.defaultProps = defaultProps$18;

var propTypes$20 = {
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$19 = {
  color: 'secondary',
  pill: false,
  tag: 'span'
};

var Badge = function Badge(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      pill = props.pill,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'color', 'pill', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'badge', 'badge-' + color, pill ? 'badge-pill' : false), cssModule);

  if (attributes.href && Tag === 'span') {
    Tag = 'a';
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Badge.propTypes = propTypes$20;
Badge.defaultProps = defaultProps$19;

var propTypes$21 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  block: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the props "body"'),
  body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

var defaultProps$20 = {
  tag: 'div'
};

var Card = function Card(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      block = props.block,
      body = props.body,
      inverse = props.inverse,
      outline = props.outline,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'color', 'block', 'body', 'inverse', 'outline', 'tag', 'innerRef']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card', inverse ? 'text-white' : false, block || body ? 'card-body' : false, color ? (outline ? 'border' : 'bg') + '-' + color : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes, ref: innerRef }));
};

Card.propTypes = propTypes$21;
Card.defaultProps = defaultProps$20;

var propTypes$22 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$21 = {
  tag: 'div'
};

var CardGroup = function CardGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-group'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardGroup.propTypes = propTypes$22;
CardGroup.defaultProps = defaultProps$21;

var propTypes$23 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$22 = {
  tag: 'div'
};

var CardDeck = function CardDeck(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-deck'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardDeck.propTypes = propTypes$23;
CardDeck.defaultProps = defaultProps$22;

var propTypes$24 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$23 = {
  tag: 'div'
};

var CardColumns = function CardColumns(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-columns'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardColumns.propTypes = propTypes$24;
CardColumns.defaultProps = defaultProps$23;

var propTypes$25 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$24 = {
  tag: 'div'
};

var CardBody = function CardBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardBody.propTypes = propTypes$25;
CardBody.defaultProps = defaultProps$24;

function CardBlock(props) {
  warnOnce('The "CardBlock" component has been deprecated.\nPlease use component "CardBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CardBody, props);
}

var propTypes$26 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$25 = {
  tag: 'a'
};

var CardLink = function CardLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'innerRef']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-link'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
};

CardLink.propTypes = propTypes$26;
CardLink.defaultProps = defaultProps$25;

var propTypes$27 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$26 = {
  tag: 'div'
};

var CardFooter = function CardFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-footer'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardFooter.propTypes = propTypes$27;
CardFooter.defaultProps = defaultProps$26;

var propTypes$28 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$27 = {
  tag: 'div'
};

var CardHeader = function CardHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-header'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardHeader.propTypes = propTypes$28;
CardHeader.defaultProps = defaultProps$27;

var propTypes$29 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$28 = {
  tag: 'img'
};

var CardImg = function CardImg(props) {
  var className = props.className,
      cssModule = props.cssModule,
      top = props.top,
      bottom = props.bottom,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'top', 'bottom', 'tag']);


  var cardImgClassName = 'card-img';
  if (top) {
    cardImgClassName = 'card-img-top';
  }
  if (bottom) {
    cardImgClassName = 'card-img-bottom';
  }

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, cardImgClassName), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardImg.propTypes = propTypes$29;
CardImg.defaultProps = defaultProps$28;

var propTypes$30 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$29 = {
  tag: 'div'
};

var CardImgOverlay = function CardImgOverlay(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-img-overlay'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardImgOverlay.propTypes = propTypes$30;
CardImgOverlay.defaultProps = defaultProps$29;

var CarouselItem = function (_React$Component) {
  inherits(CarouselItem, _React$Component);

  function CarouselItem(props) {
    classCallCheck(this, CarouselItem);

    var _this = possibleConstructorReturn(this, (CarouselItem.__proto__ || Object.getPrototypeOf(CarouselItem)).call(this, props));

    _this.state = {
      startAnimation: false
    };

    _this.onEnter = _this.onEnter.bind(_this);
    _this.onEntering = _this.onEntering.bind(_this);
    _this.onExit = _this.onExit.bind(_this);
    _this.onExiting = _this.onExiting.bind(_this);
    _this.onExited = _this.onExited.bind(_this);
    return _this;
  }

  createClass(CarouselItem, [{
    key: 'onEnter',
    value: function onEnter(node, isAppearing) {
      this.setState({ startAnimation: false });
      this.props.onEnter(node, isAppearing);
    }
  }, {
    key: 'onEntering',
    value: function onEntering(node, isAppearing) {
      // getting this variable triggers a reflow
      var offsetHeight = node.offsetHeight;
      this.setState({ startAnimation: true });
      this.props.onEntering(node, isAppearing);
      return offsetHeight;
    }
  }, {
    key: 'onExit',
    value: function onExit(node) {
      this.setState({ startAnimation: false });
      this.props.onExit(node);
    }
  }, {
    key: 'onExiting',
    value: function onExiting(node) {
      this.setState({ startAnimation: true });
      node.dispatchEvent(new CustomEvent('slide.bs.carousel'));
      this.props.onExiting(node);
    }
  }, {
    key: 'onExited',
    value: function onExited(node) {
      node.dispatchEvent(new CustomEvent('slid.bs.carousel'));
      this.props.onExited(node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isIn = _props.in,
          children = _props.children,
          cssModule = _props.cssModule,
          slide = _props.slide,
          Tag = _props.tag,
          className = _props.className,
          transitionProps = objectWithoutProperties(_props, ['in', 'children', 'cssModule', 'slide', 'tag', 'className']);


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Transition,
        _extends({}, transitionProps, {
          enter: slide,
          exit: slide,
          'in': isIn,
          onEnter: this.onEnter,
          onEntering: this.onEntering,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }),
        function (status) {
          var direction = _this2.context.direction;

          var isActive = status === TransitionStatuses.ENTERED || status === TransitionStatuses.EXITING;
          var directionClassName = (status === TransitionStatuses.ENTERING || status === TransitionStatuses.EXITING) && _this2.state.startAnimation && (direction === 'right' ? 'carousel-item-left' : 'carousel-item-right');
          var orderClassName = status === TransitionStatuses.ENTERING && (direction === 'right' ? 'carousel-item-next' : 'carousel-item-prev');
          var itemClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-item', isActive && 'active', directionClassName, orderClassName), cssModule);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Tag,
            { className: itemClasses },
            children
          );
        }
      );
    }
  }]);
  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CarouselItem.propTypes = _extends({}, Transition.propTypes, {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  in: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  slide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
});

CarouselItem.defaultProps = _extends({}, Transition.defaultProps, {
  tag: 'div',
  timeout: TransitionTimeouts.Carousel,
  slide: true
});

CarouselItem.contextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var Carousel = function (_React$Component) {
  inherits(Carousel, _React$Component);

  function Carousel(props) {
    classCallCheck(this, Carousel);

    var _this = possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    _this.renderItems = _this.renderItems.bind(_this);
    _this.hoverStart = _this.hoverStart.bind(_this);
    _this.hoverEnd = _this.hoverEnd.bind(_this);
    _this.state = {
      direction: 'right',
      indicatorClicked: false
    };
    return _this;
  }

  createClass(Carousel, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { direction: this.state.direction };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Set up the cycle
      if (this.props.ride === 'carousel') {
        this.setInterval();
      }

      // TODO: move this to the specific carousel like bootstrap. Currently it will trigger ALL carousels on the page.
      document.addEventListener('keyup', this.handleKeyPress);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setInterval(nextProps);
      // Calculate the direction to turn
      if (this.props.activeIndex + 1 === nextProps.activeIndex) {
        this.setState({ direction: 'right' });
      } else if (this.props.activeIndex - 1 === nextProps.activeIndex) {
        this.setState({ direction: 'left' });
      } else if (this.props.activeIndex > nextProps.activeIndex) {
        this.setState({ direction: this.state.indicatorClicked ? 'left' : 'right' });
      } else if (this.props.activeIndex !== nextProps.activeIndex) {
        this.setState({ direction: this.state.indicatorClicked ? 'right' : 'left' });
      }
      this.setState({ indicatorClicked: false });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearInterval();
      document.removeEventListener('keyup', this.handleKeyPress);
    }
  }, {
    key: 'setInterval',
    value: function (_setInterval) {
      function setInterval() {
        return _setInterval.apply(this, arguments);
      }

      setInterval.toString = function () {
        return _setInterval.toString();
      };

      return setInterval;
    }(function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      // make sure not to have multiple intervals going...
      this.clearInterval();
      if (props.interval) {
        this.cycleInterval = setInterval(function () {
          props.next();
        }, parseInt(props.interval, 10));
      }
    })
  }, {
    key: 'clearInterval',
    value: function (_clearInterval) {
      function clearInterval() {
        return _clearInterval.apply(this, arguments);
      }

      clearInterval.toString = function () {
        return _clearInterval.toString();
      };

      return clearInterval;
    }(function () {
      clearInterval(this.cycleInterval);
    })
  }, {
    key: 'hoverStart',
    value: function hoverStart() {
      if (this.props.pause === 'hover') {
        this.clearInterval();
      }
      if (this.props.mouseEnter) {
        var _props;

        (_props = this.props).mouseEnter.apply(_props, arguments);
      }
    }
  }, {
    key: 'hoverEnd',
    value: function hoverEnd() {
      if (this.props.pause === 'hover') {
        this.setInterval();
      }
      if (this.props.mouseLeave) {
        var _props2;

        (_props2 = this.props).mouseLeave.apply(_props2, arguments);
      }
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(evt) {
      if (this.props.keyboard) {
        if (evt.keyCode === 37) {
          this.props.previous();
        } else if (evt.keyCode === 39) {
          this.props.next();
        }
      }
    }
  }, {
    key: 'renderItems',
    value: function renderItems(carouselItems, className) {
      var _this2 = this;

      var slide = this.props.slide;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { role: 'listbox', className: className },
        carouselItems.map(function (item, index) {
          var isIn = index === _this2.props.activeIndex;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(item, {
            in: isIn,
            slide: slide
          });
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          cssModule = _props3.cssModule,
          slide = _props3.slide,
          className = _props3.className;

      var outerClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel', slide && 'slide'), cssModule);

      var innerClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('carousel-inner'), cssModule);

      // filter out booleans, null, or undefined
      var children = this.props.children.filter(function (child) {
        return child !== null && child !== undefined && typeof child !== 'boolean';
      });

      var slidesOnly = children.every(function (child) {
        return child.type === CarouselItem;
      });

      // Rendering only slides
      if (slidesOnly) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
          this.renderItems(children, innerClasses)
        );
      }

      // Rendering slides and controls
      if (children[0] instanceof Array) {
        var _carouselItems = children[0];
        var _controlLeft = children[1];
        var _controlRight = children[2];

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
          this.renderItems(_carouselItems, innerClasses),
          _controlLeft,
          _controlRight
        );
      }

      // Rendering indicators, slides and controls
      var indicators = children[0];
      var wrappedOnClick = function wrappedOnClick(e) {
        if (typeof indicators.props.onClickHandler === 'function') {
          _this3.setState({ indicatorClicked: true }, function () {
            return indicators.props.onClickHandler(e);
          });
        }
      };
      var wrappedIndicators = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(indicators, { onClickHandler: wrappedOnClick });
      var carouselItems = children[1];
      var controlLeft = children[2];
      var controlRight = children[3];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
        wrappedIndicators,
        this.renderItems(carouselItems, innerClasses),
        controlLeft,
        controlRight
      );
    }
  }]);
  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Carousel.propTypes = {
  // the current active slide of the carousel
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // a function which should advance the carousel to the next slide (via activeIndex)
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // a function which should advance the carousel to the previous slide (via activeIndex)
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // controls if the left and right arrow keys should control the carousel
  keyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  /* If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
   * mouseleave. If set to false, hovering over the carousel won't pause it. (default: "hover")
   */
  pause: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['hover', false]),
  // Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load.
  // This is how bootstrap defines it... I would prefer a bool named autoplay or something...
  ride: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['carousel']),
  // the interval at which the carousel automatically cycles (default: 5000)
  // eslint-disable-next-line react/no-unused-prop-types
  interval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // called when the mouse enters the Carousel
  mouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // called when the mouse exits the Carousel
  mouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // controls whether the slide animation on the Carousel works or not
  slide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Carousel.defaultProps = {
  interval: 5000,
  pause: 'hover',
  keyboard: true,
  slide: true
};

Carousel.childContextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselControl = function CarouselControl(props) {
  var direction = props.direction,
      onClickHandler = props.onClickHandler,
      cssModule = props.cssModule,
      directionText = props.directionText,
      className = props.className;


  var anchorClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-control-' + direction), cssModule);

  var iconClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('carousel-control-' + direction + '-icon'), cssModule);

  var screenReaderClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('sr-only'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      className: anchorClasses,
      role: 'button',
      tabIndex: '0',
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler();
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: iconClasses, 'aria-hidden': 'true' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: screenReaderClasses },
      directionText || direction
    )
  );
};

CarouselControl.propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prev', 'next']).isRequired,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  directionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselIndicators = function CarouselIndicators(props) {
  var items = props.items,
      activeIndex = props.activeIndex,
      cssModule = props.cssModule,
      onClickHandler = props.onClickHandler,
      className = props.className;


  var listClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-indicators'), cssModule);
  var indicators = items.map(function (item, idx) {
    var indicatorClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()({ active: activeIndex === idx }), cssModule);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', {
      key: '' + (item.key || item.src) + item.caption + item.altText,
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler(idx);
      },
      className: indicatorClasses
    });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'ol',
    { className: listClasses },
    indicators
  );
};

CarouselIndicators.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselCaption = function CarouselCaption(props) {
  var captionHeader = props.captionHeader,
      captionText = props.captionText,
      cssModule = props.cssModule,
      className = props.className;

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-caption', 'd-none', 'd-md-block'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: classes },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      captionHeader
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      captionText
    )
  );
};

CarouselCaption.propTypes = {
  captionHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  captionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var propTypes$31 = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  indicators: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  controls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoPlay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  goToIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var UncontrolledCarousel = function (_Component) {
  inherits(UncontrolledCarousel, _Component);

  function UncontrolledCarousel(props) {
    classCallCheck(this, UncontrolledCarousel);

    var _this = possibleConstructorReturn(this, (UncontrolledCarousel.__proto__ || Object.getPrototypeOf(UncontrolledCarousel)).call(this, props));

    _this.animating = false;
    _this.state = { activeIndex: 0 };
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);
    _this.goToIndex = _this.goToIndex.bind(_this);
    _this.onExiting = _this.onExiting.bind(_this);
    _this.onExited = _this.onExited.bind(_this);
    return _this;
  }

  createClass(UncontrolledCarousel, [{
    key: 'onExiting',
    value: function onExiting() {
      this.animating = true;
    }
  }, {
    key: 'onExited',
    value: function onExited() {
      this.animating = false;
    }
  }, {
    key: 'next',
    value: function next() {
      if (this.animating) return;
      var nextIndex = this.state.activeIndex === this.props.items.length - 1 ? 0 : this.state.activeIndex + 1;
      this.setState({ activeIndex: nextIndex });
    }
  }, {
    key: 'previous',
    value: function previous() {
      if (this.animating) return;
      var nextIndex = this.state.activeIndex === 0 ? this.props.items.length - 1 : this.state.activeIndex - 1;
      this.setState({ activeIndex: nextIndex });
    }
  }, {
    key: 'goToIndex',
    value: function goToIndex(newIndex) {
      if (this.animating) return;
      this.setState({ activeIndex: newIndex });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoPlay = _props.autoPlay,
          indicators = _props.indicators,
          controls = _props.controls,
          items = _props.items,
          goToIndex = _props.goToIndex,
          props = objectWithoutProperties(_props, ['autoPlay', 'indicators', 'controls', 'items', 'goToIndex']);
      var activeIndex = this.state.activeIndex;


      var slides = items.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          CarouselItem,
          {
            onExiting: _this2.onExiting,
            onExited: _this2.onExited,
            key: item.src
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'd-block w-100', src: item.src, alt: item.altText }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselCaption, { captionText: item.caption, captionHeader: item.header || item.caption })
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Carousel,
        _extends({
          activeIndex: activeIndex,
          next: this.next,
          previous: this.previous,
          ride: autoPlay ? 'carousel' : undefined
        }, props),
        indicators && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselIndicators, {
          items: items,
          activeIndex: props.activeIndex || activeIndex,
          onClickHandler: goToIndex || this.goToIndex
        }),
        slides,
        controls && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselControl, {
          direction: 'prev',
          directionText: 'Previous',
          onClickHandler: props.previous || this.previous
        }),
        controls && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselControl, {
          direction: 'next',
          directionText: 'Next',
          onClickHandler: props.next || this.next
        })
      );
    }
  }]);
  return UncontrolledCarousel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

UncontrolledCarousel.propTypes = propTypes$31;
UncontrolledCarousel.defaultProps = {
  controls: true,
  indicators: true,
  autoPlay: true
};

var propTypes$32 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$30 = {
  tag: 'h6'
};

var CardSubtitle = function CardSubtitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-subtitle'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardSubtitle.propTypes = propTypes$32;
CardSubtitle.defaultProps = defaultProps$30;

var propTypes$33 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$31 = {
  tag: 'p'
};

var CardText = function CardText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardText.propTypes = propTypes$33;
CardText.defaultProps = defaultProps$31;

var propTypes$34 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$32 = {
  tag: 'h5'
};

var CardTitle = function CardTitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-title'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardTitle.propTypes = propTypes$34;
CardTitle.defaultProps = defaultProps$32;

var propTypes$35 = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]).isRequired,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  valid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bsSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

function CustomInput(props) {
  var className = props.className,
      label = props.label,
      inline = props.inline,
      valid = props.valid,
      invalid = props.invalid,
      cssModule = props.cssModule,
      children = props.children,
      bsSize = props.bsSize,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'label', 'inline', 'valid', 'invalid', 'cssModule', 'children', 'bsSize', 'innerRef']);


  var type = attributes.type;

  var customClass = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'custom-' + type, bsSize ? 'custom-' + type + '-' + bsSize : false), cssModule);

  var validationClassNames = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(invalid && 'is-invalid', valid && 'is-valid'), cssModule);

  if (type === 'select') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'select',
      _extends({}, attributes, { ref: innerRef, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(validationClassNames, customClass) }),
      children
    );
  }

  if (type === 'file') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: customClass },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, attributes, { ref: innerRef, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(validationClassNames, mapToCssModules('custom-file-input', cssModule)) })),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { className: mapToCssModules('custom-file-label', cssModule), htmlFor: attributes.id },
        label || 'Choose file'
      )
    );
  }

  if (type !== 'checkbox' && type !== 'radio') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, attributes, { ref: innerRef, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(validationClassNames, customClass) }));
  }

  var wrapperClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(customClass, mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('custom-control', { 'custom-control-inline': inline }), cssModule));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: wrapperClasses },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, attributes, {
      ref: innerRef,
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(validationClassNames, mapToCssModules('custom-control-input', cssModule))
    })),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'label',
      { className: mapToCssModules('custom-control-label', cssModule), htmlFor: attributes.id },
      label
    ),
    children
  );
}

CustomInput.propTypes = propTypes$35;

var propTypes$36 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  arrowClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  fallbackPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired,
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$33 = {
  placement: 'auto',
  hideArrow: false,
  isOpen: false,
  offset: 0,
  fallbackPlacement: 'flip',
  flip: true,
  container: 'body',
  modifiers: {}
};

var childContextTypes$1 = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

var PopperContent = function (_React$Component) {
  inherits(PopperContent, _React$Component);

  function PopperContent(props) {
    classCallCheck(this, PopperContent);

    var _this = possibleConstructorReturn(this, (PopperContent.__proto__ || Object.getPrototypeOf(PopperContent)).call(this, props));

    _this.handlePlacementChange = _this.handlePlacementChange.bind(_this);
    _this.setTargetNode = _this.setTargetNode.bind(_this);
    _this.getTargetNode = _this.getTargetNode.bind(_this);
    _this.state = {};
    return _this;
  }

  createClass(PopperContent, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this.setTargetNode,
          getTargetNode: this.getTargetNode
        }
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.handleProps();
      } else if (this._element) {
        // rerender
        this.renderIntoSubtree();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.hide();
    }
  }, {
    key: 'setTargetNode',
    value: function setTargetNode(node) {
      this.targetNode = node;
    }
  }, {
    key: 'getTargetNode',
    value: function getTargetNode() {
      return this.targetNode;
    }
  }, {
    key: 'getContainerNode',
    value: function getContainerNode() {
      return getTarget(this.props.container);
    }
  }, {
    key: 'handlePlacementChange',
    value: function handlePlacementChange(data) {
      if (this.state.placement !== data.placement) {
        this.setState({ placement: data.placement });
      }
      return data;
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.container !== 'inline') {
        if (this.props.isOpen) {
          this.show();
        } else {
          this.hide();
        }
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this._element) {
        this.getContainerNode().removeChild(this._element);
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(this._element);
        this._element = null;
      }
    }
  }, {
    key: 'show',
    value: function show() {
      this._element = document.createElement('div');
      this.getContainerNode().appendChild(this._element);
      this.renderIntoSubtree();
      if (this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
        this._element.childNodes[0].focus();
      }
    }
  }, {
    key: 'renderIntoSubtree',
    value: function renderIntoSubtree() {
      __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this.renderChildren(), this._element);
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _props = this.props,
          cssModule = _props.cssModule,
          children = _props.children,
          isOpen = _props.isOpen,
          flip = _props.flip,
          target = _props.target,
          offset = _props.offset,
          fallbackPlacement = _props.fallbackPlacement,
          placementPrefix = _props.placementPrefix,
          _arrowClassName = _props.arrowClassName,
          hideArrow = _props.hideArrow,
          className = _props.className,
          tag = _props.tag,
          container = _props.container,
          modifiers = _props.modifiers,
          attrs = objectWithoutProperties(_props, ['cssModule', 'children', 'isOpen', 'flip', 'target', 'offset', 'fallbackPlacement', 'placementPrefix', 'arrowClassName', 'hideArrow', 'className', 'tag', 'container', 'modifiers']);

      var arrowClassName = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('arrow', _arrowClassName), cssModule);
      var placement = (this.state.placement || attrs.placement).split('-')[0];
      var popperClassName = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, placementPrefix ? placementPrefix + '-' + placement : placement), this.props.cssModule);

      var extendedModifiers = _extends({
        offset: { offset: offset },
        flip: { enabled: flip, behavior: fallbackPlacement },
        update: {
          enabled: true,
          order: 950,
          fn: this.handlePlacementChange
        }
      }, modifiers);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_popper__["Popper"],
        _extends({ modifiers: extendedModifiers }, attrs, { component: tag, className: popperClassName, 'x-placement': this.state.placement || attrs.placement }),
        children,
        !hideArrow && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["Arrow"], { className: arrowClassName })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      this.setTargetNode(getTarget(this.props.target));

      if (this.props.container === 'inline') {
        return this.props.isOpen ? this.renderChildren() : null;
      }

      return null;
    }
  }]);
  return PopperContent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PopperContent.propTypes = propTypes$36;
PopperContent.defaultProps = defaultProps$33;
PopperContent.childContextTypes = childContextTypes$1;

var PopperTargetHelper = function PopperTargetHelper(props, context) {
  context.popperManager.setTargetNode(getTarget(props.target));
  return null;
};

PopperTargetHelper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

PopperTargetHelper.propTypes = {
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired
};

var propTypes$37 = {
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(PopperPlacements),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  innerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  delay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};

var DEFAULT_DELAYS = {
  show: 0,
  hide: 0
};

var defaultProps$34 = {
  isOpen: false,
  hideArrow: false,
  placement: 'right',
  placementPrefix: 'bs-popover',
  delay: DEFAULT_DELAYS,
  toggle: function toggle() {}
};

var Popover = function (_React$Component) {
  inherits(Popover, _React$Component);

  function Popover(props) {
    classCallCheck(this, Popover);

    var _this = possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));

    _this.addTargetEvents = _this.addTargetEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.removeTargetEvents = _this.removeTargetEvents.bind(_this);
    _this.getRef = _this.getRef.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    return _this;
  }

  createClass(Popover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._target = getTarget(this.props.target);
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.handleProps();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearShowTimeout();
      this.clearHideTimeout();
      this.removeTargetEvents();
    }
  }, {
    key: 'getRef',
    value: function getRef(ref) {
      this._popover = ref;
    }
  }, {
    key: 'getDelay',
    value: function getDelay(key) {
      var delay = this.props.delay;

      if ((typeof delay === 'undefined' ? 'undefined' : _typeof(delay)) === 'object') {
        return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
      }
      return delay;
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.isOpen) {
        this.show();
      } else {
        this.hide();
      }
    }
  }, {
    key: 'show',
    value: function show() {
      this.clearHideTimeout();
      this.addTargetEvents();
      if (!this.props.isOpen) {
        this.clearShowTimeout();
        this._showTimeout = setTimeout(this.toggle, this.getDelay('show'));
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.clearShowTimeout();
      this.removeTargetEvents();
      if (this.props.isOpen) {
        this.clearHideTimeout();
        this._hideTimeout = setTimeout(this.toggle, this.getDelay('hide'));
      }
    }
  }, {
    key: 'clearShowTimeout',
    value: function clearShowTimeout() {
      clearTimeout(this._showTimeout);
      this._showTimeout = undefined;
    }
  }, {
    key: 'clearHideTimeout',
    value: function clearHideTimeout() {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = undefined;
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e.target !== this._target && !this._target.contains(e.target) && e.target !== this._popover && !(this._popover && this._popover.contains(e.target))) {
        if (this._hideTimeout) {
          this.clearHideTimeout();
        }

        if (this.props.isOpen) {
          this.toggle(e);
        }
      }
    }
  }, {
    key: 'addTargetEvents',
    value: function addTargetEvents() {
      var _this2 = this;

      ['click', 'touchstart'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeTargetEvents',
    value: function removeTargetEvents() {
      var _this3 = this;

      ['click', 'touchstart'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isOpen) {
        return null;
      }

      var attributes = omit(this.props, Object.keys(propTypes$37));
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover-inner', this.props.innerClassName), this.props.cssModule);

      var popperClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover', 'show', this.props.className), this.props.cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        PopperContent,
        {
          className: popperClasses,
          target: this.props.target,
          isOpen: this.props.isOpen,
          hideArrow: this.props.hideArrow,
          placement: this.props.placement,
          placementPrefix: this.props.placementPrefix,
          container: this.props.container,
          modifiers: this.props.modifiers,
          offset: this.props.offset
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, attributes, { className: classes, ref: this.getRef }))
      );
    }
  }]);
  return Popover;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Popover.propTypes = propTypes$37;
Popover.defaultProps = defaultProps$34;

var propTypes$38 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$35 = {
  tag: 'h3'
};

var PopoverHeader = function PopoverHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'popover-header'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PopoverHeader.propTypes = propTypes$38;
PopoverHeader.defaultProps = defaultProps$35;

function PopoverTitle(props) {
  warnOnce('The "PopoverTitle" component has been deprecated.\nPlease use component "PopoverHeader".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopoverHeader, props);
}

var propTypes$39 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$36 = {
  tag: 'div'
};

var PopoverBody = function PopoverBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'popover-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PopoverBody.propTypes = propTypes$39;
PopoverBody.defaultProps = defaultProps$36;

function PopoverContent(props) {
  warnOnce('The "PopoverContent" component has been deprecated.\nPlease use component "PopoverBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopoverBody, props);
}

var propTypes$40 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  bar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  multi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  animated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  barClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$37 = {
  tag: 'div',
  value: 0,
  max: 100
};

var Progress = function Progress(props) {
  var children = props.children,
      className = props.className,
      barClassName = props.barClassName,
      cssModule = props.cssModule,
      value = props.value,
      max = props.max,
      animated = props.animated,
      striped = props.striped,
      color = props.color,
      bar = props.bar,
      multi = props.multi,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['children', 'className', 'barClassName', 'cssModule', 'value', 'max', 'animated', 'striped', 'color', 'bar', 'multi', 'tag']);


  var percent = __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default()(value) / __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default()(max) * 100;

  var progressClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'progress'), cssModule);

  var progressBarClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('progress-bar', bar ? className || barClassName : barClassName, animated ? 'progress-bar-animated' : null, color ? 'bg-' + color : null, striped || animated ? 'progress-bar-striped' : null), cssModule);

  var ProgressBar = multi ? children : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
    className: progressBarClasses,
    style: { width: percent + '%' },
    role: 'progressbar',
    'aria-valuenow': value,
    'aria-valuemin': '0',
    'aria-valuemax': max,
    children: children
  });

  if (bar) {
    return ProgressBar;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: progressClasses, children: ProgressBar }));
};

Progress.propTypes = propTypes$40;
Progress.defaultProps = defaultProps$37;

var propTypes$42 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var Portal = function (_React$Component) {
  inherits(Portal, _React$Component);

  function Portal() {
    classCallCheck(this, Portal);
    return possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  createClass(Portal, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!canUseDOM) {
        return null;
      }

      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }

      return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.createPortal(this.props.children, this.props.node || this.defaultNode);
    }
  }]);
  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = propTypes$42;

function noop() {}

var FadePropTypes = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(Fade.propTypes);

var propTypes$41 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  centered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  labelledBy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backdrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['static'])]),
  onEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onExit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onOpened: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClosed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  wrapClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modalClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backdropClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  contentClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  fade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  zIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  backdropTransition: FadePropTypes,
  modalTransition: FadePropTypes,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

var propsToOmit = Object.keys(propTypes$41);

var defaultProps$38 = {
  isOpen: false,
  autoFocus: true,
  centered: false,
  role: 'dialog',
  backdrop: true,
  keyboard: true,
  zIndex: 1050,
  fade: true,
  onOpened: noop,
  onClosed: noop,
  modalTransition: {
    timeout: TransitionTimeouts.Modal
  },
  backdropTransition: {
    mountOnEnter: true,
    timeout: TransitionTimeouts.Fade // uses standard fade transition
  }
};

var Modal = function (_React$Component) {
  inherits(Modal, _React$Component);

  function Modal(props) {
    classCallCheck(this, Modal);

    var _this = possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this._element = null;
    _this._originalBodyPadding = null;
    _this.handleBackdropMouseDown = _this.handleBackdropMouseDown.bind(_this);
    _this.handleBackdropMouseUp = _this.handleBackdropMouseUp.bind(_this);
    _this.handleEscape = _this.handleEscape.bind(_this);
    _this.onOpened = _this.onOpened.bind(_this);
    _this.onClosed = _this.onClosed.bind(_this);

    _this.state = {
      isOpen: props.isOpen
    };

    if (props.isOpen) {
      _this.init();
    }
    return _this;
  }

  createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.onEnter) {
        this.props.onEnter();
      }

      if (this.state.isOpen && this.props.autoFocus) {
        this.setFocus();
      }

      this._isMounted = true;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isOpen && !this.props.isOpen) {
        this.setState({ isOpen: nextProps.isOpen });
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextState.isOpen && !this.state.isOpen) {
        this.init();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) {
        this.setFocus();
      }

      if (this._element && prevProps.zIndex !== this.props.zIndex) {
        this._element.style.zIndex = this.props.zIndex;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.onExit) {
        this.props.onExit();
      }

      if (this.state.isOpen) {
        this.destroy();
      }

      this._isMounted = false;
    }
  }, {
    key: 'onOpened',
    value: function onOpened(node, isAppearing) {
      this.props.onOpened();
      (this.props.modalTransition.onEntered || noop)(node, isAppearing);
    }
  }, {
    key: 'onClosed',
    value: function onClosed(node) {
      // so all methods get called before it is unmounted
      this.props.onClosed();
      (this.props.modalTransition.onExited || noop)(node);
      this.destroy();

      if (this._isMounted) {
        this.setState({ isOpen: false });
      }
    }
  }, {
    key: 'setFocus',
    value: function setFocus() {
      if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === 'function') {
        this._dialog.parentNode.focus();
      }
    }
  }, {
    key: 'handleBackdropMouseDown',
    value: function handleBackdropMouseDown(e) {
      this._mouseDownElement = e.target;
    }
  }, {
    key: 'handleBackdropMouseUp',
    value: function handleBackdropMouseUp(e) {
      if (e.target === this._mouseDownElement) {
        e.stopPropagation();
        if (!this.props.isOpen || this.props.backdrop !== true) return;

        var container = this._dialog;

        if (e.target && !container.contains(e.target) && this.props.toggle) {
          this.props.toggle(e);
        }
      }
    }
  }, {
    key: 'handleEscape',
    value: function handleEscape(e) {
      if (this.props.isOpen && this.props.keyboard && e.keyCode === 27 && this.props.toggle) {
        this.props.toggle(e);
      }
    }
  }, {
    key: 'init',
    value: function init() {
      this._element = document.createElement('div');
      this._element.setAttribute('tabindex', '-1');
      this._element.style.position = 'relative';
      this._element.style.zIndex = this.props.zIndex;
      this._originalBodyPadding = getOriginalBodyPadding();

      conditionallyUpdateScrollbar();

      document.body.appendChild(this._element);

      if (!this.bodyClassAdded) {
        document.body.className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(document.body.className, mapToCssModules('modal-open', this.props.cssModule));
        this.bodyClassAdded = true;
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this._element) {
        document.body.removeChild(this._element);
        this._element = null;
      }

      if (this.bodyClassAdded) {
        var modalOpenClassName = mapToCssModules('modal-open', this.props.cssModule);
        // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`
        var modalOpenClassNameRegex = new RegExp('(^| )' + modalOpenClassName + '( |$)');
        document.body.className = document.body.className.replace(modalOpenClassNameRegex, ' ').trim();
        this.bodyClassAdded = false;
      }

      setScrollbarWidth(this._originalBodyPadding);
    }
  }, {
    key: 'renderModalDialog',
    value: function renderModalDialog() {
      var _classNames,
          _this2 = this;

      var attributes = omit(this.props, propsToOmit);
      var dialogBaseClass = 'modal-dialog';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({}, attributes, {
          className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(dialogBaseClass, this.props.className, (_classNames = {}, defineProperty(_classNames, 'modal-' + this.props.size, this.props.size), defineProperty(_classNames, dialogBaseClass + '-centered', this.props.centered), _classNames)), this.props.cssModule),
          role: 'document',
          ref: function ref(c) {
            _this2._dialog = c;
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-content', this.props.contentClassName), this.props.cssModule)
          },
          this.props.children
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.isOpen) {
        var _props = this.props,
            wrapClassName = _props.wrapClassName,
            modalClassName = _props.modalClassName,
            backdropClassName = _props.backdropClassName,
            cssModule = _props.cssModule,
            isOpen = _props.isOpen,
            backdrop = _props.backdrop,
            role = _props.role,
            labelledBy = _props.labelledBy,
            external = _props.external,
            innerRef = _props.innerRef;


        var modalAttributes = {
          onMouseDown: this.handleBackdropMouseDown,
          onMouseUp: this.handleBackdropMouseUp,
          onKeyUp: this.handleEscape,
          style: { display: 'block' },
          'aria-labelledby': labelledBy,
          role: role,
          tabIndex: '-1'
        };

        var hasTransition = this.props.fade;
        var modalTransition = _extends({}, Fade.defaultProps, this.props.modalTransition, {
          baseClass: hasTransition ? this.props.modalTransition.baseClass : '',
          timeout: hasTransition ? this.props.modalTransition.timeout : 0
        });
        var backdropTransition = _extends({}, Fade.defaultProps, this.props.backdropTransition, {
          baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
          timeout: hasTransition ? this.props.backdropTransition.timeout : 0
        });

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Portal,
          { node: this._element },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: mapToCssModules(wrapClassName) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Fade,
              _extends({}, modalAttributes, modalTransition, {
                'in': isOpen,
                onEntered: this.onOpened,
                onExited: this.onClosed,
                cssModule: cssModule,
                className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal', modalClassName), cssModule),
                innerRef: innerRef
              }),
              external,
              this.renderModalDialog()
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fade, _extends({}, backdropTransition, {
              'in': isOpen && !!backdrop,
              cssModule: cssModule,
              className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-backdrop', backdropClassName), cssModule)
            }))
          )
        );
      }

      return null;
    }
  }]);
  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Modal.propTypes = propTypes$41;
Modal.defaultProps = defaultProps$38;

var propTypes$43 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  wrapTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$39 = {
  tag: 'h5',
  wrapTag: 'div',
  closeAriaLabel: 'Close'
};

var ModalHeader = function ModalHeader(props) {
  var closeButton = void 0;
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      toggle = props.toggle,
      Tag = props.tag,
      WrapTag = props.wrapTag,
      closeAriaLabel = props.closeAriaLabel,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'children', 'toggle', 'tag', 'wrapTag', 'closeAriaLabel']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-header'), cssModule);

  if (toggle) {
    closeButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { type: 'button', onClick: toggle, className: mapToCssModules('close', cssModule), 'aria-label': closeAriaLabel },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        String.fromCharCode(215)
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    WrapTag,
    _extends({}, attributes, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      { className: mapToCssModules('modal-title', cssModule) },
      children
    ),
    closeButton
  );
};

ModalHeader.propTypes = propTypes$43;
ModalHeader.defaultProps = defaultProps$39;

var propTypes$44 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$40 = {
  tag: 'div'
};

var ModalBody = function ModalBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ModalBody.propTypes = propTypes$44;
ModalBody.defaultProps = defaultProps$40;

var propTypes$45 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$41 = {
  tag: 'div'
};

var ModalFooter = function ModalFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-footer'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ModalFooter.propTypes = propTypes$45;
ModalFooter.defaultProps = defaultProps$41;

var propTypes$46 = {
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(PopperPlacements),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  innerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  arrowClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  autohide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  delay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object])
};

var DEFAULT_DELAYS$1 = {
  show: 0,
  hide: 250
};

var defaultProps$42 = {
  isOpen: false,
  hideArrow: false,
  placement: 'top',
  placementPrefix: 'bs-tooltip',
  delay: DEFAULT_DELAYS$1,
  autohide: true,
  toggle: function toggle() {}
};

var Tooltip = function (_React$Component) {
  inherits(Tooltip, _React$Component);

  function Tooltip(props) {
    classCallCheck(this, Tooltip);

    var _this = possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this.addTargetEvents = _this.addTargetEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.removeTargetEvents = _this.removeTargetEvents.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this.onMouseOverTooltip = _this.onMouseOverTooltip.bind(_this);
    _this.onMouseLeaveTooltip = _this.onMouseLeaveTooltip.bind(_this);
    _this.onMouseOverTooltipContent = _this.onMouseOverTooltipContent.bind(_this);
    _this.onMouseLeaveTooltipContent = _this.onMouseLeaveTooltipContent.bind(_this);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    _this.onEscKeyDown = _this.onEscKeyDown.bind(_this);
    return _this;
  }

  createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._target = getTarget(this.props.target);
      this.addTargetEvents();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeTargetEvents();
    }
  }, {
    key: 'onMouseOverTooltip',
    value: function onMouseOverTooltip(e) {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
      this._showTimeout = setTimeout(this.show.bind(this, e), this.getDelay('show'));
    }
  }, {
    key: 'onMouseLeaveTooltip',
    value: function onMouseLeaveTooltip(e) {
      if (this._showTimeout) {
        this.clearShowTimeout();
      }
      this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
    }
  }, {
    key: 'onMouseOverTooltipContent',
    value: function onMouseOverTooltipContent() {
      if (this.props.autohide) {
        return;
      }
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
    }
  }, {
    key: 'onMouseLeaveTooltipContent',
    value: function onMouseLeaveTooltipContent(e) {
      if (this.props.autohide) {
        return;
      }
      if (this._showTimeout) {
        this.clearShowTimeout();
      }
      e.persist();
      this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
    }
  }, {
    key: 'onEscKeyDown',
    value: function onEscKeyDown(e) {
      if (e.key === 'Escape') {
        this.hide(e);
      }
    }
  }, {
    key: 'getDelay',
    value: function getDelay(key) {
      var delay = this.props.delay;

      if ((typeof delay === 'undefined' ? 'undefined' : _typeof(delay)) === 'object') {
        return isNaN(delay[key]) ? DEFAULT_DELAYS$1[key] : delay[key];
      }
      return delay;
    }
  }, {
    key: 'show',
    value: function show(e) {
      if (!this.props.isOpen) {
        this.clearShowTimeout();
        this.toggle(e);
      }
    }
  }, {
    key: 'hide',
    value: function hide(e) {
      if (this.props.isOpen) {
        this.clearHideTimeout();
        this.toggle(e);
      }
    }
  }, {
    key: 'clearShowTimeout',
    value: function clearShowTimeout() {
      clearTimeout(this._showTimeout);
      this._showTimeout = undefined;
    }
  }, {
    key: 'clearHideTimeout',
    value: function clearHideTimeout() {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = undefined;
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e.target === this._target || this._target.contains(e.target)) {
        if (this._hideTimeout) {
          this.clearHideTimeout();
        }

        if (!this.props.isOpen) {
          this.toggle(e);
        }
      } else if (this.props.isOpen && e.target.getAttribute('role') !== 'tooltip') {
        if (this._showTimeout) {
          this.clearShowTimeout();
        }
        this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay('hide'));
      }
    }
  }, {
    key: 'addTargetEvents',
    value: function addTargetEvents() {
      var _this2 = this;

      this._target.addEventListener('mouseover', this.onMouseOverTooltip, true);
      this._target.addEventListener('mouseout', this.onMouseLeaveTooltip, true);
      this._target.addEventListener('keydown', this.onEscKeyDown, true);
      this._target.addEventListener('focusin', this.show, true);
      this._target.addEventListener('focusout', this.hide, true);

      ['click', 'touchstart'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeTargetEvents',
    value: function removeTargetEvents() {
      var _this3 = this;

      this._target.removeEventListener('mouseover', this.onMouseOverTooltip, true);
      this._target.removeEventListener('mouseout', this.onMouseLeaveTooltip, true);
      this._target.addEventListener('keydown', this.onEscKeyDown, true);
      this._target.addEventListener('focusin', this.show, true);
      this._target.addEventListener('focusout', this.hide, true);

      ['click', 'touchstart'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isOpen) {
        return null;
      }

      var attributes = omit(this.props, Object.keys(propTypes$46));
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip-inner', this.props.innerClassName), this.props.cssModule);

      var popperClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip', 'show', this.props.className), this.props.cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        PopperContent,
        {
          className: popperClasses,
          target: this.props.target,
          isOpen: this.props.isOpen,
          hideArrow: this.props.hideArrow,
          placement: this.props.placement,
          placementPrefix: this.props.placementPrefix,
          arrowClassName: this.props.arrowClassName,
          container: this.props.container,
          modifiers: this.props.modifiers,
          offset: this.props.offset,
          cssModule: this.props.cssModule
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, attributes, {
          ref: this.props.innerRef,
          className: classes,
          role: 'tooltip',
          'aria-hidden': this.props.isOpen,
          onMouseOver: this.onMouseOverTooltipContent,
          onMouseLeave: this.onMouseLeaveTooltipContent,
          onKeyDown: this.onEscKeyDown
        }))
      );
    }
  }]);
  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Tooltip.propTypes = propTypes$46;
Tooltip.defaultProps = defaultProps$42;

var propTypes$47 = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bordered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  borderless: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "dark"'),
  dark: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  responsiveTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$43 = {
  tag: 'table',
  responsiveTag: 'div'
};

var Table = function Table(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      bordered = props.bordered,
      borderless = props.borderless,
      striped = props.striped,
      inverse = props.inverse,
      dark = props.dark,
      hover = props.hover,
      responsive = props.responsive,
      Tag = props.tag,
      ResponsiveTag = props.responsiveTag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'bordered', 'borderless', 'striped', 'inverse', 'dark', 'hover', 'responsive', 'tag', 'responsiveTag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'table', size ? 'table-' + size : false, bordered ? 'table-bordered' : false, borderless ? 'table-borderless' : false, striped ? 'table-striped' : false, dark || inverse ? 'table-dark' : false, hover ? 'table-hover' : false), cssModule);

  var table = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));

  if (responsive) {
    var responsiveClassName = responsive === true ? 'table-responsive' : 'table-responsive-' + responsive;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ResponsiveTag,
      { className: responsiveClassName },
      table
    );
  }

  return table;
};

Table.propTypes = propTypes$47;
Table.defaultProps = defaultProps$43;

var propTypes$48 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  flush: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$44 = {
  tag: 'ul'
};

var ListGroup = function ListGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      flush = props.flush,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'flush']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group', flush ? 'list-group-flush' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroup.propTypes = propTypes$48;
ListGroup.defaultProps = defaultProps$44;

var propTypes$49 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$45 = {
  tag: 'form'
};

var Form = function (_Component) {
  inherits(Form, _Component);

  function Form(props) {
    classCallCheck(this, Form);

    var _this = possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

    _this.getRef = _this.getRef.bind(_this);
    _this.submit = _this.submit.bind(_this);
    return _this;
  }

  createClass(Form, [{
    key: 'getRef',
    value: function getRef(ref) {
      if (this.props.innerRef) {
        this.props.innerRef(ref);
      }
      this.ref = ref;
    }
  }, {
    key: 'submit',
    value: function submit() {
      if (this.ref) {
        this.ref.submit();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          inline = _props.inline,
          Tag = _props.tag,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'inline', 'tag', 'innerRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, inline ? 'form-inline' : false), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
    }
  }]);
  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = propTypes$49;
Form.defaultProps = defaultProps$45;

var propTypes$50 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  valid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tooltip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$46 = {
  tag: 'div',
  valid: undefined
};

var FormFeedback = function FormFeedback(props) {
  var className = props.className,
      cssModule = props.cssModule,
      valid = props.valid,
      tooltip = props.tooltip,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'valid', 'tooltip', 'tag']);


  var validMode = tooltip ? 'tooltip' : 'feedback';

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, valid ? 'valid-' + validMode : 'invalid-' + validMode), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormFeedback.propTypes = propTypes$50;
FormFeedback.defaultProps = defaultProps$46;

var propTypes$51 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  row: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$47 = {
  tag: 'div'
};

var FormGroup = function FormGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      row = props.row,
      disabled = props.disabled,
      check = props.check,
      inline = props.inline,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'row', 'disabled', 'check', 'inline', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'position-relative', row ? 'row' : false, check ? 'form-check' : 'form-group', check && inline ? 'form-check-inline' : false, check && disabled ? 'disabled' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormGroup.propTypes = propTypes$51;
FormGroup.defaultProps = defaultProps$47;

var propTypes$52 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$48 = {
  tag: 'small',
  color: 'muted'
};

var FormText = function FormText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      inline = props.inline,
      color = props.color,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'inline', 'color', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, !inline ? 'form-text' : false, color ? 'text-' + color : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormText.propTypes = propTypes$52;
FormText.defaultProps = defaultProps$48;

/* eslint react/prefer-stateless-function: 0 */

var propTypes$53 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  state: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, 'Please use the props "valid" and "invalid" to indicate the state.'),
  valid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  static: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "plaintext"'),
  plaintext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  addon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$49 = {
  type: 'text'
};

var Input = function (_React$Component) {
  inherits(Input, _React$Component);

  function Input(props) {
    classCallCheck(this, Input);

    var _this = possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

    _this.getRef = _this.getRef.bind(_this);
    _this.focus = _this.focus.bind(_this);
    return _this;
  }

  createClass(Input, [{
    key: 'getRef',
    value: function getRef(ref) {
      if (this.props.innerRef) {
        this.props.innerRef(ref);
      }
      this.ref = ref;
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this.ref) {
        this.ref.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          type = _props.type,
          bsSize = _props.bsSize,
          state = _props.state,
          valid = _props.valid,
          invalid = _props.invalid,
          tag = _props.tag,
          addon = _props.addon,
          staticInput = _props.static,
          plaintext = _props.plaintext,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'type', 'bsSize', 'state', 'valid', 'invalid', 'tag', 'addon', 'static', 'plaintext', 'innerRef']);


      var checkInput = ['radio', 'checkbox'].indexOf(type) > -1;
      var isNotaNumber = new RegExp('\\D', 'g');

      var fileInput = type === 'file';
      var textareaInput = type === 'textarea';
      var selectInput = type === 'select';
      var Tag = tag || (selectInput || textareaInput ? type : 'input');

      var formControlClass = 'form-control';

      if (plaintext || staticInput) {
        formControlClass = formControlClass + '-plaintext';
        Tag = tag || 'p';
      } else if (fileInput) {
        formControlClass = formControlClass + '-file';
      } else if (checkInput) {
        if (addon) {
          formControlClass = null;
        } else {
          formControlClass = 'form-check-input';
        }
      }

      if (state && typeof valid === 'undefined' && typeof invalid === 'undefined') {
        if (state === 'danger') {
          invalid = true;
        } else if (state === 'success') {
          valid = true;
        }
      }

      if (attributes.size && isNotaNumber.test(attributes.size)) {
        warnOnce('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
        bsSize = attributes.size;
        delete attributes.size;
      }

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, invalid && 'is-invalid', valid && 'is-valid', bsSize ? 'form-control-' + bsSize : false, formControlClass), cssModule);

      if (Tag === 'input' || tag && typeof tag === 'function') {
        attributes.type = type;
      }

      if (attributes.children && !(plaintext || staticInput || type === 'select' || typeof Tag !== 'string' || Tag === 'select')) {
        warnOnce('Input with a type of "' + type + '" cannot have children. Please use "value"/"defaultValue" instead.');
        delete attributes.children;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
    }
  }]);
  return Input;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Input.propTypes = propTypes$53;
Input.defaultProps = defaultProps$49;

var propTypes$54 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$50 = {
  tag: 'div'
};

var InputGroup = function InputGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      size = props.size,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'size']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group', size ? 'input-group-' + size : null), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroup.propTypes = propTypes$54;
InputGroup.defaultProps = defaultProps$50;

var propTypes$56 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$52 = {
  tag: 'span'
};

var InputGroupText = function InputGroupText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroupText.propTypes = propTypes$56;
InputGroupText.defaultProps = defaultProps$52;

var propTypes$55 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$51 = {
  tag: 'div'
};

var InputGroupAddon = function InputGroupAddon(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      addonType = props.addonType,
      children = props.children,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'addonType', 'children']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group-' + addonType), cssModule);

  // Convenience to assist with transition
  if (typeof children === 'string') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({}, attributes, { className: classes }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroupText, { children: children })
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes, children: children }));
};

InputGroupAddon.propTypes = propTypes$55;
InputGroupAddon.defaultProps = defaultProps$51;

var propTypes$57 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  groupClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  groupAttributes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var InputGroupButton = function InputGroupButton(props) {
  warnOnce('The "InputGroupButton" component has been deprecated.\nPlease use component "InputGroupAddon".');

  var children = props.children,
      groupClassName = props.groupClassName,
      groupAttributes = props.groupAttributes,
      propsWithoutGroup = objectWithoutProperties(props, ['children', 'groupClassName', 'groupAttributes']);


  if (typeof children === 'string') {
    var cssModule = propsWithoutGroup.cssModule,
        tag = propsWithoutGroup.tag,
        addonType = propsWithoutGroup.addonType,
        attributes = objectWithoutProperties(propsWithoutGroup, ['cssModule', 'tag', 'addonType']);


    var allGroupAttributes = _extends({}, groupAttributes, {
      cssModule: cssModule,
      tag: tag,
      addonType: addonType
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      InputGroupAddon,
      _extends({}, allGroupAttributes, { className: groupClassName }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button, _extends({}, attributes, { children: children }))
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroupAddon, _extends({}, props, { children: children }));
};

InputGroupButton.propTypes = propTypes$57;

var propTypes$58 = {
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var InputGroupButtonDropdown = function InputGroupButtonDropdown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, props);
};

InputGroupButtonDropdown.propTypes = propTypes$58;

var colWidths$1 = ['xs', 'sm', 'md', 'lg', 'xl'];

var stringOrNumberProp$1 = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]);

var columnProps$1 = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  size: stringOrNumberProp$1,
  push: deprecated(stringOrNumberProp$1, 'Please use the prop "order"'),
  pull: deprecated(stringOrNumberProp$1, 'Please use the prop "order"'),
  order: stringOrNumberProp$1,
  offset: stringOrNumberProp$1
})]);

var propTypes$59 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  hidden: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  for: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  xs: columnProps$1,
  sm: columnProps$1,
  md: columnProps$1,
  lg: columnProps$1,
  xl: columnProps$1,
  widths: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var defaultProps$53 = {
  tag: 'label',
  widths: colWidths$1
};

var getColumnSizeClass$1 = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : 'col-' + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : 'col-' + colWidth + '-auto';
  }

  return isXs ? 'col-' + colSize : 'col-' + colWidth + '-' + colSize;
};

var Label = function Label(props) {
  var className = props.className,
      cssModule = props.cssModule,
      hidden = props.hidden,
      widths = props.widths,
      Tag = props.tag,
      check = props.check,
      size = props.size,
      htmlFor = props.for,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'hidden', 'widths', 'tag', 'check', 'size', 'for']);


  var colClasses = [];

  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];

    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;
    var colClass = void 0;

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : '-' + colWidth + '-';
      colClass = getColumnSizeClass$1(isXs, colWidth, columnProp.size);

      colClasses.push(mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, defineProperty(_classNames, colClass, columnProp.size || columnProp.size === ''), defineProperty(_classNames, 'order' + colSizeInterfix + columnProp.order, columnProp.order || columnProp.order === 0), defineProperty(_classNames, 'offset' + colSizeInterfix + columnProp.offset, columnProp.offset || columnProp.offset === 0), _classNames))), cssModule);
    } else {
      colClass = getColumnSizeClass$1(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, hidden ? 'sr-only' : false, check ? 'form-check-label' : false, size ? 'col-form-label-' + size : false, colClasses, colClasses.length ? 'col-form-label' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({ htmlFor: htmlFor }, attributes, { className: classes }));
};

Label.propTypes = propTypes$59;
Label.defaultProps = defaultProps$53;

var propTypes$60 = {
  body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  list: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  middle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  object: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var Media = function Media(props) {
  var body = props.body,
      bottom = props.bottom,
      className = props.className,
      cssModule = props.cssModule,
      heading = props.heading,
      left = props.left,
      list = props.list,
      middle = props.middle,
      object = props.object,
      right = props.right,
      tag = props.tag,
      top = props.top,
      attributes = objectWithoutProperties(props, ['body', 'bottom', 'className', 'cssModule', 'heading', 'left', 'list', 'middle', 'object', 'right', 'tag', 'top']);


  var defaultTag = void 0;
  if (heading) {
    defaultTag = 'h4';
  } else if (attributes.href) {
    defaultTag = 'a';
  } else if (attributes.src || object) {
    defaultTag = 'img';
  } else if (list) {
    defaultTag = 'ul';
  } else {
    defaultTag = 'div';
  }
  var Tag = tag || defaultTag;

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
    'media-body': body,
    'media-heading': heading,
    'media-left': left,
    'media-right': right,
    'media-top': top,
    'media-bottom': bottom,
    'media-middle': middle,
    'media-object': object,
    'media-list': list,
    media: !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Media.propTypes = propTypes$60;

var propTypes$61 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  listClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  listTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$54 = {
  tag: 'nav',
  listTag: 'ul',
  'aria-label': 'pagination'
};

var Pagination = function Pagination(props) {
  var className = props.className,
      listClassName = props.listClassName,
      cssModule = props.cssModule,
      size = props.size,
      Tag = props.tag,
      ListTag = props.listTag,
      label = props['aria-label'],
      attributes = objectWithoutProperties(props, ['className', 'listClassName', 'cssModule', 'size', 'tag', 'listTag', 'aria-label']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className), cssModule);

  var listClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(listClassName, 'pagination', defineProperty({}, 'pagination-' + size, !!size)), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    { className: classes, 'aria-label': label },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListTag, _extends({}, attributes, { className: listClasses }))
  );
};

Pagination.propTypes = propTypes$61;
Pagination.defaultProps = defaultProps$54;

var propTypes$62 = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$55 = {
  tag: 'li'
};

var PaginationItem = function PaginationItem(props) {
  var active = props.active,
      className = props.className,
      cssModule = props.cssModule,
      disabled = props.disabled,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['active', 'className', 'cssModule', 'disabled', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'page-item', {
    active: active,
    disabled: disabled
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PaginationItem.propTypes = propTypes$62;
PaginationItem.defaultProps = defaultProps$55;

var propTypes$63 = {
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$56 = {
  tag: 'a'
};

var PaginationLink = function PaginationLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      next = props.next,
      previous = props.previous,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'next', 'previous', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'page-link'), cssModule);

  var defaultAriaLabel = void 0;
  if (previous) {
    defaultAriaLabel = 'Previous';
  } else if (next) {
    defaultAriaLabel = 'Next';
  }
  var ariaLabel = props['aria-label'] || defaultAriaLabel;

  var defaultCaret = void 0;
  if (previous) {
    defaultCaret = '\xAB';
  } else if (next) {
    defaultCaret = '\xBB';
  }

  var children = props.children;
  if (children && Array.isArray(children) && children.length === 0) {
    children = null;
  }

  if (!attributes.href && Tag === 'a') {
    Tag = 'button';
  }

  if (previous || next) {
    children = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        'aria-hidden': 'true',
        key: 'caret'
      },
      children || defaultCaret
    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        className: 'sr-only',
        key: 'sr'
      },
      ariaLabel
    )];
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, {
      className: classes,
      'aria-label': ariaLabel
    }),
    children
  );
};

PaginationLink.propTypes = propTypes$63;
PaginationLink.defaultProps = defaultProps$56;

var propTypes$64 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  activeTab: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$57 = {
  tag: 'div'
};

var childContextTypes$2 = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var TabContent = function (_Component) {
  inherits(TabContent, _Component);
  createClass(TabContent, null, [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (prevState.activeTab !== nextProps.activeTab) {
        return {
          activeTab: nextProps.activeTab
        };
      }
      return null;
    }
  }]);

  function TabContent(props) {
    classCallCheck(this, TabContent);

    var _this = possibleConstructorReturn(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).call(this, props));

    _this.state = {
      activeTab: _this.props.activeTab
    };
    return _this;
  }

  createClass(TabContent, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        activeTabId: this.state.activeTab
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          Tag = _props.tag;


      var attributes = omit(this.props, Object.keys(propTypes$64));

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tab-content', className), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
    }
  }]);
  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__["polyfill"])(TabContent);
TabContent.propTypes = propTypes$64;
TabContent.defaultProps = defaultProps$57;
TabContent.childContextTypes = childContextTypes$2;

var propTypes$65 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  tabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$58 = {
  tag: 'div'
};

var contextTypes$3 = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

function TabPane(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      tabId = props.tabId,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tabId', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tab-pane', className, { active: tabId === context.activeTabId }), cssModule);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
}
TabPane.propTypes = propTypes$65;
TabPane.defaultProps = defaultProps$58;
TabPane.contextTypes = contextTypes$3;

var propTypes$66 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  fluid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$59 = {
  tag: 'div'
};

var Jumbotron = function Jumbotron(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      fluid = props.fluid,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'fluid']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'jumbotron', fluid ? 'jumbotron-fluid' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Jumbotron.propTypes = propTypes$66;
Jumbotron.defaultProps = defaultProps$59;

var propTypes$67 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  transition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(Fade.propTypes),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

var defaultProps$60 = {
  color: 'success',
  isOpen: true,
  tag: 'div',
  closeAriaLabel: 'Close',
  fade: true,
  transition: _extends({}, Fade.defaultProps, {
    unmountOnExit: true
  })
};

function Alert(props) {
  var className = props.className,
      closeClassName = props.closeClassName,
      closeAriaLabel = props.closeAriaLabel,
      cssModule = props.cssModule,
      Tag = props.tag,
      color = props.color,
      isOpen = props.isOpen,
      toggle = props.toggle,
      children = props.children,
      transition = props.transition,
      fade = props.fade,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'closeClassName', 'closeAriaLabel', 'cssModule', 'tag', 'color', 'isOpen', 'toggle', 'children', 'transition', 'fade', 'innerRef']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'alert', 'alert-' + color, { 'alert-dismissible': toggle }), cssModule);

  var closeClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('close', closeClassName), cssModule);

  var alertTransition = _extends({}, Fade.defaultProps, transition, {
    baseClass: fade ? transition.baseClass : '',
    timeout: fade ? transition.timeout : 0
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Fade,
    _extends({}, attributes, alertTransition, { tag: Tag, className: classes, 'in': isOpen, role: 'alert', innerRef: innerRef }),
    toggle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { type: 'button', className: closeClasses, 'aria-label': closeAriaLabel, onClick: toggle },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        '\xD7'
      )
    ) : null,
    children
  );
}

Alert.propTypes = propTypes$67;
Alert.defaultProps = defaultProps$60;

var _transitionStatusToCl;

var propTypes$68 = _extends({}, Transition.propTypes, {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  navbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
});

var defaultProps$61 = _extends({}, Transition.defaultProps, {
  isOpen: false,
  appear: false,
  enter: true,
  exit: true,
  tag: 'div',
  timeout: TransitionTimeouts.Collapse
});

var transitionStatusToClassHash = (_transitionStatusToCl = {}, defineProperty(_transitionStatusToCl, TransitionStatuses.ENTERING, 'collapsing'), defineProperty(_transitionStatusToCl, TransitionStatuses.ENTERED, 'collapse show'), defineProperty(_transitionStatusToCl, TransitionStatuses.EXITING, 'collapsing'), defineProperty(_transitionStatusToCl, TransitionStatuses.EXITED, 'collapse'), _transitionStatusToCl);

function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || 'collapse';
}

function getHeight(node) {
  return node.scrollHeight;
}

var Collapse = function (_Component) {
  inherits(Collapse, _Component);

  function Collapse(props) {
    classCallCheck(this, Collapse);

    var _this = possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    _this.state = {
      height: null
    };

    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(function (name) {
      _this[name] = _this[name].bind(_this);
    });
    return _this;
  }

  createClass(Collapse, [{
    key: 'onEntering',
    value: function onEntering(node, isAppearing) {
      this.setState({ height: getHeight(node) });
      this.props.onEntering(node, isAppearing);
    }
  }, {
    key: 'onEntered',
    value: function onEntered(node, isAppearing) {
      this.setState({ height: null });
      this.props.onEntered(node, isAppearing);
    }
  }, {
    key: 'onExit',
    value: function onExit(node) {
      this.setState({ height: getHeight(node) });
      this.props.onExit(node);
    }
  }, {
    key: 'onExiting',
    value: function onExiting(node) {
      // getting this variable triggers a reflow
      var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
      this.setState({ height: 0 });
      this.props.onExiting(node);
    }
  }, {
    key: 'onExited',
    value: function onExited(node) {
      this.setState({ height: null });
      this.props.onExited(node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          Tag = _props.tag,
          isOpen = _props.isOpen,
          className = _props.className,
          navbar = _props.navbar,
          cssModule = _props.cssModule,
          children = _props.children,
          innerRef = _props.innerRef,
          otherProps = objectWithoutProperties(_props, ['tag', 'isOpen', 'className', 'navbar', 'cssModule', 'children', 'innerRef']);
      var height = this.state.height;

      // In NODE_ENV=production the Transition.propTypes are wrapped which results in an
      // empty object "{}". This is the result of the `react-transition-group` babel
      // configuration settings. Therefore, to ensure that production builds work without
      // error, we can either explicitly define keys or use the Transition.defaultProps.
      // Using the Transition.defaultProps excludes any required props. Thus, the best
      // solution is to explicitly define required props in our utilities and reference these.
      // This also gives us more flexibility in the future to remove the prop-types
      // dependency in distribution builds (Similar to how `react-transition-group` does).
      // Note: Without omitting the `react-transition-group` props, the resulting child
      // Tag component would inherit the Transition properties as attributes for the HTML
      // element which results in errors/warnings for non-valid attributes.

      var transitionProps = pick(otherProps, TransitionPropTypeKeys);
      var childProps = omit(otherProps, TransitionPropTypeKeys);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Transition,
        _extends({}, transitionProps, {
          'in': isOpen,
          onEntering: this.onEntering,
          onEntered: this.onEntered,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }),
        function (status) {
          var collapseClass = getTransitionClass(status);
          var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, collapseClass, navbar && 'navbar-collapse'), cssModule);
          var style = height === null ? null : { height: height };
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Tag,
            _extends({}, childProps, {
              style: _extends({}, childProps.style, style),
              className: classes,
              ref: _this2.props.innerRef
            }),
            children
          );
        }
      );
    }
  }]);
  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Collapse.propTypes = propTypes$68;
Collapse.defaultProps = defaultProps$61;

var propTypes$69 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  action: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$62 = {
  tag: 'li'
};

var handleDisabledOnClick = function handleDisabledOnClick(e) {
  e.preventDefault();
};

var ListGroupItem = function ListGroupItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      active = props.active,
      disabled = props.disabled,
      action = props.action,
      color = props.color,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'active', 'disabled', 'action', 'color']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, active ? 'active' : false, disabled ? 'disabled' : false, action ? 'list-group-item-action' : false, color ? 'list-group-item-' + color : false, 'list-group-item'), cssModule);

  // Prevent click event when disabled.
  if (disabled) {
    attributes.onClick = handleDisabledOnClick;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItem.propTypes = propTypes$69;
ListGroupItem.defaultProps = defaultProps$62;

var propTypes$70 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$63 = {
  tag: 'h5'
};

var ListGroupItemHeading = function ListGroupItemHeading(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group-item-heading'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItemHeading.propTypes = propTypes$70;
ListGroupItemHeading.defaultProps = defaultProps$63;

var propTypes$71 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$64 = {
  tag: 'p'
};

var ListGroupItemText = function ListGroupItemText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group-item-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItemText.propTypes = propTypes$71;
ListGroupItemText.defaultProps = defaultProps$64;

var UncontrolledAlert = function (_Component) {
  inherits(UncontrolledAlert, _Component);

  function UncontrolledAlert(props) {
    classCallCheck(this, UncontrolledAlert);

    var _this = possibleConstructorReturn(this, (UncontrolledAlert.__proto__ || Object.getPrototypeOf(UncontrolledAlert)).call(this, props));

    _this.state = { isOpen: true };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledAlert, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Alert, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledAlert;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var UncontrolledButtonDropdown = function (_Component) {
  inherits(UncontrolledButtonDropdown, _Component);

  function UncontrolledButtonDropdown(props) {
    classCallCheck(this, UncontrolledButtonDropdown);

    var _this = possibleConstructorReturn(this, (UncontrolledButtonDropdown.__proto__ || Object.getPrototypeOf(UncontrolledButtonDropdown)).call(this, props));

    _this.state = { isOpen: false };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledButtonDropdown, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonDropdown, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledButtonDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var propTypes$72 = {
  toggler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  toggleEvents: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
};

var defaultProps$65 = {
  toggleEvents: defaultToggleEvents
};

var UncontrolledCollapse = function (_Component) {
  inherits(UncontrolledCollapse, _Component);

  function UncontrolledCollapse(props) {
    classCallCheck(this, UncontrolledCollapse);

    var _this = possibleConstructorReturn(this, (UncontrolledCollapse.__proto__ || Object.getPrototypeOf(UncontrolledCollapse)).call(this, props));

    _this.togglers = null;
    _this.removeEventListeners = null;
    _this.toggle = _this.toggle.bind(_this);

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  createClass(UncontrolledCollapse, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.togglers = findDOMElements(this.props.toggler);
      if (this.togglers.length) {
        this.removeEventListeners = addMultipleEventListeners(this.togglers, this.toggle, this.props.toggleEvents);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.togglers.length && this.removeEventListeners) {
        this.removeEventListeners();
      }
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      this.setState(function (_ref) {
        var isOpen = _ref.isOpen;
        return { isOpen: !isOpen };
      });
      e.preventDefault();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          toggleEvents = _props.toggleEvents,
          rest = objectWithoutProperties(_props, ['toggleEvents']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Collapse, _extends({ isOpen: this.state.isOpen }, rest));
    }
  }]);
  return UncontrolledCollapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

UncontrolledCollapse.propTypes = propTypes$72;
UncontrolledCollapse.defaultProps = defaultProps$65;

var UncontrolledDropdown = function (_Component) {
  inherits(UncontrolledDropdown, _Component);

  function UncontrolledDropdown(props) {
    classCallCheck(this, UncontrolledDropdown);

    var _this = possibleConstructorReturn(this, (UncontrolledDropdown.__proto__ || Object.getPrototypeOf(UncontrolledDropdown)).call(this, props));

    _this.state = { isOpen: false };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledDropdown, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var UncontrolledNavDropdown = function UncontrolledNavDropdown(props) {
  warnOnce('The "UncontrolledNavDropdown" component has been deprecated.\nPlease use component "UncontrolledDropdown" with nav prop.');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UncontrolledDropdown, _extends({ nav: true }, props));
};

var UncontrolledTooltip = function (_Component) {
  inherits(UncontrolledTooltip, _Component);

  function UncontrolledTooltip(props) {
    classCallCheck(this, UncontrolledTooltip);

    var _this = possibleConstructorReturn(this, (UncontrolledTooltip.__proto__ || Object.getPrototypeOf(UncontrolledTooltip)).call(this, props));

    _this.state = { isOpen: false };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledTooltip, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tooltip, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledTooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


//# sourceMappingURL=reactstrap.es.js.map


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var core = __webpack_require__(35);
var hide = __webpack_require__(46);
var redefine = __webpack_require__(47);
var ctx = __webpack_require__(49);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return REPORT_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return REPORT_OUT_OF_STOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return REPORT_ZUPPER_SELLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return REPORT_BANCAMIGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return REPORT_BALANCE_MODIFIERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return REPORT_CITY_MOVEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return REPORT_CITY_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return REPORT_BRANCH_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return REPORT_BRANCH_GROUP_SALE_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return REPORT_BRANCH_PENDING_FEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return REPORT_BRANCH_PAID_INVOICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return REPORT_BRANCH_PAID_INVOICES_ALT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return REPORT_PAID_ORDERS_TO_BRANCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return REPORT_PENDING_FEES_TO_RIDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return REPORT_RIDERS_PAID_INVOICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return REPORT_RIDERS_ONLINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return REPORT_RIDERS_MOVEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return REPORT_RIDERS_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return REPORT_ACCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return REPORT_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return REPORT_USERS_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return REPORT_CLIENTS_WITH_BALANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return REPORT_CLIENTS_MOVEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return REPORT_CLIENT_PAID_INVOICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return REPORT_USER_LOGINS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return REPORT_COMPANY_SALES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return REPORT_COMPANY_PAYMENT_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return REPORT_RECENT_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return REPORT_GENERAL_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return REPORT_COMPANY_ORDERS_REVENUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return REPORT_ORDER_RATINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return REPORT_BRANCH_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return REPORT_RIDERS_EARNINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return REPORT_RIDER_EARNINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return REPORT_GENERAL_OPERATIONS_OF_RIDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return REPORT_GENERAL_OPERATIONS_OF_RIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return REPORT_PRODUCTS_PURCHASED_BY_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return REPORT_PRODUCTS_SOLD_BY_BRANCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return REPORT_PRODUCTS_SOLD_BY_USER_ON_BRANCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return REPORT_TOTAL_PRODUCTS_SOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return REPORT_TOTAL_PRODUCTS_PURCHASED_BY_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return REPORT_TOTAL_PRODUCTS_SOLD_BY_BRANCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return REPORT_TOTAL_PRODUCTS_PURCHASED_BY_USER_IN_BRANCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return REPORT_ORDERS_BY_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return REPORT_BRANCH_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return REPORT_BRANCH_REPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return REPORT_COUPONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return REPORT_COUPON_INVESTMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return REPORT_AVAILABLE_COUPONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return REPORT_USED_COUPONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return REPORT_BRANCH_PROMOTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return REPORT_BRANCH_MOVEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return REPORT_PROVIDER_FEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return IMPORT_CONFIG_GOOD_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return IMPORT_CONFIG_MAPPING_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CSV_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return MASK_AGENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AGENT_MANUAL; });
/* unused harmony export AGENT_PAYPAL */
/* unused harmony export AGENT_STRIPE */
/* unused harmony export AGENT_INSTAPAGO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AGENT_ZELLE; });
/* unused harmony export AGENT_POST_PAYMENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return PAYMENT_IS_WAITING_CONFIRMATION; });
/* unused harmony export PAYMENT_IS_CANCELLED_BY_CLIENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return PAYMENT_IS_CANCELLED_AS_DUPLICATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return PAYMENT_IS_CANCELLED_AS_INVALID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return PAYMENT_IS_ACCEPTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BRANCH_ACCESS; });
/* unused harmony export BRANCH_PROPERTY_TYPES */
/* unused harmony export DEFAULT_PAGE_SIZE */
/* unused harmony export DEFAULT_ORDERS_PAGE_SIZE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DEFAULT_PRODUCTS_PAGE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CARACAS_GEO_POSTITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BRANCH_GROUPS_ACCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return COMPANY_ACCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return TXT_REGEX_MIN4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return TXT_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DEFAULT_TIME_ZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return EMAIL_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return MIN_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return HOURS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GEO_DECIMAL_PLACES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return LANGUAGES; });
/* unused harmony export CITIES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return MIN_RAINTING_COUNT_TO_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return NUMBER_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return TXT_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MANDATORY_NUMBER_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return MANDATORY_TXT_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return UNLIMITED_STOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FLAG_ADMIN_CUSTOMIZABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return MANDATORY_EMAIL_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BANCOS_VENEZUELA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return PM_VENEZUELA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DNI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return TIMEZONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCOUNT_TYPES; });
/* unused harmony export PHONE_PREFIX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return PHONE_COMPANY_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return PM_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return REPORTS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FLEET_CURRENCIES_ISO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FLEET_BINDING_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return PERMISSIONS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return ORDER_COUPON_REASONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return WEBHOOKS_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return WEBHOOK_METHODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return WEBHOOK_AUTH_TYPES; });
var DEFAULT_TIME_ZONE="-04:00";var MIN_LIST=[{value:0,name:"No aplica"},{value:15*60*1000,name:"Durante 15 minutos"},{value:30*60*1000,name:"Durante 30 minutos"},{value:45*60*1000,name:"Durante 45 minutos"},{value:60*60*1000,name:"Durante 1 hora"},{value:120*60*1000,name:"Durante 2 horas"}];var HOURS_LIST=[{value:'00:00',name:'12:00 AM'},{value:'00:30',name:'12:30 AM'},{value:'01:00',name:'1:00 AM'},{value:'01:30',name:'1:30 AM'},{value:'02:00',name:'2:00 AM'},{value:'02:30',name:'2:30 AM'},{value:'03:00',name:'3:00 AM'},{value:'03:30',name:'3:30 AM'},{value:'04:00',name:'4:00 AM'},{value:'04:30',name:'4:30 AM'},{value:'05:00',name:'5:00 AM'},{value:'05:30',name:'5:30 AM'},{value:'06:00',name:'6:00 AM'},{value:'06:30',name:'6:30 AM'},{value:'07:00',name:'7:00 AM'},{value:'07:30',name:'7:30 AM'},{value:'08:00',name:'8:00 AM'},{value:'08:30',name:'8:30 AM'},{value:'09:00',name:'9:00 AM'},{value:'09:30',name:'9:30 AM'},{value:'10:00',name:'10:00 AM'},{value:'10:30',name:'10:30 AM'},{value:'11:00',name:'11:00 AM'},{value:'11:30',name:'11:30 AM'},{value:'12:00',name:'12:00 PM'},{value:'12:30',name:'12:30 PM'},{value:'13:00',name:'1:00 PM'},{value:'13:30',name:'1:30 PM'},{value:'14:00',name:'2:00 PM'},{value:'14:30',name:'2:30 PM'},{value:'15:00',name:'3:00 PM'},{value:'15:30',name:'3:30 PM'},{value:'16:00',name:'4:00 PM'},{value:'16:30',name:'4:30 PM'},{value:'17:00',name:'5:00 PM'},{value:'17:30',name:'5:30 PM'},{value:'18:00',name:'6:00 PM'},{value:'18:30',name:'6:30 PM'},{value:'19:00',name:'7:00 PM'},{value:'19:30',name:'7:30 PM'},{value:'20:00',name:'8:00 PM'},{value:'20:30',name:'8:30 PM'},{value:'21:00',name:'9:00 PM'},{value:'21:30',name:'9:30 PM'},{value:'22:00',name:'10:00 PM'},{value:'22:30',name:'10:30 PM'},{value:'23:00',name:'11:00 PM'},{value:'23:30',name:'11:30 PM'}];var TIMEZONES=[{value:'-12:00',name:'-12:00'},{value:'-11:30',name:'-11:30'},{value:'-11:00',name:'-11:00'},{value:'-10:30',name:'-10:30'},{value:'-10:00',name:'-10:00'},{value:'-09:30',name:'-09:30'},{value:'-09:00',name:'-09:00'},{value:'-08:30',name:'-08:30'},{value:'-08:00',name:'-08:00'},{value:'-07:30',name:'-07:30'},{value:'-07:00',name:'-07:00'},{value:'-06:30',name:'-06:30'},{value:'-06:00',name:'-06:00'},{value:'-05:30',name:'-05:30'},{value:'-05:00',name:'-05:00'},{value:'-04:30',name:'-04:30'},{value:'-04:00',name:'-04:00'},{value:'-03:30',name:'-03:30'},{value:'-03:00',name:'-03:00'},{value:'-02:30',name:'-02:30'},{value:'-02:00',name:'-02:00'},{value:'-01:30',name:'-01:30'},{value:'-01:00',name:'-01:00'},{value:'+00:00',name:'+00:00'},{value:'+00:30',name:'+00:30'},{value:'+01:00',name:'+01:00'},{value:'+01:30',name:'+01:30'},{value:'+02:00',name:'+02:00'},{value:'+02:30',name:'+02:30'},{value:'+03:00',name:'+03:00'},{value:'+03:30',name:'+03:30'},{value:'+04:00',name:'+04:00'},{value:'+04:30',name:'+04:30'},{value:'+05:00',name:'+05:00'},{value:'+05:30',name:'+05:30'},{value:'+06:00',name:'+06:00'},{value:'+06:30',name:'+06:30'},{value:'+07:00',name:'+07:00'},{value:'+07:30',name:'+07:30'},{value:'+08:00',name:'+08:00'},{value:'+08:30',name:'+08:30'},{value:'+09:00',name:'+09:00'},{value:'+09:30',name:'+09:30'},{value:'+10:00',name:'+10:00'},{value:'+10:30',name:'+10:30'},{value:'+11:00',name:'+11:00'},{value:'+11:30',name:'+11:30'},{value:'+12:00',name:'+12:00'},{value:'+12:30',name:'+12:30'},{value:'+13:00',name:'+13:00'},{value:'+13:30',name:'+13:30'},{value:'+14:00',name:'+14:00'}];var GEO_DECIMAL_PLACES=1000000;var LANGUAGES=[{"value":'es',"name":"Espa\xF1ol"},{"value":'en',"name":"English"}];var CITIES=[{"value":10,"name":'Caracas'},{"value":3,"name":'Cumana'}];var MIN_RAINTING_COUNT_TO_SHOW=1;var MANDATORY_NUMBER_REGEX="^[0-9]+^";var NUMBER_REGEX="^[0-9]*^";var MANDATORY_TXT_REGEX="^.+^";var TXT_REGEX="^.*^";var TXT_REGEX_MIN4="^(.){4,}^";var MANDATORY_EMAIL_REGEX="^[a-zA-Z0-9\\+\\.\\_\\%\\-\\+]{1,256}\\@[a-zA-Z0-9][a-zA-Z0-9\\-]{0,64}(\\.[a-zA-Z0-9][a-zA-Z0-9\\-]{0,25})+^";var EMAIL_REGEX="^([a-zA-Z0-9\\+\\.\\_\\%\\-\\+]{1,256}\\@[a-zA-Z0-9][a-zA-Z0-9\\-]{0,64}(\\.[a-zA-Z0-9][a-zA-Z0-9\\-]{0,25})+)?^";var TXT_DATE="^([0-2][0-9]|(3)[0-1])(\\\/)(((0)[0-9])|((1)[0-2]))(\\\/)\\d{4}^";var UNLIMITED_STOCK=-1;var FLAG_ADMIN_CUSTOMIZABLE=268435456;var DEFAULT_PAGE_SIZE=10;var DEFAULT_ORDERS_PAGE_SIZE=20;var DEFAULT_PRODUCTS_PAGE_SIZE=100;var FLEET_CURRENCIES_ISO=[{value:"VES",label:"VES"}];var FLEET_BINDING_ATTRIBUTE=[{value:"providers:pos_serial",label:"providers:pos_serial"}];var BANCOS_VENEZUELA=['100% Banco','ABN AMRO Bank','Bancamiga','Banco Activo Banco Comercial','Banco Agricola','Banco Bicentenario','Banco Caroni Banco Universal','Banco De Desarrollo Del Microempresario','Banco de Venezuela','Banco Del Caribe','Banco Del Pueblo Soberano','Banco Del Tesoro','Banco Espirito Santo','Banco Exterior','Banco Industrual De Venezuela','Banco internacional De Desarrollo','Banco Mercantil','Banco Nacional De Credito','Banco Occidental De Descuento','Banco Plaza','Banco Provincial BBVA','Banco Venezolano De Credito','Bancrecer Banco De Desarrollo','Banesco Banco Universal','BANFANB','Bangente','Banplus Banco Comercial','Citibank','Corp Banca','DELSUR Banco Universal','BancoFondoComun','Instituto Municipal De Credito Popular','Mi Banco, Banco de desarrollo','Sofitasa'];var PM_VENEZUELA=[{"value":"0102","name":"0102 - Banco de Venezuela"},{"value":"0104","name":"0104 - Venezolano de Crédito"},{"value":"0105","name":"0105 - Banco Mercantil"},{"value":"0108","name":"0108 - Banco Provincial"},{"value":"0114","name":"0114 - Bancaribe"},{"value":"0115","name":"0115 - Banco Exterior"},{"value":"0116","name":"0116 - Banco Occidental de Descuento"},{"value":"0128","name":"0128 - Banco Caroní"},{"value":"0134","name":"0134 - Banesco"},{"value":"0137","name":"0137 - Banco Sofitasa"},{"value":"0138","name":"0138 - Banco Plaza"},{"value":"0146","name":"0146 - Banco de la Gente Emprendedora"},{"value":"0151","name":"0151 - BFC Banco Fondo Común"},{"value":"0156","name":"0156 - 100% Banco"},{"value":"0157","name":"0157 - DelSur Banco"},{"value":"0163","name":"0163 - Banco del Tesoro"},{"value":"0166","name":"0166 - Banco Agrícola de Venezuela"},{"value":"0168","name":"0168 - Bancrecer"},{"value":"0169","name":"0169 - Mi Banco"},{"value":"0171","name":"0171 - Banco Activo"},{"value":"0172","name":"0172 - Bancamica"},{"value":"0173","name":"0173 - Banco Internacional de Desarrollo"},{"value":"0174","name":"0174 - Banplus"},{"value":"0175","name":"0175 - Banco Bicentenario"},{"value":"0176","name":"0176 - Novos Banco"},{"value":"0177","name":"0177 - Banco de la Fuerza Armana Nacional Bolivariana"},{"value":"0190","name":"0190 - Citibank"},{"value":"0191","name":"0191 - Banco Nacional de Crédito"}];var DNI=[{"value":"V","name":"V"},{"value":"E","name":"E"},{"value":"J","name":"J (R.I.F)"},{"value":"G","name":"G"}];// Tipo de acceso por numero para facilitar comparaciones
var BRANCH_ACCESS=1;var BRANCH_GROUPS_ACCESS=2;var COMPANY_ACCESS=3;var CARACAS_GEO_POSTITION=[10.48801,-66.87919];var ACCOUNT_TYPES={client:0,provider:15,sellerAdmin:48,lowAdmin:112,highAdmin:119,ownerAdmin:127,superAdmin:255};var BRANCH_PROPERTY_TYPES={numeric:512,list:256,text:1024};var PHONE_PREFIX=[{value:'58',name:'+58'}];var PHONE_COMPANY_PREFIX=[{value:"412",name:"0412"},{value:"422",name:"0422"},{value:"414",name:"0414"},{value:"424",name:"0424"},{value:"416",name:"0416"},{value:"426",name:"0426"}];var PM_PREFIX=[{"value":"0412","name":"0412"},{"value":"0414","name":"0414"},{"value":"0416","name":"0416"},{"value":"0422","name":"0422"},{"value":"0424","name":"0424"},{"value":"0426","name":"0426"}];// REPORTES
var REPORT_ADMIN="report-admin";var REPORT_OUT_OF_STOCK="report-oos";var REPORT_ZUPPER_SELLS="report-zs";var REPORT_BANCAMIGA="report-bancamiga";var REPORT_BALANCE_MODIFIERS="report-bmod";var REPORT_CITY_MOVEMENTS="report-citym";var REPORT_CITY_SUMMARY="report-citys";var REPORT_BRANCH_DETAILS="report-bd";var REPORT_BRANCH_GROUP_SALE_DETAILS="report-bgsd";var REPORT_BRANCH_PENDING_FEES="report-bpf";var REPORT_BRANCH_PAID_INVOICES="report-bpi";var REPORT_BRANCH_PAID_INVOICES_ALT="report-bpialt";var REPORT_PAID_ORDERS_TO_BRANCH="report-potb";var REPORT_PENDING_FEES_TO_RIDERS="report-pftr";var REPORT_RIDERS_PAID_INVOICES="report-rpi";var REPORT_RIDERS_ONLINE="report-ro";var REPORT_RIDERS_MOVEMENTS="report-rm";var REPORT_RIDERS_STATUS="report-rs";var REPORT_ACCESS="report-access";var REPORT_USERS="report-users";var REPORT_USERS_EMAIL="report-ue";var REPORT_CLIENTS_WITH_BALANCE="report-cwb";var REPORT_CLIENTS_MOVEMENTS="report-cm";var REPORT_CLIENT_PAID_INVOICES="report-cpi";var REPORT_USER_LOGINS="report-ul";var REPORT_COMPANY_SALES="report-cs";var REPORT_COMPANY_PAYMENT_DETAILS="report-cpd";var REPORT_RECENT_USERS="report-ru";var REPORT_GENERAL_ORDERS="report-go";var REPORT_COMPANY_ORDERS_REVENUE="report-core";var REPORT_ORDER_RATINGS="report-or";var REPORT_BRANCH_ORDERS="report-bo";var REPORT_RIDERS_EARNINGS="report-rre";var REPORT_RIDER_EARNINGS="report-re";var REPORT_GENERAL_OPERATIONS_OF_RIDERS="report-goorr";var REPORT_GENERAL_OPERATIONS_OF_RIDER="report-goor";var REPORT_PRODUCTS_PURCHASED_BY_USERS="report-ppbu";var REPORT_PRODUCTS_SOLD_BY_BRANCH="report-psbb";var REPORT_PRODUCTS_SOLD_BY_USER_ON_BRANCH="report-psbuob";var REPORT_TOTAL_PRODUCTS_SOLD="report-tps";var REPORT_TOTAL_PRODUCTS_PURCHASED_BY_USER="report-tppbu";var REPORT_TOTAL_PRODUCTS_SOLD_BY_BRANCH="report-tpsbb";var REPORT_TOTAL_PRODUCTS_PURCHASED_BY_USER_IN_BRANCH="report-tppbuib";var REPORT_ORDERS_BY_USER="report-obu";var REPORT_BRANCH_LIST="report-bl";var REPORT_BRANCH_REPORTS="report-br";var REPORT_COUPONS="report-coupons";var REPORT_COUPON_INVESTMENTS="report-ci";var REPORT_AVAILABLE_COUPONS="report-ac";var REPORT_USED_COUPONS="report-uc";var REPORT_BRANCH_PROMOTION="report-bp";var REPORT_BRANCH_MOVEMENTS="report-bm";var REPORT_PROVIDER_FEES="report-pf";var REPORTS_LIST=[{type:"company",reports:[{name:'Administradores',value:REPORT_ADMIN,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.highAdmin,withDates:false,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:false,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Ventas de Zupper',value:REPORT_ZUPPER_SELLS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.highAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:true,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:true,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Reporte Bancamiga',value:REPORT_BANCAMIGA,permissions:{type:COMPANY_ACCESS,withFile:true,hierarchy:ACCOUNT_TYPES.highAdmin,withDates:false,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:false,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Uso de Zupper Créditos',value:REPORT_BALANCE_MODIFIERS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.highAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Movimientos de la ciudad',value:REPORT_CITY_MOVEMENTS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.highAdmin,withDates:true,forceCity:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:true,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Finanzas de la ciudad',value:REPORT_CITY_SUMMARY,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.highAdmin,withDates:true,forceCity:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:true,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Reporte de accesos',value:REPORT_ACCESS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:false,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Detalles de comercio',value:REPORT_BRANCH_DETAILS,permissions:{type:BRANCH_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:false,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Facturas pendientes de comercios',value:REPORT_BRANCH_PENDING_FEES,permissions:{type:BRANCH_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:false,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:true,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Facturas pagadas a comercio',value:REPORT_BRANCH_PAID_INVOICES,permissions:{type:BRANCH_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:true,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Órdenes pagadas a comercios',value:REPORT_PAID_ORDERS_TO_BRANCH,permissions:{type:BRANCH_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:true,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Ventas de Compañia',value:REPORT_COMPANY_SALES,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Detalles de pago de compañia',value:REPORT_COMPANY_PAYMENT_DETAILS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Órdenes generales',value:REPORT_GENERAL_ORDERS,permissions:{type:BRANCH_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:true,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Ingresos de órdenes generales',value:REPORT_COMPANY_ORDERS_REVENUE,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:true,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Ratings de órdenes',value:REPORT_ORDER_RATINGS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:true,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Total general de productos vendidos',value:REPORT_TOTAL_PRODUCTS_SOLD,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Listado de comercios',value:REPORT_BRANCH_LIST,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:false,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:false,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Productos de comercio',value:REPORT_BRANCH_REPORTS,permissions:{type:BRANCH_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:true,withClients:false,withBranches:false,// Dependera de si esta activa no una branch id
maxDateRange:false,withProviders:false,activateModal:false,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:true,withBranchGroups:false,branchAsParameter:true,appendingQueryString:false}},{name:'Cupones',value:REPORT_COUPONS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:false,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:false,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Inversión por cupón',value:REPORT_COUPON_INVESTMENTS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:true,dependsOnBranch:false,withBranchGroups:true,branchAsParameter:false,appendingQueryString:false}},{name:'Cupones disponibles',value:REPORT_AVAILABLE_COUPONS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:false,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Cupones usados',value:REPORT_USED_COUPONS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:false,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}}]},{type:"branches",reports:[{name:'Productos agotados',value:REPORT_OUT_OF_STOCK,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:false,autoBranch:true,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:false,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:true,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Detalles de ventas de grupo de comercio',value:REPORT_BRANCH_GROUP_SALE_DETAILS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:true,branchAsParameter:false,appendingQueryString:false}},{name:'Órdenes de comercio',value:REPORT_BRANCH_ORDERS,permissions:{type:BRANCH_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:true,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:true,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Facturas pagadas a comercio',value:REPORT_BRANCH_PAID_INVOICES_ALT,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:true,withClients:false,withBranches:true,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:true,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Detalles de productos vendidos por comercio',value:REPORT_PRODUCTS_SOLD_BY_BRANCH,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:true,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:true,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Total de productos vendidos por comercio',value:REPORT_TOTAL_PRODUCTS_SOLD_BY_BRANCH,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:true,withClients:false,withBranches:true,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:true,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Promoción de comercio',value:REPORT_BRANCH_PROMOTION,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:true,withClients:false,withBranches:true,maxDateRange:false,withProviders:false,activateModal:false,branchRequired:false,withCityFilter:false,withAllBranches:true,dependsOnBranch:true,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Movimientos de comercio',value:REPORT_BRANCH_MOVEMENTS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:true,withClients:false,withBranches:true,maxDateRange:false,withProviders:false,activateModal:false,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:true,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Envíos de comercio',value:REPORT_PROVIDER_FEES,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:true,withClients:false,withBranches:true,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:true,withBranchGroups:false,branchAsParameter:true,appendingQueryString:false}}]},{type:"providers",reports:[{name:'Facturas pendientes de repartidores',value:REPORT_PENDING_FEES_TO_RIDERS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:false,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Facturas pagadas a repartidores',value:REPORT_RIDERS_PAID_INVOICES,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Repartidores online',value:REPORT_RIDERS_ONLINE,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Balance de repartidores',value:REPORT_RIDERS_MOVEMENTS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:false,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Estado de proveedores',value:REPORT_RIDERS_STATUS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:false,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,withTimezone:true,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Ganancias de los Riders',value:REPORT_RIDERS_EARNINGS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Ganancias de un rider',value:REPORT_RIDER_EARNINGS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:true,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Detalles de operaciones generales de Riders',value:REPORT_GENERAL_OPERATIONS_OF_RIDERS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Detalles de operaciones de un Rider',value:REPORT_GENERAL_OPERATIONS_OF_RIDER,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:true,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}}]},{type:"clients",reports:[{name:'Usuarios',value:REPORT_USERS,permissions:{type:BRANCH_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:false,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Correo electrónico de usuarios',value:REPORT_USERS_EMAIL,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:false,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:false,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Clientes con Saldo',value:REPORT_CLIENTS_WITH_BALANCE,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:false,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Movimientos de los clientes',value:REPORT_CLIENTS_MOVEMENTS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Reembolsos a clientes',value:REPORT_CLIENT_PAID_INVOICES,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Inicio de sesión de usuarios',value:REPORT_USER_LOGINS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:{count:31,time:'days'},withProviders:false,activateModal:false,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Últimos usuarios registrados',value:REPORT_RECENT_USERS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:{count:31,time:'days'},withProviders:false,activateModal:false,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Detalles de productos comprados por usuarios',value:REPORT_PRODUCTS_PURCHASED_BY_USERS,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:true,withBranches:false,maxDateRange:false,withProviders:false,activateModal:false,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Detalles de productos vendidos por un usuario en un comercio',value:REPORT_PRODUCTS_SOLD_BY_USER_ON_BRANCH,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:true,withClients:true,withBranches:false,maxDateRange:false,withProviders:false,activateModal:false,branchRequired:true,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Total de productos comprados por usuario en comercio',value:REPORT_TOTAL_PRODUCTS_PURCHASED_BY_USER_IN_BRANCH,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:true,withBranches:false,maxDateRange:false,withProviders:false,activateModal:false,branchRequired:true,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Total de productos comprados por usuario',value:REPORT_TOTAL_PRODUCTS_PURCHASED_BY_USER,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:true,withBranches:false,maxDateRange:false,withProviders:false,activateModal:false,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}},{name:'Órdenes por usuario',value:REPORT_ORDERS_BY_USER,permissions:{type:COMPANY_ACCESS,hierarchy:ACCOUNT_TYPES.lowAdmin,withDates:true,autoBranch:false,withClients:false,withBranches:false,maxDateRange:false,withProviders:false,activateModal:true,branchRequired:false,withCityFilter:false,withAllBranches:false,dependsOnBranch:false,withBranchGroups:false,branchAsParameter:false,appendingQueryString:false}}]}];var PERMISSIONS_LIST=[{name:"Asignar proveedores a la empresa",value:"can_assign_company_providers"},{name:"Gestionar textos de la plataforma",value:"can_manage_platform_texts"},{name:"Gestionar servicios",value:"can_manage_services"},{name:"Gestionar proveedores de servicios",value:"can_manage_service_suppliers"},{name:"Gestionar webhooks",value:"can_manage_webhooks"},{name:"Gestionar balance",value:"can_manage_balance"},{name:"Gestionar facturas generales",value:"can_manage_general_invoices"},{name:"Ver monedas de órdenes",value:"can_see_order_currencies"}];var ORDER_COUPON_REASONS=[{name:"Comida en mal estado",value:"Comida en mal estado"},{name:"Orden incompleta",value:"Orden incompleta"},{name:"Helados derretidos",value:"Helados derretidos"},{name:"Orden no entregada",value:"Orden no entregada"},{name:"Producto errado",value:"Producto errado"},{name:"Tiempo de espera excedido",value:"Tiempo de espera excedido"},{name:"Comida fría",value:"Comida fría"},{name:"Otros",value:"Otros"}];var WEBHOOKS_NAMES=[{name:"goods_import",value:"goods_import",description:"Envía peticiones para obtener y actualizar el Inventario de Productos"},{name:"order_status_report",value:"order_status_report",description:"Envía cambios de status de una orden"},{name:"payments_validation_zelle",value:"payments_validation_zelle",description:"Recibe validación automática de pagos por Zelle"},{name:"payments_validation_payco",value:"payments_validation_payco",description:"Deprecado"},{name:"payments_validation_sypago",value:"payments_validation_sypago",description:"Recibe validación automática de pagos de Bancamiga"},{name:"payments_report_stripe",value:"payments_report_stripe",description:"Recibe validación automática de pagos de Stripe"},{name:"payments_validation_reserve",value:"payments_validation_reserve",description:"Deprecado"},{name:"payments_validation_binance",value:"payments_validation_binance",description:"Recibe validación automática de pagos por Binance"},{name:"orders_handling",value:"orders_handling",description:"Recibe peticiones para cambiar status de una orden"},{name:"delivery_handling",value:"delivery_handling",description:" Recibe peticiones para cambiar status de un repartidor ApiPartner"},{name:"fleet_prices_ridery",value:"fleet_prices_ridery",description:"Deprecado"},{name:"fleet_prices_partner",value:"fleet_prices_partner",description:"Envía petición para obtener los precios de Envío de una Flota de ApiPartner"},{name:"order_creation_ridery",value:"order_creation_ridery",description:"Deprecado"},{name:"order_creation_partner",value:"order_creation_partner",description:"Envía petición para notificar que una orden fue creada"},{name:"shipment_creation_ridery",value:"shipment_creation_ridery",description:"Deprecado"},{name:"shipment_creation_partner",value:"shipment_creation_partner",description:"Envía petición para notificar que una orden requiere la asignación de un conductor de ApiPartner"},{name:"clients_register_ridery",value:"clients_register_ridery",description:"Deprecado"},{name:"clients_register_partner",value:"clients_register_partner",description:"Recibe peticiones para registrar a un comprador en la plataforma y otorga un token de acceso (ApiPartner)"},{name:"promos_sync",value:"promos_sync",description:"Envía petición para obtener y sincronizar las promociones de un comercio"},{name:"discounts_refresh",value:"discounts_refresh",description:"Envía petición para obtener y sincronizar los descuentos de un comercio"},{name:"sms_delivery",value:"sms_delivery",description:"Recibe petición que indica que un SMS fue entregado"}];var WEBHOOK_METHODS=[{value:"GET",name:"GET"},{value:"POST",name:"POST"},{value:"PATCH",name:"PATCH"},{value:"PUT",name:"PUT"},{value:"DELETE",name:"DELETE"}];var WEBHOOK_AUTH_TYPES=[{value:"none",name:"Ninguno"},{value:"basic",name:"Básico (Usuario y contraseña)"},{value:"token",name:"Token"},{value:"bearer",name:"Bearer (Token)"}];var IMPORT_CONFIG_GOOD_ITEMS=[{value:'name',name:'Nombre'},{value:'sku',name:'Sku'},{value:'price',name:'Precio'},{value:'details',name:'Detalles'},{value:'branch_id',name:'Id de sucursal'},{value:'eta',name:'ETA'},{value:'list_order',name:'Orden de lista'},{value:'sale_price',name:'Precio de venta'},{value:'unit',name:'Unidad'},{value:'image_url',name:'Url de la imagen'},{value:'vertical_image_url',name:'Url de la imagen vertical'},{value:'category',name:'Categoria'},{value:'quantity',name:'Cantidad'},{value:'notes_enabled',name:'Notas habilitadas'},{value:'weight_per_unit',name:'Peso por unidad'},{value:'branch_code',name:'Codigo de sucursal'}];var IMPORT_CONFIG_MAPPING_OPTIONS=[{value:'decimal',name:'Usa "," para separar miles y "." para separar decimales'},{value:'decimal_alt',name:'Usa "." para separar miles y "," para separar decimales'},{value:'to_prc',name:'Convertir % 0-100 a 0-1'},{value:'ucwords',name:'Tipo título'},{value:'to_e2',name:'Convertir a e2'},{value:'to_e6',name:'Convertir a e6'},{value:'pluck',name:'Pluck'}];var CSV_SETTINGS=[{name:"delimiter",value:"delimiter"},{name:"enclosure",value:"enclosure"},{name:"line_ending",value:"line_ending"},{name:"use_bom",value:"use_bom"},{name:"include_separator_line",value:"include_separator_line"},{name:"excel_compatibility",value:"excel_compatibility"},{name:"escape_character",value:"escape_character"},{name:"contiguous",value:"contiguous"},{name:"input_encoding",value:"input_encoding"},{name:"output_encoding",value:"output_encoding"}];var PAYMENT_IS_WAITING_CONFIRMATION=5;var PAYMENT_IS_CANCELLED_BY_CLIENT=10;var PAYMENT_IS_CANCELLED_AS_DUPLICATED=13;var PAYMENT_IS_CANCELLED_AS_INVALID=14;var PAYMENT_IS_ACCEPTED=15;var MASK_AGENT=0xfff0;var AGENT_MANUAL=0x0010;var AGENT_PAYPAL=0x0020;var AGENT_STRIPE=0x0040;var AGENT_INSTAPAGO=0x0080;var AGENT_ZELLE=0x0100;var AGENT_POST_PAYMENT=0x0200;

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONSOLE_LOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return URLsmall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return urlBuilder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return loginBuilder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return urlImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LONG_URL; });
/* unused harmony export ENV2 */
var CONSOLE_LOG= true?true:false;var URL="https://api-dev.freedond.app/api/v3/companies/";var URLsmall="https://api-dev.freedond.app/api/v3/";var urlBuilder="";var loginBuilder="";var urlImg="https://api-dev.freedond.app/storage/static/default/";// si no estoy en localhost uso el de la url, si estoy en local le adjunto el domain de la company en mi env local
//let domain = "";
//switch (process.env.REACT_APP_ENV){
//      case "PROD":
var domain=window.location.host;//.split(".").slice(1).join(".");
//              break;
//      default: // dev, local y staging... solo dame el subdominio
//              domain = window.location.host.split(".")[0];
//              break;
//}
var LONG_URL="https://api-dev.freedond.app/api/v3/companies/domain/"+domain;console.log(LONG_URL);// xq debo hacer esto ?  -.-
var ENV2="DEV";

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_audio_notification_mp3__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_audio_notification_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_audio_notification_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_audio_notification_loud_mp3__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_audio_notification_loud_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_audio_notification_loud_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var normalVolumeNotification=new Audio(__WEBPACK_IMPORTED_MODULE_2__assets_audio_notification_mp3___default.a);var highVolumeNotification=new Audio(__WEBPACK_IMPORTED_MODULE_3__assets_audio_notification_loud_mp3___default.a);var Noti=function Noti(_ref){var title=_ref.title,msg=_ref.msg,url=_ref.url;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'noti-title'},title),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'noti-msg'},msg),url?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:url,className:'btn btn-secondary'},'Ver'):null);};var Notification=function(){function Notification(){var _this=this;_classCallCheck(this,Notification);this.pushSoundHandler=function(sound,loop){if(sound==="off")return;if(sound==="on"){_this.selected_mp3=_this.mp3_notification;_this.selected_mp3.preload=true;}else if(sound==="loud"){_this.selected_mp3=_this.mp3_notification_loud;_this.selected_mp3.preload=true;}// make the sound loop
if(loop&&_this.selected_mp3)_this.selected_mp3.loop=true;// esto es para evitar el error de audio can not play file without user interaction
Promise.resolve(_this.selected_mp3&&_this.selected_mp3.play()).catch(function(err){return console.log("No se pudo reproducir el audio de notificación en tu navegador");});};this.show=function(_ref2){var title=_ref2.title,msg=_ref2.msg,type=_ref2.type,url=_ref2.url,sound=_ref2.sound,autoC=_ref2.autoC,_ref2$config=_ref2.config,config=_ref2$config===undefined?{}:_ref2$config;var comp=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Noti,{title:title,msg:msg,url:url,autoClose:autoC});switch(type){case'success':__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].success(comp,{onOpen:function onOpen(o){return _this.closePreloader();}});break;case'info':__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].info(comp,{onOpen:function onOpen(o){return _this.closePreloader();}});break;case'error':__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].error(comp,{onOpen:function onOpen(o){return _this.closePreloader();}});break;case'warning':__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].warn(comp,Object.assign({},config,{onOpen:function onOpen(o){return _this.closePreloader();}}));break;case'push':__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].info(comp);_this.pushSoundHandler(sound);break;case'sticky-push':__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].info(comp,Object.assign({},config,{onOpen:function onOpen(o){_this.pushSoundHandler(sound,true);},onClose:function onClose(o){// si el usuario tiene el sonido en off para una notificacion, selected_mp3 es undefined
if(_this.selected_mp3){_this.selected_mp3.loop=false;_this.selected_mp3.pause();}}}));break;default:__WEBPACK_IMPORTED_MODULE_0_react_toastify__["toast"].info(comp,{onOpen:function onOpen(o){return _this.closePreloader();}});break;}};this.mp3_notification=normalVolumeNotification;this.mp3_notification_loud=highVolumeNotification;this.selected_mp3;}// TODO: esta clase no se deberia usar para tocar nada en redux y menos para otra funcionalidad ajena...
// >.>  -_-  bueee u_u
_createClass(Notification,[{key:'closePreloader',value:function closePreloader(){__WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* default */].dispatch({type:"REMOVE_LOADING"});}}]);return Notification;}();/* harmony default export */ __webpack_exports__["a"] = (new Notification());

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return feeRulesType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return toPaginate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return nameValidateRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fixBinary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return regexValidateUserName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return regexGetNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return utcHours2LocalHours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return setMin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getMin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return setMax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getMax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return setStack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getStack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return orderStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return couponStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MaysPrimera; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return zerofilled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return imageLoaderHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return number_format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return validate_number; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return b64toBlob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return orderHasFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isPickUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return moneySymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return moneyFullName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return moneySymbolNative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return utcDateFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return utcConvertion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return utcToLocal; });
/* unused harmony export truncateString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return orderStatusPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return orderStatusPaymentMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return orderStatusProvider; });
/* unused harmony export orderStatusShopper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return dimenImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return providerOnline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return providerIsBussy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FloatPrecision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return orderBranchStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getBrightness; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return localizedErrorHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return tempoConverter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getPaymentMethodLogo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return formatPromoInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_data_currenciesList_en_json__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_data_currenciesList_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_data_currenciesList_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_data_currenciesList_es_json__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_data_currenciesList_es_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_data_currenciesList_es_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_locale_es__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_locale_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_general__ = __webpack_require__(6);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// ############################### store imports
var _store$getState=__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getState(),json_lang=_store$getState.json_lang,session=_store$getState.session;// ###############################
var statusCanceled={text:json_lang.order_status.canceled,style:'canceled',step:'canceled',sortingWeight:1500};var statusDelivered={text:json_lang.order_status.delivered,style:'delivered',step:'delivered',sortingWeight:1400};var statusInProgress={text:json_lang.order_status.in_progress,style:'ready',step:'ready',sortingWeight:1300};var statusArrived={text:json_lang.order_status.arrived,style:'ready',step:'ready',sortingWeight:1301//1300 a delivery
};var statusReady={text:json_lang.order_status.ready,style:'ready',step:'ready',sortingWeight:1302//1300 a pickUp
};var statusOnTheWay={text:json_lang.order_status.on_the_way,style:'on_the_way',step:'on_the_way',sortingWeight:1200/*
const statusInProgress2 = {
	text: json_lang.order_status.provider_arrived,
	style: 'on_the_way',
	step: 'on_the_way',
	sortingWeight: 1212
}*/};var statusInCommerce={text:json_lang.order_status.in_commerce,style:'on_the_way',step:'on_the_way',sortingWeight:3000};var statusDelayed={text:json_lang.order_status.delayed,style:'delayed',step:'delayed',sortingWeight:1211};var statusScheduled={text:json_lang.order_status.scheduled,style:'confirmed',step:'confirmed',sortingWeight:1001//1000
};var statusConfirmed={text:json_lang.order_status.confirmed,style:'confirmed',step:'confirmed',sortingWeight:1000};var statusIsConfirmed={text:json_lang.order_status.in_queue,style:'confirmed',step:'confirmed',sortingWeight:1000};var statusNotStarted={text:json_lang.order_status.not_started,style:'confirmed',step:'confirmed',sortingWeight:1000/*const statusProviderArrived = {
	text: json_lang.order_status.provider_arrived,
	style: 'confirmed',
	step: 'confirmed',
	sortingWeight: 1000
}*//////////////////////////////
};var statusDispatched2={//text: json_lang.order_status.dispatched,
text:json_lang.order_status.dispatched,style:'delivered',step:'delivered',sortingWeight:1010};var statusBeingPrepared={text:json_lang.order_status.preparation_started,style:'confirmed',step:'confirmed',sortingWeight:1001};var statusExpired={text:json_lang.order_status.expired,style:'canceled',step:'canceled',sortingWeight:1003};var statusPrepared={text:session.admin_type&&session.admin_type.name==="Despachador"?json_lang.order_status.is_ready:json_lang.order_status.prepared,style:session.admin_type&&session.admin_type.name==="Despachador"?'ready':'confirmed',step:'confirmed',sortingWeight:1002/*const statusDispatched = {
	text: session.admin_type && session.admin_type.name === "Despachador" ? json_lang.order_status.is_ready : json_lang.order_status.prepared,
	style: session.admin_type && session.admin_type.name === "Despachador" ? 'ready' : 'confirmed',
	step: 'confirmed',
	sortingWeight: 1002
}*/};var statusNotDelivered={text:json_lang.order_status.not_delivered,style:'canceled',step:'canceled',sortingWeight:940//////////////////////////////////////////
};var statusPaymentPending={text:json_lang.order_status.payment_pending,style:'payment_pending',step:'payment_pending',sortingWeight:940};var statusPaymentRefusedInvalid={text:json_lang.order_status.payment_refused_invalid,style:'payment_refused',step:'payment_refused',sortingWeight:940};var statusPaymentRefusedDuplicated={text:json_lang.order_status.payment_refused_duplicated,style:'payment_refused',step:'payment_refused',sortingWeight:940};var statusPaymentMixed=function statusPaymentMixed(paymentType,title){return{text:json_lang.order_status.payment_mixed,title:title,style:"mixed",step:'mixed '+paymentType.join(' '),sortingWeight:940};};var statusPaymentCash={text:json_lang.order_status.payment_cash,style:'payment_cash',step:'payment_cash',sortingWeight:940};var statusPaymentPos={text:json_lang.order_status.payment_pos,style:'payment_pos',step:'payment_pos',sortingWeight:940};var statusPaymentValidate={text:json_lang.order_status.payment_to_validate,style:'payment_to_validate',step:'payment_to_validate',sortingWeight:900};var statusAssigned={// text: json_lang.order_status.assigned, //TODO: por ahora se cambia a started
text:json_lang.order_status.started,style:'unconfirmed',step:'unconfirmed',sortingWeight:800};var statusUnAssigned={text:json_lang.order_status.unassigned,style:'canceled',step:'canceled',sortingWeight:800};var statusUnconfirmed={text:json_lang.order_status.unconfirmed,style:'unconfirmed',step:'unconfirmed',sortingWeight:800};var statusUnavailable={text:json_lang.order_status.unavailable,style:'unconfirmed',step:'unconfirmed',sortingWeight:700};var statusNotApply={text:json_lang.order_status.not_apply,style:'unconfirmed',step:'unconfirmed',sortingWeight:700};var orderHasFlag=function orderHasFlag(status,mapFilters){return mapFilters[status];};var feeRulesType=function feeRulesType(feeRules){if(feeRules.startsWith('good')){var splitedGoodType=feeRules.split('.');return splitedGoodType[1];}if(feeRules==='good'||feeRules==='quantity'){return null;}if(feeRules==='sum'){return'sum_quantity';}return feeRules;};/*const orderStatus = (status,isforDelivery) => {
	let forDelivery = isforDelivery;//a domicilio?
	let orderStatus = parseInt(status,10);
	let isService = ((status & MASK_SERVICE_TYPE) === TYPE_SERVICES);


	if((orderStatus & CANCELLED) === CANCELLED){
		return (statusCanceled)//1500
	}

	if((orderStatus & CANCELLED) === COMPLETED){
		return (statusDelivered)//1400
	}

	if ( isService && (orderStatus & FLAG_WORKING) === FLAG_WORKING) {
		return statusInProgress
	}

	if((orderStatus & TARGET_REACHED) === TARGET_REACHED){//1300
		if(isService){
			return (statusInProgress)
		}else{
			if (forDelivery) {
			    return (statusArrived)
			} else {
			    return (statusReady)
			}
		}
	}

	if((orderStatus & RUNNING) === RUNNING){//1200
		if (isService) {
		    if (forDelivery) {
		        return (statusOnTheWay)
		    } else {
		       //The service is ready to be executed. Waiting for Client
		        return (statusOnTheWay)
		    }
		} else {
		    if (forDelivery) {
		    	if((orderStatus & ASSIGNED) === ASSIGNED){
			    	return (statusInProgress2)
		    	}else{
		    		return (statusDelayed)//1211
		    	}
			}else{
				return (statusInProgress)
			}
		}
	}

	if ((orderStatus & ACCEPTED) === ACCEPTED) {//1000
        //The payment was approved
        if (isService) {
            if (forDelivery) {
                if ((orderStatus & PENDING) === 0) {
                    return (statusScheduled)
                } else {
                    return (statusConfirmed)
                }
            } else {
                if ((orderStatus & PENDING) === 0) {
                    return (statusScheduled)
                } else {
                    return (statusConfirmed)
                }
            }
        } else {
            if (forDelivery) {
                if ((orderStatus & PENDING) === 0) {
                    return (statusScheduled)
                } else {
                    return (statusConfirmed)
                }
            } else {
                return (statusConfirmed)
            }
        }
    }

    if ((orderStatus & UNCONFIRMED) === UNCONFIRMED) {//800
        return (statusUnconfirmed)
    }

	if ((orderStatus & WAITING_PAYMENT) === WAITING_PAYMENT) {//900
	    return (statusPaymentValidate)//940
	} else {
	    return (statusPaymentPending)
	}
}*/var orderStatus=function orderStatus(status,isforDelivery){var currentStatus=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var forDelivery=isforDelivery;//a domicilio?
var orderStatus=parseInt(status,10);var isService=(status&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["o" /* MASK_SERVICE_TYPE */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["A" /* TYPE_SERVICES */];currentStatus=currentStatus===0?orderStatus:parseInt(currentStatus,10);var adminType=__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getState().session&&__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getState().session.admin_type&&__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getState().session.admin_type.id;if(__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getState().userHigherAccess!==__WEBPACK_IMPORTED_MODULE_6__constants_general__["h" /* COMPANY_ACCESS */]&&adminType!==2){if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["h" /* COLLECTED */])!==0){return statusDispatched2;}else if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["s" /* PREPARED */])!==0){return statusPrepared;}else if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["f" /* BEING_PREPARED */])!==0){return statusBeingPrepared;}else if((orderStatus&(__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["r" /* POST_PAYMENT */]|__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["a" /* ACCEPTED */]))!==0&&(orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["i" /* COMPLETED */])===0){return statusIsConfirmed;}else if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["g" /* CANCELLED */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["g" /* CANCELLED */]){return statusCanceled;}else{return statusUnavailable;}}else{//console.log("orderStatus",adminType)
if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["g" /* CANCELLED */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["g" /* CANCELLED */]){if((currentStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["z" /* TARGET_REACHED */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["z" /* TARGET_REACHED */]){return statusNotDelivered;}if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["j" /* EXPIRED */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["j" /* EXPIRED */]){return statusExpired;}return statusCanceled;//1500
}if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["g" /* CANCELLED */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["i" /* COMPLETED */]){return statusDelivered;//1400
}if(isService&&(orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["k" /* FLAG_WORKING */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["k" /* FLAG_WORKING */]){return statusInProgress;}if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["z" /* TARGET_REACHED */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["z" /* TARGET_REACHED */]){//1300
if(isService){return statusInProgress;}else{if(forDelivery){return statusArrived;}else{return statusReady;}}}if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["h" /* COLLECTED */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["h" /* COLLECTED */]){return statusOnTheWay;}if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["w" /* READY_TO_COLLECT */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["w" /* READY_TO_COLLECT */]){return statusInCommerce;//statusOnTheWay //statusProviderArrived
}if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["x" /* RUNNING */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["x" /* RUNNING */]){//1200
if(isService){if(forDelivery){return statusOnTheWay;//statusInProgress2
}else{//The service is ready to be executed. Waiting for Client
return statusOnTheWay;//statusInProgress2
}}else{if(forDelivery){if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["e" /* ASSIGNED */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["e" /* ASSIGNED */]){return statusAssigned;//statusInProgress2
}else{return statusDelayed;//1211
}}else{return statusInProgress;}}}////////////////////////////////////////////
if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["s" /* PREPARED */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["s" /* PREPARED */]){return statusPrepared;}if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["f" /* BEING_PREPARED */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["f" /* BEING_PREPARED */]){return statusBeingPrepared;}///////////////////////////////////////////
if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["e" /* ASSIGNED */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["e" /* ASSIGNED */]&&orderStatus!==currentStatus){return statusAssigned;}if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["B" /* UNCONFIRMED */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["B" /* UNCONFIRMED */]){//800
return statusUnconfirmed;}else{return statusIsConfirmed;}}};var orderBranchStatus=function orderBranchStatus(status,isforDelivery){var currentStatus=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var orderStatus=parseInt(status,10);currentStatus=currentStatus===0?orderStatus:parseInt(currentStatus,10);if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["h" /* COLLECTED */])!==0){return statusDispatched2;}else if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["s" /* PREPARED */])!==0){return statusPrepared;}else if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["f" /* BEING_PREPARED */])!==0){return statusBeingPrepared;}else if((orderStatus&(__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["r" /* POST_PAYMENT */]|__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["a" /* ACCEPTED */]))!==0&&(orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["i" /* COMPLETED */])===0){// Esta entrando
return statusNotStarted;}else if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["g" /* CANCELLED */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["g" /* CANCELLED */]){return statusCanceled;}else{return statusNotStarted;//(statusUnavailable)
}};var orderStatusPayment=function orderStatusPayment(status,isforDelivery,orderDetails){var forDelivery=isforDelivery;//a domicilio?
var orderStatus=parseInt(status,10);var isService=(status&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["o" /* MASK_SERVICE_TYPE */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["A" /* TYPE_SERVICES */];if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["a" /* ACCEPTED */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["a" /* ACCEPTED */]){//1000
//The payment was approved
if(isService){if(forDelivery){if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["q" /* PENDING */])===0){return statusScheduled;}else{return statusConfirmed;}}else{if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["q" /* PENDING */])===0){return statusScheduled;}else{return statusConfirmed;}}}else{if(forDelivery){if((orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["q" /* PENDING */])===0){return statusScheduled;}else{return statusConfirmed;}}else{return statusConfirmed;}}}if((orderStatus&(__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["G" /* WAITING_PAYMENT */]|__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["r" /* POST_PAYMENT */]|__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["a" /* ACCEPTED */]))===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["G" /* WAITING_PAYMENT */]){//900
return statusPaymentValidate;//940
}// else if((orderStatus & POST_PAYMENT) === POST_PAYMENT){
// 	if(orderDetails
// 		&& orderDetails.selected_payment_method
// 		&& orderDetails.selected_payment_method.id){
// 		return (statusPaymentPos)
// 	}
// 	 return (statusPaymentCash)
// }
else{return statusPaymentPending;}};var orderStatusPaymentMethod=function orderStatusPaymentMethod(method,selectedPayment,orderStatus,total){if(method&&method.length>0){var filteredSuccessful=method.filter(function(payment){return payment.status==="successful";});if(filteredSuccessful.length>1){var paymentType=filteredSuccessful.map(function(payment){return payment.related_payment_name==="bancamiga_ci"?"bancamiga":payment.type;});var paymentTitle=filteredSuccessful.map(function(payment){var text=MaysPrimera(payment.related_payment_name);if(payment.related_payment_name==="bancamiga_ci"){text="Bancamiga CI";}if(payment.related_payment_name==="balance"){text="ZupperCredits";}return text;});return statusPaymentMixed(paymentType,paymentTitle.join(", "));}else if(filteredSuccessful.length===1&&orderStatus&&(orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["r" /* POST_PAYMENT */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["r" /* POST_PAYMENT */]&&selectedPayment){var isOrderFullyPaid=filteredSuccessful[0].total_e2>=total;if(filteredSuccessful[0].type==="pos"||filteredSuccessful[0].type==="payment_pos"){return statusPaymentPos;}else if(filteredSuccessful[0].type==="efectivo"||filteredSuccessful[0].type==="payment_cash"){return statusPaymentCash;}var text=MaysPrimera(filteredSuccessful[0].related_payment_name);if(filteredSuccessful[0].related_payment_name==="bancamiga_ci"){text="Bancamiga CI";}if(filteredSuccessful[0].related_payment_name==="balance"){text="ZupperCredits";}if(isOrderFullyPaid){return{text:text,style:filteredSuccessful[0].related_payment_name==="bancamiga_ci"?"bancamiga":filteredSuccessful[0].type};}if(selectedPayment.id){var posPaymentType=[statusPaymentPos.style,filteredSuccessful[0].related_payment_name==="bancamiga_ci"?"bancamiga":filteredSuccessful[0].type];return statusPaymentMixed(posPaymentType,statusPaymentPos.text+', '+text);}else{var cashPaymentType=[statusPaymentCash.style,filteredSuccessful[0].related_payment_name==="bancamiga_ci"?"bancamiga":filteredSuccessful[0].type];return statusPaymentMixed(cashPaymentType,statusPaymentCash.text+', '+text);}}else{var lastPayment=method[0];switch(lastPayment.status){case"successful":var _text=MaysPrimera(lastPayment.related_payment_name);var style=lastPayment.type;if(lastPayment.related_payment_name==="balance"){_text="ZupperCredits";}if(lastPayment.related_payment_name==="bancamiga_ci"){_text="Bancamiga CI";style="bancamiga";}return{text:_text,style:style};case"pending_confirmation":return statusPaymentPending;case"refused_invalid":return statusPaymentRefusedInvalid;case"refused_duplicated":return statusPaymentRefusedDuplicated;default:return statusPaymentPending;}}}else if(orderStatus&&(orderStatus&__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["r" /* POST_PAYMENT */])===__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["r" /* POST_PAYMENT */]&&selectedPayment){if(selectedPayment.id){return statusPaymentPos;}else{return statusPaymentCash;}}else{return statusPaymentPending;}};var orderStatusProvider=function orderStatusProvider(status){if(status){switch(status){case'CANCELED':return statusCanceled;case'DELIVERED':return statusDelivered;case'ARRIVED':return statusArrived;case'DELAYED':return statusDelayed;case'ON_THE_WAY':return statusOnTheWay;case'NOT_ASSIGNED':return statusUnAssigned;case'COLLECTING':return statusInCommerce;case'STARTED':return statusInProgress;case'ASSIGNED':return statusAssigned;// TODO! STATUS DE SHOPPER, DESPUES BORRAR
case'PREPARED':return statusPrepared;case'BEING_PREPARED':return statusBeingPrepared;case'WAITING_PAYMENT':return statusPaymentPending;// TODO! FIN DE STATUS SHOPPER
default:return statusNotApply;}}else{return statusUnavailable;}};var orderStatusShopper=function orderStatusShopper(status){if(status){switch(status){case'CANCELED':return statusCanceled;case'DELIVERED':return statusDelivered;case'PREPARED':return statusPrepared;case'BEING_PREPARED':return statusBeingPrepared;case'ON_THE_WAY':return statusOnTheWay;case'NOT_ASSIGNED':return statusUnAssigned;case'WAITING_PAYMENT':return statusPaymentPending;case'ASSIGNED':return statusAssigned;default:return statusNotApply;}}else{return statusUnavailable;}};var MaysPrimera=function MaysPrimera(string){return string.charAt(0).toUpperCase()+string.slice(1);};/*const zerofilled=(num, length, character)=>{
	var pad_char = typeof character !== 'undefined' ? character : '0';
	var pad = new Array(1 + length).join(pad_char);
	return (pad + num).slice(-pad.length);
}*/var zerofilled=function zerofilled(number,width){var numberOutput=Math.abs(number);/* Valor absoluto del número */var length=number.toString().length;/* Largo del número */var zero="0";/* String de cero */if(width<=length){if(number<0){return"-"+numberOutput.toString();}else{return numberOutput.toString();}}else{if(number<0){return"-"+zero.repeat(width-length)+numberOutput.toString();}else{return zero.repeat(width-length)+numberOutput.toString();}}};var number_format=function number_format(number,decimals,dec_point,thousands_sep){var defaultDecimals=__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getState().currencies.local.decimals_count||2;var n=number,c=isNaN(decimals=Math.abs(decimals))?defaultDecimals:decimals;var d=dec_point===undefined?/*","*/".":dec_point;var t=thousands_sep===undefined?".":thousands_sep,s=n<0?"-":"";var i=parseInt(n=Math.abs(+n||0).toFixed(c),10)+"";var j=void 0;j=(j=i.length)>3?j%3:0;return s+(j?i.substr(0,j)+t:"")+i.substr(j).replace(/(\d{3})(?=\d)/g,"$1"+t)+(c?d+Math.abs(n-i).toFixed(c).slice(2):"");};var validate_number=function validate_number(evt){var nav4=window.Event?true:false;var key=nav4?evt.which:evt.keyCode;return key<=13||key===127||key===46||key>=48&&key<=57||key===180||key===190||key===44?true:evt.preventDefault();};var b64toBlob=function b64toBlob(b64Data,contentType,sliceSize){contentType=contentType||'';sliceSize=sliceSize||512;var byteCharacters=atob(b64Data);var byteArrays=[];for(var offset=0;offset<byteCharacters.length;offset+=sliceSize){var slice=byteCharacters.slice(offset,offset+sliceSize);var byteNumbers=new Array(slice.length);for(var i=0;i<slice.length;i++){byteNumbers[i]=slice.charCodeAt(i);}var byteArray=new Uint8Array(byteNumbers);byteArrays.push(byteArray);}var blob=new Blob(byteArrays,{type:contentType});return blob;};var fixBinary=function fixBinary(bin){var length=bin.length;var buf=new ArrayBuffer(length);var arr=new Uint8Array(buf);for(var i=0;i<length;i++){arr[i]=bin.charCodeAt(i);}return buf;};var isPickUp=function isPickUp(clientLatitude,clientLongitude,clientAddress){return parseInt(clientLatitude,10)===0&&parseInt(clientLongitude,10)===0&&clientAddress===null;};var moneySymbol=function moneySymbol(iso){/*if(iso){
		var symbolKey = currencyListEn.findIndex(( item ) => item.value === iso )
		return currencyListEn[symbolKey].symbol;
	}*/return iso;};var moneyFullName=function moneyFullName(iso){if(iso){//var currencies= localStorage.getItem('lang_code') === 'es' ? currencyListEs : currencyListEn;
//var symbolKey = currencies.findIndex((item) => item.value === iso);
//console.log("iso",iso,symbolKey)
return iso;//`${currencies[symbolKey].name} (${currencies[symbolKey].symbol})`;
}};var moneySymbolNative=function moneySymbolNative(iso){if(iso){var symbolKey=__WEBPACK_IMPORTED_MODULE_1__assets_data_currenciesList_en_json___default.a.findIndex(function(item){return item.value===iso;});return __WEBPACK_IMPORTED_MODULE_1__assets_data_currenciesList_en_json___default.a[symbolKey].symbol_native;}return iso;};var utcDateFormat=function utcDateFormat(date){var format=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'DD-MM-YYYY';if(__WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale()!==localStorage.getItem('lang_code')){__WEBPACK_IMPORTED_MODULE_4_moment___default.a.updateLocale(localStorage.getItem('lang_code'));}var utcDate=__WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(date).utcOffset(__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getState().company.time_zone_offset||__WEBPACK_IMPORTED_MODULE_6__constants_general__["k" /* DEFAULT_TIME_ZONE */]);return format==='fromNow'?utcDate.format("DD MMM YYYY hh:mm a"):utcDate.format(format);};var utcConvertion=function utcConvertion(date){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"start";var format=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"YYYY-MM-DD HH:mm:ss";var companyTimeZone=__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getState().company.time_zone_offset||__WEBPACK_IMPORTED_MODULE_6__constants_general__["k" /* DEFAULT_TIME_ZONE */];var formatedDate=__WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(date).utcOffset(companyTimeZone);if(type==="start"){return formatedDate.startOf('day').utc().format(format);}else if(type==="end"){return formatedDate.endOf('day').utc().format(format);}else if(type==="custom"){return formatedDate.utc().format(format);}};var utcToLocal=function utcToLocal(utcTimeString){var format=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"HH:mm";var companyTimeZone=__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getState().company.time_zone_offset||__WEBPACK_IMPORTED_MODULE_6__constants_general__["k" /* DEFAULT_TIME_ZONE */];return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(utcTimeString,"HH:mm").utcOffset(companyTimeZone).format(format);};var truncateString=function truncateString(string){var maxLength=arguments.length>1&&arguments[1]!==undefined?arguments[1]:20;if(string.length>maxLength){return string.slice(0,maxLength)+'...';}return string;};var utcHours2LocalHours=function utcHours2LocalHours(date){var backwards=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if(__WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale()!==localStorage.getItem('lang_code')){__WEBPACK_IMPORTED_MODULE_4_moment___default.a.updateLocale(localStorage.getItem('lang_code'));}var time=__WEBPACK_IMPORTED_MODULE_4_moment___default()(date,"HH:mm");var hours=__WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(time).utcOffset(__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getState().company.time_zone_offset||__WEBPACK_IMPORTED_MODULE_6__constants_general__["k" /* DEFAULT_TIME_ZONE */]);return backwards?hours.utc().format("HH:mm"):hours.utc(hours).local().format("HH:mm");};var dimenImg=function dimenImg(url,dimension,ext){return url.replace(/\.([^\.]*)$/,'-'+dimension+'.'+(ext?ext:'$1'));};var providerOnline=function providerOnline(status){return(parseInt(status,10)&48)===16;};var providerIsBussy=function providerIsBussy(status){return(parseInt(status,10)&3)===2;};var FloatPrecision=function FloatPrecision(x){return Number.parseFloat(x).toPrecision(4);};var imageLoaderHandler=function imageLoaderHandler(ev,image,size,format,defaultImg){/*
		Al dar error la imagen, yo necesito comprar tiempo para que el cdn o el mal internet del usr me traigan el archivo...
		Entonces le agrego al img un atributo RETRIES y cada 20 seg intento buscar esa imagen del cdn/recortada mientras el api termina de procesarla
	*/var target=ev.target;// va iterando del 0 al 2
if(target.dataset.retries<"3"){// primero le doy la imagen por defecto para que le muestre algo al usr mientras
target.src=image;var src=target.src;setTimeout(function(){// incremento el numero de intentos q lleva
target.dataset.retries=parseInt(target.dataset.retries,10)+1;// luego de estos segundos le pongo la imagen recortada para ver si da error
// y le agrego a la url "?1"  ese signo de interrogacion y lo q venga luego es para saltar la cache del navegador
target.src=dimenImg(src,size,format)+"?"+target.dataset.retries;},20000);}else{// si esta en produccion y llego a los 3 intentos fallido quitale el cdn es el principal culpable de q falle, cuando el usr llegue otro dia, ya seguro existira la imagen
if(false){target.src=target.src.replace(".cdn","");target.dataset.retries=parseInt(target.dataset.retries,10)+1;}// si la imagen existe pero ha dado muchos errores muestra la pesada no importa
else if(// si falla en el if anterior, pasa la siguiente condicion
"DEV"==="PRODUCTION"&&target.dataset.retries==="4"||// si no estas en produccion pasa esta
target.dataset.retries==="3"){target.dataset.retries=parseInt(target.dataset.retries,10)+1;target.src=image;}// si la cuestion es q la imagen no existe/internet o XYZ ponle la imagen por defecto
else{target.src=defaultImg;}}};var couponStatus=function couponStatus(status){var couponStatus={sortingWeight:1,style:"canceled",//"delivered",
text:json_lang.common.finished};if(status==="running"){couponStatus={sortingWeight:2,style:"delivered",//"ready",
text:json_lang.common.running};}if(status==="pending"){couponStatus={sortingWeight:3,style:"ready",text:json_lang.common.pending};}if(status==="generating"){couponStatus={sortingWeight:5,style:"ready",text:json_lang.common.generating};}if(status==="ready"){couponStatus={sortingWeight:6,style:"delivered",text:json_lang.common.ready};}return couponStatus;};var setMin=function setMin(min,option){var v=min<<20;return option^=(option^v)&0x00f00000;//modifica el options real
};var getMin=function getMin(option){return(option&0x00f00000)>>20;//extrae del options real
};var setMax=function setMax(max,option){var v=max<<16;return option^=(option^v)&0x000f0000;//modifica el options real
};var getMax=function getMax(option){return(option&0x000f0000)>>16;//extrae del options real
};var setStack=function setStack(stack,option){var v=stack<<24;return option^=(option^v)&0x00f000000;//modifica el options real
};var getStack=function getStack(option){return(option&0x00f000000)>>24;//extrae del options real
};var regexGetNumber=function regexGetNumber(text){var regexp=/[0-9]+/g;var str=text;var numbers=[].concat(_toConsumableArray(str.matchAll(regexp))).map(function(num){return parseInt(num,10);});return numbers;};var regexValidateUserName=function regexValidateUserName(text){var str=text;var regexp=/[.-]+/g;var validate=regexp.test(str);return validate;};var nameValidateRegex=function nameValidateRegex(txt){var validate=new RegExp(/^([\p{L} ,']*)$/,'u').test(txt);return validate;};var toPaginate=function toPaginate(data){var limit=arguments.length>1&&arguments[1]!==undefined?arguments[1]:12;var last_page=arguments.length>2&&arguments[2]!==undefined?arguments[2]:223;return{"current_page":1,"data":data,"first_page_url":"","from":1,"last_page":last_page,"last_page_url":"","links":[],"next_page_url":"","path":"","per_page":limit,"prev_page_url":null,"to":limit,"total":data.length};};var localizedErrorHandler=function localizedErrorHandler(error){var errorBody={code:error.error_code,message:error.description,details:error.details||null};if(error.localized_error&&error.localized_error.spanish){errorBody.message=error.localized_error.spanish.message;}return errorBody;};var getBrightness=function getBrightness(color){color=color.replace('#','');var r=parseInt(color.substring(0,2),16);var g=parseInt(color.substring(2,4),16);var b=parseInt(color.substring(4,6),16);return r*0.299+g*0.587+b*0.114;};var clone=function clone(object){if(object===null){return null;}if(Array.isArray(object)){return object.map(function(item){return clone(item);});}if((typeof object==='undefined'?'undefined':_typeof(object))==='object'){var out={};Object.keys(object).forEach(function(key){out[key]=clone(object[key]);});return out;}return object;};var getPaymentMethodLogo=function getPaymentMethodLogo(paymentMethod){switch(paymentMethod){case"balance":return"https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/zupper-credits-48x48.svg";case"banco_de_venezuela":case"Transferencia bancaria":case"Transferencia Bancaria":case"transferencia-bancaria":return"https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/transferencia-48x48.svg";case"pago-movil":case"Pago Móvil":case"Pago móvil Automatizado":return"https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/pago-movil-48x48.svg";case"binance":return"https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/binance-48x48.svg";case"paypal":case"Paypal":return"https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/paypal-48x48.svg";case"stripe":return"https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/tdc-internacional-48x48.svg";case"pos":case"POS":case"payment_pos":case"Zupper POS":case"post-payment":return"https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/pos-icon-48x48.svg";case"bancamiga_ci":case"bancamiga-ci":case"bancamiga":return"https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/debito-inmediato-48x48.svg";case"zelle":return"https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/zelle-48x48.svg";default:return"https://cdn.dondemand.io/Zupper/marketplace-web/payment-methods/efectivo-48x48.svg";}};var tempoConverter=function tempoConverter(minutes){if(minutes===0)return"pocos segundos";if(minutes<60)return minutes+' minuto'+(minutes!==1?'s':'');var hours=Math.floor(minutes/60);var remainingMinutes=Math.floor(minutes%60);if(hours<24)return remainingMinutes>0?hours+' hora'+(hours!==1?'s':'')+' y '+remainingMinutes+' minuto'+(remainingMinutes!==1?'s':''):hours+' hora'+(hours!==1?'s':'');var days=Math.floor(hours/24);var remainingHours=Math.floor(hours%24);if(days<30)return days+' dia'+(days!==1?'s':'')+' y '+remainingHours+' hora'+(remainingHours!==1?'s':'');var months=Math.floor(days/30);if(months<12)return months+' mes'+(months!==1?'es':'');var years=Math.floor(months/12);var remainingMonths=Math.floor(months%12);return years+' a\xF1o'+(years!==1?'s':'')+' y '+remainingMonths+' mes'+(remainingMonths!==1?'es':'');};var formatPromoInfo=function formatPromoInfo(promo_info){if(!promo_info)return"";var isCustom=promo_info.startsWith("!");var isPercentStar=promo_info.startsWith("%");var isPercentEnd=promo_info.endsWith("%");var isPercent=isPercentStar||isPercentEnd;var isRelative=promo_info.startsWith("<");if(isCustom)return promo_info.substring(1);if(isRelative)return'Hasta '+promo_info.substring(1)+' off';if(isPercent)return isPercentStar?promo_info.substring(1)+'% off':promo_info+' off';return'-'+promo_info+'$';};

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_general__ = __webpack_require__(6);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}//import logger from 'redux-logger';
var userData=localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')):{};var branches=JSON.parse(localStorage.getItem('userHigherAccess'))>__WEBPACK_IMPORTED_MODULE_3__constants_general__["e" /* BRANCH_ACCESS */]?[]:userData.accesses&&userData.accesses.filter(function(e){return e.access_type==="branch";});var initialState={newBilling:{type:"company",key:"",amount_e2:"",description:"",move:"add"},serviceSuppliers:[],parcialGivechange:{amount_e2:'',description:'',adjust_client_balance:false,add:"add"},companyPayment:{},featuredGoods:{},featuredGood:{},giveChangeHistory:[],etaConfig:{name:"",fixed_label:"",manufacturing_delay:0,manufacturing_count:0,manufacturing_cooldown:0,delivery_delay:0,mode:'',hour_from:'',hour_to:'',weekDays:[]},giveChange:{amount_e2:'',description:''},session:userData,userHigherAccess:localStorage.getItem('userHigherAccess')?JSON.parse(localStorage.getItem('userHigherAccess')):__WEBPACK_IMPORTED_MODULE_3__constants_general__["e" /* BRANCH_ACCESS */],appMovilStatus:{},promotedBanner:{},aceptedpayment:{},adminWithoutAccess:false,goodType:"",providersVehicle:[],branchGroupsVehicle:[],vehicles:[],priceListId:{},vehicle:{name:""},isUploadingExcel:false,confirmationOrder:{type:"gateway",name:"",ref:""},coupon:{name:"",type:"",promo_code:"",human_price_prc:"",human_price_e2:"",applies_to:"",total_count:"",unlimited:false,config:{limit:"",human_company_assumption_prc:"0",only_deliveries:false,only_first_purchase:false,usable_in_promos:false}},companySubCategory:{name:"",in_order:null},initialBranch:{},new_service_skill_groups:'',service_skill_groups:[],allClients:[],showNotification:true,notificationsPaginated:[],hasDeletedSuccessfully:false,client:{},clients:[],paginated_clients:{current_page:1,data:[],per_page:10,total:1},orderBranchRatings:[],cancelationReason:{},cancelationReasons:[],unseenNotifications:false,// user is aware by default
newCancelationReason:'',category:{type:1},pendingActions:[],dolarToday:{},paymentResponse:{},paymentReference:{approved:[],pending:[]},errorOnPaymentReference:null,branchGeoFence:{name:"",type:'circle',enabled:true,data:{radius:""}},branchGeoFences:[],ordersCounter:{"assigned":0,"unassigned":0},branchGroupData:{name:""},allCategories:[],app:{},autocomplete_results:[],order_client_address_query:"",branch:localStorage.getItem('activeBranch')?JSON.parse(localStorage.getItem('activeBranch')):{},branchHolidays:[],errorBranchHolidays:false,newBranch:{name:"",description:"",phone:"",time_zone_offset:""},providerBranchAccesses:[],branches:branches||[],workSchedulesForOrdering:[],branchGroup:localStorage.getItem('activeBranchGroup')?JSON.parse(localStorage.getItem('activeBranchGroup')):{},branchGroups:[],branchGroupsByIds:[],branchCategory:{},branchCategories:[],company:{id:''},editable_company_settings:{},companies:[],currencies:{local:{},international:{},accepted:[]},admin:{id:'',name:'',display_name:'',phonePrefix:'58',phone:'',email:''},admins:[],companySections:[],companySection:{type:"custom",payload:{type:"ids",ids:[]}},companyCities:[],branchAdmins:[],branchGroupsAdmins:[],companyAdmins:[],provider:{id:'',name:'',display_name:'',phonePrefix:'58',phone:'',email:''},providerSettings:{},providers:[],autocompleteProviders:[],invalidConfig:{},order:{client_id:"",client_latitude_e6:0,client_longitude_e6:0,scheduled_at:"",notes:"",goods:[],providers_id:"",propertiesGood:[],ordered_goods:[]},cartOrder:{},orderDetails:{client_id:"",client_latitude_e6:0,client_longitude_e6:0,scheduled_at:"",notes:"",goods:[],providers_id:"",propertiesGood:[],taxes:[]},orderHistory:{history:[],original_data:null},orderHistoryError:{error:null},hasToUpdateOrderView:false,orders:[],mapOrders:[],ordersBranchHeatmap:[],cancelOrderError:false,paginationOrders:{},filteredMapOrders:[],archived_orders:[],providerOrders:[],todayOrders:[],cart:{billing:{},branch:{},branch_id:null,client_id:null,created_at:null,currency_iso:null,delivery:{},id:null,items:[],payment_info:{},resume:{},status:null,updated_at:null},errorOnOrderPayment:null,couponCode:{error:null},errorOnRecreateOrder:null,payment_form:[],allPayments:[],account:{},accounts:{},goods:[],goodsList:[],good:{unit_config:null,unit_config_visible:false},isSidebarActive:false,isAsidemenuActive:false,dashboardStatistics:{},dashboardDaysStatistics:{},dashboardDaysStatisticsUpdate:{},dashboardMonthsStatistics:{},dashboardMonthsData:{},goodRatings:[],orderRatings:[],categoriesGood:[],branchPriceList:[],sendNotification:{title:"",body:"",target_type:""},associations:{current_page:1,data:[],per_page:100,total:1,limit:100},branchCurrency:{},newOrderTableRowAdded:"",// id of the table row when a push notification of order type comes in
properties:[],property:{disabled:false},propertiesGood:[],branchProperties:[],branchProperty:{disabled:true},branchPropertiesGood:[],dropzoneActive:false,dropzoneFiles:[],active_form:"",user:{},userIsOnline:JSON.parse(localStorage.getItem('userIsOnline'))===true?true:false,users:[],categories:[],apps:[],templates:[],layouts:[],sections:[],errors:{message:'',errors:{},preloader:''},table:{ready:false,dataTransactions:[],limitTransactions:2,pageTransactions:1,ordTransactions:'desc',sortTransactions:'id',searchTransactions:'',mode:'all'},preloader:false,paymentMethods:{},paymentMethodsForms:[],notificationsCounter:0,notificationPagination:{},notifications:[],// localStorage.getItem('notifications') ? JSON.parse(localStorage.getItem('notifications')) : [], /* for sidebar firebase push notifications */
notification:{/* title: "", */message:"",level:0/* Available Levels:
			0 = DONT USE THIS ONE IS JUST FOR INITIALIZATION,
			1 = info,
			2 = success,
			3 = warning,
			4 = error
		*/},form:{answers:[]},productosConProveedoresAsignables:[],forms:{},reset_inputs:false,available_languages:{"es":{name:"Español",flag_code:"ve"},"en":{name:"English",flag_code:"us"}},/* xHACER: read this from disk json files?? */company_styles_json:{},terms_of_service:'',workSchedules:[],workSchedule:{},mapFilters:{// general
goods:true,services:false,// providers
availableProviders:true,unavailableProviders:true,offlineProviders:true,// orders
unassigned:true,assigned:true,date:{todayOrders:false,thisWeekOrders:false,thisMonthOrders:true},// orders status
canceled:false,delivered:false,ready:true,// in progress
on_the_way:true,delayed:true,confirmed:true,payment_pending:true,payment_to_validate:true//unconfirmed
},lang_code:localStorage.getItem('lang_code')?localStorage.getItem('lang_code'):localStorage.setItem('lang_code',"es"),properties_types:[{value:256,name:localStorage.getItem('lang_code')==='en'?"List":"Lista"},{value:512,name:localStorage.getItem('lang_code')==='en'?"Numeric":"Numérico"},{value:1024,name:localStorage.getItem('lang_code')==='en'?"Text":"Texto"}],json_lang:__webpack_require__(118)("./"+localStorage.getItem('lang_code')+'.json'),customEmailFooter:'',customClientBg:'',deliveryFee:'',loginError:false,chats:{current_page:1,data:[],per_page:100,total:1,limit:100},chatMembers:{current_page:1,data:[],per_page:100,total:1,limit:100},activeInbox:false,newChatMember:false,providerChats:[],shopperChats:[],deliveryChats:[],chatUser:{},inovicesLot:[],fleetPaymentMethods:{config:{payment_methods:[]}},localized_messages:[],webhooks:{current_page:1,data:[],per_page:100,total:1,limit:100},webhook:{},webhooksOptions:{}};var reducer=function reducer(){var _Object$assign2;var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){/*
		|---------------------------------
		|         ERRORS & AUTH          |
		|---------------------------------
		*/case"ERROR":return Object.assign({},state,{preloader:false});case"COMPANY_INITIALIZATION":return Object.assign({},state,{company:action.company,initCompany:action.initCompany,currencies:action.currencies,lang_code:action.lang_code,company_styles_json:action.company_styles_json,json_lang:__webpack_require__(118)("./"+action.lang_code+".json"),customEmailFooter:action.customEmailFooter,customClientBg:action.customClientBg,deliveryFee:action.deliveryFee,preloader:false});case"FETCH_COMPANY_SETTINGS":return Object.assign({},state,{editable_company_settings:action.editable_company_settings,preloader:false});case"COMPANY_EDITING":return Object.assign({},state,{company:action.company,preloader:false});case"RESPONSE":return Object.assign({},state,{response:action.response,preloader:false});case"REMOVE_LOADING":return Object.assign({},state,{preloader:false});case"LOGIN":return Object.assign({},state,{session:action.user,branch:action.branch||{},branches:action.branches||[],userHigherAccess:action.userHigherAccess,branchGroups:action.branchGroups||[],preloader:false,loginError:false});case"LOGIN_ERROR":return Object.assign({},state,{adminWithoutAccess:action.adminWithoutAccess,loginError:true,preloader:false});case"LOGOUT":return Object.assign({},state,{session:action.user});case"STATUS_ONLINE":return Object.assign({},state,{userIsOnline:action.userIsOnline});case"DASHBOARD":return Object.assign({},state,{dashboardStatistics:action.dashboardStatistics});case"DASHBOARD_DAYS":return Object.assign({},state,{dashboardDaysStatistics:action.dashboardDaysStatistics});case"DASHBOARD_MONTHS":return Object.assign({},state,{dashboardMonthsStatistics:action.dashboardMonthsStatistics});case"DASHBOARD_MONTHS_DATA":return Object.assign({},state,{dashboardMonthsData:action.dashboardMonthsData});case"DASHBOARD_DAYS_UPDATE":return Object.assign({},state,{orderPast:action.orderPast});case"REGISTER":return Object.assign({},state,{user:action.user});case"FETCH_ACCOUNT":return Object.assign({},state,{account:action.account,preloader:false});case"FETCH_ACCOUNTS":return Object.assign({},state,{accounts:action.accounts,preloader:false});case"USER_ONLINE_STATUS":return Object.assign({},state,{userIsOnline:action.userIsOnline,timerId:action.timerId});/*
		|---------------------------------
		|        BRANCH                  |
		|---------------------------------
		*/case"FETCH_BRANCH":return Object.assign({},state,{branch:Object.assign({},action.branch),initialBranch:Object.assign({},action.initialBranch),preloader:false});case"FETCH_BRANCH_RATINGS":return Object.assign({},state,{branchRatings:Object.assign({},action.branchRatings),preloader:false});case"FETCH_ORDER_BRANCH_RATINGS":return Object.assign({},state,{orderBranchRatings:[].concat(_toConsumableArray(action.orderBranchRatings)),preloader:false});case"FETCH_EDITABLEBRANCH":return Object.assign({},state,{editableBranch:action.editableBranch,preloader:false});case"UPDATE_BRANCH":return Object.assign({},state,{branch:Object.assign({},action.branch),initialBranch:Object.assign({},action.initialBranch),editable_company_settings:Object.assign({},action.editable_company_settings),preloader:false});case"UPDATE_NEWBRANCH":return Object.assign({},state,{newBranch:Object.assign({},action.newBranch),initialBranch:Object.assign({},action.initialBranch),editable_company_settings:Object.assign({},action.editable_company_settings),preloader:false});case"FETCH_BRANCH_ADMINS":return Object.assign({},state,{branchAdmins:action.branchAdmins,preloader:false});case"FETCH_BRANCHES":return Object.assign({},state,{branches:action.branches,preloader:false});case"FETCH_PROVIDER_BRANCHES_ACCESSES":return Object.assign({},state,{providerBranchAccesses:action.providerBranchAccesses,preloader:false});case"GET_WORK_SCHEDULES_FOR_ORDERING":return Object.assign({},state,{workSchedulesForOrdering:action.workSchedulesForOrdering,preloader:false});case"BRANCH_HOLIDAYS":return Object.assign({},state,{branchHolidays:action.branchHolidays,errorBranchHolidays:false,preloader:false});case"ERROR_BRANCH_HOLIDAYS":return Object.assign({},state,{errorBranchHolidays:true,preloader:false/*
		|---------------------------------
		|        BRANCH GROUPS		      |
		|---------------------------------
		*/});case"FETCH_BRANCH_GROUPS_ADMINS":return Object.assign({},state,{branchGroupsAdmins:action.branchGroupsAdmins,preloader:false});case"FETCH_BRANCH_GROUP_DATA":return Object.assign({},state,{branchGroupData:action.branchGroupData,preloader:false});case"FETCH_ETA_CONFIG_DATA":return Object.assign({},state,{etaConfigData:action.etaConfigData,preloader:false});case"FETCH_ETA_ID_CONFIG_DATA":return Object.assign({},state,{etaConfig:action.etaConfig,preloader:false});case"FETCH_BRANCH_GROUPS_IDS":return Object.assign({},state,{branchGroupsByIds:action.branchGroupsByIds,preloader:false});case"FETCH_BRANCH_GROUP_LIST":return Object.assign({},state,{branchGroupList:action.branchGroupList,preloader:false});case"FETCH_BRANCH_GROUP_DATA_SETTINGS":return Object.assign({},state,{branchGroupSettings:action.branchGroupSettings,preloader:false});case"FETCH_BRANCH_GROUPS":return Object.assign({},state,{branchGroups:action.branchGroups,preloader:false});/* case "FETCH_BRANCH_GROUP_LIST":
            return {
                ...state,
                branchGroupList: action.branchGroupList,
                preloader: false,
            }; */case"DELETE_BRANCH_GROUP":return Object.assign({},state,{branchGroupList:action.branchGroupList,branchGroups:action.branchGroups,hasDeletedSuccessfully:action.hasDeletedSuccessfully,preloader:false});/*
		|---------------------------------
		|        BRANCH CATEGORIES       |
		|---------------------------------
		*/case"FETCH_BRANCH_CATEGORIES":return Object.assign({},state,{branchCategories:action.branchCategories,preloader:false});case"FETCH_BRANCH_COMPANY_CATEGORIES":return Object.assign({},state,{BranchCompanyCategories:action.BranchCompanyCategories,preloader:false});case"REMOVE_BRANCH_CATEGORY":return Object.assign({},state,{branchCategories:action.branchCategories,preloader:false});case"UPDATE_BRANCH_CATEGORY":return Object.assign({},state,{branchCategories:action.branchCategories,preloader:false});/*
		|---------------------------------
		|        PUSH NOTIFICATIONS      |
		|---------------------------------
		*/case"ADD_NOTIFICATION_SIDEBAR":return Object.assign({},state,{notifications:[action.push].concat(_toConsumableArray(state.notifications)),//[action.target.storeKey]: action.target.data,
unseenNotifications:action.unseenNotifications// ...action.updates,
});case"NOTIFICATION_SIDEBAR_LIST":return Object.assign({},state,{notifications:action.notifications});case"NOTIFICATIONS_PAGINATED_LIST":return Object.assign({},state,{notificationsPaginated:action.notificationsPaginated,preloader:false});case"REMOVE_NOTIFICATION_SIDEBAR":return Object.assign({},state,{notifications:action.notifications,notificationsPaginated:action.notificationsPaginated,unseenNotifications:action.unseenNotifications,preloader:false});case"PUSH_NOTIFICATION":return Object.assign({},state,{notificationPushEvent:action.notificationPushEvent,preloader:false});case"EMPTY_NOTIFICATION_LIST":return Object.assign({},state,{notifications:[],unseenNotifications:false});case"NOTIFICATIONS_COUNTER":return Object.assign({},state,{notificationsCounter:action.notificationsCounter});case"NOTIFICATIONS_UNSEEN":return Object.assign({},state,{unseenNotifications:action.unseenNotifications});case"NOTIFICATIONS_PAGINATION":return Object.assign({},state,{notificationPagination:action.notificationPagination});case"TOGGLE_TOUCHED":return Object.assign({},state,_defineProperty({},action.storeKey,action.list));/*
		|---------------------------------
		|           UTILITIES          |
		|---------------------------------
		*/case"SET_USER_DEFAULT_LANGUAGE":return Object.assign({},state,{lang_code:action.lang_code,json_lang:action.json_lang,preloader:false});case"WAIT_FOR_RESPONSE":return Object.assign({},state,{preloader:true});case"SET_TABLE":return Object.assign({},state,{table:action.table,preloader:false});/* set table but using notifications */case"SET_TABLE_NOTIFICATION":return Object.assign({},state,{preloader:false,table:action.table});case"GEOCODER_LOADING":return Object.assign({},state,{isLoading:action.isLoading,order_client_address_query:action.order_client_address_query});case"ON_RESIZE_LISTENER":return Object.assign({},state,{isSidebarActive:action.isSidebarActive!==undefined?action.isSidebarActive:state.isSidebarActive,isAsidemenuActive:action.isAsidemenuActive!==undefined?action.isAsidemenuActive:state.isAsidemenuActive});/*
		|---------------------------------
		|            new table            |
		|---------------------------------
		*/case"RESET_TABLE_DATA":return Object.assign({},state,(_Object$assign2={},_defineProperty(_Object$assign2,action.storeAttr,[]),_defineProperty(_Object$assign2,'preloader',false),_Object$assign2));/*
		|---------------------------------
		|            generator            |
		|---------------------------------
		*/case"INIT_PROTOYPE":return Object.assign({},state,{infPrototype:action.infPrototype});/*
		|---------------------------------
		|            CATEGORY            |
		|---------------------------------
		*/case"RESET_CATEGORY":return Object.assign({},state,{category:action.category});case"FETCH_CATEGORIES":return Object.assign({},state,{categories:action.categories,preloader:false});case"FETCH_CATEGORY":return Object.assign({},state,{category:action.category});case"CREATE_CATEGORY":return Object.assign({},state,_defineProperty({},action.updateList,state[action.updateList].concat(action.category)));case"UPDATE_CATEGORY":return Object.assign({},state,{preloader:false,categories:[].concat(_toConsumableArray(action.categories)),category:action.category});case"CATEGORY_UPDATE_SUCCESS":return Object.assign({},state,{preloader:false,categories:action.categories,category:action.category});case"CATEGORY_DESTROY_SUCCESS":return Object.assign({},state,{categories:action.categories,preloader:false,category:action.clear});case"DESTROY_CATEGORY":return Object.assign({},state,{categories:[].concat(_toConsumableArray(action.categories))});/*
		|---------------------------------
		|               APP              |
		|---------------------------------
		*/case"FETCH_APPS":return Object.assign({},state,{apps:[].concat(_toConsumableArray(action.apps))});case"FETCH_APP":return Object.assign({},state,{app:action.app});case"FETCH_APP_PROTOTYPES":return Object.assign({},state,{prototypes:action.prototypes});/*
		|---------------------------------
		|             USER               |
		|---------------------------------
		*/case"FETCH_USERS":return Object.assign({},state,{users:[].concat(_toConsumableArray(action.users))});case"FETCH_USER":return Object.assign({},state,{user:action.user});case"FETCH_USER_APPS":return Object.assign({},state,{apps:action.apps});/*
		|---------------------------------
		|             COMPANY            |
		|---------------------------------
		*/case"COMPANY_PROFILE":return Object.assign({},state,{company:action.company,initCompany:action.initCompany,preloader:false});case"COMPANY_SETTINGS_UPDATE":return Object.assign({},state,{editable_company_settings:Object.assign({},action.editable_company_settings),preloader:false});case"COMPANY_UPDATE":return Object.assign({},state,{company:action.company,initCompany:action.initCompany,preloader:false});case"FETCH_TOS":return Object.assign({},state,{terms_of_service:action.terms_of_service,preloader:false});case"FETCH_WORK_SCHEDULES":return Object.assign({},state,{workSchedules:[].concat(_toConsumableArray(action.workSchedules)),preloader:false});case"FETCH_HOLIDAYS":return Object.assign({},state,{companyHolidays:[].concat(_toConsumableArray(action.companyHolidays)),preloader:false});case"FETCH_COMPANIES":return Object.assign({},state,{companies:action.companies});case"REPORT_HISTORIES":return Object.assign({},state,{reportHistories:action.reportHistories,preloader:false});case"REPORT":return Object.assign({},state,{report:action.report,preloader:false/*
		|---------------------------------
		|             ADMIN
		|---------------------------------
		*/});case"CLEAR_ADMIN":return Object.assign({},state,{admin:action.admin,dropzoneFiles:action.dropzoneFiles,preloader:false});case"FETCH_ADMIN":return Object.assign({},state,{admin:action.admin,preloader:false});case"FETCH_ADMINS":return Object.assign({},state,{admins:action.admins,preloader:false});case"ADMIN_REGISTER_SUCCESS":return Object.assign({},state,{admin:action.admin,admins:[].concat(_toConsumableArray(state.admins),[action.admin]),preloader:false});case"ADMIN_UPDATE_SUCCESS":return Object.assign({},state,{admin:action.admin,admins:action.admins,preloader:false});case"ADMIN_UPDATE_PREFERENCES":return Object.assign({},state,{session:Object.assign({},state.session,_defineProperty({},state.session.settings.preferences,action.preferences)),preloader:false});case"ADMIN_RANKING":return Object.assign({},state,{preloader:false});case"ADMIN_DELETED":return Object.assign({},state,{preloader:false,admins:action.admins});/*
		|---------------------------------
		|             MAPS
		|---------------------------------
		*/case"GEOCODER_SUCCESS":return Object.assign({},state,{autocomplete_results:action.autocomplete_results,isLoading:false});case"MAP_FILTERS_VISIBILITY":return Object.assign({},state,{mapFilters:Object.assign({},state.mapFilters,_defineProperty({},action.filter,!state.mapFilters[action.filter]))});case"MAP_RADIO_FILTER_VISIBILITY":return Object.assign({},state,{mapFilters:Object.assign({},state.mapFilters,{date:Object.assign({},action.newDateFilters)})});case"STATIC_MAP":return Object.assign({},state,{staticMap:action.staticMap});/*
		|---------------------------------
		|             PROVIDER
		|---------------------------------
		*/case"CLEAR_PROVIDER":return Object.assign({},state,{provider:action.provider,dropzoneFiles:action.dropzoneFiles});case"CLEAR_PROVIDERS":return Object.assign({},state,{providers:action.providers,preloader:false});/* case "SET_PROVIDERS_BY_EVENT":
            return {
                ...state,
                providers: action.providers,
                preloader: false,
            }; */case"UPDATE_PROVIDER_GEOLOCATION":return Object.assign({},state,{providers:action.providers});case"FETCH_PROVIDERS":return Object.assign({},state,{providers:action.providers,preloader:false});case"FETCH_PROVIDER_SETTINGS":return Object.assign({},state,{providerSettings:action.providerSettings,preloader:false});case"FETCH_AUTOCOMPLETE_SEARCH_PROVIDERS":return Object.assign({},state,{autocompleteProviders:action.autocompleteProviders,preloader:false});case"FETCH_PROVIDER":return Object.assign({},state,{provider:action.provider,preloader:false});//!case "PROVIDER_DELETED":
case"UPDATE_PROVIDER_SUCCESS":return Object.assign({},state,{providers:action.providers,provider:action.provider,preloader:false});case"REGISTER_PROVIDER_SUCCESS":return Object.assign({},state,{provider:action.clear,providers:[].concat(_toConsumableArray(state.providers),[action.provider]),preloader:false});case"AUTOCOMPLETE_PROVIDER":return Object.assign({},state,{providers:action.providers});case"FETCH_PROVIDER_STATISTICS":return Object.assign({},state,{providerStatistics:action.providerStatistics,preloader:false});case"FETCH_PROVIDER_ORDERS":return Object.assign({},state,{providerOrders:action.providerOrders,preloader:false});case"INVALID_ADVANCE_CONFIG":return Object.assign({},state,{invalidConfig:action.invalidConfig});/*
		|---------------------------------
		|             ORDERS
		|---------------------------------
		*/case"RESET_DATA_DETAILS_ORDER":return Object.assign({},state,{orderDetails:action.orderDetails,preloader:false});case"COMPANY_COLOR":return Object.assign({},state,{color_accent:action.color_accent});case"FETCH_ORDER":return Object.assign({},state,{order:action.order,preloader:false});case"FETCH_MAP_ORDERS":return Object.assign({},state,{mapOrders:action.mapOrders||state.mapOrders,//!paginationOrders: state.paginationOrders,
filteredMapOrders:action.filteredMapOrders||state.filteredMapOrders,preloader:false});case"CLEAR_MAP_FILTERS":return Object.assign({},state,{filteredMapOrders:[]});case"FETCH_ORDERS":return Object.assign({},state,{orders:action.orders,archived_orders:action.archived_orders,preloader:false});case"SET_ORDERS_BY_EVENT":return Object.assign({},state,{filteredMapOrders:action.orders,preloader:false});case"FETCH_ARCHIVED_ORDERS":return Object.assign({},state,{orders:action.orders,archived_orders:action.archived_orders,preloader:false});case"FETCH_RATINGS":return Object.assign({},state,{goodRatings:action.goodRatings});case"FETCH_ORDER_RATINGS":return Object.assign({},state,{orderRatings:action.orderRatings});case"LIST_TODAY_ORDERS":return Object.assign({},state,{todayOrders:action.todayOrders,ordersCounter:action.ordersCounter//orders: action.orders,
});case"UPDATE_TODAY_ORDERS":return Object.assign({},state,{todayOrders:action.todayOrders,orders:action.orders,preloader:false});case"ORDER_REGISTERED":return Object.assign({},state,{order:action.order,preloader:false,reset_inputs:action.reset_inputs});case"REGISTER_NEW_ORDER":return Object.assign({},state,{cart:{client_latitude_e6:0,client_longitude_e6:0,scheduled_at:"",notes:"",goods:[],goodsQuantity:[],propertiesQuantity:[],delivery_method:"other",// asap or scheduled
isPickup:true,client_address:null},order:{client_id:"",client_latitude_e6:0,client_longitude_e6:0,scheduled_at:"",notes:"",goods:[],providers_id:"",propertiesGood:[]},client:{},autocomplete_results:[],properties:[],provider:{},reset_inputs:false,order_client_address_query:"",client_address:""});case"FETCH_ORDERS_HEATMAP":return Object.assign({},state,{ordersBranchHeatmap:action.ordersBranchHeatmap,preloader:false});case"CANCEL_ORDER_ERROR":return Object.assign({},state,{cancelOrderError:action.cancelOrderError,preloader:false});case"CHECKOUT_PROMO_CODE":return Object.assign({},state,{couponCode:action.couponCode,preloader:false});case"FETCH_CLIENT_ORDERS":return Object.assign({},state,{clientOrders:action.clientOrders,preloader:false});/*
		|---------------------------------
		|             GOODS
		|---------------------------------
		*/case"FETCH_GOODS":return Object.assign({},state,{goods:action.goods,category:action.category,preloader:action.preloader||false});case"IS_UPLOADING_EXCEL":return Object.assign({},state,{isUploadingExcel:action.isUploadingExcel,preloader:false});case"FETCH_LIST_GOODS":return Object.assign({},state,{goodsList:action.goodsList,goodType:action.goodType,category:action.category,preloader:action.preloader||false});case"FETCH_LIST_GOODSBULK":return Object.assign({},state,{goodsListBulk:action.goodsListBulk,preloader:action.preloader});case"DISPLAY_LIST_GOODS":return Object.assign({},state,{goodsList:action.goodsList,preloader:false});case"REGISTER_GOOD":return Object.assign({},state,{good:action.clear,goodsList:[].concat(_toConsumableArray(state.goodsList),[action.good]),preloader:false});case"FETCH_GOOD":return Object.assign({},state,{good:action.good,preloader:false});case"GOOD_UPDATE_SUCCESS":return Object.assign({},state,{good:action.good,goodsList:action.goodsList,preloader:false,dropzoneFiles:[]});case"DUPLICATE_GOOD":return Object.assign({},state,{goods:action.goods,savedGood:action.savedGood,table:action.table,preloader:action.preloader||false});case"GOOD_RESTAURED":break;case"GOOD_DELETED":return Object.assign({},state,{goodsList:action.goodsList,good:action.good,preloader:false});case"CLEAR_GOOD":return Object.assign({},state,{good:action.good,dropzoneFiles:action.dropzoneFiles});case"CATEGORIES_GOOD":return Object.assign({},state,{categoriesGood:action.categoriesGood,allCategories:action.allCategories,preloader:false});case"UPDATE_CATEGORIES_GOOD":return Object.assign({},state,{categoriesGood:action.categoriesGood,allCategories:action.allCategories,preloader:false});case"PROPERTIES_GOOD":return Object.assign({},state,{propertiesGood:action.propertiesGood,properties:action.properties});case"SAVE_PROPERTIES_GOOD":return Object.assign({},state,{propertiesGood:action.propertiesGood,preloader:false});case"PROPERTY_UPDATE_SUCCESS":return Object.assign({},state,{preloader:false,properties:action.properties,property:action.property});case"PROPERTY_DESTROY_SUCCESS":return Object.assign({},state,{preloader:false,properties:action.properties,property:action.property});case"ALL_PROPERTIES":return Object.assign({},state,{properties:action.properties,preloader:action.preloader||false});case"ALL_CATEGORIES":return Object.assign({},state,{allCategories:action.allCategories,preloader:false});case"CLEAR_CATEGORY":return Object.assign({},state,{category:action.category,dropzoneFiles:action.dropzoneFiles});case"GET_QUERY_IMAGES":return Object.assign({},state,{queryImages:action.queryImages,preloader:false});case"GET_ORDERED_GOOD":return Object.assign({},state,{orderedGood:action.orderedGood,preloader:false});case"ERROR_ON_ORDERED_GOOD":return Object.assign({},state,{errorOnOrderedGood:action.errorOnOrderedGood,preloader:false/*
		|---------------------------------
		|             PROPERTIES
		|---------------------------------
		*/});case"GET_FORM":return Object.assign({},state,{form:action.form});case"ACTIVE_FORM":return Object.assign({},state,{active_form:action.active_form,property:action.property});case"GET_ALL_PAYMENT":return Object.assign({},state,{allPayments:action.allPayments,preloader:false});case"GET_ACEPTED_PAYMENT":return Object.assign({},state,{aceptedpayments:action.aceptedpayments,preloader:false});case"GET_ONE_PAYMENT":return Object.assign({},state,{onePayment:action.onePayment,preloader:false});case"GET_PAYMENT_FORM":return Object.assign({},state,{payment_form:action.payment_form,preloader:false});case"UPDATE_PAYMENT_FORM":return Object.assign({},state,{payment_form:action.payment_form,preloader:false});case"FORM_UPDATE_SUCCESS":return Object.assign({},state,{table:action.table,preloader:false});case"FORM_TYPE":return Object.assign({},state,{form:action.form,preloader:false});case"FETCH_PROPERTY":return Object.assign({},state,{property:action.property,preloader:false});case"FETCH_PROPERTIES":return Object.assign({},state,{properties:action.properties,preloader:false});case"CREATE_PROPERTIES":return Object.assign({},state,{property:{},properties:[].concat(_toConsumableArray(state.properties),[action.property]),preloader:false});case"FETCH_PROPERTIES_GOOD":return Object.assign({},state,{propertiesGood:action.propertiesGood,properties:action.properties,preloader:false});case"AUTOCOMPLETE_GOODS":return Object.assign({},state,{goods:action.goods});case"AUTOCOMPLETE_PROPERTIES":return Object.assign({},state,{properties:action.properties});/*
		|---------------------------------
		|             BRANCH PROPERTIES
		|---------------------------------
		*/case"ALL_BRANCH_PROPERTIES":return Object.assign({},state,{branchProperties:action.branchProperties,preloader:action.preloader});case"BRANCH_PROPERTY_UPDATE":return Object.assign({},state,{preloader:false,branchProperties:action.branchProperties,property:action.property});/*
		|---------------------------------
		|             ORDER
		|---------------------------------
		*/case"GET_CLIENT_CART":return Object.assign({},state,{cart:action.cart,errorOnCart:action.errorOnCart,preloader:false});case"GET_ORDER_CART":return Object.assign({},state,{cartOrder:action.cartOrder,errorOnCart:false,preloader:false});case"CLEAR_CART":return Object.assign({},state,{cart:{billing:{},branch:{},branch_id:null,client_id:null,created_at:null,currency_iso:null,delivery:{},id:null,items:[],payment_info:{},resume:{},status:null,updated_at:null},preloader:false,errorOnCart:false});case"ERROR_ON_ORDER_PAYMENT":return Object.assign({},state,{errorOnOrderPayment:action.errorOnOrderPayment,preloader:false});case"ERROR_ON_RECREATE_ORDER":return Object.assign({},state,{errorOnRecreateOrder:action.errorOnRecreateOrder,preloader:false});case"BUILD_ORDER":return Object.assign({},state,{provider:action.provider,cart:action.cart});case"FETCH_ORDER_DETAILS":return Object.assign({},state,{orderDetails:action.orderDetails,preloader:false});case"FETCH_ORDER_HISTORY":return Object.assign({},state,{orderHistory:action.orderHistory,preloader:false});case"ORDER_HISTORY_ERROR":return Object.assign({},state,{orderHistoryError:action.orderHistoryError,preloader:false});case"FETCH_PROOF_DELIVERY":return Object.assign({},state,{proofDelivery:action.proofDelivery});case"ASSIGN_CLIENT_TO_ORDER":return Object.assign({},state,{client:action.client});case"ASSIGN_PROVIDER_TO_ORDER":return Object.assign({},state,{provider:action.provider,cart:Object.assign({},state.cart,{isPickup:action.isPickup})});/*
		|---------------------------------
		|             CLIENT
		|---------------------------------
		*/case"CLEAR_CLIENT":return Object.assign({},state,{client:action.client,dropzoneFiles:action.dropzoneFiles});case"FETCH_CLIENT":return Object.assign({},state,{client:action.client,preloader:false});case"FETCH_CLIENT_SETTINGS":return Object.assign({},state,{clientSettings:action.clientSettings,preloader:false});case"FETCH_CLIENTS":return Object.assign({},state,{clients:action.clients,preloader:false});case"FETCH_PAGINATED_CLIENTS":return Object.assign({},state,{paginated_clients:action.paginated_clients,preloader:false});case"AUTOCOMPLETE_CLIENT":return Object.assign({},state,{clients:action.clients});case"DESTROY_CLIENT":return Object.assign({},state,{client:action.client});case"UPDATE_CLIENT":return Object.assign({},state,{paginated_clients:Object.assign({},state.paginated_clients,{data:action.paginated_clients}),client:action.client,preloader:false});case"REGISTER_CLIENT_SUCCESS":return Object.assign({},state,{clients:[].concat(_toConsumableArray(state.clients),[action.client]),preloader:false});case"CLIENT_DELETED":case"CLIENT_RESTAURED":return Object.assign({},state,{client:action.client,paginated_clients:Object.assign({},state.paginated_clients,{data:action.paginated_clients}),preloader:false});case"ATTACHABLE_CLIENS":return Object.assign({},state,{clientsToAsing:action.clientsToAsing,allClients:action.allClients,preloader:false});case"ATTACHABLE_ADMINS":return Object.assign({},state,{adminsToAsing:action.adminsToAsing,admins:action.admins,preloader:false});/*
		|---------------------------------
		|             SECTION            |
		|---------------------------------
		*/case"FETCH_SECTIONS":return Object.assign({},state,{sections:[].concat(_toConsumableArray(action.sections))});case"CREATE_SECTION":return Object.assign({},state,{sections:state.sections.concat(action.section)});case"UPDATE_SECTION":return Object.assign({},state,{sections:[].concat(_toConsumableArray(action.sections))});/*
		|---------------------------------
		|             TEMPLATES           |
		|---------------------------------
		*/case"FETCH_TEMPLATES":return Object.assign({},state,{templates:[].concat(_toConsumableArray(action.templates))});/*
		|---------------------------------
		|             LAYOUTS            |
		|---------------------------------
		*/case"FETCH_LAYOUTS":return Object.assign({},state,{layouts:[].concat(_toConsumableArray(action.layouts))});case"GET_CANCELATION_REASONS":return Object.assign({},state,{cancelationReasons:action.cancelationReasons});case"UPDATE_CANCELATION_REASONS":return Object.assign({},state,{cancelationReasons:action.cancelationReasons,newCancelationReason:"",preloader:false});case"CANCELATION_REASON":return Object.assign({},state,{newCancelationReason:action.newCancelationReason});case"DROPZONE":return Object.assign({},state,{dropzoneFiles:action.dropzoneFiles,dropzoneActive:false});case"CLEAR_DROPZONE":return Object.assign({},state,{dropzoneFiles:[].concat(_toConsumableArray(action.dropzoneFiles)),dropzoneActive:false});case"ACTIVE_DROPZONE":return Object.assign({},state,{dropzoneActive:true});case"APP_MOVIL_STATUS":return Object.assign({},state,{appMovilStatus:action.appMovilStatus});case"UPDATE_APP_MOVIL_STATUS":return Object.assign({},state,{appMovilStatus:action.appMovilStatus,preloader:false});case"CUSTOM_EMAIL_FOOTER":return Object.assign({},state,{customEmailFooter:action.customEmailFooter});case"CUSTOM_CLIENT_BG":return Object.assign({},state,{customClientBg:action.customClientBg});case"GET_CANCELATION_REASON":return Object.assign({},state,{cancelationReason:action.cancelationReason});case"GET_DOLAR_TODAY":return Object.assign({},state,{dolarToday:action.dolarToday});case"GET_PAYMENT_METHODS":return Object.assign({},state,{paymentMethods:action.paymentMethods,preloader:false});case"GET_PAYMENT_METHODS_FORMS":return Object.assign({},state,{paymentMethodsForms:action.paymentMethodsForms,preloader:false});case"GET_PENDING_ACTIONS":return Object.assign({},state,{pendingActions:action.pendingActions});case"GET_PAYMENT_RESPONSE":return Object.assign({},state,{paymentResponse:action.paymentResponse});case"GET_PAYMENT_REFERENCE":return Object.assign({},state,{paymentReference:action.paymentReference});case"ERROR_ON_PAYMENT_REFERENCE":return Object.assign({},state,{errorOnPaymentReference:action.errorOnPaymentReference});case"CLEAR_PAYMENT_REFERENCE":return Object.assign({},state,{paymentReference:action.paymentReference,errorOnPaymentReference:action.errorOnPaymentReference});case"BUILDER_PACKAGES":return Object.assign({},state,{builderPackages:action.builderPackages});case"GET_BIDS":return Object.assign({},state,{bids:action.bids,preloader:false});case"UPDATE_BIDS":return Object.assign({},state,{bids:action.bids,orderDetails:action.orderDetails,preloader:false});case"ERROR_BIDS":return Object.assign({},state,{errorBids:action.errorBids});case"FETCH_ALL_CLIENTS":return Object.assign({},state,{allClients:action.allClients,preloader:false});case"NEW_SERVICE_SKILL_GROUPS":return Object.assign({},state,{new_service_skill_groups:action.new_service_skill_groups,preloader:false});case"NEW_GOOD_TAG_GROUPS":return Object.assign({},state,{new_good_tag_groups:action.new_good_tag_groups,preloader:false});case"LIST_GOOD_TAG_GROUPS":return Object.assign({},state,{good_tag_groups:action.good_tag_groups,new_good_tag_groups:"",preloader:false});case"LIST_SERVICE_SKILL_GROUPS":return Object.assign({},state,{service_skill_groups:action.service_skill_groups,new_service_skill_groups:"",preloader:false});case"LIST_GOODSERVICE_SKILL_GROUPS":return Object.assign({},state,{goodServiceSkills:action.goodServiceSkills,preloader:false});case"LIST_PROPERTIES_SKILL_GROUPS":return Object.assign({},state,{propertiesSkills:action.propertiesSkills,preloader:false});case"LIST_PROVIDER_SKILLS_GROUP":return Object.assign({},state,{providerSkillsGroups:action.providerSkillsGroups,preloader:false});case"CLEAR_BIDS":return Object.assign({},state,{bids:[],preloader:false});case"FETCH_COMPANY_SECTIONS":return Object.assign({},state,{companySections:action.companySections,preloader:false});case"FETCH_COMPANY_SECTION":return Object.assign({},state,{companySection:action.companySection,preloader:false});case"ASIGNABLE_TOOGLE":return Object.assign({},state,{productosConProveedoresAsignables:action.productosConProveedoresAsignables,preloader:false});case"FETCH_TIMELINEORDER":return Object.assign({},state,{timelineOrder:action.timelineOrder,preloader:false});case"FETCH_ADMINTYPE":return Object.assign({},state,{adminType:action.adminType,preloader:false});case"FETCH_BRANCH_COMPNAY_CATEGORIES":return Object.assign({},state,{branchesCompanyCategories:action.branchesCompanyCategories,preloader:false});case"FETCH_COMPANY_BRANCH_CATEGORY":return Object.assign({},state,{companyCategory:action.companyCategory,preloader:false});case"FETCH_ADMINS_ACCESS":return Object.assign({},state,{admindAccessList:action.admindAccessList,preloader:false});case"FETCH_ALLADMINTYPES":return Object.assign({},state,{allAdminTypes:action.allAdminTypes,preloader:false});case"FETCH_PROMMOTED_BANNERS":return Object.assign({},state,{promotedBanners:action.promotedBanners,preloader:false});case"FETCH_PROMMOTED_BANNER":return Object.assign({},state,{promotedBanner:action.promotedBanner,preloader:false});case"FETCH_COMPANY_BRANCH_SUBCATEGORY":return Object.assign({},state,{companySubCategory:action.companySubCategory,preloader:false});case"DATA_NOTIFICATION":return Object.assign({},state,{sendNotification:action.sendNotification});case"GET_BROADCASTMESSAGE":return Object.assign({},state,{broadcastMessages:action.broadcastMessages,preloader:false});case"GET_BROADCASTMESSAGE_DETAILS":return Object.assign({},state,{broadcastMessageDetails:action.broadcastMessageDetails,preloader:false});case"COMPANY_GEOFENCES":return Object.assign({},state,{companyGeoFences:action.companyGeoFences,preloader:false});case"BRANCH_GEOFENCE":return Object.assign({},state,{branchGeoFence:action.branchGeoFence,preloader:false});case"BRANCH_GEOFENCES":return Object.assign({},state,{branchGeoFences:action.branchGeoFences,preloader:false});case"BRANCH_GEOFENCE_DELIVERYFEE":return Object.assign({},state,{branchGeoFenceDeliveryFee:action.branchGeoFenceDeliveryFee,preloader:false});case"BRANCH_DELIVERY_FEEDS":return Object.assign({},state,{branchDeliveryFees:action.branchDeliveryFees,preloader:false});case"FETCH_COMPANY_DELYVERY_FEEDS":return Object.assign({},state,{companyDeliveryFeeds:action.companyDeliveryFeeds,preloader:false});case"FETCH_BALANCE_MOVEMENTS":return Object.assign({},state,{balanceMovements:action.balanceMovements,preloader:false});case"FETCH_BALANCE_MOVEMENT":return Object.assign({},state,{balanceMovement:action.balanceMovement,preloader:false});case"FETCH_BALANCE_MODIFIERS":return Object.assign({},state,{balanceModifiers:action.balanceModifiers,preloader:false});case"FETCH_BALANCE_DEBT":return Object.assign({},state,{balanceDebt:action.balanceDebt,preloader:false});case"CONFIRMATION_REAZON":return Object.assign({},state,{confirmationOrder:action.confirmationOrder,preloader:false});case"FETCH_COUPONS":return Object.assign({},state,{coupons:action.coupons,preloader:false});case"CLEAR_COUPON_DATA":return Object.assign({},state,{coupon:{name:"",type:"",promo_code:"",human_price_prc:"",human_price_e2:"",applies_to:"",total_count:"",unlimited:false,config:{limit:"",human_company_assumption_prc:"0",only_deliveries:false,only_first_purchase:false,usable_in_promos:false}}});case"CLEAR_PROMOTION_DATA":return Object.assign({},state,{coupon:{name:"",type:"",promo_code:"",human_price_prc:"",human_price_e2:"",applies_to:"",total_count:"",unlimited:false,config:{limit:""}}});case"FETCH_COUPON":return Object.assign({},state,{coupon:action.coupon,preloader:false});case"FETCH_VEHICLES":return Object.assign({},state,{vehicles:action.vehicles,preloader:false});case"STORE_VEHICLE":return Object.assign({},state,{vehicle:action.vehicle,preloader:false});case"FETCH_PROVIDERS_VEHICLES":return Object.assign({},state,{providersVehicle:action.providersVehicle,preloader:false});case"FETCH_BRANCH_GROUPS_VEHICLES":return Object.assign({},state,{branchGroupsVehicle:action.branchGroupsVehicle,preloader:false});case"FETCH_LOCALIZED_MESSAGES":return Object.assign({},state,{localized_messages:action.localized_messages,preloader:false});case"FETCH_APILOGS":return Object.assign({},state,{apilogs:action.apilogs,preloader:false});case"FETCH_COMPANY_CURRENCIES":return Object.assign({},state,{companyCurrencies:action.companyCurrencies,currencyError:action.currencyError,preloader:false});case"FETCH_COMPANY_CURRENCY":return Object.assign({},state,{companyCurrency:action.companyCurrency,preloader:false});case"FETCH_BRANCH_CURRENCIES":return Object.assign({},state,{branchCurrencies:action.branchCurrencies,branchCurrencyError:action.branchCurrencyError,preloader:false});case"FETCH_BRANCH_CURRENCY":return Object.assign({},state,{branchCurrency:action.branchCurrency,preloader:false});case"FETCH_BRANCH_PRICELIST":return Object.assign({},state,{branchPriceList:action.branchPriceList,preloader:false});case"FETCH_BRANCH_PRICELIST_ID":return Object.assign({},state,{priceListId:action.priceListId,preloader:false});case"STORE_NEW_BILLING":return Object.assign({},state,{newBilling:action.newBilling,preloader:false});case"LOT_BILLING_DETAILS":return Object.assign({},state,{lotBillingsDetails:action.lotBillingsDetails,newBilling:action.newBilling,preloader:false});case"FETCH_GENERAL_INVOICES":return Object.assign({},state,{generalInvoices:action.generalInvoices,preloader:false});case"FETCH_COMPANY_GENERAL_INVOICES":return Object.assign({},state,{companyGeneralInvoices:action.companyGeneralInvoices,preloader:false});case"FETCH_TO_PAY_COMPANY_GENERAL_INVOICES":return Object.assign({},state,{toPayCompanyGeneralInvoices:action.toPayCompanyGeneralInvoices,preloader:false});case"FETCH_INVOICE":return Object.assign({},state,{invoice:action.invoice,preloader:false});case"FETCH_GIVE_CHANGE":return Object.assign({},state,{giveChange:action.giveChange,preloader:false});case"GIVE_CHANGE_ERROR":return Object.assign({},state,{giveChangeError:action.giveChangeError});case"FETCH_PARTIAL_GIVE_CHANGE":return Object.assign({},state,{parcialGivechange:action.parcialGivechange,preloader:false});case"FETCH_GIVE_CHANGE_HISTORY":return Object.assign({},state,{giveChangeHistory:action.giveChangeHistory,preloader:false});case"FETCH_COMPANY_COUNTRIES":return Object.assign({},state,{companyCountriesCities:action.companyCountriesCities,preloader:false});case"FETCH_COMPANY_CITIES":return Object.assign({},state,{companyCities:action.companyCities,preloader:false});case"FEATURED_GOODS":return Object.assign({},state,{featuredGoods:action.featuredGoods,preloader:false});case"FEATURED_GOOD":return Object.assign({},state,{featuredGood:action.featuredGood,preloader:false});case"FETCH_BRANCHES_LIST":return Object.assign({},state,{branchesList:action.branchesList,preloader:false});case"FETCH_BRANCHES_LIST_MAP":return Object.assign({},state,{branchesListMap:action.branchesListMap,preloader:false});case"GET_COMPANY_EARNING":return Object.assign({},state,{companyEarning:action.companyEarning,preloader:false});case"GET_SERVICE_CHARGES":return Object.assign({},state,{serviceCharges:action.serviceCharges,preloader:false});case"GET_SERVICE_SUPPLIERS":return Object.assign({},state,{serviceSuppliers:action.serviceSuppliers,preloader:false});case"GET_FLEETS":return Object.assign({},state,{fleets:action.fleets,preloader:false});case"GET_ORDER_FLEETS":return Object.assign({},state,{orderFleets:action.orderFleets,preloader:false});case"SET_HAS_FLEETS":return Object.assign({},state,{hasFleets:action.hasFleets});case"GET_ONE_FLEET":return Object.assign({},state,{fleet:action.fleet,preloader:false});case"NEW_FLEET":return Object.assign({},state,{newFleet:action.newFleet,preloader:false});case"UPDATE_FLEET":return Object.assign({},state,{updateFleet:action.updateFleet,preloader:false});case"FLEET_DELETED":return Object.assign({},state,{getFleets:action.getFleets,fleet:action.fleet,preloader:false});case"GET_SERVICE_PROFILES":return Object.assign({},state,{serviceProfiles:action.serviceProfiles,preloader:false});case"GET_COUNTRIES":return Object.assign({},state,{countries:action.countries,preloader:false});case"GET_PAYMENT_REPORT":return Object.assign({},state,{companyPayment:action.companyPayment,preloader:false});case"NEW_FLEET_MEMBER":return Object.assign({},state,{new_fleet_member:action.new_fleet_member,preloader:false});case"GET_FLEET_MEMBERS":return Object.assign({},state,{fleet_members:action.fleet_members,preloader:false});case"GET_ASSOCIATIONS":return Object.assign({},state,{associations:action.associations,preloader:false});case"GET_FLEETS_PAYMENT_METHODS":return Object.assign({},state,{fleetPaymentMethods:action.fleetPaymentMethods,preloader:false});/*
		|---------------------------------
		|             CHATS              |
		|---------------------------------
		*/case"FETCH_CHAT_MEMBERS":return Object.assign({},state,{chatMembers:action.chatMembers,activeInbox:action.activeInbox,preloader:false});case"NEW_CHAT_MEMBER":return Object.assign({},state,{newChatMember:action.newChatMember});case"FETCH_CHATS":return Object.assign({},state,{chats:action.chats,preloader:false});case"FETCH_SHOPPER_CHATS":return Object.assign({},state,{shopperChats:action.shopperChats,preloader:false});case"FETCH_PROVIDER_CHATS":return Object.assign({},state,{providerChats:action.providerChats,preloader:false});case"FETCH_CHAT_USER":return Object.assign({},state,{chatUser:action.chatUser,preloader:false});case"CLEAR_CHATS":return Object.assign({},state,{chatUser:action.chatUser,chats:action.chats,chatMembers:action.chatMembers,prelaoder:false///////////////////////////////////////////////////////
});case"TOOGLE_NOTIFICATIONS":return Object.assign({},state,{showNotification:action.showNotification,preloader:false});case"TWO_STEPS":return Object.assign({},state,{twoSteps:action.twoSteps,preloader:false});default:return state;/*
		|---------------------------------
		|             WEBHOOKS           |
		|---------------------------------
		*/case"GET_WEBHOOKS":return Object.assign({},state,{webhooks:action.webhooks,preloader:false});case"SET_WEBHOOK":return Object.assign({},state,{webhook:action.webhook,preloader:false});case"GET_WEBHOOKS_OPTIONS":return Object.assign({},state,{webhooksOptions:action.webhooksOptions,preloader:false});}};var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* createStore */])(reducer,initialState,Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__["a" /* default */]));//, logger));
if(!__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* CONSOLE_LOG */]){store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* createStore */])(reducer,initialState,Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__["a" /* default */]));}/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return iaxios; });
/* unused harmony export CathTokenRenewal */
/* unused harmony export HandleErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions_userActions__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Modal_TwoStepsModal__ = __webpack_require__(455);
var json_lang=__WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].getState().json_lang;var iaxios=__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create();var appVersion="3.1.7";var buildVersion="3939";var xVersion='Web panel.dondemand.io '+appVersion+'.'+buildVersion;iaxios.defaults.headers.common['Authorization']='Bearer '+localStorage.getItem('token')||'';iaxios.defaults.headers.common['X-Version']=xVersion;iaxios.interceptors.response.use(function(res){CathTokenRenewal(res);if(res&&res.status<200&&res.status>299){return HandleErrors(res);}return res;},function(error){if(error&&error.response){if(error.response.data&&error.response.data.error_code==="ET100"){__WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].dispatch({type:"REMOVE_LOADING"});return HandleErrors(error.response);}return Promise.reject(HandleErrors(error.response));}else{return Promise.reject(HandleErrors(error));}});function CathTokenRenewal(res){if(res.headers["authorization"]){localStorage.setItem('token',res.headers["authorization"].split(" ")[1]);Object(__WEBPACK_IMPORTED_MODULE_1__store_actions_userActions__["m" /* setupTokenRenewal */])();}}function HandleErrors(res){console.log("res",res);var msg_code=res&&res.data&&res.data.message?res.data.message:'',errors=res&&res.data&&res.data.errors?res.data.errors:'',status=res&&res.status,out={data:res.data,status:res.status,title:'',message:res.data&&res.data.description?res.data.description:'generic',level:4};switch(status){case 400:out.title='Error '+(res.data&&res.data.error_code)+': '+json_lang.errors.title_400;switch(msg_code){case'error_deleting':/* xHACER: este trae características extra */out.message=json_lang.errors.on_delete_des;break;case'error_restoring':out.message=json_lang.errors.on_restore_des;break;case'scheduling_date_too_low':case'scheduling_date_too_high':out.message=json_lang.errors.bad_schedule_des;break;case'token_invalid':out.message=json_lang.errors.token_invalid_des;invalidateSession();break;case'confirmation_token_invalid':out.message=json_lang.errors.token_invalid_des2;break;case'branch_does_not_have_address':out.message=json_lang.errors.branch_does_not_have_address;break;case'branch_not_enabled':out.message=json_lang.errors.branch_not_enabled;break;case'branch_enabled':out.message=json_lang.errors.branch_enabled;break;case'branch_not_visible':out.message=json_lang.errors.branch_not_visible;break;case'branch_visible':out.message=json_lang.errors.branch_visible;break;case'branch_not_featured':out.message=json_lang.errors.branch_not_featured;break;case'branch_featured':out.message=json_lang.errors.branch_featured;break;case'branch_does_not_have_stock':out.message=json_lang.errors.branch_does_not_have_stock;break;case'not_allowed':out.message=json_lang.errors.order_requires_auth_from_commerce;break;case'already_prepared':out.title=json_lang.errors.already_prepared_title;out.message=json_lang.errors.already_prepared;break;case'two_steps_verification':var promiseResolverWrapper={};var promise=new Promise(function(resolve){promiseResolverWrapper.resolve=resolve;});var ref=modal(out.data,res.config,true,promiseResolverWrapper.resolve);__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.render(ref,document.getElementById("two-steps-verification"));return promise;default:out.message='generic';break;}break;case 401:out.title='Error '+(res.data&&res.data.error_code)+': '+json_lang.errors.title_401;switch(msg_code){case'token_expired':// luego de 2 semanas sin validar o sin iniciar sesión
out.message=json_lang.errors.token_expired_des;invalidateSession();break;case'token_invalid':out.message=json_lang.errors.token_invalid_des;invalidateSession();break;case'invalid_credentials':out.message=json_lang.errors.invalid_credentials_des;break;case'token_not_provided':out.message=json_lang.errors.token_not_provided_des;break;default:out.message='generic';break;}break;case 403:out.title='Error '+(res.data&&res.data.error_code)+': '+json_lang.errors.title_403;switch(msg_code){case'account_disabled':out.message=json_lang.errors.token_not_provided_des;break;case'account_blocked':out.message=json_lang.errors.account_blocked_des;break;case'account_unconfirmed':out.message=json_lang.errors.account_unconfirmed_des;break;case'account_mismatches':out.message=json_lang.errors.account_mismatches_des;break;case'company_disabled':out.message=json_lang.errors.company_disabled;break;case'feature_disabled':out.message=json_lang.errors.feature_disabled_des;break;case'target_too_high':out.message=json_lang.errors.target_too_high_des;break;case'forbidden':out.title='Esta funcionalidad no está disponible';out.message='por favor comunicate con soporte';break;default:break;}break;case 404:switch(msg_code){case'generic_error':out.title="Por favor seleccione un comercio";out.message="";break;case'invalid_url_parameters':out.title="Por favor seleccione un comercio";out.message="";break;default:break;}// este es el que estaba antes
// out.message = json_lang.errors.title_404;
break;case 405:out.message=json_lang.errors.title_405;break;case 409:out.title='Error '+(res.data&&res.data.error_code)+': '+json_lang.errors.title_409;out.title=json_lang.errors.title_409;switch(msg_code){case'already_exists':out.message=json_lang.errors.already_exists_title_des;break;case'token_invalid':out.message=json_lang.errors.token_invalid_des;invalidateSession();break;case'invalid_credentials':out.message=json_lang.errors.invalid_credentials_des;break;case'token_not_provided':out.message=json_lang.errors.token_not_provided_des;break;case'attached_branches':out.title="Grupo tiene comercios asociados";var re=/\(([a-zA-Z ]+)\)/;// captura de la resp que trae el api, el nombre del branch_group
var branch_group=re.exec(out.message)?re.exec(out.message)[1]:'';out.message=json_lang.errors.branch_attached_to_group.replace("{branch_group}",branch_group);break;default:break;}break;case 422:out.title='Error '+(res.data&&res.data.error_code)+': '+json_lang.errors.title_422;if(msg_code){if(out.data&&out.data.error_code==="ER422"&&out.data.errors.image){if(out.data.errors.image[0].indexOf("invalid_dimensions")!==-1){out.message="El archivo excede el tamaño máximo";}}else if(out.data&&out.data.errors.password){if(out.data.errors.password[0].indexOf("min 5 characters")!==-1){out.message="Contraseña muy corta. Min 5 caracteres";}}else if(out.data&&out.data.errors.target_type){if(out.data.errors.target_type[0]==="The selected target type is invalid."){out.title='Error al registrar banner';out.message='Por favor complete los campos requeridos';}}else if(Object.keys(out.data.errors).length>0){var txt='';for(var i=0;i<=Object.keys(out.data.errors);i++){var key_errors=Object.keys(out.data.errors)[i];var key_values=Object.values(out.data.errors)[i];txt=txt+(key_errors.replaceAll("_"," ").replaceAll("."," ")+': '+key_values);}out.message=txt;}//out.message = json_lang.errors.des_422;
}else if(errors){console.log('error 422 '.JSON.stringify(res.data));for(var e in errors){console.log(e);}}break;case 423:out.title='Error '+(res.data&&res.data.error_code)+': '+json_lang.errors.company_in_service_title;out.message=json_lang.errors.company_in_service_msg;break;case 429:out.title='Error '+(res.data&&res.data.error_code)+': '+json_lang.errors.des_422;out.message=json_lang.errors.des_422;break;default:out.title='';out.message=json_lang.errors.network_error;break;}//out.message= res.data && res.data.localized_error ? res.data.localized_error : res.data && res.data.message
console.log("out ",out);return out;}var invalidateSession=function invalidateSession(){localStorage.clear();window.location.reload();};var modal=function modal(data,config,toggleModal,promiseResolver){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Modal_TwoStepsModal__["a" /* default */],{title:data.alert_title,message:data.alert_message,data:data,config:config,toggleModal:toggleModal,promiseResolver:promiseResolver}));};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(341);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(347);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(355);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(177);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(356);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(358);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(360);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(362);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(114);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(364);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(366);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(368);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(369);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(370);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 14 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(29)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(102)('wks');
var uid = __webpack_require__(71);
var Symbol = __webpack_require__(19).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(186);
var isBuffer = __webpack_require__(413);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 19 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(99);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(29);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warn = exports.stripDiacritics = exports.scrollIntoViewIfNeeded = exports.preventInputBlur = exports.pluralize = exports.getTruncatedOptions = exports.getStringLabelKey = exports.getOptionLabel = exports.getMenuItemId = exports.getMatchBounds = exports.getInputText = exports.getHintText = exports.getDisplayName = exports.getAccessibilityStatus = exports.defaultFilterBy = exports.addCustomOption = undefined;

var _addCustomOption2 = __webpack_require__(486);

var _addCustomOption3 = _interopRequireDefault(_addCustomOption2);

var _defaultFilterBy2 = __webpack_require__(489);

var _defaultFilterBy3 = _interopRequireDefault(_defaultFilterBy2);

var _getAccessibilityStatus2 = __webpack_require__(552);

var _getAccessibilityStatus3 = _interopRequireDefault(_getAccessibilityStatus2);

var _getDisplayName2 = __webpack_require__(553);

var _getDisplayName3 = _interopRequireDefault(_getDisplayName2);

var _getHintText2 = __webpack_require__(554);

var _getHintText3 = _interopRequireDefault(_getHintText2);

var _getInputText2 = __webpack_require__(556);

var _getInputText3 = _interopRequireDefault(_getInputText2);

var _getMatchBounds2 = __webpack_require__(215);

var _getMatchBounds3 = _interopRequireDefault(_getMatchBounds2);

var _getMenuItemId2 = __webpack_require__(557);

var _getMenuItemId3 = _interopRequireDefault(_getMenuItemId2);

var _getOptionLabel2 = __webpack_require__(127);

var _getOptionLabel3 = _interopRequireDefault(_getOptionLabel2);

var _getStringLabelKey2 = __webpack_require__(216);

var _getStringLabelKey3 = _interopRequireDefault(_getStringLabelKey2);

var _getTruncatedOptions2 = __webpack_require__(558);

var _getTruncatedOptions3 = _interopRequireDefault(_getTruncatedOptions2);

var _pluralize2 = __webpack_require__(559);

var _pluralize3 = _interopRequireDefault(_pluralize2);

var _preventInputBlur2 = __webpack_require__(560);

var _preventInputBlur3 = _interopRequireDefault(_preventInputBlur2);

var _scrollIntoViewIfNeeded2 = __webpack_require__(561);

var _scrollIntoViewIfNeeded3 = _interopRequireDefault(_scrollIntoViewIfNeeded2);

var _stripDiacritics2 = __webpack_require__(126);

var _stripDiacritics3 = _interopRequireDefault(_stripDiacritics2);

var _warn2 = __webpack_require__(37);

var _warn3 = _interopRequireDefault(_warn2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.addCustomOption = _addCustomOption3.default; /* eslint-disable object-curly-spacing */

exports.defaultFilterBy = _defaultFilterBy3.default;
exports.getAccessibilityStatus = _getAccessibilityStatus3.default;
exports.getDisplayName = _getDisplayName3.default;
exports.getHintText = _getHintText3.default;
exports.getInputText = _getInputText3.default;
exports.getMatchBounds = _getMatchBounds3.default;
exports.getMenuItemId = _getMenuItemId3.default;
exports.getOptionLabel = _getOptionLabel3.default;
exports.getStringLabelKey = _getStringLabelKey3.default;
exports.getTruncatedOptions = _getTruncatedOptions3.default;
exports.pluralize = _pluralize3.default;
exports.preventInputBlur = _preventInputBlur3.default;
exports.scrollIntoViewIfNeeded = _scrollIntoViewIfNeeded3.default;
exports.stripDiacritics = _stripDiacritics3.default;
exports.warn = _warn3.default;
/* eslint-enable object-curly-spacing */

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return IS_DIGITAL; });
/* unused harmony export VALUE_TYPE_BALANCE */
/* unused harmony export VALUE_TYPE_BDV */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return TYPE_SERVICES; });
/* unused harmony export CUSTOM_PICKUP */
/* unused harmony export PAYMENT_REGISTERED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MASK_SERVICE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return HAS_DELIVERY; });
/* unused harmony export WAITING_CLIENT */
/* unused harmony export WAITING_ADMIN */
/* unused harmony export WAITING_PROVIDER */
/* unused harmony export MASK_WAITING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return UNCONFIRMED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return WAITING_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCEPTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ASSIGNED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return RUNNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return TARGET_REACHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FLAG_WORKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return COMPLETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return POST_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BEING_PREPARED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PREPARED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return READY_TO_COLLECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return COLLECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return EXPIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PENDING; });
/* unused harmony export ACCEPTED_PENDING */
/* unused harmony export ACCEPTED_SCHEDULED */
/* unused harmony export ASSIGNED_PENDING */
/* unused harmony export ASSIGNED_SCHEDULED */
/* unused harmony export QUEUED_PENDING */
/* unused harmony export QUEUED_SCHEDULED */
/* unused harmony export UNCONFIRMED_PENDING */
/* unused harmony export UNCONFIRMED_SCHEDULED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADMIN_HIGH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADMIN_LOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADMIN_OWNER; });
/* unused harmony export CLIENT */
/* unused harmony export PROVIDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SUPER_ADMIN; });
/* unused harmony export GOODS_TYPE_FLAG */
/* unused harmony export SERVICE_TYPE_FLAG */
/* unused harmony export PROPERTY_OPTION_SUBMASK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return PROPERTY_TYPE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return PROPERTY_TYPE_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return PROPERTY_TYPE_TEXT; });
/* unused harmony export VALUE_STATUS_CANCELLED_BY_CLIENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return MASK_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return VALUE_TYPE_PAYPAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return VALUE_TYPE_STRIPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return VALUE_TYPE_INSTAPAGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return MASK_AGENT; });
/* unused harmony export IS_SERVICE_PROVIDER */
/* unused harmony export IS_GOOD_DELIVERER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return VALUE_TYPE_ZELLE; });
/* unused harmony export VALUE_TYPE_EFECTIVO */
/* unused harmony export VALUE_TYPE_MANUAL */
/* unused harmony export TYPE_CUSTOM */
/* Orders */var TYPE_SERVICES=0x1;var CUSTOM_PICKUP=0x2;var MASK_SERVICE_TYPE=0x7;var HAS_DELIVERY=0x08;var WAITING_CLIENT=0x10;var WAITING_ADMIN=0x20;var WAITING_PROVIDER=0x40;var MASK_WAITING=0x070;var PENDING=0x080;var UNCONFIRMED=0x100;var WAITING_PAYMENT=0x200;var ACCEPTED=0x400;var ASSIGNED=0x800;var RUNNING=0x1000;var TARGET_REACHED=0x2000;var FLAG_WORKING=0x4000;var TYPE_CUSTOM=0x0010;var COMPLETED=0x08000;//const TARGET_REACHED = 8192;
var CANCELLED=0x18000;var POST_PAYMENT=0x100000;var BEING_PREPARED=0x0200000;//new
var PREPARED=0x0400000;//new
var READY_TO_COLLECT=0x800000;var COLLECTED=0x1000000;var EXPIRED=0x2000000;var ACCEPTED_PENDING=1152;var ACCEPTED_SCHEDULED=1024;var ASSIGNED_PENDING=2176;var ASSIGNED_SCHEDULED=2048;var QUEUED_PENDING=640;var QUEUED_SCHEDULED=512;var UNCONFIRMED_PENDING=384;var UNCONFIRMED_SCHEDULED=25;//const WAITING_PAYMENT = 512/*16*/;
/* ACCOUNT */var ADMIN_HIGH=119;var ADMIN_LOW=112;var ADMIN_OWNER=127;var CLIENT=0;var PROVIDER=15;var SUPER_ADMIN=255;/* GOODS */var GOODS_TYPE_FLAG=0;var SERVICE_TYPE_FLAG=1;/* PROPERTIES */var PROPERTY_OPTION_SUBMASK=4095;var PROPERTY_TYPE_OPTIONS=256;var PROPERTY_TYPE_RANGE=512;var PROPERTY_TYPE_TEXT=1024;/* PAYMENT */var VALUE_STATUS_CANCELLED_BY_CLIENT=10;var MASK_STATUS=15;var VALUE_TYPE_PAYPAL=32;var VALUE_TYPE_STRIPE=64;var VALUE_TYPE_INSTAPAGO=128;var VALUE_TYPE_ZELLE=0x0100;var VALUE_TYPE_MANUAL=0x010;var VALUE_TYPE_EFECTIVO=0x200;var MASK_AGENT=65520;var PAYMENT_REGISTERED=0x100400;// el pago ya sea por efectivo o no, fue validado por los admins de dondemand
var VALUE_TYPE_BDV=0x1000;var VALUE_TYPE_BALANCE=0x0800;//digase saldo
/* PROVIDERS */var IS_SERVICE_PROVIDER=256;var IS_GOOD_DELIVERER=512;var IS_DIGITAL=4;

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAccounts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return socketInitialization; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return toggleOnlineStatusApiCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeUserDefaultLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return confirmRegister; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return validateRegister; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return invalidateRegister; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return scheduleTokenRenewal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setupTokenRenewal; });
/* unused harmony export fetchUser */
/* unused harmony export fetchUsers */
/* unused harmony export fetchUserApps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return toggleData; });
/* unused harmony export updateUser */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return forgotPasword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return recoverPasword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return socketteInit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_general__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UtilsOperation__ = __webpack_require__(9);
var _this=this;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}// var pubnub;
/* session utilities */var setupTokenRenewal=function setupTokenRenewal(){localStorage.setItem('expires_in',localStorage.getItem('tokenExpirationInSeconds')*1000+Date.now()-600000);//240000 );
__WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].defaults.headers.common['Authorization']='Bearer '+localStorage.getItem('token')||'';scheduleTokenRenewal();};var tokenRenewalTimeout=void 0;var scheduleTokenRenewal=function scheduleTokenRenewal(){var expiresIn=JSON.parse(localStorage.getItem('expires_in'));var delay=expiresIn-Date.now();if(delay>0){// if has expired (with an interval of 3 days -259200000-)
tokenRenewalTimeout=setTimeout(function(){renewToken();},delay);}else{renewToken();}};/* lang utilities */var loadJsonLang=function loadJsonLang(code){return new Promise(function(resolve,reject){resolve(__webpack_require__(118)("./"+code+'.json'));//reject(Notification.show({type: "error", title:"Error al inicializar app", msg:"Error: Archivo de idiomas no encontrado." /> ) );
});};var changeUserDefaultLanguage=function changeUserDefaultLanguage(code){return function(dispatch){dispatch({type:"WAIT_FOR_RESPONSE"});return loadJsonLang(code).then(function(response){localStorage.setItem('lang_code',code);dispatch({type:"SET_USER_DEFAULT_LANGUAGE",lang_code:code,json_lang:response});});};};/* xPENSAR: esto sale en el login pero no se si lo usa internamente coreui o se puede borrar */var setValues=function setValues(target){return function(dispatch){dispatch({type:'SET_VALUES',target:target});};};/* Login related */var logout=function logout(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */].replace('companies','logout').slice(0,-1)).then(function(res){clearTimeout(tokenRenewalTimeout);clearTimeout(pubnubTokenRenewalTimeout);localStorage.clear();window.location.reload();/* navigator.serviceWorker.getRegistrations().then(function (registrations) {  /// elimina el service worker
                registrations.forEach(function (reg) {
                    reg.unregister();
                });
            }); */}).catch(function(err){/*
                // si me da error la petición yo debería poder cerrar sesión aunque sea en local?
                // y si perdí la conexión y no pudo llegar al endpoint del api?

                dispatch({
                    type: 'NOTIFICATION',
                    notification: err
                })
            */clearTimeout(tokenRenewalTimeout);clearTimeout(pubnubTokenRenewalTimeout);localStorage.clear();});};};var login=function login(data){return function(dispatch,getState){var _getState=getState(),company=_getState.company,json_lang=_getState.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});data.type='admin';return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/login-native',data).then(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res){var userHigherAccess,branchGroups,userCompany,userBranches,branch,_userBranches;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(res.data.accesses.length){_context.next=5;break;}// si no tiene ningun acceso asociado, le digo que busque ayuda
__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Su usuario no ha recibido privilegios',msg:'Para entrar a este panel administrativo, por favor comun\xEDquese con alg\xFAn usuario administrativo que le otorgue acceso'});dispatch({type:'LOGIN_ERROR',loginError:true,adminWithoutAccess:true});_context.next=31;break;case 5:res.data.accesses=res.data.accesses.filter(function(a){return a.related_access;});//const auth_host = `${URL + company.id}/socket-auth`;
localStorage.setItem('user',JSON.stringify(res.data));localStorage.setItem('token',res.data.access_token.access_token);localStorage.setItem('userIsOnline',true);localStorage.setItem('tokenExpirationInSeconds',res.data.access_token.expires_in);userHigherAccess=__WEBPACK_IMPORTED_MODULE_5__constants_general__["e" /* BRANCH_ACCESS */];// por defecto es un branch admin, le llamaremos nivel 1
branchGroups=res.data.accesses.filter(function(e){return e.access_type==="branch_group";});userCompany=res.data.accesses.filter(function(e){return e.access_type==="company";});if(branchGroups.length>0)userHigherAccess=__WEBPACK_IMPORTED_MODULE_5__constants_general__["f" /* BRANCH_GROUPS_ACCESS */];// si tiene acceso de tipo group, le llamaremos nivel 2
if(userCompany.length>0)userHigherAccess=__WEBPACK_IMPORTED_MODULE_5__constants_general__["h" /* COMPANY_ACCESS */];// si tiene acceso de tipo company, le llamaremos nivel 3
localStorage.setItem('userHigherAccess',userHigherAccess);console.log("branchGroups",JSON.stringify(branchGroups.length>0&&branchGroups[0]&&branchGroups[0].related_access));if(!(userHigherAccess===__WEBPACK_IMPORTED_MODULE_5__constants_general__["e" /* BRANCH_ACCESS */])){_context.next=30;break;}userBranches=res.data.accesses.filter(function(e){return e.access_type==="branch";});if(!(userBranches.length===1)){_context.next=27;break;}_context.next=22;return res.data.accesses[0].related_access;case 22:branch=_context.sent;localStorage.setItem('activeBranch',JSON.stringify(branch));/*
							const created_at = res.data.created_at;
							const updated_at = res.data.updated_at;

							if (created_at === updated_at) {
								window.location.href = '/settings'
							} else {
								window.location.href = '/dashboard'
							}*/if(res.data.admin_type){window.location.href='/'+res.data.admin_type.default_key;}else{window.location.href='/order-management';}_context.next=28;break;case 27:// si administras muchas listas de sucursales te muestro el listado de branchGroups y luego eliges cual branch especificamente
dispatch({type:'LOGIN',user:res.data,userHigherAccess:userHigherAccess,branches:userBranches});case 28:_context.next=31;break;case 30:if(userHigherAccess===__WEBPACK_IMPORTED_MODULE_5__constants_general__["f" /* BRANCH_GROUPS_ACCESS */]){// si ademas de el acceso al branch tengo acceso al grupo, debo buscar cual es el access del branch
_userBranches=res.data.accesses.filter(function(e){return e.access_type==="branch";});// si tengo un solo branch group y un solo branch lo logueo y ya
if(_userBranches.length===1&&branchGroups.length===1){localStorage.setItem('activeBranchGroup',JSON.stringify(branchGroups.length&&branchGroups[0]&&branchGroups[0].related_access));localStorage.setItem('activeBranch',JSON.stringify(_userBranches.length&&_userBranches[0]&&_userBranches[0].related_access));/*if (created_at === updated_at) {
								window.location.href = '/settings'
							} else {
								window.location.href = '/dashboard'
							}*/if(res.data.admin_type){window.location.href='/'+res.data.admin_type.default_key;}else{window.location.href='/order-management';}}// si tengo varios le paso la lista y que el elija
else{if(branchGroups.length===1){// si admdinistras muchas branchs pero en un solo branchGroup, solo te paso la lista de branches
localStorage.setItem('activeBranchGroup',JSON.stringify(_userBranches.length&&_userBranches[0]&&branchGroups[0].related_access));dispatch({type:'LOGIN',user:res.data,userHigherAccess:userHigherAccess,branches:_userBranches});}else{// si administras muchas listas de sucursales te muestro el listado de branchGroups y luego eliges cual branch especificamente
dispatch({type:'LOGIN',user:res.data,userHigherAccess:userHigherAccess,branchGroups:branchGroups});/*<-------- */dispatch({type:'LOGIN',user:res.data,userHigherAccess:userHigherAccess,branches:_userBranches});}}}else if(userHigherAccess===__WEBPACK_IMPORTED_MODULE_5__constants_general__["h" /* COMPANY_ACCESS */]){//const userBranches = res.data.accesses.filter(e => e.access_type === "branch");
if(res.data.admin_type){window.location.href='/'+res.data.admin_type.default_key;}else{if(res.data&&res.data.admin_type&&res.data.admin_type.id===3||res.data&&res.data.admin_type&&res.data.admin_type.id===9||res.data&&res.data.admin_type&&res.data.admin_type.id===10){window.location.href='/reports';}else if(res.data&&res.data.session&&res.data.session.account&&res.data.session.account.type===112||res.data&&res.data.admin_type&&res.data.admin_type.id===8||res.data&&res.data.admin_type&&res.data.admin_type.id===6||res.data&&res.data.admin_type&&res.data.admin_type.id===7||res.data&&res.data.admin_type&&res.data.admin_type.id===4||res.data&&res.data.admin_type&&res.data.admin_type.id===5){window.location.href='/order-management';}else{window.location.href='/dashboard';}}}case 31:case'end':return _context.stop();}}},_callee,_this);}));return function(_x){return _ref.apply(this,arguments);};}()).catch(function(err){/*dispatch({
					type: 'LOGIN_ERROR',
					loginError: true
				})*/console.log('err',err);if(err&&err.message){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:json_lang.errors[err.data&&err.data.message]});}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:json_lang.errors.token_not_provided_des});}});};};var renewToken=function renewToken(){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */].replace('companies','token-refresh').slice(0,-1)).then(function(res){localStorage.setItem('token',res.data&&res.data.access_token);localStorage.setItem('tokenExpirationInSeconds',res.data.expires_in);setupTokenRenewal();}).catch(function(err){console.log("renewToken",err);__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:"",msg:"Disculpe, hubo un error en el manejo de su sesión"});/* Notification.show({
				  type: "error",
				  title: "Error al iniciar sesión",
				  msg: "Disculpe, hubo un error en el manejo de su sesión"
                }); *///if (err.data.error === "token_invalid"){
//localStorage.clear();
//window.location.reload();
//}
//setTimeout(() => , 5000);  // manejar su conectividad?
});};var socketteInit=function socketteInit(company_id,callback){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company_id+'/socket-auth').then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res){var _store$getState,session,company,userHigherAccess,allowedChannels,_allowedChannels;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_store$getState=__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState(),session=_store$getState.session,company=_store$getState.company,userHigherAccess=_store$getState.userHigherAccess;allowedChannels=[];if(session&&session.account_id&&company&&company.id){allowedChannels=['private-'+session.account_id];if(userHigherAccess===__WEBPACK_IMPORTED_MODULE_5__constants_general__["h" /* COMPANY_ACCESS */]){(_allowedChannels=allowedChannels).push.apply(_allowedChannels,['group-'+company.id+'-admins']);}else if(userHigherAccess===__WEBPACK_IMPORTED_MODULE_5__constants_general__["f" /* BRANCH_GROUPS_ACCESS */]){session.accesses.forEach(function(access){if(access.access_type==="branch"){allowedChannels.push('branch-'+access.access_id+'-admins');}else if(access.access_type==="branch_group"){allowedChannels.push('branch-group-'+access.access_id+'-admins');}});}else if(userHigherAccess===__WEBPACK_IMPORTED_MODULE_5__constants_general__["e" /* BRANCH_ACCESS */]){session.accesses.forEach(function(access){if(access.access_type==="branch"){allowedChannels.push('branch-'+access.access_id+'-admins');}});}}window.socketteAuth(res.data.auth_key,res.data.uid,allowedChannels,callback,"DEV".toUpperCase()==="DEV"||"DEV".toUpperCase()==="DEVELOP"||"DEV".toUpperCase()==="LOCAL");case 4:case'end':return _context2.stop();}}},_callee2,_this);}));return function(_x2){return _ref2.apply(this,arguments);};}()).catch(function(e){return console.log(e);});};/* Pubnub notification related */var socketInitialization=function socketInitialization(){/*let sockette = Sockette({
        isDebug: true,
        authKey: localStorage.getItem("pubnub_auth_key"),
        uid: "user1",
      });*//*pubnub = new PubNubReact({
		publishKey: localStorage.getItem("pubnub_publish_key"),
		subscribeKey: localStorage.getItem("pubnub_subscribe_key"),
		authKey: localStorage.getItem("pubnub_auth_key")
	});
	schedulePubnubTokenRenewal();

	return pubnub;
    //return sockette;*/};var setupPubnubTokenRenewal=function setupPubnubTokenRenewal(company_id){// TODO: si se modifica aqui, haz cambios tambien dentro de la funcion login.. en algunos casos el llamado anidado se salta el guardado de los tokens,
// pero la de login no requiere el llamado de la funcion schedulePubnubTokenRenewal, xq al recargar la ventana
// necesita reiniciar el contador de peticion de token
return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company_id+'/socket-auth').then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:console.log("setupPubnubTokenRenewal ---->",setupPubnubTokenRenewal);localStorage.setItem("pubnub_auth_key",res.data.auth_key);localStorage.setItem("pubnub_publish_key",res.data.publishKey);localStorage.setItem("pubnub_subscribe_key",res.data.subscribeKey);localStorage.setItem("pubnub_expires_in",res.data.expires_in*1000+Date.now()-60000);// un minuto antes de que expire el token
_context3.next=7;return schedulePubnubTokenRenewal();case 7:case'end':return _context3.stop();}}},_callee3,_this);}));return function(_x3){return _ref3.apply(this,arguments);};}()).catch(function(e){return console.log(e);});};var pubnubTokenRenewalTimeout=void 0;var schedulePubnubTokenRenewal=function schedulePubnubTokenRenewal(){}/*const expiresIn = JSON.parse(localStorage.getItem('pubnub_expires_in'));
	const delay = expiresIn - Date.now();
	const companyId = localStorage.getItem('companyId');*//* User related */;var fetchUsers=function fetchUsers(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().company.id+'/admins').then(function(res){dispatch({type:'FETCH_USERS',users:res.data.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.custom_errors.retrieving_user_list});});};};var fetchUser=function fetchUser(id){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+'/users/'+id).then(function(res){dispatch({type:'FETCH_USER',user:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.custom_errors.retrieving_user_data});});};};var fetchUserApps=function fetchUserApps(id){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+'/users/'+id+'/apps').then(function(res){dispatch({type:'FETCH_USER_APPS',apps:res.data});}).catch(function(err){if(err.message)__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:err.message});});};};var updateUser=function updateUser(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].put(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+'/users/'+__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().user.id,__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().user).then(function(res){dispatch({type:'FETCH_USER',user:res.data.user});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.custom_errors.user_update_failed});});};};///////////////////////////////////////////////////////////////////////////////
var find=function find(id,token){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["d" /* URLsmall */]+'accounts/'+id+'?token='+token).then(function(res){var newdata={};if(res.data.admin){newdata={admin:true,name:res.data.admin.name,display_name:res.data.admin.display_name,email:res.data.admin.email,avatar_url:res.data.admin.avatar_url,phone:res.data.admin.phone,password:"",password_confirm:"",token:token,company_id:res.data.company_id,type_name:res.data.type_name};}else if(res.data.provider){newdata={provider:true,is_deliverer:res.data.provider.is_deliverer,is_shopper:res.data.provider.is_shopper,name:res.data.provider.name,display_name:res.data.provider.display_name,email:res.data.provider.email,avatar_url:res.data.provider.avatar_url,phone:res.data.provider.phone,password:"",password_confirm:"",token:token,company_id:res.data.company_id,type_name:res.data.type_name};}else if(res.data.client){newdata={client:true,name:res.data.client.name,display_name:res.data.client.display_name,email:res.data.client.email,avatar_url:res.data.client.avatar_url,phone:res.data.client.phone,token:token,company_id:res.data.company_id,type_name:res.data.type_name};}dispatch({type:'FETCH_ACCOUNT',account:newdata});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"warning",title:'Token invalido',msg:'Favor solicitar reenviar uno nuevo por correo',autoC:false,config:{autoClose:false}});/*if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title: err.title, msg: err.message});
            else{
                error.message="Email usado o confirmado"
                Notification.show({type: "error", title: err.title, msg: store.getState().json_lang.custom_errors.retrieving_user_data });
            }*/});};};var toggleData=function toggleData(value,type){return function(dispatch){var data=Object.assign({},__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().account);data[value.name]=value.data;dispatch({type:'FETCH_ACCOUNT',account:data});};};var toggleOnlineStatusApiCall=function toggleOnlineStatusApiCall(status){var status_url=status?"/set-online":"/set-offline";__WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().company.id+"/admins/"+__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().session.id+status_url).then(function(res){localStorage.setItem('userIsOnline',status);__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch({type:"STATUS_ONLINE",userIsOnline:status});}).catch(function(err){console.log("error");});};var confirmRegister=function confirmRegister(data){return function(dispatch,getState){var _getState2=getState(),dropzoneFiles=_getState2.dropzoneFiles;dispatch({type:"WAIT_FOR_RESPONSE"});if(data.password!==data.password_confirm&&data.password.length>5&&data.password_confirm.length>5){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:"",msg:"Las contraseñas deben coincidir y poseer al menos 5 caracteres"});}else{var account=new FormData();account.append('display_name',data.display_name);account.append('email',data.email);account.append('name',data.name);account.append('phone',data.phone);account.append('password',data.password);account.append('token',data.token);if(dropzoneFiles.length){var block=dropzoneFiles.split(";");var contentType=block[0].split(":")[1];var realData=block[1].split(",")[1];var blob=Object(__WEBPACK_IMPORTED_MODULE_6__UtilsOperation__["c" /* b64toBlob */])(realData,contentType);account.append('avatar',blob);}else if(data.avatar_url&&data.avatar_url!==null){account.append('avatar_url',data.avatar_url);}if(data.provider){var newPayoutData=[];if(data.payout_accounts.bank_name){newPayoutData=[{bank_name:data.payout_accounts.bank_name,document:''+data.payout_accounts.document_prefix+data.payout_accounts.document,account:data.payout_accounts.account,name:data.payout_accounts.name,email:data.payout_accounts.email||'',type:"national_bank_account"}];}else if(data.payout_accounts.bank_code){newPayoutData=[{bank_code:data.payout_accounts.bank_code,document:''+data.payout_accounts.document_prefix+data.payout_accounts.document,phone:''+data.payout_accounts.phone_prefix+data.payout_accounts.phone,type:"mobile_payment"}];}account={display_name:data.display_name,email:data.email,name:data.name,phone:data.phone,password:data.password,token:data.token,payload:{data:{brand:data.brand,model:data.model,color:data.color,plate:data.plate,year:data.year},service_type:Number(data.service_type),vehicle_type:Number(data.vehicle_type),payout_accounts:newPayoutData}};}return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["d" /* URLsmall */]+'confirm/'+data.company_id+'?type='+data.type_name,account).then(function(res){dispatch({type:'REGISTER',user:res.data.user});if(data.provider===true){window.location.href='/confirmed';}else if(data.client===true){window.location.href='/confirmed-client';}else{//window.location.href = '/confirmed-client'
window.location.href=window.location.origin;}}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err.message)__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:err.message});});}};};var invalidateRegister=function invalidateRegister(data){data={email:data.email,token:data.token};return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["d" /* URLsmall */]+'invalidate/'+__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().company.id,data).then(function(res){}).catch(function(err){if(err.message)__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:err.message});});};};var validateRegister=function validateRegister(data){var newdata={email:data.email,token:data.token};return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["d" /* URLsmall */]+'validate/'+data.company_id+'?type=client',newdata).then(function(res){window.location.href='/confirmed-client';}).catch(function(err){if(err.message)__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:err.message});});};};var forgotPasword=function forgotPasword(email,type){var showNotification=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+getState().company.id+'/forgot-password/'+email+'?type='+type).then(function(res){var succesful=getState().json_lang.common.success;if(showNotification)__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:getState().json_lang.custom_success.email_sent});dispatch({type:'UPDATE_PROVIDER_SUCCESS',providers:getState().providers,provider:getState().provider,preloader:false});}).catch(function(err){/*if(err.message)*/__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:"El e-mail no fue encontrado"});});};};var recoverPasword=function recoverPasword(type){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var account={email:getState().account.email,password:getState().account.password,token:getState().account.token};return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["d" /* URLsmall */]+'recover/'+getState().account.company_id+'?type='+type,account).then(function(res){window.location.href='/confirmed-client';}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:"No se pudo procesar correctamente su solicitud"});});};};var getAccount=function getAccount(id){return function(dispatch,getState){var _getState3=getState(),company=_getState3.company,json_lang=_getState3.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/accounts/'+id).then(function(res){dispatch({type:'FETCH_ACCOUNT',account:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:err.message&&err.message!=='generic'?err.message:json_lang.custom_errors.user_restore_failed});});};};var getAccounts=function getAccounts(query){return function(dispatch,getState){var _getState4=getState(),company=_getState4.company,json_lang=_getState4.json_lang,session=_getState4.session;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/accounts?search='+query).then(function(res){var filteredData=res.data.data.filter(function(user){return user.id!==session.account_id;});dispatch({type:'FETCH_ACCOUNTS',accounts:Object.assign({},res.data,{data:[].concat(_toConsumableArray(filteredData))})});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:err.message&&err.message!=='generic'?err.message:json_lang.custom_errors.user_restore_failed});});};};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(204);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.2';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)(module)))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var IE8_DOM_DEFINE = __webpack_require__(147);
var toPrimitive = __webpack_require__(69);
var dP = Object.defineProperty;

exports.f = __webpack_require__(15) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(68);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return findReference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return applyPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return clearPaymentReference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return updateGeneralInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return clearInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return getProvidersBalanceMovements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GetInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return conciliateGeneralInvoices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return setPaidGeneralInvoices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return payGeneralInvoices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return retryPaymentInvoices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return editGeneralInvoices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return deleteGeneralInvoices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return getBalanceMovementBetween; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return getBalanceMovementBetweenLot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return resetBalance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return toogleBalance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return getBalanceMovements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return getBalanceDebt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return setBalanceMovements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return setBalanceMovementBetween; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return setBalanceMovementBetweenLot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return toggleDataCompanyFeeds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return editCompanyCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return currencySetMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return deleteCompanyCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return createCompanyCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return toogleCompanyCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return clearCompanyCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return getCompanyCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return getCompanyCurrencies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return apiReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return apiReportHistories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return updateReportHistories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return deleteCompanyVehicles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return toggleVehicleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return createCompanyVehicles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return getCompanyDeliveryFees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return getCompanyVehicles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return getCompanyPaymentMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return clearSubcategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return editSubcaractegory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return getGeneralInvoices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return deleteSubcaractegory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return updateCompanyInformation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UnAttachCategoryToBranchs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AttachtCategoryToBranchs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return getBranchsCompanyArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GetbranchCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return clearBranchCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return deleteBranchCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return addBranchCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return toggleDataCompanyCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return editBranchCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return findBranchCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return getBranchsCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return updateMultiProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return updateCompanyClientBg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return show; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return toggleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return update; });
/* unused harmony export logout */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return findCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return changeCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return fetchCompanies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return fetchTOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return toggleTOSData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return toggleDataSubCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return fetchCompanySettings; });
/* unused harmony export toggleSettingsData */
/* unused harmony export updateSettings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return addSubcaractegory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return updateCompanyDeliveryDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return updateCompanyTOS; });
/* unused harmony export toggleGeoData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return getWorkSchedule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return storeWorkSchedule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return deleteWorkSchedule; });
/* unused harmony export getCompanyHolidays */
/* unused harmony export storeCompanyHolidays */
/* unused harmony export getAppMovilStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return updateCompanyFooter; });
/* unused harmony export email_footerChange */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return companyAdjustCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return getPaymentMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return getPaymentMethodsForms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return togglePaymentMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return storePaymentMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return destroyPaymentMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return pendingActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return deletePendingAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return confirmPendingAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return updatePendingActionFromNotification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return getBuilderPackages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return updateStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return setCompanyCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return removeCompanyCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return storeDataWorkSchedule; });
/* unused harmony export updateSesionCompany */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return updateCompanyContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return updateCompanyComerci; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return updateDeliverySettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return updateCompanyDeliveryFeeSteps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return showSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return deleteCompanyDeliveryFeeSteps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return addCompanyDeliveryFeeSteps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return deleteCompanyServiceApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return addCompanyServiceApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return updateCompanyAssignableOrdersMask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return fetchCompanyGeofences; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return getGeneralProviderInvoices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return getCompanyGeneralInvoices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return getClientBalanceMovements; });
/* unused harmony export getClientBalanceMovement */
/* unused harmony export clearBalanceMovement */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return getClientTemporalBalanceMovements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return fetchCompanyCountriesCities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return fetchCompanyCities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return updateCompanyCities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return updateCompanyPaymentGeneralConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return updateCompanyContactPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return deleteCompanyCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return getCompanyServiceCharges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return setServiceCharge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return pathServiceCharge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return deleteServiceCharge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return deleteCompanyGeneralInvoices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return payCompanyGeneralInvoices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return sendTwoStepsVerification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return setBalanceModifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_data_currenciesList_en_json__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_data_currenciesList_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_data_currenciesList_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UtilsOperation__ = __webpack_require__(9);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}//import { renderSync } from 'node-sass';
/*function saveCompanySettings(companyId, data) {
	return axios.patch(`${URL+companyId}/settings`, data)
}

function saveCompanyData(companyId, data) {
	return axios.patch(URL + companyId, data)
}*///##################################################3
var fetchCompanyCountriesCities=function fetchCompanyCountriesCities(){return function(dispatch,getState){var _getState=getState(),company=_getState.company,json_lang=_getState.json_lang;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/countries?with=cities&limit=0').then(function(res){dispatch({type:'FETCH_COMPANY_COUNTRIES',companyCountriesCities:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:json_lang.custom_errors.retrieving_user_list});});};};var fetchCompanyCities=function fetchCompanyCities(){return function(dispatch,getState){var _getState2=getState(),company=_getState2.company,json_lang=_getState2.json_lang;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/cities?limit=0').then(function(res){dispatch({type:'FETCH_COMPANY_CITIES',companyCities:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:json_lang.custom_errors.retrieving_user_list});});};};var updateCompanyCities=function updateCompanyCities(city){return function(dispatch,getState){var _getState3=getState(),company=_getState3.company,json_lang=_getState3.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/cities/'+city.id,city).then(function(){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});dispatch({type:'FETCH_COMPANY_CITIES',companyCities:city});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:json_lang.custom_errors.retrieving_user_list});});};};var deleteCompanyCity=function deleteCompanyCity(id){return function(dispatch,getState){var _getState4=getState(),company=_getState4.company,json_lang=_getState4.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/cities/'+id).then(function(){dispatch({type:'RESPONSE',response:true});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){dispatch({type:'RESPONSE',response:false});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:'Ocurrió un error al querer eliminar la ciudad.'});});};};var fetchCompanyGeofences=function fetchCompanyGeofences(){return function(dispatch,getState){var _getState5=getState(),company=_getState5.company,json_lang=_getState5.json_lang;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branch-geofences?limit=0').then(function(res){dispatch({type:'COMPANY_GEOFENCES',companyGeoFences:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:json_lang.custom_errors.retrieving_user_list});});};};var show=function show(){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'?with=currencies').then(function(res){dispatch({type:'COMPANY_PROFILE',company:res.data,initCompany:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_company});}});};};var showSettings=function showSettings(){return function(dispatch,getState){var _getState6=getState(),company=_getState6.company;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/settings').then(function(res){var update=company;update.settings=res.data;/* let estee = []
            if(update.settings.service_app_modifiers && update.settings.service_app_modifiers.length >0){
                estee= update.settings.service_app_modifiers.map( (service_app_modifier,key) => {
                    service_app_modifier.client_fee_e2 = service_app_modifier.client_fee_e2 > 0 ? parseFloat(FloatPrecision(service_app_modifier.client_fee_e2/100)) : 0
                    service_app_modifier.order_fee_e2 = service_app_modifier.order_fee_e2 > 0 ? parseFloat(FloatPrecision(service_app_modifier.order_fee_e2/100)) : 0
                    service_app_modifier.price_max_e2 = service_app_modifier.price_max_e2 > 0 ? parseFloat(FloatPrecision(service_app_modifier.price_max_e2/100)) : 0
                    service_app_modifier.price_min_e2 = service_app_modifier.price_min_e2 > 0 ? parseFloat(FloatPrecision(service_app_modifier.price_min_e2/100)) : 0
                    return service_app_modifier
                })
            } */dispatch({type:'COMPANY_PROFILE',company:update,initCompany:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_company});}});};};var findCompany=function findCompany(id){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+id).then(function(res){dispatch({type:'COMPANY_PROFILE',company:Object.assign({},res.data)});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_company});}});};};var changeCompany=function changeCompany(id){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+id).then(function(res){dispatch({type:'COMPANY_PROFILE',company:res.data});var customEmailFooter=res.data.custom_json&&res.data.custom_json.mail_footer?res.data.custom_json.mail_footer:'';dispatch({type:'COMPANY_INITIALIZATION',company:res.data,lang_code:localStorage.getItem('lang_code')||res.data.default_iso_lang,company_styles_json:res.data.styles_json.styles,currency:res.data.currency,// TODO: esto no viene de aqui,
customEmailFooter:customEmailFooter});localStorage.setItem("companyId",res.data.id);}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().json_lang.custom_errors.retrieving_company});}});};};var fetchCompanies=function fetchCompanies(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return function(dispatch){var url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */].slice(0,-1);return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(url_host+"?page="+page).then(function(res){dispatch({type:'FETCH_COMPANIES',companies:res.data.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().json_lang.custom_errors.retrieving_company});}});};};var setCompanyCurrency=function setCompanyCurrency(iso,factor){return function(dispatch,getState){var findIso=__WEBPACK_IMPORTED_MODULE_4__assets_data_currenciesList_en_json___default.a.findIndex(function(item){return item.value===iso;});var newCurrency={symbol:__WEBPACK_IMPORTED_MODULE_4__assets_data_currenciesList_en_json___default.a[findIso].symbol,conversion_factor:factor};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].put(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/currencies/'+iso,newCurrency).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});dispatch({type:'COMPANY_PROFILE',company:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_company});}});};};var removeCompanyCurrency=function removeCompanyCurrency(iso){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/currencies/'+iso).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});dispatch({type:'COMPANY_PROFILE',company:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_company});}});};};var email_footerChange=function email_footerChange(input){return function(dispatch,getState){var data=Object.assign({},getState().customEmailFooter);data=input.value;dispatch({type:'CUSTOM_EMAIL_FOOTER',customEmailFooter:data});};};var toggleData=function toggleData(value){return function(dispatch,getState){var data=Object.assign({},getState().company);var settingsX=value.name.split('_setting');var settingsY=value.name.split('_service_app');var option=value.name.split("-");if(value.name==='currency_iso'){data.local_currency={iso:value.data,symbol:Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["s" /* moneySymbol */])(value.data)};}else if(option.length>1){var mValue=parseInt(value.data,10);if((mValue&768)!==0){//alternar donde se coincinde los pick ups o delivery para q almenos uno este selectionados
data.options&=~(768^mValue);mValue|=256;}if((mValue&768<<12)!==0){//alternar donde se coincinde los pick ups o delivery para q almenos uno este selectionados
data.options&=~(768<<12^mValue);mValue|=256<<12;}data.options^=mValue;}else if(value.name.split("conversion_factor").length>1){data.currencies[parseInt(value.name.split("conversion_factor")[1],10)].conversion_factor=value.data;}else if(value.name==='decimals_count'||value.name==='slogan'/*|| value.name === 'delivery_fee_e2'*/){data.custom_json[value.name]=value.data;}else if(value.name==='in_service2'){data.in_service=!data.in_service;data.in_service2=1;}else if(value.name==='color_accent'){console.log('color_accent',value.data);data.styles_json.styles.color_accent=value.data;data.styles_json.styles.color_primary=value.data;}else if(value.name==='nearby_providers_distance'||value.name==='subcategories_count'||value.name==='contact_phone_whatsapp'||value.name==='assignable_orders_mask'||value.name==='human_delivery_discount_prc'||value.name==='human_delivery_providers_prc'||value.name==='human_delivery_fee_e2'||value.name==='contact_phone'||value.name==='uid'||value.name==='branch_invoice_tax_name'||value.name==='auto_assign_delay_minutes'||value.name==='auto_assign_bid_count'||value.name==='auto_assign_bid_attempts'||value.name==='branch_invoice_tax_prc'){data.settings[value.name]=value.data;}else if(value.name==='disable_balance'||value.name==='pay_in_store'||value.name==='auto_assign_prepared_mode'||value.name==='disable_reports'){console.log(value.name,value.checked);data.settings[value.name]=value.checked;}else if(settingsX&&settingsX.length>1){console.log("settingsX",settingsX[0]);data.settings.delivery_fee_steps[settingsX[1]][settingsX[0]]=settingsX[0]==="is_additional"?value.checked:value.data;}else if(settingsY&&settingsY.length>1){data.settings.service_app_modifiers[settingsY[1]][settingsY[0]]=value.data;}else{data[value.name]=value.data;}dispatch({type:'COMPANY_UPDATE',company:data,initCompany:getState().initCompany});};};var toggleDataCompanyFeeds=function toggleDataCompanyFeeds(value){return function(dispatch,getState){var data=[].concat(_toConsumableArray(getState().companyDeliveryFeeds));var settingsX=value.name.split('_setting');data[settingsX[1]][settingsX[0]]=settingsX[0]==="is_additional"?value.checked:value.data;dispatch({type:'FETCH_COMPANY_DELYVERY_FEEDS',companyDeliveryFeeds:data});};};var toggleGeoData=function toggleGeoData(value){return function(dispatch){var data=Object.assign({},__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().company);data.longitude_e6=value.longitude_e6;data.latitude_e6=value.latitude_e6;dispatch({type:'COMPANY_PROFILE',company:Object.assign({},data)});};};var update=function update(){return function(dispatch,getState){var _getState7=getState(),company=_getState7.company,initCompany=_getState7.initCompany;dispatch({type:"WAIT_FOR_RESPONSE"});var data={settings:{}};if(initCompany.local_currency!==company.local_currency){data.local_currency=company.local_currency;}if(initCompany.currency!==company.currency){data.currency=company.currency;// TODO=  esto no viene de aqui
}if(initCompany.currency_iso!==company.currency_iso){data.currency_iso=company.currency_iso;// TODO=  esto no viene de aqui
}if(initCompany.name!==company.name){data.name=company.name;}if(initCompany.address!==company.address){data.address=company.address;}if(initCompany.latitude_e6!==company.latitude_e6){data.latitude_e6=company.latitude_e6;}if(initCompany.latitude_e6!==company.latitude_e6){data.longitude_e6=company.longitude_e6;}if(initCompany.default_iso_lang!==company.default_iso_lang){data.default_iso_lang=company.default_iso_lang;}if(initCompany.in_service!==company.in_service){data.in_service=company.in_service&&company.in_service===true?1:0;}/* custom_json:{
            decimals_count:company.custom_json.decimals_count ? company.custom_json.decimals_count:undefined,
            uid:company.custom_json.uid ? company.custom_json.uid:undefined,
            slogan:company.custom_json.slogan ? company.custom_json.slogan:undefined,
            human_delivery_fee_e2: company.custom_json.human_delivery_fee_e2 ? company.custom_json.human_delivery_fee_e2 : undefined,
        } *//*if(initCompany.settings.contact_phone !== company.settings.in_service){
            data.settings.contact_phone= company.settings.contact_phone
        }*//* Promise.all([
        	saveCompanySettings(company.id, data.settings),
        	saveCompanyData(company.id, data)
		])
		.then(values => {
            company.in_service2 = undefined;

            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful} );
            dispatch({
                type: 'COMPANY_UPDATE',
                company: values[1].data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });*/};};var updateCompanyInformation=function updateCompanyInformation(){return function(dispatch,getState){var _getState8=getState(),company=_getState8.company,initCompany=_getState8.initCompany;var data={settings:{}};if(initCompany.name!==company.name){data.name=company.name;}if(initCompany.options!==company.options){data.options=company.options;}if(initCompany.default_iso_lang!==company.default_iso_lang){data.default_iso_lang=company.default_iso_lang;}if(initCompany.email!==company.email){data.email=company.email;}data.settings={uid:company.settings.uid};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/settings',data.settings).then(function(settingsRes){__WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(''+(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id),data).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});dispatch({type:'COMPANY_UPDATE',company:Object.assign({},res.data,{settings:settingsRes.data}),initCompany:Object.assign({},res.data,{settings:settingsRes.data})});});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var updateCompanyContact=function updateCompanyContact(){return function(dispatch,getState){var _getState9=getState(),company=_getState9.company;var settings={contact_phone:company.settings.contact_phone,contact_phone_whatsapp:company.settings.contact_phone_whatsapp,subcategories_count:company.settings.subcategories_count,nearby_providers_distance:company.settings.nearby_providers_distance,branch_invoice_tax_name:company.settings.branch_invoice_tax_name,branch_invoice_tax_prc:company.settings.branch_invoice_tax_prc,service_app_modifiers:company.settings.service_app_modifiers,disable_balance:company.settings.disable_balance,pay_in_store:company.settings.pay_in_store,disable_reports:company.settings.disable_reports,auto_assign_bid_count:company.settings.auto_assign_bid_count,auto_assign_bid_attempts:company.settings.auto_assign_bid_attempts,auto_assign_delay_minutes:company.settings.auto_assign_delay_minutes,auto_assign_prepared_mode:company.settings.auto_assign_prepared_mode};if(settings.service_app_modifiers&&settings.service_app_modifiers.length>0){settings.service_app_modifiers.map(function(service_app_modifier,key){service_app_modifier.client_fee_e2=service_app_modifier.client_fee_e2>0?parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(service_app_modifier.client_fee_e2*100)):0;service_app_modifier.order_fee_e2=service_app_modifier.order_fee_e2>0?parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(service_app_modifier.order_fee_e2*100)):0;service_app_modifier.price_max_e2=service_app_modifier.price_max_e2>0?parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(service_app_modifier.price_max_e2*100)):0;service_app_modifier.price_min_e2=service_app_modifier.price_min_e2>0?parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(service_app_modifier.price_min_e2*100)):0;if(service_app_modifier.price_min_e2>service_app_modifier.price_max_e2){return __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:service_app_modifier.name,msg:'El monto maximo no puede ser inferior al minimo'});}return service_app_modifier;});}dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/settings',settings).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});company.settings=res.data;var update=company;if(update.settings.service_app_modifiers&&update.settings.service_app_modifiers.length>0){update.settings.service_app_modifiers.map(function(service_app_modifier,key){service_app_modifier.client_fee_e2=service_app_modifier.client_fee_e2>0?parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(service_app_modifier.client_fee_e2/100)):0;service_app_modifier.order_fee_e2=service_app_modifier.order_fee_e2>0?parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(service_app_modifier.order_fee_e2/100)):0;service_app_modifier.price_max_e2=service_app_modifier.price_max_e2>0?parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(service_app_modifier.price_max_e2/100)):0;service_app_modifier.price_min_e2=service_app_modifier.price_min_e2>0?parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(service_app_modifier.price_min_e2/100)):0;return service_app_modifier;});}dispatch({type:'COMPANY_UPDATE',company:update,initCompany:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var updateCompanyContactPhone=function updateCompanyContactPhone(){return function(dispatch,getState){var _getState10=getState(),company=_getState10.company;var settings={contact_phone:company.settings.contact_phone,contact_phone_whatsapp:company.settings.contact_phone_whatsapp};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/settings',settings).then(function(){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var updateCompanyPaymentGeneralConfig=function updateCompanyPaymentGeneralConfig(){return function(dispatch,getState){var _getState11=getState(),company=_getState11.company;var settings={disable_balance:company.settings.disable_balance,pay_in_store:company.settings.pay_in_store};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/settings',settings).then(function(){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var updateCompanyDeliveryDiscount=function updateCompanyDeliveryDiscount(){return function(dispatch,getState){var _getState12=getState(),company=_getState12.company;var settings={human_delivery_discount_prc:company.settings.human_delivery_discount_prc};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/settings',settings).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});company.settings=res.data;var update=company;dispatch({type:'COMPANY_UPDATE',company:update,initCompany:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var updateCompanyAssignableOrdersMask=function updateCompanyAssignableOrdersMask(){return function(dispatch,getState){var _getState13=getState(),company=_getState13.company;var settings={assignable_orders_mask:company.settings.assignable_orders_mask};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/settings',settings).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});company.settings=res.data;var update=company;dispatch({type:'COMPANY_UPDATE',company:update,initCompany:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var updateCompanyComerci=function updateCompanyComerci(){return function(dispatch,getState){var _getState14=getState(),company=_getState14.company;var settings={};settings.human_delivery_providers_prc=company.settings.human_delivery_providers_prc;settings.human_delivery_fee_e2=company.settings.human_delivery_fee_e2;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/settings',settings).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});company.settings=res.data;var update=company;dispatch({type:'COMPANY_UPDATE',company:update,initCompany:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var updateDeliverySettings=function updateDeliverySettings(){return function(dispatch,getState){var _getState15=getState(),company=_getState15.company;var data={options:company.options};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(''+(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id),data).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});dispatch({type:'COMPANY_UPDATE',company:res.data,initCompany:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var updateSesionCompany=function updateSesionCompany(){return function(dispatch,getState){var company=getState().company;var data={in_service:company.in_service&&company.in_service===true?1:0};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id,data).then(function(res){company.in_service2=undefined;__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});dispatch({type:'COMPANY_EDITING',company:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var deleteCompanyDeliveryFeeSteps=function deleteCompanyDeliveryFeeSteps(keyId){return function(dispatch,getState){var _getState16=getState(),companyDeliveryFeeds=_getState16.companyDeliveryFeeds;var data=[].concat(_toConsumableArray(companyDeliveryFeeds));var update=companyDeliveryFeeds.filter(function(step,key){return key!==keyId;});data=update;dispatch({type:'FETCH_COMPANY_DELYVERY_FEEDS',companyDeliveryFeeds:data});};};var addCompanyDeliveryFeeSteps=function addCompanyDeliveryFeeSteps(){return function(dispatch,getState){var _getState17=getState(),companyDeliveryFeeds=_getState17.companyDeliveryFeeds;var data=[].concat(_toConsumableArray(companyDeliveryFeeds));var step={name:"",distance_min:"",distance_max:"",human_fee_min_e2:"",human_fee_max_e2:"",human_delivery_providers_prc:"",hour_beg:"",hour_end:"",label:"",is_additional:false,days:[]};data.push(step);dispatch({type:'FETCH_COMPANY_DELYVERY_FEEDS',companyDeliveryFeeds:data});};};var updateCompanyDeliveryFeeSteps=function updateCompanyDeliveryFeeSteps(id){return function(dispatch,getState){var _getState18=getState(),company=_getState18.company,json_lang=_getState18.json_lang,companyDeliveryFeeds=_getState18.companyDeliveryFeeds;var data=[].concat(_toConsumableArray(companyDeliveryFeeds));dispatch({type:"WAIT_FOR_RESPONSE"});var theUpdate=data.map(function(step,key){var update=void 0;if(step.name!==""&&step.distance_min!==""&&step.distance_max!==""&&step.human_fee_min_e2!==""&&step.human_fee_min_e2!==0&&step.human_fee_max_e2!==""&&step.human_fee_max_e2!==0&&step.human_delivery_providers_prc!==""&&step.human_delivery_providers_prc!==0){update={name:step.name,distance_min:step.distance_min,distance_max:step.distance_max,human_fee_min_e2:step.human_fee_min_e2,human_fee_max_e2:step.human_fee_max_e2,human_delivery_providers_prc:step.human_delivery_providers_prc,hour_beg:step.hour_beg,hour_end:step.hour_end,is_additional:step.is_additional,label:step.label,days:[]};}return update;}).filter(function(step){return step!==undefined;});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].put(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/service-charges/'+id+'/delivery-fees',theUpdate).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:'FETCH_COMPANY_DELYVERY_FEEDS',companyDeliveryFeeds:data});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:json_lang.custom_errors.retrieving_user_list});});};};var addCompanyServiceApp=function addCompanyServiceApp(){return function(dispatch,getState){var data=Object.assign({},getState().company);var step={name:"",label:"",price_min_e2:"",price_max_e2:"",order_fee_e2:"",client_fee_e2:"",hour_beg:"",hour_end:""};var update=data.settings&&data.settings.service_app_modifiers.concat(step);data.settings.service_app_modifiers=update;dispatch({type:'COMPANY_UPDATE',company:data,initCompany:getState().initCompany});};};var deleteCompanyServiceApp=function deleteCompanyServiceApp(keyId){return function(dispatch,getState){console.log("entre",keyId);var data=Object.assign({},getState().company);var update=data.settings&&data.settings.service_app_modifiers.filter(function(step,key){return key!==keyId;});data.settings.service_app_modifiers=update;dispatch({type:'COMPANY_UPDATE',company:data,initCompany:getState().initCompany});};};var updateStyles=function updateStyles(){return function(dispatch,getState){var company=Object.assign({},getState().company);var newData=new FormData();newData.append('color_primary',/*'#FF0058'*/company.styles_json.styles.color_primary);newData.append('color_accent',/*'#FF0058'*/company.styles_json.styles.color_accent);//newData.append('company_logo', data);
dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/styles',newData).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var logout=function logout(){localStorage.removeItem('token');localStorage.removeItem('user');};var getAppMovilStatus=function getAppMovilStatus(){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["f" /* urlBuilder */]+'company_app/'+getState().company.id+'/status').then(function(res){dispatch({type:'APP_MOVIL_STATUS',appMovilStatus:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.app_status});});};};var getBuilderPackages=function getBuilderPackages(){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["f" /* urlBuilder */]+'plans').then(function(res){dispatch({type:'BUILDER_PACKAGES',builderPackages:res.data});}).catch(function(err){console.log("No se ha podido traer los packs del builder");});};};var updateCompanyFooter=function updateCompanyFooter(){return function(dispatch,getState){var data={/*uid:getState().company.custom_json.uid,
            mail_footer: getState().customEmailFooter,
            slogan:getState().company.custom_json.slogan,*/human_delivery_providers_prc:getState().company.settings.human_delivery_providers_prc,human_delivery_fee_e2:getState().company.settings.human_delivery_fee_e2};dispatch({type:"WAIT_FOR_RESPONSE"});var json_lang=getState().json_lang;var succesful=json_lang.common.success;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/settings',data).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:json_lang.custom_success.saved_successful});/*dispatch({
                type: 'UPDATE_APP_MOVIL_STATUS',
                appMovilStatus: res.data.custom_json.mail_footer
            })*/}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var updateMultiProvider=function updateMultiProvider(value){return function(dispatch,getState){var data={enable_multi_providers:value.checked};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().session_company.id+'/settings',data).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});/* setTimeout(() => {
                window.location.reload()
            }, 1000);

              var company = {...getState().company}
            company.settings = res.data
            dispatch({
                type: 'COMPANY_UPDATE',
                company: company
            })*/}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};/* TOS = Terms Of Service */var updateCompanyTOS=function updateCompanyTOS(){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var data={"terms_of_service":getState().terms_of_service};var json_lang=getState().json_lang;var succesful=json_lang.common.success;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/settings',data).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:json_lang.custom_success.saved_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var fetchTOS=function fetchTOS(){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var json_lang=getState().json_lang;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/terms-of-service').then(function(res){dispatch({type:'FETCH_TOS',terms_of_service:res.data.terms_of_service});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var toggleTOSData=function toggleTOSData(input){return function(dispatch){dispatch({type:'FETCH_TOS',terms_of_service:input.value});};};var updateSettings=function updateSettings(update){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var json_lang=getState().json_lang;var settings=getState().company.settings;var data={};switch(update){case"invoices":data.invoice_format=settings.invoice_format;data.enable_invoices=settings.enable_invoices;break;case"terms_of_service":data.terms_of_service=settings.terms_of_service;break;default:break;}return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/settings',data).then(function(res){var company=getState().company;company.settings=Object.assign({},company.settings);__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});dispatch({type:'COMPANY_UPDATE',company:company});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var toggleSettingsData=function toggleSettingsData(update){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var data={};var editable_company_settings=getState().editable_company_settings;switch(update.name){case"invoice_size":data.invoice_format=editable_company_settings.invoice_format;data.invoice_format.paper=update.data;break;case"invoice_orientation":data.invoice_format=editable_company_settings.invoice_format;data.invoice_format.orientation=update.data;break;case"enable_invoices":data.enable_invoices=update.data==="true"?false:true;break;case"terms_of_service":data.terms_of_service=getState().terms_of_service;break;default:break;}editable_company_settings=Object.assign({},editable_company_settings,data);dispatch({type:'COMPANY_SETTINGS_UPDATE',editable_company_settings:editable_company_settings});};};var fetchCompanySettings=function fetchCompanySettings(){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});// TODO: organizar configuracion para el usuario que no es branch o no es high
var _getState19=getState(),company=_getState19.company;var url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/settings';/*if(branch.id)
			url_host = URL + company.id + '/branches/' + branch.id + '/settings';*/return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(url_host).then(function(res){dispatch({type:'FETCH_COMPANY_SETTINGS',editable_company_settings:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_company});});};};var updateCompanyClientBg=function updateCompanyClientBg(){return function(dispatch,getState){var data=new FormData();if(getState().dropzoneFiles.length){var block=getState().dropzoneFiles.split(";");var contentType=block[0].split(":")[1];var realData=block[1].split(",")[1];var blob=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["c" /* b64toBlob */])(realData,contentType);data.append('company_logo',blob);}dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/settings',data).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});dispatch({type:'UPDATE_APP_MOVIL_STATUS',customClientBg:res.data.custom_json.mail_footer});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var companyAdjustCurrency=function companyAdjustCurrency(value,good_conversion,property_conversion){return function(dispatch,getState){var data={value:value,good_conversion:good_conversion,property_conversion:property_conversion};var company=Object.assign({},getState().company);dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/currency-adjust',data).then(function(res){var conversion_factor=res.data&&res.data.currency_conversion;company.international_currency.conversion_factor=conversion_factor;dispatch({type:'COMPANY_UPDATE',company:company});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var getPaymentMethods=function getPaymentMethods(isBranch){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id)+(isBranch?'/branches/'+getState().branch.id:'')+'/payment-methods/set-up').then(function(res){var method=Object.getOwnPropertyNames(res.data);for(var i=0;i<method.length;i++){res.data[method[i]].tax_flat_e2=res.data[method[i]].tax_flat_e2?res.data[method[i]].tax_flat_e2/100:0;res.data[method[i]].tax_percent=res.data[method[i]].tax_percent?res.data[method[i]].tax_percent*100:0;}dispatch({type:'GET_PAYMENT_METHODS',paymentMethods:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var getPaymentMethodsForms=function getPaymentMethodsForms(noLimit){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/forms'+(noLimit?'?limit=0':'')).then(function(res){dispatch({type:'GET_PAYMENT_METHODS_FORMS',paymentMethodsForms:noLimit?res.data:res.data.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var getCompanyCurrencies=function getCompanyCurrencies(){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/currencies?limit=0').then(function(res){var errorCurrencies=false;res.data.forEach(function(curreny,key){//console.log(curreny,curreny.related_iso_error)
if(curreny.related_iso_error===true){errorCurrencies=true;}});dispatch({type:'FETCH_COMPANY_CURRENCIES',companyCurrencies:res.data,currencyError:errorCurrencies});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var getCompanyCurrency=function getCompanyCurrency(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/currencies/'+id).then(function(res){dispatch({type:'FETCH_COMPANY_CURRENCY',companyCurrency:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var getCompanyPaymentMethods=function getCompanyPaymentMethods(){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/payment-methods').then(function(res){dispatch({type:'GET_PAYMENT_METHODS',paymentMethods:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var togglePaymentMethods=function togglePaymentMethods(method,value){return function(dispatch,getState){var data=Object.assign({},getState().paymentMethods);value.name=value.name.split('-')[0];if(value.name==='enabled'){data[method][value.name]=!data[method][value.name];}else{if(value.name==='client_id'||value.name==='secret_id'||value.name==='public_key'||value.name==='secret_key'||value.name==='KeyId'||value.name==='PublicKeyId'||value.name==='receiver_email'||value.name==='receiver_name'||value.name==='authorization_key'||value.name==='merchant_id'||value.name==='username'||value.name==='password'){data[method].config[value.name]=value.data;}else{data[method][value.name]=value.data;}}dispatch({type:'GET_PAYMENT_METHODS',paymentMethods:data});};};var storePaymentMethod=function storePaymentMethod(method,isBranch){console.log("storePaymentMethod",method,isBranch);var actionURL;var actionAxios;return function(dispatch,getState){var newdata=getState().paymentMethods;var data=getState().paymentMethods[method];data.tax_percent=data.tax_percent?data.tax_percent/100:undefined;data.tax_flat_e2=data.tax_flat_e2?data.tax_flat_e2*100:undefined;data.currency_iso=data.currency_iso?data.currency_iso:data.available_currencies[0];if(method==='paypal'){data.config.mode=undefined;if(data.enabled===true&&(data.config.client_id===''||data.config.secret_id===''||data.config.client_id===null||data.config.secret_id===null)){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error al activar '+method,msg:'cliend id y secret id deben estar llenos'});return;}}if(method==='stripe'){if(data.enabled===true&&(data.config.public_key===''||data.config.secret_key===''||data.config.public_key===null||data.config.secret_key===null)){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error al activar '+method,msg:'public id y secret id deben estar llenos'});return;}}if(method==='instapago'){if(data.enabled===true&&(data.config.KeyId===''||data.config.PublicKeyId===''||data.config.KeyId===null||data.config.PublicKeyId===null)){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error al activar '+method,msg:'KeyId y PublicKeyId id deben estar llenos'});return;}}if(method==='zelle'){if(data.enabled===true&&(data.config.KeyId===''||data.config.PublicKeyId===''||data.config.KeyId===null||data.config.PublicKeyId===null)){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error al activar '+method,msg:'KeyId y PublicKeyId id deben estar llenos'});return;}}console.log("method ===> ",method);if(method==='pos'){data.config.none=true;}if(method==='banco_de_venezuela'){data.currency_iso='VES';console.log('averr',data);}if(getState().paymentMethods[method].id){actionURL=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/payment-methods/'+getState().paymentMethods[method].id;actionAxios='patch';}else{actionURL=''+(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id)+(isBranch?'/branches/'+getState().branch.id:'')+'/payment-methods';actionAxios='post';}//data = {"name":"zelle", "enabled":true, "config":{"receiver_email":"email@email.com", "receiver_name":"Pedro Parra"}}
return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */][actionAxios](''+actionURL,data).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});newdata[method]=Object.assign({},newdata[method],{id:res.data.id});newdata[method].tax_percent=newdata[method].tax_percent*100;newdata[method].tax_flat_e2=newdata[method].tax_flat_e2/100;// dispatch({
//     type: 'GET_PAYMENT_METHODS',
//     paymentMethods: newdata
// })
}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var destroyPaymentMethod=function destroyPaymentMethod(method){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/payment-methods/'+getState().paymentMethods[method].id).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});getState().paymentMethods[method]=undefined;}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var pendingActions=function pendingActions(){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/pending-actions').then(function(res){dispatch({type:'GET_PENDING_ACTIONS',pendingActions:res.data&&res.data.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var deletePendingAction=function deletePendingAction(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/pending-actions/'+id).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:'Acción completada'});var actions=getState().pendingActions.filter(function(item){return item.id!==id;});dispatch({type:'GET_PENDING_ACTIONS',pendingActions:actions});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var confirmPendingAction=function confirmPendingAction(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/pending-actions/'+id+'/apply').then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:'Cambio Aprobado'});var actions=getState().pendingActions.filter(function(item){return item.id!==id;});dispatch({type:'GET_PENDING_ACTIONS',pendingActions:actions});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var updatePendingActionFromNotification=function updatePendingActionFromNotification(payload){return function(dispatch,getState){var _getState20=getState(),pendingActions=_getState20.pendingActions;var updatedPendingActions=[].concat(_toConsumableArray(pendingActions));var findIndex=updatedPendingActions.findIndex(function(item){return item.id===payload.id;});if(findIndex!==-1){updatedPendingActions[findIndex]=payload;}else{updatedPendingActions.push(payload);}dispatch({type:'GET_PENDING_ACTIONS',pendingActions:updatedPendingActions});};};var storeWorkSchedule=function storeWorkSchedule(data){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState21=getState(),branch=_getState21.branch;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/branches/'+branch.id+'/work-schedules',data).then(function(res){dispatch({type:"WAIT_FOR_RESPONSE"});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});dispatch({type:'FETCH_WORK_SCHEDULES',workSchedules:[].concat(_toConsumableArray(getState().workSchedules),[res.data])});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var storeDataWorkSchedule=function storeDataWorkSchedule(data){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState22=getState(),branch=_getState22.branch;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].put(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/branches/'+branch.id+'/work-schedules',data).then(function(res){dispatch({type:"WAIT_FOR_RESPONSE"});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});dispatch({type:'FETCH_WORK_SCHEDULES',workSchedules:[].concat(_toConsumableArray(getState().workSchedules),[res.data])});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var deleteWorkSchedule=function deleteWorkSchedule(id){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/work-schedules/'+id).then(function(res){dispatch({type:'FETCH_WORK_SCHEDULES',workSchedules:getState().workSchedules.filter(function(deleted){return deleted.id!==res.data.id;})});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var getWorkSchedule=function getWorkSchedule(){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState23=getState(),branch=_getState23.branch;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/branches/'+branch.id+'/work-schedules?limit=0').then(function(res){dispatch({type:"WAIT_FOR_RESPONSE"});dispatch({type:'FETCH_WORK_SCHEDULES',workSchedules:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var getCompanyHolidays=function getCompanyHolidays(){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/holidays?limit=0').then(function(res){dispatch({type:"WAIT_FOR_RESPONSE"});dispatch({type:'FETCH_HOLIDAYS',companyHolidays:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var storeCompanyHolidays=function storeCompanyHolidays(data){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].put(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/holidays',data).then(function(res){dispatch({type:"WAIT_FOR_RESPONSE"});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});dispatch({type:'FETCH_HOLIDAYS',companyHolidays:[].concat(_toConsumableArray(getState().companyHolidays),[res.data])});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.company_update_failed});});};};var getBranchsCompany=function getBranchsCompany(show){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var sort=arguments[2];return function(dispatch,getState){var _getState24=getState(),company=_getState24.company,json_lang=_getState24.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branch-categories?limit=10&page='+page+'\n            '+(sort?'&sort_by='+sort.columnName+','+sort.direction:'')+'\n            '+(show?'&branch_category_id=null':'&branch_category_id=notnull')).then(function(res){//console.log('show',show,page,sort)
//console.log(res.data)
dispatch({type:'FETCH_BRANCH_COMPNAY_CATEGORIES',branchesCompanyCategories:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var toggleDataCompanyCategory=function toggleDataCompanyCategory(value){return function(dispatch,getState){var data=Object.assign({},getState().companyCategory);data[value.name]=value.data;var thekey=value.name.split('-');if(thekey.length>1){data.children[thekey[1]][thekey[0]]=value.data;}dispatch({type:'FETCH_COMPANY_BRANCH_CATEGORY',companyCategory:data});};};var toggleDataSubCategory=function toggleDataSubCategory(value){return function(dispatch,getState){var data=Object.assign({},getState().companySubCategory);data[value.name]=value.data;dispatch({type:'FETCH_COMPANY_BRANCH_SUBCATEGORY',companySubCategory:data});};};var findBranchCompany=function findBranchCompany(branchCategoryId){return function(dispatch,getState){var _getState25=getState(),company=_getState25.company,json_lang=_getState25.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branch-categories/'+branchCategoryId+'?with=children').then(function(res){dispatch({type:'FETCH_COMPANY_BRANCH_CATEGORY',companyCategory:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var editBranchCompany=function editBranchCompany(data){return function(dispatch,getState){var _getState26=getState(),company=_getState26.company,json_lang=_getState26.json_lang,branchesCompanyCategories=_getState26.branchesCompanyCategories;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branch-categories/'+data.id,data).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});var updatebranchesCompanyCategories=branchesCompanyCategories.data.map(function(category,key){if(category.id===res.data.id){category=res.data;}return category;});branchesCompanyCategories.data=updatebranchesCompanyCategories;dispatch({type:'FETCH_BRANCH_COMPNAY_CATEGORIES',branchesCompanyCategories:branchesCompanyCategories});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var addBranchCompany=function addBranchCompany(data){return function(dispatch,getState){var _getState27=getState(),company=_getState27.company,json_lang=_getState27.json_lang,branchesCompanyCategories=_getState27.branchesCompanyCategories;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branch-categories',data).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});/*let updatebranchesCompanyCategories = branchesCompanyCategories.data.map( (category,key) => {
                if(category.id=== res.data.id){
                    category= res.data
                }
                return category
            })*//* let update = branchesCompanyCategories.data.concat(res.data);
            branchesCompanyCategories.data = update */dispatch({type:'FETCH_BRANCH_COMPNAY_CATEGORIES'//branchesCompanyCategories: branchesCompanyCategories,
});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var addSubcaractegory=function addSubcaractegory(data,category){return function(dispatch,getState){var _getState28=getState(),company=_getState28.company,json_lang=_getState28.json_lang;//dispatch({type: "WAIT_FOR_RESPONSE"});
var subcategory={name:data.name,in_order:parseInt(data.in_order,10),branch_category_id:category};return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branch-categories',subcategory).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});/*let updatebranchesCompanyCategories = branchesCompanyCategories.data.map( (category,key) => {
                if(category.id=== res.data.id){
                    category= res.data
                }
                return category
            })*///let update = branchesCompanyCategories.data.concat(res.data);
//branchesCompanyCategories.data = update
/*dispatch({
                type: 'FETCH_BRANCH_COMPNAY_CATEGORIES',
                branchesCompanyCategories: branchesCompanyCategories,
            })*/}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var editSubcaractegory=function editSubcaractegory(data){return function(dispatch,getState){var _getState29=getState(),company=_getState29.company,json_lang=_getState29.json_lang;//dispatch({type: "WAIT_FOR_RESPONSE"});
return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branch-categories/'+data.id,data).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});/*let updatebranchesCompanyCategories = branchesCompanyCategories.data.map( (category,key) => {
                if(category.id=== res.data.id){
                    category= res.data
                }
                return category
            })
            branchesCompanyCategories.data = updatebranchesCompanyCategories

            dispatch({
                type: 'FETCH_BRANCH_COMPNAY_CATEGORIES',
                branchesCompanyCategories: branchesCompanyCategories,
            })*/}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var deleteSubcaractegory=function deleteSubcaractegory(id){return function(dispatch,getState){var _getState30=getState(),company=_getState30.company,json_lang=_getState30.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branch-categories/'+id).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var deleteBranchCompany=function deleteBranchCompany(id){return function(dispatch,getState){var _getState31=getState(),company=_getState31.company,json_lang=_getState31.json_lang,branchesCompanyCategories=_getState31.branchesCompanyCategories;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branch-categories/'+id).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});var update_data=branchesCompanyCategories.data.filter(function(category,key){return category.id!==res.data.id;});branchesCompanyCategories.data=update_data;dispatch({type:'FETCH_BRANCH_COMPNAY_CATEGORIES',branchesCompanyCategories:branchesCompanyCategories});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var clearBranchCompany=function clearBranchCompany(){return function(dispatch,getState){dispatch({type:'FETCH_COMPANY_BRANCH_CATEGORY',companyCategory:{name:""}});};};var clearSubcategory=function clearSubcategory(){return function(dispatch,getState){dispatch({type:'FETCH_COMPANY_BRANCH_SUBCATEGORY',companySubCategory:{name:"",in_order:null}});};};var GetbranchCategories=function GetbranchCategories(id){return function(dispatch,getState){var _getState32=getState(),company=_getState32.company,json_lang=_getState32.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});//return axios.get(`${URL+company.id}/branch-groups/${id}/branch-categories?limit=0`).then((res) => {
return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branches/'+id+'/branch-categories?limit=0').then(function(res){dispatch({type:'FETCH_BRANCH_COMPANY_CATEGORIES',BranchCompanyCategories:res.data});}).catch(function(err){if(err&&err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var getBranchsCompanyArray=function getBranchsCompanyArray(){return function(dispatch,getState){var _getState33=getState(),company=_getState33.company,json_lang=_getState33.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branch-categories?limit=0&with=children').then(function(res){dispatch({type:'FETCH_BRANCH_COMPNAY_CATEGORIES',branchesCompanyCategories:res.data});}).catch(function(err){console.log("err",err);if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var AttachtCategoryToBranchs=function AttachtCategoryToBranchs(branchCategory,branchId){return function(dispatch,getState){var _getState34=getState(),company=_getState34.company,json_lang=_getState34.json_lang,BranchCompanyCategories=_getState34.BranchCompanyCategories;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].put(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branch-categories/'+branchCategory.id+'/branches/'+branchId).then(function(res){var update=BranchCompanyCategories.concat(branchCategory);__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});dispatch({type:'FETCH_BRANCH_COMPANY_CATEGORIES',BranchCompanyCategories:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var UnAttachCategoryToBranchs=function UnAttachCategoryToBranchs(branchCategoryId,branchId){return function(dispatch,getState){var _getState35=getState(),company=_getState35.company,json_lang=_getState35.json_lang,BranchCompanyCategories=_getState35.BranchCompanyCategories;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branch-categories/'+branchCategoryId+'/branches/'+branchId).then(function(res){var update=BranchCompanyCategories.filter(function(branchCategory){return branchCategory.id!==branchCategoryId;});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});dispatch({type:'FETCH_BRANCH_COMPANY_CATEGORIES',BranchCompanyCategories:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var getCompanyVehicles=function getCompanyVehicles(){return function(dispatch,getState){var _getState36=getState(),company=_getState36.company,json_lang=_getState36.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/delivery-vehicles?limit=0').then(function(res){dispatch({type:'FETCH_VEHICLES',vehicles:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var getCompanyDeliveryFees=function getCompanyDeliveryFees(id){return function(dispatch,getState){var _getState37=getState(),company=_getState37.company,json_lang=_getState37.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/service-charges/'+id+'/delivery-fees?limit=0').then(function(res){dispatch({type:'FETCH_COMPANY_DELYVERY_FEEDS',companyDeliveryFeeds:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var getCompanyServiceCharges=function getCompanyServiceCharges(){return function(dispatch,getState){var _getState38=getState(),company=_getState38.company,json_lang=_getState38.json_lang;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/service-charges?limit=0').then(function(res){dispatch({type:"GET_SERVICE_CHARGES",serviceCharges:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var setServiceCharge=function setServiceCharge(name){return function(dispatch,getState){var _getState39=getState(),company=_getState39.company,json_lang=_getState39.json_lang,serviceCharges=_getState39.serviceCharges;dispatch({type:"WAIT_FOR_RESPONSE"});var data={name:name,type:1,service_type:1};return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/service-charges',data).then(function(res){var _ref;dispatch({type:"GET_SERVICE_CHARGES",serviceCharges:(_ref=[res.data]).concat.apply(_ref,_toConsumableArray(serviceCharges))});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var pathServiceCharge=function pathServiceCharge(name,id){return function(dispatch,getState){var _getState40=getState(),company=_getState40.company,json_lang=_getState40.json_lang,serviceCharges=_getState40.serviceCharges;dispatch({type:"WAIT_FOR_RESPONSE"});var data={name:name,type:1,service_type:1};var prevServiceCharges=[].concat(_toConsumableArray(serviceCharges));return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["d" /* URLsmall */]+'service-charges/'+id,data).then(function(res){var i=prevServiceCharges.findIndex(function(index){return index.id===id;});if(i!==-1){prevServiceCharges[i]=Object.assign({},res.data);}dispatch({type:"GET_SERVICE_CHARGES",serviceCharges:[].concat(_toConsumableArray(prevServiceCharges))});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var deleteServiceCharge=function deleteServiceCharge(id){return function(dispatch,getState){var _getState41=getState(),company=_getState41.company,json_lang=_getState41.json_lang,serviceCharges=_getState41.serviceCharges;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["d" /* URLsmall */]+'service-charges/'+id).then(function(){dispatch({type:"GET_SERVICE_CHARGES",serviceCharges:serviceCharges.filter(function(charge){return charge.id!==id;})});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.delete_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var toggleVehicleData=function toggleVehicleData(value){return function(dispatch,getState){var data=Object.assign({},getState().vehicle);data[value.name]=value.data;dispatch({type:'STORE_VEHICLE',vehicle:data});};};var createCompanyVehicles=function createCompanyVehicles(){return function(dispatch,getState){var _getState42=getState(),company=_getState42.company,json_lang=_getState42.json_lang,vehicle=_getState42.vehicle,vehicles=_getState42.vehicles;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/delivery-vehicles',vehicle).then(function(res){console.log("vehicles1",res.data);var update=vehicles.concat(res.data);dispatch({type:'FETCH_VEHICLES',vehicles:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var deleteCompanyVehicles=function deleteCompanyVehicles(id){return function(dispatch,getState){var _getState43=getState(),company=_getState43.company,json_lang=_getState43.json_lang,vehicles=_getState43.vehicles;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/delivery-vehicles/'+id).then(function(res){var update=vehicles.filter(function(elm){return elm.id!==parseInt(id,10);});dispatch({type:'FETCH_VEHICLES',vehicles:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var apiReport=function apiReport(urlReport){return function(dispatch){if(!urlReport){dispatch({type:"REPORT",report:null});return;}return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(urlReport).then(function(res){dispatch({type:"REPORT",report:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:err&&err.title!==''?err.title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});});};};var apiReportHistories=function apiReportHistories(accountId){return function(dispatch,getState){var _getState44=getState(),company=_getState44.company;dispatch({type:"WAIT_FOR_RESPONSE"});var url=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/report-histories?limit=15';return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(url,{account_id:accountId}).then(function(res){dispatch({type:"REPORT_HISTORIES",reportHistories:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:err&&err.title!==''?err.title:'Error '+(err&&err.data&&err.data.error_code),msg:err&&err.data&&err.data.description});});};};var updateReportHistories=function updateReportHistories(payload){return function(dispatch,getState){var _getState45=getState(),reportHistories=_getState45.reportHistories,report=_getState45.report;if(reportHistories&&reportHistories.data&&reportHistories.data.length>0){var prevReportHistories=Object.assign({},reportHistories);var reportHistoryIndex=reportHistories.data.findIndex(function(report){return report.id===payload.id;});if(reportHistoryIndex!==-1){prevReportHistories.data[reportHistoryIndex].status=payload.status;if(payload.progress>prevReportHistories.data[reportHistoryIndex].progress){prevReportHistories.data[reportHistoryIndex].progress=payload.progress;}dispatch({type:"REPORT_HISTORIES",reportHistories:Object.assign({},prevReportHistories)});}}if(report&&report.id===payload.id){var prevReport=Object.assign({},report);prevReport.status=payload.status;if(payload.progress>prevReport.progress){prevReport.progress=payload.progress;}dispatch({type:"REPORT",report:Object.assign({},prevReport)});}};};var toogleCompanyCurrency=function toogleCompanyCurrency(value){return function(dispatch,getState){var data=Object.assign({},getState().companyCurrency);if(value.name==="enabled"||value.name==="available"||value.name==="use_thousands_separator"||value.name==="is_local"||value.name==="is_custom"||value.name==="auto_sync"||value.name==="is_international"){data[value.name]=value.checked;}else{data[value.name]=value.data;}dispatch({type:'FETCH_COMPANY_CURRENCY',companyCurrency:data});};};var clearCompanyCurrency=function clearCompanyCurrency(value){return function(dispatch){dispatch({type:'FETCH_COMPANY_CURRENCY',companyCurrency:{enabled:false,iso:"",symbol:"",conversion_factor:"",related_iso:"",decimals_count:0,format:"",decimal_point:"",use_thousands_separator:false,auto_sync:false,thousands_separator:"",is_local:false,is_international:false,use_conversion:false,available:false}});};};var createCompanyCurrency=function createCompanyCurrency(){return function(dispatch,getState){var _getState46=getState(),company=_getState46.company,json_lang=_getState46.json_lang,companyCurrency=_getState46.companyCurrency,companyCurrencies=_getState46.companyCurrencies;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/currencies',companyCurrency).then(function(res){var update=companyCurrencies.concat(res.data);dispatch({type:'FETCH_COMPANY_CURRENCIES',companyCurrencies:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var editCompanyCurrency=function editCompanyCurrency(id,branch){return function(dispatch,getState){var _getState47=getState(),company=_getState47.company,json_lang=_getState47.json_lang,companyCurrency=_getState47.companyCurrency,companyCurrencies=_getState47.companyCurrencies,branchCurrencies=_getState47.branchCurrencies;dispatch({type:"WAIT_FOR_RESPONSE"});companyCurrency.related_iso=companyCurrency.related_iso_expected;console.log("editCompanyCurrency",companyCurrency);return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/currencies/'+id,companyCurrency).then(function(res){var errorCurrencies=res.data.related_iso_error;var update=[];if(branch){update=branchCurrencies.map(function(item,key){if(item.id===parseInt(res.data.id,10)){item=res.data;}return item;});dispatch({type:'FETCH_BRANCHES_CURRENCIES',branchCurrencies:update});}else{update=companyCurrencies.map(function(item,key){if(item.id===parseInt(res.data.id,10)){item=res.data;}return item;});dispatch({type:'FETCH_COMPANY_CURRENCIES',companyCurrencies:update,currencyError:errorCurrencies});}}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var deleteCompanyCurrency=function deleteCompanyCurrency(id){return function(dispatch,getState){var _getState48=getState(),company=_getState48.company,json_lang=_getState48.json_lang,companyCurrencies=_getState48.companyCurrencies;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/currencies/'+id).then(function(res){var update=companyCurrencies.filter(function(elm){return elm.id!==parseInt(id,10);});dispatch({type:'FETCH_COMPANY_CURRENCIES',companyCurrencies:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var currencySetMode=function currencySetMode(id,mode){return function(dispatch,getState){var _getState49=getState(),company=_getState49.company,json_lang=_getState49.json_lang,companyCurrencies=_getState49.companyCurrencies;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/currencies/'+id+'/set-'+mode).then(function(res){console.log("related_iso_error",res.data.related_iso_error);var errorCurrencies=res.data.related_iso_error;var update=companyCurrencies.map(function(item,key){if(item.id===parseInt(res.data.id,10)){item=res.data;}if(res.data.is_international===true&&item.id!==res.data.id){item.is_international=false;}if(res.data.is_local===true&&item.id!==res.data.id){item.is_local=false;}return item;});dispatch({type:'FETCH_COMPANY_CURRENCIES',companyCurrencies:update,currencyError:errorCurrencies});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var getBalanceMovements=function getBalanceMovements(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var sort=arguments[1];var search=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var cityId=arguments.length>3&&arguments[3]!==undefined?arguments[3]:2;var dates=arguments.length>4&&arguments[4]!==undefined?arguments[4]:null;return function(dispatch,getState){var _getState50=getState(),company=_getState50.company,json_lang=_getState50.json_lang,branch=_getState50.branch;dispatch({type:"WAIT_FOR_RESPONSE"});//let url =`/balance-movements?type=company&key=${company.id}&page=${page}${sort? `&sort_by=${sort.columnName},${sort.direction}` :``}`
var sort_by=sort?'&sort_by='+sort.columnName+','+sort.direction:'';var url='/balance-movements?page='+page+'&with=author'+sort_by+(search?'&description= ilike'+encodeURIComponent(search):'');url+='&type=city&key='+cityId;if(dates){url+='&created_at=between '+dates.dateStart+' 00:00:00,'+dates.dateEnd+' 23:59:59';}return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+url)).then(function(res){dispatch({type:'FETCH_BALANCE_MOVEMENTS',balanceMovements:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var getBalanceDebt=function getBalanceDebt(cityId){return function(dispatch,getState){var _getState51=getState(),company=_getState51.company,json_lang=_getState51.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/cities/'+cityId+'/balance-movements/debt').then(function(res){dispatch({type:'FETCH_BALANCE_DEBT',balanceDebt:res.data});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var getProvidersBalanceMovements=function getProvidersBalanceMovements(id){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;return function(dispatch,getState){var _getState52=getState(),json_lang=_getState52.json_lang,company=_getState52.company;dispatch({type:"WAIT_FOR_RESPONSE"});var url='/balance-movements?type=provider&key='+id+'&page='+page;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+url)).then(function(res){dispatch({type:'FETCH_BALANCE_MOVEMENTS',balanceMovements:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var getClientBalanceMovements=function getClientBalanceMovements(id){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;return function(dispatch,getState){var _getState53=getState(),json_lang=_getState53.json_lang,company=_getState53.company;dispatch({type:"WAIT_FOR_RESPONSE"});var url='/balance-movements?type=client&key='+id+'&page='+page+'&with=author';return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+url)).then(function(res){dispatch({type:'FETCH_BALANCE_MOVEMENTS',balanceMovements:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var getClientBalanceMovement=function getClientBalanceMovement(id){return function(dispatch,getState){var _getState54=getState(),json_lang=_getState54.json_lang,company=_getState54.company;var url='/balance-movements/current?type=client&key='+id;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+url)).then(function(res){dispatch({type:'FETCH_BALANCE_MOVEMENT',balanceMovement:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var clearBalanceMovement=function clearBalanceMovement(){return function(dispatch){dispatch({type:'FETCH_BALANCE_MOVEMENT',balanceMovement:null});};};var getClientTemporalBalanceMovements=function getClientTemporalBalanceMovements(id){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;return function(dispatch,getState){var _getState55=getState(),json_lang=_getState55.json_lang,company=_getState55.company;dispatch({type:"WAIT_FOR_RESPONSE"});var url='/balance-modifiers?page='+page+'&owner_id='+id+'&sort_by=id,desc';return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+url)).then(function(res){dispatch({type:'FETCH_BALANCE_MODIFIERS',balanceModifiers:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var setBalanceMovements=function setBalanceMovements(){return function(dispatch,getState){var _getState56=getState(),company=_getState56.company,json_lang=_getState56.json_lang,newBilling=_getState56.newBilling,balanceMovements=_getState56.balanceMovements,session=_getState56.session;// let actualBalance = balanceMovements.data.length > 0 ? balanceMovements.data[0].final_balance_e2 : 0;
if(newBilling.type==="company"){newBilling.key=company.id;}var data=newBilling;var newBalancements=Object.assign({},balanceMovements);data.amount_e2=data.amount_e2*100;if(newBilling.move!=="add"){// TODO: Aqui se evitaba que el cliente tuviera balance negativo, se pidio que se quitara
// data.amount_e2 > actualBalance ? data.amount_e2 = -actualBalance : data.amount_e2 = -data.amount_e2
data.amount_e2=-data.amount_e2;}dispatch({type:"WAIT_FOR_RESPONSE"});var url='/balance-movements/adjust';return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(''+(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+url),data).then(function(res){if(newBalancements.current_page===1){var author={author:{email:session.email}};var newMovements=[Object.assign({},res.data,author)].concat(newBalancements.data);newBalancements.data=newMovements;dispatch({type:'FETCH_BALANCE_MOVEMENTS',balanceMovements:Object.assign({},newBalancements)});}else{dispatch({type:"REMOVE_LOADING"});}}).catch(function(err){dispatch({type:"REMOVE_LOADING"});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var toogleBalance=function toogleBalance(value){return function(dispatch,getState){var _getState57=getState(),newBilling=_getState57.newBilling;var data=Object.assign({},newBilling);if(value.name==='type'&&value.data==='city'){data.key=value.value;}data[value.name]=value.data;dispatch({type:'STORE_NEW_BILLING',newBilling:data});};};var resetBalance=function resetBalance(value){return function(dispatch,getState){var data={type:"company",key:"",amount_e2:"",notes:"",move:"add",order_ids:[]};dispatch({type:'LOT_BILLING_DETAILS',newBilling:data,lotBillingsDetails:null});};};var getBalanceMovementBetween=function getBalanceMovementBetween(date1,date2,type){return function(dispatch,getState){var _getState58=getState(),company=_getState58.company,json_lang=_getState58.json_lang,branch=_getState58.branch,newBilling=_getState58.newBilling,provider=_getState58.provider;//dispatch({type: "WAIT_FOR_RESPONSE"});
var url='/balance-movements?type=company&key='+company.id+'&report=1&created_at=between '+date1+','+date2;if(type==='branch'){url='/branches/'+branch.id+'/branch-pending-fees/report?no_invoice=1&created_at=between '+date1+','+date2;}if(type==='provider'){url='/balance-movements?type=provider&key='+provider.id+'&report=1&created_at=between '+date1+','+date2;}return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+url)).then(function(res){var data=res.data;if(type==="branch"){var subtotalOrder=data?data.details.reduce(function(acc,order){acc+=order.amount_order_e2;return acc;},0):0;var subtotalFee=data?data.details.reduce(function(acc,order){if(order.amount_order_e2-order.amount_fee_e2+order.amount_discount_e2!==order.amount_total_e2){acc+=order.amount_order_e2-order.amount_total_e2-order.amount_fee_e2+order.amount_discount_e2;}else{acc+=order.amount_fee_e2;}return acc;},0):0;var subtotalDiscount=data?data.details.reduce(function(acc,order){acc+=order.amount_discount_e2;return acc;},0):0;data=Object.assign({},data,{subtotal_order_e2:subtotalOrder,pending_fee_e2:subtotalFee,pending_discount_e2:subtotalDiscount});newBilling.amount_e2=data.pending_total_e2;newBilling.order_ids=data.details.map(function(order){return order.order_id;});}else{newBilling.amount_e2=data&&data.total&&data.total.split(" ")[1];newBilling.order_ids=data.orders.map(function(order,key){return order.order_id;});}dispatch({type:'LOT_BILLING_DETAILS',lotBillingsDetails:data,newBilling:newBilling});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var getBalanceMovementBetweenLot=function getBalanceMovementBetweenLot(cityId,startDate,endDate,type){return function(dispatch,getState){var _getState59=getState(),company=_getState59.company,json_lang=_getState59.json_lang,newBilling=_getState59.newBilling;dispatch({type:"WAIT_FOR_RESPONSE"});var url="";if(type==='branch'){url='/branch-pending-fees/report?no_invoice=1&created_at=between '+startDate+','+endDate+(cityId?'&city_id='+cityId:"");}if(type==='provider'){url='/providers/general-invoices?created_at=between '+startDate+','+endDate+(cityId?'&city_id='+cityId:"");}return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+url)).then(function(res){var data=res.data;if(type==="branch"){var subtotalOrder=data?data.details.reduce(function(acc,order){acc+=order.amount_order_e2;return acc;},0):0;data=Object.assign({},data,{subtotal_order_e2:subtotalOrder});newBilling.amount_e2=data.pending_total_e2;newBilling.order_ids=data.details.map(function(order){return order.order_id;});}else{newBilling.amount_e2=data&&data.total&&data.total.split(" ")[1];newBilling.order_ids=data.orders.map(function(order,key){return order.order_id;});}dispatch({type:'LOT_BILLING_DETAILS',lotBillingsDetails:data,newBilling:newBilling});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var setBalanceMovementBetween=function setBalanceMovementBetween(type,newBillingState){return function(dispatch,getState){var _getState60=getState(),company=_getState60.company,newBilling=_getState60.newBilling,branch=_getState60.branch,provider=_getState60.provider;var data=newBilling;if(newBillingState){data=newBillingState;}data.amount_e2=-(data.amount_e2*100);data.type='branch';data.key=branch.id;data.relatedType='branches';var url='/branches/'+branch.id;if(type==='provider'){url='/providers/'+provider.id;data.type='provider';data.key=provider.id;data.relatedType='providers';}dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+url+'/general-invoices',data).then(function(res){/*let newMovements =  [res.data].concat(balanceMovements.data);
            balanceMovements.data = newMovements
            dispatch({
                type: 'FETCH_BALANCE_MOVEMENTS',
                balanceMovements: balanceMovements
            })*/if(type==='provider'){window.location.href='/provider-management/invoice-details-'+res.data.id;}else{window.location.href='/company-billings/invoices/'+res.data.id;}}).catch(function(err){console.log("err",err.message);__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:''+(err&&err&&err.title),msg:''+(err&&err.data&&err.data.message==='conflict'?'¡Atención! Existe una factura pendiente. Conciliar o eliminar primero':err&&err.data&&err.data.message)});});};};var setBalanceMovementBetweenLot=function setBalanceMovementBetweenLot(type,newBillingState){return function(dispatch,getState){var _getState61=getState(),company=_getState61.company,newBilling=_getState61.newBilling,branch=_getState61.branch,provider=_getState61.provider,json_lang=_getState61.json_lang;var data=newBilling;if(newBillingState){data=newBillingState;}data.amount_e2=-(data.amount_e2*100);data.type='branch';data.key=branch.id;data.relatedType='branches';var url='/general-invoices?related_type=branches';if(type==='provider'){url='/general-invoices?related_type=provider';data.type='provider';data.key=provider.id;data.relatedType='providers';}dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(''+(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+url),data).then(function(res){if(res.data.task_queued){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:"El proceso de generación de las facturas se está ejecutando, irán apareciendo en la lista de facturas en breve."});}else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:"Facturas generadas exitosamente."});}}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err&&err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:error.code,msg:error.message});}else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'error',msg:json_lang.custom_errors.default_error});}});};};var getGeneralInvoices=function getGeneralInvoices(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var relatedType=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"branches";var conciliatedOnly=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return function(dispatch,getState){var _getState62=getState(),company=_getState62.company,json_lang=_getState62.json_lang,branch=_getState62.branch;dispatch({type:"WAIT_FOR_RESPONSE"});var url='';if(branch&&branch.id){url='/branches/'+branch.id+'/general-invoices?page='+page+(conciliatedOnly?"&status=conciliated":"");}else{url='/general-invoices?related_type='+relatedType+'&page='+page+'&limit=12&with=related';}return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+url)).then(function(res){dispatch({type:'FETCH_GENERAL_INVOICES',generalInvoices:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var getGeneralProviderInvoices=function getGeneralProviderInvoices(id){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;return function(dispatch,getState){var _getState63=getState(),company=_getState63.company,json_lang=_getState63.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/providers/'+id+'/general-invoices?page='+page).then(function(res){dispatch({type:'FETCH_GENERAL_INVOICES',generalInvoices:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var getCompanyGeneralInvoices=function getCompanyGeneralInvoices(){var limit=arguments.length>0&&arguments[0]!==undefined?arguments[0]:10;var relatedType=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"branches";return function(dispatch,getState){var _getState64=getState(),company=_getState64.company,json_lang=_getState64.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});var url='/general-invoices?related_type='+relatedType+'&page=1&limit='+limit+'&mode=pending&with=related';return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+url)).then(function(res){dispatch({type:'FETCH_COMPANY_GENERAL_INVOICES',companyGeneralInvoices:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var deleteCompanyGeneralInvoices=function deleteCompanyGeneralInvoices(){var ids=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return function(dispatch,getState){var _getState65=getState(),company=_getState65.company,json_lang=_getState65.json_lang,companyGeneralInvoices=_getState65.companyGeneralInvoices;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/general-invoices/batch-delete',{data:ids}).then(function(res){var filteredSuccessful=res.data.filter(function(item){return item.is_successful;}).map(function(item){return item.id;});var newCompanyGeneralInvoices=companyGeneralInvoices.data.filter(function(invoice){return!filteredSuccessful.includes(invoice.id);});dispatch({type:'FETCH_COMPANY_GENERAL_INVOICES',companyGeneralInvoices:Object.assign({},companyGeneralInvoices,{data:newCompanyGeneralInvoices})});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.delete_successful});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.delete_invoice_failed});});};};var payCompanyGeneralInvoices=function payCompanyGeneralInvoices(){var ids=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var relatedType=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"branches";var type=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"get";return function(dispatch,getState){var _getState66=getState(),company=_getState66.company,json_lang=_getState66.json_lang,companyGeneralInvoices=_getState66.companyGeneralInvoices;dispatch({type:"WAIT_FOR_RESPONSE"});var newsIds=ids.map(function(id){return'ids[]='+id;}).join("&");return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */][type](__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/general-invoices/batch-send-payments?mode=ids&type='+relatedType+'&'+newsIds).then(function(res){if(type==="get"){dispatch({type:"FETCH_TO_PAY_COMPANY_GENERAL_INVOICES",toPayCompanyGeneralInvoices:res.data});}else if(type==="post"){if(res&&res.data&&res.data.length>0){var responseIds=res.data.map(function(invoice){return invoice.id;});var newCompanyGeneralInvoices=companyGeneralInvoices.data.filter(function(invoice){return!responseIds.includes(invoice.id);});dispatch({type:'FETCH_COMPANY_GENERAL_INVOICES',companyGeneralInvoices:Object.assign({},companyGeneralInvoices,{data:newCompanyGeneralInvoices})});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.pay_successful});}else{dispatch({type:"REMOVE_LOADING"});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"warning",title:'Atenci\xF3n',msg:"No se encontraron facturas para pagar"});}}}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err&&err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);switch(error.code){default:__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:error.message});break;}}else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:json_lang.custom_errors.pay_invoices_failed});}});};};/* const getGeneralClientInvoices = (id,page = 1) => {
    return (dispatch, getState) => {
        const { company, json_lang} = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
        return axios.get(`${URL+company.id}/client/${id}/general-invoices?page=${page}`).then((res) => {
            dispatch({
                type: 'FETCH_GENERAL_INVOICES',
                generalInvoices: res.data
            })
        }).catch((err) => {
            Notification.show({ type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.company_update_failed });
        });
    }
} */var conciliateGeneralInvoices=function conciliateGeneralInvoices(generalInvoiceId){return function(dispatch,getState){var _getState67=getState(),company=_getState67.company,json_lang=_getState67.json_lang,invoice=_getState67.invoice,companyGeneralInvoices=_getState67.companyGeneralInvoices;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/general-invoices/'+generalInvoiceId+'/conciliate').then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});if(invoice){dispatch({type:'FETCH_INVOICE',invoice:Object.assign({},res.data,{items:invoice.items,related:invoice.related,payout_accounts:invoice.payout_accounts})});}if(companyGeneralInvoices&&companyGeneralInvoices.data&&companyGeneralInvoices.data.length>0){var newCompanyGeneralInvoices=Object.assign({},companyGeneralInvoices);var index=companyGeneralInvoices.data.findIndex(function(item){return item.id===generalInvoiceId;});newCompanyGeneralInvoices.data[index]=res.data;dispatch({type:'FETCH_COMPANY_GENERAL_INVOICES',companyGeneralInvoices:newCompanyGeneralInvoices});}}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err&&err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);var relatedName=invoice.related&&invoice.related.name||"El beneficiario";switch(error.code){case"EF607":__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:json_lang.custom_errors.target_invalid_payment_method.replace("{target}",relatedName)});break;default:__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:error.message});break;}}else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:json_lang.two_steps_modal.default_error});}});};};var setPaidGeneralInvoices=function setPaidGeneralInvoices(generalInvoiceId,reference){return function(dispatch,getState){var _getState68=getState(),company=_getState68.company,json_lang=_getState68.json_lang,invoice=_getState68.invoice,companyGeneralInvoices=_getState68.companyGeneralInvoices;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/general-invoices/'+generalInvoiceId+'/set-paid',{ref:reference}).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});if(invoice){dispatch({type:'FETCH_INVOICE',invoice:Object.assign({},res.data,{items:invoice.items,related:invoice.related,payout_accounts:invoice.payout_accounts})});}if(companyGeneralInvoices&&companyGeneralInvoices.data&&companyGeneralInvoices.data.length>0){var newCompanyGeneralInvoices=Object.assign({},companyGeneralInvoices);var index=companyGeneralInvoices.data.findIndex(function(item){return item.id===generalInvoiceId;});newCompanyGeneralInvoices.data[index]=res.data;dispatch({type:'FETCH_COMPANY_GENERAL_INVOICES',companyGeneralInvoices:newCompanyGeneralInvoices});}}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err&&err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);var relatedName=invoice.related&&invoice.related.name||"El beneficiario";switch(error.code){case"EF607":__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:json_lang.custom_errors.target_invalid_payment_method.replace("{target}",relatedName)});break;default:__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:error.message});break;}}else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:json_lang.two_steps_modal.default_error});}});};};var payGeneralInvoices=function payGeneralInvoices(generalInvoiceId,payoutIndex){return function(dispatch,getState){var _getState69=getState(),company=_getState69.company,json_lang=_getState69.json_lang,invoice=_getState69.invoice,companyGeneralInvoices=_getState69.companyGeneralInvoices;dispatch({type:"WAIT_FOR_RESPONSE"});var data={send_payment:true};if(payoutIndex>=0){data=Object.assign({},data,{payout_index:payoutIndex});}return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/general-invoices/'+generalInvoiceId+'/conciliate',data).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});if(invoice){dispatch({type:'FETCH_INVOICE',invoice:Object.assign({},res.data,{items:invoice.items,related:invoice.related,payout_accounts:invoice.payout_accounts})});}if(companyGeneralInvoices&&companyGeneralInvoices.data&&companyGeneralInvoices.data.length>0){var newCompanyGeneralInvoices=Object.assign({},companyGeneralInvoices);var index=companyGeneralInvoices.data.findIndex(function(item){return item.id===generalInvoiceId;});newCompanyGeneralInvoices.data[index]=res.data;dispatch({type:'FETCH_COMPANY_GENERAL_INVOICES',companyGeneralInvoices:newCompanyGeneralInvoices});}}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err&&err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);var relatedName=invoice.related&&invoice.related.name||"El beneficiario";switch(error.code){case"EF607":__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:json_lang.custom_errors.target_invalid_payment_method.replace("{target}",relatedName)});break;default:__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:error.message});break;}}else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:json_lang.two_steps_modal.default_error});}});};};var retryPaymentInvoices=function retryPaymentInvoices(generalInvoiceId,payoutIndex){return function(dispatch,getState){var _getState70=getState(),company=_getState70.company,json_lang=_getState70.json_lang,invoice=_getState70.invoice,companyGeneralInvoices=_getState70.companyGeneralInvoices;dispatch({type:"WAIT_FOR_RESPONSE"});var data={};if(payoutIndex>=0){data={payout_index:payoutIndex};}return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/general-invoices/'+generalInvoiceId+'/send-payment',data).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});if(invoice){dispatch({type:'FETCH_INVOICE',invoice:Object.assign({},res.data,{items:invoice.items,related:invoice.related,payout_accounts:invoice.payout_accounts})});}if(companyGeneralInvoices&&companyGeneralInvoices.data&&companyGeneralInvoices.data.length>0){var newCompanyGeneralInvoices=Object.assign({},companyGeneralInvoices);var index=companyGeneralInvoices.data.findIndex(function(item){return item.id===generalInvoiceId;});newCompanyGeneralInvoices.data[index]=res.data;dispatch({type:'FETCH_COMPANY_GENERAL_INVOICES',companyGeneralInvoices:newCompanyGeneralInvoices});}}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err&&err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);var relatedName=invoice.related&&invoice.related.name||"El beneficiario";switch(error.code){case"EF607":__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:json_lang.custom_errors.target_invalid_payment_method.replace("{target}",relatedName)});break;default:__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:error.message});break;}}else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:json_lang.two_steps_modal.default_error});}});};};var editGeneralInvoices=function editGeneralInvoices(generalInvoiceId,body){return function(dispatch,getState){var _getState71=getState(),company=_getState71.company,json_lang=_getState71.json_lang,invoice=_getState71.invoice,companyGeneralInvoices=_getState71.companyGeneralInvoices;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/general-invoices/'+generalInvoiceId,body).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});if(invoice){dispatch({type:'FETCH_INVOICE',invoice:Object.assign({},res.data,{items:invoice.items,related:invoice.related,payout_accounts:invoice.payout_accounts})});}if(companyGeneralInvoices&&companyGeneralInvoices.data&&companyGeneralInvoices.data.length>0){var newCompanyGeneralInvoices=Object.assign({},companyGeneralInvoices);var index=companyGeneralInvoices.data.findIndex(function(item){return item.id===generalInvoiceId;});newCompanyGeneralInvoices.data[index]=res.data;dispatch({type:'FETCH_COMPANY_GENERAL_INVOICES',companyGeneralInvoices:newCompanyGeneralInvoices});}}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err&&err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);switch(error.code){default:__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:error.message});break;}}else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:json_lang.two_steps_modal.default_error});}});};};var deleteGeneralInvoices=function deleteGeneralInvoices(generalInvoiceId,type,providerId){return function(dispatch,getState){var _getState72=getState(),company=_getState72.company,json_lang=_getState72.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/general-invoices/'+generalInvoiceId).then(function(res){/*dispatch({
                type: 'FETCH_GENERAL_INVOICES',
                generalInvoices: res.data
            })*/if(type==='provider'){console.log("match",window.location);window.location.href='/provider-management/billings-'+providerId;}else if(type==='companyLot'){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.delete_successful});}else{window.location.href='/company-billings';}}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err&&err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);switch(error.code){default:__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:error.message});break;}}else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:json_lang.two_steps_modal.default_error});}});};};var GetInvoice=function GetInvoice(generalInvoiceId){return function(dispatch,getState){var _getState73=getState(),company=_getState73.company,json_lang=_getState73.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/general-invoices/'+generalInvoiceId+'?with=items.order.branch,related,city').then(function(res){console.log("GetInvoice",res.data);dispatch({type:'FETCH_INVOICE',invoice:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var sendTwoStepsVerification=function sendTwoStepsVerification(url,method,body){return function(dispatch,getState){var _getState74=getState(),json_lang=_getState74.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */][method](url,body).then(function(res){// Notification.show({ 
//     type: "success", 
//     title: json_lang.common.success, 
//     msg: json_lang.custom_success.update_successful
// });
dispatch({type:'TWO_STEPS',twoSteps:{error:false,data:res}});}).catch(function(err){var error=err.data;switch(error.error_code){case"ET101":dispatch({type:'TWO_STEPS',twoSteps:{error:true,message:json_lang.two_steps_modal.wrong_two_steps_code}});break;case"ET102":__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:json_lang.two_steps_modal.not_found_signature});dispatch({type:'TWO_STEPS',twoSteps:{error:true}});break;default:dispatch({type:'TWO_STEPS',twoSteps:{error:true,message:json_lang.two_steps_modal.default_error}});break;}});};};var setBalanceModifier=function setBalanceModifier(body,type,balanceModifierId){return function(dispatch,getState){var _getState75=getState(),company=_getState75.company;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */][type](__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/balance-modifiers'+(balanceModifierId?'/'+balanceModifierId:""),body).then(function(){dispatch({type:"REMOVE_LOADING"});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err&&err.data&&err.data.description});});};};var findReference=function findReference(reference){return function(dispatch,getState){var _getState76=getState(),company=_getState76.company;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/sim-bots/search?code='+reference).then(function(res){dispatch({type:"GET_PAYMENT_REFERENCE",paymentReference:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err&&err.data&&err.data.description});});};};var applyPayment=function applyPayment(orderId,referenceId){return function(dispatch,getState){var _getState77=getState(),company=_getState77.company,errorOnPaymentReference=_getState77.errorOnPaymentReference,json_lang=_getState77.json_lang;if(errorOnPaymentReference){dispatch({type:"ERROR_ON_PAYMENT_REFERENCE",errorOnPaymentReference:null});}return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/sim-bots/'+referenceId+'/set-accepted',{order_id:orderId}).then(function(res){dispatch({type:"GET_PAYMENT_REFERENCE",paymentReference:res.data});}).catch(function(err){if(err&&err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);console.log("error",error);dispatch({type:"ERROR_ON_PAYMENT_REFERENCE",errorOnPaymentReference:error});}else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:"Error",msg:json_lang.custom_errors.default_error});}});};};var clearPaymentReference=function clearPaymentReference(){return function(dispatch){dispatch({type:"CLEAR_PAYMENT_REFERENCE",paymentReference:{approved:[],pending:[]},errorOnPaymentReference:null});};};var updateGeneralInvoice=function updateGeneralInvoice(payload){return function(dispatch,getState){var _getState78=getState(),companyGeneralInvoices=_getState78.companyGeneralInvoices,invoice=_getState78.invoice;if(companyGeneralInvoices&&companyGeneralInvoices.data&&companyGeneralInvoices.data.length>0){var index=companyGeneralInvoices.data.findIndex(function(invoice){return invoice.id===payload.id;});if(index!==-1){var newCompanyGeneralInvoices=Object.assign({},companyGeneralInvoices);newCompanyGeneralInvoices.data[index]=Object.assign({},companyGeneralInvoices.data[index],payload);dispatch({type:"FETCH_COMPANY_GENERAL_INVOICES",companyGeneralInvoices:newCompanyGeneralInvoices});}}if(invoice&&invoice.id===payload.id){dispatch({type:"FETCH_INVOICE",invoice:Object.assign({},invoice,payload)});}};};var clearInvoice=function clearInvoice(){return function(dispatch){dispatch({type:'FETCH_INVOICE',invoice:null});};};

/***/ }),
/* 32 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(382);


/***/ }),
/* 34 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 35 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(72);
var defined = __webpack_require__(99);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = warn;
exports._resetWarned = _resetWarned;

var _warning = __webpack_require__(57);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {}; /**
                  * This code is copied from: https://github.com/ReactTraining/react-router/blob/master/modules/routerWarning.js
                  */

function warn(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (!falseToWarn && message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }
    warned[message] = true;
  }

  message = '[react-bootstrap-typeahead] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return clearCancelOrderError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return fetchShopperChats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return fetchProviderChats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return clearChats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return getOrderFleets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return setOrderFleet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return clearProviderOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return recreateOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return clearErrorOnRecreateOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return getOrderedGood; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addOrderedGood; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return editOrderedGood; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return deleteOrderedGood; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return fetchOrderHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return clearOrderHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return clearOrderHistoryError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return clearOrderedGood; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return clearErrorOnOrderedGood; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return getClientCarts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return updateCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addItemToCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return updateItemFromCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return clearItemsFromCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return removeItemFromCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return cartCheckout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return checkForPromoCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return saveOrderPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return getClientOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return clearClientOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return generateOrderCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return setReadyOrderCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return getOrderCouponCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return setOrderPostPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return changeStatusOrderProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return fetchHistoryGivechange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return clearOrderGiveChange; });
/* unused harmony export toogleOrderGiveChange */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return orderGiveChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return setOrderPrivatePool; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return setOrderPublicPool; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return fetchOrdersByStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return getTimelineOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return toogleAssingProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return findOrderWithAvaliableProviders; });
/* unused harmony export editQuantity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return dataAsignableOrderParse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return assigMultiProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return clearBids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return clearPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return fetchTodayOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return fetchMapOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return markAsTouched; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return clearMapFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return filterOrdersInsideDateRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return filterOrdersAssigned; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return filterOrdersUnassigned; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return fetchOrdersByUserType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return fetchOrdersByProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return filterOrderByStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return fetchArchivedOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return resetDataDetailsOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return unassignProviderFromTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return updateProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return updateMapProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return removeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return fetchOrders; });
/* unused harmony export addScheduleToOrder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return cancelOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return confirmOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return modifyInvoice; });
/* unused harmony export addInstructionsToOrder */
/* unused harmony export addClientAddressToOrder */
/* unused harmony export addProviderToOrder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return toggleData; });
/* unused harmony export addPickupOptionToOrder */
/* unused harmony export addDeliveryMethodToOrder */
/* unused harmony export addPropertiesToOrder */
/* unused harmony export saveOrder */
/* unused harmony export addToCart */
/* unused harmony export removeGoodsFromOrder */
/* unused harmony export removePropertyFromOrder */
/* unused harmony export addQuantity */
/* unused harmony export substractQuantity */
/* unused harmony export addClientToOrder */
/* unused harmony export update */
/* unused harmony export register */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return fetchOrderDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return fetchProofOfDelivery; });
/* unused harmony export destroy */
/* unused harmony export registerNewOrder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return fetchOrderForms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return acceptOrderPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return completeOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return beginOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return deliverOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return fetchOrderCancelationReason; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return fillDashboardStatistics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return fillDashboardMonthStatistics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return fillDashboardDayStatistics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return drawMonthStatistics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return newStadistic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return fetchOrderBids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return confirmOrderBid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return cancelOrderBid; });
/* unused harmony export preloadOrderCart */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return clearCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return updateOrderView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return updateOrdersView; });
/* unused harmony export drawDasboard */
/* unused harmony export addProviderToService */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return beingPreparedOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return preparedOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return drawMonthStatisticsID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return confirmationToggle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return toogleOrdeParcialGiveChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return orderpParcialGivechange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return clearOrderParcialGivechange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return updateShopper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return resendPool; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return adminNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addAttachment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return fetchOrdersBranchHeatmap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handlers_Errors__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tableActions__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_general__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UtilsOperation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__handlers_utils__ = __webpack_require__(258);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var priotizeOrders=function priotizeOrders(priority,orders){var orderList=[],auxList=[];switch(priority){case"unassigned":orders.forEach(function(item){if(item.is_shopper_allowed){if(!item.is_shopper_assigned){orderList.push(item);}else if(!item.is_status_prepared){auxList.push(item);}else if(!item.is_provider_assigned){orderList.push(item);}else{auxList.push(item);}}else if(!item.is_provider_assigned){orderList.push(item);// sin asignar
}else auxList.push(item);});return[orderList.concat(auxList),orderList.length,auxList.length];default:break;}};var find=function find(id){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/orders/'+id).then(function(res){dispatch({type:'FETCH_ORDER',order:res.data});}).catch(function(err){var dataError=Object(__WEBPACK_IMPORTED_MODULE_1__handlers_Errors__["a" /* default */])(err);dispatch({type:'ERROR',errors:dataError});});};};var findOrderWithAvaliableProviders=function findOrderWithAvaliableProviders(){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState=getState(),company=_getState.company,bids=_getState.bids,order=_getState.order,goodsList=_getState.goodsList,json_lang=_getState.json_lang;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/providers?limit=0&with=skills,account,accesses').then(function(res){var setPosition=res.data.map(function(provider){provider.position=[parseInt(provider.latitude_e6,10)/1000000,parseInt(provider.longitude_e6,10)/1000000];return provider;});var asignableProviders=setPosition.filter(function(asignable,key){var found=void 0;var isAsignable=asignable;if(bids){found=bids.find(function(bidsProvider){return bidsProvider.provider_id===asignable.id;});if(found){isAsignable=asignable.id!==found.provider_id;}}return isAsignable;});var goodsInOrder=order&&order.ordered_goods.map(function(ordered_good,key){return ordered_good.good_id;});var providerForGoods=goodsList.filter(function(good){return goodsInOrder.includes(good.id);});// let productosConProveedoresAsignables = [];
// if(asignableProviders){
//     productosConProveedoresAsignables = order && order.ordered_goods.map((ordered_good, key) => {
//         var addtest = providerForGoods.find((providerForGood) => providerForGood.id === ordered_good.good_id);
//         asignableProviders.filter((asignable) => addtest && addtest.allowed_providers.includes(asignable.id));
//         ordered_good.allowed_providers =  asignableProviders.filter((asignable) => addtest && addtest.allowed_providers.includes(asignable.id));
//         ordered_good.assigned_provider = null;
//         return ordered_good;
//     })
// }
dispatch({type:'FETCH_ORDER',order:order});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.retrieving_user_list});});};};var fetchOrders=function fetchOrders(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var search_query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var filter_query=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var sort=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var city_id=arguments.length>4&&arguments[4]!==undefined?arguments[4]:"all";var limit=arguments.length>5&&arguments[5]!==undefined?arguments[5]:20;return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});//orderProviders.provider
var _getState2=getState(),company=_getState2.company,branch=_getState2.branch,session=_getState2.session;var url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders?page='+page+'&with=client,branch.city,creator,taxes.coupon&limit='+limit;if(branch&&branch.id){url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id+'/orders?page='+page+'&with=client,creator,taxes.coupon&limit='+limit;}url_host+=search_query!==''?'&search='+search_query:'';url_host+=filter_query!==''?'&'+filter_query:'';url_host+=sort!==''?'&sort_by='+sort.columnName+','+sort.direction:'';url_host+=city_id!=="all"?'&city_id='+city_id:'';return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(url_host).then(function(res){for(var i=0;i<res.data.data.length;++i){__WEBPACK_IMPORTED_MODULE_5_moment___default()(res.data.data[i].updated_at).diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(res.data.data[i].created_at))<15000?res.data.data[i].touched=false:res.data.data[i].touched=true;}// let dataToDraw = res.data.data;
// if( session && session.admin_type && session.admin_type.id && parseInt(session.admin_type.id,10) === 2 ){
//     dataToDraw = res.data.data.filter((order) =>  order.status_data.payment_confirmed === true )
// }
dispatch({type:'FETCH_ORDERS',orders:res.data,archived_orders:[]});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Acceso denegado al intentar obtener listado de ordenes'});});};};var fetchProofOfDelivery=function fetchProofOfDelivery(id){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/orders/'+id+'/proof-of-deliveries').then(function(res){dispatch({type:'FETCH_PROOF_DELIVERY',proofDelivery:res.data});}).catch(function(err){console.log(err);});};};var resetDataDetailsOrder=function resetDataDetailsOrder(){return function(dispatch,getState){dispatch({type:'RESET_DATA_DETAILS_ORDER',orderDetails:{client_id:"",client_latitude_e6:0,client_longitude_e6:0,scheduled_at:"",notes:"",goods:[],providers_id:"",propertiesGood:[],taxes:[]}});};};var updateOrderView=function updateOrderView(order){return function(dispatch,getState){var _getState3=getState(),orderDetails=_getState3.orderDetails;dispatch({type:'FETCH_ORDER_DETAILS',orderDetails:Object.assign({},orderDetails,order)});};};var updateOrdersView=function updateOrdersView(new_order,type){return function(dispatch,getState){var branch=Object.assign({},getState().branch);var orders_list=Object.assign({},getState().orders);var order=Object.assign({},getState().order);var newOrderId=new_order.order_id?new_order.order_id:new_order.id;if(orders_list.data){if(type==="neworder"){var findOrder=orders_list.data.find(function(order){return order.id===newOrderId;});if(findOrder){return;}else{if(branch.id){if(branch.id===new_order.branch_id){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/orders/'+newOrderId+'?with=taxes.coupon,taxes.author.admin,order_providers,branch').then(function(res){new_order=res.data;orders_list=Object.assign({},orders_list,{data:[].concat(_toConsumableArray(orders_list.data)).concat(new_order)});orders_list.data=[].concat(_toConsumableArray(orders_list.data));setTimeout(function(){dispatch({type:'FETCH_ORDERS',orders:orders_list,archived_orders:[]});if(order&&order.id){if(order.id===newOrderId){dispatch({type:'FETCH_ORDER',order:new_order});}}},100);}).catch(function(err){console.log(err);});}else{if(order&&order.id){if(order.id===newOrderId){dispatch({type:'FETCH_ORDER',order:new_order});}}else{return;}}}else{return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/orders/'+newOrderId+'?with=taxes.coupon,taxes.author.admin,order_providers,branch').then(function(res){new_order=res.data;orders_list=Object.assign({},orders_list,{data:[].concat(_toConsumableArray(orders_list.data)).concat(new_order)});orders_list.data=[].concat(_toConsumableArray(orders_list.data));setTimeout(function(){dispatch({type:'FETCH_ORDERS',orders:orders_list,archived_orders:[]});if(order&&order.id){if(order.id===newOrderId){dispatch({type:'FETCH_ORDER',order:new_order});}}},100);}).catch(function(err){console.log(err);});}}}else{var index=orders_list.data.findIndex(function(order){return order.id===newOrderId;});if(index!==-1){orders_list.data[index]=Object.assign({},orders_list.data[index],new_order);orders_list.data=[].concat(_toConsumableArray(orders_list.data));setTimeout(function(){dispatch({type:'FETCH_ORDERS',orders:orders_list,archived_orders:[]});},100);}if(order&&order.id){if(order.id===newOrderId){setTimeout(function(){dispatch({type:'FETCH_ORDER',order:new_order});},100);}}}setTimeout(function(){dispatch({type:'FETCH_ORDERS',orders:orders_list,archived_orders:[]});if(order&&order.id){if(order.id===newOrderId){dispatch({type:'FETCH_ORDER',order:new_order});}}},100);}};};var fetchOrderDetails=function fetchOrderDetails(id){var withAddresses=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/orders/'+id+'?with=taxes.coupon,taxes.author.admin,creator,order_providers,branch'+(withAddresses?',client.addresses':'')).then(function(res){dispatch({type:'FETCH_ORDER_DETAILS',orderDetails:res.data});}).catch(function(err){var dataError=Object(__WEBPACK_IMPORTED_MODULE_1__handlers_Errors__["a" /* default */])(err);dispatch({type:'ERROR',errors:dataError});});};};var toggleData=function toggleData(value){var update='';return function(dispatch,getState){var data=Object.assign({},getState().order);if(value.name==="goods_id"){data.propertiesGood=[];}if(value.name==="propertiesGood"){var find=data.propertiesGood.find(function(item){return item===value.data;});if(find){update=data.propertiesGood.filter(function(item){return item!==value.data&&item!=="";});}else{update=data.propertiesGood.concat(value.data);}data.propertiesGood=update;}else{data[value.name]=value.data;}dispatch({type:'FETCH_ORDER',order:data});};};var addPickupOptionToOrder=function addPickupOptionToOrder(data){var obj=Object.assign({},__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().cart);obj.isPickup=data==="pickup";obj.client_address=null;return{type:'BUILD_ORDER',cart:obj,provider:undefined};};var addInstructionsToOrder=function addInstructionsToOrder(notes){var obj=Object.assign({},__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().cart);obj.notes=notes;return{type:'BUILD_ORDER',cart:obj};};var addDeliveryMethodToOrder=function addDeliveryMethodToOrder(data){var obj=Object.assign({},__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().cart);obj.delivery_method=data;if(data==="asap")obj.scheduled_at="";return{type:'BUILD_ORDER',cart:obj};};var addClientAddressToOrder=function addClientAddressToOrder(address){var obj=Object.assign({},__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().cart);//let addr = store.getState().order_client_address_query;
if(address){obj.client_address=address.display_name;obj.client_latitude_e6=parseInt((parseFloat(address.lat)*1000000).toFixed(),10);obj.client_longitude_e6=parseInt((parseFloat(address.lon)*1000000).toFixed(),10);return{type:'BUILD_ORDER',cart:obj};}else{/* xHACER: q tome lo q selecciono antes y le adjunte lo q escribio luego *//*  Notification.show({
            type: 'error',
            title:'',
            msg:store.getState().json_lang.custom_errors.select_complete_address
        }); */delete obj.client_address;obj.client_latitude_e6=0;obj.client_longitude_e6=0;return{type:'BUILD_ORDER',cart:obj};}};var addScheduleToOrder=function addScheduleToOrder(schedule){var obj=Object.assign({},__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().cart);obj.scheduled_at=__WEBPACK_IMPORTED_MODULE_5_moment___default.a.utc(schedule).format("YYYY-MM-DD HH:mm:ss");return{type:'BUILD_ORDER',cart:obj};};var addClientToOrder=function addClientToOrder(data){return{type:'ASSIGN_CLIENT_TO_ORDER',client:data};};var addProviderToOrder=function addProviderToOrder(data){return{type:'ASSIGN_PROVIDER_TO_ORDER',provider:data,isPickup:false};};var addPropertiesToOrder=function addPropertiesToOrder(data,good_id,input_type){var prevAddedProperty=void 0,obj=Object.assign({},__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().cart),prevAddedGood=obj.goods.findIndex(function(item){return item.id===good_id;});data.temp_base_price=data.price;if(obj.goods[prevAddedGood].properties===undefined){obj.goods[prevAddedGood]["properties"]=[];obj.goods[prevAddedGood].properties.push(data);}else{data.price=data.temp_base_price*obj.goods[prevAddedGood].quantity;switch(input_type){case"checkbox":prevAddedProperty=obj.goods[prevAddedGood].properties.findIndex(function(item){// debo preguntar si ya existe este value y eliminarlo si vuelve a llegar
return item.value===data.value;});if(prevAddedProperty!==-1)// si ya existe la property
obj.goods[prevAddedGood].properties=obj.goods[prevAddedGood].properties.filter(function(item,idx,properties){return item.value!==properties[prevAddedProperty].value;});else obj.goods[prevAddedGood].properties.push(data);break;default:prevAddedProperty=obj.goods[prevAddedGood].properties.findIndex(function(item){return item.property_id===data.property_id;});if(prevAddedProperty!==-1)// si ya existe la property
obj.goods[prevAddedGood].properties[prevAddedProperty]=data;else obj.goods[prevAddedGood].properties.push(data);break;}}return{type:'BUILD_ORDER',cart:obj};};var update=function update(data,type){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var properties={name:data.name,type:data.type,mandatory:data.mandatory?data.mandatory:false};if(type===256){properties.property_options=data.property_options;}else if(type===512){properties.property_range=data.property_range;}else if(type===1024){properties.property_text=data.property_text;}__WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].put(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/properties/'+data.id,properties).then(function(res){}).catch(function(err){var dataError=Object(__WEBPACK_IMPORTED_MODULE_1__handlers_Errors__["a" /* default */])(err);dispatch({type:'ERROR',errors:dataError});});};};var register=function register(data,type){return function(dispatch,getState){var properties={name:data.name,type:data.type,mandatory:data.mandatory?data.mandatory:false};if(type===256){properties.property_options=data.property_options;}else if(type===512){properties.property_range=data.property_range;}else if(type===1024){properties.property_text=data.property_text;}__WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/properties',properties).then(function(res){}).catch(function(err){var dataError=Object(__WEBPACK_IMPORTED_MODULE_1__handlers_Errors__["a" /* default */])(err);dispatch({type:'ERROR',errors:dataError});});};};var destroy=function destroy(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});__WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/accounts/'+id).then(function(res){var newdata=Object(__WEBPACK_IMPORTED_MODULE_4__tableActions__["i" /* tableRemoveAcount */])(res);dispatch({type:'SET_TABLE',table:newdata});}).catch(function(err){var dataError=Object(__WEBPACK_IMPORTED_MODULE_1__handlers_Errors__["a" /* default */])(err);dispatch({type:'ERROR',errors:dataError});});};};var addToCart=function addToCart(good){var propertyQuantity;return function(dispatch,getState){var cart=Object.assign({},getState().cart);good.stock=good.quantity;good.quantity=good.apiQuantity>0?good.apiQuantity:1;good.total_price_e2=good.min_price_e2;//price_e2;
cart.goods.push(good);good.provider_id='';var itemsQuantity={id:good.good_id,stock:good.stock,quantity:good.quantity};if(good.properties.length>0){good.properties.map(function(goodProperty,key){var multiOptionInputs=goodProperty.type==='checkbox'||goodProperty.type==='select-one'||goodProperty.type==='radio';propertyQuantity={id:multiOptionInputs?goodProperty.value+'-'+goodProperty.property_id:goodProperty.property_id,stock:goodProperty.quantity!=null?parseInt(goodProperty.quantity,10):__WEBPACK_IMPORTED_MODULE_7__constants_general__["_43" /* UNLIMITED_STOCK */],quantity:goodProperty.type==='range'?parseInt(goodProperty.value,10):good.quantity};var propertiesInCart=cart.propertiesQuantity.find(function(pQuantity,key){return pQuantity.id===propertyQuantity.id;});if(goodProperty.type==='range'){goodProperty.value=String(goodProperty.value);}if(!propertiesInCart){cart.propertiesQuantity.push(propertyQuantity);}else{cart.propertiesQuantity.map(function(pQuantity,key){if(pQuantity.id===propertyQuantity.id){pQuantity.quantity=pQuantity.quantity+propertyQuantity.quantity;}return propertyQuantity;});}return goodProperty;});}var goodIsInCart=cart.goodsQuantity.find(function(goodQuantity,key){return goodQuantity.id===itemsQuantity.id;});if(!goodIsInCart){cart.goodsQuantity.push(itemsQuantity);}else{cart.goodsQuantity.map(function(goodQuantity,key){if(goodQuantity.id===itemsQuantity.id){goodQuantity.quantity++;}return goodQuantity;});}dispatch({type:'BUILD_ORDER',cart:cart});};};var removeGoodsFromOrder=function removeGoodsFromOrder(idx){return function(dispatch,getState){var cart=Object.assign({},getState().cart);cart.goodsQuantity.map(function(goodQuantity,Gkey){if(goodQuantity.id===cart.goods[idx].id){goodQuantity.quantity=goodQuantity.quantity-cart.goods[idx].quantity;}if(goodQuantity.quantity<=0){cart.goodsQuantity.splice(Gkey,1);}return goodQuantity;});cart.propertiesQuantity.filter(function(pQuantity,Pkey){var propertyRemoved=cart.goods[idx].properties.find(function(property,Pkey){var multiOptionInputs=property.type==='checkbox'||property.type==='select-one'||property.type==='radio';var idReference=multiOptionInputs?property.value+'-'+property.property_id:property.property_id;return idReference===pQuantity.id;});if(propertyRemoved){if(propertyRemoved.type==='range'){pQuantity.quantity=pQuantity.quantity-propertyRemoved.value;}else{pQuantity.quantity=pQuantity.quantity-cart.goods[idx].quantity;}}return pQuantity;});cart.goods.splice(idx,1);dispatch({type:'BUILD_ORDER',cart:cart});};};var addQuantity=function addQuantity(idx){return function(dispatch,getState){var cart=Object.assign({},getState().cart);cart.goods[idx].quantity++;cart.goods[idx].total_price_e2=cart.goods[idx].price_e2*cart.goods[idx].quantity;//cart.goods[idx].total_price_e2 +;
cart.goods[idx].properties.map(function(goodProprerty,propKey){goodProprerty.price=goodProprerty.temp_base_price*cart.goods[idx].quantity;var multiOptionInputs=goodProprerty.type==='checkbox'||goodProprerty.type==='select-one'||goodProprerty.type==='radio';var idReference=multiOptionInputs?goodProprerty.value+'-'+goodProprerty.property_id:goodProprerty.property_id;cart.propertiesQuantity.map(function(pQuantity,key){if(pQuantity.id===idReference){pQuantity.quantity=goodProprerty.type==='range'?parseInt(goodProprerty.value,10)*cart.goods[idx].quantity:pQuantity.quantity+1;}return pQuantity;});return goodProprerty;});cart.goodsQuantity.map(function(goodQuantity,key){if(goodQuantity.id===cart.goods[idx].id){goodQuantity.quantity++;}return goodQuantity;});dispatch({type:'BUILD_ORDER',cart:cart});};};var substractQuantity=function substractQuantity(idx){return function(dispatch,getState){var cart=Object.assign({},getState().cart);cart.goods[idx].quantity=cart.goods[idx].quantity>1?cart.goods[idx].quantity-1:1;cart.goods[idx].total_price_e2=cart.goods[idx].total_price_e2-cart.goods[idx].price_e2;cart.goods[idx].properties.map(function(goodProprerty,propKey){goodProprerty.price=goodProprerty.temp_base_price*cart.goods[idx].quantity;var multiOptionInputs=goodProprerty.type==='checkbox'||goodProprerty.type==='select-one'||goodProprerty.type==='radio';var idReference=multiOptionInputs?goodProprerty.value+'-'+goodProprerty.property_id:goodProprerty.property_id;cart.propertiesQuantity.map(function(pQuantity,key){if(pQuantity.id===idReference){var bandera=0;var deflt=1;if(goodProprerty.type==='range'){bandera=pQuantity.quantity-parseInt(goodProprerty.value,10);deflt=goodProprerty.value;}else{bandera=pQuantity.quantity-1;}pQuantity.quantity=bandera>0?bandera:deflt;}return goodProprerty;});return goodProprerty;});cart.goodsQuantity.map(function(goodQuantity,key){if(goodQuantity.id===cart.goods[idx].id){if(goodQuantity.quantity>0){goodQuantity.quantity--;}else{goodQuantity.quantity=1;}}return goodQuantity;});dispatch({type:'BUILD_ORDER',cart:cart});};};var removePropertyFromOrder=function removePropertyFromOrder(property_key,good_key){return function(dispatch,getState){var cart=Object.assign({},getState().cart);var cartPropery=cart.goods[good_key].properties[property_key];cart.propertiesQuantity.map(function(pQuantity,key){var multiOptionInputs=cartPropery.type==='checkbox'||cartPropery.type==='select-one'||cartPropery.type==='radio';var idReference=multiOptionInputs?cartPropery.value+'-'+cartPropery.property_id:cartPropery.property_id;if(pQuantity.id===idReference){pQuantity.quantity=cartPropery.type==='range'?pQuantity.quantity=pQuantity.quantity-cartPropery.value:pQuantity.quantity=pQuantity.quantity-cart.goods[good_key].quantity;}return pQuantity;});cart.goods[good_key].properties.splice(property_key,1);dispatch({type:'BUILD_ORDER',cart:cart});};};var fetchArchivedOrders=function fetchArchivedOrders(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var search_query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var filter_query=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var sort=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var city_id=arguments.length>4&&arguments[4]!==undefined?arguments[4]:"all";var dates=arguments.length>5&&arguments[5]!==undefined?arguments[5]:null;return function(dispatch,getState){var _getState4=getState(),branch=_getState4.branch;var url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/orders?page='+page+'&with=branch,orderProviders.provider,client,creator,taxes.coupon&mode=deleted';if(dates){url_host+='&created_at=between '+dates.dateStart+' 00:00:00,'+dates.dateEnd+' 23:59:59';}dispatch({type:"WAIT_FOR_RESPONSE"});if(branch&&branch.id){url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/branches/'+branch.id+'/orders?page='+page+'&with=branch,orderProviders.provider,client,creator,taxes.coupon&mode=deleted';}url_host+=search_query!==''?'&search='+search_query:'';url_host+=filter_query!==''?'&'+filter_query:'';url_host+=sort!==''?'&sort_by='+sort.columnName+','+sort.direction:'';url_host+=city_id!=="all"?'&city_id='+city_id:'';return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(url_host).then(function(res){dispatch({type:'FETCH_ARCHIVED_ORDERS',archived_orders:res.data,orders:[]});return res.data;}).catch(function(err){console.log("FETCH_ARCHIVED_ORDERS",err);dispatch({type:'ERROR',errors:""});});};};var addProviderToService=function addProviderToService(goodKey,providerId){return function(dispatch,getState){var cart=Object.assign({},getState().cart);if(providerId){var goodsIsInCart=cart.goods.map(function(good,key){if(key===goodKey){good.provider_id=providerId.id;}return good;});cart.goods=goodsIsInCart;dispatch({type:'BUILD_ORDER',cart:cart});}};};var fetchOrdersByUserType=function fetchOrdersByUserType(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var search_query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var filter_query=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var isClient=arguments[3];var userId=arguments[4];return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id;url_host+=isClient?'/clients/':'/providers/';url_host+=userId+'/orders?page='+page+'&mode=all';//url_host += (search_query !== '') ? ('&search=' + search_query) : '';
url_host+=filter_query!==''?'&'+filter_query:'';url_host+=isClient?'&with=order_providers.provider':'&with=order';__WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(url_host).then(function(res){dispatch({type:'FETCH_ARCHIVED_ORDERS',archived_orders:res.data,orders:[]});}).catch(function(err){var dataError=Object(__WEBPACK_IMPORTED_MODULE_1__handlers_Errors__["a" /* default */])(err);dispatch({type:'ERROR',errors:dataError});dispatch({type:"WAIT_FOR_RESPONSE"});});};};var fetchOrdersByProvider=function fetchOrdersByProvider(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var search_query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var filter_query=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var isClient=arguments[3];var userId=arguments[4];var sort=arguments[5];return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});// ${sort? `&sort_by=${sort.columnName},${sort.direction}` :``}
// let url_host = `${URL + getState().company.id}/providers/${userId}/order-providers?page=${page}&with=order_providers.order`;
var url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/providers/'+userId+'/order-providers?page='+page+(sort?'&sort_by='+sort.columnName+','+sort.direction:'');__WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(url_host).then(function(res){dispatch({type:'FETCH_PROVIDER_ORDERS',providerOrders:res.data});}).catch(function(err){var dataError=Object(__WEBPACK_IMPORTED_MODULE_1__handlers_Errors__["a" /* default */])(err);dispatch({type:'ERROR',errors:dataError});dispatch({type:"REMOVE_LOADING"});});};};var saveOrder=function saveOrder(_ref,client_id,provider_id,searchType,forceProvider){var data=_objectWithoutProperties(_ref,[]);return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState5=getState(),company=_getState5.company,branch=_getState5.branch,json_lang=_getState5.json_lang,cart=_getState5.cart,order_client_address_query=_getState5.order_client_address_query;var options=parseInt(company.options,10);var isPickupSelected=cart.isPickup;var shiftService=searchType==="0"?0:12;if(provider_id){data.provider_id=provider_id;}data.client_address=data.client_address||order_client_address_query;if(!data.scheduled_at)delete data.scheduled_at;/* si la orden va por delivery */if((options&512<<shiftService)===0&&!isPickupSelected){}/* if(!client_id){
                Notification.show({type: "error", title:"", msg:json_lang.custom_errors.insert_client });
                return;
            }
            if(!data.client_address){
                Notification.show({type: "error", title:"", msg:json_lang.custom_errors.insert_client_addres });ç
                return ;
            }
            else if(data.client_address.length > 255){
                Notification.show({type: "error", title:"", msg:json_lang.custom_errors.client_addres_to_long});
                return ;
            }
            if(data.goods.length === 0){
                Notification.show({type: "error", title:"", msg:json_lang.custom_errors.empty_shopping_cart});
                return ;
            }
            *//* si la orden va por pickup */else if((options&256<<shiftService)!==0&&isPickupSelected){/* if(!client_id){
                Notification.show({type: "error", title:"", msg:json_lang.custom_errors.insert_client});
                return;
            } */if(data.goods.length===0){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:"",msg:json_lang.custom_errors.empty_shopping_cart});return;}delete data.provider_id;delete data.client_address;data.client_latitude_e6=0;data.client_longitude_e6=0;}if(data.provider_id===""){delete data.provider_id;}if(data.client_address===""){delete data.client_address;}if(!client_id){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:"",msg:json_lang.custom_errors.insert_client});return;}var new_goods=data.goods.map(function(good,idx){return{good_id:good.id,quantity:good.quantity,properties:good.properties,provider_id:provider_id?provider_id:good.provider_id};});data.goods=new_goods;if(forceProvider){data.force_providers=[forceProvider];}// dani was here
if(!company.settings.enable_multi_providers){new_goods=data.goods.map(function(good,idx){return{good_id:good.good_id,quantity:good.quantity,properties:good.properties};});data.goods=new_goods;}return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id+'/clients/'+client_id+'/orders',data).then(function(res){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:'ORDER_REGISTERED',order:res.data,reset_inputs:true});}).catch(function(err){if(err.message&&err.message!=='generic'){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});}else{var msg=err.data.message.match(/([a-z_]+) [0-9]+ ([a-z 0-9áéíóúñ]+)/i);// error format: "type_of_error ID Item Name"  // type its a specific error code, id its a number, alphanumeric item name
if(msg&&msg[1]==='good_no_stock'){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:json_lang.custom_errors.insufficient_stock_title,msg:json_lang.custom_errors.insufficient_stock_msg});}else if(msg&&msg[1]==='property_no_stock'){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:json_lang.custom_errors.insufficient_stock_title,msg:json_lang.custom_errors.unavailable_product__msg.replace("{type}",json_lang.common.property).toLowerCase().replace("{item}",msg[2])});}else if(msg&&msg[1]==='good_not_available'){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:json_lang.custom_errors.insufficient_stock_title,msg:json_lang.custom_errors.unavailable_product__msg.replace("{type}",json_lang.common.good).toLowerCase().replace("{item}",msg[2])});}else if(msg&&msg[1]==='mixes_order_type'){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.unavailable_product__msg.replace("{type}",json_lang.common.good).toLowerCase().replace("{item}",msg[2])});}else if(msg&&msg[1]==='mixes_order_type'){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"La orden no puede contener producctos y servicios"});}else{__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:json_lang.custom_errors.order_registration_failed});}}});};};var registerNewOrder=function registerNewOrder(){return{type:"REGISTER_NEW_ORDER"};};var updateShopper=function updateShopper(orderq,provider,action){//solo funciona con órdenes sin proveedor
var provider_id=typeof provider==='number'?provider:provider[0].id;return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState6=getState(),company=_getState6.company,json_lang=_getState6.json_lang;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */][action](''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+orderq+'/shoppers/'+provider_id).then(function(res){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){if(err&&err.data&&err.data.error_code){var error=err.data;var message=error.description||error.message;var title=error.error_code;switch(error.error_code){case"ED202":case"ED203":message="El shopper no se encuentra en línea";break;case"EC318":message="Shopper no asignable, no pertenece a este comercio";break;case"EC149":message="No puede realizar compras y entregas al mismo tiempo, por favor complete las ordenes pendientes.";break;default:break;}__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:title,msg:message});}else{__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:"Error",msg:json_lang.custom_errors.provider_attach_failed});}});};};var updateProvider=function updateProvider(orderq,provider){//solo funciona con órdenes sin proveedor
var provider_id=typeof provider==='number'?provider:provider[0].id;return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState7=getState(),order=_getState7.order,company=_getState7.company,json_lang=_getState7.json_lang;var ordered_goods=order?[].concat(_toConsumableArray(order.ordered_goods)):[];var data=ordered_goods.map(function(ordered_good){return{ordered_good_id:ordered_good.id,provider_id:provider_id};}).filter(function(ordered_good){return ordered_good.provider_id;});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].put(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+(orderq||order.id)+'/providers',data).then(function(res){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){if(err&&err.data&&err.data.error_code){var error=err.data;var message=error.description||error.message;var title=error.error_code;switch(error.error_code){case"ES074":message="El repartidor seleccionado no pertenece a la flota actual de la orden";break;case"ED202":case"ED203":message="El repartidor no se encuentra en línea";break;case"EC318":message="Repartidor no asignable, no pertenece a este comercio";break;case"EC149":message="No puede realizar compras y entregas al mismo tiempo, por favor complete las ordenes pendientes.";break;case"EC150":title="Repartidor no asignable";message="El repartidor no posee POS asociado";break;case"EC151":title="Repartidor no asignable";message="El repartidor tiene órdenes activas muy lejanas a la ubicación del cliente objetivo, debe completarlas primero antes de poder asignarle más órdenes.";break;default:break;}__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:title,msg:message});}else{__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:"Error",msg:json_lang.custom_errors.provider_attach_failed});}});};};var updateMapProvider=function updateMapProvider(propsOrder,provider){//solo funciona con órdenes sin proveedor
var provider_id;if(typeof provider==='number'){provider_id=provider;}else{provider_id=provider[0].id;}return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var ordered_goods=propsOrder?[].concat(_toConsumableArray(propsOrder.ordered_goods)):[];var data=ordered_goods.map(function(ordered_good){return{ordered_good_id:ordered_good.id,provider_id:provider_id};}).filter(function(ordered_good){return ordered_good.provider_id;});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].put(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/orders/'+propsOrder.id+'/providers',data).then(function(res){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});});};};var removeProvider=function removeProvider(order,provider){return function(dispatch){__WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().company.id+'/orders/'+order+'/providers/'+provider).then(function(res){var updateOrder=__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().todayOrders.map(function(order){if(order.id===res.data.id){order=res.data;var lat=parseInt(order.client_latitude_e6,10)/1000000;var long=parseInt(order.client_longitude_e6,10)/1000000;order.position=[lat,long];}return order;});dispatch({type:'LIST_TODAY_ORDERS',todayOrders:updateOrder});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.custom_errors.provider_attach_failed});});};};var unassignProviderFromTable=function unassignProviderFromTable(order,provider){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().company.id+'/orders/'+order+'/providers/'+provider).then(function(res){var succesful=__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.common.success;__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.custom_success.update_successful});res.data.touched=true;/*let updateTable = [...getState().orders].map( (item) => {
                if(item.id === res.data.order.id){
                    item = res.data.order
                }
                return item;
            })

            dispatch({
                type: 'FETCH_ORDERS',
                orders: updateTable
            })*/}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.custom_errors.provider_attach_failed});});};};var markAsTouched=function markAsTouched(id,storeKey){return function(dispatch,getState){var itemsList=getState()[storeKey];var touchedOrderIndex=itemsList.data.findIndex(function(order){return order.id===id;});itemsList.data[touchedOrderIndex].touched=true;dispatch({type:"TOGGLE_TOUCHED",storeKey:"orders",list:itemsList});};};var fetchTodayOrders=function fetchTodayOrders(){return function(dispatch,getState){var _getState8=getState(),company=_getState8.company,json_lang=_getState8.json_lang,branch=_getState8.branch;var url_host='/orders?sort_by=created_at,asc&limit=0&is_status_completed=0&with=client,providers';if(branch&&branch.id){url_host='/branches/'+branch.id+'/orders?sort_by=created_at,asc&limit=0&is_status_completed=0&with=client,providers';}return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(''+(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id)+url_host).then(function(res){var unassigned=void 0,assigned=void 0,orderedList=void 0,orders=void 0;orders=res.data.map(function(order){var lat=parseInt(order.client_latitude_e6,10)/1000000;var long=parseInt(order.client_longitude_e6,10)/1000000;order.position=[lat,long];return order;});var _priotizeOrders=priotizeOrders("unassigned",orders);var _priotizeOrders2=_slicedToArray(_priotizeOrders,3);orderedList=_priotizeOrders2[0];unassigned=_priotizeOrders2[1];assigned=_priotizeOrders2[2];dispatch({type:'LIST_TODAY_ORDERS',todayOrders:orderedList,ordersCounter:{"assigned":assigned,"unassigned":unassigned}});dispatch({type:"REMOVE_LOADING"});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.retrieving_today_order_list});});};};var cancelOrder=function cancelOrder(id){return function(dispatch,getState){var _getState9=getState(),order=_getState9.order,company=_getState9.company,json_lang=_getState9.json_lang;var data={reason:order&&order.reason/*let orderitem = [...orders]
        let o = orderitem.find(( item ) => item.id === id )
        let providers = o && o.providers;
        let client = o && o.client;*/};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+id+'/set-canceled',data).then(function(res){res.data.touched=true;/*res.data.providers = providers;
            res.data.client = client;*/__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.update_successful});/*dispatch({
                type: 'FETCH_ORDERS',
                orders: tableUpdate(res, "orders"),
            });*/}).catch(function(err){dispatch({type:"CANCEL_ORDER_ERROR",cancelOrderError:true});if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.order_cancel_failed});});};};var clearCancelOrderError=function clearCancelOrderError(){return function(dispatch){dispatch({type:"CANCEL_ORDER_ERROR",cancelOrderError:false});};};var beingPreparedOrder=function beingPreparedOrder(id){return function(dispatch,getState){var _getState10=getState(),order=_getState10.order,company=_getState10.company,json_lang=_getState10.json_lang;var data={reason:order&&order.reason/*let orderitem = [...orders]
        let o = orderitem.find(( item ) => item.id === id )
        let providers = o && o.providers;
        let client = o && o.client;*/};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+id+'/set-being-prepared',data).then(function(res){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.update_successful});/*
            res.data.touched = true;
            res.data.providers = providers;
            res.data.client = client;
            dispatch({
                type: 'FETCH_ORDERS',
                orders: tableUpdate(res, "orders"),
            });*/}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.order_cancel_failed});});};};var preparedOrder=function preparedOrder(id){return function(dispatch,getState){var _getState11=getState(),order=_getState11.order,company=_getState11.company,json_lang=_getState11.json_lang;var data={reason:order&&order.reason/*let orderitem = [...orders]
        let o = orderitem.find(( item ) => item.id === id )
        let providers = o && o.providers;
        let client = o && o.client;*/};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+id+'/set-prepared',data).then(function(res){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.order_canceled});/*res.data.touched = true;
            res.data.providers = providers;
            res.data.client = client;
            dispatch({
                type: 'FETCH_ORDERS',
                orders: tableUpdate(res, "orders"),
            });*/}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.order_cancel_failed});});};};var confirmationToggle=function confirmationToggle(value){return function(dispatch,getState){var data=Object.assign({},getState().confirmationOrder);data[value.name]=value.data;dispatch({type:'CONFIRMATION_REAZON',confirmationOrder:data});};};var acceptOrderPayment=function acceptOrderPayment(id){return function(dispatch,getState){var _getState12=getState(),orders=_getState12.orders,json_lang=_getState12.json_lang,orderDetails=_getState12.orderDetails,confirmationOrder=_getState12.confirmationOrder;var update={type:confirmationOrder.name==="pos"||confirmationOrder.name==="efectivo"?"post-payment":"gateway",name:confirmationOrder.name,ref:confirmationOrder.ref};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/orders/'+id+'/set-paid',update).then(function(res){var ordersList=Object.assign({},orders);var newOrderDetails=Object.assign({},orderDetails);var index=ordersList&&ordersList.data&&ordersList.data.findIndex(function(order){return order.id===res.data.id;})||-1;if(index!==-1){ordersList.data[index]=Object.assign({},ordersList.data[index],res.data);ordersList.data=[].concat(_toConsumableArray(ordersList.data));setTimeout(function(){dispatch({type:'FETCH_ORDERS',orders:ordersList,archived_orders:[]});},100);}else if(newOrderDetails&&newOrderDetails.id){newOrderDetails=Object.assign({},newOrderDetails,res.data);dispatch({type:'FETCH_ORDER_DETAILS',orderDetails:newOrderDetails});}else{dispatch({type:"REMOVE_LOADING"});}__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.pament_accep});});};};var setOrderPublicPool=function setOrderPublicPool(id){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/orders/'+id+'/set-public-pool').then(function(res){res.data.touched=true;}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.pament_accep});});};};var setOrderPrivatePool=function setOrderPrivatePool(id){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/orders/'+id+'/set-private-pool').then(function(res){res.data.touched=true;}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.pament_accep});});};};var clearPayment=function clearPayment(){var data={type:"gateway",name:"",ref:""};return function(dispatch,getState){dispatch({type:'CONFIRMATION_REAZON',confirmationOrder:data});};};var confirmOrder=function confirmOrder(id){return function(dispatch,getState){var data=[].concat(_toConsumableArray(getState().orders));// let order = data.find(( item ) => item.id === id )
/*let providers = order && order.providers;
        let client = order && order.client;*/return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/orders/'+id+'/set-confirmed').then(function(res){/*res.data.touched = true;
            res.data.providers = providers;
            res.data.client = client;
            dispatch({
                type: 'FETCH_ORDERS',
                orders: tableUpdate(res, "orders"),
            });*/}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:getState().json_lang.custom_errors.order_confirm});});};};var modifyInvoice=function modifyInvoice(id,type){return function(dispatch,getState){var _getState13=getState(),json_lang=_getState13.json_lang,company=_getState13.company,orders=_getState13.orders,archived_orders=_getState13.archived_orders,orderDetails=_getState13.orderDetails;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+id+'/'+type+'-invoices').then(function(res){var ordersList=Object.assign({},orders);var archivedOrdersList=Object.assign({},archived_orders);var newOrderDetails=Object.assign({},orderDetails);var index=ordersList&&ordersList.data&&ordersList.data.findIndex(function(order){return order.id===res.data.id;})||-1;var archivedIndex=archivedOrdersList&&archivedOrdersList.data&&archivedOrdersList.data.findIndex(function(order){return order.id===res.data.id;})||-1;if(index!==-1){ordersList.data[index]=Object.assign({},ordersList.data[index],res.data);ordersList.data=[].concat(_toConsumableArray(ordersList.data));setTimeout(function(){dispatch({type:'FETCH_ORDERS',orders:ordersList,archived_orders:[]});},100);}else if(archivedIndex!==-1){archivedOrdersList.data[archivedIndex]=Object.assign({},archivedOrdersList.data[archivedIndex],res.data);archivedOrdersList.data=[].concat(_toConsumableArray(archivedOrdersList.data));setTimeout(function(){dispatch({type:'FETCH_ORDERS',orders:[],archived_orders:archivedOrdersList});},100);}else if(newOrderDetails&&newOrderDetails.id){newOrderDetails=Object.assign({},newOrderDetails,res.data);dispatch({type:'FETCH_ORDER_DETAILS',orderDetails:newOrderDetails});}else{dispatch({type:"REMOVE_LOADING"});}__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:getState().json_lang.custom_errors.order_confirm});});};};var adminNotes=function adminNotes(id,note,noteId){return function(dispatch,getState){var _getState14=getState(),company=_getState14.company,json_lang=_getState14.json_lang,orderDetails=_getState14.orderDetails;dispatch({type:"WAIT_FOR_RESPONSE"});var adminNotes={admin_notes:note};if(noteId){adminNotes=Object.assign({},adminNotes,{admin_note_id:noteId});}return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+id,adminNotes).then(function(res){if(noteId){dispatch({type:'FETCH_ORDER_DETAILS',orderDetails:Object.assign({},orderDetails,res.data)});}else{dispatch({type:"REMOVE_LOADING"});}__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:getState().json_lang.custom_errors.order_confirm});});};};var addAttachment=function addAttachment(id,data){return function(dispatch,getState){var _getState15=getState(),company=_getState15.company,json_lang=_getState15.json_lang,orderDetails=_getState15.orderDetails;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+id+'/add-attachment',data).then(function(res){dispatch({type:'FETCH_ORDER_DETAILS',orderDetails:Object.assign({},orderDetails,res.data)});__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:getState().json_lang.custom_errors.order_confirm});});};};var beginOrder=function beginOrder(id){return function(dispatch,getState){var data=[].concat(_toConsumableArray(getState().orders));// let order = data.find(( item ) => item.id === id )
/*let providers = order && order.providers;
        let client = order && order.client;*/return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/orders/'+id+'/set-running').then(function(res){/*res.data.touched = true;
            res.data.providers = providers;
            res.data.client = client;
            /dispatch({
                type: 'FETCH_ORDERS',
                orders: tableUpdate(res, "orders"),
            });*/}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.order_start});});};};var deliverOrder=function deliverOrder(id){return function(dispatch,getState){var data=[].concat(_toConsumableArray(getState().orders));var order=data.find(function(item){return item.id===id;});var providers=order&&order.providers;var client=order&&order.client;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/orders/'+id+'/set-ready').then(function(res){res.data.touched=true;res.data.providers=providers;res.data.client=client;dispatch({type:'FETCH_ORDERS',orders:Object(__WEBPACK_IMPORTED_MODULE_4__tableActions__["j" /* tableUpdate */])(res,"orders")});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.order_deliver});});};};var completeOrder=function completeOrder(id){return function(dispatch,getState){__WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/orders/'+id+'/set-completed').then(function(res){}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.order_complete});});};};var fillDashboardStatistics=function fillDashboardStatistics(){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState16=getState(),branch=_getState16.branch;var thisUrl=''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/order-dashboards/today';if(branch&&branch.id){thisUrl=''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/branches/'+branch.id+'/order-dashboards/today';}return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(thisUrl).then(function(res){dispatch({type:'DASHBOARD',dashboardStatistics:res.data.payload});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:'Falta permisos para obtener la data del dashboard'});});};};var fillDashboardDayStatistics=function fillDashboardDayStatistics(month){var year=arguments.length>1&&arguments[1]!==undefined?arguments[1]:__WEBPACK_IMPORTED_MODULE_5_moment___default()().format("YYYY");return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/order-dashboards/days?month='+month.replace(/^0+/,'')+'&year='+year+'&limit=0').then(function(res){dispatch({type:'DASHBOARD_DAYS',dashboardDaysStatistics:res});}).catch(function(err){if(err.message)__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});});};};var fillDashboardMonthStatistics=function fillDashboardMonthStatistics(){var year=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_5_moment___default()().format("YYYY");return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState17=getState(),branch=_getState17.branch;var thisUrl=''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/order-dashboards/months?year='+year+'&limit=0';if(branch&&branch.id){thisUrl=''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/branches/'+branch.id+'/order-dashboards/months?year='+year+'&limit=0';}return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(thisUrl).then(function(res){dispatch({type:'DASHBOARD_MONTHS',dashboardMonthsStatistics:res.data});}).catch(function(err){if(err.message)__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});});};};var drawMonthStatistics=function drawMonthStatistics(month){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/order-dashboards/month/'+__WEBPACK_IMPORTED_MODULE_5_moment___default()().format("YYYY")+'-'+month.replace(/^0+/,'')).then(function(res){dispatch({type:'DASHBOARD_MONTHS_DATA',dashboardMonthsData:res.data});}).catch(function(err){});};};var drawMonthStatisticsID=function drawMonthStatisticsID(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/order-dashboards/'+id).then(function(res){dispatch({type:'DASHBOARD_MONTHS_DATA',dashboardMonthsData:res.data.payload});}).catch(function(err){//console.log("El mes "+month+" No tiene data")
});};};var drawDasboard=function drawDasboard(month){var year=arguments.length>1&&arguments[1]!==undefined?arguments[1]:__WEBPACK_IMPORTED_MODULE_5_moment___default()().format("YYYY");return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var urlArray=[''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/order-dashboards/today',//today
''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/order-dashboards/days?month='+month+'&year='+year+'&limit=0',//dias en el mes x q tienen ordenes
''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/order-dashboards/month/'+year+'-'+month,//today
''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/order-dashboards/months?year='+year+'&limit=0'];var promiseArray=urlArray.map(function(url){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(url);});Promise.all(promiseArray).then(function(res){/*let temp = res.map(r => r.data);
            dispatch({
                type: 'DASHBOARD_MONTHS_DATA',
                dashboardMonthsData: res.data
            })*/});};};var newStadistic=function newStadistic(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/order-dashboards/'+id).then(function(res){dispatch({type:'DASHBOARD_DAYS_UPDATE',orderPast:res.data.payload});}).catch(function(err){//console.log("El mes "+month+" No tiene data")
});};};var fetchOrderForms=function fetchOrderForms(id){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/orders/'+id+'/payments?with=admin').then(function(res){res.data.sort(function(a,b){if(a.id>b.id){//ordena los ids de mayor a menor
return-1;}if(a.id<b.id){return 1;}return 0;});dispatch({type:'GET_PAYMENT_FORM',payment_form:res.data});}).catch(function(err){if(err.message)__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});});};};var fetchOrderCancelationReason=function fetchOrderCancelationReason(id){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/orders/'+id+'/cancellation-reason').then(function(res){dispatch({type:'GET_CANCELATION_REASON',cancelationReason:res.data});}).catch(function(err){if(err.message)__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});});};};var fetchOrderBids=function fetchOrderBids(id){return function(dispatch,getState){// dispatch({type: "WAIT_FOR_RESPONSE"})
return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/orders/'+id+'/bids?limit=0&with=provider').then(function(res){dispatch({type:'GET_BIDS',bids:res.data});}).catch(function(err){/*if(err.message)
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});*/});};};var confirmOrderBid=function confirmOrderBid(id){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/bids/'+id+'/confirm').then(function(res){//let order = getState().order;
__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});/*order = {
                ...order,
            ...res.data
            }

            dispatch({
                type: 'UPDATE_BIDS',
                bids: [],
                orderDetails:order
            })*/dispatch({type:"ERROR_BIDS",errorBids:false});}).catch(function(err){dispatch({type:"ERROR_BIDS",errorBids:true});if(err.data){if(err.data.message==="not_allowed"){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:"Pago pendiente",msg:"Debe confirmar el pago"});}if(err.data.error_code==="ED203"){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:"Repartidor Offline",msg:"El repartidor no está en línea"});return"ED203";}}else{__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:"Ha ocurrido un error inesperado"});}});};};var cancelOrderBid=function cancelOrderBid(id){return function(dispatch,getState){var bid_id=id;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/bids/'+id+'/cancel').then(function(res){var order=getState().order;order=Object.assign({},order,res.data);var bids=getState().bids.filter(function(elm){return elm.id!==bid_id;});dispatch({type:'UPDATE_BIDS',orderDetails:order,bids:bids});}).catch(function(err){if(err.data.message==="not_allowed")__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:"Pago pendiente",msg:"Debe confirmar el pago"});else if(err.message)__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});});};};var preloadOrderCart=function preloadOrderCart(){return function(dispatch,getState){var preloadOrder=getState().order;var cart=getState().cart;cart.client_address=preloadOrder.client_address;cart.client_latitude_e6=preloadOrder.client_latitude_e6;cart.client_longitude_e6=preloadOrder.client_longitude_e6;cart.isPickup=parseInt(preloadOrder.client_latitude_e6,10)===0&&parseInt(preloadOrder.client_longitude_e6,10)===0&&preloadOrder.client_address===null?true:false;cart.notes=preloadOrder.notes!==null?preloadOrder.notes:'';cart.scheduled_at=preloadOrder.scheduled_at!==null?preloadOrder.scheduled_at:'';dispatch({type:'BUILD_ORDER',cart:cart});};};var clearCart=function clearCart(){return function(dispatch){dispatch({type:'CLEAR_CART'});};};var clearBids=function clearBids(){return function(dispatch){dispatch({type:'CLEAR_BIDS'});};};var filterOrdersAssigned=function filterOrdersAssigned(){return function(dispatch,getState){var assginedAddedOrders=[],mapFilters=getState().mapFilters,filteredMapOrders=[].concat(_toConsumableArray(getState().filteredMapOrders)),mapOrders=[].concat(_toConsumableArray(getState().mapOrders));mapOrders.forEach(function(order){if(order.provider_id){assginedAddedOrders.push(order);}});dispatch({type:"FETCH_MAP_ORDERS",filteredMapOrders:mapFilters.assigned?Object(__WEBPACK_IMPORTED_MODULE_9__handlers_utils__["b" /* mergeArrays */])([].concat(_toConsumableArray(filteredMapOrders),assginedAddedOrders)):Object(__WEBPACK_IMPORTED_MODULE_9__handlers_utils__["c" /* removeFromArray */])([].concat(_toConsumableArray(filteredMapOrders)),[].concat(assginedAddedOrders))});};};var filterOrdersUnassigned=function filterOrdersUnassigned(){return function(dispatch,getState){var unassginedAddedOrders=[],mapFilters=getState().mapFilters,filteredMapOrders=[].concat(_toConsumableArray(getState().filteredMapOrders)),mapOrders=[].concat(_toConsumableArray(getState().mapOrders));mapOrders.forEach(function(order){if(!order.provider_id){unassginedAddedOrders.push(order);}});dispatch({type:"FETCH_MAP_ORDERS",filteredMapOrders:mapFilters.unassigned?Object(__WEBPACK_IMPORTED_MODULE_9__handlers_utils__["b" /* mergeArrays */])([].concat(_toConsumableArray(filteredMapOrders),unassginedAddedOrders)):Object(__WEBPACK_IMPORTED_MODULE_9__handlers_utils__["c" /* removeFromArray */])([].concat(_toConsumableArray(filteredMapOrders)),[].concat(unassginedAddedOrders))});};};var filterOrdersInsideDateRange=function filterOrdersInsideDateRange(){return function(dispatch,getState){var mapOrders=[],filteredMapOrders=getState().filteredMapOrders,dateFilter=getState().mapFilters.date;// Obtener fechas base usando Date nativo
var today=new Date();// Funciones auxiliares para validación y conversión de fechas
var isValidDate=function isValidDate(dateString){if(!dateString)return false;var date=new Date(dateString);return date instanceof Date&&!isNaN(date);};var parseDate=function parseDate(dateString){if(!dateString)return null;var date=new Date(dateString);return isNaN(date)?null:date;};// Función para determinar si una fecha está dentro del rango permitido
var isWithinAllowedRange=function isWithinAllowedRange(date,filterType){if(!date)return false;var today=new Date();var startOfMonth=new Date(today.getFullYear(),today.getMonth(),1);var fiveDaysAgo=new Date(today.getTime()-5*24*60*60*1000);switch(filterType){case"day":return date.toDateString()===today.toDateString();case"week":var startOfWeek=new Date(today.getFullYear(),today.getMonth(),today.getDate()-today.getDay());var endOfWeek=new Date(today.getFullYear(),today.getMonth(),today.getDate()+(6-today.getDay()));return date>=startOfWeek&&date<=endOfWeek;case"month":return date>=startOfMonth&&date<=today||date>=fiveDaysAgo&&date<startOfMonth;default:return false;}};// Filtrar órdenes según los criterios establecidos
filteredMapOrders.forEach(function(order){var orderDate=null;// Priorizar scheduled_at si existe
if(order.scheduled_at){var scheduledDate=parseDate(order.scheduled_at.split(" ")[0]);if(isValidDate(scheduledDate)){orderDate=scheduledDate;}}// Usar created_at si scheduled_at no es válido
if(!orderDate&&order.created_at){var createdDate=parseDate(order.created_at.split(" ")[0]);if(isValidDate(createdDate)){orderDate=createdDate;}}// Verificar si la orden cumple con el filtro seleccionado
if(orderDate){switch(true){case dateFilter.todayOrders:if(isWithinAllowedRange(orderDate,"day")){mapOrders.push(order);}break;case dateFilter.thisWeekOrders:if(isWithinAllowedRange(orderDate,"week")){mapOrders.push(order);}break;case dateFilter.thisMonthOrders:if(isWithinAllowedRange(orderDate,"month")){mapOrders.push(order);}break;}}});dispatch({type:"FETCH_MAP_ORDERS",filteredMapOrders:[].concat(mapOrders)});};};var filterOrderByStatus=function filterOrderByStatus(){return function(dispatch,getState){var mapOrders=[],mapFilters=getState().mapFilters,filteredMapOrders=getState().filteredMapOrders;// guarda las que esten activas segun el filtro indicados en mapfilters
filteredMapOrders.forEach(function(order){var algo=Object(__WEBPACK_IMPORTED_MODULE_8__UtilsOperation__["y" /* orderStatus */])(order.status,true);// filters in map are always fordelivery so second parameter its always true
if(Object(__WEBPACK_IMPORTED_MODULE_8__UtilsOperation__["x" /* orderHasFlag */])(algo.step,mapFilters)){mapOrders.push(order);}});dispatch({type:"FETCH_MAP_ORDERS",filteredMapOrders:[].concat(mapOrders)});};};var clearMapFilters=function clearMapFilters(){return{type:"CLEAR_MAP_FILTERS"};};var fetchMapOrders=function fetchMapOrders(){var limit=arguments.length>0&&arguments[0]!==undefined?arguments[0]:10;var filter_query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState18=getState(),company=_getState18.company,branch=_getState18.branch,userHigherAccess=_getState18.userHigherAccess;var url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id+'/orders?with=client,orderProviders.provider&limit='+limit;if(userHigherAccess===__WEBPACK_IMPORTED_MODULE_7__constants_general__["h" /* COMPANY_ACCESS */]&&!branch.name){url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders?with=client,orderProviders.provider&limit='+limit;}url_host+=filter_query!==""?"&"+filter_query:"";return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(url_host).then(function(res){var deliveryOrders=[];// busco todos las ordenes tipo delivery
var data=limit===0?res.data:res.data.data;data.forEach(function(order){if(!Object(__WEBPACK_IMPORTED_MODULE_8__UtilsOperation__["p" /* isPickUp */])(order.client_latitude_e6,order.client_longitude_e6,order.client_address)){deliveryOrders.push(order);}});delete res.data.data;dispatch({type:'FETCH_MAP_ORDERS',mapOrders:deliveryOrders,filteredMapOrders:deliveryOrders//!paginationOrders: res.data
});}).catch(function(err){var dataError=Object(__WEBPACK_IMPORTED_MODULE_1__handlers_Errors__["a" /* default */])(err);dispatch({type:'ERROR',errors:dataError});});};};var dataAsignableOrderParse=function dataAsignableOrderParse(orderID){return function(dispatch,getState){var orders=[].concat(_toConsumableArray(getState().orders));var selected_order=orders.find(function(order,key){return order.id===orderID;});return selected_order;};};var toogleAssingProvider=function toogleAssingProvider(provider,assignedGood){return function(dispatch,getState){//let goods = [assignedGood];
var order=Object.assign({},getState().order);var rck=order.ordered_goods.map(function(ordered_good){if(ordered_good.id===assignedGood){ordered_good.assigned_provider=provider.id;}return ordered_good;});order.ordered_goods=rck;dispatch({type:'FETCH_ORDER',order:order});};};var assigMultiProvider=function assigMultiProvider(orderId){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState19=getState(),order=_getState19.order,company=_getState19.company,json_lang=_getState19.json_lang;//let goods = [assignedGood];
var ordered_goods=order?[].concat(_toConsumableArray(order.ordered_goods)):[];var data=ordered_goods.map(function(ordered_good){return{ordered_good_id:ordered_good.id,provider_id:ordered_good.assigned_provider};}).filter(function(ordered_good){return ordered_good.provider_id;});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].put(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+orderId+'/providers',data).then(function(res){/* dispatch({ type: "REMOVE_LOADING" })

            var allorder = todayOrders.map( (order) => {
                if (order.id === res.data.id) {
                    order.provider = res.data.providers;
                }
                order.position =[
                    parseInt(parseInt(order.client_latitude_e6,10)/1000000,10),
                    parseInt(parseInt(order.client_longitude_e6,10)/1000000,10)
                ]
                return (order)
            })

            dispatch({
                type: 'UPDATE_TODAY_ORDERS',
                todayOrders: allorder,
                orders: tableUpdate(res, "orders")
            }); */__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});});};};var editQuantity=function editQuantity(quantity,key){return function(dispatch,getState){var cart=Object.assign({},getState().cart);cart.goods[key].quantity=quantity;cart.goods[key].total_price_e2=cart.goods[key].price_e2*cart.goods[key].quantity;//cart.goods[key].total_price_e2 +;
cart.goods[key].properties.map(function(goodProprerty,propKey){goodProprerty.price=goodProprerty.temp_base_price*cart.goods[key].quantity;var multiOptionInputs=goodProprerty.type==='checkbox'||goodProprerty.type==='select-one'||goodProprerty.type==='radio';var idReference=multiOptionInputs?goodProprerty.value+'-'+goodProprerty.property_id:goodProprerty.property_id;cart.propertiesQuantity.map(function(pQuantity,key){if(pQuantity.id===idReference){pQuantity.quantity=goodProprerty.type==='range'?parseInt(goodProprerty.value,10)*quantity:quantity;}return pQuantity;});return goodProprerty;});cart.goodsQuantity.map(function(goodQuantity,key){if(goodQuantity.id===cart.goods[key].id){goodQuantity.quantity=quantity;}return goodQuantity;});dispatch({type:'BUILD_ORDER',cart:cart});};};var getTimelineOrder=function getTimelineOrder(orderId){return function(dispatch,getState){var _getState20=getState(),company=_getState20.company;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+orderId+'/order-histories').then(function(res){dispatch({type:'FETCH_TIMELINEORDER',timelineOrder:res.data});}).catch(function(err){dispatch({type:'REMOVE_LOADING'});/* Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: err.message && err.message !== 'generic' ? err.message : json_lang.custom_errors.retrieving_user_list
            });*/});};};var fetchOrdersByStatus=function fetchOrdersByStatus(MASK,VALUE){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState21=getState(),company=_getState21.company,userHigherAccess=_getState21.userHigherAccess,branch=_getState21.branch;var url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id+'/orders?status=flag '+MASK+','+VALUE+'&with=orderProviders.provider,client,creator&limit=0';if(userHigherAccess===__WEBPACK_IMPORTED_MODULE_7__constants_general__["h" /* COMPANY_ACCESS */]&&!branch.name){url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders?status=flag '+MASK+','+VALUE+'&with=orderProviders.provider,client,branch,creator&limit=0';}return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(url_host).then(function(res){/// if user tipe 2 mostrar solo ordenes pagadas
dispatch({type:'FETCH_ORDERS',orders:res.data,archived_orders:[]});}).catch(function(err){var dataError=Object(__WEBPACK_IMPORTED_MODULE_1__handlers_Errors__["a" /* default */])(err);dispatch({type:'ERROR',errors:dataError});});};};var resendPool=function resendPool(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState22=getState(),company=_getState22.company,json_lang=_getState22.json_lang;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+id+'/send-to-pool',{force:true}).then(function(){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.resend_pool_successful});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:err.data.message});});};};var orderGiveChange=function orderGiveChange(data,orderId){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});dispatch({type:'GIVE_CHANGE_ERROR',giveChangeError:false});var _getState23=getState(),company=_getState23.company,json_lang=_getState23.json_lang;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+orderId+'/balance-movements/give-change',data).then(function(res){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.givechange_successful});dispatch({type:'FETCH_GIVE_CHANGE',giveChange:res.data});}).catch(function(err){dispatch({type:'GIVE_CHANGE_ERROR',giveChangeError:true});dispatch({type:"REMOVE_LOADING"});if(err&&err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_8__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);switch(error.code){case"EF504":{var message=error.message;var regex=/amount_e2 \((\d+)\).*order amount \((\d+)\)/;var match=message.match(regex);if(match){var totalAmount=Number(match[1]);var orderAmount=Number(match[2]);message='El monto total ('+Object(__WEBPACK_IMPORTED_MODULE_8__UtilsOperation__["v" /* number_format */])(totalAmount/100)+') no puede ser mayor que el monto de la orden ('+Object(__WEBPACK_IMPORTED_MODULE_8__UtilsOperation__["v" /* number_format */])(orderAmount/100)+').';}__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error: '+error.code,msg:message});break;}default:{__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error: '+error.code,msg:error.message});break;}}}else{__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:"Error",msg:json_lang.two_steps_modal.default_error});}});};};var orderpParcialGivechange=function orderpParcialGivechange(){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState24=getState(),company=_getState24.company,parcialGivechange=_getState24.parcialGivechange,orderDetails=_getState24.orderDetails,json_lang=_getState24.json_lang;var amount=parseFloat(Object(__WEBPACK_IMPORTED_MODULE_8__UtilsOperation__["a" /* FloatPrecision */])(parcialGivechange.amount_e2.replace(',','.')))*100;if(parcialGivechange.add==='remove'){amount=amount*-1;}parcialGivechange.amount_e2=amount;parcialGivechange.adjust_client_balance=parcialGivechange.adjust_client_balance===null||parcialGivechange.adjust_client_balance===false?false:true;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+orderDetails.id+'/adjust',parcialGivechange).then(function(res){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.edit_order_successful});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:err.data.message});});};};var toogleOrdeParcialGiveChange=function toogleOrdeParcialGiveChange(value){return function(dispatch,getState){var data=Object.assign({},getState().parcialGivechange);data[value.name]=value.name==='adjust_client_balance'?value.checked:value.data;dispatch({type:'FETCH_PARTIAL_GIVE_CHANGE',parcialGivechange:data});};};var toogleOrderGiveChange=function toogleOrderGiveChange(value){return function(dispatch,getState){var data=Object.assign({},getState().giveChange);data[value.name]=value.name==='adjust_provider_balance'?value.checked:value.data;dispatch({type:'FETCH_GIVE_CHANGE',giveChange:data});};};var clearOrderParcialGivechange=function clearOrderParcialGivechange(value){return function(dispatch,getState){var data={amount_e2:'',description:'',adjust_client_balance:false,add:"add"};dispatch({type:'FETCH_PARTIAL_GIVE_CHANGE',parcialGivechange:data});};};var clearOrderGiveChange=function clearOrderGiveChange(value){return function(dispatch,getState){var data={amount_e2:'',description:''};dispatch({type:'FETCH_GIVE_CHANGE',giveChange:data});};};var fetchHistoryGivechange=function fetchHistoryGivechange(orderId){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/orders/'+orderId+'/balance-movements?type=:in:change,refund,adjustment&with=author.admin,owner').then(function(res){dispatch({type:'FETCH_GIVE_CHANGE_HISTORY',giveChangeHistory:res.data});}).catch(function(err){console.log("FETCH_ARCHIVED_ORDERS",err);dispatch({type:'ERROR',errors:""});});};};var changeStatusOrderProvider=function changeStatusOrderProvider(orderProviderId,status,ProofCode){return function(dispatch,getState){var data=void 0;if(ProofCode){data={code:ProofCode};}dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/order-providers/'+orderProviderId+'/set-'+status,data).then(function(res){dispatch({type:"REMOVE_LOADING"});__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"success",msg:'Estatus modificado con \xE9xito'});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err&&err.data&&err.data.error_code){var error=err.data;switch(error.error_code){case"EC104":__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code+': Pago no v\xE1lido',msg:"La orden no posee un pago válido"});break;case"EC127":__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code+': Orden no preparada',msg:"La orden aún no se encuentra preparada. Por favor comuníquese con el comercio"});break;default:__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:'Ocurri\xF3 un error inesperado al actualizar el estatus de la orden con mensaje: '+error.description});break;}}else{__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:"Ocurrió un error inesperado al actualizar el estatus de la orden"});}});};};var fetchOrdersBranchHeatmap=function fetchOrdersBranchHeatmap(){return function(dispatch,getState){var _getState25=getState(),company=_getState25.company;dispatch({type:'WAIT_FOR_RESPONSE'});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/branch-heatmap').then(function(res){dispatch({type:'FETCH_ORDERS_HEATMAP',ordersBranchHeatmap:res.data});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});});};};var fetchShopperChats=function fetchShopperChats(id){return function(dispatch,getState){var _getState26=getState(),company=_getState26.company;dispatch({type:'WAIT_FOR_RESPONSE'});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/order-providers/'+id+'/chat-messages?limit=0&sort_by=id,asc').then(function(res){dispatch({type:'FETCH_SHOPPER_CHATS',shopperChats:res.data});}).catch(function(err){dispatch({type:'REMOVE_LOADING'});if(err.message&&err.message!=='generic')switch(err&&err.data&&err.data.error_code){case'ER404':break;default:__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:'Error al cargar los datos del chat con el shopper con mensaje: '+err.data.description});break;}else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"Error al cargar los datos del chat con el shopper"});});};};var fetchProviderChats=function fetchProviderChats(id){return function(dispatch,getState){var _getState27=getState(),company=_getState27.company;dispatch({type:'WAIT_FOR_RESPONSE'});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/order-providers/'+id+'/chat-messages?limit=0&sort_by=id,asc').then(function(res){dispatch({type:'FETCH_PROVIDER_CHATS',providerChats:res.data});}).catch(function(err){dispatch({type:'REMOVE_LOADING'});if(err.message&&err.message!=='generic')switch(err&&err.data&&err.data.error_code){case'ER404':break;default:__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:'Error al cargar los datos del chat con el repartidor con mensaje: '+err.data.description});break;}else __WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"Error al cargar los datos del chat con el repartidor"});});};};var clearChats=function clearChats(){return function(dispatch){dispatch({type:'FETCH_PROVIDER_CHATS',providerChats:[]});dispatch({type:'FETCH_SHOPPER_CHATS',shopperChats:[]});};};var getOrderFleets=function getOrderFleets(orderId){return function(dispatch,getState){var _getState28=getState(),company=_getState28.company;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+orderId+'/available-fleets').then(function(res){dispatch({type:'GET_ORDER_FLEETS',orderFleets:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:'Error al cargar las flotas de la orden con mensaje: '+err.description});});};};var setOrderFleet=function setOrderFleet(orderId,id){return function(dispatch,getState){var _getState29=getState(),company=_getState29.company;dispatch({type:'WAIT_FOR_RESPONSE'});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+orderId+'/set-selected-fleet',{service_charge_id:id}).then(function(res){dispatch({type:'FETCH_ORDER',order:res.data});}).catch(function(err){dispatch({type:'REMOVE_LOADING'});if(err&&err.data&&err.data.error_code){var error=err.data;var message=error.description||error.message;var title=error.error_code;switch(error.error_code){case"EC241":message="No se puede asignar flota debido a restricciones de pago";break;default:break;}__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:title,msg:message});}else{__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:"Error",msg:"Ha ocurrido un error inesperado"});}});};};var clearProviderOrders=function clearProviderOrders(){return function(dispatch){dispatch({type:'FETCH_PROVIDER_ORDERS',providerOrders:[]});};};var recreateOrder=function recreateOrder(id,cartId,client){return function(dispatch,getState){var _getState30=getState(),company=_getState30.company;dispatch({type:"FETCH_CLIENT",client:client});var body={order_id:id};return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/carts/'+cartId+'/replace-items-from-order',body).catch(function(err){var error=Object(__WEBPACK_IMPORTED_MODULE_8__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:error.title,msg:error.description});dispatch({type:'ERROR_ON_RECREATE_ORDER',errorOnRecreateOrder:error});});};};var clearErrorOnRecreateOrder=function clearErrorOnRecreateOrder(){return function(dispatch){dispatch({type:'ERROR_ON_RECREATE_ORDER',errorOnRecreateOrder:null});};};// EDIT ORDER ENDPOINTS
var getOrderedGood=function getOrderedGood(branchId,goodId){return function(dispatch,getState){var _getState31=getState(),company=_getState31.company;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branches/'+branchId+'/goods/'+goodId+'?limit=0&with=materials,branch_good_properties&include_weight_unit_compat=1').then(function(res){dispatch({type:'GET_ORDERED_GOOD',orderedGood:res.data});}).catch(function(err){if(err&&err.data){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+err.data.error_code,msg:'Error al cargar el producto de la orden con mensaje: '+err.description});}else{__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:'Error al cargar el producto de la orden'});}});};};var addOrderedGood=function addOrderedGood(orderId,body){return function(dispatch,getState){var _getState32=getState(),company=_getState32.company,orderDetails=_getState32.orderDetails;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+orderId+'/ordered-goods',body).then(function(res){dispatch({type:'FETCH_ORDER_DETAILS',orderDetails:Object.assign({},orderDetails,res.data.order)});}).catch(function(err){dispatch({type:'ERROR_ON_ORDERED_GOOD',errorOnOrderedGood:true});if(err&&err.data){var error=err.data;switch(error.error_code){case"EC215":if(error.localized_error&&error.localized_error.spanish){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:''+error.localized_error.spanish.message});}else{__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:'Error al agregar producto con mensaje: '+error.description});}break;default:if(error.localized_error&&error.localized_error.spanish){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:''+error.localized_error.spanish.message});}else{__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:'Error al agregar producto con mensaje: '+error.description});}break;}}});};};var editOrderedGood=function editOrderedGood(orderId,goodId,body){return function(dispatch,getState){var _getState33=getState(),company=_getState33.company,orderDetails=_getState33.orderDetails;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+orderId+'/ordered-goods/'+goodId,body).then(function(res){dispatch({type:'FETCH_ORDER_DETAILS',orderDetails:Object.assign({},orderDetails,res.data.order)});}).catch(function(err){dispatch({type:'ERROR_ON_ORDERED_GOOD',errorOnOrderedGood:true});if(err&&err.data){var error=err.data;switch(error.error_code){case"EC215":if(error.localized_error&&error.localized_error.spanish){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:''+error.localized_error.spanish.message});}else{__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:'Error al modificar producto con mensaje: '+error.description});}break;default:__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:'Error al modificar producto con mensaje: '+error.description});break;}}});};};var deleteOrderedGood=function deleteOrderedGood(orderId,goodId){return function(dispatch,getState){var _getState34=getState(),company=_getState34.company,orderDetails=_getState34.orderDetails;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+orderId+'/ordered-goods/'+goodId).then(function(res){dispatch({type:'FETCH_ORDER_DETAILS',orderDetails:Object.assign({},orderDetails,res.data.order)});}).catch(function(err){dispatch({type:'ERROR_ON_ORDERED_GOOD',errorOnOrderedGood:true});if(err&&err.data){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+err.data.error_code,msg:'Error al eliminar producto con mensaje: '+err.data.description});}});};};var fetchOrderHistory=function fetchOrderHistory(orderId){return function(dispatch,getState){var _getState35=getState(),company=_getState35.company;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+orderId+'/ordered-goods/history').then(function(res){dispatch({type:'FETCH_ORDER_HISTORY',orderHistory:Object.assign({},res.data)});}).catch(function(err){if(err&&err.data){dispatch({type:"ORDER_HISTORY_ERROR",orderHistoryError:{error:Object.assign({},err.data)}});__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+err.data.error_code,msg:'Error al cargar historial con mensaje: '+err.data.description});}});};};var clearOrderHistory=function clearOrderHistory(){return function(dispatch){dispatch({type:'FETCH_ORDER_HISTORY',orderHistory:{history:[],original_data:null}});};};var clearOrderHistoryError=function clearOrderHistoryError(){return function(dispatch){dispatch({type:'ORDER_HISTORY_ERROR',orderHistoryError:{error:null}});};};var clearOrderedGood=function clearOrderedGood(){return function(dispatch){dispatch({type:'GET_ORDERED_GOOD',orderedGood:{}});};};var clearErrorOnOrderedGood=function clearErrorOnOrderedGood(){return function(dispatch){dispatch({type:'ERROR_ON_ORDERED_GOOD',errorOnOrderedGood:false});};};var getClientCarts=function getClientCarts(clientId){return function(dispatch,getState){var _getState36=getState(),company=_getState36.company,branch=_getState36.branch;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/clients/'+clientId+'/branches/'+branch.id+'/carts?with=branch').then(function(res){res.data.items.forEach(function(item){item.quantity_real=item.quantity;});dispatch({type:'GET_CLIENT_CART',cart:res.data,errorOnCart:false});}).catch(function(err){if(err&&err.data){// dispatch({
//     type: "CLIENT_CARTS_ERROR",
//     clientCartsError: {
//         error: {
//             ...err.data
//         }
//     }
// });
__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+err.data.error_code,msg:'Error al cargar carritos con mensaje: '+err.data.description});}});};};var updateCart=function updateCart(body){return function(dispatch,getState){var _getState37=getState(),company=_getState37.company,cart=_getState37.cart;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/carts/'+cart.id,body).then(function(res){if(res.data.payment_info.is_balance_in_use&&res.data.resume.fees.available_balance.amount_e2<=0){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/carts/'+cart.id,{payment_info:Object.assign({},res.data.payment_info,{is_balance_in_use:false})}).then(function(res){res.data.items.forEach(function(item){item.quantity_real=item.quantity;});__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"warning",title:'Balance insuficiente.',msg:'El balance disponible es insuficiente, por lo que no es posible aplicar los ZupperCredits'});dispatch({type:'GET_CLIENT_CART',cart:res.data,errorOnCart:false});}).catch(function(err){dispatch({type:'GET_CLIENT_CART',cart:Object.assign({},cart),errorOnCart:true});if(err&&err.data){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+err.data.error_code,msg:'Error al cargar carritos con mensaje: '+err.data.description});}});}else{res.data.items.forEach(function(item){item.quantity_real=item.quantity;});dispatch({type:'GET_CLIENT_CART',cart:res.data,errorOnCart:false});}}).catch(function(err){dispatch({type:'GET_CLIENT_CART',cart:Object.assign({},cart),errorOnCart:true});if(err&&err.data){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+err.data.error_code,msg:'Error al cargar carritos con mensaje: '+err.data.description});}});};};var addItemToCart=function addItemToCart(body){return function(dispatch,getState){var _getState38=getState(),company=_getState38.company,cart=_getState38.cart;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/carts/'+cart.id+'/cart-items',body).then(function(res){res.data.items.forEach(function(item){item.quantity_real=item.quantity;});dispatch({type:'GET_CLIENT_CART',cart:res.data,errorOnCart:false});}).catch(function(err){dispatch({type:'GET_CLIENT_CART',cart:Object.assign({},cart),errorOnCart:true});if(err&&err.data){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+err.data.error_code,msg:'Error al cargar carritos con mensaje: '+err.data.description});}});};};var updateItemFromCart=function updateItemFromCart(body){return function(dispatch,getState){var _getState39=getState(),company=_getState39.company,cart=_getState39.cart;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/cart-items/'+body.id,body).then(function(res){res.data.items.forEach(function(item){item.quantity_real=item.quantity;});dispatch({type:'GET_CLIENT_CART',cart:res.data,errorOnCart:false});}).catch(function(err){dispatch({type:'GET_CLIENT_CART',cart:Object.assign({},cart),errorOnCart:true});if(err&&err.data){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+err.data.error_code,msg:'Error al cargar carritos con mensaje: '+err.data.description});}});};};var clearItemsFromCart=function clearItemsFromCart(){return function(dispatch,getState){var _getState40=getState(),company=_getState40.company,cart=_getState40.cart;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/carts/'+cart.id+'/clear').then(function(res){dispatch({type:'GET_CLIENT_CART',cart:res.data,errorOnCart:false});}).catch(function(err){dispatch({type:'GET_CLIENT_CART',cart:Object.assign({},cart),errorOnCart:true});if(err&&err.data){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+err.data.error_code,msg:'Error al cargar carritos con mensaje: '+err.data.description});}});};};var removeItemFromCart=function removeItemFromCart(id){return function(dispatch,getState){var _getState41=getState(),company=_getState41.company,cart=_getState41.cart;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/cart-items/'+id).then(function(res){res.data.items.forEach(function(item){item.quantity_real=item.quantity;});dispatch({type:'GET_CLIENT_CART',cart:res.data,errorOnCart:false});}).catch(function(err){dispatch({type:'GET_CLIENT_CART',cart:Object.assign({},cart),errorOnCart:true});if(err&&err.data){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+err.data.error_code,msg:'Error al cargar carritos con mensaje: '+err.data.description});}});};};var cartCheckout=function cartCheckout(body){return function(dispatch,getState){var _getState42=getState(),company=_getState42.company,cart=_getState42.cart;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/carts/'+cart.id+'/checkout',body).then(function(res){dispatch({type:'GET_ORDER_CART',cartOrder:res.data});}).catch(function(err){dispatch({type:'GET_CLIENT_CART',cart:Object.assign({},cart),errorOnCart:true});if(err&&err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_8__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);if(error.code==="EC603"){__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:'El contenido del carrito es inv\xE1lido. Por favor revise la informaci\xF3n e intente nuevamente.'});}else{__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:''+error.message});}}});};};var checkForPromoCode=function checkForPromoCode(body){return function(dispatch,getState){var _getState43=getState(),company=_getState43.company,branch=_getState43.branch;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id+'/coupons/check',body).then(function(res){dispatch({type:'CHECKOUT_PROMO_CODE',couponCode:Object.assign({},res.data,{error:null})});}).catch(function(err){dispatch({type:'CHECKOUT_PROMO_CODE',couponCode:{error:err.data}});if(err&&err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_8__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:''+error.message});}});};};var saveOrderPayment=function saveOrderPayment(orderId,body){return function(dispatch,getState){var _getState44=getState(),company=_getState44.company,json_lang=_getState44.json_lang;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+orderId+'/payments/report',body).then(function(){dispatch({type:"ERROR_ON_ORDER_PAYMENT",errorOnOrderPayment:null});__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){if(err&&err.data){dispatch({type:"ERROR_ON_ORDER_PAYMENT",errorOnOrderPayment:Object.assign({},err.data)});var error=Object(__WEBPACK_IMPORTED_MODULE_8__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);if(error.code!=="ER423")__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:''+error.message});}});};};var getClientOrders=function getClientOrders(search,clientId){return function(dispatch,getState){var _getState45=getState(),company=_getState45.company,json_lang=_getState45.json_lang;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders?page=1&limit=20&uid=ilike '+encodeURIComponent(search)+'&client_id='+encodeURIComponent(clientId)+'&is_status_completed=1&mode=all').then(function(res){dispatch({type:'FETCH_CLIENT_ORDERS',clientOrders:res.data});}).catch(function(err){if(err&&err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_8__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:''+error.message});}else{__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:''+json_lang.two_steps_modal.default_error});}});};};var clearClientOrders=function clearClientOrders(){return function(dispatch){dispatch({type:'FETCH_CLIENT_ORDERS',clientOrders:[]});};};var generateOrderCoupon=function generateOrderCoupon(couponData,note){return function(dispatch,getState){var _getState46=getState(),company=_getState46.company,orderDetails=_getState46.orderDetails;var adminNotes={admin_notes:note};return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons',couponData).then(function(response){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+orderDetails.id,adminNotes).then(function(res){dispatch({type:'FETCH_ORDER_DETAILS',orderDetails:Object.assign({},orderDetails,res.data)});dispatch({type:'FETCH_COUPON',coupon:Object.assign({},couponData,response.data,{error:null})});}).catch(function(noteError){if(noteError&&noteError.data){var error=Object(__WEBPACK_IMPORTED_MODULE_8__UtilsOperation__["q" /* localizedErrorHandler */])(noteError.data);__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:''+error.message});}});}).catch(function(err){if(err&&err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_8__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);dispatch({type:'FETCH_COUPON',coupon:{error:error}});__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:''+error.message});}});};};var setReadyOrderCoupon=function setReadyOrderCoupon(couponId){return function(dispatch,getState){var _getState47=getState(),company=_getState47.company,coupon=_getState47.coupon;coupon.timezone=company.time_zone_offset?company.time_zone_offset:__WEBPACK_IMPORTED_MODULE_7__constants_general__["k" /* DEFAULT_TIME_ZONE */];return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons/'+couponId+'/set-ready',coupon).then(function(res){dispatch({type:'FETCH_COUPON',coupon:Object.assign({},res.data,{error:null})});}).catch(function(err){if(err&&err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_8__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);dispatch({type:'FETCH_COUPON',coupon:{error:error}});__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:''+error.message});}});};};var getOrderCouponCode=function getOrderCouponCode(couponId){return function(dispatch,getState){var _getState48=getState(),coupon=_getState48.coupon,company=_getState48.company;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons/'+couponId+'/codes').then(function(res){var update=Object.assign({},coupon,{available_codes:res.data.available_codes,used_codes:res.data.used_codes});dispatch({type:'FETCH_COUPON',coupon:update});}).catch(function(err){if(err&&err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_8__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);dispatch({type:'FETCH_COUPON',coupon:{error:error}});__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:''+error.message});}});};};var setOrderPostPayment=function setOrderPostPayment(paymentData){return function(_,getState){var _getState49=getState(),company=_getState49.company,cartOrder=_getState49.cartOrder;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/orders/'+cartOrder.id+'/set-post-payment',paymentData).catch(function(err){if(err&&err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_8__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);__WEBPACK_IMPORTED_MODULE_6__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:''+error.message});}});};};

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return tableClientsUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchingTableData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return resetTableData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return initData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return tableRemoveAcount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return tableUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return tableRemove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OLDtableUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OLDtableRemove; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__ = __webpack_require__(8);
var getTable=function getTable(data){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().company.id+data.url).then(function(res){var table={dataTransactions:res.data,sortTransactions:data.sort,ordTransactions:data.ord,pageTransactions:data.page,searchTransactions:data.search,ready:true,limitTransactions:__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().table.limitTransactions,mode:data.mode?data.mode:'all'};dispatch({type:'SET_TABLE',table:table,redirect:''});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:"",msg:""});});};};var initData=function initData(){return function(dispatch){var table={ready:false,dataTransactions:[],limitTransactions:2,pageTransactions:1,ordTransactions:'desc',sortTransactions:'id',searchTransactions:'',mode:'all'};dispatch({type:'SET_TABLE',table:table});};};var OLDtableUpdate=function OLDtableUpdate(res){var newdata=Object.assign({},__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().table);if(newdata.dataTransactions.data.find(function(data){return data.id===res.data.id;})){var update=newdata.dataTransactions.data.map(function(item){if(item.id===res.data.id){item=res.data;}return item;});newdata.dataTransactions.data=update;}else{newdata.dataTransactions.data.push(res.data);}return newdata;};var OLDtableRemove=function OLDtableRemove(res){var update=__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().table.dataTransactions.data.filter(function(item){return item.id!==res.data.id;});var newdata=Object.assign({},__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().table);newdata.dataTransactions.data=update;return newdata;};/* ----------- new table methods */var resetTableData=function resetTableData(name){return{type:'RESET_TABLE_DATA',storeAttr:name};};var fetchingTableData=function fetchingTableData(){return{type:'WAIT_FOR_RESPONSE',preloader:true};};/* helper methods */var tableUpdate=function tableUpdate(res,table){return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState()[table].map(function(item){if(item.id===res.data.id){if(res.data.hasOwnProperty("client")){// TODO: el api no retorna el cliente en la tabla ordenes solo el id
item=Object.assign({},res.data,{client:item.client.name?Object.assign({},item.client):Object.assign({},res.data.client)});}else if(res.data.hasOwnProperty("admin_type")){item=Object.assign({account:item.account},res.data);}else{item=res.data;}}return item;});};var tableClientsUpdate=function tableClientsUpdate(res,table){return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState()[table].data.map(function(item){if(item.id===res.data.id){if(item.account.type===0){// si es cliente, entra en el if
item.account.email=res.data.email;item=Object.assign({account:item.account},res.data);}else{item=res.data;}}return item;});};/**
 * elimina un item de tipo account en la litsta de objetos
 * @param  {Object} res   la respuesta del servidor
 * @param  {String} table el nombre del característica en el store ejm: "admins" o "providers"
 * @return {Array}       la lista de items si esa cuenta
 */var tableRemoveAcount=function tableRemoveAcount(res,table){var storeData=__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState()[table]&&__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState()[table].data||__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState()[table];return storeData.filter(function(item){return item.account_id!==res.data.id;});};var tableRemove=function tableRemove(res,table){return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState()[table].filter(function(item){return item.id!==res.data.id;});};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokenContainer = exports.menuItemContainer = exports.asyncContainer = exports.TypeaheadMenu = exports.Typeahead = exports.Token = exports.MenuItem = exports.Menu = exports.Highlighter = exports.AsyncTypeahead = undefined;

var _AsyncTypeahead2 = __webpack_require__(479);

var _AsyncTypeahead3 = _interopRequireDefault(_AsyncTypeahead2);

var _Highlighter2 = __webpack_require__(230);

var _Highlighter3 = _interopRequireDefault(_Highlighter2);

var _Menu2 = __webpack_require__(231);

var _Menu3 = _interopRequireDefault(_Menu2);

var _MenuItem2 = __webpack_require__(130);

var _MenuItem3 = _interopRequireDefault(_MenuItem2);

var _Token2 = __webpack_require__(224);

var _Token3 = _interopRequireDefault(_Token2);

var _Typeahead2 = __webpack_require__(218);

var _Typeahead3 = _interopRequireDefault(_Typeahead2);

var _TypeaheadMenu2 = __webpack_require__(229);

var _TypeaheadMenu3 = _interopRequireDefault(_TypeaheadMenu2);

var _asyncContainer2 = __webpack_require__(203);

var _asyncContainer3 = _interopRequireDefault(_asyncContainer2);

var _menuItemContainer2 = __webpack_require__(232);

var _menuItemContainer3 = _interopRequireDefault(_menuItemContainer2);

var _tokenContainer2 = __webpack_require__(225);

var _tokenContainer3 = _interopRequireDefault(_tokenContainer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AsyncTypeahead = _AsyncTypeahead3.default; /* eslint-disable object-curly-spacing */

// Components

exports.Highlighter = _Highlighter3.default;
exports.Menu = _Menu3.default;
exports.MenuItem = _MenuItem3.default;
exports.Token = _Token3.default;
exports.Typeahead = _Typeahead3.default;
exports.TypeaheadMenu = _TypeaheadMenu3.default;

// HOCs

exports.asyncContainer = _asyncContainer3.default;
exports.menuItemContainer = _menuItemContainer3.default;
exports.tokenContainer = _tokenContainer3.default;

/* eslint-enable object-curly-spacing */

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(49);
var IObject = __webpack_require__(72);
var toObject = __webpack_require__(20);
var toLength = __webpack_require__(30);
var asc = __webpack_require__(306);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(53),
    getRawTag = __webpack_require__(484),
    objectToString = __webpack_require__(485);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(501),
    getValue = __webpack_require__(504);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 45 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(27);
var createDesc = __webpack_require__(70);
module.exports = __webpack_require__(15) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var hide = __webpack_require__(46);
var has = __webpack_require__(48);
var SRC = __webpack_require__(71)('src');
var $toString = __webpack_require__(296);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(35).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 48 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(54);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(350);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(353);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(354);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(77);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(58);
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["b"]; });










/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule warning
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable sort-keys */

/**
 * KeyCode
 *
 * Map of common (non-printable) keycodes for the `keydown` and `keyup` events.
 * Note that `keypress` handles things differently and may not return the same
 * values.
 */
module.exports = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ESC: 27,
  SPACE: 32,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(25);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(16)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(46)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(80);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCountries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return onResize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__ = __webpack_require__(8);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getCompany=function getCompany(){return function(dispatch,getState){if(window.location.pathname==='/'){dispatch({type:"WAIT_FOR_RESPONSE"});}var host=__WEBPACK_IMPORTED_MODULE_1__config_js__["b" /* LONG_URL */];if(localStorage.getItem("companyId")){host=''+__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+localStorage.getItem("companyId");}return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(host).then(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res){var currencies,local_currency,international_currency,customEmailFooter,customClientBg;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:currencies=void 0,local_currency=void 0,international_currency=void 0;_context.next=3;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+res.data.id+'/currencies')/// TODO: MALDITO JAVASCRIPT porque me haces hacer esto...
.then(function(res){currencies=res.data;}).catch(function(err){return console.log("Error: No se pudo acceder al servidor para la lista de monedas usadas por la compañía, se esta usando el $ como simbolo por defecto, pero esto indica que exploto");});case 3:// de la lista de currencies que tiene la company tomo la que este definida como local (es la usada por defecto para los productos) y la internacional
local_currency=currencies.data.find(function(cur){return cur.is_local;});international_currency=currencies.data.find(function(cur){return cur.is_international;});customEmailFooter=res.data&&res.data.custom_json&&res.data.custom_json.mail_footer?res.data.custom_json.mail_footer:'';customClientBg=res.data&&res.data.custom_json&&res.data.custom_json.customClientBg?res.data.custom_json.customClientBg:'';dispatch({type:'COMPANY_INITIALIZATION',company:res.data,initCompany:res.data,lang_code:localStorage.getItem('lang_code')||res.data.default_iso_lang,company_styles_json:res.data.styles_json.styles,currencies:{local:local_currency,international:international_currency,accepted:currencies.data},customEmailFooter:customEmailFooter,customClientBg:customClientBg});localStorage.setItem("companyId",res.data.id);case 9:case'end':return _context.stop();}}},_callee,_this);}));return function(_x){return _ref.apply(this,arguments);};}()).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.custom_errors.retrieving_company});//window.location.replace('/404');
});};};var getCountries=function getCountries(){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+localStorage.getItem("companyId")+'/countries').then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// console.log("getCountries",res)
dispatch({type:'GET_COUNTRIES',countries:res.data});case 1:case'end':return _context2.stop();}}},_callee2,_this);}));return function(_x2){return _ref2.apply(this,arguments);};}()).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.custom_errors.retrieving_company});});};};/* This method allows to know when the sidebar or the aside menu are open */var onResize=function onResize(isSidebarActive,isAsidemenuActive){if(isSidebarActive!==undefined){return{type:"ON_RESIZE_LISTENER",isSidebarActive:!isSidebarActive};}if(isAsidemenuActive!==undefined){return{type:"ON_RESIZE_LISTENER",isAsidemenuActive:!isAsidemenuActive};}};

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalBase=function(_Component){_inherits(ModalBase,_Component);function ModalBase(props){_classCallCheck(this,ModalBase);var _this=_possibleConstructorReturn(this,(ModalBase.__proto__||Object.getPrototypeOf(ModalBase)).call(this,props));_this.toggleModal=function(){_this.setState({modal:!_this.state.modal});};_this.actionModal=function(){if(_this.props.confirmFunc){_this.props.confirmFunc();_this.toggleModal();}else{_this.toggleModal();}};_this.state={modal:false};return _this;}_createClass(ModalBase,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Modal"],{isOpen:this.state.modal,toggle:this.toggleModal,className:this.props.className?this.props.className:'',style:this.props.style?this.props.style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["ModalHeader"],{toggle:this.toggleModal},this.props.title?this.props.title:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["ModalBody"],null,this.props.html),this.props.confirmFunc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{disabled:this.props.disabled||false,color:''+(this.props.isDelete?'danger':'primary'),onClick:this.actionModal},this.props.isDelete?__WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].getState().json_lang.common.delete:this.props.isPay?__WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].getState().json_lang.common.pay:__WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].getState().json_lang.common.save),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{color:'secondary',onClick:this.toggleModal},__WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].getState().json_lang.common.cancel)):null);}}]);return ModalBase;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ModalBase);

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spinner=function(_Component){_inherits(Spinner,_Component);function Spinner(){_classCallCheck(this,Spinner);return _possibleConstructorReturn(this,(Spinner.__proto__||Object.getPrototypeOf(Spinner)).apply(this,arguments));}_createClass(Spinner,[{key:'render',value:function render(){var _props=this.props,size=_props.size,color=_props.color,className=_props.className,companyColor=_props.companyColor;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:className,style:{width:size||"12px",height:size||"12px"},version:'1.1',id:'L9',xmlns:'http://www.w3.org/2000/svg',x:'0px',y:'0px',viewBox:'0 0 100 100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:color||companyColor||"#3BD4AE",d:'M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('animateTransform',{attributeName:'transform',attributeType:'XML',type:'rotate',dur:'1s',from:'0 50 50',to:'360 50 50',repeatCount:'indefinite'})));}}]);return Spinner;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{companyColor:state.company.styles_json.styles.color_primary};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Spinner));

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return getWorkSchedulesForOrdering; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return getBranchHolidays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return createBranchHoliday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return updateBranchHoliday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return deleteHoliday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return toggleDataBranchServiceModifiers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return addBranchServiceModifiers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return deleteBranchServiceModifiers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return toggleDataPricelist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return storePriceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return getPriceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return getPriceListId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return editPriceList; });
/* unused harmony export deletePriceList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return getBranchCurrencies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return createBranchCurrency; });
/* unused harmony export clearBranchCurrency */
/* unused harmony export toogleBranchCurrency */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return deleteBranchDeliveryFeeSteps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return updatebranchDeliveryFeeSteps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return addBranchDeliveryFeeSteps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return clearNewBranch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ClearBranchGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getBrancchGroupAcceses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return fetchBranchSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return updateBranchSetings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return updateAutoAssignDriverUponPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return updateBranchSetingsWorkSchedules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DeleteAccesessss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Addaccesessss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return accesessss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddBranchGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return fetchBranchGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return toggleBranchEnabledStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return toggleBranchVisibleStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return updateSelectedBranch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return fetchCompanyBranches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return fetchProviderBranchAccesses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return toggleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return toggleData2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return updateBranchInServiceStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return updateBranchSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return updateBranchPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return fetchBranch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return fetchBranchGroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return fetchBranchGroupsByIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return clearBranchGroupsByIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AddBranchInGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DeleteBranch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return toggleData3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DeleteBranchGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return clearBranch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return toggleBranchServiceStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return toggleBranchInFeature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return updateBranchInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return updateBranchCommercies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return EditBranchGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return EditBranchGroupSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return updateBranchAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return toggleData4; });
/* unused harmony export getBranchRatings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return getOrderBranchRatings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return getBranchDeliveryFees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return toggleDataBranchFeeds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return excelConfigUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return pushExcelImport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return deleteExcelImport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return fetchBranchlist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return fetchBranchlistForMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return bulkbranchesActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return clearPriceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return clearAdmindAccessList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return searchBranchesByCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return updateBranchPaymentEmails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tableActions__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UtilsOperation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_general__ = __webpack_require__(6);
var _this=this;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//import store from '../store';
function saveBranchSettings(companyId,branchId,data){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+companyId+'/branches/'+branchId+'/settings',data);}function saveBranchData(companyId,data){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+companyId+'/branches/'+data.id,data);}var clearAdmindAccessList=function clearAdmindAccessList(){return function(dispatch,getState){dispatch({type:'FETCH_ADMINS_ACCESS',admindAccessList:[]});};};var updateBranchSettings=function updateBranchSettings(activeFormTab){return function(dispatch,getState){var _getState=getState(),company=_getState.company,json_lang=_getState.json_lang,branch=_getState.branch,editable_company_settings=_getState.editable_company_settings;dispatch({type:"WAIT_FOR_RESPONSE"});var formOnlyInputs=void 0;if(activeFormTab==="1"){formOnlyInputs={name:branch.name,phone:branch.phone,eta:branch.eta,description:branch.description,uid:editable_company_settings.uid};}else if(activeFormTab==="2"){formOnlyInputs={address:branch.address,latitude_e6:branch.latitude_e6,longitude_e6:branch.longitude_e6};}else if(activeFormTab==="3"){formOnlyInputs={service_fee_name:editable_company_settings.service_fee_name,human_service_fee_prc:editable_company_settings.human_service_fee_prc,human_branch_fee_prc:editable_company_settings.human_branch_fee_prc,human_order_tax_prc:editable_company_settings.human_order_tax_prc,human_delivery_discount_prc:editable_company_settings.human_delivery_discount_prc,order_expiration_minutes:editable_company_settings.order_expiration_minutes};}// saveBranchSettings modifica algunos valores visibles, entonces para que esos cambios existan en
// saveBranchData, debo hacerlos uno luego del otro... por eso esta sintaxys
return saveBranchSettings(company.id,branch.id,formOnlyInputs).then(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res){var newBranch;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:// necesito actualizar en localstorage los settings q son visibles,
// a partir de los cambios en los settings q no son visibles
newBranch=Object.assign({},branch,{service_fee_name:res.data.service_fee_name,human_delivery_discount_prc:res.data.human_delivery_discount_prc,human_delivery_fee_e2:res.data.human_delivery_fee_e2,human_service_fee_prc:res.data.human_service_fee_prc,order_expiration_minutes:res.data.order_expiration_minutes//human_delivery_providers_prc: res.human_delivery_providers_prc,
//human_service_fee_flat_e2: res.human_service_fee_flat_e2,
// como requiero ambos valores, retorno un array
});_context.t0=res.data;_context.next=4;return saveBranchData(company.id,newBranch);case 4:_context.t1=_context.sent;return _context.abrupt('return',[_context.t0,_context.t1]);case 6:case'end':return _context.stop();}}},_callee,_this);}));return function(_x){return _ref.apply(this,arguments);};}()).then(function(values){dispatch({type:"WAIT_FOR_RESPONSE"});localStorage.setItem("activeBranch",JSON.stringify(values[1].data));__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:'COMPANY_SETTINGS_UPDATE',editable_company_settings:Object.assign({},editable_company_settings,formOnlyInputs)});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var updateBranchInfo=function updateBranchInfo(){return function(dispatch,getState){var _getState2=getState(),company=_getState2.company,json_lang=_getState2.json_lang,branch=_getState2.branch,initialBranch=_getState2.initialBranch;if(!branch.domain||branch.domain===""){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:'Es requerido el dominio del comercio'});return;}if(!branch.city_id){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'La ciudad es requerida',msg:'Por favor seleccione una ciudad'});return;}if(branch.domain.length<=2){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:'El dominio del comercio requiere un minimo de 3 car\xE1cteres'});return;}var data={domain:encodeURIComponent(branch.domain)};if(initialBranch.name!==branch.name){data.name=branch.name;}if(initialBranch.description!==branch.description){data.description=branch.description;}if(initialBranch.phone!==branch.phone){data.phone=branch.phone;}if(initialBranch.eta!==branch.eta){data.eta=branch.eta;}if(initialBranch.in_order!==branch.in_order){data.in_order=branch.in_order;}if(initialBranch.time_zone_offset!==branch.time_zone_offset){data.time_zone_offset=branch.time_zone_offset;}if(initialBranch.options!==branch.options){data.options=branch.options;}if(initialBranch.city_id!==branch.city_id){data.city_id=branch.city_id||null;}if(initialBranch.has_custom_settings!==branch.has_custom_settings){data.has_custom_settings=branch.has_custom_settings;}dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id,data).then(function(res){localStorage.setItem("activeBranch",JSON.stringify(res.data));__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});// dispatch({
// 	type: 'UPDATE_BRANCH',
// 	branch: {
// 		...res.data,
// 		settings: branch.settings
// 	},
// 	initialBranch: {
// 		...res.data,
// 		settings: branch.settings
// 	}
// })
}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var updateBranchPayment=function updateBranchPayment(bankTransferForms,pmForms){return function(dispatch,getState){var _getState3=getState(),company=_getState3.company,json_lang=_getState3.json_lang,branch=_getState3.branch;var branchData=branch;var newBankTransferData=[];var newPmData=[];var data=[];if(bankTransferForms.length>0){newBankTransferData=bankTransferForms.map(function(banks){return{bank_name:banks.bank_name,document:''+banks.document_prefix+banks.document,account:banks.account,name:banks.name,email:banks.email||'',type:banks.type};});data=[].concat(_toConsumableArray(data),_toConsumableArray(newBankTransferData));}if(pmForms.length>0){newPmData=pmForms.map(function(banks){return{bank_code:banks.bank_code,document:''+banks.document_prefix+banks.document,phone:''+banks.phone_prefix+banks.phone,email:banks.email||'',type:banks.type};});data=[].concat(_toConsumableArray(data),_toConsumableArray(newPmData));}dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id+'/settings',{payout_accounts:data}).then(function(res){branchData.settings=res.data;var update=branchData;localStorage.setItem("activeBranch",JSON.stringify(update));__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:'UPDATE_BRANCH',branch:update,initialBranch:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var updateBranchSetings=function updateBranchSetings(settings2){return function(dispatch,getState){var _getState4=getState(),company=_getState4.company,json_lang=_getState4.json_lang,branch=_getState4.branch,initialBranch=_getState4.initialBranch;var newDate=Number(branch.settings.mark_too_busy_until);var minutesDifferenceSetting=branch.settings.minutes_difference?branch.settings.minutes_difference:null;if(newDate&&newDate!==0){var actualDate=new Date();actualDate=new Date(actualDate.getTime()+newDate);newDate=actualDate.toISOString();var minutesDifference=Math.floor(branch.settings.mark_too_busy_until/(1000*60));minutesDifferenceSetting=minutesDifference;}else{newDate=null;minutesDifferenceSetting=null;}var settings={uid:branch.settings.uid,enable_work_schedules:branch.settings.enable_work_schedules,auto_sync_work_schedules:branch.settings.auto_sync_work_schedules,human_min_checkout_price_e2:branch.settings.human_min_checkout_price_e2,order_expiration_minutes:branch.settings.order_expiration_minutes,payments_mode:branch.settings.payments_mode,max_scheduling_days:branch.settings.max_scheduling_days,pool_mode:branch.settings.pool_mode?"company":"branch",auto_assign_driver_upon_payment:branch.settings.auto_assign_driver_upon_payment,max_simultaneous_deliveries:Number(branch.settings.max_simultaneous_deliveries),mark_too_busy_until:newDate,auto_busy_quantity:Number(branch.settings.auto_busy_quantity),is_pool_automatic:branch.settings.is_pool_automatic,inventory_reminder_delay:branch.settings.inventory_reminder_delay// console.log("---->settings",data.settings.enable_work_schedules, settings2.auto_sync_work_schedules)
// if(branch.settings.uid !== settings2.uid){
//     data.settings.uid = branch.settings.uid
// }
// if(branch.settings.enable_work_schedules !== settings2.enable_work_schedules){
//     data.settings.enable_work_schedules = branch.settings.enable_work_schedules
// }
// if(branch.settings.auto_sync_work_schedules !== settings2.auto_sync_work_schedules){
//     data.settings.auto_sync_work_schedules = branch.settings.auto_sync_work_schedules
// }
// if (branch.settings.human_min_checkout_price_e2 !== settings2.human_min_checkout_price_e2) {
// 	data.settings.human_min_checkout_price_e2 = branch.settings.human_min_checkout_price_e2
// }
// if (branch.settings.order_expiration_minutes !== settings2.order_expiration_minutes) {
// 	data.settings.order_expiration_minutes = branch.settings.order_expiration_minutes
// }
// if (branch.settings.payments_mode !== settings2.payments_mode) {
// 	data.settings.payments_mode = branch.settings.payments_mode
// }
// if (branch.settings.max_scheduling_days !== settings2.max_scheduling_days) {
// 	data.settings.max_scheduling_days = branch.settings.max_scheduling_days
// }
// if (branch.settings.pool_mode !== settings2.pool_mode) {
// 	data.settings.pool_mode =  branch.settings.pool_mode === true ? "company" : "branch"
// }
};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id+'/settings',settings).then(function(res){// localStorage.setItem("activeBranch", JSON.stringify(res.data ))
__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:'UPDATE_BRANCH',branch:Object.assign({},branch,{settings:Object.assign({},branch.settings,res.data,{mark_too_busy_until:branch.settings.mark_too_busy_until,minutes_difference:minutesDifferenceSetting,pool_mode:res.data.pool_mode==="company"})}),initialBranch:Object.assign({},branch,{settings:Object.assign({},branch.settings,res.data,{mark_too_busy_until:branch.settings.mark_too_busy_until,minutes_difference:minutesDifferenceSetting,pool_mode:res.data.pool_mode==="company"})})});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var updateAutoAssignDriverUponPayment=function updateAutoAssignDriverUponPayment(value){return function(dispatch,getState){var _getState5=getState(),company=_getState5.company,json_lang=_getState5.json_lang,branch=_getState5.branch;var settings={auto_assign_driver_upon_payment:value};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id+'/settings',settings).then(function(res){dispatch({type:'UPDATE_BRANCH',branch:Object.assign({},branch,{settings:res.data}),initialBranch:Object.assign({},branch,{settings:res.data})});__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var updateBranchSetingsWorkSchedules=function updateBranchSetingsWorkSchedules(){return function(dispatch,getState){var _getState6=getState(),company=_getState6.company,json_lang=_getState6.json_lang,initialBranch=_getState6.initialBranch,branch=_getState6.branch;var data={settings:{}};if(data.settings.auto_sync_work_schedules!==initialBranch.settings.auto_sync_work_schedules){data.settings.auto_sync_work_schedules=branch.settings.auto_sync_work_schedules;}if(data.settings.enable_work_schedules!==initialBranch.settings.enable_work_schedules){data.settings.enable_work_schedules=branch.settings.enable_work_schedules;}dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id+'/settings',data.settings).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});branch.settings=res.data;branch.settings.pool_mode=res.data.pool_mode==="company"?true:false;var update=branch;dispatch({type:'UPDATE_BRANCH',branch:update,initialBranch:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var updateBranchCommercies=function updateBranchCommercies(){return function(dispatch,getState){var _getState7=getState(),company=_getState7.company,json_lang=_getState7.json_lang,initialBranch=_getState7.initialBranch,branch=_getState7.branch;var settings={};var initial=initialBranch.settings;if(settings.service_fee_name!==initial.service_fee_name){settings.service_fee_name=branch.settings.service_fee_name;}if(settings.human_order_tax_prc!==initial.human_order_tax_prc){settings.human_order_tax_prc=branch.settings.human_order_tax_prc;}if(settings.human_service_fee_prc!==initial.human_service_fee_prc){settings.human_service_fee_prc=branch.settings.human_service_fee_prc;}if(settings.human_delivery_discount_prc!==initial.human_delivery_discount_prc){settings.human_delivery_discount_prc=branch.settings.human_delivery_discount_prc;}if(settings.order_expiration_minutes!==initial.order_expiration_minutes){settings.order_expiration_minutes=branch.settings.order_expiration_minutes;}if(settings.human_order_tax_flat_e2!==initial.human_order_tax_flat_e2){settings.human_order_tax_flat_e2=branch.settings.human_order_tax_flat_e2;}if(settings.human_service_fee_flat_e2!==initial.human_service_fee_flat_e2){settings.human_service_fee_flat_e2=branch.settings.human_service_fee_flat_e2;}if(settings.islr_prc!==initial.islr_prc){settings.islr_prc=Number(branch.settings.islr_prc);}if(settings.iva_retention_prc!==initial.iva_retention_prc){settings.iva_retention_prc=Number(branch.settings.iva_retention_prc);}if(settings.is_special_contributor!==initial.is_special_contributor){settings.is_special_contributor=branch.settings.is_special_contributor;}if(settings.is_payment_deduction_disabled!==initial.is_payment_deduction_disabled){settings.is_payment_deduction_disabled=branch.settings.is_payment_deduction_disabled;}if(settings.legal_name_for_fiscal_docs!==initial.legal_name_for_fiscal_docs){settings.legal_name_for_fiscal_docs=branch.settings.legal_name_for_fiscal_docs;}if(settings.email_for_fiscal_docs!==initial.email_for_fiscal_docs){settings.email_for_fiscal_docs=branch.settings.email_for_fiscal_docs;}if(settings.address_for_fiscal_docs!==initial.address_for_fiscal_docs){settings.address_for_fiscal_docs=branch.settings.address_for_fiscal_docs;}if(settings.is_digital_invoice_enabled!==initial.is_digital_invoice_enabled){settings.is_digital_invoice_enabled=branch.settings.is_digital_invoice_enabled;}settings.service_app_modifiers=branch.settings.service_app_modifiers;/*[{
			name:"Servicio Nocturno",
			price_min_e2:0,
			order_fee_e2:100,
			client_fee_e2:50,
			order_fee_prc:0.1,
			client_fee_prc:0.05,
			hour_beg:"18:00",
			hour_end:"07:00",
			label:"Recargo Nocturo" // texto a mostrar en el Checkout
		}]*/dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id+'/settings',settings).then(function(res){branch.settings=res.data;var update=branch;update.settings.human_branch_fee_prc=update.settings.human_order_tax_prc-update.settings.human_service_fee_prc;localStorage.setItem("activeBranch",JSON.stringify(update));__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:'UPDATE_BRANCH',branch:update,initialBranch:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var excelConfigUpdate=function excelConfigUpdate(mappingName){return function(dispatch,getState){var _getState8=getState(),company=_getState8.company,json_lang=_getState8.json_lang,branch=_getState8.branch;var updatedMapping={};var mapping=branch.settings.import_config.mapping;if(Object.keys(mappingName).length!==0){Object.keys(mapping).forEach(function(key){if(key in mappingName){updatedMapping[mappingName[key]]=mapping[key];}else{updatedMapping[key]=mapping[key];}});}else{updatedMapping=mapping;}// let settings={}
var initial={import_config:Object.assign({},branch.settings.import_config,{mapping:updatedMapping})// if(settings.human_order_tax_prc !== initial.human_order_tax_prc){
//     settings.human_order_tax_prc = branch.settings.human_order_tax_prc
// }
// if(settings.human_service_fee_prc !== initial.human_service_fee_prc){
//     settings.human_service_fee_prc = branch.settings.human_service_fee_prc
// }
// if(settings.human_delivery_discount_prc !== initial.human_delivery_discount_prc){
//     settings.human_delivery_discount_prc = branch.settings.human_delivery_discount_prc
// }
// if(settings.order_expiration_minutes !== initial.order_expiration_minutes){
//     settings.order_expiration_minutes = branch.settings.order_expiration_minutes
// }
};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id+'/settings',initial).then(function(res){branch.settings=res.data;var update=branch;update.settings.human_branch_fee_prc=update.settings.human_order_tax_prc-update.settings.human_service_fee_prc;localStorage.setItem("activeBranch",JSON.stringify(update));__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:'UPDATE_BRANCH',branch:update,initialBranch:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var pushExcelImport=function pushExcelImport(data1){return function(dispatch,getState){var _getState9=getState(),branch=_getState9.branch;var data=Object.assign({},branch);data.settings.import_config.mapping=Object.assign({},data.settings.import_config.mapping,_defineProperty({},data1.key,''+data1.key_name+(data1.key_option?':'+data1.key_option:'')));dispatch({type:'UPDATE_BRANCH',initialBranch:getState().initialBranch,branch:data});};};var deleteExcelImport=function deleteExcelImport(data1){return function(dispatch,getState){var _getState10=getState(),branch=_getState10.branch;var data=Object.assign({},branch);/*data.settings.import_config.mapping = {
			...data.settings.import_config.mapping,
			[data1.key]:`${data1.key_name}${data1.key_option ? `:${data1.key_option}`:``}`
		}*/delete data.settings.import_config.mapping[data1];dispatch({type:'UPDATE_BRANCH',initialBranch:getState().initialBranch,branch:data});};};var updateBranchAddress=function updateBranchAddress(state){return function(dispatch,getState){var _getState11=getState(),company=_getState11.company,json_lang=_getState11.json_lang,branch=_getState11.branch;var data={domain:state.domain,address:state.address||branch.address,latitude_e6:branch.latitude_e6,// state.coords.lat || branch.latitude_e6,
longitude_e6:branch.longitude_e6// state.coords.lng || branch.longitude_e6
};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id,data).then(function(res){localStorage.setItem("activeBranch",JSON.stringify(res.data));__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:'UPDATE_BRANCH',branch:res.data,initialBranch:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var fetchBranchlist=function fetchBranchlist(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var sort=arguments[1];var search_query=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState12=getState(),company=_getState12.company,json_lang=_getState12.json_lang;var url_host='/branches?limit=16&page='+page+(sort?'&sort_by='+sort.columnName+','+sort.direction:'');url_host+=search_query!==''?'&name=ilike '+search_query:'';return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(''+(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+url_host)).then(function(res){dispatch({type:"FETCH_BRANCHES_LIST",branchesList:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var fetchBranchlistForMap=function fetchBranchlistForMap(){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState13=getState(),company=_getState13.company,json_lang=_getState13.json_lang;var url_host='/branches/all';return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(''+(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+url_host)).then(function(res){dispatch({type:"FETCH_BRANCHES_LIST_MAP",branchesListMap:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};/* const filterBranchStatus = (status) => {
    return (dispatch, getState) => {
			  const { branchesListMap } = getState();

				const mapBranches = branchesListMap.filter((branch) => {
					return branch.status === status;
				});

				dispatch({
					type: "FETCH_BRANCHES_LIST_MAP",
					branchesListMap: mapBranches,
				});
			}
} */var bulkbranchesActions=function bulkbranchesActions(action,data){return function(dispatch,getState){var _getState14=getState(),json_lang=_getState14.json_lang,company=_getState14.company;var branchesIds=data.map(function(branchs){return branchs.id;});var updateData={ids:branchesIds};console.log("data",data,updateData);dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/batch-action/set-'+action,updateData).then(function(res){if(res.data[0].payload.error_code==="EA174"){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:json_lang.common.error,msg:"No se puede colocar en servicio comercios sin stock en el inventario."});}else if(res.data[0].payload.error_code==="EA170"){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:json_lang.common.error,msg:"No se puede colocar en servicio comercios que no esten habilitados."});}else if(res.data[0].payload.error_code==="EF607"){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:json_lang.common.error,msg:"No se puede colocar en servicio comercios que no tengan métodos de pago configurados."});}else if(res.data[0].payload.error_code==="EA180"){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:json_lang.common.error,msg:"No se puede colocar en servicio comercios que no tengan administradores en línea."});}else if(res.data[0].payload.error_code==="EA172"){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:json_lang.common.error,msg:"Este comercio no está en servicio."});}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.update_successful});}/*let newdata= res.data.map( (item) => {
                return item.payload
            })*/// let errors = 0;
/* newdata.forEach( (item) => {
                if(item.id){
                    let index = goodsList.findIndex(good => good.id === item.id)
                    goodsList[index] = item
                }else{
                    errors++
                    Notification.show({type: "error", title:`Error ${item.error_code}`, msg: item.description });

                }
                //console.log("azuk",goodsList);
            })*/// if(errors === 0){
//     Notification.show({type: "success", title:json_lang.common.success, msg:json_lang.custom_success.update_successful});
// }
dispatch({type:"REMOVE_LOADING"});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.update_categories_product});});};};var fetchBranchGroups=function fetchBranchGroups(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var query=arguments[1];return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState15=getState(),company=_getState15.company,json_lang=_getState15.json_lang;//?limit=0
query=query?'&name=ilike '+encodeURIComponent(query):'';return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branch-groups?limit=10&sort_by=name,asc&page='+page+query).then(function(res){dispatch({type:"FETCH_BRANCH_GROUPS",branchGroups:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var fetchBranchGroupsByIds=function fetchBranchGroupsByIds(){var limit=arguments.length>0&&arguments[0]!==undefined?arguments[0]:10;var ids=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState16=getState(),company=_getState16.company,json_lang=_getState16.json_lang;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branch-groups?limit='+limit+'&page=1&id=:in:'+ids).then(function(res){dispatch({type:"FETCH_BRANCH_GROUPS_IDS",branchGroupsByIds:res.data.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var clearBranchGroupsByIds=function clearBranchGroupsByIds(){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});dispatch({type:"FETCH_BRANCH_GROUPS_IDS",branchGroupsByIds:[]});};};var fetchBranchGroup=function fetchBranchGroup(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState17=getState(),company=_getState17.company,json_lang=_getState17.json_lang;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branch-groups/'+id+'/branches?limit=0').then(function(res){dispatch({type:"FETCH_BRANCH_GROUP_LIST",branchGroupList:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var AddBranchInGroup=function AddBranchInGroup(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState18=getState(),company=_getState18.company,newBranch=_getState18.newBranch,json_lang=_getState18.json_lang,branchGroupList=_getState18.branchGroupList;var theBranch={name:newBranch.name,description:newBranch.description,address:"n/a",phone:newBranch.phone,domain:newBranch.domain,time_zone_offset:newBranch.time_zone_offset?newBranch.time_zone_offset:__WEBPACK_IMPORTED_MODULE_6__constants_general__["k" /* DEFAULT_TIME_ZONE */],latitude_e6:0,longitude_e6:0,city_id:newBranch.city_id||null};return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branch-groups/'+id+'/branches',theBranch).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});var update=branchGroupList.concat(res.data);dispatch({type:"FETCH_BRANCH_GROUP_LIST",branchGroupList:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var AddBranchGroup=function AddBranchGroup(){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState19=getState(),company=_getState19.company,json_lang=_getState19.json_lang,branchGroupData=_getState19.branchGroupData,branchGroups=_getState19.branchGroups;var theBranchG={name:branchGroupData.name,display_unavailable_goods:branchGroupData.display_unavailable_goods,enable_shoppers:branchGroupData.enable_shoppers,is_market:branchGroupData.is_market,promo_label:branchGroupData.promo_label,display_spent_goods:branchGroupData.display_spent_goods,enable_auto_image_search:branchGroupData.enable_auto_image_search,enable_pool:branchGroupData.enable_pool,description:branchGroupData.description,group_description:branchGroupData.group_description};if(branchGroupData.domain){theBranchG.domain=encodeURIComponent(branchGroupData.domain);return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branch-groups',theBranchG).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.update_successful});console.log('res data update',res.data);console.log('branchGroups update',branchGroups);//let update= branchGroups.data.concat(res.data)
branchGroups.data.unshift(res.data);console.log("update concat",branchGroups);dispatch({type:"FETCH_BRANCH_GROUPS",branchGroups:branchGroups});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});}};};var EditBranchGroup=function EditBranchGroup(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState20=getState(),company=_getState20.company,json_lang=_getState20.json_lang,branchGroupData=_getState20.branchGroupData;var theBranchG={name:branchGroupData.name,display_unavailable_goods:branchGroupData.display_unavailable_goods,enable_shoppers:branchGroupData.enable_shoppers,is_market:branchGroupData.is_market,promo_label:branchGroupData.promo_label,domain:encodeURIComponent(branchGroupData.domain),display_spent_goods:branchGroupData.display_spent_goods,is_digital:branchGroupData.is_digital,enable_pool:branchGroupData.enable_pool,description:branchGroupData.description,group_description:branchGroupData.group_description,settings:{template:branchGroupData.settings.template,int_sku_enabled:branchGroupData.settings.int_sku_enabled,is_food_vendor:branchGroupData.settings.is_food_vendor,enable_auto_image_search:branchGroupData.settings.enable_auto_image_search}};return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branch-groups/'+id,theBranchG).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.update_successful});/* let update= branchGroups.map( (branchGroup,key) => {
				if(branchGroup.id===id){
					branchGroup = res.data
				}
				return branchGroup
			}) *//*branchGroups[indexX] = res.data;
			let update = branchGroups
			console.log("update",update)*//* dispatch({
				type: "FETCH_BRANCH_GROUPS",
				branchGroups: update
			}) */}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var EditBranchGroupSettings=function EditBranchGroupSettings(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState21=getState(),company=_getState21.company,json_lang=_getState21.json_lang,branchGroupData=_getState21.branchGroupData,branchGroups=_getState21.branchGroups;var settings={template:branchGroupData.settings.template,color_accent:branchGroupData.settings.color_accent,color_primary:branchGroupData.settings.color_accent,int_sku_enabled:branchGroupData.settings.int_sku_enabled,is_food_vendor:branchGroupData.settings.is_food_vendor,enable_auto_image_search:branchGroupData.settings.enable_auto_image_search};return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branch-groups/'+id+'/settings',settings).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.update_successful});dispatch({type:"FETCH_BRANCH_GROUPS",branchGroups:branchGroups});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var ClearBranchGroup=function ClearBranchGroup(){return function(dispatch,getState){var update={name:"",display_unavailable_goods:false,enable_shoppers:false,is_market:false,enable_pool:false,display_spent_goods:false,is_digital:false};dispatch({type:"FETCH_BRANCH_GROUP_DATA",branchGroupData:update});};};var DeleteBranchGroup=function DeleteBranchGroup(branchGroupId){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState22=getState(),company=_getState22.company,branchGroups=_getState22.branchGroups,branchGroupList=_getState22.branchGroupList,json_lang=_getState22.json_lang;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branch-groups/'+branchGroupId).then(function(res){var updatedBranchGroupsList=[];if(branchGroupList){updatedBranchGroupsList=branchGroupList.filter(function(item){return branchGroupId!==item.id;});}__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.delete_successful});// let updatedBranchGroups = branchGroups.data.filter((item) => {
// 	return (branchGroupId !== item.id);
// })
// console.log('updatebranch delete', updatedBranchGroups)
// dispatch({
// 	type: "DELETE_BRANCH_GROUP",
// 	branchGroupList: updatedBranchGroupsList,
// 	branchGroups: updatedBranchGroups,
// 	hasDeletedSuccessfully: true
// })
}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var fetchBranch=function fetchBranch(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState23=getState(),company=_getState23.company,branch=_getState23.branch,json_lang=_getState23.json_lang;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+(id||branch.id)).then(function(res){var update=res.data;update.settings.human_branch_fee_prc=update.settings.human_order_tax_prc-update.settings.human_service_fee_prc;dispatch({type:"FETCH_BRANCH",branch:res.data,initialBranch:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var fetchBranchSettings=function fetchBranchSettings(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState24=getState(),company=_getState24.company,branch=_getState24.branch,json_lang=_getState24.json_lang;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+(id||branch.id)+'/settings').then(function(res){branch.settings=res.data;var update=branch;var newDate=update.settings.mark_too_busy_until;if(newDate){var date=new Date(newDate);var actualDate=new Date();var timeDifference=date-actualDate;var closestTime=__WEBPACK_IMPORTED_MODULE_6__constants_general__["z" /* MIN_LIST */].reduce(function(prev,curr){return Math.abs(curr.value-timeDifference)<Math.abs(prev.value-timeDifference)?curr:prev;});var minutesDifference=Math.floor(timeDifference/(1000*60));update.settings.minutes_difference=minutesDifference>0?minutesDifference:null;newDate=closestTime.value;}update.settings.human_branch_fee_prc=update.settings.human_order_tax_prc-update.settings.human_service_fee_prc;update.settings.pool_mode=res.data.pool_mode==="company";update.settings.mark_too_busy_until=newDate;dispatch({type:"FETCH_BRANCH",branch:update,initialBranch:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var DeleteBranch=function DeleteBranch(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState25=getState(),company=_getState25.company,branchGroupList=_getState25.branchGroupList,json_lang=_getState25.json_lang;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+id).then(function(res){var update=branchGroupList.filter(function(item){return id!==item.id;});__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.delete_successful});dispatch({type:"FETCH_BRANCH_GROUP_LIST",branchGroupList:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var fetchCompanyBranches=function fetchCompanyBranches(){var limit=arguments.length>0&&arguments[0]!==undefined?arguments[0]:10;var query=arguments[1];var page=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;var loader=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;return function(dispatch,getState){if(loader)dispatch({type:"WAIT_FOR_RESPONSE"});var _getState26=getState(),company=_getState26.company,json_lang=_getState26.json_lang,branches=_getState26.branches;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches?with=city&page='+page+'&limit='+limit+(query?'&name=ilike '+encodeURIComponent(query):'')).then(function(res){var response=res.data.data;dispatch({type:"FETCH_BRANCHES",branches:response});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:json_lang.custom_errors.company_update_failed});});};};var fetchProviderBranchAccesses=function fetchProviderBranchAccesses(ids){return function(dispatch,getState){var _getState27=getState(),company=_getState27.company,json_lang=_getState27.json_lang;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches?with=city&id=:in:'+ids.join(',')).then(function(res){dispatch({type:"FETCH_PROVIDER_BRANCHES_ACCESSES",providerBranchAccesses:res.data.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:json_lang.custom_errors.company_update_failed});});};};var searchBranchesByCity=function searchBranchesByCity(id){return function(dispatch,getState){var _getState28=getState(),company=_getState28.company,json_lang=_getState28.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches?city_id='+id).then(function(res){dispatch({type:"FETCH_BRANCHES",branches:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:json_lang.custom_errors.retrieving_user_list});});};};var toggleBranchEnabledStatus=function toggleBranchEnabledStatus(branch_id,status,isFromAllBranch){return function(dispatch,getState){var _getState29=getState(),company=_getState29.company,json_lang=_getState29.json_lang,branchesList=_getState29.branchesList;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branch_id+'/set-'+(!status?'disabled':'enabled')).then(function(res){if(isFromAllBranch){return;// TODO: Por ahora coloco retorno, ya que el componente no se esta actualizando a pesar de que se setea un nuevo estados
// const index = branchesList.data.findIndex(branch => branch.id === res.data.id)
// let branches_list = branchesList;
// branches_list.data[index] = res.data;
// branches_list.data = [...branches_list.data]
// dispatch({
// 	type: "FETCH_BRANCHES_LIST",
// 	branchesList: branches_list
// })
}else{dispatch({type:"FETCH_BRANCH_GROUP_LIST",branchGroupList:Object(__WEBPACK_IMPORTED_MODULE_3__tableActions__["j" /* tableUpdate */])(res,"branchGroupList")});}__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var toggleBranchVisibleStatus=function toggleBranchVisibleStatus(branch_id,status,isFromAllBranch){return function(dispatch,getState){var _getState30=getState(),company=_getState30.company,json_lang=_getState30.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branch_id+'/set-'+(!status?'hidden':'visible')).then(function(res){if(isFromAllBranch){return;}else{dispatch({type:"WAIT_FOR_RESPONSE"});dispatch({type:"FETCH_BRANCH_GROUP_LIST",branchGroupList:Object(__WEBPACK_IMPORTED_MODULE_3__tableActions__["j" /* tableUpdate */])(res,"branchGroupList")});}__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var toggleBranchServiceStatus=function toggleBranchServiceStatus(branch_id,status,isFromAllBranch){return function(dispatch,getState){var _getState31=getState(),company=_getState31.company,json_lang=_getState31.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branch_id+'/set-'+(!status?'in-service-disabled':'in-service-enabled')).then(function(res){if(isFromAllBranch){return;}else{dispatch({type:"WAIT_FOR_RESPONSE"});dispatch({type:"FETCH_BRANCH_GROUP_LIST",branchGroupList:Object(__WEBPACK_IMPORTED_MODULE_3__tableActions__["j" /* tableUpdate */])(res,"branchGroupList")});}__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){if(err.data){switch(err.data.error_code){case"EA170":__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:"Error",msg:"No se puede colocar en servicio comercios que no estén habilitados."});break;case"EA174":__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:"Error",msg:"No se puede colocar en servicio comercios sin stock en el inventario."});break;case"EF607":__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:"Error",msg:"No se puede colocar en servicio comercios que no tengan métodos de pago configurados."});break;case"EA180":__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:"Error",msg:"No se puede colocar en servicio comercios que no tengan administradores en línea."});break;case"EA172":__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:"Error",msg:"Este comercio no está en servicio."});break;default:if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});break;}}else{if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});}});};};var updateSelectedBranch=function updateSelectedBranch(userBranch){return function(dispatch,getState){var _getState32=getState(),company=_getState32.company,json_lang=_getState32.json_lang,branch=_getState32.branch,userHigherAccess=_getState32.userHigherAccess;if(userBranch&&userBranch.id||branch&&branch.id){dispatch({type:"WAIT_FOR_RESPONSE"});localStorage.setItem('activeBranch',JSON.stringify(userBranch));return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+(userBranch.id||branch.id)+(userHigherAccess===__WEBPACK_IMPORTED_MODULE_6__constants_general__["h" /* COMPANY_ACCESS */]?'/settings':'')).then(function(res){userBranch.settings=res.data;var update=userBranch;update.settings.human_branch_fee_prc=update.settings.human_order_tax_prc-update.settings.human_service_fee_prc;localStorage.setItem('activeBranch',JSON.stringify(userBranch));dispatch({type:"FETCH_BRANCH",branch:userBranch,initialBranch:userBranch});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});}else{localStorage.setItem('activeBranch',JSON.stringify({}));dispatch({type:"FETCH_BRANCH",branch:userBranch,initialBranch:userBranch});}};};/*
const updateCompanyInformation = () => {
    return (dispatch,getState) => {
        let { branch,initCompany,company } = getState();
        let data = {
            settings:{}
        }

        if(initCompany.options !== branch.options){
            data.options = branch.options
        }

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.patch(`${URL+company.id}`, data).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful} );
            dispatch({
				type: "FETCH_BRANCH",
				branch: res.data,
				initialBranch: res.data,
			})
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.company_update_failed });
        });
    }
}
*/var toggleData=function toggleData(value){return function(dispatch,getState){//let {branch, editable_company_settings,initialBranch} = getState();
var data=Object.assign({},getState().branch);//let settingsX = value.name && value.name.split('_setting');
var option="";if(value&&value.name&&value.name.split("-")){option=value&&value.name.split("-");}if(value.name==='in_service'){data.in_service=value.checked===true?true:false;}/* else if (value.name === 'enable_multi_providers') {
			editable_company_settings.enable_multi_providers = !editable_company_settings.enable_multi_providers;

		}*/else if(value.name==='uid'){data.settings.uid=value.data;}else if(value.longitude_e6||value.latitude_e6){data.longitude_e6=value.longitude_e6;data.latitude_e6=value.latitude_e6;}else if(value.name==='human_service_fee_prc'||value.name==='human_branch_fee_prc'||value.name==='human_service_fee_flat_e2'||value.name==='human_order_tax_flat_e2'||value.name==='max_simultaneous_deliveries'||value.name==='mark_too_busy_until'||value.name==='auto_busy_quantity'||value.name==='legal_name_for_fiscal_docs'||value.name==='islr_prc'||value.name==='iva_retention_prc'||value.name==='address_for_fiscal_docs'||value.name==='email_for_fiscal_docs'){data.settings[value.name]=value.data;data.settings["human_order_tax_prc"]=parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(data.settings.human_branch_fee_prc))+parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(data.settings.human_service_fee_prc))//( !Number.isNaN(editable_company_settings.human_service_fee_prc) ? editable_company_settings.human_service_fee_prc : 0)
;}else if(value.name==='human_delivery_discount_prc'||value.name==='order_expiration_minutes'){data.settings[value.name]=parseFloat(value.data);}else if(value.name==='human_min_checkout_price_e2'||value.name==='payments_mode'||value.name==='max_scheduling_days'||value.name==='service_fee_name'){data.settings[value.name]=value.data;}else if(value.name==='pool_mode'||value.name==='enable_work_schedules'||value.name==='auto_sync_work_schedules'||value.name==='is_special_contributor'||value.name==='is_payment_deduction_disabled'||value.name==='is_digital_invoice_enabled'||value.name==='is_pool_automatic'){data.settings[value.name]=value.checked;}else if(option.length>1){var mValue=parseInt(value.data,10);if((mValue&768)!==0){//alternar donde se coincinde los pick ups o delivery para q almenos uno este selectionados
data.options&=~(768^mValue);mValue|=256;}if((mValue&768<<12)!==0){//alternar donde se coincinde los pick ups o delivery para q almenos uno este selectionados
data.options&=~(768<<12^mValue);mValue|=256<<12;}data.options^=mValue;}else if(value.name==='refresh_data'||value.name==='clear_missing'||value.name==='debug'||value.name==='check_in_service'){data.settings.import_config.config[value.name]=value.checked===true?true:false;}else if(value.name==='starting_cell'||value.name==='currency'||value.name==='quantity_threshold'||value.name==='quantity_reservation'){if(data.settings&&data.settings.import_config&&data.settings.import_config.config){data.settings.import_config.config[value.name]=value.value;}}/*else if(settingsX && settingsX.length >1){
			console.log(
				"test",
				settingsX[1],
				settingsX[0],
				data.settings.delivery_fee_steps,
				data.settings.delivery_fee_steps[settingsX[1]][settingsX[0]],
				value,
				value.checked
			);

			console.log("is_additional",settingsX[0] === "is_additional")
			settingsX[0] === "is_additional" ?
			data.settings.delivery_fee_steps[settingsX[1]][settingsX[0]] = value.checked
			:
			data.settings.delivery_fee_steps[settingsX[1]][settingsX[0]] = value.data
        }*/else if(value.type){var firstOption=data.settings.import_config.mapping[value.name].split(":").length>1?data.settings.import_config.mapping[value.name].split(":")[0]:data.settings.import_config.mapping[value.name];var secondOption=data.settings.import_config.mapping[value.name].split(":")[1]?data.settings.import_config.mapping[value.name].split(":")[1]:'';if(value.type==='key'){data.settings.import_config.mapping[value.name]=secondOption?value.value+(':'+secondOption):value.value;}else{data.settings.import_config.mapping[value.name]=firstOption+(':'+value.value);}}else if(value.name==='has_custom_settings'){data.has_custom_settings=!value.checked;}else if(value.name==="auto_assign_driver_upon_payment"){data.settings.auto_assign_driver_upon_payment=value.checked;}else if(value.name==="inventory_reminder_delay"){console.log("value ====> ",value);if(value.checked){data.settings.inventory_reminder_delay=72;}else{data.settings.inventory_reminder_delay=0;}}else{data[value.name]=value.data;}//console.log("import_config",data.settings.import_config)
dispatch({type:'UPDATE_BRANCH',initialBranch:getState().initialBranch,branch:data});};};var toggleData2=function toggleData2(value){return function(dispatch,getState){var _getState33=getState(),branch=_getState33.branch,editable_company_settings=_getState33.editable_company_settings;branch[value.name]=value.data;dispatch({type:'UPDATE_BRANCH',branch:branch,editable_company_settings:editable_company_settings});};};var toggleDataBranchFeeds=function toggleDataBranchFeeds(value){return function(dispatch,getState){var data=[].concat(_toConsumableArray(getState().branchDeliveryFees));var settingsX=value.name.split('_setting');data[settingsX[1]][settingsX[0]]=settingsX[0]==="is_additional"?value.checked:value.data;dispatch({type:'BRANCH_DELIVERY_FEEDS',branchDeliveryFees:data});};};var toggleData4=function toggleData4(value){return function(dispatch,getState){var _getState34=getState(),newBranch=_getState34.newBranch;newBranch[value.name]=value.data;dispatch({type:'UPDATE_NEWBRANCH',newBranch:newBranch});};};var clearNewBranch=function clearNewBranch(value){return function(dispatch,getState){var _getState35=getState(),editable_company_settings=_getState35.editable_company_settings;var update={name:"",description:"",address:"",phone:"",time_zone_offset:""};dispatch({type:'UPDATE_NEWBRANCH',newBranch:update,editable_company_settings:editable_company_settings});};};var clearBranch=function clearBranch(value){return function(dispatch,getState){var _getState36=getState(),editable_company_settings=_getState36.editable_company_settings;var update={name:"",description:"",address:"",phone:"",time_zone_offset:""};dispatch({type:'UPDATE_BRANCH',branch:update,editable_company_settings:editable_company_settings});};};var toggleData3=function toggleData3(value){return function(dispatch,getState){var _getState37=getState(),branchGroupData=_getState37.branchGroupData;var data=Object.assign({},branchGroupData);if(value.name==='is_digital'||value.name==='display_spent_goods'||value.name==='enable_shoppers'||value.name==='is_market'||value.name==='display_unavailable_goods'||value.name==='enable_pool'){data[value.name]=value.checked;}else if(value.name==='template'||value.name==='color_accent'){if(data&&data.settings){data.settings[value.name]=value.data;}else{data.settings={};data.settings[value.name]=value.data;}}else if(value.name==='enable_auto_image_search'||value.name==='int_sku_enabled'||value.name==='is_food_vendor'){data.settings[value.name]=value.checked;}else{data[value.name]=value.data;}dispatch({type:'FETCH_BRANCH_GROUP_DATA',branchGroupData:data});};};var updateBranchInServiceStatus=function updateBranchInServiceStatus(enabled){return function(dispatch,getState){var _getState38=getState(),company=_getState38.company,json_lang=_getState38.json_lang,branch=_getState38.branch;dispatch({type:"WAIT_FOR_RESPONSE"});// cuando llega aqui branch.in_service ya viene seteada con el valor contrario al q tiene el api... por eso se niega con !branch.in_service
return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id+'/set-in-service-'+(enabled?'enabled':'disabled')).then(function(res){dispatch({type:"WAIT_FOR_RESPONSE"});dispatch({type:"FETCH_BRANCH",branch:res.data});localStorage.setItem("activeBranch",JSON.stringify(res.data));__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var toggleBranchInFeature=function toggleBranchInFeature(branch_id,status,isFromAllBranch){return function(dispatch,getState){var _getState39=getState(),company=_getState39.company,json_lang=_getState39.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branch_id+'/set-featured-'+(!status?'disabled':'enabled')).then(function(res){if(isFromAllBranch){return;}else{dispatch({type:"WAIT_FOR_RESPONSE"});dispatch({type:"FETCH_BRANCH_GROUP_LIST",branchGroupList:Object(__WEBPACK_IMPORTED_MODULE_3__tableActions__["j" /* tableUpdate */])(res,"branchGroupList")});}__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var accesessss=function accesessss(id){return function(dispatch,getState){var _getState40=getState(),company=_getState40.company,json_lang=_getState40.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});// cuando llega aqui branch.in_service ya viene seteada con el valor contrario al q tiene el api... por eso se niega con !branch.in_service
return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+id+'/admin-accesses?limit=0&with=admin').then(function(res){//dispatch({type: "WAIT_FOR_RESPONSE"})
dispatch({type:"FETCH_ADMINS_ACCESS",admindAccessList:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var getBrancchGroupAcceses=function getBrancchGroupAcceses(id){return function(dispatch,getState){var _getState41=getState(),company=_getState41.company,json_lang=_getState41.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});// cuando llega aqui branch.in_service ya viene seteada con el valor contrario al q tiene el api... por eso se niega con !branch.in_service
return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branch-groups/'+id+'/admin-accesses?limit=0&with=admin').then(function(res){//dispatch({type: "WAIT_FOR_RESPONSE"})
dispatch({type:"FETCH_ADMINS_ACCESS",admindAccessList:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var Addaccesessss=function Addaccesessss(access_type,id,access_id){return function(dispatch,getState){var _getState42=getState(),company=_getState42.company,json_lang=_getState42.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});var data={access_type:access_type,access_id:access_id};return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/admins/'+id+'/admin-accesses',data).then(function(res){dispatch({type:"FETCH_ADMINS_ACCESS",admindAccessList:res.data});__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var DeleteAccesessss=function DeleteAccesessss(id){return function(dispatch,getState){var _getState43=getState(),company=_getState43.company,json_lang=_getState43.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/admin-accesses/'+id).then(function(res){dispatch({type:"FETCH_ADMINS_ACCESS",admindAccessList:res.data});__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var getBranchDeliveryFees=function getBranchDeliveryFees(branchId){return function(dispatch,getState){var _getState44=getState(),company=_getState44.company,json_lang=_getState44.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branchId+'/delivery-fees?limit=0').then(function(res){dispatch({type:'BRANCH_DELIVERY_FEEDS',branchDeliveryFees:res.data});}).catch(function(err){console.log("errerrerrerrerrerrerr",err);if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});/*else if (err.data.errors.date_at && err.data.errors.date_at[0].indexOf("after_or_equal") !== -1 )
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.date_prior_today });*/else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var getBranchRatings=function getBranchRatings(id){return function(dispatch,getState){var _getState45=getState(),company=_getState45.company;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+id+'/branch-ratings').then(function(res){dispatch({type:"FETCH_BRANCH_RATINGS",branchRatings:res.data});}).catch(function(err){console.log("fallo el traer los ratings",err);});};};var getOrderBranchRatings=function getOrderBranchRatings(id){var query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';return function(dispatch,getState){var _getState46=getState(),company=_getState46.company;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+id+'/branch-ratings'+query).then(function(res){dispatch({type:"FETCH_ORDER_BRANCH_RATINGS",orderBranchRatings:res.data});}).catch(function(err){console.log("fallo el traer los ratings",err);});};};var addBranchDeliveryFeeSteps=function addBranchDeliveryFeeSteps(){return function(dispatch,getState){var _getState47=getState(),branchDeliveryFees=_getState47.branchDeliveryFees;var data=[].concat(_toConsumableArray(branchDeliveryFees));var step={name:"",distance_min:"",distance_max:"",human_fee_min_e2:"",human_fee_max_e2:"",human_delivery_providers_prc:"",hour_beg:"",hour_end:"",label:"",is_additional:false,days:[]};data.push(step);dispatch({type:'BRANCH_DELIVERY_FEEDS',branchDeliveryFees:data});};};var updatebranchDeliveryFeeSteps=function updatebranchDeliveryFeeSteps(branch_id){return function(dispatch,getState){var _getState48=getState(),company=_getState48.company,branchDeliveryFees=_getState48.branchDeliveryFees,json_lang=_getState48.json_lang;var data=[].concat(_toConsumableArray(branchDeliveryFees));var theUpdate=data.map(function(step,key){var update=void 0;if(step.name!==""&&step.distance_min!==""&&step.distance_max!==""&&step.human_fee_min_e2!==""&&step.human_fee_min_e2!==0&&step.human_fee_max_e2!==""&&step.human_fee_max_e2!==0&&step.human_delivery_providers_prc!==""&&step.human_delivery_providers_prc!==0){update={name:step.name,distance_min:step.distance_min,distance_max:step.distance_max,human_fee_min_e2:step.human_fee_min_e2,human_fee_max_e2:step.human_fee_max_e2,human_delivery_providers_prc:step.human_delivery_providers_prc,hour_beg:step.hour_beg,hour_end:step.hour_end,is_additional:step.is_additional,label:step.label,days:[]};}return update;}).filter(function(step){return step!==undefined;});dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].put(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branch_id+'/delivery-fees',theUpdate).then(function(res){localStorage.setItem("activeBranch",JSON.stringify(res.data));__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:'BRANCH_DELIVERY_FEEDS',branchDeliveryFees:res.data});});};};var deleteBranchDeliveryFeeSteps=function deleteBranchDeliveryFeeSteps(keyId){return function(dispatch,getState){var data=Object.assign({},getState().branch);var update=data.settings&&data.settings.delivery_fee_steps.filter(function(step,key){return key!==keyId;});data.settings.delivery_fee_steps=update;dispatch({type:'UPDATE_BRANCH',branch:data,initialBranch:data});};};var getBranchCurrencies=function getBranchCurrencies(){return function(dispatch,getState){var _getState49=getState(),company=_getState49.company,json_lang=_getState49.json_lang,branch=_getState49.branch;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id+'/currencies?limit=0').then(function(res){var errorCurrencies=false;res.data.forEach(function(curreny,key){if(curreny.related_iso_error===true){errorCurrencies=true;}});dispatch({type:'FETCH_BRANCH_CURRENCIES',branchCurrencies:res.data,branchCurrencyError:errorCurrencies});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var clearBranchCurrency=function clearBranchCurrency(){return function(dispatch){dispatch({type:'FETCH_BRANCH_CURRENCY',companyCurrency:{enabled:false,iso:"",symbol:"",conversion_factor:"",related_iso:"",decimals_count:0,format:"",decimal_point:"",use_thousands_separator:false,thousands_separator:"",is_local:false,is_international:false,use_conversion:false,available:false}});};};var toogleBranchCurrency=function toogleBranchCurrency(value){return function(dispatch,getState){var data=Object.assign({},getState().branchCurrency);if(value.name==="enabled"||value.name==="available"||value.name==="use_thousands_separator"||value.name==="is_local"||value.name==="is_custom"||value.name==="auto_sync"||value.name==="is_international"){data[value.name]=value.checked;}else{data[value.name]=value.data;}dispatch({type:'FETCH_BRANCH_CURRENCY',branchCurrency:data});};};var createBranchCurrency=function createBranchCurrency(){return function(dispatch,getState){var _getState50=getState(),company=_getState50.company,json_lang=_getState50.json_lang,branchCurrencies=_getState50.branchCurrencies,branch=_getState50.branch,companyCurrency=_getState50.companyCurrency;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id+'/currencies',companyCurrency).then(function(res){var update=branchCurrencies.concat(res.data);dispatch({type:'FETCH_BRANCH_CURRENCIES',branchCurrencies:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var getPriceList=function getPriceList(){return function(dispatch,getState){var _getState51=getState(),company=_getState51.company,json_lang=_getState51.json_lang,branch=_getState51.branch,companyCurrency=_getState51.companyCurrency;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id+'/price-lists?limit=0',companyCurrency).then(function(res){/*let update = branchCurrencies.concat(res.data)*/dispatch({type:'FETCH_BRANCH_PRICELIST',branchPriceList:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err&&err.data&&err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var getPriceListId=function getPriceListId(id){return function(dispatch,getState){var _getState52=getState(),company=_getState52.company,companyCurrency=_getState52.companyCurrency;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/price-lists/'+id,companyCurrency).then(function(res){/*let update = branchCurrencies.concat(res.data)*/var response=res.data;/*response.price_adjustment_e2 = response.price_adjustment_e2*100;
			response.price_multiple_e2 = response.price_multiple_e2*100;*/dispatch({type:'FETCH_BRANCH_PRICELIST_ID',priceListId:response});}).catch(function(err){});};};var storePriceList=function storePriceList(){return function(dispatch,getState){var _getState53=getState(),company=_getState53.company,json_lang=_getState53.json_lang,branch=_getState53.branch,priceListId=_getState53.priceListId;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id+'/price-lists',priceListId).then(function(res){/*let update = branchCurrencies.concat(res.data)
            dispatch({
                type: 'FETCH_BRANCH_PRICELIST',
                branchPriceList: res.data
            })*/}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var editPriceList=function editPriceList(id){return function(dispatch,getState){var _getState54=getState(),company=_getState54.company,json_lang=_getState54.json_lang,branchPriceList=_getState54.branchPriceList,priceListId=_getState54.priceListId;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/price-lists/'+id,priceListId).then(function(res){/*let update = branchCurrencies.concat(res.data)*/dispatch({type:'FETCH_BRANCH_PRICELIST',branchPriceList:branchPriceList});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var deletePriceList=function deletePriceList(id){return function(dispatch,getState){var _getState55=getState(),company=_getState55.company,json_lang=_getState55.json_lang,branchPriceList=_getState55.branchPriceList;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/price-lists/'+id,branchPriceList).then(function(res){/*let update = branchCurrencies.concat(res.data)
            dispatch({
                type: 'FETCH_BRANCH_PRICELIST',
                branchPriceList: res.data
            })*/}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else if(err.data.errors.date_at&&err.data.errors.date_at[0].indexOf("after_or_equal")!==-1)__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.date_prior_today});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var clearPriceList=function clearPriceList(){var clear={};return function(dispatch){dispatch({type:'FETCH_BRANCH_PRICELIST_ID',priceListId:clear});};};var toggleDataPricelist=function toggleDataPricelist(value){return function(dispatch,getState){var _getState56=getState(),priceListId=_getState56.priceListId;var data=Object.assign({},priceListId);data[value.name]=value.data;dispatch({type:'FETCH_BRANCH_PRICELIST_ID',priceListId:data});};};var toggleDataBranchServiceModifiers=function toggleDataBranchServiceModifiers(value){return function(dispatch,getState){var data=Object.assign({},getState().branch);var item=value.name.split('_service')[0];var key=value.name.split('_service')[1];data.settings.service_app_modifiers[key][item]=value.data;dispatch({type:'UPDATE_BRANCH',branch:data,initialBranch:data});};};var addBranchServiceModifiers=function addBranchServiceModifiers(){return function(dispatch,getState){var data=Object.assign({},getState().branch);var step={name:"",label:"",price_max_e2:"",price_min_e2:"",order_fee_e2:"",client_fee_e2:"",order_fee_prc:"",hour_beg:"",hour_end:""};data.settings.service_app_modifiers.push(step);dispatch({type:'UPDATE_BRANCH',branch:data,initialBranch:data});};};var deleteBranchServiceModifiers=function deleteBranchServiceModifiers(keyId){return function(dispatch,getState){var data=Object.assign({},getState().branch);var update=data.settings&&data.settings.service_app_modifiers.filter(function(step,key){return key!==keyId;});data.settings.service_app_modifiers=update;dispatch({type:'UPDATE_BRANCH',branch:data,initialBranch:data});};};var updateBranchPaymentEmails=function updateBranchPaymentEmails(emails){return function(dispatch,getState){var _getState57=getState(),company=_getState57.company,branch=_getState57.branch,json_lang=_getState57.json_lang;var data={emails_for_payments:emails};var branchData=branch;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id+'/settings',data).then(function(res){branchData.settings=res.data;var update=branchData;localStorage.setItem("activeBranch",JSON.stringify(update));__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:'UPDATE_BRANCH',branch:update,initialBranch:update});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.company_update_failed});});};};var getWorkSchedulesForOrdering=function getWorkSchedulesForOrdering(branchId){return function(dispatch,getState){var _getState58=getState(),company=_getState58.company,branch=_getState58.branch;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+('/branches/'+(branchId||branch.id)+'/work-schedules/for-ordering')).then(function(res){dispatch({type:"GET_WORK_SCHEDULES_FOR_ORDERING",workSchedulesForOrdering:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err&&err.data&&err.data.description||"Error desconocido"});});};};var getBranchHolidays=function getBranchHolidays(){return function(dispatch,getState){var _getState59=getState(),company=_getState59.company,branch=_getState59.branch,json_lang=_getState59.json_lang;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+('/branches/'+branch.id+'/holidays?limit=0')).then(function(res){dispatch({type:"BRANCH_HOLIDAYS",branchHolidays:res.data});}).catch(function(err){dispatch({type:"ERROR_BRANCH_HOLIDAYS"});if(err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:error.message});}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:json_lang.two_steps_modal.default_error});}});};};var createBranchHoliday=function createBranchHoliday(payload){return function(dispatch,getState){var _getState60=getState(),company=_getState60.company,branch=_getState60.branch,json_lang=_getState60.json_lang,branchHolidays=_getState60.branchHolidays;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+('/branches/'+branch.id+'/holidays'),payload).then(function(res){dispatch({type:"BRANCH_HOLIDAYS",branchHolidays:[].concat(_toConsumableArray(branchHolidays),[res.data])});__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){if(err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:error.message});}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:json_lang.two_steps_modal.default_error});}});};};var updateBranchHoliday=function updateBranchHoliday(payload){return function(dispatch,getState){var _getState61=getState(),company=_getState61.company,json_lang=_getState61.json_lang,branchHolidays=_getState61.branchHolidays;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+('/holidays/'+payload.id),payload).then(function(res){dispatch({type:"BRANCH_HOLIDAYS",branchHolidays:branchHolidays.map(function(holiday){return holiday.id===payload.id?res.data:holiday;})});__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.update_successful});}).catch(function(err){if(err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:error.message});}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:json_lang.two_steps_modal.default_error});}});};};var deleteHoliday=function deleteHoliday(id){return function(dispatch,getState){var _getState62=getState(),company=_getState62.company,json_lang=_getState62.json_lang,branchHolidays=_getState62.branchHolidays;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+('/holidays/'+id)).then(function(){dispatch({type:"BRANCH_HOLIDAYS",branchHolidays:branchHolidays.filter(function(holiday){return holiday.id!==id;})});__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.delete_successful});}).catch(function(err){if(err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:error.message});}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:json_lang.two_steps_modal.default_error});}});};};

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapQueryString", function() { return mapQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withApiService", function() { return withApiService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(281);
/**
 * @description this configures the base URL to make it point to
 * the current company, this behavior can be overriden by passing
 * through an entire URL with protocol
 * @example
 * build in URL: /branches/2
 * overriden URL: https://www.google.com.ve
 * @type {string}
 */var baseURL=''+__WEBPACK_IMPORTED_MODULE_2__config__["c" /* URL */]+localStorage.getItem('companyId');__WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].defaults.baseURL=baseURL;/**
 * @description this parses an object and turns it into a query string
 * excluding empty, null and undefined values
 * @param filters
 * @returns {string}
 */var mapQueryString=function mapQueryString(filters){var appendingQueryString=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return Object.entries(filters).filter(function(entry){return entry[1]!==''&&entry[1]!==null&&entry[1]!==undefined;}).map(function(entry,index){return''+(index===0&&!appendingQueryString?'?':'&')+entry[0]+'='+entry[1];/*.replaceAll(/\s+/gm, '') // removes all new lines, tabs and spaces
                .trim()*/}).join('');};var files=__webpack_require__(618);var resources=files.keys()// gets all directory urls
.filter(function($0){return $0!=='./index.js';})// exclude this file from the list of urls
.map(function($0){return{file:files($0).default,info:$0};})// executes and read each file
.filter(function($0){return typeof $0.file==='function';});// verifies that the file exports a function
var api={};resources.forEach(function($0){api[$0.info.split('.')[1].replace('/','')]=$0.file({axios:__WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */],mapQueryString:mapQueryString,baseURL:baseURL});});/**
 * @description this allow to use withApiService to wrap a component
 * and automatically inject all the api services into that component as props under the `api` attribute
 * @param WrappedComponent
 * @returns {function(*): *}
 */var withApiService=function withApiService(WrappedComponent){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent,Object.assign({},props,{api:api,bitwise:__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* bitwise */],notification:__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */]}));};};/* harmony default export */ __webpack_exports__["default"] = (api);

/***/ }),
/* 65 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearBroadcastMessageDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getBroadcastMessage; });
/* unused harmony export toggleData */
/* unused harmony export sendBroadcastMessage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchNewNotificationsPaginated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appendNotificationToSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchNewNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return markNotificationConsumed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearNotification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return showNotificationForPushEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setNotificationsListEmpty; });
/* unused harmony export mergeUpdateIntoObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getBroadcastMessageDetail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__push_notification__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_general__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//******************************* Utilities
/**
 * Merge the new items from update object to source object, based on the "touched paths" or keys that the update should replace. It has preference for the update over the old data on those keys and leave the rest intact.
 */var mergeUpdateIntoObject=function mergeUpdateIntoObject(paths,source,update){var result=Object.assign({},source);for(var p in paths){result[paths[p]]=update[paths[p]];}return result;};//*******************************
var clearNotification=function clearNotification(){/* TODO: eliminar esto */return function(dispatch){var initNotification={message:'',title:'',level:0};dispatch({type:'NOTIFICATION',notification:initNotification});};};var appendNotificationToSidebar=function appendNotificationToSidebar(notification,pag){var results={type:"ADD_NOTIFICATION_SIDEBAR",push:{title:notification.title,msg:notification.msg,url:notification.url,type:notification.type,consumed:notification.consumed,id:notification.id},unseenNotifications:notification.consumed===undefined?true:false};if(pag){results={title:notification.title,msg:notification.msg,url:notification.url,type:notification.type,consumed:notification.consumed,id:notification.id};}var list=__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getState();/* xHACER: aqui debo validar si debe llevar data el push o no, en vez de preguntar por update preguntar por eso */if(notification.update){var notification_storeKey=list[notification.storeKey]&&list[notification.storeKey].data||list[notification.storeKey];var target=_defineProperty({},notification.storeKey,null);var idx=void 0;if(notification.operation==="replace-from-paginated-list"){/* update item in a list. exm: An order in list orders... find by id */idx=list[notification.storeKey]&&list[notification.storeKey].data?list[notification.storeKey].data.findIndex(function(elm){return elm.id===notification.update.id;}):-1;var arrayOfPage=list[notification.storeKey].data;if(idx!==-1){// found the item in the list
// debido a la naturaleza asincrona de js, no puedo colocar el siguiente indice en la linea de arriba
// para hacer un oneliner
arrayOfPage[idx]=Object.assign({},notification.update);// mergeUpdateIntoObject(notification.touchedPropsToReplace, target[notification.storeKey][idx], notification.update);
results.updates=Object.assign({},notification.update);}return results;}if(notification.operation==="replace-from-list"){/* update item in a list. exm: An order in list orders... find by id */idx=notification_storeKey&&notification_storeKey.length?notification_storeKey.findIndex(function(elm){return elm.id===notification.update.id;}):-1;if(idx!==-1){// found the item in the list
target[notification.storeKey]=[].concat(_toConsumableArray(list[notification.storeKey]));// retrieve the source data
target[notification.storeKey][idx]=Object.assign({},notification.update);// mergeUpdateIntoObject(notification.touchedPropsToReplace, target[notification.storeKey][idx], notification.update);
}else{if(notification.type!=="neworder"){target[notification.storeKey]=list[notification.storeKey];}}}else if(notification.operation==="append"){if(notification.update&&notification.storeKey&&list[notification.storeKey]){target[notification.storeKey]=[notification.update].concat(_toConsumableArray(list[notification.storeKey]));}}else{// here is  notification.update.operation === "replace"
target[notification.storeKey]=Object.assign({},list[target.storeKey]);// retrieve the source data
target[notification.storeKey]=Object.assign({},notification.update);// mergeUpdateIntoObject(notification.touchedPropsToReplace, target[notification.storeKey], notification.update);
}results.updates=target;if(notification.type==="neworder")results.updates.newOrderTableRowAdded=notification.update.id;}/*if(notification.update){
 probar aqui
    }*///localStorage.setItem("notifications", JSON.stringify([...list.notifications, results.push]) );
return results;};var showNotificationForPushEvent=function showNotificationForPushEvent(){return{type:'PUSH_NOTIFICATION',notificationPushEvent:true};};var setNotificationsListEmpty=function setNotificationsListEmpty(){//localStorage.setItem("notifications", JSON.stringify([]));
return{type:'EMPTY_NOTIFICATION_LIST'};};/* Database notifications  */var fetchNewNotifications=function fetchNewNotifications(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return function(dispatch,getState){var _getState=getState(),session=_getState.session;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_3__config_js__["c" /* URL */]+getState().company.id+'/accounts/'+getState().session.account_id+'/notifications?page='+page+'&limit=8').then(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res){var data,list,idx,notification,_res,unseen;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:data=res.data.data;// aqui la data llega en el objeto res.data.data para hacerlo mas rapido de escribir ya que se repite en varios lados, uso data
list=[];idx=data.length-1;case 3:if(!(idx>=0)){_context.next=15;break;}if(!(data[idx].type!=="order_provider")){_context.next=12;break;}notification={title:"",msg:"",url:"",type:(data[idx].action||'')+' '+(data[idx].type||''),update:data[idx].related,//.data,
related:data[idx].related,consumed:false,//data[idx].consumed,
id:data[idx].id};_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_5__push_notification__["a" /* notificationOptionSetting */])(data[idx],data[idx],notification,session);case 8:_res=_context.sent;notification=Object.assign({},_res);notification.title=notification.title+' - '+getState().company.name;list.unshift(notification);case 12:--idx;_context.next=3;break;case 15:dispatch({type:"NOTIFICATION_SIDEBAR_LIST",notifications:list});// no esta llegando consumed
unseen=data.data;//.filter(noti => !noti.consumed);
dispatch({type:"NOTIFICATIONS_UNSEEN",unseenNotifications:true//unseen.length ? true : false
});case 18:case'end':return _context.stop();}}},_callee,_this);}));return function(_x2){return _ref.apply(this,arguments);};}()).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.errors.title_404});});};};var fetchNewNotificationsPaginated=function fetchNewNotificationsPaginated(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return function(dispatch,getState){var _getState2=getState(),company=_getState2.company,session=_getState2.session,userHigherAccess=_getState2.userHigherAccess,json_lang=_getState2.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});var maxNotificationsQty=userHigherAccess===__WEBPACK_IMPORTED_MODULE_6__constants_general__["h" /* COMPANY_ACCESS */]?10:100;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_3__config_js__["c" /* URL */]+company.id+'/accounts/'+session.account.id+'/notifications?with=related&sort_by=id,desc&page='+page+'&limit='+maxNotificationsQty).then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res){var _getState3,session,data,list,idx,related,notification,_res2;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_getState3=getState(),session=_getState3.session;data=res.data.data;list=[];idx=data.length-1;case 4:if(!(idx>=0)){_context2.next=22;break;}related=data[idx].related;notification={title:"",msg:"",url:"",type:data[idx].action+data[idx].type,update:related,//data[idx].data.data,
consumed:data[idx].consumed,id:data[idx].id,related:related};if(!(related!==null)){_context2.next=17;break;}// POR TERMINAR
data[idx].data={action:data[idx].action,type:data[idx].type};_context2.next=11;return Object(__WEBPACK_IMPORTED_MODULE_5__push_notification__["a" /* notificationOptionSetting */])(data[idx],related,notification,session);case 11:_res2=_context2.sent;_context2.next=14;return Object.assign({},_res2);case 14:notification=_context2.sent;_context2.next=18;break;case 17:notification=Object.assign({},notification,{title:"Objetivo no encontrado",msg:"Este ojeto ha cambiado o fue eliminado y no fue posible acceder a él",url:"#"});case 18:if(notification.title){notification.title=notification.title+' - '+company.name;list.unshift(notification);}case 19:--idx;_context2.next=4;break;case 22:res.data.data=list;if(userHigherAccess!==__WEBPACK_IMPORTED_MODULE_6__constants_general__["h" /* COMPANY_ACCESS */]){res.data.total=list.length;res.data.last_page=1;}dispatch({type:"NOTIFICATIONS_PAGINATED_LIST",notificationsPaginated:res.data});case 25:case'end':return _context2.stop();}}},_callee2,_this);}));return function(_x4){return _ref2.apply(this,arguments);};}()).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.errors.title_404});});};};var markNotificationConsumed=function markNotificationConsumed(id,isPush){return function(dispatch,getState){if(isPush){// si la notificacion viene de un push, en vez de un id tomo el indice del array de la lista de notificaciones que tengo en el store
var list=getState().notifications;var notification=list[id];notification.consumed=true;dispatch({type:"REMOVE_NOTIFICATION_SIDEBAR",notifications:list});}else{// si la notificacion viene de la base de datos
//axios.post(`${URL}${getState().company.id}accounts/${accountId}/notifications/${id}/consume`).then(res => {
//axios.post(URL + getState().company.id + '/notifications/' + id + '/consume').then(res => {
__WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_3__config_js__["c" /* URL */]+getState().company.id+'/accounts/'+getState().session.account_id+'/notifications/'+id+'/consume').then(function(res){// dame la copia, es mas facil traerme la copia y la modifico, asi se modifica directamente en el store sin hacer otra peticion solo para marcarla consumida
var new_array=getState().notifications;var unseenNotifications=new_array.filter(function(noti){return!noti.consumed&&noti.id!==id;});var unseen=unseenNotifications.length?true:false;if(new_array.length>0){var _notification=new_array.find(function(noti){return noti.id===id;});if(_notification){_notification.consumed=true;}}var paginated=getState().notificationsPaginated;var new_array2=paginated&&paginated.data?paginated.data:[];if(new_array2.length>0){var notification2=new_array2.find(function(noti){return noti.id===id;});if(notification2){notification2.consumed=true;}}dispatch({type:"REMOVE_NOTIFICATION_SIDEBAR",notifications:new_array,notificationsPaginated:new_array2,unseenNotifications:unseen});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_goods});});}};};var sendBroadcastMessage=function sendBroadcastMessage(){return function(dispatch,getState){var _getState4=getState(),company=_getState4.company,json_lang=_getState4.json_lang,sendNotification=_getState4.sendNotification;var data={title:sendNotification.title,body:sendNotification.body};if(sendNotification.target_type){data.target_type=sendNotification.target_type;}if(sendNotification.send_at){data.send_at=sendNotification.send_at;data.send_at_timezone=company.time_zone_offset;}dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_3__config_js__["c" /* URL */]+company.id+'/send-broadcast-message',data).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:'Notificaci\xF3n enviada exitosamente'});var sendNotification={title:"",body:"",target_type:"",send_at:__WEBPACK_IMPORTED_MODULE_7_moment___default()()};dispatch({type:'DATA_NOTIFICATION',sendNotification:sendNotification});}).catch(function(err){if(err.data&&err.data.message)__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.data.message[err.data.message]});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'',msg:'Error al enviar Notificati\xF3n'});});};};var toggleData=function toggleData(value){return function(dispatch,getState){var _getState5=getState(),sendNotification=_getState5.sendNotification;sendNotification[value.name]=value.data;var data=Object.assign({},sendNotification);dispatch({type:'DATA_NOTIFICATION',sendNotification:data});};};var getBroadcastMessage=function getBroadcastMessage(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;return function(dispatch,getState){var _getState6=getState(),company=_getState6.company;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_3__config_js__["c" /* URL */]+company.id+'/scheduled-tasks?type=notification&page='+page+'&sort_by=created_at,desc').then(function(res){dispatch({type:'GET_BROADCASTMESSAGE',broadcastMessages:res.data});}).catch(function(err){if(err.data&&err.data.message)__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.data.message[err.data.message]});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'',msg:'Error al enviar Notificati\xF3n'});});};};var getBroadcastMessageDetail=function getBroadcastMessageDetail(id){return function(dispatch,getState){var _getState7=getState(),company=_getState7.company;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_3__config_js__["c" /* URL */]+company.id+'/scheduled-tasks/'+id+'?with_action=1').then(function(res){dispatch({type:'GET_BROADCASTMESSAGE_DETAILS',broadcastMessageDetails:res.data});}).catch(function(err){if(err.data&&err.data.message)__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:err.data.message[err.data.message]});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'',msg:'Error al enviar Notificati\xF3n'});});};};var clearBroadcastMessageDetail=function clearBroadcastMessageDetail(){return function(dispatch,getState){dispatch({type:'GET_BROADCASTMESSAGE_DETAILS',broadcastMessageDetails:{}});};};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(28);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(73);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(68);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(171);
var createDesc = __webpack_require__(70);
var toIObject = __webpack_require__(36);
var toPrimitive = __webpack_require__(69);
var has = __webpack_require__(48);
var IE8_DOM_DEFINE = __webpack_require__(147);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(15) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(101) || !__webpack_require__(29)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(19)[K];
});


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(58);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["a" /* default */])(a.state, b.state);
};

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classes__ = __webpack_require__(385);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__classes__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__classes__["a"]; });




/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ACTION = exports.TYPE = exports.POSITION = void 0;
var POSITION = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  TOP_CENTER: 'top-center',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_CENTER: 'bottom-center'
};
exports.POSITION = POSITION;
var TYPE = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  DEFAULT: 'default'
};
exports.TYPE = TYPE;
var ACTION = {
  SHOW: 0,
  CLEAR: 1,
  DID_MOUNT: 2,
  WILL_UNMOUNT: 3,
  ON_CHANGE: 4
};
exports.ACTION = ACTION;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(43),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(491),
    listCacheDelete = __webpack_require__(492),
    listCacheGet = __webpack_require__(493),
    listCacheHas = __webpack_require__(494),
    listCacheSet = __webpack_require__(495);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(65);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(44);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(513);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(14),
    isKey = __webpack_require__(125),
    stringToPath = __webpack_require__(541),
    toString = __webpack_require__(205);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputNormal__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SelectNormal__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InfoCard__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SimpleTooltip__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchBranchSelect__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchBranchGroupsSelect__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SearchClient__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SearchProvider__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SearchAdmin__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SearchGoodsListSelect__ = __webpack_require__(605);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InputNormal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__SelectNormal__["a"]; });
/* unused harmony reexport InfoCard */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__SimpleTooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__SearchBranchSelect__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__SearchBranchGroupsSelect__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__SearchClient__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__SearchProvider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__SearchAdmin__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__SearchGoodsListSelect__["a"]; });


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Paginate_Paginate__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Table__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Preloader_Preloader_jsx__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Preloader_Preloader2_jsx__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InputAutocomplete_InputAutocomplete__ = __webpack_require__(616);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Paginate_Paginate__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__Table__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Preloader_Preloader_jsx__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Preloader_Preloader2_jsx__["a"]; });
/* unused harmony reexport InputAutocomplete */


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Debouncer; });
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Debouncer=function Debouncer(delayInMilliseconds){_classCallCheck(this,Debouncer);this.delayInMilliseconds=450;this.timeoutId=null;this.lastDelay=null;this.debounce=function(callback){if(this.timeoutId!==null){clearTimeout(this.timeoutId);}this.timeoutId=setTimeout(callback,this.delayInMilliseconds);};this.delay=function(callback){var _this=this;if(this.timeoutId!==null){clearTimeout(this.timeoutId);this.timeoutId=null;}var now=Date.now();var diff=now-this.lastDelay;if(this.lastDelay!==null&&diff<this.delayInMilliseconds){this.timeoutId=setTimeout(function(){_this.lastDelay=Date.now();callback();},this.delayInMilliseconds-diff);return;}this.lastDelay=now;callback();};if(delayInMilliseconds>0){this.delayInMilliseconds=delayInMilliseconds;}};

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return removeAccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return toggleAccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clearvehicle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return updateVehicle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return toggleDataVehicle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getVehicle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return dettachVehicleProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return attachVehicleProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return fetchProvidersVehicle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return clearProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clearProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearProviderAdvanceConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return updateProviderGeolocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return updateAvatar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return toggleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return update; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return register; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return fetchProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return statusAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return destroy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return sendmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return sendsms; });
/* unused harmony export searchQueryProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return fetchArchivedProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getServiceSkillGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return toggleServiceSkillGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addServiceSkillGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deleteServiceSkillGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return editServiceSkillGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addSkill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return removeSkill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return editSkill; });
/* unused harmony export getProviderSkillsGroups */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return updateProviderPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return updateProviderAdvanceSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return fetchProviderStatistics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tableActions__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UtilsOperation__ = __webpack_require__(9);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var clear={display_name:'',avatar_url:'',email:'',name:'',phone:'',status:'',password:"secret"};var clearProvider=function clearProvider(){return function(dispatch){dispatch({type:'CLEAR_PROVIDER',provider:{id:'',name:'',display_name:'',phonePrefix:'58',phone:'',email:''},dropzoneFiles:[]});};};var clearProviderAdvanceConfig=function clearProviderAdvanceConfig(){return function(dispatch){dispatch({type:"INVALID_ADVANCE_CONFIG",invalidConfig:{}});};};var clearProviders=function clearProviders(){return function(dispatch){dispatch({type:'CLEAR_PROVIDERS',providers:[]});};};var fetchArchivedProviders=function fetchArchivedProviders(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var query=arguments[1];var limit=arguments.length>2&&arguments[2]!==undefined?arguments[2]:10;return function(dispatch){dispatch({type:"WAIT_FOR_RESPONSE"});var url_host='/providers?with=skills,delivery-vehicles,accesses&mode=deleted&limit='+limit+'&page='+page;url_host+=query?'&'+query:'';return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().company.id+url_host).then(function(res){dispatch({type:'FETCH_PROVIDERS',providers:res.data});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().json_lang.custom_errors.user_delete_failed});}});};};var fetchProviders=function fetchProviders(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var query=arguments[1];var setConditionState=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var limit=arguments.length>3&&arguments[3]!==undefined?arguments[3]:500;var loader=arguments.length>4&&arguments[4]!==undefined?arguments[4]:true;return function(dispatch,getState){var _getState=getState(),company=_getState.company,json_lang=_getState.json_lang;if(loader)dispatch({type:"WAIT_FOR_RESPONSE"});var url_host='/providers?with=skills,delivery-vehicles,accesses&limit='+limit+'&page='+page;if(query&&query.startsWith('order_id=')){url_host='/providers?with=skills,delivery-vehicles,accesses';}url_host+=query?'&'+query:'';return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+url_host)).then(function(res){if(res.data.data){res.data.data=res.data.data.map(function(provider){provider.position=[parseInt(provider.latitude_e6,10)/1000000,parseInt(provider.longitude_e6,10)/1000000];return provider;});dispatch({type:'SET_HAS_FLEETS',hasFleets:false});}else{dispatch({type:'SET_HAS_FLEETS',hasFleets:true});res.data=res.data.map(function(provider){provider.position=[parseInt(provider.latitude_e6,10)/1000000,parseInt(provider.longitude_e6,10)/1000000];return provider;});}if(setConditionState==="autocompleteSearch"){dispatch({type:'FETCH_AUTOCOMPLETE_SEARCH_PROVIDERS',autocompleteProviders:res.data});}else{dispatch({type:'FETCH_PROVIDERS',providers:res.data});}}).catch(function(err){if(loader)dispatch({type:"REMOVE_LOADING"});if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.retrieving_user_list});});};};var find=function find(id){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/providers/'+id+'?with=accesses,skills,delivery-vehicles,fleetMembers.fleet.serviceSupplier,serviceProfiles').then(function(res){res.data.accesses.forEach(function(access){access.access_type=access.access_type.split('\\')[1].toLowerCase();});dispatch({type:'FETCH_PROVIDER',provider:res.data});dispatch({type:'FETCH_PROVIDERS_VEHICLES',providersVehicle:res.data.delivery_vehicles});dispatch({type:'LIST_PROVIDER_SKILLS_GROUP',providerSkillsGroups:res.data.skills});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_user_data});}});};};var toggleData=function toggleData(value){return function(dispatch,getState){var data=Object.assign({},getState().provider);if(value.name.split("-").length>1){var mValue=parseInt(value.data,10);data.status^=mValue;if((data.status&768)===0){data.status^=768-mValue;}}if(value.name=='is_deliverer'||value.name=='is_shopper'){data[value.name]=value.checked===true?true:false;}else{data[value.name]=value.data;}if(value.data==='company'){data.access_id?data.access_id='':null;}dispatch({type:'FETCH_PROVIDER',provider:data});};};var register=function register(){return function(dispatch,getState){var data=Object.assign({},getState().provider);var provider=new FormData();var providerPhone='+58'+data.phone_prefix+data.phone;provider.append('display_name',data.display_name);provider.append('email',data.email);provider.append('name',data.name);provider.append('phone',providerPhone);provider.append('password',"secret");provider.append('access_type',data.access_type);provider.append('access_id',data.access_type==='company'?getState().company.id:data.access_id);provider.append('is_deliverer',data.is_deliverer&&data.is_deliverer===true?1:0);provider.append('is_shopper',data.is_shopper&&data.is_shopper===true?1:0);if(getState().dropzoneFiles.length){var block=getState().dropzoneFiles.split(";");var contentType=block[0].split(":")[1];var realData=block[1].split(",")[1];var blob=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["c" /* b64toBlob */])(realData,contentType);provider.append('avatar',blob);}/*else if(data.avatar_url && data.avatar_url.length ){
           provider.append('avatar_url', data.avatar_url)
        }*/dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/providers?skip_disable_route=1',provider).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});dispatch({type:"REMOVE_LOADING"});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err.data&&err.data.message.indexOf("already_exists")===0||err.message==='The entity already exists')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:getState().json_lang.custom_errors.user_registration_failed,msg:getState().json_lang.custom_errors.user_already_exist});else if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_registration_failed});});};};var update=function update(initialProvider){return function(dispatch,getState){var _getState2=getState(),provider=_getState2.provider,company=_getState2.company;// debo buscar en la lista de providers, xq hay atributos que el api no devuelve, x ejm
// el account status, para saber si esta confirmado o no, q se usa en la tabla
//!const modifiedProvider = providers.find( p => p.id === provider.id);
var providerData={};if(provider.name!==initialProvider.name){providerData.name=provider.name;}if(provider.is_deliverer!==initialProvider.is_deliverer){providerData.is_deliverer=provider.is_deliverer;}if(provider.is_shopper!==initialProvider.is_shopper){providerData.is_shopper=provider.is_shopper;}if('+58'+provider.phone_prefix+provider.phone!==initialProvider.phone){providerData.phone='+58'+provider.phone_prefix+provider.phone;}if(provider.email!==initialProvider.email){providerData.email=provider.email;}if(Object.keys(providerData).length===0){return Promise.resolve();}dispatch({type:"WAIT_FOR_RESPONSE"});if(provider.email!==initialProvider.email){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/accounts/'+provider.account_id+'/update-email',{"email":provider.email}).then(function(email_res){provider.email=email_res.data.email;provider.status=undefined;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/providers/'+provider.id,providerData);}).then(function(res){dispatch({type:"REMOVE_LOADING"});var succesful=getState().json_lang.common.success;__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:getState().json_lang.custom_success.update_successful});// luego como provider tiene la data actualizada a cambiar, sustituyo
/* let newProvider = {
                        ...modifiedProvider,
                        ...res.data
                    }
                    res.data = newProvider; */// dispatch({
//     type: 'UPDATE_PROVIDER_SUCCESS',
//     //providers:  tableUpdate(res, "providers"),
//     provider: clear ? res.data : clear,
//     preloader: false
// })
}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_update_failed});});}else{return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/providers/'+provider.id,providerData).then(function(res){dispatch({type:"REMOVE_LOADING"});var succesful=getState().json_lang.common.success;__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:getState().json_lang.custom_success.update_successful});// luego como provider tiene la data actualizada a cambiar, sustituyo
/* let newProvider = {
                        ...modifiedProvider,
                        ...res.data
                    }
                    res.data = newProvider; */// dispatch({
//     type: 'UPDATE_PROVIDER_SUCCESS',
//     //providers:  tableUpdate(res, "providers"),
//     provider: clear ? res.data : clear,
//     preloader: false
// })
}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_update_failed});});}};};var updateAvatar=function updateAvatar(clear){return function(dispatch,getState){var data=Object.assign({},getState().provider);var provider=new FormData();if(getState().dropzoneFiles.length){var block=getState().dropzoneFiles.split(";");var contentType=block[0].split(":")[1];var realData=block[1].split(",")[1];var blob=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["c" /* b64toBlob */])(realData,contentType);provider.append('avatar',blob);}dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/providers/'+data.id+'/upload-avatar',provider).then(function(res){var succesful=getState().json_lang.common.success;__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:getState().json_lang.custom_success.update_successful});if(clear){dispatch({type:'UPDATE_PROVIDER_SUCCESS',providers:Object(__WEBPACK_IMPORTED_MODULE_3__tableActions__["j" /* tableUpdate */])(res,"providers"),provider:res.data,preloader:false});}else{dispatch({type:'UPDATE_PROVIDER_SUCCESS',providers:Object(__WEBPACK_IMPORTED_MODULE_3__tableActions__["j" /* tableUpdate */])(res,"providers"),provider:clear,preloader:false});}}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_update_failed});});};};var destroy=function destroy(id){return function(dispatch){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().company.id+'/accounts/'+id).then(function(res){var succesful=__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().json_lang.common.success;__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().json_lang.custom_success.delete_successful});/*dispatch({
                type: 'PROVIDER_DELETED',
                providers: tableRemoveAcount(res, "providers"),
                provider: clear,
                preloader: false
            });*/}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().json_lang.custom_errors.user_delete_failed});});};};var sendmail=function sendmail(email){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});__WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/confirm/'+email+'?type=provider').then(function(res){var succesful=getState().json_lang.common.success;__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:getState().json_lang.custom_success.email_sent});dispatch({type:'UPDATE_PROVIDER_SUCCESS',providers:getState().providers,provider:getState().provider,preloader:false});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_delete_failed});});};};var sendsms=function sendsms(payload){var _payload$phone=payload.phone,phone=_payload$phone===undefined?null:_payload$phone,_payload$account_id=payload.account_id,account_id=_payload$account_id===undefined?null:_payload$account_id;return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});__WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/accounts/'+account_id+'/send-phone-code',{phone:phone}).then(function(res){var succesful=getState().json_lang.common.success;__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:getState().json_lang.custom_success.sms_sent});dispatch({type:'UPDATE_PROVIDER_SUCCESS',providers:getState().providers,provider:getState().provider,preloader:false});}).catch(function(err){if(err.data.message&&err.data.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.status_code),msg:err.data.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_delete_failed});});};};var searchQueryProvider=function searchQueryProvider(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";return function(dispatch){__WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().company.id+'/providers'+(query?"?search="+query:'')).then(function(res){dispatch({type:'AUTOCOMPLETE_PROVIDER',providers:res.data.data});}).catch(function(err){if(err.message){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});}});};};var statusAccount=function statusAccount(id,_statusAccount){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/accounts/'+id+'/'+_statusAccount).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});/* let provider = getState().providers.find( (provider,key) => {
                return parseInt(provider.account_id,10) === parseInt(id,10)
            }) *///provider.account.status = res.data.status
/* dispatch({
                type: 'UPDATE_PROVIDER_SUCCESS',
                providers:  tableUpdate(res, "providers"),
                provider: clear,
                preloader: false
            }) */}).catch(function(err){console.log("error ",err);if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err&&err.title!=""?err.title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_restore_failed});});};};var updateProviderGeolocation=function updateProviderGeolocation(newData){return function(dispatch,getState){var list=[];var _getState3=getState(),providers=_getState3.providers;list=providers.data||providers;var index=list.findIndex(function(provider){return provider.id===newData.id;});var provider=list[index];if(provider){if(newData.hasOwnProperty('status')){provider.status=newData.status;}if(newData.latitude_e6&&newData.longitude_e6){provider.position=[parseInt(newData.latitude_e6,10)/1000000,parseInt(newData.longitude_e6,10)/1000000];provider.time=true;provider.from=list[index].position;provider.to=[].concat(_toConsumableArray(provider.position));}list[index]=provider;return new Promise(function(resolve){dispatch({type:"UPDATE_PROVIDER_GEOLOCATION",providers:list});resolve(list);// Resolvemos la promesa una vez que se despacha la acción
});}};};var getServiceSkillGroup=function getServiceSkillGroup(){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/service-skill-groups?with_skills=1').then(function(res){dispatch({type:'LIST_SERVICE_SKILL_GROUPS',service_skill_groups:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:'Error al buscar habilidades requeridas de los productos'});});};};var getProviderSkillsGroups=function getProviderSkillsGroups(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/providers/'+id+'/service-skills').then(function(res){var data=[].concat(_toConsumableArray(getState().service_skill_groups));var activeSkills=[];data.forEach(function(data){if(data.skills.length>0){var test={name:data.name,skills:[]};data.skills.forEach(function(skill){res.data.forEach(function(res){if(res.id===skill.id){test.skills.push({name:skill.name});}});});if(test.skills.length>0){activeSkills.push(test);}}});dispatch({type:'LIST_PROVIDER_SKILLS_GROUP',providerSkillsGroups:activeSkills});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:'Error al buscar habilidades requeridas de los productos'});});};};var addServiceSkillGroup=function addServiceSkillGroup(){return function(dispatch,getState){var newData={name:getState().new_service_skill_groups};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/service-skill-groups',newData).then(function(res){var new_service_skill_groups=[];res.data.skills=[];new_service_skill_groups.push(res.data);var update_data=new_service_skill_groups.concat(getState().service_skill_groups);__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});dispatch({type:'LIST_SERVICE_SKILL_GROUPS',service_skill_groups:update_data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_restore_failed});});};};var addSkill=function addSkill(id){return function(dispatch,getState){var newData=getState().service_skill_groups.find(function(service_skill,key){return service_skill.id===parseInt(id,10);});dispatch({type:"WAIT_FOR_RESPONSE"});var skill={name:newData.new_name};return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/service-skill-groups/'+id+'/service-skills',skill).then(function(res){var update_data=getState().service_skill_groups.map(function(service_skill,key){if(service_skill.id===parseInt(id,10)){service_skill.skills=service_skill.skills.concat(res.data);service_skill.new_name='';}return service_skill;});dispatch({type:'LIST_SERVICE_SKILL_GROUPS',service_skill_groups:update_data});__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});dispatch({type:'LIST_SERVICE_SKILL_GROUPS',service_skill_groups:update_data});}).catch(function(err){if(err.data.message)__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:getState().json_lang.custom_errors[err.data.message]});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_restore_failed});});};};var editSkill=function editSkill(id,group_id){return function(dispatch,getState){var newData=getState().service_skill_groups.find(function(service_skill,key){return service_skill.id===parseInt(group_id,10);});dispatch({type:"WAIT_FOR_RESPONSE"});var skill={name:newData.name};return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/service-skills/'+id,skill).then(function(res){var update_data=getState().service_skill_groups.map(function(service_skill,key){if(service_skill.id===parseInt(id,10)){service_skill.skills=service_skill.skills.concat(res.data);service_skill.new_name='';}return service_skill;});dispatch({type:'LIST_SERVICE_SKILL_GROUPS',service_skill_groups:update_data});__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});dispatch({type:'LIST_SERVICE_SKILL_GROUPS',service_skill_groups:update_data});}).catch(function(err){/*if(err.data.message)
               Notification.show({type: "error", title: 'Error', msg: getState().json_lang.custom_errors[err.data.message] });
            else*/__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_restore_failed});});};};var removeSkill=function removeSkill(id,group_id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/service-skills/'+id).then(function(res){var update_data=[].concat(_toConsumableArray(getState().service_skill_groups));update_data.map(function(service_skill,key){if(parseInt(service_skill.id,10)===parseInt(group_id,10)){service_skill.skills=service_skill.skills.filter(function(skill,key){return parseInt(skill.id,10)!==parseInt(id,10);});}return service_skill;});dispatch({type:'LIST_SERVICE_SKILL_GROUPS',service_skill_groups:update_data});__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});}).catch(function(err){if(err.message&&err.message!=='generic'){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});}else if(err.data.message){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:getState().json_lang.custom_errors[err.data.message]});}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:''});}});};};var editServiceSkillGroup=function editServiceSkillGroup(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var data=getState().service_skill_groups.find(function(service_skill,key){return service_skill.id===parseInt(id,10);});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/service-skill-groups/'+id,data).then(function(res){var update_data=getState().service_skill_groups.map(function(service_skill,key){if(service_skill.id===parseInt(res.data.id,10)){service_skill.reason=res.data.reason;}return service_skill;});__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.delete_successful});dispatch({type:'LIST_SERVICE_SKILL_GROUPS',service_skill_groups:update_data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_restore_failed});});};};var deleteServiceSkillGroup=function deleteServiceSkillGroup(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/service-skill-groups/'+id).then(function(res){var update_data=getState().service_skill_groups.filter(function(service_skill,key){return service_skill.id!==parseInt(res.data.id,10);});__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().json_lang.custom_success.delete_successful});update_data.sort();dispatch({type:'LIST_SERVICE_SKILL_GROUPS',service_skill_groups:update_data});}).catch(function(err){if(err.message&&err.message!=='generic'){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});}else if(err.data.message){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:getState().json_lang.custom_errors[err.data.message]});}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:''});}});};};var toggleServiceSkillGroup=function toggleServiceSkillGroup(value){return function(dispatch,getState){var name=value.name.split('-');if(name.length>1){var update_data=getState().service_skill_groups.map(function(service_skill,key){if(key===parseInt(name[1],10)){if(name[0]==='name'||name[0]==='new_name'){service_skill[name[0]]=value.data;}else{service_skill.skills[name[2]].name=value.data;}}return service_skill;});dispatch({type:'LIST_SERVICE_SKILL_GROUPS',service_skill_groups:update_data});}else{var data=getState().new_service_skill_groups=value.data;dispatch({type:'NEW_SERVICE_SKILL_GROUPS',new_service_skill_groups:data});}};};var fetchProvidersVehicle=function fetchProvidersVehicle(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState4=getState(),company=_getState4.company;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/providers/'+id+'/delivery-vehicles?limit=0').then(function(res){dispatch({type:'FETCH_PROVIDERS_VEHICLES',providersVehicle:res.data});}).catch(function(err){if(err&&err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.data.message});else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});}});};};var attachVehicleProvider=function attachVehicleProvider(providerId,vehicleID){return function(dispatch,getState){// dispatch({type: "WAIT_FOR_RESPONSE"})
var _getState5=getState(),company=_getState5.company,json_lang=_getState5.json_lang,providersVehicle=_getState5.providersVehicle,vehicles=_getState5.vehicles;var find=vehicles.find(function(vehicle,key){return vehicle.id===parseInt(vehicleID,10);});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].put(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/providers/'+providerId+'/delivery-vehicles/'+vehicleID).then(function(res){var update=providersVehicle.concat(find);__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:'FETCH_PROVIDERS_VEHICLES',providersVehicle:update});}).catch(function(err){if(err&&err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.data.message});else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});}});};};var dettachVehicleProvider=function dettachVehicleProvider(providerId,vehicleId){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState6=getState(),company=_getState6.company,json_lang=_getState6.json_lang,providersVehicle=_getState6.providersVehicle;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/providers/'+providerId+'/delivery-vehicles/'+vehicleId).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});var update=providersVehicle.filter(function(item){return item.id!==vehicleId;});dispatch({type:'FETCH_PROVIDERS_VEHICLES',providersVehicle:update});}).catch(function(err){if(err&&err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.data.message});else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});}});};};var getVehicle=function getVehicle(vehicleId){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState7=getState(),company=_getState7.company;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/delivery-vehicles/'+vehicleId).then(function(res){dispatch({type:'STORE_VEHICLE',vehicle:res.data});}).catch(function(err){if(err&&err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.data.message});else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});}});};};var toggleDataVehicle=function toggleDataVehicle(value){return function(dispatch,getState){var data=Object.assign({},getState().vehicle);data[value.name]=value.data;dispatch({type:'STORE_VEHICLE',vehicle:data});};};var clearvehicle=function clearvehicle(){return function(dispatch,getState){var update={name:""};dispatch({type:'STORE_VEHICLE',vehicle:update});};};var updateVehicle=function updateVehicle(vehicleId){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState8=getState(),company=_getState8.company,json_lang=_getState8.json_lang,vehicles=_getState8.vehicles,vehicle=_getState8.vehicle;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/delivery-vehicles/'+vehicleId,vehicle).then(function(res){var update=vehicles.map(function(item){if(item.id===vehicleId){item=res.data;}return item;});__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:'FETCH_VEHICLES',vehicles:update});}).catch(function(err){if(err&&err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.data.message});else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});}});};};var toggleAccess=function toggleAccess(access_id,branch){return function(dispatch,getState){var _getState9=getState(),provider=_getState9.provider,company=_getState9.company,json_lang=_getState9.json_lang,providerBranchAccesses=_getState9.providerBranchAccesses;var data=Object.assign({},provider);var accss={access_type:provider.access_type,access_id:access_id};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/providers/'+data.id+'/grant-access',accss).then(function(res){res.data.access_type=res.data.access_type.split('\\')[1].toLowerCase();/*let branchS = [...session.accesses].find(e => e.access_id === parseInt(access_id,10));
            console.log("branchS",session.accesses,)*///if(branchS && branchS.related_access){
data.accesses.push(res.data);__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});//}
dispatch({type:'FETCH_PROVIDER',provider:data});if(branch){var newBranches=[].concat(_toConsumableArray(providerBranchAccesses));newBranches.push(branch.related_access);dispatch({type:'FETCH_PROVIDER_BRANCHES_ACCESSES',providerBranchAccesses:newBranches});}}).catch(function(err){if(err&&err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.data.message});else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});}});};};var removeAccess=function removeAccess(access,type){return function(dispatch,getState){var _getState10=getState(),provider=_getState10.provider,company=_getState10.company,json_lang=_getState10.json_lang;var data=Object.assign({},provider);var accss={access_type:type?type:'company',access_id:access.access_id?access.access_id:access};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/providers/'+data.id+'/revoke-access',accss).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});var reveItem=access&&access.access_id?parseInt(access.access_id,10):access;var branchS=data.accesses.filter(function(e){return e.access_id!==reveItem;});data.accesses=branchS;dispatch({type:'FETCH_PROVIDER',provider:data});}).catch(function(err){if(err&&err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.data.message});else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});}});};};var updateProviderPayment=function updateProviderPayment(data,id,fromInvoice){return function(dispatch,getState){var _getState11=getState(),company=_getState11.company,json_lang=_getState11.json_lang,invoice=_getState11.invoice;var paymentData={settings:{payout_accounts:[].concat(_toConsumableArray(data))}};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/providers/'+id,paymentData).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});if(fromInvoice){dispatch({type:'FETCH_INVOICE',invoice:Object.assign({},invoice,{payout_accounts:paymentData.settings.payout_accounts})});}else{dispatch({type:'FETCH_PROVIDER',provider:res.data});}}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"Error al guardar el método de pago"});});};};var updateProviderAdvanceSettings=function updateProviderAdvanceSettings(body,id){return function(dispatch,getState){var _getState12=getState(),company=_getState12.company,json_lang=_getState12.json_lang;var posData={settings:Object.assign({},body)};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/providers/'+id,posData).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:"INVALID_ADVANCE_CONFIG",invalidConfig:{}});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err.data&&err.data.error_code){var error=err.data;switch(error.error_code){case'ER422':if(error.errors){var errors=Object.keys(error.errors).reduce(function(acc,key){var splitedKey=key.split(".");acc[splitedKey[1]]=json_lang.custom_errors[splitedKey[1]+"_format"];return acc;},{});console.log("errorssssss",errors);dispatch({type:"INVALID_ADVANCE_CONFIG",invalidConfig:Object.assign({},errors)});}else{if(error.description){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:error.description});}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:"Ocurrió un error inesperado al guardar el método de pago"});}}break;case'ER409':if(error.errors){var _errors=Object.keys(error.errors).reduce(function(acc,key){var splitedKey=key.split(".");acc[splitedKey[1]]=json_lang.custom_errors[splitedKey[1]+"_conflict"];return acc;},{});dispatch({type:"INVALID_ADVANCE_CONFIG",invalidConfig:Object.assign({},_errors)});}else{if(error.description){if(error.description.includes("pos_serial")){dispatch({type:"INVALID_ADVANCE_CONFIG",invalidConfig:{pos_serial:json_lang.custom_errors.pos_serial_conflict}});}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:error.description});}}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:"Ocurrió un error inesperado al guardar el método de pago"});}}break;default:if(error.description){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:error.description});}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:"Error al guardar el método de pago"});}break;}}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:"Error al guardar el método de pago"});}});};};var fetchProviderStatistics=function fetchProviderStatistics(id){var mode=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"today";var date=arguments[2];return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var url="";if(mode==="range"){url+='&day_from='+date.dayFrom+'&day_to='+date.dayTo;}if(mode==="day"){url+='&day='+date;}return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/providers/'+id+'/statistics?mode='+mode+url).then(function(res){dispatch({type:'FETCH_PROVIDER_STATISTICS',providerStatistics:res.data});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err&&err.data&&err.data.description});});};};

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(95),
    isLength = __webpack_require__(123);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(265),
    baseKeys = __webpack_require__(530),
    isArrayLike = __webpack_require__(92);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(43),
    isObject = __webpack_require__(32);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(527),
    isObjectLike = __webpack_require__(34);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(295)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(100)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 99 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(101);
var $export = __webpack_require__(5);
var redefine = __webpack_require__(47);
var hide = __webpack_require__(46);
var Iterators = __webpack_require__(55);
var $iterCreate = __webpack_require__(297);
var setToStringTag = __webpack_require__(106);
var getPrototypeOf = __webpack_require__(107);
var ITERATOR = __webpack_require__(16)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(35);
var global = __webpack_require__(19);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(101) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(150);
var enumBugKeys = __webpack_require__(105);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(102)('keys');
var uid = __webpack_require__(71);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 105 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(27).f;
var has = __webpack_require__(48);
var TAG = __webpack_require__(16)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(48);
var toObject = __webpack_require__(20);
var IE_PROTO = __webpack_require__(104)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(27);
var createDesc = __webpack_require__(70);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(115);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(17);
var normalizeHeaderName = __webpack_require__(416);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(187);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(187);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(415)))

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": 434,
	"./es.json": 435
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 118;

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(490),
    isObjectLike = __webpack_require__(34);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(44),
    root = __webpack_require__(25);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(505),
    mapCacheDelete = __webpack_require__(512),
    mapCacheGet = __webpack_require__(514),
    mapCacheHas = __webpack_require__(515),
    mapCacheSet = __webpack_require__(516);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(86),
    toKey = __webpack_require__(59);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(14),
    isSymbol = __webpack_require__(80);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stripDiacritics;
/**
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Taken from: http://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript/18391901#18391901
 */

/* eslint-disable max-len */
var map = [{ 'base': 'A', 'letters': 'A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F' }, { 'base': 'AA', 'letters': '\uA732' }, { 'base': 'AE', 'letters': '\xC6\u01FC\u01E2' }, { 'base': 'AO', 'letters': '\uA734' }, { 'base': 'AU', 'letters': '\uA736' }, { 'base': 'AV', 'letters': '\uA738\uA73A' }, { 'base': 'AY', 'letters': '\uA73C' }, { 'base': 'B', 'letters': 'B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181' }, { 'base': 'C', 'letters': 'C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E' }, { 'base': 'D', 'letters': 'D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\xD0' }, { 'base': 'DZ', 'letters': '\u01F1\u01C4' }, { 'base': 'Dz', 'letters': '\u01F2\u01C5' }, { 'base': 'E', 'letters': 'E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E' }, { 'base': 'F', 'letters': 'F\u24BB\uFF26\u1E1E\u0191\uA77B' }, { 'base': 'G', 'letters': 'G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E' }, { 'base': 'H', 'letters': 'H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D' }, { 'base': 'I', 'letters': 'I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197' }, { 'base': 'J', 'letters': 'J\u24BF\uFF2A\u0134\u0248' }, { 'base': 'K', 'letters': 'K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2' }, { 'base': 'L', 'letters': 'L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780' }, { 'base': 'LJ', 'letters': '\u01C7' }, { 'base': 'Lj', 'letters': '\u01C8' }, { 'base': 'M', 'letters': 'M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C' }, { 'base': 'N', 'letters': 'N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4' }, { 'base': 'NJ', 'letters': '\u01CA' }, { 'base': 'Nj', 'letters': '\u01CB' }, { 'base': 'O', 'letters': 'O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C' }, { 'base': 'OI', 'letters': '\u01A2' }, { 'base': 'OO', 'letters': '\uA74E' }, { 'base': 'OU', 'letters': '\u0222' }, { 'base': 'OE', 'letters': '\x8C\u0152' }, { 'base': 'oe', 'letters': '\x9C\u0153' }, { 'base': 'P', 'letters': 'P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754' }, { 'base': 'Q', 'letters': 'Q\u24C6\uFF31\uA756\uA758\u024A' }, { 'base': 'R', 'letters': 'R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782' }, { 'base': 'S', 'letters': 'S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784' }, { 'base': 'T', 'letters': 'T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786' }, { 'base': 'TZ', 'letters': '\uA728' }, { 'base': 'U', 'letters': 'U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244' }, { 'base': 'V', 'letters': 'V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245' }, { 'base': 'VY', 'letters': '\uA760' }, { 'base': 'W', 'letters': 'W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72' }, { 'base': 'X', 'letters': 'X\u24CD\uFF38\u1E8A\u1E8C' }, { 'base': 'Y', 'letters': 'Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE' }, { 'base': 'Z', 'letters': 'Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762' }, { 'base': 'a', 'letters': 'a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250' }, { 'base': 'aa', 'letters': '\uA733' }, { 'base': 'ae', 'letters': '\xE6\u01FD\u01E3' }, { 'base': 'ao', 'letters': '\uA735' }, { 'base': 'au', 'letters': '\uA737' }, { 'base': 'av', 'letters': '\uA739\uA73B' }, { 'base': 'ay', 'letters': '\uA73D' }, { 'base': 'b', 'letters': 'b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253' }, { 'base': 'c', 'letters': 'c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184' }, { 'base': 'd', 'letters': 'd\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A' }, { 'base': 'dz', 'letters': '\u01F3\u01C6' }, { 'base': 'e', 'letters': 'e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD' }, { 'base': 'f', 'letters': 'f\u24D5\uFF46\u1E1F\u0192\uA77C' }, { 'base': 'g', 'letters': 'g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F' }, { 'base': 'h', 'letters': 'h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265' }, { 'base': 'hv', 'letters': '\u0195' }, { 'base': 'i', 'letters': 'i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131' }, { 'base': 'j', 'letters': 'j\u24D9\uFF4A\u0135\u01F0\u0249' }, { 'base': 'k', 'letters': 'k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3' }, { 'base': 'l', 'letters': 'l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747' }, { 'base': 'lj', 'letters': '\u01C9' }, { 'base': 'm', 'letters': 'm\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F' }, { 'base': 'n', 'letters': 'n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5' }, { 'base': 'nj', 'letters': '\u01CC' }, { 'base': 'o', 'letters': 'o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275' }, { 'base': 'oi', 'letters': '\u01A3' }, { 'base': 'ou', 'letters': '\u0223' }, { 'base': 'oo', 'letters': '\uA74F' }, { 'base': 'p', 'letters': 'p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755' }, { 'base': 'q', 'letters': 'q\u24E0\uFF51\u024B\uA757\uA759' }, { 'base': 'r', 'letters': 'r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783' }, { 'base': 's', 'letters': 's\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B' }, { 'base': 't', 'letters': 't\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787' }, { 'base': 'tz', 'letters': '\uA729' }, { 'base': 'u', 'letters': 'u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289' }, { 'base': 'v', 'letters': 'v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C' }, { 'base': 'vy', 'letters': '\uA761' }, { 'base': 'w', 'letters': 'w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73' }, { 'base': 'x', 'letters': 'x\u24E7\uFF58\u1E8B\u1E8D' }, { 'base': 'y', 'letters': 'y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF' }, { 'base': 'z', 'letters': 'z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763' }];
/* eslint-enable max-len */

var diacriticsMap = {};
for (var ii = 0; ii < map.length; ii++) {
  var letters = map[ii].letters;
  for (var jj = 0; jj < letters.length; jj++) {
    diacriticsMap[letters[jj]] = map[ii].base;
  }
}

// "what?" version ... http://jsperf.com/diacritics/12
function stripDiacritics(str) {
  return str.replace(/[\u0300-\u036F]/g, '') // Remove combining diacritics
  .replace(/[^\u0000-\u007E]/g, function (a) {
    return diacriticsMap[a] || a;
  });
}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _invariant = __webpack_require__(18);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(141);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _getStringLabelKey = __webpack_require__(216);

var _getStringLabelKey2 = _interopRequireDefault(_getStringLabelKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Retrieves the display string from an option. Options can be the string
 * themselves, or an object with a defined display string. Anything else throws
 * an error.
 */
function getOptionLabel(option, labelKey) {
  if (option.paginationOption || option.customOption) {
    return option[(0, _getStringLabelKey2.default)(labelKey)];
  }

  var optionLabel = void 0;

  if (typeof option === 'string') {
    optionLabel = option;
  }

  if (typeof labelKey === 'function') {
    // This overwrites string options, but we assume the consumer wants to do
    // something custom if `labelKey` is a function.
    optionLabel = labelKey(option);
  } else if (typeof labelKey === 'string' && (0, _isPlainObject2.default)(option)) {
    optionLabel = option[labelKey];
  }

  !(typeof optionLabel === 'string') ?  false ? (0, _invariant2.default)(false, 'One or more options does not have a valid label string. Check the ' + '`labelKey` prop to ensure that it matches the correct option key and ' + 'provides a string for filtering and display.') : (0, _invariant2.default)(false) : void 0;

  return optionLabel;
}

exports.default = getOptionLabel;

/***/ }),
/* 128 */
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(575);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);
module.exports = exports['default'];

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseMenuItem = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _noop = __webpack_require__(131);

var _noop2 = _interopRequireDefault(_noop);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _menuItemContainer = __webpack_require__(232);

var _menuItemContainer2 = _interopRequireDefault(_menuItemContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseMenuItem = function (_React$Component) {
  _inherits(BaseMenuItem, _React$Component);

  function BaseMenuItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BaseMenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BaseMenuItem.__proto__ || Object.getPrototypeOf(BaseMenuItem)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick;


      e.preventDefault();
      !disabled && onClick(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BaseMenuItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          children = _props.children,
          className = _props.className,
          disabled = _props.disabled,
          onClick = _props.onClick,
          onMouseDown = _props.onMouseDown,
          props = _objectWithoutProperties(_props, ['active', 'children', 'className', 'disabled', 'onClick', 'onMouseDown']);

      var conditionalClassNames = {
        'active': active,
        'disabled': disabled
      };

      return (
        /* eslint-disable jsx-a11y/anchor-is-valid */
        _react2.default.createElement(
          'li',
          _extends({}, props, {
            className: (0, _classnames2.default)(conditionalClassNames, className) }),
          _react2.default.createElement(
            'a',
            {
              className: (0, _classnames2.default)('dropdown-item', conditionalClassNames),
              href: '#',
              onClick: this._handleClick,
              onMouseDown: onMouseDown },
            children
          )
        )
        /* eslint-enable jsx-a11y/anchor-is-valid */

      );
    }
  }]);

  return BaseMenuItem;
}(_react2.default.Component);

BaseMenuItem.defaultProps = {
  onClick: _noop2.default
};

exports.BaseMenuItem = BaseMenuItem;
exports.default = (0, _menuItemContainer2.default)(BaseMenuItem);

/***/ }),
/* 131 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(144),
    baseLodash = __webpack_require__(133);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 133 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(144),
    baseLodash = __webpack_require__(133);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCompany", function() { return fetchCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrder", function() { return fetchOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProvider", function() { return fetchProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchBranch", function() { return fetchBranch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProviders", function() { return fetchProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchGood", function() { return fetchGood; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchClientRating", function() { return fetchClientRating; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchClient", function() { return fetchClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrderProviderClient", function() { return fetchOrderProviderClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCoupon", function() { return fetchCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateProviderOrder", function() { return updateProviderOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateBranch", function() { return updateBranch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__handlers_RequestHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handlers_Notification_js__ = __webpack_require__(8);
var fetchCompany=function fetchCompany(){return __WEBPACK_IMPORTED_MODULE_0__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store_store_js__["a" /* default */].getState().company.id).then(function(res){return res.data;}).catch(function(err){return{error:{data:'Company id '+__WEBPACK_IMPORTED_MODULE_2__store_store_js__["a" /* default */].getState().company.id}};});};/* export const fetchPayment = id => {
	return axios.get(URL + store.getState().company.id + '/forms/' + id)
			.then( res => {
				return res.data;
			} )
}
 */var fetchOrder=function fetchOrder(id){var loadPayments=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return __WEBPACK_IMPORTED_MODULE_0__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store_store_js__["a" /* default */].getState().company.id+'/orders/'+id+'?with=branch,orderProviders.provider,taxes.coupon'+(!loadPayments?'':',payments')).then(function(res){//console.log('fetchOrder api',res.data)
return res.data;}).catch(function(err){return{error:{data:'Order id '+id}};});};var fetchProvider=function fetchProvider(id){return __WEBPACK_IMPORTED_MODULE_0__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store_store_js__["a" /* default */].getState().company.id+'/providers/'+id+"?with=order.branch").then(function(res){return res.data;}).catch(function(err){return{error:{data:'Provider id '+id}};});};var fetchBranch=function fetchBranch(id){return __WEBPACK_IMPORTED_MODULE_0__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store_store_js__["a" /* default */].getState().company.id+'/branches/'+id).then(function(res){return res.data;}).catch(function(err){return{error:{data:'Branch id '+id}};});};var fetchProviders=function fetchProviders(){return __WEBPACK_IMPORTED_MODULE_0__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store_store_js__["a" /* default */].getState().company.id+'/providers').then(function(res){return res.data;}).catch(function(err){return{error:{data:'Providers list'}};});};var fetchGood=function fetchGood(id){return __WEBPACK_IMPORTED_MODULE_0__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store_store_js__["a" /* default */].getState().company.id+'/goods/'+id+"?with=branch").then(function(res){return res.data;}).catch(function(err){return{error:{data:'Good id '+id}};});};var fetchClientRating=function fetchClientRating(id){return __WEBPACK_IMPORTED_MODULE_0__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store_store_js__["a" /* default */].getState().company.id+'/orders/'+id+'/client-ratings?with=order.branch').then(function(res){return res.data;}).catch(function(err){return{error:{data:'Client rating id '+id}};});};var fetchClient=function fetchClient(id){return __WEBPACK_IMPORTED_MODULE_0__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store_store_js__["a" /* default */].getState().company.id+'/clients/'+id).then(function(res){return res.data;}).catch(function(err){return{error:{data:'Client id '+id}};});};var fetchOrderProviderClient=function fetchOrderProviderClient(order_id,provider_id,client_id){return __WEBPACK_IMPORTED_MODULE_0__handlers_RequestHandler__["a" /* axios */].all([fetchOrder(order_id),fetchProvider(provider_id),fetchClient(client_id)]).then(__WEBPACK_IMPORTED_MODULE_0__handlers_RequestHandler__["a" /* axios */].spread(function(res){return res.data;})).catch(function(err){return{error:{data:'OrderProviderClient id '+order_id}};});};var fetchCoupon=function fetchCoupon(coupon_id){return __WEBPACK_IMPORTED_MODULE_0__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store_store_js__["a" /* default */].getState().company.id+'/coupons/'+coupon_id).then(function(res){return res.data;}).catch(function(err){return{error:{data:'Coupon id '+coupon_id}};});};var updateProviderOrder=function updateProviderOrder(payload){return function(dispatch,getState){var _getState=getState(),providerOrders=_getState.providerOrders,company=_getState.company,provider=_getState.provider;var data=payload.data;var sameProvider=provider.id===data.provider_id;var prevProviderOrder=Object.assign({},providerOrders);if(sameProvider){var findIndex=prevProviderOrder.data.findIndex(function(providerData){return providerData.order_id===data.order_id;});if(findIndex!==-1){prevProviderOrder.data[findIndex]=Object.assign({},prevProviderOrder.data[findIndex],data);dispatch({type:'FETCH_PROVIDER_ORDERS',providerOrders:Object.assign({},providerOrders,{data:prevProviderOrder.data})});}else if(payload.action==="assigned"&&providerOrders.current_page===1&&provider.id){var url_host=__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/providers/'+provider.id+'/order-providers?page=1&sort_by=created_at,desc';__WEBPACK_IMPORTED_MODULE_0__handlers_RequestHandler__["a" /* axios */].get(url_host).then(function(res){dispatch({type:'FETCH_PROVIDER_ORDERS',providerOrders:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification_js__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err&&err.data&&err.data.description});dispatch({type:"REMOVE_LOADING"});});}}};};var updateBranch=function updateBranch(branchUpdate){return function(dispatch,getState){var _getState2=getState(),branch=_getState2.branch;if(branch&&branch.id){dispatch({type:"FETCH_BRANCH",branchUpdate:branchUpdate});}};};

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return attachFeaturedProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return searchGoods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return searchBranchGoods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return dettachFeaturedProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clearFeaturedProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return deleteFeaturedProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return storeFeaturedProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return updateFeaturedProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return toggleData4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return fetchFeaturedProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return findFeaturedProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return updateGoodEta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return isUploadingExcel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return clearGoodWithBranchGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return fetchGoodWithBranchGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return activePreloader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getCategoryWithProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return displayListGoods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return attachToogleGoodsTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return clearGoodTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return toggleGoodTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getGoodTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return removeTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return editTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return editGoodTagGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return deleteGoodTagGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addGoodTagGroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return toggleNewGoodTagGroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getGoodTagGroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return clearGoodServiceSkills; });
/* unused harmony export showG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return toggleCategoryItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return toggleData; });
/* unused harmony export restoreGood */
/* unused harmony export searchQueryGoods */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return update; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return register; });
/* unused harmony export fetchArchivedGoods */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return duplicateGood; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return fetchGood; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return fetchGoods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return destroy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return updatePropertiesGood; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return togglepropertiesGood; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return savepropertiesGood; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return clearGood; });
/* unused harmony export checkAvailability */
/* unused harmony export fetchAvaliableGoods */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getGoodServiceSkills; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return toggleGoodServiceSkillGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return attachToogleServiceSkills; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getGoodServiceSkillsDetails; });
/* unused harmony export fetchUncatogiresGoods */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return fetchModalGoods; });
/* unused harmony export fetchCompanyGoods */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getCustomCategoryWithProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return fetchModalGoodsgroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return clearGoodsgroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return enableFeaturedProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return getQueryImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return clearQueryImages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tableActions__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UtilsOperation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_general__ = __webpack_require__(6);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var clear={picture_urls:[],name:"",price_e2:"",short_details:"",details:"",level:"",type:"",unit_config_visible:false,unit_config:null};var clearGood=function clearGood(){return function(dispatch){dispatch({type:'CLEAR_GOOD',good:clear,dropzoneFiles:[]});};};var showG=function showG(){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/goods').then(function(res){dispatch({type:'FETCH_GOODS',goods:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_goods});});};};var searchGoods=function searchGoods(search){return function(dispatch,getState){dispatch({type:'FETCH_GOODS',goods:[]});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/goods/search?q='+search+'&limit=10&with=branch_group').then(function(res){dispatch({type:'FETCH_GOODS',goods:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_goods});});};};var toggleCategoryItems=function toggleCategoryItems(id,isSelected,goodType){var new_id=id.split("-")[1];var url='';var category='';var error='';return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});if(isSelected){url=''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/branches/'+getState().branch.id+'/goods?limit='+__WEBPACK_IMPORTED_MODULE_6__constants_general__["j" /* DEFAULT_PRODUCTS_PAGE_SIZE */]+'&good-type=flag 7,'+goodType;category='';error=getState().json_lang.custom_errors.retrieving_goods_list;}else{url=''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/branches/'+getState().branch.id+'/branch-goods?limit='+__WEBPACK_IMPORTED_MODULE_6__constants_general__["j" /* DEFAULT_PRODUCTS_PAGE_SIZE */]+'&category_id='+new_id+'&has_stock=1';category=new_id;error=getState().json_lang.custom_errors.update_categories_product;}return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+url).then(function(res){dispatch({type:'FETCH_LIST_GOODS',goodsList:isSelected?res.data:res.data.filter(function(elm){return elm.type===parseInt(goodType,10);}),category:category});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:error});});};};var getCustomCategoryWithProducts=function getCustomCategoryWithProducts(branch_id,category_id){return function(dispatch,getState){var _getState=getState(),company=_getState.company;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branches/'+branch_id+'/branch-goods?limit='+__WEBPACK_IMPORTED_MODULE_6__constants_general__["j" /* DEFAULT_PRODUCTS_PAGE_SIZE */]+(category_id?"&category_id="+category_id:"")).then(function(res){dispatch({type:'FETCH_LIST_GOODS',goodsList:res.data.length&&res.data[0].branch_goods});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var getCategoryWithProducts=function getCategoryWithProducts(category_id,stock){var page=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;return function(dispatch,getState){//branches/44/branch-categories/goods?limit=0
var _getState2=getState(),company=_getState2.company,branch=_getState2.branch;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id+'/branch-goods?limit='+__WEBPACK_IMPORTED_MODULE_6__constants_general__["j" /* DEFAULT_PRODUCTS_PAGE_SIZE */]+'&page='+page+(category_id?'&category_id='+category_id:'')+(stock?'&has_stock='+stock:'')).then(function(res){dispatch({type:'FETCH_LIST_GOODS',goodsList:res.data//.length && res.data[0].branch_goods //categoryFilter && categoryFilter.length > 0 ? categoryFilter[0].branch_goods : []
});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var searchQueryGoods=function searchQueryGoods(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var goodType=arguments[1];var queryString="";if(query)queryString="?search="+query+"&good-type=flag 7,"+goodType;else if(!query)queryString="?type="+goodType;return function(dispatch){__WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().company.id+'/goods'+queryString).then(function(res){dispatch({type:'AUTOCOMPLETE_GOODS',goods:res.data.data.filter(function(good){return good.available===true;})});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var find=function find(id){/* xHACER: esto ya no es asi... revisar esta inicializacion con data vieja... y pasar el res.data directamente, pa ver donde se rompe */return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().company.id+'/goods/'+id).then(function(res){console.log('goodsData',res);var goodsData={id:res.data.id,picture_urls:res.data.picture_urls,vertical_picture_urls:res.data.vertical_picture_urls,name:res.data.name,price_e2:parseFloat(res.data.price_e2,10),short_details:res.data.short_details,details:res.data.details,type:res.data.type,eta:res.data.eta,sku:res.data.sku,available:res.data.available,quantity:res.data.quantity,notes_enabled:res.data.notes_enabled,quantity_unlimited:res.data.quantity===null?true:false,flag_digital_types:0,eta_config_id:res.data.eta_config_id,eta_config:res.data.eta_config,featured_in_order:res.data.featured_in_order};dispatch({type:'FETCH_GOOD',good:goodsData});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().json_lang.custom_errors.retrieving_goods});});};};var fetchGood=function fetchGood(id,materials,branchId){return function(dispatch,getState){var _getState3=getState(),company=_getState3.company,json_lang=_getState3.json_lang,branch=_getState3.branch;//const api_host = /*company.settings && company.settings.is_marketplace ? `/branches/${branch.id}/branch-goods`:*/`/goods`
var api_host=/*company.settings.is_marketplace ?:`/goods`*/'/branches/'+(branchId||branch.id)+'/goods';return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+api_host+'/'+id+(materials?'?with=materials':"")).then(function(res){dispatch({type:'FETCH_GOOD',good:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.retrieving_goods});});};};var fetchGoodWithBranchGroup=function fetchGoodWithBranchGroup(id){return function(dispatch,getState){var _getState4=getState(),company=_getState4.company,json_lang=_getState4.json_lang;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/goods/'+id+'?with=branch_group').then(function(res){dispatch({type:'FETCH_GOOD',good:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.retrieving_goods});});};};var clearGoodWithBranchGroup=function clearGoodWithBranchGroup(){return function(dispatch){dispatch({type:'FETCH_GOOD',good:{}});};};var activePreloader=function activePreloader(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});};};var fetchGoods=function fetchGoods(){var goodType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var stock=arguments[1];var page=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;var filterQuery=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var search=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'';var categoryId=arguments.length>5&&arguments[5]!==undefined?arguments[5]:null;var featured=arguments.length>6&&arguments[6]!==undefined?arguments[6]:false;var limit=arguments.length>7&&arguments[7]!==undefined?arguments[7]:__WEBPACK_IMPORTED_MODULE_6__constants_general__["j" /* DEFAULT_PRODUCTS_PAGE_SIZE */];return function(dispatch,getState){var _getState5=getState(),company=_getState5.company,json_lang=_getState5.json_lang,branch=_getState5.branch;var categoryParam=categoryId?'&category_id='+categoryId:'';if(categoryId==="uncategory"){categoryParam='&goodCategories=:has:0';}//return false;
var queryParams=(search?"&":"?")+'limit='+__WEBPACK_IMPORTED_MODULE_6__constants_general__["j" /* DEFAULT_PRODUCTS_PAGE_SIZE */]+'&with=materials'+(goodType===0||goodType===1?'&good-type=flag 7,'+goodType:'')+'&page='+page+categoryParam+(stock?'&has_stock='+stock:'')+filterQuery+(featured?'&is_featured=1':'');var url_host=''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branches/'+branch.id+'/branch-goods'+(search?'/search?q='+search:'')+queryParams;//!TODO: arreglar el search
//*https://api-dev.dondemand.io/api/v3/companies/116/branch-groups/109/goods/search?q=Harina
return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(url_host).then(function(res){var goods_arrays=null;if(!search){goods_arrays=res.data;}else{goods_arrays=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["K" /* toPaginate */])(res.data,limit,1);}dispatch({type:'FETCH_LIST_GOODS',goodsList:goods_arrays});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.retrieving_goods_list});});};};var searchBranchGoods=function searchBranchGoods(search){var branchId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;return function(dispatch,getState){var _getState6=getState(),company=_getState6.company,branch=_getState6.branch;var url_host=''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branches/'+(branchId||branch.id)+'/branch-goods/search?q='+encodeURIComponent(search);return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(url_host).then(function(res){dispatch({type:'FETCH_GOODS',goods:res.data});});};};var fetchCompanyGoods=function fetchCompanyGoods(query){return function(dispatch,getState){var _getState7=getState(),company=_getState7.company,json_lang=_getState7.json_lang;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/goods/search?q='+query).then(function(res){dispatch({type:'FETCH_LIST_GOODS',goodsList:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.retrieving_goods_list});});};};var fetchModalGoods=function fetchModalGoods(branch_id){return function(dispatch,getState){var _getState8=getState(),company=_getState8.company,json_lang=_getState8.json_lang;dispatch({type:'FETCH_LIST_GOODS',goodsList:[]});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branches/'+branch_id+'/branch-goods?limit=10').then(function(res){dispatch({type:'FETCH_LIST_GOODS',goodsList:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.retrieving_goods_list});});};};var fetchModalGoodsgroup=function fetchModalGoodsgroup(branch_id){var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var query=arguments[2];return function(dispatch,getState){var _getState9=getState(),company=_getState9.company,json_lang=_getState9.json_lang;dispatch({type:'FETCH_LIST_GOODS',goodsList:[]});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/branch-groups/'+branch_id+'/goods?limit=10&with=branch_group&page='+page+(query?'&name=ilike '+query:'')).then(function(res){console.log("fetchModalGoodsgroup",res.data);dispatch({type:'FETCH_LIST_GOODS',goodsList:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:json_lang.custom_errors.retrieving_goods_list});});};};var clearGoodsgroup=function clearGoodsgroup(){return function(dispatch){dispatch({type:'FETCH_LIST_GOODS',goodsList:[]});};};var fetchUncatogiresGoods=function fetchUncatogiresGoods(){var goodType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var stock=arguments[1];return function(dispatch,getState){var _getState10=getState(),company=_getState10.company,json_lang=_getState10.json_lang,branch=_getState10.branch;var api_host=company.settings&&company.settings.is_marketplace?'/branches/'+branch.id+'/branch-goods?limit='+__WEBPACK_IMPORTED_MODULE_6__constants_general__["j" /* DEFAULT_PRODUCTS_PAGE_SIZE */]+'&goodCategories=:has:0'+(stock?'&has_stock='+stock:''):'/goods';return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+api_host+(goodType===0||goodType===1?'&good-type=flag 7,'+goodType:'')).then(function(res){dispatch({type:'FETCH_LIST_GOODS',goodsList:res&&res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.retrieving_goods_list});});};};var fetchAvaliableGoods=function fetchAvaliableGoods(){var goodType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;return function(dispatch,getState){var _getState11=getState(),company=_getState11.company,json_lang=_getState11.json_lang;var urlGoodType=goodType===0||goodType===1?'&type=flag 7,'+goodType:'';var api_host=''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/goods?limit=0&'+urlGoodType;// available=1&with=good.allowedProviders
return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(api_host).then(function(res){dispatch({type:'FETCH_LIST_GOODS',goodsList:res.data,goodType:goodType});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.retrieving_goods_list});});};};var displayListGoods=function displayListGoods(){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/goods?limit=0&available=1').then(function(res){// with=good.allowedProviders
dispatch({type:'DISPLAY_LIST_GOODS',goodsList:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_goods_list});});};};var fetchArchivedGoods=function fetchArchivedGoods(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().company.id+'/goods?limit=0&mode=deleted').then(function(res){dispatch({type:'FETCH_LIST_GOODS',goodsList:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().json_lang.custom_errors.retrieving_goods});});};};var toggleData=function toggleData(value,priceChanged){return function(dispatch,getState){var data=Object.assign({},getState().good);if(value.name==='available'||value.name==='quantity_unlimited'||value.name==='notes_enabled'||value.name==='is_combo'){data[value.name]=value.checked;if(value.name==='quantity_unlimited'){data.quantity=data.quantity_unlimited===true?'':data.quantity;}}else if(value.name==='picture_urls'){if(data.picture_urls.length>0){var urls=data.picture_urls.filter(function(item,i){return parseInt(value.data,10)!==i;});data.picture_urls=urls;}}else if(value.name==='price_e2'||value.name==='quantity'||value.name==='eta'){data[value.name]=isNaN(value.data)?data[value.name]:value.data;if(value.name==='price_e2'){data.priceChanged=true;}}else if(value.name==="list_type"){data.type=value.checked?parseInt(data.type,10)|16:parseInt(data.type,10)&~16;data.list_type=value.checked?1:0;}else if(value.name==="digital_type"){data.type=value.checked?parseInt(data.type,10)|0x4:parseInt(data.type,10)&~0x4;data.digital_type=value.checked?1:0;}else if(value.name==="flag_digital_types"){// console.log("flag_digital_types",parseInt(value.data,10))
data.type=parseInt(data.type,10)&~0xff00|parseInt(value.data,10);data.flag_digital_types=value.data;}//
else if(value.name==="max_quantity"){data[value.name]=parseInt(value.data,10);}else if(value.name==="enabled"){data.unit_config.enabled=value.checked;}else if(value.name==="weight_per_unit"||value.name==="min_quantity"||value.name==="step_quantity"||value.name==="display_mode"||value.name==="fraction"||value.name==="unit_name"){data.unit_config[value.name]=value.data;}else if(value.name==="unit_max_quantity"){data.unit_config.max_quantity=value.data;}else if(value.name==="max_quantity_unlimited"){data.unit_config.max_quantity_unlimited=value.checked;data.unit_config.max_quantity="";}else if(value.name.split('picture_urls_order-').length>1){var key2=parseInt(value.name.split('picture_urls_order-')[1],10);if(parseInt(value.data,10)<data.picture_urls.length&&value.data!==""){var newOrder=[].concat(_toConsumableArray(data.picture_urls));newOrder[value.data]=data.picture_urls[key2];newOrder[key2]=data.picture_urls[value.data];data.picture_urls=newOrder;}}else if(value.name.split('vertical_picture_order-').length>1){var _key=parseInt(value.name.split('vertical_picture_order-')[1],10);if(parseInt(value.data,10)<data.vertical_picture_urls.length&&value.data!==""){var _newOrder=[].concat(_toConsumableArray(data.vertical_picture_urls));_newOrder[value.data]=data.vertical_picture_urls[_key];_newOrder[_key]=data.vertical_picture_urls[value.data];data.vertical_picture_urls=_newOrder;}}else{data[value.name]=value.data;}// console.log(" data.unit_config", data)
dispatch({type:'FETCH_GOOD',good:data});};};var update=function update(){return function(dispatch,getState){var data=getState().good;var good=new FormData();good.append('name',data.name);if(data.priceChanged){good.append('price_e2',data.price_e2*100);}good.append('short_details',data.short_details?data.short_details:'n/a');good.append('details',data.details);good.append('level',0);good.append('type',data.type?data.type:0);good.append('available',data.available===true?1:0);good.append('sku',data.sku?data.sku:"");good.append('eta',data.eta?data.eta:"");if(data.quantity_unlimited===true){good.append('quantity',__WEBPACK_IMPORTED_MODULE_6__constants_general__["_43" /* UNLIMITED_STOCK */]);}else{good.append('quantity',parseInt(data.quantity,10)>0?data.quantity:0);}/*if(getState().dropzoneFiles.length){
                getState().dropzoneFiles.map( (file) => {
                    var block = file.split(";");
                    var contentType = block[0].split(":")[1];
                    var realData = block[1].split(",")[1];
                    var blob = b64toBlob(realData, contentType);
                    return  good.append('pictures[]',  blob )
                })
            }*/if(data.picture_urls.length>0){data.picture_urls.map(function(url){return good.append('picture_urls[]',url);});}else{good.append('picture_urls[]',[]);}/*if(data.picture_urls.length === 0 && getState().dropzoneFiles.length === 0){
                good.append('picture_urls[]', [] )
            }*/dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].put(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/branches/'+getState().branch.id+'/branch-goods/'+data.id,good).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});dispatch({type:'GOOD_UPDATE_SUCCESS',goodsList:Object(__WEBPACK_IMPORTED_MODULE_3__tableActions__["j" /* tableUpdate */])(res,"goodsList"),good:clear});}).catch(function(err){if(err.message&&err.message!=='generic'){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});}else if(err.data.message==="in_service_locked"){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.in_service_locked});}else if(err.data.message==="bound_type"){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"El producto pertenece a almenos una categoria de tipo lista"});}else if(err.data.message==="attached_service_skills"){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"Es necesario retirar las habilidades requeridas del Servicio"});}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_goods});}});};};var updateGoodEta=function updateGoodEta(good_id,eta_id){return function(dispatch,getState){var _getState12=getState(),good=_getState12.good,branch=_getState12.branch;var updatedGood=Object.assign({},good);updatedGood.eta_config_id=eta_id===0?null:eta_id;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/branches/'+branch.id+'/goods/'+good_id,updatedGood).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});}).catch(function(err){if(err.message&&err.message!=='generic'){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});}else if(err.data.message==="in_service_locked"){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.in_service_locked});}else if(err.data.message==="bound_type"){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"El producto pertenece a almenos una categoria de tipo lista"});}else if(err.data.message==="attached_service_skills"){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"Es necesario retirar las habilidades requeridas del Servicio"});}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_goods});}});};};var checkAvailability=function checkAvailability(data){return function(dispatch,getState){var _getState13=getState(),company=_getState13.company,json_lang=_getState13.json_lang;var good=new FormData();good.append('available',data.available===true?0:1);if(data.picture_urls.length>0){data.picture_urls.map(function(url){return good.append('picture_urls[]',url);});}dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/goods/'+data.good_id+'/categories?limit=0').then(function(res){if(res.data.length>0){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/goods/'+data.good_id,good).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:'GOOD_UPDATE_SUCCESS',goodsList:Object(__WEBPACK_IMPORTED_MODULE_3__tableActions__["j" /* tableUpdate */])(res,"goodsList"),good:clear});}).catch(function(err){if(err.message&&err.message!=='generic'){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});}else if(err.data.message==="in_service_locked"){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.in_service_locked});}else if(err.data.message==="missing_service_skills"){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"Por favor anexe habilidades requeridas"});}else if(err.data.message==="matching_providers_not_found"){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"No tiene proveedores con las habilidades necesarias para hacer este servicio"});}else if(err.data.message==="no_stock"){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"El inventario de este producto es 0"});}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.retrieving_goods});}});}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"warning",title:'datos incompletos',msg:'por favor ingrese almenos 1 categoria'});}}).catch(function(err){if(err&&err.data&&err.data.message&&err.data.message){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.data.message});}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.retrieving_categories_product});}});};};var register=function register(){return function(dispatch,getState){var _getState14=getState(),company=_getState14.company,json_lang=_getState14.json_lang,branch=_getState14.branch,good=_getState14.good,userHigherAccess=_getState14.userHigherAccess;var goodData={name:good.name,short_details:good.short_details?good.short_details:'n/a',details:good.details?good.details:"n/a",price_e2:parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(good.price_e2*100)),type:good.type?good.type:0,available:0,unit_config:null};if(branch.branch_group.is_digital){goodData.type=branch.branch_group.is_digital?parseInt(good.type,10)|0x4:parseInt(good.type,10)&~0x4;}if(good.sku){goodData.sku=good.sku;}if(good.unit){goodData.unit=good.unit;}if(good.list_order){goodData.list_order=good.list_order;}if(good.eta){goodData.eta=good.eta;}if(good.quantity_unlimited===true){goodData.quantity=__WEBPACK_IMPORTED_MODULE_6__constants_general__["_43" /* UNLIMITED_STOCK */];}else{goodData.quantity=parseInt(good.quantity,10)>0?good.quantity:0;}if(userHigherAccess===__WEBPACK_IMPORTED_MODULE_6__constants_general__["h" /* COMPANY_ACCESS */]){goodData.notes_enabled=good.notes_enabled?good.notes_enabled:false;}if(good.unit_config_visible===true){goodData.unit_config={enabled:good.unit_config&&good.unit_config.enabled,display_mode:good.unit_config&&good.unit_config.display_mode,fraction:parseFloat(good.unit_config&&good.unit_config.fraction),min_quantity:parseFloat(good.unit_config&&good.unit_config.min_quantity),step_quantity:parseFloat(good.unit_config&&good.unit_config.step_quantity),max_quantity:parseFloat(good.unit_config&&good.unit_config.max_quantity),unit_name:good.unit_config&&good.unit_config.unit_name,weight_per_unit:parseInt(good.unit_config&&good.unit_config.weight_per_unit,10)};}if(good.max_quantity){goodData.max_quantity=good.max_quantity;}if(good.limit_type){goodData.limit_type=good.limit_type;}console.log("registerBranchGood",branch);dispatch({type:"WAIT_FOR_RESPONSE"});var api_host=company.settings&&company.settings.is_marketplace?'/branches/'+branch.id+'/goods':'/goods';return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+api_host,goodData).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful_product});dispatch({type:'REGISTER_GOOD',good:res.data,clear:clear});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_goods});});};};var duplicateGood=function duplicateGood(data){return function(dispatch){var data=__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().good;var good=new FormData();good.append('name',data.name);good.append('price_e2',data.price_e2);good.append('short_details',data.short_details?data.short_details:'n/a');good.append('eta',data.eta);good.append('details',data.details);good.append('level',0);good.append('type',data.type?data.type:0);good.append('available',data.available===true?1:0);__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().dropzoneFiles.map(function(file){return good.append('pictures[]',file);});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().company.id+'/goods',good).then(function(res){dispatch({type:'REGISTER_GOOD',good:res.data,clear:clear});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"Hubo un error al duplicar producto"});});};};var destroy=function destroy(id){return function(dispatch){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().company.id+'/goods/'+id).then(function(res){var succesful=__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().json_lang.common.success;__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().json_lang.custom_success.saved_successful});dispatch({type:'GOOD_DELETED',goodsList:Object(__WEBPACK_IMPORTED_MODULE_3__tableActions__["h" /* tableRemove */])(res,"goodsList"),good:clear});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().json_lang.custom_errors.good_delete_failed});});};};var restoreGood=function restoreGood(id){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().company.id+'/goods/'+id+'/restore').then(function(res){var succesful=__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().json_lang.common.success;__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().json_lang.custom_success.saved_successful});dispatch({type:'GOOD_RESTAURED',goodsList:Object(__WEBPACK_IMPORTED_MODULE_3__tableActions__["h" /* tableRemove */])(res,"goodsList"),good:clear});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().json_lang.custom_errors.retrieving_goods});});};};var togglepropertiesGood=function togglepropertiesGood(value){var in_order=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;return function(dispatch,getState){var name=value.name.split('-')[0];var id=parseInt(value.name.split('-')[1],10);var data=getState().propertiesGood.map(function(property){if(property.pivot===undefined){property.pivot={property_id:id,display_name:'',options:0};}if(property.pivot.mandatory===undefined){property.pivot.mandatory=false;}if(property.id===id){if(name==='display_name'){property.pivot.display_name=value.data;}if(name==='options'){property.pivot.options=property.pivot.options&~0xfff|value.data;}if(name==='mandatory'){property.pivot.options=(property.pivot.options&0xF00000)!==0?property.pivot.options&~0xF00000:property.pivot.options|0x100000;}if(name==='adminCustomizable'){property.pivot.options=(property.pivot.options&__WEBPACK_IMPORTED_MODULE_6__constants_general__["n" /* FLAG_ADMIN_CUSTOMIZABLE */])!==0?property.pivot.options&~__WEBPACK_IMPORTED_MODULE_6__constants_general__["n" /* FLAG_ADMIN_CUSTOMIZABLE */]:property.pivot.options|__WEBPACK_IMPORTED_MODULE_6__constants_general__["n" /* FLAG_ADMIN_CUSTOMIZABLE */];}if(name==='min'){property.pivot.options=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["H" /* setMin */])(value.data,property.pivot.options);}if(name==='max'){property.pivot.options=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["G" /* setMax */])(value.data,property.pivot.options);}if(name==='stack'){property.pivot.options=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["I" /* setStack */])(value.data,property.pivot.options);}}// console.log(variant)
if(in_order!==null){property.pivot.in_order=in_order;}return property;});dispatch({type:'PROPERTIES_GOOD',propertiesGood:data,properties:getState().properties});};};var updatePropertiesGood=function updatePropertiesGood(id){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/properties/'+id).then(function(res){if(id>0){var newRes=res.data;newRes.pivot={property_id:res.data.id,display_name:res.data.name,options:res.data.type};var newdata=[].concat(_toConsumableArray(getState().propertiesGood));newdata.push(newRes);var propertiesUpdate=getState().properties.filter(function(item){return item.id!==id;});dispatch({type:'PROPERTIES_GOOD',propertiesGood:newdata,properties:propertiesUpdate});}}).catch(function(err){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});});};};var savepropertiesGood=function savepropertiesGood(id,good_id){var data=__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().propertiesGood.map(function(property){if(property.pivot===undefined){property.pivot={property_id:'',display_name:'',options:1024};}else{var optionValue=1024;if(property.pivot.options){optionValue=property.pivot.mandatory===true?property.pivot.options|0xF00000:property.pivot.options;}property.pivot={property_id:property.pivot.property_id,display_name:property.pivot.display_name,options:optionValue};}return property.pivot;});return function(dispatch){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().company.id+'/goods/'+good_id+'/properties',data).then(function(res){var succesful=__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().json_lang.common.success;__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getState().json_lang.custom_success.saved_successful});dispatch({type:'SAVE_PROPERTIES_GOOD',propertiesGood:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"Hubo un error al guardar variantes de un producto"});});};};var getGoodServiceSkills=function getGoodServiceSkills(id){return function(dispatch,getState){var data=[].concat(_toConsumableArray(getState().service_skill_groups));dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/goods/'+id+'/service-skills').then(function(res){var enabled={};res.data.forEach(function(e){enabled[e.id]=true;});var activeSkills=data.filter(function(group){return group.skills.length>0;}).map(function(group){group.skills=group.skills.map(function(skill){skill.active=enabled[skill.id]||false;return skill;});return group;});/*let activeSkills =[]
            data.forEach( (data) => {
                if( data.skills.length > 0 ){
                    var test={
                        name:data.name,
                        skills:[]
                    }
                    data.skills.forEach( (skill) => {
                        let skillTest ={
                            id:skill.id,
                            name:skill.name,
                            active:false
                        }
                        res.data.forEach(  (res) => {
                            if(res.id === skill.id){
                                skillTest.active = true
                            }
                        })
                        test.skills.push(skillTest)
                    })
                    if(test.skills.length > 0){
                        activeSkills.push(test)
                    }
                }
            })*/dispatch({type:'LIST_GOODSERVICE_SKILL_GROUPS',goodServiceSkills:activeSkills});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"Hubo un error al guardar variantes de un producto"});});};};var getGoodTags=function getGoodTags(id){return function(dispatch,getState){var data=[].concat(_toConsumableArray(getState().good_tag_groups));dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/goods/'+id+'/good-tags').then(function(res){var enabled={};res.data.forEach(function(e){enabled[e.id]=true;});var activeTags=data.filter(function(group){return group.tags.length>0;}).map(function(group){group.tags=group.tags.map(function(tag){tag.active=enabled&&enabled[tag.id]||false;return tag;});return group;});dispatch({type:'LIST_GOOD_TAG_GROUPS',good_tag_groups:activeTags});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"Hubo un error al guardar variantes de un producto"});});};};var toggleGoodTags=function toggleGoodTags(value){return function(dispatch,getState){var name=value.name.split('-');var newdata=[].concat(_toConsumableArray(getState().good_tag_groups));newdata[name[1]].tags[name[2]].active=!newdata[name[1]].tags[name[2]].active;dispatch({type:'LIST_GOOD_TAG_GROUPS',good_tag_groups:newdata});};};var clearGoodTags=function clearGoodTags(){return function(dispatch,getState){dispatch({type:'LIST_GOOD_TAG_GROUPS',good_tag_groups:[]});};};var getGoodServiceSkillsDetails=function getGoodServiceSkillsDetails(id){return function(dispatch,getState){var data=[].concat(_toConsumableArray(getState().service_skill_groups));dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/goods/'+id+'/service-skills').then(function(res){var enabled={};res.data.forEach(function(e){enabled[e.id]=true;});var activeSkills=data.filter(function(group){return group.skills.length>0;}).map(function(group){group.skills=group.skills.filter(function(skill){return enabled[skill.id]||false;});return group;});dispatch({type:'LIST_GOODSERVICE_SKILL_GROUPS',goodServiceSkills:activeSkills});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"Hubo un error al guardar variantes de un producto"});});};};var clearGoodServiceSkills=function clearGoodServiceSkills(){return function(dispatch,getState){dispatch({type:'LIST_GOODSERVICE_SKILL_GROUPS',goodServiceSkills:[]});};};var toggleGoodServiceSkillGroup=function toggleGoodServiceSkillGroup(value){return function(dispatch,getState){var name=value.name.split('-');var newdata=[].concat(_toConsumableArray(getState().goodServiceSkills));newdata[name[1]].skills[name[2]].active=!newdata[name[1]].skills[name[2]].active;dispatch({type:'LIST_GOODSERVICE_SKILL_GROUPS',goodServiceSkills:newdata});};};var attachToogleServiceSkills=function attachToogleServiceSkills(id){return function(dispatch,getState){var attachData=[];getState().goodServiceSkills.forEach(function(goodServiceSkills){goodServiceSkills.skills.forEach(function(skill){if(skill.active===true){attachData.push(skill.id);}});});dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].put(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/goods/'+id+'/service-skills',attachData).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"Hubo un error al guardar variantes de un producto"});});};};var attachToogleGoodsTags=function attachToogleGoodsTags(id){return function(dispatch,getState){var attachData=[];getState().good_tag_groups.forEach(function(good_tag_group){good_tag_group.tags.forEach(function(tag){if(tag.active===true){attachData.push(tag.id);}});});dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].put(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/goods/'+id+'/good-tags',attachData).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"Hubo un error al guardar variantes de un producto"});});};};var getGoodTagGroups=function getGoodTagGroups(){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/good-tag-groups?with_tags=1').then(function(res){dispatch({type:'LIST_GOOD_TAG_GROUPS',good_tag_groups:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:'Error al buscar habilidades requeridas de los productos'});});};};var addGoodTagGroups=function addGoodTagGroups(){return function(dispatch,getState){var newData={name:getState().new_good_tag_groups};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/good-tag-groups',newData).then(function(res){var new_good_tag_groups=[];res.data.tags=[];new_good_tag_groups.push(res.data);var update_data=new_good_tag_groups.concat(getState().good_tag_groups);__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});dispatch({type:'LIST_GOOD_TAG_GROUPS',good_tag_groups:update_data});}).catch(function(err){if(err.data.message)__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:getState().json_lang.custom_errors[err.data.message]});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var toggleNewGoodTagGroups=function toggleNewGoodTagGroups(value){return function(dispatch,getState){var name=value.name.split('-');if(name.length>1){var update_data=getState().good_tag_groups.map(function(good_tag_group,key){if(key===parseInt(name[1],10)){if(name[0]==='name'||name[0]==='new_name'){good_tag_group[name[0]]=value.data;}else{good_tag_group.tags[name[2]].name=value.data;}}return good_tag_group;});dispatch({type:'LIST_GOOD_TAG_GROUPS',good_tag_groups:update_data});}else{var data=getState().new_good_tag_groups=value.data;dispatch({type:'NEW_GOOD_TAG_GROUPS',new_good_tag_groups:data});}};};var deleteGoodTagGroup=function deleteGoodTagGroup(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/good-tag-groups/'+id).then(function(res){var update_data=getState().good_tag_groups.filter(function(tag_group,key){return tag_group.id!==parseInt(res.data.id,10);});__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.delete_successful});update_data.sort();dispatch({type:'LIST_GOOD_TAG_GROUPS',good_tag_groups:update_data});}).catch(function(err){if(err.message&&err.message!=='generic'){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});}else if(err.data.message){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:getState().json_lang.custom_errors[err.data.message]});}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:''});}});};};var editGoodTagGroup=function editGoodTagGroup(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var data=getState().good_tag_groups.find(function(tag_group,key){return tag_group.id===parseInt(id,10);});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/good-tag-groups/'+id,data).then(function(res){var update_data=getState().good_tag_groups.map(function(tag_group,key){if(tag_group.id===parseInt(res.data.id,10)){tag_group.reason=res.data.reason;}return tag_group;});__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.delete_successful});dispatch({type:'LIST_GOOD_TAG_GROUPS',good_tag_groups:update_data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_restore_failed});});};};var addTag=function addTag(id){return function(dispatch,getState){var newData=getState().good_tag_groups.find(function(good_tag_group,key){return good_tag_group.id===parseInt(id,10);});dispatch({type:"WAIT_FOR_RESPONSE"});var tag={name:newData.new_name};return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/good-tag-groups/'+id+'/good-tags',tag).then(function(res){var update_data=getState().good_tag_groups.map(function(good_tag_group,key){if(good_tag_group.id===parseInt(id,10)){good_tag_group.tags=good_tag_group.tags.concat(res.data);good_tag_group.new_name='';}return good_tag_group;});__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});dispatch({type:'LIST_GOOD_TAG_GROUPS',good_tag_groups:update_data});}).catch(function(err){console.log("err.data.message",err.data.message);if(err.data.message)__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:getState().json_lang.custom_errors[err.data.message]});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_restore_failed});});};};var editTag=function editTag(id,tag_id){return function(dispatch,getState){var newData=getState().good_tag_groups.find(function(good_tag_group,key){return good_tag_group.id===parseInt(tag_id,10);});var editedTag=newData.tags.find(function(tag,key){return tag.id===parseInt(id,10);});dispatch({type:"WAIT_FOR_RESPONSE"});var tag={name:editedTag.name};return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/good-tags/'+id,tag).then(function(res){/*let update_data = getState().good_tag_groups.map( (good_tag_group,key) => {
                if(good_tag_group.id === parseInt( id,10 )){
                    good_tag_group.tags = good_tag_group.tags.concat(res.data)
                    good_tag_group.new_name =''
                }
                return good_tag_group
            })
            dispatch({
                type: 'LIST_GOOD_TAG_GROUPS',
                good_tag_groups: update_data
            })

            */__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"Hubo un error al editar la etiqueta"});});};};var removeTag=function removeTag(id,tag_id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/good-tags/'+id).then(function(res){var update_data=[].concat(_toConsumableArray(getState().good_tag_groups));update_data.map(function(tag_group,key){if(parseInt(tag_group.id,10)===parseInt(tag_id,10)){tag_group.tags=tag_group.tags.filter(function(tag,key){return parseInt(tag.id,10)!==parseInt(id,10);});}return tag_group;});dispatch({type:'LIST_GOOD_TAG_GROUPS',good_tag_groups:update_data});__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});}).catch(function(err){if(err.message&&err.message!=='generic'){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});}else if(err.data.message){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:getState().json_lang.custom_errors[err.data.message]});}else{__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:''});}});};};var isUploadingExcel=function isUploadingExcel(){return function(dispatch,getState){var _getState15=getState(),isUploadingExcel=_getState15.isUploadingExcel;dispatch({type:'IS_UPLOADING_EXCEL',isUploadingExcel:!isUploadingExcel});};};var fetchFeaturedProducts=function fetchFeaturedProducts(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var search=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";return function(dispatch,getState){__WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/good-sections?page='+page+(search?'&name=ilike '+encodeURIComponent(search):'')).then(function(res){dispatch({type:'FEATURED_GOODS',featuredGoods:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var findFeaturedProduct=function findFeaturedProduct(id){return function(dispatch,getState){var _getState16=getState(),company=_getState16.company;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/good-sections/'+id+'?with=goods.branch_group').then(function(res){res.data.good_ids=res.data.goods.map(function(item,key){return item.id;});res.data.hour_from=res.data.hour_from?Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["O" /* utcToLocal */])(res.data.hour_from,"HH:mm"):"";res.data.hour_to=res.data.hour_to?Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["O" /* utcToLocal */])(res.data.hour_to,"HH:mm"):"";dispatch({type:'FEATURED_GOOD',featuredGood:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var toggleData4=function toggleData4(value){return function(dispatch,getState){var data=Object.assign({},getState().featuredGood);if(value.name==='use_date_configuration'){data.date_from=value.checked?value.date_from:null;data.date_to=value.checked?value.date_to:null;}else if(value.name==='is_featured'||value.name.startsWith("day")){data[value.name]=value.checked;}else{data[value.name]=value.data;}dispatch({type:'FEATURED_GOOD',featuredGood:data});};};var storeFeaturedProduct=function storeFeaturedProduct(id){return function(dispatch,getState){var _getState17=getState(),company=_getState17.company,json_lang=_getState17.json_lang,featuredGoods=_getState17.featuredGoods,featuredGood=_getState17.featuredGood;var data=Object.assign({},featuredGood);data.tz=company.time_zone_offset||__WEBPACK_IMPORTED_MODULE_6__constants_general__["k" /* DEFAULT_TIME_ZONE */],data.good_ids=data.goods.map(function(item,key){return item.id;});dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/good-sections',data).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});var newData=Object.assign({},featuredGoods);var updateEtaConfigData=newData.data.concat(res.data);newData.data=updateEtaConfigData;dispatch({type:'FEATURED_GOODS',featuredGoods:newData});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var updateFeaturedProduct=function updateFeaturedProduct(id){return function(dispatch,getState){var _getState18=getState(),company=_getState18.company,json_lang=_getState18.json_lang,featuredGoods=_getState18.featuredGoods,featuredGood=_getState18.featuredGood;var data=Object.assign({},featuredGood);data.tz=company.time_zone_offset||__WEBPACK_IMPORTED_MODULE_6__constants_general__["k" /* DEFAULT_TIME_ZONE */],data.good_ids=data.goods.map(function(item,key){return item.id;});dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/good-sections/'+id,data).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});var newData=Object.assign({},featuredGoods);var update=newData.data.map(function(item,key){if(item.id===res.data.id){item=res.data;}return item;});newData.data=update;dispatch({type:'FEATURED_GOODS',featuredGoods:newData});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var enableFeaturedProduct=function enableFeaturedProduct(id,valor){console.log(id,valor);return function(dispatch,getState){var _getState19=getState(),company=_getState19.company,json_lang=_getState19.json_lang,featuredGoods=_getState19.featuredGoods;var data={enabled:valor};dispatch({type:"WAIT_FOR_RESPONSE"});__WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/good-sections/'+id,data).then(function(res){__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});var newData=Object.assign({},featuredGoods);var update=newData.data.map(function(item,key){if(item.id===res.data.id){item=res.data;}return item;});newData.data=update;dispatch({type:'FEATURED_GOODS',featuredGoods:newData});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var deleteFeaturedProduct=function deleteFeaturedProduct(id){return function(dispatch,getState){var _getState20=getState(),featuredGoods=_getState20.featuredGoods;dispatch({type:"WAIT_FOR_RESPONSE"});__WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/good-sections/'+id).then(function(res){var newData=Object.assign({},featuredGoods);var update=newData.data.filter(function(elm){return elm.id!==parseInt(id,10);});newData.data=update;dispatch({type:'FEATURED_GOODS',featuredGoods:newData});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_4__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var clearFeaturedProduct=function clearFeaturedProduct(){return function(dispatch){var config={name:"",in_order:"",is_featured:false};dispatch({type:'FEATURED_GOOD',featuredGood:config});};};var dettachFeaturedProduct=function dettachFeaturedProduct(id){return function(dispatch,getState){var _getState21=getState(),featuredGood=_getState21.featuredGood;var data=Object.assign({},featuredGood);var update=data.goods.filter(function(typeId){return parseInt(typeId.id,10)!==parseInt(id,10);});console.log("featuredGood",data.goods,id,update);data.goods=update;dispatch({type:'FEATURED_GOOD',featuredGood:data});};};var attachFeaturedProduct=function attachFeaturedProduct(item){return function(dispatch,getState){var _getState22=getState(),featuredGood=_getState22.featuredGood;var data=Object.assign({},featuredGood);if(!data.goods){data.goods=[];}var update=data.goods.concat(item);if(data.goods){data.goods=update;}dispatch({type:'FEATURED_GOOD',featuredGood:data});};};var getQueryImages=function getQueryImages(goodId){return function(dispatch,getState){var _getState23=getState(),company=_getState23.company,json_lang=_getState23.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/goods/'+goodId+'/query-images').then(function(res){dispatch({type:"GET_QUERY_IMAGES",queryImages:res.data});});};};var clearQueryImages=function clearQueryImages(){return function(dispatch){dispatch({type:"GET_QUERY_IMAGES",queryImages:[]});};};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(412);

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(81),
    stackClear = __webpack_require__(496),
    stackDelete = __webpack_require__(497),
    stackGet = __webpack_require__(498),
    stackHas = __webpack_require__(499),
    stackSet = __webpack_require__(500);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(25),
    stubFalse = __webpack_require__(528);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)(module)))

/***/ }),
/* 140 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(43),
    getPrototype = __webpack_require__(253),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 142 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(529),
    baseUnary = __webpack_require__(249),
    nodeUtil = __webpack_require__(250);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(32);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports = [{"symbol":"Af","name":"Afghan Afghani","symbol_native":"؋","decimal_digits":0,"rounding":0,"value":"AFN","name_plural":"Afghan Afghanis"},{"symbol":"ALL","name":"Albanian Lek","symbol_native":"Lek","decimal_digits":0,"rounding":0,"value":"ALL","name_plural":"Albanian lekë"},{"symbol":"DA","name":"Algerian Dinar","symbol_native":"د.ج.‏","decimal_digits":2,"rounding":0,"value":"DZD","name_plural":"Algerian dinars"},{"symbol":"AR$","name":"Argentine Peso","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"ARS","name_plural":"Argentine pesos"},{"symbol":"AMD","name":"Armenian Dram","symbol_native":"դր.","decimal_digits":0,"rounding":0,"value":"AMD","name_plural":"Armenian drams"},{"symbol":"AU$","name":"Australian Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"AUD","name_plural":"Australian dollars"},{"symbol":"man.","name":"Azerbaijani Manat","symbol_native":"ман.","decimal_digits":2,"rounding":0,"value":"AZN","name_plural":"Azerbaijani manats"},{"symbol":"BD","name":"Bahraini Dinar","symbol_native":"د.ب.‏","decimal_digits":3,"rounding":0,"value":"BHD","name_plural":"Bahraini dinars"},{"symbol":"Tk","name":"Bangladeshi Taka","symbol_native":"৳","decimal_digits":2,"rounding":0,"value":"BDT","name_plural":"Bangladeshi takas"},{"symbol":"BYR","name":"Belarusian Ruble","symbol_native":"BYR","decimal_digits":0,"rounding":0,"value":"BYR","name_plural":"Belarusian rubles"},{"symbol":"BZ$","name":"Belize Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"BZD","name_plural":"Belize dollars"},{"symbol":"Bs","name":"Bolivian Boliviano","symbol_native":"Bs","decimal_digits":2,"rounding":0,"value":"BOB","name_plural":"Bolivian bolivianos"},{"symbol":"KM","name":"Bosnia-Herzegovina Convertible Mark","symbol_native":"KM","decimal_digits":2,"rounding":0,"value":"BAM","name_plural":"Bosnia-Herzegovina convertible marks"},{"symbol":"BWP","name":"Botswanan Pula","symbol_native":"P","decimal_digits":2,"rounding":0,"value":"BWP","name_plural":"Botswanan pulas"},{"symbol":"R$","name":"Brazilian Real","symbol_native":"R$","decimal_digits":2,"rounding":0,"value":"BRL","name_plural":"Brazilian reals"},{"symbol":"£","name":"British Pound Sterling","symbol_native":"£","decimal_digits":2,"rounding":0,"value":"GBP","name_plural":"British pounds sterling"},{"symbol":"BN$","name":"Brunei Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"BND","name_plural":"Brunei dollars"},{"symbol":"BGN","name":"Bulgarian Lev","symbol_native":"лв.","decimal_digits":2,"rounding":0,"value":"BGN","name_plural":"Bulgarian leva"},{"symbol":"FBu","name":"Burundian Franc","symbol_native":"FBu","decimal_digits":0,"rounding":0,"value":"BIF","name_plural":"Burundian francs"},{"symbol":"KHR","name":"Cambodian Riel","symbol_native":"៛","decimal_digits":2,"rounding":0,"value":"KHR","name_plural":"Cambodian riels"},{"symbol":"CA$","name":"Canadian Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"CAD","name_plural":"Canadian dollars"},{"symbol":"CV$","name":"Cape Verdean Escudo","symbol_native":"CV$","decimal_digits":2,"rounding":0,"value":"CVE","name_plural":"Cape Verdean escudos"},{"symbol":"CFA","name":"CFA Franc BCEAO","symbol_native":"CFA","decimal_digits":0,"rounding":0,"value":"XOF","name_plural":"CFA francs BCEAO"},{"symbol":"FCFA","name":"CFA Franc BEAC","symbol_native":"FCFA","decimal_digits":0,"rounding":0,"value":"XAF","name_plural":"CFA francs BEAC"},{"symbol":"CL$","name":"Chilean Peso","symbol_native":"$","decimal_digits":0,"rounding":0,"value":"CLP","name_plural":"Chilean pesos"},{"symbol":"CN¥","name":"Chinese Yuan","symbol_native":"CN¥","decimal_digits":2,"rounding":0,"value":"CNY","name_plural":"Chinese yuan"},{"symbol":"CO$","name":"Colombian Peso","symbol_native":"$","decimal_digits":0,"rounding":0,"value":"COP","name_plural":"Colombian pesos"},{"symbol":"CF","name":"Comorian Franc","symbol_native":"FC","decimal_digits":0,"rounding":0,"value":"KMF","name_plural":"Comorian francs"},{"symbol":"CDF","name":"Congolese Franc","symbol_native":"FrCD","decimal_digits":2,"rounding":0,"value":"CDF","name_plural":"Congolese francs"},{"symbol":"₡","name":"Costa Rican Colón","symbol_native":"₡","decimal_digits":0,"rounding":0,"value":"CRC","name_plural":"Costa Rican colóns"},{"symbol":"kn","name":"Croatian Kuna","symbol_native":"kn","decimal_digits":2,"rounding":0,"value":"HRK","name_plural":"Croatian kunas"},{"symbol":"Kč","name":"Czech Republic Koruna","symbol_native":"Kč","decimal_digits":2,"rounding":0,"value":"CZK","name_plural":"Czech Republic korunas"},{"symbol":"Dkr","name":"Danish Krone","symbol_native":"kr","decimal_digits":2,"rounding":0,"value":"DKK","name_plural":"Danish kroner"},{"symbol":"Fdj","name":"Djiboutian Franc","symbol_native":"Fdj","decimal_digits":0,"rounding":0,"value":"DJF","name_plural":"Djiboutian francs"},{"symbol":"RD$","name":"Dominican Peso","symbol_native":"RD$","decimal_digits":2,"rounding":0,"value":"DOP","name_plural":"Dominican pesos"},{"symbol":"EGP","name":"Egyptian Pound","symbol_native":"ج.م.‏","decimal_digits":2,"rounding":0,"value":"EGP","name_plural":"Egyptian pounds"},{"symbol":"Nfk","name":"Eritrean Nakfa","symbol_native":"Nfk","decimal_digits":2,"rounding":0,"value":"ERN","name_plural":"Eritrean nakfas"},{"symbol":"Ekr","name":"Estonian Kroon","symbol_native":"kr","decimal_digits":2,"rounding":0,"value":"EEK","name_plural":"Estonian kroons"},{"symbol":"Br","name":"Ethiopian Birr","symbol_native":"Br","decimal_digits":2,"rounding":0,"value":"ETB","name_plural":"Ethiopian birrs"},{"symbol":"€","name":"Euro","symbol_native":"€","decimal_digits":2,"rounding":0,"value":"EUR","name_plural":"Euros"},{"symbol":"GEL","name":"Georgian Lari","symbol_native":"GEL","decimal_digits":2,"rounding":0,"value":"GEL","name_plural":"Georgian laris"},{"symbol":"GH₵","name":"Ghanaian Cedi","symbol_native":"GH₵","decimal_digits":2,"rounding":0,"value":"GHS","name_plural":"Ghanaian cedis"},{"symbol":"GTQ","name":"Guatemalan Quetzal","symbol_native":"Q","decimal_digits":2,"rounding":0,"value":"GTQ","name_plural":"Guatemalan quetzals"},{"symbol":"FG","name":"Guinean Franc","symbol_native":"FG","decimal_digits":0,"rounding":0,"value":"GNF","name_plural":"Guinean francs"},{"symbol":"HNL","name":"Honduran Lempira","symbol_native":"L","decimal_digits":2,"rounding":0,"value":"HNL","name_plural":"Honduran lempiras"},{"symbol":"HK$","name":"Hong Kong Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"HKD","name_plural":"Hong Kong dollars"},{"symbol":"Ft","name":"Hungarian Forint","symbol_native":"Ft","decimal_digits":0,"rounding":0,"value":"HUF","name_plural":"Hungarian forints"},{"symbol":"Ikr","name":"Icelandic Króna","symbol_native":"kr","decimal_digits":0,"rounding":0,"value":"ISK","name_plural":"Icelandic krónur"},{"symbol":"Rs","name":"Indian Rupee","symbol_native":"টকা","decimal_digits":2,"rounding":0,"value":"INR","name_plural":"Indian rupees"},{"symbol":"Rp","name":"Indonesian Rupiah","symbol_native":"Rp","decimal_digits":0,"rounding":0,"value":"IDR","name_plural":"Indonesian rupiahs"},{"symbol":"IRR","name":"Iranian Rial","symbol_native":"﷼","decimal_digits":0,"rounding":0,"value":"IRR","name_plural":"Iranian rials"},{"symbol":"IQD","name":"Iraqi Dinar","symbol_native":"د.ع.‏","decimal_digits":0,"rounding":0,"value":"IQD","name_plural":"Iraqi dinars"},{"symbol":"₪","name":"Israeli New Sheqel","symbol_native":"₪","decimal_digits":2,"rounding":0,"value":"ILS","name_plural":"Israeli new sheqels"},{"symbol":"J$","name":"Jamaican Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"JMD","name_plural":"Jamaican dollars"},{"symbol":"¥","name":"Japanese Yen","symbol_native":"￥","decimal_digits":0,"rounding":0,"value":"JPY","name_plural":"Japanese yen"},{"symbol":"JD","name":"Jordanian Dinar","symbol_native":"د.أ.‏","decimal_digits":3,"rounding":0,"value":"JOD","name_plural":"Jordanian dinars"},{"symbol":"KZT","name":"Kazakhstani Tenge","symbol_native":"тңг.","decimal_digits":2,"rounding":0,"value":"KZT","name_plural":"Kazakhstani tenges"},{"symbol":"Ksh","name":"Kenyan Shilling","symbol_native":"Ksh","decimal_digits":2,"rounding":0,"value":"KES","name_plural":"Kenyan shillings"},{"symbol":"KD","name":"Kuwaiti Dinar","symbol_native":"د.ك.‏","decimal_digits":3,"rounding":0,"value":"KWD","name_plural":"Kuwaiti dinars"},{"symbol":"Ls","name":"Latvian Lats","symbol_native":"Ls","decimal_digits":2,"rounding":0,"value":"LVL","name_plural":"Latvian lati"},{"symbol":"LB£","name":"Lebanese Pound","symbol_native":"ل.ل.‏","decimal_digits":0,"rounding":0,"value":"LBP","name_plural":"Lebanese pounds"},{"symbol":"LD","name":"Libyan Dinar","symbol_native":"د.ل.‏","decimal_digits":3,"rounding":0,"value":"LYD","name_plural":"Libyan dinars"},{"symbol":"Lt","name":"Lithuanian Litas","symbol_native":"Lt","decimal_digits":2,"rounding":0,"value":"LTL","name_plural":"Lithuanian litai"},{"symbol":"MOP$","name":"Macanese Pataca","symbol_native":"MOP$","decimal_digits":2,"rounding":0,"value":"MOP","name_plural":"Macanese patacas"},{"symbol":"MKD","name":"Macedonian Denar","symbol_native":"MKD","decimal_digits":2,"rounding":0,"value":"MKD","name_plural":"Macedonian denari"},{"symbol":"MGA","name":"Malagasy Ariary","symbol_native":"MGA","decimal_digits":0,"rounding":0,"value":"MGA","name_plural":"Malagasy Ariaries"},{"symbol":"RM","name":"Malaysian Ringgit","symbol_native":"RM","decimal_digits":2,"rounding":0,"value":"MYR","name_plural":"Malaysian ringgits"},{"symbol":"MURs","name":"Mauritian Rupee","symbol_native":"MURs","decimal_digits":0,"rounding":0,"value":"MUR","name_plural":"Mauritian rupees"},{"symbol":"MX$","name":"Mexican Peso","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"MXN","name_plural":"Mexican pesos"},{"symbol":"MDL","name":"Moldovan Leu","symbol_native":"MDL","decimal_digits":2,"rounding":0,"value":"MDL","name_plural":"Moldovan lei"},{"symbol":"MAD","name":"Moroccan Dirham","symbol_native":"د.م.‏","decimal_digits":2,"rounding":0,"value":"MAD","name_plural":"Moroccan dirhams"},{"symbol":"MTn","name":"Mozambican Metical","symbol_native":"MTn","decimal_digits":2,"rounding":0,"value":"MZN","name_plural":"Mozambican meticals"},{"symbol":"MMK","name":"Myanma Kyat","symbol_native":"K","decimal_digits":0,"rounding":0,"value":"MMK","name_plural":"Myanma kyats"},{"symbol":"N$","name":"Namibian Dollar","symbol_native":"N$","decimal_digits":2,"rounding":0,"value":"NAD","name_plural":"Namibian dollars"},{"symbol":"NPRs","name":"Nepalese Rupee","symbol_native":"नेरू","decimal_digits":2,"rounding":0,"value":"NPR","name_plural":"Nepalese rupees"},{"symbol":"NT$","name":"New Taiwan Dollar","symbol_native":"NT$","decimal_digits":2,"rounding":0,"value":"TWD","name_plural":"New Taiwan dollars"},{"symbol":"NZ$","name":"New Zealand Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"NZD","name_plural":"New Zealand dollars"},{"symbol":"C$","name":"Nicaraguan Córdoba","symbol_native":"C$","decimal_digits":2,"rounding":0,"value":"NIO","name_plural":"Nicaraguan córdobas"},{"symbol":"₦","name":"Nigerian Naira","symbol_native":"₦","decimal_digits":2,"rounding":0,"value":"NGN","name_plural":"Nigerian nairas"},{"symbol":"Nkr","name":"Norwegian Krone","symbol_native":"kr","decimal_digits":2,"rounding":0,"value":"NOK","name_plural":"Norwegian kroner"},{"symbol":"OMR","name":"Omani Rial","symbol_native":"ر.ع.‏","decimal_digits":3,"rounding":0,"value":"OMR","name_plural":"Omani rials"},{"symbol":"PKRs","name":"Pakistani Rupee","symbol_native":"₨","decimal_digits":0,"rounding":0,"value":"PKR","name_plural":"Pakistani rupees"},{"symbol":"B/.","name":"Panamanian Balboa","symbol_native":"B/.","decimal_digits":2,"rounding":0,"value":"PAB","name_plural":"Panamanian balboas"},{"symbol":"₲","name":"Paraguayan Guarani","symbol_native":"₲","decimal_digits":0,"rounding":0,"value":"PYG","name_plural":"Paraguayan guaranis"},{"symbol":"S/.","name":"Peruvian Nuevo Sol","symbol_native":"S/.","decimal_digits":2,"rounding":0,"value":"PEN","name_plural":"Peruvian nuevos soles"},{"symbol":"₱","name":"Philippine Peso","symbol_native":"₱","decimal_digits":2,"rounding":0,"value":"PHP","name_plural":"Philippine pesos"},{"symbol":"zł","name":"Polish Zloty","symbol_native":"zł","decimal_digits":2,"rounding":0,"value":"PLN","name_plural":"Polish zlotys"},{"symbol":"QR","name":"Qatari Rial","symbol_native":"ر.ق.‏","decimal_digits":2,"rounding":0,"value":"QAR","name_plural":"Qatari rials"},{"symbol":"RON","name":"Romanian Leu","symbol_native":"RON","decimal_digits":2,"rounding":0,"value":"RON","name_plural":"Romanian lei"},{"symbol":"RUB","name":"Russian Ruble","symbol_native":"руб.","decimal_digits":2,"rounding":0,"value":"RUB","name_plural":"Russian rubles"},{"symbol":"RWF","name":"Rwandan Franc","symbol_native":"FR","decimal_digits":0,"rounding":0,"value":"RWF","name_plural":"Rwandan francs"},{"symbol":"SR","name":"Saudi Riyal","symbol_native":"ر.س.‏","decimal_digits":2,"rounding":0,"value":"SAR","name_plural":"Saudi riyals"},{"symbol":"din.","name":"Serbian Dinar","symbol_native":"дин.","decimal_digits":0,"rounding":0,"value":"RSD","name_plural":"Serbian dinars"},{"symbol":"S$","name":"Singapore Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"SGD","name_plural":"Singapore dollars"},{"symbol":"Ssh","name":"Somali Shilling","symbol_native":"Ssh","decimal_digits":0,"rounding":0,"value":"SOS","name_plural":"Somali shillings"},{"symbol":"R","name":"South African Rand","symbol_native":"R","decimal_digits":2,"rounding":0,"value":"ZAR","name_plural":"South African rand"},{"symbol":"₩","name":"South Korean Won","symbol_native":"₩","decimal_digits":0,"rounding":0,"value":"KRW","name_plural":"South Korean won"},{"symbol":"SLRs","name":"Sri Lankan Rupee","symbol_native":"SL Re","decimal_digits":2,"rounding":0,"value":"LKR","name_plural":"Sri Lankan rupees"},{"symbol":"SDG","name":"Sudanese Pound","symbol_native":"SDG","decimal_digits":2,"rounding":0,"value":"SDG","name_plural":"Sudanese pounds"},{"symbol":"Skr","name":"Swedish Krona","symbol_native":"kr","decimal_digits":2,"rounding":0,"value":"SEK","name_plural":"Swedish kronor"},{"symbol":"CHF","name":"Swiss Franc","symbol_native":"CHF","decimal_digits":2,"rounding":0.05,"value":"CHF","name_plural":"Swiss francs"},{"symbol":"SY£","name":"Syrian Pound","symbol_native":"ل.س.‏","decimal_digits":0,"rounding":0,"value":"SYP","name_plural":"Syrian pounds"},{"symbol":"TSh","name":"Tanzanian Shilling","symbol_native":"TSh","decimal_digits":0,"rounding":0,"value":"TZS","name_plural":"Tanzanian shillings"},{"symbol":"฿","name":"Thai Baht","symbol_native":"฿","decimal_digits":2,"rounding":0,"value":"THB","name_plural":"Thai baht"},{"symbol":"T$","name":"Tongan Paʻanga","symbol_native":"T$","decimal_digits":2,"rounding":0,"value":"TOP","name_plural":"Tongan paʻanga"},{"symbol":"TT$","name":"Trinidad and Tobago Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"TTD","name_plural":"Trinidad and Tobago dollars"},{"symbol":"DT","name":"Tunisian Dinar","symbol_native":"د.ت.‏","decimal_digits":3,"rounding":0,"value":"TND","name_plural":"Tunisian dinars"},{"symbol":"TL","name":"Turkish Lira","symbol_native":"TL","decimal_digits":2,"rounding":0,"value":"TRY","name_plural":"Turkish Lira"},{"symbol":"USh","name":"Ugandan Shilling","symbol_native":"USh","decimal_digits":0,"rounding":0,"value":"UGX","name_plural":"Ugandan shillings"},{"symbol":"₴","name":"Ukrainian Hryvnia","symbol_native":"₴","decimal_digits":2,"rounding":0,"value":"UAH","name_plural":"Ukrainian hryvnias"},{"symbol":"AED","name":"United Arab Emirates Dirham","symbol_native":"د.إ.‏","decimal_digits":2,"rounding":0,"value":"AED","name_plural":"UAE dirhams"},{"symbol":"$U","name":"Uruguayan Peso","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"UYU","name_plural":"Uruguayan pesos"},{"symbol":"$","name":"US Dollar","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"USD","name_plural":"US dollars"},{"symbol":"UZS","name":"Uzbekistan Som","symbol_native":"UZS","decimal_digits":0,"rounding":0,"value":"UZS","name_plural":"Uzbekistan som"},{"symbol":"Bs.S","name":"Venezuelan bolívar soberano","symbol_native":"Bs.S","decimal_digits":2,"rounding":0,"value":"VES","name_plural":"Venezuelan bolívars"},{"symbol":"₫","name":"Vietnamese Dong","symbol_native":"₫","decimal_digits":0,"rounding":0,"value":"VND","name_plural":"Vietnamese dong"},{"symbol":"YR","name":"Yemeni Rial","symbol_native":"ر.ي.‏","decimal_digits":0,"rounding":0,"value":"YER","name_plural":"Yemeni rials"},{"symbol":"ZK","name":"Zambian Kwacha","symbol_native":"ZK","decimal_digits":0,"rounding":0,"value":"ZMK","name_plural":"Zambian kwachas"}]

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(289);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(15) && !__webpack_require__(29)(function () {
  return Object.defineProperty(__webpack_require__(148)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
var document = __webpack_require__(19).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(41);
var dPs = __webpack_require__(298);
var enumBugKeys = __webpack_require__(105);
var IE_PROTO = __webpack_require__(104)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(148)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(152).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(48);
var toIObject = __webpack_require__(36);
var arrayIndexOf = __webpack_require__(151)(false);
var IE_PROTO = __webpack_require__(104)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(36);
var toLength = __webpack_require__(30);
var toAbsoluteIndex = __webpack_require__(74);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(19).document;
module.exports = document && document.documentElement;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(73);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(41);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(55);
var ITERATOR = __webpack_require__(16)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(157);
var ITERATOR = __webpack_require__(16)('iterator');
var Iterators = __webpack_require__(55);
module.exports = __webpack_require__(35).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(73);
var TAG = __webpack_require__(16)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(16)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(54);
var toObject = __webpack_require__(20);
var IObject = __webpack_require__(72);
var toLength = __webpack_require__(30);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19);
var dP = __webpack_require__(27);
var DESCRIPTORS = __webpack_require__(15);
var SPECIES = __webpack_require__(16)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(56);
var step = __webpack_require__(162);
var Iterators = __webpack_require__(55);
var toIObject = __webpack_require__(36);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(100)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(157);
var test = {};
test[__webpack_require__(16)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(47)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(161);
var getKeys = __webpack_require__(103);
var redefine = __webpack_require__(47);
var global = __webpack_require__(19);
var hide = __webpack_require__(46);
var Iterators = __webpack_require__(55);
var wks = __webpack_require__(16);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(27).f;
var create = __webpack_require__(149);
var redefineAll = __webpack_require__(166);
var ctx = __webpack_require__(49);
var anInstance = __webpack_require__(167);
var forOf = __webpack_require__(168);
var $iterDefine = __webpack_require__(100);
var step = __webpack_require__(162);
var setSpecies = __webpack_require__(160);
var DESCRIPTORS = __webpack_require__(15);
var fastKey = __webpack_require__(169).fastKey;
var validate = __webpack_require__(109);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(47);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(49);
var call = __webpack_require__(154);
var isArrayIter = __webpack_require__(155);
var anObject = __webpack_require__(41);
var toLength = __webpack_require__(30);
var getIterFn = __webpack_require__(156);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(71)('meta');
var isObject = __webpack_require__(28);
var has = __webpack_require__(48);
var setDesc = __webpack_require__(27).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(29)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19);
var $export = __webpack_require__(5);
var redefine = __webpack_require__(47);
var redefineAll = __webpack_require__(166);
var meta = __webpack_require__(169);
var forOf = __webpack_require__(168);
var anInstance = __webpack_require__(167);
var isObject = __webpack_require__(28);
var fails = __webpack_require__(29);
var $iterDetect = __webpack_require__(158);
var setToStringTag = __webpack_require__(106);
var inheritIfRequired = __webpack_require__(325);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 171 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(15);
var getKeys = __webpack_require__(103);
var toIObject = __webpack_require__(36);
var isEnum = __webpack_require__(171).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BranchRequiredRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__coreui_icons_css_coreui_icons_min_css__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__coreui_icons_css_coreui_icons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__coreui_icons_css_coreui_icons_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flag_icon_css_css_flag_icon_min_css__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flag_icon_css_css_flag_icon_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_flag_icon_css_css_flag_icon_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_font_awesome_css_font_awesome_min_css__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_simple_line_icons_css_simple_line_icons_css__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_simple_line_icons_css_simple_line_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_simple_line_icons_css_simple_line_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_loader_spinner_dist_loader_css_react_spinner_loader_css__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_loader_spinner_dist_loader_css_react_spinner_loader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_loader_spinner_dist_loader_css_react_spinner_loader_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scss_style_css__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scss_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__scss_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scss_preloader_css__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scss_preloader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__scss_preloader_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_checkout_js__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Register_Confirmation_jsx__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Register_Confirmed_jsx__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Register_ConfirmedClient_jsx__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Register_InvalidateEmail_jsx__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_actions_initialState__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_actions_userActions__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__devexpress_dx_react_grid_bootstrap4_dist_dx_react_grid_bootstrap4_css__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__devexpress_dx_react_grid_bootstrap4_dist_dx_react_grid_bootstrap4_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__devexpress_dx_react_grid_bootstrap4_dist_dx_react_grid_bootstrap4_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_toastify__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_toastify_dist_ReactToastify_css__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_toastify_dist_ReactToastify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react_toastify_dist_ReactToastify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_toastify_dist_ReactToastify_min_css__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_toastify_dist_ReactToastify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_toastify_dist_ReactToastify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_ga__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react_ga__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// Styles
// CoreUI Icons Set
// Import Flag Icons Set
// Import Font Awesome Icons Set
// Import Simple Line Icons Set
// Import react-spinner-loader css
// Import Main styles for this application
__WEBPACK_IMPORTED_MODULE_23_react_ga___default.a.initialize('UA-85340412-2');__WEBPACK_IMPORTED_MODULE_23_react_ga___default.a.pageview(window.location.pathname+window.location.search);var PrivateRoute=function PrivateRoute(_ref){var Component=_ref.component,rest=_objectWithoutProperties(_ref,['component']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],Object.assign({},rest,{render:function render(props){return localStorage.getItem('user')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,props):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:{pathname:'/login',state:{from:props.location}}});}}));};var BranchRequiredRoute=Object(__WEBPACK_IMPORTED_MODULE_18_react_redux__["b" /* connect */])(function(_ref2){var branch=_ref2.branch;return{branch:branch};})(function(_ref3){var Component=_ref3.component,rest=_objectWithoutProperties(_ref3,['component']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],Object.assign({},rest,{render:function render(props){var user=localStorage.getItem('user');if(user){if(rest.branch&&Object.keys(rest.branch).length>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,props);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'d-flex justify-content-center align-items-center flex-grow-1 text-center mt-4'},'Selecciona un comercio');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:{pathname:'/login',state:{from:props.location}}});}}));});var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.handlePositionChange=function(event){_this.setState({defaultNotiPosition:event.detail.position});};props.getCompany();_this.state={defaultNotiPosition:localStorage.getItem("notiPosition")||"BOTTOM_RIGHT"};if(localStorage.getItem('user'))Object(__WEBPACK_IMPORTED_MODULE_17__store_actions_userActions__["k" /* scheduleTokenRenewal */])();return _this;}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('notificationPositionChange',this.handlePositionChange);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('notificationPositionChange',this.handlePositionChange);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps&&prevProps.color_accent!==this.props.color_accent){document.documentElement.style.setProperty('--primary',this.props.color_accent);document.documentElement.style.setProperty('--info',this.props.color_accent);}if(this.props.isZupper){document.documentElement.style.setProperty('--light','#2f353a');document.documentElement.style.setProperty('--dark','#f0f3f5');}else{document.documentElement.style.setProperty('--light','#FFF');}}},{key:'render',value:function render(){if(this.props.company.id===''){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-loader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'preloader pls-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'pl-circular',viewBox:'25 25 50 50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{className:'plc-path',cx:50,cy:50,r:20})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.json_lang.common.waiting_message)));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_toastify__["ToastContainer"],{position:__WEBPACK_IMPORTED_MODULE_20_react_toastify__["toast"].POSITION[this.state.defaultNotiPosition],transition:__WEBPACK_IMPORTED_MODULE_20_react_toastify__["Slide"],toastClassName:'noti_container',autoClose:3500,limit:2,hideProgressBar:true,newestOnTop:false,draggable:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/login',name:'Login Page',component:__WEBPACK_IMPORTED_MODULE_10__views__["b" /* Login */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/register',name:'Register Page',component:__WEBPACK_IMPORTED_MODULE_10__views__["f" /* Register */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/confirmation/:id/:token',name:'Confirmation User Register',component:__WEBPACK_IMPORTED_MODULE_12__views_Register_Confirmation_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/confirmed',name:'Usuario confirmado',component:__WEBPACK_IMPORTED_MODULE_13__views_Register_Confirmed_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/confirmed-client',name:'Usuario confirmado',component:__WEBPACK_IMPORTED_MODULE_14__views_Register_ConfirmedClient_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/invalidate/:id/:token',name:'Confirmation User Register',component:__WEBPACK_IMPORTED_MODULE_15__views_Register_InvalidateEmail_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/password-reset',name:'Reset Password',component:__WEBPACK_IMPORTED_MODULE_10__views__["a" /* Email */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/recover/:id/:token',name:'Reset Password',component:__WEBPACK_IMPORTED_MODULE_10__views__["e" /* Password */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/checkout/:id',name:'Checkout',component:__WEBPACK_IMPORTED_MODULE_11__views_checkout_js__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/404',name:'Page 404',component:__WEBPACK_IMPORTED_MODULE_10__views__["c" /* Page404 */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/500',name:'Page 500',component:__WEBPACK_IMPORTED_MODULE_10__views__["d" /* Page500 */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{path:'/',component:__WEBPACK_IMPORTED_MODULE_9__containers__["a" /* DefaultLayout */]}))));}}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var zupper=false;if(state.company){if(state.company.id===7||state.company.id===120){zupper=true;}}return{errors:state.errors,session:state.session,company:state.company,json_lang:state.json_lang,color_accent:state.company_styles_json&&state.company_styles_json.color_accent,isZupper:zupper};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getCompany:function getCompany(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_16__store_actions_initialState__["a" /* getCompany */])());}};};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_18_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(App));

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule warning
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(50);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(179);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(116);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(359)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__coreui_react__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_userActions__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actions_chatActions_js__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__navOwner_es__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__navOwner_en__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__navSuper_en__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__navSuper_es__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__nav_es__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__nav_en__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__routes__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CustomSidebar__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_actions_orderActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DefaultAside__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DefaultFooter__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__DefaultHeader__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__push_notification_js__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__handlers_Notification__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store_actions_notificationsActions__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__store_actions_goodsActions__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__store_actions_companyActions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__store_actions_providerActions__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__constants_bitwiseOperations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__store_actions_UtilsOperation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__constants_general__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_moment__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Breadcrumb__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__App__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__api_ondemand_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__utils_debouncer_js__ = __webpack_require__(89);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import {GeneralErrors} from '../../views/Errors/GeneralErrors';
// sidebar nav config
// routes config
//import { getStyle } from '@coreui/coreui/dist/js/coreui-utilities';
//import { keyboardHotkeys } from '../../handlers/utils';
//import { debug } from 'util';
//const brandPrimary = getStyle('--primary')
var DefaultLayout=function(_Component){_inherits(DefaultLayout,_Component);function DefaultLayout(props){var _this2=this;_classCallCheck(this,DefaultLayout);var _this=_possibleConstructorReturn(this,(DefaultLayout.__proto__||Object.getPrototypeOf(DefaultLayout)).call(this,props));_this.debouncer=new __WEBPACK_IMPORTED_MODULE_35__utils_debouncer_js__["a" /* Debouncer */](5000);_this.updateFromServerNotification=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(push){var enableNotification,host_url,payload,notification,res,PAYLOAD,orderFromProviderDetails,notificationOptions,_payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:enableNotification=JSON.parse(localStorage.getItem("enableNotification"));if(enableNotification===null||enableNotification===undefined){enableNotification=true;}// via sockets
// si el admin tiene perfil tipo "Gerente Comercial" o "Reportes"
if(!(_this.props.admin_type&&(_this.props.admin_type.id===9||_this.props.admin_type.id===10))){_context.next=4;break;}return _context.abrupt('return');case 4:host_url=window.location.href;_context.t0=push.event;_context.next=_context.t0==="notification"?8:_context.t0==="data_updated"?18:33;break;case 8:payload={data:push};notification={title:"",msg:"",url:"",type:push.action+push.type,storeKey:"",operation:"",update:push.data,touchedPropsToReplace:[]};_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_21__push_notification_js__["a" /* notificationOptionSetting */])(payload,push.data,notification,_this.props.session);case 12:res=_context.sent;PAYLOAD=payload&&payload.data||payload;orderFromProviderDetails=_this.props.providerOrders;if(PAYLOAD.type==='order_provider'){if(orderFromProviderDetails&&orderFromProviderDetails.data){_this.props.updateProviderOrder(PAYLOAD);}}// if(host_url.indexOf("goods-management") !== -1){
// 	this.props.isUploadingExcel();
// 	if(push.action==="completed"){
// 		Notification.show({ type: "success", title:"¡Éxito!", msg:"Carga de documento completada" });
// 	}
// }
if(res){notification=Object.assign({},res);notification.title=notification.title+' - '+_this.props.company.name;if(host_url.indexOf("order-management")!==-1){if(notification.update.id===parseInt(host_url.split("/").pop(),10)){_this.props.updateOrderView(notification.update);}// else if(notification.type === "neworder" || notification.type === "assignedorder"){
else{if(PAYLOAD.type==="order"){_this.props.updateOrdersView(notification.update,notification.type);}if(PAYLOAD.action==="in_service_changed"&&PAYLOAD.type==="branch"){_this.props.updateBranch(notification.update);}}}if(notification.operation==="notification-only"){// cuando la notificacion viene de un comercio distinto y soy tipo owner, solo muestrame la notificacion pero no actualices listado de ordenes en el store
notification.update=null;}if(PAYLOAD.type==="pending_action"){_this.props.updatePendingActionFromNotification(notification.update);}if(enableNotification){_this.props.appendNotificationToSidebar(notification);_this.props.showNotificationForPushEvent();// this.props.fetchTodayOrders();
notificationOptions={type:"push",title:notification.title,msg:notification.msg,url:notification.url,sound:notification.sound};if(notification.sticky){notificationOptions.type="sticky-push";notificationOptions.config={/*autoClose: false*/autoClose:30000};}__WEBPACK_IMPORTED_MODULE_22__handlers_Notification__["a" /* default */].show(notificationOptions);}}return _context.abrupt('break',34);case 18:_context.t1=push.type;_context.next=_context.t1==="chat_message"?21:_context.t1==="provider"?25:_context.t1==="report_history"?27:_context.t1==="general_invoice"?29:31;break;case 21:_payload=push.data;_this.props.handleNewMessages(_payload,push.action);if(push.action==="new"){_this.props.messageActions(_payload.id,"delivered");}return _context.abrupt('break',32);case 25:if(push.action==="partial_update"){_this.props.updateProviderGeolocation(push.data);localStorage.setItem("providerGeolocationMoved",true);}return _context.abrupt('break',32);case 27:_this.props.updateReportHistories(push.data);return _context.abrupt('break',32);case 29:if(push.action==="new"){_this.debouncer.delay(function(){window.dispatchEvent(new CustomEvent("updateGeneralInvoices",{detail:{type:"new",data:push.data}}));});}else if(push.action==="changed"){_this.props.updateGeneralInvoice(push.data);}// this.props.updateReportHistories(push.data);
return _context.abrupt('break',32);case 31:return _context.abrupt('break',32);case 32:return _context.abrupt('break',34);case 33:return _context.abrupt('break',34);case 34:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.translatedRoutes=function(routesList){var _this3=this;return routesList.map(function(r){r.name=_this3.props.json_lang.common[r.lang_key];return r;},this);};_this.filterOutMapForNotDeliveryCompanies=function(lista){if(_this.props.session&&_this.props.session.admin_type&&_this.props.session.admin_type.id===12){lista.items.push({lang_key:"map",name:"Mapa",icon:"icon-bag",url:"/map"});}//if(parseInt(this.props.defaultDashboard,10)&(512|(512<<12)) !== 0){  // condicion que cumple si es delivery
if((parseInt(_this.props.defaultDashboard,10)&(768|768<<12))===(768|768<<12)){// condicion que cumple si es pickup
return{items:lista.items.filter(function(elm){return elm.lang_key!=="map";}),visibles:['map']};}else return Object.assign({},lista,{visibles:['map','dashboard']});};_this.handleAccesses=function(list,type){var admin_type=_this.props.admin_type;var data={};if(type===__WEBPACK_IMPORTED_MODULE_28__constants_bitwiseOperations__["y" /* SUPER_ADMIN */]){data={items:[].concat(_toConsumableArray(list.items))};}else{data={items:list.items.map(function(nav){if(nav.children){var filteredChildren=nav.children.filter(function(child){return child.type<__WEBPACK_IMPORTED_MODULE_28__constants_bitwiseOperations__["y" /* SUPER_ADMIN */];});if(filteredChildren.length>0){return Object.assign({},nav,{children:filteredChildren});}}else if(nav.type<__WEBPACK_IMPORTED_MODULE_28__constants_bitwiseOperations__["y" /* SUPER_ADMIN */]){return nav;}}).filter(function(nav){return nav!==undefined;})};}var visibles=null;if(admin_type){var filteredRoles=[];if(admin_type.roles.length!==0){filteredRoles=admin_type.roles.filter(function(role){return role.role.startsWith('access');});}// TODO borrar cuando no sea necesaria esta condicion
if(filteredRoles.length===0){var _data={items:list.items.filter(function(elm){return elm.lang_key!=="categories"&&elm.lang_key!=="company_settings"&&elm.lang_key!=="attributes"&&elm.lang_key!=="goods"&&elm.lang_key!=="eta"&&elm.lang_key!=='Branch dashboard';})};var _visibles=[];if(_this.props.branch&&_this.props.branch.id){_data={items:list.items.filter(function(elm){return elm.lang_key!=="company_settings";}/*&& (elm.lang_key !== 'Branch dashboard')*/)};_visibles=['','company_settings'];}if(_this.props.session&&_this.props.session.admin_type&&_this.props.session.admin_type.id===3){_data={items:list.items.filter(function(elm){return elm.lang_key!=="providers"&&elm.lang_key!=='promo'&&elm.lang_key!=='coupons'&&elm.lang_key!=='push_notification'&&elm.lang_key!=='banners'&&elm.lang_key!=="branchs"&&elm.lang_key!=="admins"&&elm.lang_key!=="company"&&elm.lang_key!=="map"&&/*(elm.lang_key !== "dashboard") &&*/elm.lang_key!=="settings"&&elm.lang_key!=="categories"&&elm.lang_key!=="company_settings"&&elm.lang_key!=="attributes"&&elm.lang_key!=="goods"&&elm.lang_key!=="featured_products"&&elm.lang_key!=="section"&&elm.lang_key!=="eta"&&elm.lang_key!=="branches"&&elm.url!=="/company-billings"&&// importante
elm.lang_key!=="reports"&&//(elm.lang_key !== "billing") &&
elm.lang_key!=='Branch dashboard'&&elm.lang_key!=="clients";})};_visibles=['','providers','promo','coupons','push_notification','banners',"branchs","admins","categories","company_settings","attributes","goods","featured_products","section","eta","branches","reports"];}if(_this.props.session&&_this.props.session.admin_type&&_this.props.session.admin_type.id===4){_data={items:list.items.filter(function(elm){return elm.lang_key!=="branchs"&&elm.lang_key!=='promo'&&elm.lang_key!=='coupons'&&elm.lang_key!=='push_notification'&&elm.lang_key!=='banners'&&elm.lang_key!=="admins"&&elm.lang_key!=="company"&&elm.lang_key!=="dashboard"&&elm.lang_key!=="billing"&&elm.lang_key!=="settings"&&elm.lang_key!=="categories"&&elm.lang_key!=="company_settings"&&elm.lang_key!=="attributes"&&elm.lang_key!=="goods"&&elm.lang_key!=='Branch dashboard'&&elm.lang_key!=="clients";})};}if(_this.props.session&&_this.props.session.admin_type&&_this.props.session.admin_type.id===5){_data={items:list.items.filter(function(elm){return elm.lang_key!=="billing"&&elm.lang_key!=='Branch dashboard'&&elm.lang_key!=='dashboard';})};if(!(_this.props.branch&&_this.props.branch.id)){_data={items:list.items.filter(function(elm){return elm.lang_key!=="attributes"&&elm.lang_key!=="goods"&&elm.lang_key!=="categories"&&elm.lang_key!=="billing"&&elm.lang_key!=="clients"&&//(elm.lang_key !== 'company') &&
//(elm.lang_key !== "branchs") &&
elm.lang_key!=='Branch dashboard'&&elm.lang_key!=='dashboard';})};}_visibles=['',"categories","goods","attributes","eta","branches","Roles","admins","providers","Notificaciones masivas","section","promo","branchs-groups","banners","coupons","featured-products","notifications"];}if(_this.props.session&&_this.props.session.admin_type&&_this.props.session.admin_type.id===6){_data={items:list.items.filter(function(elm){return elm.lang_key!=='promo'&&elm.lang_key!=="billing"&&elm.lang_key!=='reports'&&elm.lang_key!=='coupons'&&elm.lang_key!=='push_notification'&&elm.lang_key!=='banners'&&elm.lang_key!=="branchs"&&elm.lang_key!=="admins"&&elm.lang_key!=="company"&&elm.lang_key!=="map"&&elm.lang_key!=="dashboard"&&elm.lang_key!=="settings"&&elm.lang_key!=="categories"&&elm.lang_key!=="company_settings"&&elm.lang_key!=="attributes"&&elm.lang_key!=="goods"&&elm.lang_key!=='Branch dashboard'&&elm.lang_key!=="clients";})};}if(_this.props.session&&_this.props.session.admin_type&&_this.props.session.admin_type.id===7){_data={items:list.items.filter(function(elm){return elm.lang_key!=='promo'&&elm.lang_key!=="billing"&&elm.lang_key!=='coupons'&&elm.lang_key!=='push_notification'&&elm.lang_key!=='banners'&&elm.lang_key!=="branchs"&&elm.lang_key!=="admins"&&elm.lang_key!=="company"&&elm.lang_key!=="settings"&&elm.lang_key!=="categories"&&elm.lang_key!=="company_settings"&&elm.lang_key!=="attributes"&&elm.lang_key!=="goods"&&elm.lang_key!=='Branch dashboard'&&elm.lang_key!=="clients";})};}if(_this.props.session&&_this.props.session.admin_type&&_this.props.session.admin_type.id===8){_data={items:list.items.filter(function(elm){return elm.lang_key!=='promo'&&elm.lang_key!=='map'&&elm.lang_key!=='providers'&&elm.lang_key!=='dashboard'&&elm.lang_key!=="billing"&&elm.lang_key!=='coupons'&&elm.lang_key!=='push_notification'&&elm.lang_key!=='banners'&&elm.lang_key!=="branchs"&&elm.lang_key!=="admins"&&elm.lang_key!=="company"&&elm.lang_key!=="settings"&&elm.lang_key!=="categories"&&elm.lang_key!=="company_settings"&&elm.lang_key!=="attributes"&&elm.lang_key!=="goods"&&elm.lang_key!=='Branch dashboard'&&elm.lang_key!=="clients";})};}if(_this.props.session&&_this.props.session.admin_type&&_this.props.session.admin_type.id===9){_data={items:list.items.filter(function(elm){return elm.lang_key!=='orders'&&elm.lang_key!=='promo'&&elm.lang_key!=='map'&&elm.lang_key!=='providers'&&elm.lang_key!=="billing"&&elm.lang_key!=='coupons'&&elm.lang_key!=='push_notification'&&elm.lang_key!=='banners'&&elm.lang_key!=="branchs"&&elm.lang_key!=="admins"&&elm.lang_key!=="company"&&elm.lang_key!=="settings"&&elm.lang_key!=="categories"&&elm.lang_key!=="company_settings"&&elm.lang_key!=="attributes"&&elm.lang_key!=="goods"&&elm.lang_key!=='Branch dashboard'&&elm.lang_key!=="clients";})};}if(_this.props.session&&_this.props.session.admin_type&&_this.props.session.admin_type.id===10){_data={items:list.items.filter(function(elm){return elm.lang_key!=='dashboard'&&elm.lang_key!=='orders'&&elm.lang_key!=='promo'&&elm.lang_key!=='map'&&elm.lang_key!=='providers'&&elm.lang_key!=="billing"&&elm.lang_key!=='coupons'&&elm.lang_key!=='push_notification'&&elm.lang_key!=='banners'&&elm.lang_key!=="branchs"&&elm.lang_key!=="admins"&&elm.lang_key!=="company"&&elm.lang_key!=="settings"&&elm.lang_key!=="categories"&&elm.lang_key!=="company_settings"&&elm.lang_key!=="attributes"&&elm.lang_key!=="goods"&&elm.lang_key!=='Branch dashboard'&&elm.lang_key!=="clients";})};}if(_this.props.session&&_this.props.session.admin_type&&_this.props.session.admin_type.id===12){_data={items:list.items.filter(function(elm){return elm.lang_key!=="providers"&&elm.lang_key!=='promo'&&elm.lang_key!=='coupons'&&elm.lang_key!=='push_notification'&&elm.lang_key!=='banners'&&elm.lang_key!=="branchs"&&elm.lang_key!=="admins"&&elm.lang_key!=="company"&&elm.lang_key!=="settings"&&elm.lang_key!=="categories"&&elm.lang_key!=="company_settings"&&elm.lang_key!=="attributes"&&elm.lang_key!=="goods"&&elm.lang_key!=="featured_products"&&elm.lang_key!=="section"&&elm.lang_key!=="eta"&&elm.lang_key!=="branches"&&elm.url!=="/company-billings"&&elm.lang_key!=="reports"&&elm.lang_key!=='Branch dashboard'&&elm.lang_key!=="clients";})};_visibles=["","map","coupons","promo","branchs","attributes","goods","branches"];}if(_this.props.isZupper){_data={items:list.items.filter(function(elm){return elm.lang_key!=='branches'&&elm.lang_key!=='Branch dashboard';})};}return Object.assign({},_data,{visibles:_this.props.session&&_this.props.session.admin_type&&_this.props.session.admin_type.id?_visibles:null});}var filteredList=filteredRoles.map(function(role){var splitUrl=role.role.split('_');return{url:splitUrl[1]};});data={items:data.items.filter(function(item){var urlToCheck=_this.findUrl(item,filteredList);return filteredList.some(function(filtered){return filtered.url===urlToCheck;});})};data.items.map(function(item,index){if(item.children){var newChildData=item.children.filter(function(child){var splitChildUrl=child.url.split('/')[1];return filteredList.some(function(filtered){return filtered.url===splitChildUrl;});});data.items[index]=Object.assign({},item,{children:newChildData});}});}return Object.assign({},data,{visibles:visibles});};_this.state={visible:true,notification_requirement:true,alert_int_service:true};if(Object.keys(_this.props.company).length===0&&_this.props.company.constructor===Object){_this.props.fetchCompany();}_this.sidebarMinimizer=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();return _this;}_createClass(DefaultLayout,[{key:'componentDidMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_userActions__["o" /* socketteInit */])(this.props.company.id,this.updateFromServerNotification);case 2://let retries = localStorage.getItem("pubnubRetries") || 0;
/*this.pubnub.addListener({
			message: (message) => this.updateFromServerNotification(message.message),
			status: function(statusEvent) {
				if (retries > 3) {
					//this.props.logout();
					return;
				}
				else {
					switch (statusEvent.category) {

						// Conexion estable con Pubnub
						case "PNNetworkUpCategory":
						case "PNReconnectedCategory":
						case "PNConnectedCategory":
							localStorage.setItem("pubnubRetries", 0);
							break;

						// ERROR de conexion con Pubnub
						case "PNAccessDeniedCategory":
							/*Notification.show({
								type: "warning",
								title: "Nuevo inicio sesión detectado",
								msg: "Ha iniciado sesión en otro equipo, por seguridad invalidaremos la sesión en este equipo"
							});* /
							/*setTimeout(function() {
								this.props.logout();
							}.bind(this), 10000);* /
							break;

						case "PNNetworkDownCategory":
						case "PNNetworkIssuesCategory":
						case "PNTimeoutCategory":
						default:
							if (retries === 1){
								Notification.show({
									type: "warning",
									title: "Hubo problemas para conectar",
									msg: "Intentaremos renovar automáticamente. Por favor espere"
								});
							}

							setTimeout(function() {
								localStorage.setItem("pubnubRetries", retries++);
								//forceRenewPubnubToken(this.props.company.id);
								this.pubnub.init(this)
								retries++;
							}.bind(this), 10000);
							break;
					}
				}
			}.bind(this)
		});

		if ( (this.props.session && this.props.session.account_id) && ( this.props.company && this.props.company.id ) ) {
			let allowedChannels = [
				`private-${ this.props.session.account_id }`
			]
			// cuando hay muchos accesos pubnub limita a 200 la cantidad de canales por subscripcion
			let i, j, chunk = 200;

			if( this.props.userHigherAccess === COMPANY_ACCESS ){
				allowedChannels.push(...[
					`group-${ this.props.company.id }-admins`
					//`group-${ this.props.company.id }-tracking`
				])
			}
			else if (this.props.userHigherAccess === BRANCH_GROUPS_ACCESS) {
				this.props.session.accesses.forEach(access => {
					if(access.access_type === "branch"){


						allowedChannels.push(`branch-${ access.access_id }-admins`);
					}
					else if(access.access_type === "branch_group"){
						allowedChannels.push(`branch-group-${ access.access_id }-admins`);
					}
				})
			}
			else if (this.props.userHigherAccess === BRANCH_ACCESS) {
				this.props.session.accesses.forEach(access => {
					if (access.access_type === "branch") {
						allowedChannels.push(`branch-${ access.access_id }-admins`);
					}
				})
			}

			for (i = 0, j = allowedChannels.length; i < j; i += chunk) {
				let _200channels = allowedChannels.slice(i, i + chunk);
				/*this.pubnub.subscribe({
					channels: _200channels
				});* /
			}
		}

		/*var x = document.getElementsByClassName("nav-icon");
		var i;
		for (i = 0; i < x.length; i++) {
		    x[i].style.color = this.props.icon_color;//brandPrimary//
		}*/// TODO: activar para las ordenes
// window.addEventListener("keydown", keyboardHotkeys.bind(this), false);
__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this.sidebarMinimizer.current).addEventListener('click',this.handleMinimizerToggling.bind(this));case 3:case'end':return _context2.stop();}}},_callee2,this);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()},{key:'componentWillUnmount',value:function componentWillUnmount(){//window.removeEventListener("keydown", keyboardHotkeys.bind(this), false);
__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this.sidebarMinimizer.current).removeEventListener('click',this.handleMinimizerToggling.bind(this));/*this.pubnub.unsubscribe({
			channels: ["notifications-"+this.props.session.account_id]
		});*/}},{key:'handleMinimizerToggling',value:function handleMinimizerToggling(target){// hides the miniture picture of company logo
// when its clicked it still needs time to end rendering the component with the class to find, thats why I use false if its found
if(target.currentTarget.id==="sidebar-minimizer")if(!document.getElementsByTagName('sidebar-minimized').length)document.getElementById('company-logo-admin').classList.toggle('d-none');}},{key:'findUrl',value:function findUrl(item,filteredList){if(item.url){var splitListUrl=item.url.split('/');return splitListUrl[1];}else if(item.children&&Array.isArray(item.children)){if(filteredList){var childUrl=item.children.find(function(child){return filteredList.some(function(url){return url.url===child.url.split('/')[1];});});return childUrl?childUrl.url.split('/')[1]:null;}else{var _childUrl=item.children.map(function(child){return child.url.split('/')[1];});return _childUrl;}}return null;}},{key:'handleCloseCustomSidebar',value:function handleCloseCustomSidebar(){if(document.body.classList.contains('sidebar-show')){document.body.classList.remove('sidebar-show');}}},{key:'render',value:function render(){var _this4=this;if(!this.props.session){this.props.history.push('/login');}var routes,adminNavigation,hasEnglishEnabled=this.props.lang_code&&this.props.lang_code==='en';var navList=hasEnglishEnabled?__WEBPACK_IMPORTED_MODULE_10__navOwner_en__["a" /* default */]:__WEBPACK_IMPORTED_MODULE_9__navOwner_es__["a" /* default */];switch(this.props.session&&this.props.session.account&&this.props.session.account.type){case __WEBPACK_IMPORTED_MODULE_28__constants_bitwiseOperations__["c" /* ADMIN_LOW */]:routes=__WEBPACK_IMPORTED_MODULE_15__routes__["a" /* routesHigh */];adminNavigation=this.handleAccesses(navList,__WEBPACK_IMPORTED_MODULE_28__constants_bitwiseOperations__["c" /* ADMIN_LOW */]);break;case __WEBPACK_IMPORTED_MODULE_28__constants_bitwiseOperations__["b" /* ADMIN_HIGH */]:routes=__WEBPACK_IMPORTED_MODULE_15__routes__["a" /* routesHigh */];adminNavigation=this.handleAccesses(navList,__WEBPACK_IMPORTED_MODULE_28__constants_bitwiseOperations__["b" /* ADMIN_HIGH */]);break;case __WEBPACK_IMPORTED_MODULE_28__constants_bitwiseOperations__["d" /* ADMIN_OWNER */]:routes=__WEBPACK_IMPORTED_MODULE_15__routes__["a" /* routesHigh */];adminNavigation=this.handleAccesses(navList,__WEBPACK_IMPORTED_MODULE_28__constants_bitwiseOperations__["d" /* ADMIN_OWNER */]);break;case __WEBPACK_IMPORTED_MODULE_28__constants_bitwiseOperations__["y" /* SUPER_ADMIN */]:routes=__WEBPACK_IMPORTED_MODULE_15__routes__["a" /* routesHigh */];adminNavigation=this.handleAccesses(navList,__WEBPACK_IMPORTED_MODULE_28__constants_bitwiseOperations__["y" /* SUPER_ADMIN */]);break;default:routes=__WEBPACK_IMPORTED_MODULE_15__routes__["b" /* routesLow */];adminNavigation=this.filterOutMapForNotDeliveryCompanies(hasEnglishEnabled?__WEBPACK_IMPORTED_MODULE_14__nav_en__["a" /* default */]:__WEBPACK_IMPORTED_MODULE_13__nav_es__["a" /* default */]);break;}var transRoutes=this.translatedRoutes(routes);var now=Object(__WEBPACK_IMPORTED_MODULE_29__store_actions_UtilsOperation__["M" /* utcDateFormat */])(undefined,"YYYY/MM/DD");var trial_date=0;var subscription="";var endDate=0;if(this.props.company&&this.props.company.custom_json&&this.props.company.custom_json.subscription&&this.props.company.custom_json.subscription.current_period_end){subscription=this.props.company&&this.props.company.custom_json&&this.props.company.custom_json.subscription;trial_date=__WEBPACK_IMPORTED_MODULE_31_moment___default()(Object(__WEBPACK_IMPORTED_MODULE_29__store_actions_UtilsOperation__["M" /* utcDateFormat */])(subscription.current_period_end,"YYYY/MM/DD"));endDate=trial_date.diff(now,"days");}var logo_link='/dashboard';if(this.props.session.admin_type){var adminType=this.props.session.admin_type;var filteredUrl=[];if(this.props.branch&&this.props.branch.id){adminNavigation.items.map(function(nav){filteredUrl=[].concat(_toConsumableArray(filteredUrl),[_this4.findUrl(nav)]);});}else{adminNavigation.items.filter(function(filter){return filter.lang_key!=="inventory";}).map(function(nav){filteredUrl=[].concat(_toConsumableArray(filteredUrl),[_this4.findUrl(nav)]);});}var findUrl=filteredUrl.find(function(url){if(Array.isArray(url)){return url.some(function(someUrl){return someUrl===adminType.default_key;});}else{return url===adminType.default_key;}});if(findUrl){logo_link='/'+adminType.default_key;}else{if(Array.isArray(filteredUrl[0])){logo_link='/'+filteredUrl[0][0];}else{logo_link='/'+filteredUrl[0];}}}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'app'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__coreui_react__["d" /* AppHeader */],{fixed:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__DefaultHeader__["a" /* default */],{handleCloseCustomSidebar:this.handleCloseCustomSidebar,logoLink:logo_link})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'app-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__coreui_react__["g" /* AppSidebar */],{fixed:true,display:'lg'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__coreui_react__["j" /* AppSidebarHeader */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__coreui_react__["i" /* AppSidebarForm */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__CustomSidebar__["a" /* default */],Object.assign({navConfig:adminNavigation},this.props)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__coreui_react__["h" /* AppSidebarFooter */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__coreui_react__["k" /* AppSidebarMinimizer */],{id:'sidebar-minimizer',ref:this.sidebarMinimizer})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('main',{className:'main',onClick:function onClick(){return _this4.handleCloseCustomSidebar();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'two-steps-verification'}),this.state.alert_int_service===true&&this.props.company&&this.props.company.in_service===false&&!this.props.company.in_service2?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["Alert"],{color:'warning m-0 text-center'},this.props.json_lang.common.alert_int_service):null,this.props.company&&this.props.company.phone&&this.props.company.phone===null?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["Alert"],{color:'warning m-0 text-center'},this.props.json_lang.common.alert_no_phone_company):null,subscription&&subscription.status==='trialing'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactstrap__["Alert"],{color:endDate<0?"danger":"info",className:'m-0 text-center'},endDate<0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,this.props.json_lang.common.trial.toUpperCase()+' '+this.props.json_lang.common.expired),', ',this.props.json_lang.common.trial_description_fail.toLowerCase(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_27__config_js__["e" /* loginBuilder */]+'login?user='+this.props.session.email,target:'_blank',className:'ml-2'},this.props.json_lang.common.verify)):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,endDate===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,this.props.json_lang.common.trial.toUpperCase()+' disponible hasta hoy'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,this.props.json_lang.common.trial.toUpperCase()+' '+this.props.json_lang.common.available_by.toLowerCase()+' '+endDate+' '+this.props.json_lang.common.days.toLowerCase()),', ',this.props.json_lang.common.trial_description.toLowerCase(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_27__config_js__["e" /* loginBuilder */]+'login?user='+this.props.session.email,target:'_blank',className:'btn btn-success btn-large ml-2'},this.props.json_lang.common.ativate_now))):null,this.props.location.pathname==='/map'||this.props.location.pathname==='/dashboard'?/*|| (this.props.admin_type && (
							this.props.admin_type.id === 10 || this.props.admin_type.id === 3 || this.props.admin_type.id === 2 || this.props.admin_type.id === 1 ||
							this.props.admin_type.id === 10 || this.props.admin_type.id === 3 || this.props.admin_type.id === 2 || this.props.admin_type.id === 1 ||
							this.props.admin_type.id === 4 || this.props.admin_type.id === 6 || this.props.admin_type.id === 8 || this.props.admin_type.id === 9 ||
							this.props.admin_type.id === 7 ))*/null:// <AppBreadcrumb appRoutes={transRoutes}/>
__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__components_Breadcrumb__["a" /* default */],{routes:transRoutes,session:this.props.session}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* Switch */],null,routes.map(function(route,key){return route.component?route.requiresAdmin&&!_this4.props.session.is_admin?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Redirect */],{key:key,from:'/',to:logo_link}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */],{key:key,path:route.path,exact:route.exact,name:route.name,render:function render(props){if(route.branchRequired)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__App__["a" /* BranchRequiredRoute */],{component:route.component});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(route.component,Object.assign({},props,{title:route.name}));}}):null;}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Redirect */],{from:'/',to:logo_link})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__coreui_react__["a" /* AppAside */],{fixed:true,style:{overflowY:"auto"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__DefaultAside__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__coreui_react__["c" /* AppFooter */],null,"DEV".toUpperCase()!=='PRODUCTION'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'env-warning'},"DEV",' '):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__DefaultFooter__["a" /* default */],null)));}}]);return DefaultLayout;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var zupper=false;if(state.company){if(state.company.id===7||state.company.id===120){zupper=true;}}return{isZupper:zupper,company:state.company,session:state.session,errors:state.errors,user:state.user,//providers: state.providers,
provider:state.providers,mapFilters:state.mapFilters,notificationPushEvent:state.notificationPushEvent,notifications:state.notifications,defaultDashboard:state.company.options,lang_code:state.lang_code,json_lang:state.json_lang,icon_color:state.company_styles_json.color_accent,userHigherAccess:state.userHigherAccess,branch:state.branch,admin_type:state.session&&state.session.admin_type,admin_account_type:state.session&&state.session.account&&state.session.account.type,showNotification:state.showNotification,providerOrders:state.providerOrders};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{logout:function logout(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_userActions__["i" /* logout */])());},updateOrderView:function updateOrderView(order){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__store_actions_orderActions__["_44" /* updateOrderView */])(order));},updateOrdersView:function updateOrdersView(new_order,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__store_actions_orderActions__["_45" /* updateOrdersView */])(new_order,type));},showNotificationForPushEvent:function showNotificationForPushEvent(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__store_actions_notificationsActions__["j" /* showNotificationForPushEvent */])());},appendNotificationToSidebar:function appendNotificationToSidebar(notification){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_23__store_actions_notificationsActions__["a" /* appendNotificationToSidebar */])(notification));},fetchCompany:function fetchCompany(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__store_actions_companyActions__["_34" /* show */])());},updateProviderGeolocation:function updateProviderGeolocation(newData){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_26__store_actions_providerActions__["G" /* updateProviderGeolocation */])(newData));},isUploadingExcel:function isUploadingExcel(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_24__store_actions_goodsActions__["L" /* isUploadingExcel */])());},fetchOrders:function fetchOrders(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__store_actions_orderActions__["V" /* fetchOrders */])());},fetchTodayOrders:function fetchTodayOrders(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__store_actions_orderActions__["_3" /* fetchTodayOrders */])());},updateProviderOrder:function updateProviderOrder(order,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_34__api_ondemand_js__["updateProviderOrder"])(order,type));},updateReportHistories:function updateReportHistories(payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__store_actions_companyActions__["_65" /* updateReportHistories */])(payload));},handleNewMessages:function handleNewMessages(payload,push){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_chatActions_js__["e" /* handleNewMessages */])(payload,push));},messageActions:function messageActions(messageId,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_chatActions_js__["f" /* messageActions */])(messageId,action));},updatePendingActionFromNotification:function updatePendingActionFromNotification(pendingAction){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__store_actions_companyActions__["_64" /* updatePendingActionFromNotification */])(pendingAction));},updateBranch:function updateBranch(branch){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_34__api_ondemand_js__["updateBranch"])(branch));},updateGeneralInvoice:function updateGeneralInvoice(payload){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_25__store_actions_companyActions__["_62" /* updateGeneralInvoice */])(payload));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["h" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(DefaultLayout)));

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside__ = __webpack_require__(384);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Aside__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsideToggler__ = __webpack_require__(386);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__AsideToggler__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Breadcrumb__ = __webpack_require__(387);
/* unused harmony reexport AppBreadcrumb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer__ = __webpack_require__(396);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header__ = __webpack_require__(397);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__Header__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HeaderDropdown__ = __webpack_require__(398);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__HeaderDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavbarBrand__ = __webpack_require__(399);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__NavbarBrand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Sidebar__ = __webpack_require__(400);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__Sidebar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SidebarFooter__ = __webpack_require__(401);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_8__SidebarFooter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SidebarForm__ = __webpack_require__(402);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_9__SidebarForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SidebarHeader__ = __webpack_require__(403);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_10__SidebarHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SidebarMinimizer__ = __webpack_require__(404);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_11__SidebarMinimizer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SidebarNav__ = __webpack_require__(405);
/* unused harmony reexport AppSidebarNav */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SidebarToggler__ = __webpack_require__(410);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_13__SidebarToggler__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Switch__ = __webpack_require__(411);
/* unused harmony reexport AppSwitch */






























// export AppLayout from './Shared';

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toggleClasses;
function toggleClasses(toggleClass, classList) {
  var level = classList.indexOf(toggleClass);
  var removeClassList = classList.slice(0, level);
  removeClassList.map(function (className) {
    return document.body.classList.remove(className);
  });
  document.body.classList.toggle(toggleClass);
}

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Manager__ = __webpack_require__(390);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Manager", function() { return __WEBPACK_IMPORTED_MODULE_0__Manager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Target__ = __webpack_require__(391);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Target", function() { return __WEBPACK_IMPORTED_MODULE_1__Target__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popper__ = __webpack_require__(392);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Popper", function() { return __WEBPACK_IMPORTED_MODULE_2__Popper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "placements", function() { return __WEBPACK_IMPORTED_MODULE_2__Popper__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Arrow__ = __webpack_require__(394);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Arrow", function() { return __WEBPACK_IMPORTED_MODULE_3__Arrow__["a"]; });





/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);
var settle = __webpack_require__(417);
var buildURL = __webpack_require__(419);
var parseHeaders = __webpack_require__(420);
var isURLSameOrigin = __webpack_require__(421);
var createError = __webpack_require__(188);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(422);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(423);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(418);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createStore; });
/* unused harmony export combineReducers */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* unused harmony export compose */
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(431);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT' + Math.random().toString(36).substring(7).split('').join('.'),
  REPLACE: '@@redux/REPLACE' + Math.random().toString(36).substring(7).split('').join('.')
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) return false;

  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.REPLACE });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty
}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && 'action "' + String(actionType) + '"' || 'an action';

  return 'Given ' + actionDescription + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var store = createStore.apply(undefined, args);
      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(undefined, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */
function isCrushed() {}

if (false) {
  warning("You are currently using minified code outside of NODE_ENV === 'production'. " + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(192);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(195);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(119);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(444);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _ToastContainer = _interopRequireDefault(__webpack_require__(456));

exports.ToastContainer = _ToastContainer.default;

var _Transitions = __webpack_require__(199);

exports.Bounce = _Transitions.Bounce;
exports.Slide = _Transitions.Slide;
exports.Zoom = _Transitions.Zoom;
exports.Flip = _Transitions.Flip;

var _toast = _interopRequireDefault(__webpack_require__(464));

exports.toast = _toast.default;

var _cssTransition = _interopRequireDefault(__webpack_require__(200));

exports.cssTransition = _cssTransition.default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isValidDelay = isValidDelay;
exports.objectValues = objectValues;
exports.falseOrElement = exports.falseOrDelay = void 0;

var _react = __webpack_require__(0);

function isValidDelay(val) {
  return typeof val === 'number' && !isNaN(val) && val > 0;
}

function objectValues(obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
}

function withRequired(fn) {
  fn.isRequired = function (props, propName, componentName) {
    var prop = props[propName];

    if (typeof prop === 'undefined') {
      return new Error("The prop " + propName + " is marked as required in \n      " + componentName + ", but its value is undefined.");
    }

    fn(props, propName, componentName);
  };

  return fn;
}

var falseOrDelay = withRequired(function (props, propName, componentName) {
  var prop = props[propName];

  if (prop !== false && !isValidDelay(prop)) {
    return new Error(componentName + " expect " + propName + " \n      to be a valid Number > 0 or equal to false. " + prop + " given.");
  }

  return null;
});
exports.falseOrDelay = falseOrDelay;
var falseOrElement = withRequired(function (props, propName, componentName) {
  var prop = props[propName];

  if (prop !== false && !(0, _react.isValidElement)(prop)) {
    return new Error(componentName + " expect " + propName + " \n      to be a valid react element or equal to false. " + prop + " given.");
  }

  return null;
});
exports.falseOrElement = falseOrElement;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Flip = exports.Zoom = exports.Slide = exports.Bounce = void 0;

var _cssTransition = _interopRequireDefault(__webpack_require__(200));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Bounce = (0, _cssTransition.default)({
  enter: 'Toastify__bounce-enter',
  exit: 'Toastify__bounce-exit',
  appendPosition: true
});
exports.Bounce = Bounce;
var Slide = (0, _cssTransition.default)({
  enter: 'Toastify__slide-enter',
  exit: 'Toastify__slide-exit',
  duration: [450, 750],
  appendPosition: true
});
exports.Slide = Slide;
var Zoom = (0, _cssTransition.default)({
  enter: 'Toastify__zoom-enter',
  exit: 'Toastify__zoom-exit'
});
exports.Zoom = Zoom;
var Flip = (0, _cssTransition.default)({
  enter: 'Toastify__flip-enter',
  exit: 'Toastify__flip-exit'
});
exports.Flip = Flip;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = _default;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(462));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var noop = function noop() {};

function _default(_ref) {
  var enter = _ref.enter,
      exit = _ref.exit,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 750 : _ref$duration,
      _ref$appendPosition = _ref.appendPosition,
      appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition;
  return function Animation(_ref2) {
    var children = _ref2.children,
        position = _ref2.position,
        preventExitTransition = _ref2.preventExitTransition,
        props = _objectWithoutPropertiesLoose(_ref2, ["children", "position", "preventExitTransition"]);

    var enterClassName = appendPosition ? enter + "--" + position : enter;
    var exitClassName = appendPosition ? exit + "--" + position : exit;
    var enterDuration, exitDuration;

    if (Array.isArray(duration) && duration.length === 2) {
      enterDuration = duration[0];
      exitDuration = duration[1];
    } else {
      enterDuration = exitDuration = duration;
    }

    var onEnter = function onEnter(node) {
      node.classList.add(enterClassName);
      node.style.animationFillMode = 'forwards';
      node.style.animationDuration = enterDuration * 0.001 + "s";
    };

    var onEntered = function onEntered(node) {
      node.classList.remove(enterClassName);
      node.style.cssText = '';
    };

    var onExit = function onExit(node) {
      node.classList.add(exitClassName);
      node.style.animationFillMode = 'forwards';
      node.style.animationDuration = exitDuration * 0.001 + "s";
    };

    return _react.default.createElement(_Transition.default, _extends({}, props, {
      timeout: preventExitTransition ? 0 : {
        enter: enterDuration,
        exit: exitDuration
      },
      onEnter: onEnter,
      onEntered: onEntered,
      onExit: preventExitTransition ? noop : onExit
    }), children);
  };
}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var eventManager = {
  list: new Map(),
  on: function on(event, callback) {
    this.list.has(event) || this.list.set(event, []);
    this.list.get(event).push(callback);
    return this;
  },
  off: function off(event) {
    if (event === void 0) {
      event = null;
    }

    this.list.delete(event);
    return this;
  },
  emit: function emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (!this.list.has(event)) {
      return false;
    }

    this.list.get(event).forEach(function (callback) {
      return setTimeout(function () {
        return callback.call.apply(callback, [null].concat(args));
      }, 0);
    });
    return true;
  }
};
var _default = eventManager;
exports.default = _default;

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_orderActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_bitwiseOperations__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { exist } from '../../handlers/utils';
var Dashboard=function(_Component){_inherits(Dashboard,_Component);function Dashboard(props){_classCallCheck(this,Dashboard);var _this=_possibleConstructorReturn(this,(Dashboard.__proto__||Object.getPrototypeOf(Dashboard)).call(this,props));_this.props.fillDashboardStatistics();_this.props.fillDashboardMonthStatistics().then(function(res){if(_this.props.months.length>0){_this.props.drawMonthStatisticsID(_this.props.months[0].id);}}).catch(function(err){console.log(err,"fillDashboardMonthStatistics store fail");});//this.props.fillDashboardDayStatistics(moment().format("MM"),moment().format("YYYY"))
//this.props.drawMonthStatistics(moment().format("MM"))
return _this;}_createClass(Dashboard,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _this2=this;if(prevProps.branch!==this.props.branch){this.props.fillDashboardStatistics();this.props.fillDashboardMonthStatistics().then(function(res){_this2.props.drawMonthStatisticsID(_this2.props.months[0].id);}).catch(function(err){console.log(err,"fillDashboardStatistics store fail");});}}},{key:'handleOrderRedirection',value:function handleOrderRedirection(type){switch(type){case'in_progress':localStorage.setItem("selectedStatusOrders",JSON.stringify([{name:'En curso',value:type}]));break;case'completed':localStorage.setItem("selectedStatusOrders",JSON.stringify([{name:'Completada',value:type}]));break;case'cancelled':localStorage.setItem("selectedStatusOrders",JSON.stringify([{name:'Cancelada',value:type}]));break;}}},{key:'render',value:function render(){var _this3=this;// Órdenes 
var propsStats=this.props.stats;var ordersStats=propsStats&&propsStats.orders?propsStats.orders:{};var currentStats=ordersStats&&ordersStats.current?ordersStats.current:{};var currentPaymentsStats=currentStats&&currentStats.payments?currentStats.payments:{};var onGoingStats=ordersStats&&ordersStats.ongoing?ordersStats.ongoing:{};var onGoingPaymentsStats=onGoingStats&&onGoingStats.payments?onGoingStats.payments:{};var unattendedStats=ordersStats&&ordersStats.unattended?ordersStats.unattended:{};var montData=this.props.monthData&&this.props.monthData.orders&&this.props.monthData.orders.current?this.props.monthData.orders.current:[];var orderStats={current:{created:currentStats.created?currentStats.created:0,hanging:currentStats.hanging?currentStats.hanging:0,attended:currentStats.attended?currentStats.attended:0,attended_asap:currentStats.attended_asap?currentStats.attended_asap:0,attended_completed:currentStats.attended_completed?currentStats.attended_completed:0,attended_cancelled:currentStats.attended_cancelled?currentStats.attended_cancelled:0,attended_scheduled:currentStats.attended_scheduled?currentStats.attended_scheduled:0,payments:{received_count:currentPaymentsStats.received_count?currentPaymentsStats.received_count:0,received_refunded_count:currentPaymentsStats.received_refunded_count?currentPaymentsStats.received_refunded_count:0,received_reconciled_count:currentPaymentsStats.received_reconciled_count?currentPaymentsStats.received_reconciled_count:0,received_uncompleted_count:currentPaymentsStats.received_uncompleted_count?currentPaymentsStats.received_uncompleted_count:0,pending_count:currentPaymentsStats.pending_count?currentPaymentsStats.pending_count:0,cancelled_count:currentPaymentsStats.cancelled_count?currentPaymentsStats.cancelled_count:0,total_e2:currentPaymentsStats.total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(currentPaymentsStats.total_e2)/100):0,expected_total_e2:currentPaymentsStats.expected_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(currentPaymentsStats.expected_total_e2)/100):2,registered_total_e2:currentPaymentsStats.registered_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(currentPaymentsStats.registered_total_e2)/100):0,reconciled_total_e2:currentPaymentsStats.reconciled_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(currentPaymentsStats.reconciled_total_e2)/100):0,uncompleted_total_e2:currentPaymentsStats.uncompleted_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(currentPaymentsStats.uncompleted_total_e2)/100):0,refunded_total_e2:currentPaymentsStats.refunded_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(currentPaymentsStats.refunded_total_e2)/100):0,pending_total_e2:currentPaymentsStats.pending_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(currentPaymentsStats.pending_total_e2)/100):0,cancelled_total_e2:currentPaymentsStats.cancelled_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(currentPaymentsStats.cancelled_total_e2)/100):0,total_e2_without_canceled:(currentPaymentsStats.total_e2||onGoingPaymentsStats.total_e2===0)&&(currentPaymentsStats.cancelled_total_e2||onGoingPaymentsStats.cancelled_total_e2===0)?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])((parseFloat(currentPaymentsStats.total_e2)-parseFloat(currentPaymentsStats.cancelled_total_e2))/100):0},payment_pending:currentStats.payment_pending?currentStats.payment_pending:0,payment_reported:currentStats.payment_reported?currentStats.payment_reported:0,payment_approved:currentStats.payment_approved?currentStats.payment_approved:0,total:currentStats.total?currentStats.total:0,total_asap:currentStats.total_asap?currentStats.total_asap:0,total_scheduled:currentStats.total_scheduled?currentStats.total_scheduled:0,unattended:currentStats.unattended?currentStats.unattended:0,unattended_asap:currentStats.unattended_asap?currentStats.unattended_asap:0,unattended_scheduled:currentStats.unattended_scheduled?currentStats.unattended_scheduled:0},ongoing:{created:onGoingStats.created?onGoingStats.created:0,hanging:onGoingStats.hanging?onGoingStats.hanging:0,attended:onGoingStats.attended?onGoingStats.attended:0,attended_asap:onGoingStats.attended_asap?onGoingStats.attended_asap:0,attended_completed:onGoingStats.attended_completed?onGoingStats.attended_completed:0,attended_cancelled:onGoingStats.attended_cancelled?onGoingStats.attended_cancelled:0,attended_scheduled:onGoingStats.attended_scheduled?onGoingStats.attended_scheduled:0,payments:{received_count:onGoingPaymentsStats.received_count?onGoingPaymentsStats.received_count:0,received_refunded_count:onGoingPaymentsStats.received_refunded_count?onGoingPaymentsStats.received_refunded_count:0,received_reconciled_count:onGoingPaymentsStats.received_reconciled_count?onGoingPaymentsStats.received_reconciled_count:0,received_uncompleted_count:onGoingPaymentsStats.received_uncompleted_count?onGoingPaymentsStats.received_uncompleted_count:0,pending_count:onGoingPaymentsStats.pending_count?onGoingPaymentsStats.pending_count:0,cancelled_count:onGoingPaymentsStats.cancelled_count?onGoingPaymentsStats.cancelled_count:0,total_e2:onGoingPaymentsStats.total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(onGoingPaymentsStats.total_e2)/100):0,expected_total_e2:onGoingPaymentsStats.expected_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(onGoingPaymentsStats.expected_total_e2)/100):0,registered_total_e2:onGoingPaymentsStats.registered_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(onGoingPaymentsStats.registered_total_e2)/100):0,reconciled_total_e2:onGoingPaymentsStats.reconciled_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(onGoingPaymentsStats.reconciled_total_e2)/100):0,uncompleted_total_e2:onGoingPaymentsStats.uncompleted_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(onGoingPaymentsStats.uncompleted_total_e2)/100):0,refunded_total_e2:onGoingPaymentsStats.refunded_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(onGoingPaymentsStats.refunded_total_e2)/100):0,pending_total_e2:onGoingPaymentsStats.pending_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(onGoingPaymentsStats.pending_total_e2)/100):0,cancelled_total_e2:onGoingPaymentsStats.cancelled_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(onGoingPaymentsStats.cancelled_total_e2)/100):0,total_e2_without_canceled:(onGoingPaymentsStats.total_e2||onGoingPaymentsStats.total_e2===0)&&(onGoingPaymentsStats.cancelled_total_e2||onGoingPaymentsStats.cancelled_total_e2===0)?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])((parseFloat(onGoingPaymentsStats.total_e2)-parseFloat(onGoingPaymentsStats.cancelled_total_e2))/100):0},payment_pending:onGoingStats.payment_pending?onGoingStats.payment_pending:0,payment_reported:onGoingStats.payment_reported?onGoingStats.payment_reported:0,payment_approved:onGoingStats.payment_approved?onGoingStats.payment_approved:0,total:onGoingStats.total?onGoingStats.total:0,total_asap:onGoingStats.total_asap?onGoingStats.total_asap:0,total_scheduled:onGoingStats.total_scheduled?onGoingStats.total_scheduled:0,unattended:onGoingStats.unattended?onGoingStats.unattended:0,unattended_asap:onGoingStats.unattended_asap?onGoingStats.unattended_asap:0,unattended_scheduled:onGoingStats.unattended_scheduled?onGoingStats.unattended_scheduled:0},unattended:{confirmed:unattendedStats.confirmed?onGoingStats.confirmed:0,confirmed_asap:unattendedStats.confirmed_asap?onGoingStats.confirmed_asap:0,confirmed_scheduled:unattendedStats.confirmed_scheduled?onGoingStats.confirmed_scheduled:0,not_running:unattendedStats.not_running?onGoingStats.not_running:0,payments:{},running:unattendedStats.running?onGoingStats.running:0,total:unattendedStats.total?onGoingStats.total:0,unconfirmed:unattendedStats.unconfirmed?onGoingStats.unconfirmed:0},months:{created:montData&&montData.created?montData.created:0,hanging:montData.hanging?montData.hanging:0,attended:montData&&montData.attended?montData.attended:0,attended_asap:montData&&montData.attended_asap?montData.attended_asap:0,attended_completed:montData&&montData.attended_completed?montData.attended_completed:0,attended_cancelled:montData&&montData.attended_cancelled?montData.attended_cancelled:0,attended_scheduled:montData&&montData.attended_scheduled?montData.attended_scheduled:0,payments:{received_count:montData&&montData.payments&&montData.payments.received_count?montData.payments.received_count:0,received_refunded_count:montData&&montData.payments&&montData.payments.received_refunded_count?montData.payments.received_refunded_count:0,received_reconciled_count:montData&&montData.payments&&montData.payments.received_reconciled_count?montData.payments.received_reconciled_count:0,received_uncompleted_count:montData&&montData.payments&&montData.payments.received_uncompleted_count?montData.payments.received_uncompleted_count:0,pending_count:montData&&montData.payments&&montData.payments.pending_count?montData.payments.pending_count:0,cancelled_count:montData&&montData.payments&&montData.payments.cancelled_count?montData.payments.cancelled_count:0,total_e2:montData&&montData.payments&&montData.payments.total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(montData.payments.total_e2)/100):0,expected_total_e2:montData&&montData.payments&&montData.payments.expected_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(montData.payments.expected_total_e2)/100):0,registered_total_e2:montData&&montData.payments&&montData.payments.registered_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(montData.payments.registered_total_e2)/100):0,reconciled_total_e2:montData&&montData.payments&&montData.payments.reconciled_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(montData.payments.reconciled_total_e2)/100):0,uncompleted_total_e2:montData&&montData.payments&&montData.payments.uncompleted_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(montData.payments.uncompleted_total_e2)/100):0,refunded_total_e2:montData&&montData.payments&&montData.payments.refunded_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(montData.payments.refunded_total_e2)/100):0,pending_total_e2:montData&&montData.payments&&montData.payments.pending_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(montData.payments.pending_total_e2)/100):0,cancelled_total_e2:montData&&montData.payments&&montData.payments.cancelled_total_e2?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(montData.payments.cancelled_total_e2)/100):0,total_e2_without_canceled:montData&&montData.payments&&(montData.payments.total_e2||montData.payments.total_e2===0)&&(montData.payments.cancelled_total_e2||montData.payments.cancelled_total_e2===0)?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["v" /* number_format */])(parseFloat(montData.payments.total_e2-montData.payments.cancelled_total_e2)/100):0},payment_pending:montData&&montData.payment_pending?montData.payment_pending:0,payment_reported:montData&&montData.payment_reported?montData.payment_reported:0,payment_approved:montData&&montData.payment_approved?montData.payment_approved:0,total:montData&&montData.total?montData.total:0,total_asap:montData&&montData.total_asap?montData.total_asap:0,total_scheduled:montData&&montData.total_scheduled?montData.total_scheduled:0,unattended:montData&&montData.unattended?montData.unattended:0,unattended_asap:montData&&montData.unattended_asap?montData.unattended_asap:0,unattended_scheduled:montData&&montData.unattended_scheduled?montData.unattended_scheduled:0}//var onGoingStatsPast = this.props.orderPast && this.props.orderPast.orders && this.props.orderPast.orders.ongoing ? this.props.orderPast.orders.ongoing : {}
//var onGoingPaymentsStatsPast = this.props.orderPast && this.props.orderPast.orders && this.props.orderPast.orders.ongoing && this.props.orderPast.orders.ongoing.payments ? this.props.orderPast.orders.ongoing.payments :{}
/*var orderPastStats= {
			ongoing:{
				created: onGoingStatsPast.created ? onGoingStatsPast.created : 0,
				attended: onGoingStatsPast.attended ? onGoingStatsPast.attended : 0,
				attended_asap: onGoingStatsPast.attended_asap ? onGoingStatsPast.attended_asap : 0,
				attended_completed: onGoingStatsPast.attended_completed ? onGoingStatsPast.attended_completed : 0,
				attended_cancelled: onGoingStatsPast.attended_cancelled ? onGoingStatsPast.attended_cancelled : 0,
				attended_scheduled: onGoingStatsPast.attended_scheduled ? onGoingStatsPast.attended_scheduled : 0 ,
				payments:{
					received_count: onGoingPaymentsStatsPast.received_count ? onGoingPaymentsStatsPast.received_count : 0,
					received_refunded_count: onGoingPaymentsStatsPast.received_refunded_count ? onGoingPaymentsStatsPast.received_refunded_count : 0,
					received_reconciled_count: onGoingPaymentsStatsPast.received_reconciled_count ? onGoingPaymentsStatsPast.received_reconciled_count : 0,
					received_uncompleted_count: onGoingPaymentsStatsPast.received_uncompleted_count ? onGoingPaymentsStatsPast.received_uncompleted_count : 0,
					pending_count: onGoingPaymentsStatsPast.pending_count ? onGoingPaymentsStatsPast.pending_count : 0,
					cancelled_count: onGoingPaymentsStatsPast.cancelled_count ? onGoingPaymentsStatsPast.cancelled_count : 0,
					total_e2: onGoingPaymentsStatsPast.total_e2 ? number_format(parseFloat(onGoingPaymentsStatsPast.total_e2)/100) : 0,
					expected_total_e2: onGoingPaymentsStatsPast.expected_total_e2 ? number_format(parseFloat(onGoingPaymentsStatsPast.expected_total_e2)/100) : 0,
					registered_total_e2: onGoingPaymentsStatsPast.registered_total_e2 ? number_format(parseFloat(onGoingPaymentsStatsPast.registered_total_e2)/100) : 0,
					reconciled_total_e2: onGoingPaymentsStatsPast.reconciled_total_e2 ? number_format(parseFloat(onGoingPaymentsStatsPast.reconciled_total_e2)/100) : 0,
					uncompleted_total_e2: onGoingPaymentsStatsPast.uncompleted_total_e2 ? number_format(parseFloat(onGoingPaymentsStatsPast.uncompleted_total_e2)/100) : 0,
					refunded_total_e2: onGoingPaymentsStatsPast.refunded_total_e2 ? number_format(parseFloat(onGoingPaymentsStatsPast.refunded_total_e2)/100) : 0,
					pending_total_e2: onGoingPaymentsStatsPast.pending_total_e2 ? number_format(parseFloat(onGoingPaymentsStatsPast.pending_total_e2)/100) : 0,
					cancelled_total_e2: onGoingPaymentsStatsPast.cancelled_total_e2 ? number_format(parseFloat(onGoingPaymentsStatsPast.cancelled_total_e2)/100) : 0,
					total_e2_without_canceled:(onGoingPaymentsStatsPast.total_e2 || onGoingPaymentsStatsPast.total_e2  === 0) && (onGoingPaymentsStatsPast.cancelled_total_e2 || onGoingPaymentsStatsPast.cancelled_total_e2  === 0) ? number_format( ( parseFloat(onGoingPaymentsStatsPast.total_e2) - parseFloat(onGoingPaymentsStatsPast.cancelled_total_e2) ) /100 ) : 0,
				},
				payment_pending: onGoingStatsPast.payment_pending ? onGoingStatsPast.payment_pending : 0,
				payment_reported: onGoingStatsPast.payment_reported ? onGoingStatsPast.payment_reported : 0,
				payment_approved: onGoingStatsPast.payment_approved ? onGoingStatsPast.payment_approved : 0,
				total: onGoingStatsPast.total ? onGoingStatsPast.total : 0,
				total_asap: onGoingStatsPast.total_asap ? onGoingStatsPast.total_asap : 0,
				total_scheduled: onGoingStatsPast.total_scheduled ? onGoingStatsPast.total_scheduled : 0,
				unattended: onGoingStatsPast.unattended ? onGoingStatsPast.unattended : 0,
				unattended_asap: onGoingStatsPast.unattended_asap ? onGoingStatsPast.unattended_asap : 0,
				unattended_scheduled: onGoingStatsPast.unattended_scheduled ? onGoingStatsPast.unattended_scheduled : 0,
			}
		}*/};var listStats=orderStats;// : orderPastStats
//console.log("listStats.current",listStats.months)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Container"],{className:'mt-4',fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'animated fadeIn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'my-4 font-weight-bold',style:{color:"#888"}},this.props.json_lang.dashboard.today),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Col"],{sm:'6',md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'order-management',onClick:function onClick(){return _this3.handleOrderRedirection('in_progress');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-white card bg-'+(this.props.isZupper?'zupper':'good')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h1 text-muted text-right mb-2',style:{position:"absolute",right:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-basket-loaded'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h1 mb-0 mt-3',style:{fontWeight:"bolder"}},Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["Q" /* zerofilled */])(listStats.ongoing.unattended)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'text-uppercase font-weight-bold'},'\xD3rdenes Pendientes'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Col"],{sm:'6',md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'order-management',onClick:function onClick(){return _this3.handleOrderRedirection('cancelled');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-white card bg-'+(this.props.isZupper?'zupper':'wrong')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h1 text-muted text-right mb-2',style:{position:"absolute",right:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-basket'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h1 mb-0 mt-3',style:{fontWeight:"bolder"}},listStats.ongoing.attended_cancelled),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'text-uppercase font-weight-bold'},'\xD3rdenes Canceladas'))))),this.props.accountType>=__WEBPACK_IMPORTED_MODULE_7__constants_bitwiseOperations__["d" /* ADMIN_OWNER */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Col"],{sm:'6',md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/company-charges'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-white card bg-'+(this.props.isZupper?'zupper':'money')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h1 text-muted text-right mb-2',style:{position:"absolute",right:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-money'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h1 mb-0 mt-3',style:{fontWeight:"bolder"}},this.props.currency+' '+listStats.ongoing.payments.reconciled_total_e2),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'text-uppercase font-weight-bold'},'Vol. de Ventas'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Col"],{sm:'6',md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/order-management',onClick:function onClick(){return _this3.handleOrderRedirection('completed');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-white card bg-'+(this.props.isZupper?'zupper':'money')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h1 text-muted text-right mb-2',style:{position:"absolute",right:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-basket-loaded'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h1 mb-0 mt-3',style:{fontWeight:"bolder"}},Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["Q" /* zerofilled */])(listStats.current.attended_completed)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'text-uppercase font-weight-bold'},'\xD3rdenes Completadas')))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Col"],{sm:'12',md:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/order-management',onClick:function onClick(){return _this3.handleOrderRedirection('completed');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-white card bg-'+(this.props.isZupper?'zupper':'money')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h1 text-muted text-right mb-2',style:{position:"absolute",right:"25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-basket-loaded'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'h1 mb-0 mt-3',style:{fontWeight:"bolder"}},Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["Q" /* zerofilled */])(listStats.current.attended_completed)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'text-uppercase font-weight-bold'},'\xD3rdenes Completadas')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Col"],{sm:'6',md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex flex-column my-4 font-weight-bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'font-weight-bold',style:{color:"#888"}},this.props.json_lang.dashboard.today),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{textTransform:"capitalize"}},__WEBPACK_IMPORTED_MODULE_3_moment___default()().format("dddd D, MMMM"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Card"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Table"],{className:'dashboard-tables',bordered:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.props.accountType>=__WEBPACK_IMPORTED_MODULE_7__constants_bitwiseOperations__["d" /* ADMIN_OWNER */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{scope:'row'},this.props.currency+" "+listStats.ongoing.payments.reconciled_total_e2),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Ventas')):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{scope:'row'},Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["Q" /* zerofilled */])(listStats.ongoing.created)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'\xD3rdenes creadas')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{scope:'row'},Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["Q" /* zerofilled */])(listStats.ongoing.attended_completed)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'\xD3rdenes Completadas')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{scope:'row'},Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["Q" /* zerofilled */])(listStats.ongoing.attended_cancelled)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'\xD3rdenes Canceladas')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Col"],{sm:'6',md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex flex-column my-4 font-weight-bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'font-weight-bold',style:{color:"#888"}},this.props.json_lang.dashboard.month),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{textTransform:"capitalize"}},__WEBPACK_IMPORTED_MODULE_3_moment___default()().format("MMMM YYYY"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Card"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Table"],{className:'dashboard-tables',bordered:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.props.accountType>=__WEBPACK_IMPORTED_MODULE_7__constants_bitwiseOperations__["d" /* ADMIN_OWNER */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{scope:'row'},this.props.currency+" "+listStats.months.payments.reconciled_total_e2),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Ventas')):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{scope:'row'},Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["Q" /* zerofilled */])(listStats.months.unattended+listStats.ongoing.created)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'\xD3rdenes Pendientes')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{scope:'row'},Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["Q" /* zerofilled */])(listStats.months.attended_completed+listStats.ongoing.attended_completed)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'\xD3rdenes Completadas')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{scope:'row'},Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["Q" /* zerofilled */])(listStats.months.attended_cancelled+listStats.ongoing.attended_cancelled)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'\xD3rdenes Canceladas'))))))))));}}]);return Dashboard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var zupper=false;if(state.company){if(state.company.id===7||state.company.id===120){zupper=true;}}return{admin_type:state.session&&state.session.admin_type&&state.session.admin_type.id?state.session.admin_type.id:"",json_lang:state.json_lang,stats:state.dashboardStatistics,currency:state.currencies.local.symbol,orders:state.orders,orderPast:state.orderPast,days:state.dashboardDaysStatistics,months:state.dashboardMonthsStatistics,monthData:state.dashboardMonthsData,branch:state.branch,accountType:state.session.account.type,isZupper:zupper};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fillDashboardStatistics:function fillDashboardStatistics(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_orderActions__["_6" /* fillDashboardStatistics */])());},fillDashboardDayStatistics:function fillDashboardDayStatistics(month,year){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_orderActions__["_4" /* fillDashboardDayStatistics */])(month,year));},fillDashboardMonthStatistics:function fillDashboardMonthStatistics(year){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_orderActions__["_5" /* fillDashboardMonthStatistics */])(year));},newStadistic:function newStadistic(date){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_orderActions__["_22" /* newStadistic */])(date));},drawMonthStatistics:function drawMonthStatistics(month){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_orderActions__["K" /* drawMonthStatistics */])(month));},drawMonthStatisticsID:function drawMonthStatisticsID(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_orderActions__["L" /* drawMonthStatisticsID */])(id));}};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Dashboard));

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debounce = __webpack_require__(247);

var _debounce2 = _interopRequireDefault(_debounce);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_DELAY_MS = 200;

/**
 * HoC that encapsulates common behavior and functionality for doing
 * asynchronous searches, including:
 *
 *  - Debouncing user input
 *  - Query caching (optional)
 *  - Search prompt and empty results behaviors
 */
var asyncContainer = function asyncContainer(Typeahead) {
  var WrappedTypeahead = function (_React$Component) {
    _inherits(WrappedTypeahead, _React$Component);

    function WrappedTypeahead() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WrappedTypeahead);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WrappedTypeahead.__proto__ || Object.getPrototypeOf(WrappedTypeahead)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        query: ''
      }, _this._getEmptyLabel = function () {
        var _this$props = _this.props,
            emptyLabel = _this$props.emptyLabel,
            isLoading = _this$props.isLoading,
            promptText = _this$props.promptText,
            searchText = _this$props.searchText,
            useCache = _this$props.useCache;
        var query = _this.state.query;


        if (!query.length) {
          return promptText;
        }

        if (isLoading || useCache && !_this._cache[query]) {
          return searchText;
        }

        return emptyLabel;
      }, _this._handleInputChange = function (query, e) {
        _this.props.onInputChange && _this.props.onInputChange(query, e);
        _this._handleSearchDebounced(query);
      }, _this._handleSearch = function (query) {
        var _this$props2 = _this.props,
            minLength = _this$props2.minLength,
            onSearch = _this$props2.onSearch,
            useCache = _this$props2.useCache;


        _this.setState({ query: query });

        if (!query || minLength && query.length < minLength) {
          return;
        }

        // Use cached results, if available.
        if (useCache && _this._cache[query]) {
          return;
        }

        // Perform the search.
        onSearch(query);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WrappedTypeahead, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this._cache = {};
        this._handleSearchDebounced = (0, _debounce2.default)(this._handleSearch, this.props.delay);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var options = nextProps.options,
            useCache = nextProps.useCache;


        if (!this.props.isLoading) {
          return;
        }

        if (useCache) {
          this._cache[this.state.query] = options;
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this._cache = {};
        this._handleSearchDebounced.cancel();
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            allowNew = _props.allowNew,
            options = _props.options,
            useCache = _props.useCache,
            props = _objectWithoutProperties(_props, ['allowNew', 'options', 'useCache']);

        var cachedQuery = this._cache[this.state.query];
        var emptyLabel = this._getEmptyLabel();

        // Short-circuit the creation of custom selections while the user is in
        // the process of searching. The logic for whether or not to display the
        // custom menu option is basically the same as whether we display the
        // empty label, so use that as a proxy.
        var shouldAllowNew = allowNew && emptyLabel === props.emptyLabel;

        return _react2.default.createElement(Typeahead, _extends({}, props, {
          allowNew: shouldAllowNew,
          emptyLabel: emptyLabel,
          onInputChange: this._handleInputChange,
          options: useCache && cachedQuery ? cachedQuery : options,
          ref: function ref(instance) {
            return _this2._instance = instance;
          }
        }));
      }

      /**
       * Make the component instance available.
       */

    }, {
      key: 'getInstance',
      value: function getInstance() {
        return this._instance.getInstance();
      }
    }]);

    return WrappedTypeahead;
  }(_react2.default.Component);

  WrappedTypeahead.displayName = 'AsyncContainer(' + (0, _utils.getDisplayName)(Typeahead) + ')';

  WrappedTypeahead.propTypes = {
    /**
     * Delay, in milliseconds, before performing search.
     */
    delay: _propTypes2.default.number,
    /**
     * Whether or not a request is currently pending. Necessary for the
     * container to know when new results are available.
     */
    isLoading: _propTypes2.default.bool.isRequired,
    /**
     * Callback to perform when the search is executed.
     */
    onSearch: _propTypes2.default.func.isRequired,
    /**
     * Options to be passed to the typeahead. Will typically be the query
     * results, but can also be initial default options.
     */
    options: _propTypes2.default.array,
    /**
     * Message displayed in the menu when there is no user input.
     */
    promptText: _propTypes2.default.node,
    /**
     * Message displayed in the menu while the request is pending.
     */
    searchText: _propTypes2.default.node,
    /**
     * Whether or not the component should cache query results.
     */
    useCache: _propTypes2.default.bool
  };

  WrappedTypeahead.defaultProps = {
    delay: DEFAULT_DELAY_MS,
    minLength: 2,
    options: [],
    promptText: 'Type to search...',
    searchText: 'Searching...',
    useCache: true
  };

  return WrappedTypeahead;
};

exports.default = asyncContainer;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)))

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(488);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(120);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 207 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(517),
    arraySome = __webpack_require__(209),
    cacheHas = __webpack_require__(520);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 209 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 210 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(44),
    root = __webpack_require__(25);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(32);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 213 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(544),
    hasPath = __webpack_require__(545);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getMatchBounds;

var _escapeStringRegexp = __webpack_require__(555);

var _escapeStringRegexp2 = _interopRequireDefault(_escapeStringRegexp);

var _stripDiacritics = __webpack_require__(126);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CASE_INSENSITIVE = 'i';
var COMBINING_MARKS = /[\u0300-\u036F]/;

function getMatchBounds(subject, search) {
  search = new RegExp((0, _escapeStringRegexp2.default)((0, _stripDiacritics2.default)(search)), CASE_INSENSITIVE);

  var matches = search.exec((0, _stripDiacritics2.default)(subject));

  if (!matches) {
    return null;
  }

  var start = matches.index;
  var matchLength = matches[0].length;

  // Account for combining marks, which changes the indices.
  if (COMBINING_MARKS.test(subject)) {
    // Starting at the beginning of the subject string, check for the number of
    // combining marks and increment the start index whenever one is found.
    for (var ii = 0; ii <= start; ii++) {
      if (COMBINING_MARKS.test(subject[ii])) {
        start++;
      }
    }

    // Similarly, increment the length of the match string if it contains a
    // combining mark.
    for (var _ii = start; _ii <= start + matchLength; _ii++) {
      if (COMBINING_MARKS.test(subject[_ii])) {
        matchLength++;
      }
    }
  }

  return {
    end: start + matchLength,
    start: start
  };
}

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getStringLabelKey;

var _defaultLabelKey = __webpack_require__(217);

function getStringLabelKey(labelKey) {
  return typeof labelKey === 'string' ? labelKey : _defaultLabelKey.DEFAULT_LABELKEY;
}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_LABELKEY = exports.DEFAULT_LABELKEY = 'label';

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _pick = __webpack_require__(562);

var _pick2 = _interopRequireDefault(_pick);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ClearButton = __webpack_require__(221);

var _ClearButton2 = _interopRequireDefault(_ClearButton);

var _Loader = __webpack_require__(573);

var _Loader2 = _interopRequireDefault(_Loader);

var _Overlay = __webpack_require__(574);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _TypeaheadInputMulti = __webpack_require__(579);

var _TypeaheadInputMulti2 = _interopRequireDefault(_TypeaheadInputMulti);

var _TypeaheadInputSingle = __webpack_require__(581);

var _TypeaheadInputSingle2 = _interopRequireDefault(_TypeaheadInputSingle);

var _TypeaheadMenu = __webpack_require__(229);

var _TypeaheadMenu2 = _interopRequireDefault(_TypeaheadMenu);

var _typeaheadContainer = __webpack_require__(583);

var _typeaheadContainer2 = _interopRequireDefault(_typeaheadContainer);

var _utils = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Typeahead = function (_React$Component) {
  _inherits(Typeahead, _React$Component);

  function Typeahead() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Typeahead);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Typeahead.__proto__ || Object.getPrototypeOf(Typeahead)).call.apply(_ref, [this].concat(args))), _this), _this._renderInput = function (inputProps) {
      var Input = inputProps.multiple ? _TypeaheadInputMulti2.default : _TypeaheadInputSingle2.default;

      return _react2.default.createElement(Input, inputProps);
    }, _this._renderAux = function () {
      var _this$props = _this.props,
          bsSize = _this$props.bsSize,
          clearButton = _this$props.clearButton,
          disabled = _this$props.disabled,
          isLoading = _this$props.isLoading,
          onClear = _this$props.onClear,
          selected = _this$props.selected;


      var content = void 0;

      if (isLoading) {
        content = _react2.default.createElement(_Loader2.default, { bsSize: bsSize });
      } else if (clearButton && !disabled && selected.length) {
        content = _react2.default.createElement(_ClearButton2.default, {
          bsSize: bsSize,
          onClick: onClear,
          onFocus: function onFocus(e) {
            // Prevent the main input from auto-focusing again.
            e.stopPropagation();
          },
          onMouseDown: _utils.preventInputBlur
        });
      }

      return content ? _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)('rbt-aux', {
            'rbt-aux-lg': bsSize === 'large' || bsSize === 'lg'
          }) },
        content
      ) : null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Typeahead, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var allowNew = nextProps.allowNew,
          onInitialItemChange = nextProps.onInitialItemChange,
          results = nextProps.results;

      // Clear the initial item when there are no results.

      if (!(allowNew || results.length)) {
        onInitialItemChange(null);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          bodyContainer = _props.bodyContainer,
          className = _props.className,
          isMenuShown = _props.isMenuShown,
          menuId = _props.menuId,
          renderMenu = _props.renderMenu,
          results = _props.results;


      var inputProps = (0, _pick2.default)(this.props, ['activeIndex', 'activeItem', 'bsSize', 'disabled', 'initialItem', 'inputProps', 'inputRef', 'isMenuShown', 'labelKey', 'menuId', 'multiple', 'onAdd', 'onBlur', 'onChange', 'onFocus', 'onKeyDown', 'onRemove', 'placeholder', 'renderToken', 'selected', 'selectHintOnEnter', 'text']);

      var overlayProps = (0, _pick2.default)(this.props, ['align', 'className', 'dropup', 'flip', 'onMenuHide', 'onMenuShow']);

      var menuProps = (0, _pick2.default)(this.props, ['emptyLabel', 'labelKey', 'maxHeight', 'newSelectionPrefix', 'renderMenuItemChildren', 'text']);

      var auxContent = this._renderAux();

      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)('rbt', 'clearfix', 'open', {
            'has-aux': !!auxContent
          }, className),
          ref: function ref(target) {
            return _this2._target = target;
          },
          style: { position: 'relative' },
          tabIndex: -1 },
        this._renderInput(inputProps),
        auxContent,
        _react2.default.createElement(
          _Overlay2.default,
          _extends({}, overlayProps, {
            container: bodyContainer ? document.body : this,
            show: isMenuShown,
            target: this._target }),
          renderMenu(results, _extends({}, menuProps, { id: menuId }))
        ),
        _react2.default.createElement(
          'div',
          {
            'aria-atomic': true,
            'aria-live': 'polite',
            className: 'sr-only rbt-sr-status',
            role: 'status' },
          (0, _utils.getAccessibilityStatus)(this.props)
        )
      );
    }
  }]);

  return Typeahead;
}(_react2.default.Component);

Typeahead.propTypes = {
  renderMenu: _propTypes2.default.func
};

Typeahead.defaultProps = {
  renderMenu: function renderMenu(results, menuProps) {
    return _react2.default.createElement(_TypeaheadMenu2.default, _extends({}, menuProps, { options: results }));
  }
};

exports.default = (0, _typeaheadContainer2.default)(Typeahead);

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(44);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(566),
    overRest = __webpack_require__(271),
    setToString = __webpack_require__(272);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * ClearButton
 *
 * http://getbootstrap.com/css/#helper-classes-close
 */
var ClearButton = function ClearButton(_ref) {
  var bsSize = _ref.bsSize,
      className = _ref.className,
      label = _ref.label,
      _onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ['bsSize', 'className', 'label', 'onClick']);

  return _react2.default.createElement(
    'button',
    _extends({}, props, {
      'aria-label': label,
      className: (0, _classnames2.default)('close', 'rbt-close', {
        'rbt-close-lg': bsSize === 'large' || bsSize === 'lg'
      }, className),
      onClick: function onClick(e) {
        e.stopPropagation();
        _onClick(e);
      },
      type: 'button' }),
    _react2.default.createElement(
      'span',
      { 'aria-hidden': 'true' },
      '\xD7'
    ),
    _react2.default.createElement(
      'span',
      { className: 'sr-only' },
      label
    )
  );
};

ClearButton.propTypes = {
  bsSize: _propTypes2.default.oneOf(['large', 'lg', 'small', 'sm']),
  label: _propTypes2.default.string,
  onClick: _propTypes2.default.func.isRequired
};

ClearButton.defaultProps = {
  label: 'Clear'
};

exports.default = ClearButton;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getContainer;

var _reactDom = __webpack_require__(12);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(12);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(577);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClearButton = __webpack_require__(221);

var _ClearButton2 = _interopRequireDefault(_ClearButton);

var _tokenContainer = __webpack_require__(225);

var _tokenContainer2 = _interopRequireDefault(_tokenContainer);

var _keyCode = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Token
 *
 * Individual token component, generally displayed within the TokenizerInput
 * component, but can also be rendered on its own.
 */
var Token = function (_React$Component) {
  _inherits(Token, _React$Component);

  function Token() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Token);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Token.__proto__ || Object.getPrototypeOf(Token)).call.apply(_ref, [this].concat(args))), _this), _this._renderRemoveableToken = function () {
      var _this$props = _this.props,
          active = _this$props.active,
          children = _this$props.children,
          className = _this$props.className,
          onRemove = _this$props.onRemove,
          props = _objectWithoutProperties(_this$props, ['active', 'children', 'className', 'onRemove']);

      return _react2.default.createElement(
        'div',
        _extends({}, props, {
          className: (0, _classnames2.default)('rbt-token', 'rbt-token-removeable', {
            'rbt-token-active': active
          }, className) }),
        children,
        _react2.default.createElement(_ClearButton2.default, {
          className: 'rbt-token-remove-button',
          label: 'Remove',
          onClick: onRemove,
          onKeyDown: _this._handleRemoveButtonKeydown,
          tabIndex: -1
        })
      );
    }, _this._renderToken = function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          href = _this$props2.href;

      var classnames = (0, _classnames2.default)('rbt-token', {
        'rbt-token-disabled': disabled
      }, className);

      if (href) {
        return _react2.default.createElement(
          'a',
          { className: classnames, href: href },
          children
        );
      }

      return _react2.default.createElement(
        'div',
        { className: classnames },
        children
      );
    }, _this._handleRemoveButtonKeydown = function (e) {
      switch (e.keyCode) {
        case _keyCode.RETURN:
          _this.props.onRemove();
          break;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Token, [{
    key: 'render',
    value: function render() {
      return this.props.onRemove && !this.props.disabled ? this._renderRemoveableToken() : this._renderToken();
    }
  }]);

  return Token;
}(_react2.default.Component);

Token.propTypes = {
  active: _propTypes2.default.bool,
  /**
   * Handler for removing/deleting the token. If not defined, the token will
   * be rendered in a read-only state.
   */
  onRemove: _propTypes2.default.func,
  tabIndex: _propTypes2.default.number
};

Token.defaultProps = {
  active: false,
  tabIndex: 0
};

exports.default = (0, _tokenContainer2.default)(Token);

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactOnclickoutside = __webpack_require__(226);

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _utils = __webpack_require__(22);

var _keyCode = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Higher-order component that encapsulates Token behaviors, allowing them to
 * be easily re-used.
 */
var tokenContainer = function tokenContainer(Component) {
  var WrappedComponent = function (_React$Component) {
    _inherits(WrappedComponent, _React$Component);

    function WrappedComponent() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WrappedComponent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WrappedComponent.__proto__ || Object.getPrototypeOf(WrappedComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        active: false
      }, _this._handleBlur = function (e) {
        _this.setState({ active: false });
      }, _this._handleKeyDown = function (e) {
        switch (e.keyCode) {
          case _keyCode.BACKSPACE:
            if (_this.state.active) {
              // Prevent backspace keypress from triggering the browser "back"
              // action.
              e.preventDefault();
              _this.props.onRemove();
            }
            break;
        }
      }, _this.handleClickOutside = function (e) {
        _this._handleBlur();
      }, _this._handleActive = function (e) {
        e.stopPropagation();
        _this.setState({ active: true });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WrappedComponent, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            disableOnClickOutside = _props.disableOnClickOutside,
            enableOnClickOutside = _props.enableOnClickOutside,
            eventTypes = _props.eventTypes,
            outsideClickIgnoreClass = _props.outsideClickIgnoreClass,
            preventDefault = _props.preventDefault,
            stopPropagation = _props.stopPropagation,
            tokenProps = _objectWithoutProperties(_props, ['disableOnClickOutside', 'enableOnClickOutside', 'eventTypes', 'outsideClickIgnoreClass', 'preventDefault', 'stopPropagation']);

        return _react2.default.createElement(Component, _extends({}, tokenProps, this.state, {
          onBlur: this._handleBlur,
          onClick: this._handleActive,
          onFocus: this._handleActive,
          onKeyDown: this._handleKeyDown
        }));
      }

      /**
       * From `onClickOutside` HOC.
       */

    }]);

    return WrappedComponent;
  }(_react2.default.Component);

  WrappedComponent.displayName = 'TokenContainer(' + (0, _utils.getDisplayName)(Component) + ')';

  return (0, _reactOnclickoutside2.default)(WrappedComponent);
};

exports.default = tokenContainer;

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IGNORE_CLASS_NAME", function() { return IGNORE_CLASS_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.props.disableOnClickOutside) return;
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
        }
      }

      this.componentNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(22);

var _keyCode = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// IE doesn't seem to get the composite computed value (eg: 'padding',
// 'borderStyle', etc.), so generate these from the individual values.
function interpolateStyle(styles, attr) {
  var subattr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  // Title-case the sub-attribute.
  if (subattr) {
    subattr = subattr.replace(subattr[0], subattr[0].toUpperCase());
  }

  return ['Top', 'Right', 'Bottom', 'Left'].map(function (dir) {
    return styles[attr + dir + subattr];
  }).join(' ');
}

function copyStyles(inputNode, hintNode) {
  var inputStyle = window.getComputedStyle(inputNode);

  hintNode.style.borderStyle = interpolateStyle(inputStyle, 'border', 'style');
  hintNode.style.borderWidth = interpolateStyle(inputStyle, 'border', 'width');
  hintNode.style.fontSize = inputStyle.fontSize;
  hintNode.style.lineHeight = inputStyle.lineHeight;
  hintNode.style.margin = interpolateStyle(inputStyle, 'margin');
  hintNode.style.padding = interpolateStyle(inputStyle, 'padding');
}

function hintContainer(Input) {
  var HintedInput = function (_React$Component) {
    _inherits(HintedInput, _React$Component);

    function HintedInput() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, HintedInput);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HintedInput.__proto__ || Object.getPrototypeOf(HintedInput)).call.apply(_ref, [this].concat(args))), _this), _this._handleKeyDown = function (e) {
        var _this$context = _this.context,
            hintText = _this$context.hintText,
            initialItem = _this$context.initialItem,
            onAdd = _this$context.onAdd,
            selectHintOnEnter = _this$context.selectHintOnEnter;
        var _this$props = _this.props,
            onKeyDown = _this$props.onKeyDown,
            value = _this$props.value;


        if (hintText && (e.keyCode === _keyCode.RETURN && selectHintOnEnter || e.keyCode === _keyCode.RIGHT && e.target.selectionStart === value.length || e.keyCode === _keyCode.TAB)) {
          e.preventDefault(); // Prevent input from blurring on TAB.
          onAdd(initialItem);
        }

        onKeyDown(e);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(HintedInput, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        copyStyles(this._input, this._hint);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        copyStyles(this._input, this._hint);
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return _react2.default.createElement(
          'div',
          {
            className: 'rbt-input-hint-container',
            style: { position: 'relative' } },
          _react2.default.createElement(Input, _extends({}, this.props, {
            inputRef: function inputRef(input) {
              _this2._input = input;
              _this2.props.inputRef(input);
            },
            onKeyDown: this._handleKeyDown
          })),
          _react2.default.createElement('input', {
            'aria-hidden': true,
            className: 'rbt-input-hint',
            ref: function ref(hint) {
              return _this2._hint = hint;
            },
            style: {
              backgroundColor: 'transparent',
              borderColor: 'transparent',
              boxShadow: 'none',
              color: 'rgba(0, 0, 0, 0.35)',
              left: 0,
              pointerEvents: 'none',
              position: 'absolute',
              top: 0
            },
            tabIndex: -1,
            value: this.context.hintText
          })
        );
      }
    }]);

    return HintedInput;
  }(_react2.default.Component);

  HintedInput.displayName = 'HintContainer(' + (0, _utils.getDisplayName)(Input) + ')';

  HintedInput.contextTypes = {
    hintText: _propTypes2.default.string.isRequired,
    initialItem: _propTypes2.default.oneOfType([_propTypes2.default.object.isRequired, _propTypes2.default.string.isRequired]),
    onAdd: _propTypes2.default.func.isRequired,
    selectHintOnEnter: _propTypes2.default.bool.isRequired
  };

  return HintedInput;
}

exports.default = hintContainer;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function inputContainer(Input) {
  var WrappedInput = function (_React$Component) {
    _inherits(WrappedInput, _React$Component);

    function WrappedInput() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WrappedInput);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WrappedInput.__proto__ || Object.getPrototypeOf(WrappedInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        isFocused: false
      }, _this._handleBlur = function (e) {
        e.persist();
        _this.setState({ isFocused: false }, function () {
          return _this.props.onBlur(e);
        });
      }, _this._handleFocus = function (e) {
        e.persist();
        _this.setState({ isFocused: true }, function () {
          return _this.props.onFocus(e);
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WrappedInput, [{
      key: 'getChildContext',
      value: function getChildContext() {
        var _props = this.props,
            initialItem = _props.initialItem,
            onAdd = _props.onAdd,
            selectHintOnEnter = _props.selectHintOnEnter;


        return {
          hintText: (0, _utils.getHintText)(this.props),
          initialItem: initialItem,
          onAdd: onAdd,
          selectHintOnEnter: selectHintOnEnter
        };
      }
    }, {
      key: 'render',
      value: function render() {
        var _cx;

        var _props2 = this.props,
            activeIndex = _props2.activeIndex,
            bsSize = _props2.bsSize,
            disabled = _props2.disabled,
            inputRef = _props2.inputRef,
            isMenuShown = _props2.isMenuShown,
            labelKey = _props2.labelKey,
            menuId = _props2.menuId,
            multiple = _props2.multiple,
            onChange = _props2.onChange,
            onKeyDown = _props2.onKeyDown,
            onRemove = _props2.onRemove,
            placeholder = _props2.placeholder,
            renderToken = _props2.renderToken,
            selected = _props2.selected;

        // Add a11y-related props.

        var inputProps = _extends({}, this.props.inputProps, {
          'aria-activedescendant': activeIndex >= 0 ? (0, _utils.getMenuItemId)(activeIndex) : '',
          'aria-autocomplete': multiple ? 'list' : 'both',
          'aria-expanded': isMenuShown,
          'aria-haspopup': 'listbox',
          'aria-owns': menuId,
          autoComplete: 'nope',
          disabled: disabled,
          inputRef: inputRef,
          onBlur: this._handleBlur,
          onChange: onChange,
          // Re-open the menu, eg: if it's closed via ESC.
          onClick: this._handleFocus,
          onFocus: this._handleFocus,
          onKeyDown: onKeyDown,
          placeholder: selected.length ? null : placeholder,
          // Comboboxes are single-select by definition:
          // https://www.w3.org/TR/wai-aria-practices-1.1/#combobox
          role: 'combobox',
          value: (0, _utils.getInputText)(this.props)
        });

        var className = inputProps.className || '';

        if (multiple) {
          inputProps = _extends({}, inputProps, {
            inputClassName: className,
            labelKey: labelKey,
            onRemove: onRemove,
            renderToken: renderToken,
            role: '',
            selected: selected
          });
        }

        return _react2.default.createElement(Input, _extends({}, inputProps, {
          className: (0, _classnames2.default)('rbt-input', (_cx = {}, _defineProperty(_cx, className, !multiple), _defineProperty(_cx, 'focus', this.state.isFocused), _defineProperty(_cx, 'input-lg form-control-lg', bsSize === 'large' || bsSize === 'lg'), _defineProperty(_cx, 'input-sm form-control-sm', bsSize === 'small' || bsSize === 'sm'), _cx))
        }));
      }
    }]);

    return WrappedInput;
  }(_react2.default.Component);

  WrappedInput.displayName = 'InputContainer(' + (0, _utils.getDisplayName)(Input) + ')';

  WrappedInput.childContextTypes = {
    hintText: _propTypes2.default.string.isRequired,
    initialItem: _propTypes2.default.oneOfType([_propTypes2.default.object.isRequired, _propTypes2.default.string.isRequired]),
    onAdd: _propTypes2.default.func.isRequired,
    selectHintOnEnter: _propTypes2.default.bool.isRequired
  };

  return WrappedInput;
}

exports.default = inputContainer;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Highlighter = __webpack_require__(230);

var _Highlighter2 = _interopRequireDefault(_Highlighter);

var _Menu = __webpack_require__(231);

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuItem = __webpack_require__(130);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _utils = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TypeaheadMenu = function (_React$Component) {
  _inherits(TypeaheadMenu, _React$Component);

  function TypeaheadMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TypeaheadMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TypeaheadMenu.__proto__ || Object.getPrototypeOf(TypeaheadMenu)).call.apply(_ref, [this].concat(args))), _this), _this._renderMenuItem = function (option, idx) {
      var _this$props = _this.props,
          labelKey = _this$props.labelKey,
          newSelectionPrefix = _this$props.newSelectionPrefix,
          renderMenuItemChildren = _this$props.renderMenuItemChildren,
          text = _this$props.text;


      var label = (0, _utils.getOptionLabel)(option, labelKey);

      var menuItemProps = {
        disabled: option.disabled,
        key: idx,
        label: label,
        option: option,
        position: idx
      };

      if (option.customOption) {
        return _react2.default.createElement(
          _MenuItem2.default,
          _extends({}, menuItemProps, {
            className: 'rbt-menu-custom-option',
            label: newSelectionPrefix + label }),
          newSelectionPrefix,
          _react2.default.createElement(
            _Highlighter2.default,
            { search: text },
            label
          )
        );
      }

      if (option.paginationOption) {
        return [_react2.default.createElement(_Menu2.default.Divider, { key: 'pagination-item-divider' }), _react2.default.createElement(
          _MenuItem2.default,
          _extends({}, menuItemProps, {
            className: 'rbt-menu-pagination-option',
            key: 'pagination-item' }),
          label
        )];
      }

      return _react2.default.createElement(
        _MenuItem2.default,
        menuItemProps,
        renderMenuItemChildren(option, _this.props, idx)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TypeaheadMenu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          labelKey = _props.labelKey,
          newSelectionPrefix = _props.newSelectionPrefix,
          options = _props.options,
          renderMenuItemChildren = _props.renderMenuItemChildren,
          text = _props.text,
          menuProps = _objectWithoutProperties(_props, ['labelKey', 'newSelectionPrefix', 'options', 'renderMenuItemChildren', 'text']);

      return _react2.default.createElement(
        _Menu2.default,
        menuProps,
        options.map(this._renderMenuItem)
      );
    }
  }]);

  return TypeaheadMenu;
}(_react2.default.Component);

TypeaheadMenu.propTypes = {
  /**
   * Provides the ability to specify a prefix before the user-entered text to
   * indicate that the selection will be new. No-op unless `allowNew={true}`.
   */
  newSelectionPrefix: _propTypes2.default.string,
  /**
   * Provides a hook for customized rendering of menu item contents.
   */
  renderMenuItemChildren: _propTypes2.default.func
};

TypeaheadMenu.defaultProps = {
  newSelectionPrefix: 'New selection: ',
  renderMenuItemChildren: function renderMenuItemChildren(option, props, idx) {
    return _react2.default.createElement(
      _Highlighter2.default,
      { search: props.text },
      (0, _utils.getOptionLabel)(option, props.labelKey)
    );
  }
};

exports.default = TypeaheadMenu;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Stripped-down version of https://github.com/helior/react-highlighter
 *
 * Results are already filtered by the time the component is used internally so
 * we can safely ignore case and diacritical marks for the purposes of matching.
 */
var Highlighter = function (_React$Component) {
  _inherits(Highlighter, _React$Component);

  function Highlighter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Highlighter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Highlighter.__proto__ || Object.getPrototypeOf(Highlighter)).call.apply(_ref, [this].concat(args))), _this), _this._count = 0, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Highlighter, [{
    key: 'render',
    value: function render() {
      var children = this.props.search ? this._renderHighlightedChildren() : this.props.children;

      return _react2.default.createElement(
        'span',
        null,
        children
      );
    }
  }, {
    key: '_renderHighlightedChildren',
    value: function _renderHighlightedChildren() {
      var children = [];
      var remaining = this.props.children;

      while (remaining) {
        var bounds = (0, _utils.getMatchBounds)(remaining, this.props.search);

        if (!bounds) {
          this._count++;
          children.push(_react2.default.createElement(
            'span',
            { key: this._count },
            remaining
          ));
          return children;
        }

        // Capture the string that leads up to a match...
        var nonMatch = remaining.slice(0, bounds.start);
        if (nonMatch) {
          this._count++;
          children.push(_react2.default.createElement(
            'span',
            { key: this._count },
            nonMatch
          ));
        }

        // Now, capture the matching string...
        var match = remaining.slice(bounds.start, bounds.end);
        if (match) {
          this._count++;
          children.push(_react2.default.createElement(
            'mark',
            { className: 'rbt-highlight-text', key: this._count },
            match
          ));
        }

        // And if there's anything left over, continue the loop.
        remaining = remaining.slice(bounds.end);
      }

      return children;
    }
  }]);

  return Highlighter;
}(_react2.default.Component);

Highlighter.propTypes = {
  children: _propTypes2.default.string.isRequired,
  search: _propTypes2.default.string.isRequired
};

exports.default = Highlighter;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isRequiredForA11y = __webpack_require__(582);

var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MenuItem = __webpack_require__(130);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Menu component that handles empty state when passed a set of results.
 */
var Menu = function (_React$Component) {
  _inherits(Menu, _React$Component);

  function Menu() {
    _classCallCheck(this, Menu);

    return _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).apply(this, arguments));
  }

  _createClass(Menu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          emptyLabel = _props.emptyLabel,
          id = _props.id,
          innerRef = _props.innerRef,
          maxHeight = _props.maxHeight,
          style = _props.style;


      var contents = _react.Children.count(children) === 0 ? _react2.default.createElement(
        _MenuItem.BaseMenuItem,
        { disabled: true },
        emptyLabel
      ) : children;

      return _react2.default.createElement(
        'ul',
        {
          className: (0, _classnames2.default)('rbt-menu', 'dropdown-menu', 'show', className),
          id: id,
          ref: innerRef,
          role: 'listbox',
          style: _extends({}, style, {
            display: 'block',
            maxHeight: maxHeight,
            overflow: 'auto'
          }) },
        contents
      );
    }
  }]);

  return Menu;
}(_react2.default.Component);

Menu.propTypes = {
  /**
   * Needed for accessibility.
   */
  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
  /**
   * Maximum height of the dropdown menu.
   */
  maxHeight: _propTypes2.default.string
};

Menu.defaultProps = {
  maxHeight: '300px'
};

Menu.Divider = function (props) {
  return _react2.default.createElement('li', { className: 'divider dropdown-divider', role: 'separator' });
};

Menu.Header = function (props) {
  return _react2.default.createElement('li', _extends({}, props, { className: 'dropdown-header' }));
};

exports.default = Menu;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(12);

var _utils = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var menuItemContainer = function menuItemContainer(Component) {
  var WrappedMenuItem = function (_React$Component) {
    _inherits(WrappedMenuItem, _React$Component);

    function WrappedMenuItem() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WrappedMenuItem);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WrappedMenuItem.__proto__ || Object.getPrototypeOf(WrappedMenuItem)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
        var _this$props = _this.props,
            option = _this$props.option,
            onClick = _this$props.onClick;


        _this.context.onMenuItemClick(option, e);
        onClick && onClick(e);
      }, _this._updateInitialItem = function (props) {
        var option = props.option,
            position = props.position;

        if (position === 0) {
          _this.context.onInitialItemChange(option);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WrappedMenuItem, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this._updateInitialItem(this.props);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var currentlyActive = this.context.activeIndex === this.props.position;
        var option = nextProps.option,
            position = nextProps.position;
        var activeIndex = nextContext.activeIndex,
            onActiveItemChange = nextContext.onActiveItemChange;


        if (position == null) {
          return;
        }

        // The item will become active.
        if (activeIndex === position) {
          // Ensures that if the menu items exceed the bounds of the menu, the
          // menu will scroll up or down as the user hits the arrow keys.
          (0, _utils.scrollIntoViewIfNeeded)((0, _reactDom.findDOMNode)(this));

          // Fire the change handler when the menu item becomes active.
          !currentlyActive && onActiveItemChange(option);
        }

        this._updateInitialItem(nextProps);
      }
    }, {
      key: 'render',
      value: function render() {
        var _context = this.context,
            activeIndex = _context.activeIndex,
            isOnlyResult = _context.isOnlyResult;

        var _props = this.props,
            label = _props.label,
            option = _props.option,
            position = _props.position,
            props = _objectWithoutProperties(_props, ['label', 'option', 'position']);

        var active = isOnlyResult || activeIndex === position;

        return _react2.default.createElement(Component, _extends({}, props, {
          active: active,
          'aria-label': label,
          'aria-selected': active,
          id: (0, _utils.getMenuItemId)(position),
          onClick: this._handleClick,
          onMouseDown: _utils.preventInputBlur,
          role: 'option'
        }));
      }
    }]);

    return WrappedMenuItem;
  }(_react2.default.Component);

  WrappedMenuItem.displayName = 'MenuItemContainer(' + (0, _utils.getDisplayName)(Component) + ')';

  WrappedMenuItem.propTypes = {
    option: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired,
    position: _propTypes2.default.number
  };

  WrappedMenuItem.contextTypes = {
    activeIndex: _propTypes2.default.number.isRequired,
    isOnlyResult: _propTypes2.default.bool.isRequired,
    onActiveItemChange: _propTypes2.default.func.isRequired,
    onInitialItemChange: _propTypes2.default.func.isRequired,
    onMenuItemClick: _propTypes2.default.func.isRequired
  };

  return WrappedMenuItem;
};

exports.default = menuItemContainer;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(586),
    noop = __webpack_require__(131);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(587);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Plugins__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_datetime_picker_dist_picker_css__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_datetime_picker_dist_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rc_datetime_picker_dist_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_general__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReportItemRow__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_actions_companyActions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Plugins_MainModals_ModalBase__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ModalReportsHistories__ = __webpack_require__(646);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Reports=function(_Component){_inherits(Reports,_Component);function Reports(props){_classCallCheck(this,Reports);var _this=_possibleConstructorReturn(this,(Reports.__proto__||Object.getPrototypeOf(Reports)).call(this,props));_this.state={adminType:_this.props.session.admin_type,reportsList:__WEBPACK_IMPORTED_MODULE_5__constants_general__["L" /* REPORTS_LIST */].filter(function(item){return item.reports.some(function(report){return report.permissions.hierarchy<=_this.props.accountType;});}),selectType:"general"};return _this;}_createClass(Reports,[{key:'componentDidMount',value:function componentDidMount(){var _state=this.state,adminType=_state.adminType,reportsList=_state.reportsList;this.props.fetchCompanyCities();if(adminType){var filteredRoles=adminType.roles.filter(function(rol){return rol.role.startsWith("access_report")&&rol.role!=="access_reports";});var splitedReports=filteredRoles.map(function(rol){return rol.role.split('_')[1];});var newReportsList=reportsList.map(function(item){return Object.assign({},item,{reports:item.reports.filter(function(report){return splitedReports.some(function(rol){return report.value===rol;});})});}).filter(function(item){return item.reports.length>0;});this.setState({reportsList:newReportsList});}}},{key:'handleReportsQuery',value:function handleReportsQuery(query,value){switch(value){case __WEBPACK_IMPORTED_MODULE_5__constants_general__["N" /* REPORT_ADMIN */]:return this.props.api.reports.admins();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_16" /* REPORT_OUT_OF_STOCK */]:return this.props.api.reports.downloadSoldoutGoods(query.branch_id);case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_38" /* REPORT_ZUPPER_SELLS */]:return this.props.api.reports.branchSales();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["Q" /* REPORT_BANCAMIGA */]:return this.props.api.reports.bancamigaReport();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["P" /* REPORT_BALANCE_MODIFIERS */]:return this.props.api.reports.balanceModifiers();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_1" /* REPORT_CITY_MOVEMENTS */]:return this.props.api.reports.cityMovements();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_2" /* REPORT_CITY_SUMMARY */]:return this.props.api.reports.citySummary();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["R" /* REPORT_BRANCH_DETAILS */]:return this.props.api.reports.branchAgreements();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["S" /* REPORT_BRANCH_GROUP_SALE_DETAILS */]:return this.props.api.reports.branchGroupSaleDetails();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["Y" /* REPORT_BRANCH_PENDING_FEES */]:return this.props.api.reports.branchInvoices();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["W" /* REPORT_BRANCH_PAID_INVOICES */]:case __WEBPACK_IMPORTED_MODULE_5__constants_general__["X" /* REPORT_BRANCH_PAID_INVOICES_ALT */]:return this.props.api.reports.branchPaidInvoices();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_17" /* REPORT_PAID_ORDERS_TO_BRANCH */]:return this.props.api.reports.branchInvoicesEarnings();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_18" /* REPORT_PENDING_FEES_TO_RIDERS */]:return this.props.api.reports.providersInvoices();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_27" /* REPORT_RIDERS_PAID_INVOICES */]:return this.props.api.reports.providerPaidInvoices();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_26" /* REPORT_RIDERS_ONLINE */]:return this.props.api.reports.providerOnline();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_25" /* REPORT_RIDERS_MOVEMENTS */]:return this.props.api.reports.providerBalance();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_28" /* REPORT_RIDERS_STATUS */]:return this.props.api.reports.providerStatus();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["M" /* REPORT_ACCESS */]:return this.props.api.reports.companyAccesses();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_35" /* REPORT_USERS */]:return this.props.api.reports.clients();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_36" /* REPORT_USERS_EMAIL */]:return this.props.api.reports.clientsSlimAll();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_4" /* REPORT_CLIENTS_WITH_BALANCE */]:return this.props.api.reports.userWithBalance();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_3" /* REPORT_CLIENTS_MOVEMENTS */]:return this.props.api.reports.clientMovements();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_5" /* REPORT_CLIENT_PAID_INVOICES */]:return this.props.api.reports.clientPaidInvoices();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_37" /* REPORT_USER_LOGINS */]:return this.props.api.reports.clientsSlimEmail();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_8" /* REPORT_COMPANY_SALES */]:return this.props.api.reports.companySales();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_7" /* REPORT_COMPANY_PAYMENT_DETAILS */]:return this.props.api.reports.paymentDetails();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_23" /* REPORT_RECENT_USERS */]:return this.props.api.reports.clientsSlim();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_13" /* REPORT_GENERAL_ORDERS */]:return this.props.api.reports.companyOrders();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_6" /* REPORT_COMPANY_ORDERS_REVENUE */]:return this.props.api.reports.companyOrdersRevenue();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_15" /* REPORT_ORDER_RATINGS */]:return this.props.api.reports.companyOrdersRatings();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["V" /* REPORT_BRANCH_ORDERS */]:return this.props.api.reports.branchOrders(query.branch_id);case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_24" /* REPORT_RIDERS_EARNINGS */]:return this.props.api.reports.providerEarnings();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_29" /* REPORT_RIDER_EARNINGS */]:return this.props.api.reports.providerEarnings(query.provider_id);case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_12" /* REPORT_GENERAL_OPERATIONS_OF_RIDERS */]:return this.props.api.reports.providerDetailedEarnings();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_11" /* REPORT_GENERAL_OPERATIONS_OF_RIDER */]:return this.props.api.reports.providerDetailedEarnings(query.provider_id);case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_19" /* REPORT_PRODUCTS_PURCHASED_BY_USERS */]:case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_20" /* REPORT_PRODUCTS_SOLD_BY_BRANCH */]:case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_21" /* REPORT_PRODUCTS_SOLD_BY_USER_ON_BRANCH */]:return this.props.api.reports.orderedGoods();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_32" /* REPORT_TOTAL_PRODUCTS_SOLD */]:case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_30" /* REPORT_TOTAL_PRODUCTS_PURCHASED_BY_USER */]:case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_33" /* REPORT_TOTAL_PRODUCTS_SOLD_BY_BRANCH */]:return this.props.api.reports.goods();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_31" /* REPORT_TOTAL_PRODUCTS_PURCHASED_BY_USER_IN_BRANCH */]:case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_14" /* REPORT_ORDERS_BY_USER */]:return this.props.api.reports.clientOrders();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["T" /* REPORT_BRANCH_LIST */]:return this.props.api.reports.branches();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_0" /* REPORT_BRANCH_REPORTS */]:return this.props.api.reports.branchGoods(query.branch_id);case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_9" /* REPORT_COUPONS */]:return this.props.api.reports.coupons();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_10" /* REPORT_COUPON_INVESTMENTS */]:return this.props.api.reports.couponInvestments();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["O" /* REPORT_AVAILABLE_COUPONS */]:return this.props.api.reports.availableCoupons();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_34" /* REPORT_USED_COUPONS */]:return this.props.api.reports.usedCoupons();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["Z" /* REPORT_BRANCH_PROMOTION */]:return this.props.api.reports.promos();case __WEBPACK_IMPORTED_MODULE_5__constants_general__["U" /* REPORT_BRANCH_MOVEMENTS */]:return this.props.api.reports.businessMovements(query.branch_id);case __WEBPACK_IMPORTED_MODULE_5__constants_general__["_22" /* REPORT_PROVIDER_FEES */]:return this.props.api.reports.providerFees(query.branch_id);default:break;}}},{key:'toggleModal',value:function toggleModal(modal){this.refs[modal].toggleModal();}},{key:'handleSelectChange',value:function handleSelectChange(value){this.setState({selectType:value});}},{key:'render',value:function render(){var _this2=this;var _state2=this.state,reportsList=_state2.reportsList,selectType=_state2.selectType;var _props=this.props,json_lang=_props.json_lang,session=_props.session;var NEW_REPORTS_LIST=reportsList.filter(function(item){if(_this2.props.branch.id){return item;}else{return item.reports.some(function(report){return!report.permissions.withAllBranches;});}}).filter(function(item){if(selectType==="general"){return true;}else{return item.type===selectType;}});var reportsTypes=[{name:json_lang.settings.information_title,value:"general"}];reportsList.forEach(function(item){if(item.type){reportsTypes.push({name:json_lang.common[item.type],value:item.type});}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Container"],{className:'mt-4',fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex flex-row justify-content-between mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'font-weight-bold mr-2'},json_lang.reports.reports),reportsTypes.length>2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:selectType,onChange:function onChange(e){return _this2.handleSelectChange(e.target.value);}},reportsTypes.map(function(reportType,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:reportType.value},reportType.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Button"],{color:'primary',onClick:function onClick(){return _this2.toggleModal('history');}},'Historial')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Row"],{className:'justify-content-center'},NEW_REPORTS_LIST.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'mt-2 w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'font-weight-bold'},json_lang.common[item.type]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table-outline d-sm-table table table-hover',style:{background:"white"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',{className:'thead-light'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,json_lang.common.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-right'},json_lang.common.actions))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,item.reports.map(function(report){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ReportItemRow__["a" /* default */],{key:report.value,title:report.permissions.dependsOnBranch||report.permissions.branchRequired?_this2.props.branch.name?report.name.replace("comercio",_this2.props.branch.name):report.name:report.name,cityId:session.city_id,withFile:report.permissions.withFile,withDates:report.permissions.withDates,forceCity:report.permissions.forceCity,autoBranch:report.permissions.autoBranch,withClients:report.permissions.withClients,withBranches:report.permissions.dependsOnBranch?!_this2.props.branch.id:report.permissions.withBranches,maxDateRange:report.permissions.maxDateRange,withProviders:report.permissions.withProviders,activateModal:report.permissions.activateModal,withCityFilter:report.permissions.withCityFilter,withAllBranches:report.permissions.withAllBranches,withTimezone:report.permissions.withTimezone,withBranchGroups:report.permissions.withBranchGroups,branchAsParameter:report.permissions.branchAsParameter,appendingQueryString:report.permissions.appendingQueryString,url:function url(_ref){var query=_ref.query;return _this2.handleReportsQuery(query,report.value);}});}))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Plugins_MainModals_ModalBase__["a" /* default */],{ref:'history',title:'Histórico de reportes',style:{maxWidth:"1000px"},html:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ModalReportsHistories__["a" /* default */],{reportsList:reportsList,handleReportsQuery:function handleReportsQuery(query,value){return _this2.handleReportsQuery(query,value);}})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Plugins__["b" /* Preloader */],null));}}]);return Reports;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{session:state.session,accountType:state.session.account.type,json_lang:state.json_lang,company:state.company,branches:state.branches,branch:state.branch};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchCompanyCities:function fetchCompanyCities(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__store_actions_companyActions__["P" /* fetchCompanyCities */])());}};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_6__api__["withApiService"])(Reports)));

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return notificationOptionSetting; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_ondemand__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_UtilsOperation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_bitwiseOperations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_general__ = __webpack_require__(6);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var json_lang=__WEBPACK_IMPORTED_MODULE_3__store_store_js__["a" /* default */].getState().json_lang;var notificationOptionSetting=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(payload,data,notification,session,dispatch){var sound,hasListOfOrdersView,hasListOfProvidersView,isMapView,isBranchListView,activeBranch,userHigherAccess,fetchedData,ignorePush,PAYLOAD,orderIdToUpdate,rating_id,isService,status_type,providerName,_providerName,coupon,isCouponsListView,company,msg,textt,_isService,_status_type;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:// session se envia solo cuando llega un push, desde la vista de Lista de Notificaciones este es undefined siempre
sound=session&&session.settings.preferences&&session.settings.preferences.audible_notifications;hasListOfOrdersView=['order-management','map'].includes(window.location.pathname.split("/")[1]);// debo incluir esto porque al agregar el "search-status" en la url de "order-management" deja de coincidir
hasListOfProvidersView=['/provider-management','/map'].includes(window.location.pathname);isMapView=['/map'].includes(window.location.pathname);isBranchListView=['/branchs'].includes(window.location.pathname);activeBranch=JSON.parse(localStorage.getItem("activeBranch"));userHigherAccess=JSON.parse(localStorage.getItem("userHigherAccess"));fetchedData={};ignorePush=false;/* Los default se mantienen comentados, xq por ahora la unica forma de saber de que comercio son los push no es posible desde el api, entonces para evitar que lleguen notificaciones por defecto/no reconocidas a cualquier comercio se opta por ocultar las default */PAYLOAD=payload&&payload.data||payload;orderIdToUpdate=void 0;if(PAYLOAD.type==='order'){fetchedData=notification.update;orderIdToUpdate=notification.update.id;// const orderFromNotificaion = (notification.related || notification.update) || null;
// if (orderIdToUpdate) {
// 	fetchedData = orderFromNotificaion ?  orderFromNotificaion : (orderIdToUpdate && await fetchOrder(orderIdToUpdate));
// 	notification.update = {
// 		...fetchedData
// 	};
// }
}else if(PAYLOAD.type==='order_provider'||PAYLOAD.type==="payment"){orderIdToUpdate=notification.update.order_id?notification.update.order_id:notification.update.id;if(orderIdToUpdate){// fetchedData = orderIdToUpdate && await fetchOrder(orderIdToUpdate);
// notification.update = {
// 	...fetchedData
// };
fetchedData=notification.update;}}else{fetchedData=notification.related||PAYLOAD.related||PAYLOAD.data||{};notification.update=Object.assign({},fetchedData);}// console.log("PAYLOAD ========>",PAYLOAD);
// console.log("notification ========>",notification);
// console.log("fetchedData ========>",fetchedData);
// console.log("session ========>",session);
_context.t0=PAYLOAD.action;_context.next=_context.t0==='new'?15:_context.t0==='available'?51:_context.t0==='unavailable'?98:_context.t0==='cancelled'?134:_context.t0==='started'?150:_context.t0==='for_delivery'?164:_context.t0==='completed'?177:_context.t0==='refused'?190:_context.t0==='assigned'?207:_context.t0==='shopper_assigned'?221:_context.t0==='unassigned'?235:_context.t0==='shopper_unassigned'?247:_context.t0==='accepted'?259:_context.t0==='changed'?286:_context.t0==='in_service_changed'?335:_context.t0==='being_prepared'?354:_context.t0==='prepared'?369:_context.t0==='in_destination'?376:_context.t0==='collected'?389:_context.t0==='paid'?403:_context.t0==='post_pay'?413:_context.t0==='pool_changed'?420:_context.t0==='inventory_outdated'?428:_context.t0==='payment_reported'?436:449;break;case 15:_context.t1=PAYLOAD.type;_context.next=_context.t1==='order'?18:_context.t1==='clientrating'?29:_context.t1==='rating'?35:_context.t1==='bid'?40:_context.t1==='pending_action'?47:49;break;case 18:if(!(PAYLOAD.data&&PAYLOAD.data.number!==null&&session.admin_type_id===2)){_context.next=20;break;}return _context.abrupt('return');case 20:/*if (activeBranch && activeBranch.id && (fetchedData && fetchedData.branch && fetchedData.branch.id) !== activeBranch.id) {
						// soy admin de dondemand, pero estoy viendo otro comercio
						ignorePush = true;
					}*/notification.sticky=true;notification.title=json_lang.firebase.new_order__title;if(fetchedData.branch)notification.title.replace("-",'- '+fetchedData.branch.name+' -');notification.msg=fetchedData.uid?json_lang.firebase.new_order__msg.replace("{number}",fetchedData.uid):json_lang.firebase.new_order__msg.replace(" # {number} ","");if(fetchedData.branch){notification.title.replace("-",'- '+fetchedData.branch.name+' -');notification.msg=fetchedData.branch.name+": "+notification.msg;}notification.url='/order-management/'+orderIdToUpdate;notification.sound=sound&&sound.order_new!=="off"?sound.order_new:null;if(ignorePush&&hasListOfOrdersView){// si estoy en otro comercio solo muestra la notificacion, no puede actualizarme el listado en la tabla ordenes ni nada, solo muestra el push y agregalo en el listado de notificaciones
notification.operation="notification-only";}else{notification.operation="replace-from-paginated-list";//notification.related ? "replace-from-list" : 'append';
notification.storeKey=isMapView?'filteredMapOrders':'orders';}return _context.abrupt('break',50);case 29:fetchedData=notification&&notification.related||{};// await fetchClientRating(notification.update.order_id);
notification.update=Object.assign({},fetchedData);notification.title=json_lang.firebase.new_clientrating__title;notification.msg=json_lang.firebase.new_clientrating__msg.replace("{rate}",fetchedData.rate||'');notification.url='/order-management/'+orderIdToUpdate;return _context.abrupt('break',50);case 35:notification.title=json_lang.firebase.new_rating__title;notification.msg=json_lang.firebase.new_rating__msg;rating_id={};// await fetchRating(notification.update.id);
notification.update=Object.assign({},rating_id);return _context.abrupt('break',50);case 40:notification.title=json_lang.firebase.new_bid__title;notification.msg=json_lang.firebase.new_bid__msg;notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';notification.touchedPropsToReplace=[];/* xHACER: */return _context.abrupt('break',50);case 47:if(userHigherAccess===__WEBPACK_IMPORTED_MODULE_7__constants_general__["h" /* COMPANY_ACCESS */]){notification.title=json_lang.firebase.new_pending_action__title;notification.msg=json_lang.firebase.new_pending_action__msg;notification.update=Object.assign({},fetchedData);}return _context.abrupt('break',50);case 49:return _context.abrupt('break',50);case 50:return _context.abrupt('break',451);case 51:_context.t2=PAYLOAD.type;_context.next=_context.t2==='order'?54:_context.t2==='bid'?60:_context.t2==='good'?67:_context.t2==='payment'?78:_context.t2==='provider'?82:96;break;case 54:notification.title=json_lang.firebase.available_order__title;notification.msg=json_lang.firebase.available_order__msg.replace("{number}",fetchedData.uid||fetchedData.id);notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';return _context.abrupt('break',97);case 60:notification.title=json_lang.firebase.available_bid__title;notification.msg=json_lang.firebase.available_bid__msg;notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';notification.touchedPropsToReplace=[];/* xHACER: */return _context.abrupt('break',97);case 67:_context.t3=notification&&notification.related;if(_context.t3){_context.next=72;break;}_context.next=71;return Object(__WEBPACK_IMPORTED_MODULE_4__api_ondemand__["fetchGood"])(notification.update.id);case 71:_context.t3=_context.sent;case 72:fetchedData=_context.t3;notification.update=Object.assign({},fetchedData);notification.title=json_lang.firebase.available_good__title;notification.msg=json_lang.firebase.available_good__msg.replace("{name}",fetchedData.name);notification.url='/goods-management/'+data.id;return _context.abrupt('break',97);case 78:notification.title=json_lang.firebase.available_payment__title;notification.msg=json_lang.firebase.available_payment__msg.replace("{number}",fetchedData.uid||fetchedData.id);notification.url='/order-management/'+orderIdToUpdate;return _context.abrupt('break',97);case 82:_context.t4=notification&&notification.related;if(_context.t4){_context.next=87;break;}_context.next=86;return Object(__WEBPACK_IMPORTED_MODULE_4__api_ondemand__["fetchProvider"])(notification.update.id);case 86:_context.t4=_context.sent;case 87:fetchedData=_context.t4;notification.update=Object.assign({},fetchedData);notification.title=json_lang.firebase.available_provider__title;notification.msg=json_lang.firebase.available_provider__msg.replace("{provider}",fetchedData.name);notification.operation=hasListOfProvidersView?'replace-from-list':'replace';notification.url='/order-management';notification.storeKey=notification.operation==='replace'?'provider':'providers';notification.touchedPropsToReplace=["status","provider","provider_id","updated_at"];return _context.abrupt('break',97);case 96:return _context.abrupt('break',97);case 97:return _context.abrupt('break',451);case 98:_context.t5=PAYLOAD.type;_context.next=_context.t5==='order'?101:_context.t5==='provider'?108:_context.t5==='good'?121:132;break;case 101:notification.title=json_lang.firebase.unavailable_order__title;notification.msg=json_lang.firebase.unavailable_order__msg.replace("{number}",fetchedData.uid||fetchedData.id);notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';notification.touchedPropsToReplace=["status","provider","provider_id","updated_at"];return _context.abrupt('break',133);case 108:_context.t6=notification&&notification.related;if(_context.t6){_context.next=113;break;}_context.next=112;return Object(__WEBPACK_IMPORTED_MODULE_4__api_ondemand__["fetchProvider"])(notification.update.id);case 112:_context.t6=_context.sent;case 113:fetchedData=_context.t6;notification.update=Object.assign({},fetchedData);notification.title=json_lang.firebase.unavailable_provider__title;notification.operation=hasListOfProvidersView?'replace-from-list':'replace';notification.msg=json_lang.firebase.unavailable_provider__msg.replace("{provider}",fetchedData.name);notification.storeKey=notification.operation==='replace'?'provider':'providers';notification.touchedPropsToReplace=[];/* xHACER: */return _context.abrupt('break',133);case 121:_context.t7=notification&&notification.related;if(_context.t7){_context.next=126;break;}_context.next=125;return Object(__WEBPACK_IMPORTED_MODULE_4__api_ondemand__["fetchGood"])(notification.update.id);case 125:_context.t7=_context.sent;case 126:fetchedData=_context.t7;notification.update=Object.assign({},fetchedData);notification.title=json_lang.firebase.unavailable_good__title;notification.msg=json_lang.firebase.unavailable_good__msg.replace("{name}",fetchedData.name);notification.url='/goods-management/'+data.id;return _context.abrupt('break',133);case 132:return _context.abrupt('break',133);case 133:return _context.abrupt('break',451);case 134:_context.t8=PAYLOAD.type;_context.next=_context.t8==='order'?137:_context.t8==='payment'?146:148;break;case 137:// si yo soy tipo branch y se cancela la orden sin confirmar el pago, no me muestres notificacion de cancelada
if(userHigherAccess!==__WEBPACK_IMPORTED_MODULE_7__constants_general__["h" /* COMPANY_ACCESS */]&&(parseInt(fetchedData.status,10)&__WEBPACK_IMPORTED_MODULE_6__constants_bitwiseOperations__["G" /* WAITING_PAYMENT */])===0){ignorePush=true;}notification.title=json_lang.firebase.canceled_order__title;notification.sound=sound&&sound.order_canceled!=="off"?sound.order_canceled:null;notification.msg=json_lang.firebase.canceled_order__msg.replace("{number}",fetchedData.uid||fetchedData.id);notification.operation='replace';//hasListOfOrdersView ? 'replace-from-list' : 'replace';
notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';notification.touchedPropsToReplace=["status","provider","provider_id","updated_at"];return _context.abrupt('break',149);case 146:ignorePush=true;return _context.abrupt('break',149);case 148:return _context.abrupt('break',149);case 149:return _context.abrupt('break',451);case 150:_context.t9=PAYLOAD.type;_context.next=_context.t9==='order'?153:162;break;case 153:isService=(fetchedData.status&__WEBPACK_IMPORTED_MODULE_6__constants_bitwiseOperations__["o" /* MASK_SERVICE_TYPE */])===__WEBPACK_IMPORTED_MODULE_6__constants_bitwiseOperations__["A" /* TYPE_SERVICES */];status_type=!Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_UtilsOperation__["p" /* isPickUp */])(fetchedData.client_latitude_e6,fetchedData.client_longitude_e6,fetchedData.client_address)&&!isService?json_lang.firebase.the_way:json_lang.firebase.progress;notification.title=json_lang.firebase.started_order__title.replace("{status_type}",status_type);notification.msg=json_lang.firebase.started_order__msg.replace("{number}",fetchedData.uid||fetchedData.id).replace("{status_type}",status_type);notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';notification.touchedPropsToReplace=["status","provider","provider_id","updated_at"];return _context.abrupt('break',163);case 162:return _context.abrupt('break',163);case 163:return _context.abrupt('break',451);case 164:_context.t10=PAYLOAD.type;_context.next=_context.t10==='order'?167:175;break;case 167:// case 'order_provider':
if(userHigherAccess!==__WEBPACK_IMPORTED_MODULE_7__constants_general__["h" /* COMPANY_ACCESS */]){ignorePush=true;}notification.title=json_lang.firebase.started_order__title.replace("{status_type}",json_lang.order_status.arrived);notification.msg=json_lang.firebase.started_order__msg.replace("{number}",fetchedData.uid||fetchedData.id).replace("{status_type}",json_lang.order_status.arrived);notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';notification.touchedPropsToReplace=["status","provider","provider_id","updated_at"];return _context.abrupt('break',176);case 175:return _context.abrupt('break',176);case 176:return _context.abrupt('break',451);case 177:_context.t11=PAYLOAD.type;_context.next=_context.t11==='order'?180:188;break;case 180:notification.title=json_lang.firebase.completed_order__title;notification.sound=sound&&sound.order_delivered!=="off"?sound.order_delivered:null;notification.msg=json_lang.firebase.completed_order__msg.replace("{number}",fetchedData.uid||fetchedData.id);notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';notification.touchedPropsToReplace=["status","provider","provider_id","updated_at"];return _context.abrupt('break',189);case 188:return _context.abrupt('break',189);case 189:return _context.abrupt('break',451);case 190:_context.t12=PAYLOAD.type;_context.next=_context.t12==='order'?193:_context.t12==='bid'?197:205;break;case 193:notification.title=json_lang.firebase.refused_order__title;notification.msg=json_lang.firebase.refused_order__msg.replace("{number}",fetchedData.uid||fetchedData.id);notification.url='/order-management/'+orderIdToUpdate;return _context.abrupt('break',206);case 197:if(userHigherAccess!==__WEBPACK_IMPORTED_MODULE_7__constants_general__["h" /* COMPANY_ACCESS */]){ignorePush=true;}notification.title=json_lang.firebase.refused_bid__title;notification.msg=json_lang.firebase.refused_bid__msg.replace("{number}",fetchedData.uid);notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';notification.touchedPropsToReplace=[];/* xHACER: */return _context.abrupt('break',206);case 205:return _context.abrupt('break',206);case 206:return _context.abrupt('break',451);case 207:_context.t13=PAYLOAD.type;_context.next=_context.t13==='order'?210:219;break;case 210:providerName="";if(fetchedData&&fetchedData.order_providers&&fetchedData.order_providers.length>0){providerName=fetchedData.order_providers[0].provider.name;}else if(fetchedData&&fetchedData.providers&&fetchedData.providers.length){providerName=fetchedData.providers[0].name;}else if(fetchedData&&fetchedData.order_provider_snapshot&&fetchedData.order_provider_snapshot.id){providerName=fetchedData.order_provider_snapshot.provider.name;}else{providerName="un nuevo repartidor";}notification.title=json_lang.firebase.assigned_order__title;notification.msg=json_lang.firebase.assigned_order__msg.replace("{number}",fetchedData.uid||fetchedData.id||"").replace("{provider}",providerName);notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';notification.touchedPropsToReplace=["status","provider","provider_id","updated_at"];return _context.abrupt('break',220);case 219:return _context.abrupt('break',220);case 220:return _context.abrupt('break',451);case 221:_context.t14=PAYLOAD.type;_context.next=_context.t14==='order'?224:233;break;case 224:_providerName="";if(fetchedData&&fetchedData.order_providers&&fetchedData.order_providers.length>0){_providerName=fetchedData.order_providers[0].provider.name;}else if(fetchedData&&fetchedData.providers&&fetchedData.providers.length){_providerName=fetchedData.providers[0].name;}else if(fetchedData&&fetchedData.shopper_snapshot&&fetchedData.shopper_snapshot.id){_providerName=fetchedData.shopper_snapshot.name;}else{_providerName="un nuevo shopper";}notification.title=json_lang.firebase.assigned_order__title;notification.msg=json_lang.firebase.assigned_order__msg.replace("{number}",fetchedData.uid||fetchedData.id||"").replace("{provider}",_providerName);notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';notification.touchedPropsToReplace=["status","provider","provider_id","updated_at"];return _context.abrupt('break',234);case 233:return _context.abrupt('break',234);case 234:return _context.abrupt('break',451);case 235:_context.t15=PAYLOAD.type;_context.next=_context.t15==='order'?238:245;break;case 238:notification.title=json_lang.firebase.unassigned_order__title;notification.msg=json_lang.firebase.unassigned_order__msg.replace("{number}",fetchedData.uid||fetchedData.id||"");notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';notification.touchedPropsToReplace=["status","provider","provider_id","updated_at"];return _context.abrupt('break',246);case 245:return _context.abrupt('break',246);case 246:return _context.abrupt('break',451);case 247:_context.t16=PAYLOAD.type;_context.next=_context.t16==='order'?250:257;break;case 250:notification.title=json_lang.firebase.unassigned_order__title;notification.msg=json_lang.firebase.unassigned_order_shopper__msg.replace("{number}",fetchedData.uid||fetchedData.id||"");notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';notification.touchedPropsToReplace=["status","provider","provider_id","updated_at"];return _context.abrupt('break',258);case 257:return _context.abrupt('break',258);case 258:return _context.abrupt('break',451);case 259:_context.t17=PAYLOAD.type;_context.next=_context.t17==='bid'?262:_context.t17==='order'?269:_context.t17==='payment'?280:284;break;case 262:notification.title=json_lang.firebase.accepted_bid__title;notification.msg=json_lang.firebase.accepted_bid__msg.replace("{number}",fetchedData&&fetchedData.uid||"").replace("{provider}",fetchedData&&fetchedData.providers&&fetchedData.providers[0]&&fetchedData.providers[0].name||"");notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';notification.touchedPropsToReplace=[];/* xHACER: */return _context.abrupt('break',285);case 269:notification.sound=sound&&sound.order_accepted!=="off"?sound.order_accepted:null;notification.title=json_lang.firebase.accepted_order__title;_context.next=273;return json_lang.firebase.accepted_order__msg.replace("{number}",fetchedData&&fetchedData.uid||"").replace("{provider}",fetchedData&&fetchedData.providers&&fetchedData.providers[0]&&fetchedData.providers[0].name||"");case 273:notification.msg=_context.sent;notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';notification.touchedPropsToReplace=["status","provider","provider_id","updated_at"];if(userHigherAccess!==__WEBPACK_IMPORTED_MODULE_7__constants_general__["h" /* COMPANY_ACCESS */]){// si soy branch necesito notificar al usuario recordando que el no puede ver un listado de todas las ordenes
// si el supuesto caso que tengo acceso a varios comercios, y estoy en un comercio distinto al del push.. solo notificame , no puede actualizarme el listado en la tabla ordenes ni nada, solo muestra el push y agregalo en el listado de notificaciones
if(activeBranch&&activeBranch.id&&(fetchedData&&fetchedData.branch&&fetchedData.branch.id)!==activeBranch.id&&hasListOfOrdersView){notification.operation="notification-only";}if(fetchedData.branch){notification.title.replace("-",'- '+fetchedData.branch.name+' -');}notification.msg=fetchedData.uid?json_lang.firebase.new_order__msg.replace("{number}",fetchedData.uid):json_lang.firebase.new_order__msg.replace(" # {number} ","");if(fetchedData.branch){notification.msg=fetchedData.branch.name+": "+notification.msg;}if(PAYLOAD.type&&session.admin_type_id===2){notification.operation=notification.related?"replace-from-list":'append';}}return _context.abrupt('break',285);case 280:notification.title=json_lang.firebase.accepted_payment__title;notification.msg=json_lang.firebase.accepted_payment__msg;notification.url='/order-management/'+orderIdToUpdate;return _context.abrupt('break',285);case 284:return _context.abrupt('break',285);case 285:return _context.abrupt('break',451);case 286:_context.t18=PAYLOAD.type;_context.next=_context.t18==='order'?289:_context.t18==='coupon'?294:_context.t18==='company'?309:_context.t18==='branch'?322:333;break;case 289:notification.title=json_lang.firebase.changed_order__title;notification.msg=json_lang.firebase.changed_order__msg.replace("{number}",fetchedData.uid).replace("{status}",Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_UtilsOperation__["y" /* orderStatus */])(fetchedData.status).text);;notification.url='/order-management/'+orderIdToUpdate;return _context.abrupt('break',334);case 294:_context.t19=notification&&notification.related;if(_context.t19){_context.next=299;break;}_context.next=298;return Object(__WEBPACK_IMPORTED_MODULE_4__api_ondemand__["fetchCoupon"])(notification.update.id);case 298:_context.t19=_context.sent;case 299:coupon=_context.t19;isCouponsListView=['/coupons'].includes(window.location.pathname);notification.update=Object.assign({},coupon);if(userHigherAccess!==__WEBPACK_IMPORTED_MODULE_7__constants_general__["h" /* COMPANY_ACCESS */]){ignorePush=true;}notification.title=json_lang.firebase.changed_coupon__title;notification.msg=json_lang.firebase.changed_coupon__msg.replace("{name}",coupon.name).replace("{status}",Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_UtilsOperation__["e" /* couponStatus */])(coupon.status).text);notification.url='/coupons';notification.storeKey='coupons';notification.operation=isCouponsListView?'replace-from-paginated-list':"notification-only";return _context.abrupt('break',334);case 309:_context.t20=notification&&notification.related;if(_context.t20){_context.next=314;break;}_context.next=313;return Object(__WEBPACK_IMPORTED_MODULE_4__api_ondemand__["fetchCompany"])(notification.update.id);case 313:_context.t20=_context.sent;case 314:company=_context.t20;notification.update=Object.assign({},company);notification.title=json_lang.firebase.changed_company__title;notification.msg=json_lang.firebase.changed_company__msg;notification.url='/settings';notification.storeKey='company';notification.operation='replace';return _context.abrupt('break',334);case 322:if(fetchedData.id){_context.next=326;break;}_context.next=325;return Object(__WEBPACK_IMPORTED_MODULE_4__api_ondemand__["fetchBranch"])(notification.update.id);case 325:fetchedData=_context.sent;case 326:notification.update=Object.assign({},fetchedData);if(activeBranch&&activeBranch.id&&(notification.update&&notification.update.id)===activeBranch.id){localStorage.setItem('activeBranch',JSON.stringify(notification.update));}else{ignorePush=true;}notification.title=json_lang.firebase.changed_branch__title;notification.msg=json_lang.firebase.changed_branch__msg.replace("{branch}",fetchedData.name);notification.url=isBranchListView?'/branchs':'/settings';// si es un usuario owner y cambia el status de la sucursal a en servicio
if(userHigherAccess===__WEBPACK_IMPORTED_MODULE_7__constants_general__["h" /* COMPANY_ACCESS */]/*  || ignorePush */){notification.storeKey=isBranchListView?'branchGroupList':null;notification.operation=isBranchListView?'replace-from-list':null;}else{// si es mi comercio y soy tipo branch actualizame lo que estoy viendo
notification.storeKey='branch';notification.operation='replace';}return _context.abrupt('break',334);case 333:return _context.abrupt('break',334);case 334:return _context.abrupt('break',451);case 335:_context.t21=PAYLOAD.type;_context.next=_context.t21==='branch'?338:352;break;case 338:_context.t22=payload.related||payload.data&&payload.data.data;if(_context.t22){_context.next=343;break;}_context.next=342;return Object(__WEBPACK_IMPORTED_MODULE_4__api_ondemand__["fetchBranch"])(notification.update.id);case 342:_context.t22=_context.sent;case 343:fetchedData=_context.t22;notification.update=Object.assign({},fetchedData);if(activeBranch&&activeBranch.id&&(notification.update&&notification.update.id)===activeBranch.id){ignorePush=false;}else{ignorePush=true;}notification.title=json_lang.firebase.changed_branch__title;notification.msg=json_lang.firebase.changed_branch__msg.replace("{branch}",fetchedData.name);notification.url=isBranchListView?'/branchs':'/settings';notification.sound=sound&&sound.branch_in_service!=="off"?sound.branch_in_service:null;// si es un usuario owner y cambia el status de la sucursal a en servicio
if(userHigherAccess===__WEBPACK_IMPORTED_MODULE_7__constants_general__["h" /* COMPANY_ACCESS */]/*  || ignorePush */){notification.storeKey=isBranchListView?'branchGroupList':null;notification.operation=isBranchListView?'replace-from-list':null;}else{// si es mi comercio y soy tipo branch actualizame lo que estoy viendo
notification.storeKey='branch';notification.operation='replace';}return _context.abrupt('break',353);case 352:return _context.abrupt('break',353);case 353:return _context.abrupt('break',451);case 354:_context.t23=PAYLOAD.type;_context.next=_context.t23==='order'?357:367;break;case 357:/* if (fetchedData
						&& fetchedData.providers
						&& fetchedData.providers.length
					) {
					} */notification.title=json_lang&&json_lang.firebase&&json_lang.firebase.being_prepared_order__title&&json_lang.firebase.being_prepared_order__title.replace("{number}",fetchedData.uid);msg=json_lang.firebase.being_prepared_order__msg.split(".");if(fetchedData.eta){msg=msg.join(".");msg=json_lang.firebase.being_prepared_order__msg.replace("{eta}",fetchedData.eta);}else{msg=msg[0];}notification.msg=msg;notification.sound=sound&&sound.order_being_prepared!=="off"?sound.order_being_prepared:null;notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';notification.touchedPropsToReplace=["status","provider","provider_id","updated_at"];return _context.abrupt('break',368);case 367:return _context.abrupt('break',368);case 368:return _context.abrupt('break',451);case 369:_context.t24=PAYLOAD.type;_context.next=_context.t24==='order'?372:374;break;case 372:if(fetchedData&&!fetchedData.provider_id){notification.title=json_lang.firebase.prepared_order__title.replace("{number}",fetchedData.uid);notification.sound=sound&&sound.order_prepared!=="off"?sound.order_prepared:null;if(fetchedData.is_provider_assigned&&fetchedData.order_provider_snapshot&&fetchedData.order_provider_snapshot.id){notification.msg=json_lang.firebase.prepared_order__msg.replace("{provider}","para el repartidor "+fetchedData.order_provider_snapshot.provider.name);}else{textt=fetchedData.status_data&&fetchedData.status_data.is_provider_required===true?'y no tiene Rider asignado':'';notification.msg=json_lang.firebase.prepared_order__msg.replace("{provider}",textt);}notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';notification.touchedPropsToReplace=["status","provider","provider_id","updated_at"];}else ignorePush=true;return _context.abrupt('break',375);case 374:return _context.abrupt('break',375);case 375:return _context.abrupt('break',451);case 376:_context.t25=PAYLOAD.type;_context.next=_context.t25==='order'?379:387;break;case 379:/* if (userHigherAccess < COMPANY_ACCESS)
						ignorePush = true; */notification.title=json_lang.firebase.in_destination_order__title;notification.sound=sound&&sound.order_arrived!=="off"?sound.order_arrived:null;notification.msg=fetchedData.uid?json_lang.firebase.in_destination_order__msg.replace("{number}",fetchedData.uid):json_lang.firebase.in_destination_order__msg.replace(" # {number} ","");notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';notification.touchedPropsToReplace=["status","provider","provider_id","updated_at"];return _context.abrupt('break',388);case 387:return _context.abrupt('break',388);case 388:return _context.abrupt('break',451);case 389:_context.t26=PAYLOAD.type;_context.next=_context.t26==="order"?392:401;break;case 392:_isService=(fetchedData.status&__WEBPACK_IMPORTED_MODULE_6__constants_bitwiseOperations__["o" /* MASK_SERVICE_TYPE */])===__WEBPACK_IMPORTED_MODULE_6__constants_bitwiseOperations__["A" /* TYPE_SERVICES */];_status_type=!Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_UtilsOperation__["p" /* isPickUp */])(fetchedData.client_latitude_e6,fetchedData.client_longitude_e6,fetchedData.client_address)&&!_isService?json_lang.firebase.the_way:json_lang.firebase.progress;notification.title=json_lang.firebase.started_order__title.replace("{status_type}",_status_type);notification.msg=json_lang.firebase.started_order__msg.replace("{number}",fetchedData.uid||fetchedData.id).replace("{status_type}",_status_type);notification.operation=hasListOfOrdersView?"replace-from-list":"replace";notification.url="/order-management/"+data.id;notification.storeKey=notification.operation==="replace"?"order":isMapView?"filteredMapOrders":"orders";notification.touchedPropsToReplace=["status","provider","provider_id","updated_at"];return _context.abrupt('break',402);case 401:return _context.abrupt('break',402);case 402:return _context.abrupt('break',451);case 403:_context.t27=PAYLOAD.type;_context.next=_context.t27==='order'?406:411;break;case 406:// hoy 15-10-2020 cae en este caso, si se pago por efectivo (digo por si cambia en el futuro o se agregan nuevos casos)
notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';if(userHigherAccess!==__WEBPACK_IMPORTED_MODULE_7__constants_general__["h" /* COMPANY_ACCESS */]){notification.title=json_lang.firebase.available_order__title;notification.msg=json_lang.firebase.available_order__msg.replace("{number}",fetchedData.uid||fetchedData.id);}else{notification.title=json_lang.firebase.paid_order__msg;notification.msg=fetchedData.uid?json_lang.firebase.paid_order__title.replace("{number}",fetchedData.uid):json_lang.firebase.paid_order__title.replace(" # {number} ","");if(fetchedData.branch){notification.title.replace("-",'- '+fetchedData.branch.name+' -');notification.msg=fetchedData.branch.name+": "+notification.msg;}// pero si el supuesto caso que tengo acceso a varios comercios, y estoy en un comercio distinto al del push.. solo notificame , no puede actualizarme el listado en la tabla ordenes ni nada, solo muestra el push y agregalo en el listado de notificaciones
if(activeBranch&&activeBranch.id&&(fetchedData&&fetchedData.branch&&fetchedData.branch.id)!==activeBranch.id&&hasListOfOrdersView){notification.operation="notification-only";}else{notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.storeKey=isMapView?'filteredMapOrders':'orders';}}return _context.abrupt('break',412);case 411:return _context.abrupt('break',412);case 412:return _context.abrupt('break',451);case 413:_context.t28=PAYLOAD.type;_context.next=_context.t28==='order'?416:418;break;case 416:ignorePush=true;return _context.abrupt('break',419);case 418:return _context.abrupt('break',419);case 419:return _context.abrupt('break',451);case 420:_context.t29=PAYLOAD.type;_context.next=_context.t29==='order'?423:426;break;case 423://console.log("notification.update",notification,PAYLOAD)
notification.title=json_lang.firebase.pool_changed__title;notification.msg=json_lang.firebase.pool_changed__msg.replace("{number}",fetchedData.uid||fetchedData.id);return _context.abrupt('break',427);case 426:return _context.abrupt('break',427);case 427:return _context.abrupt('break',451);case 428:_context.t30=PAYLOAD.type;_context.next=_context.t30==='branch'?431:435;break;case 431:notification.title=json_lang.firebase.inventory_outdated__title;notification.msg=json_lang.firebase.inventory_outdated__msg.replace("{name}",fetchedData.name||"");if(activeBranch&&activeBranch.id&&(notification.update&&notification.update.id)===activeBranch.id){notification.url='/goods-management';}else{notification.url='/';}return _context.abrupt('break',435);case 435:return _context.abrupt('break',451);case 436:_context.t31=PAYLOAD.type;_context.next=_context.t31==='order'?439:447;break;case 439:if(!(userHigherAccess===__WEBPACK_IMPORTED_MODULE_7__constants_general__["h" /* COMPANY_ACCESS */])){// si soy owner oculta
ignorePush=true;}notification.title=json_lang.firebase.new_payment__title;notification.sound=sound&&sound.payment_new!=="off"?sound.payment_new:null;notification.msg=json_lang.firebase.new_payment__msg.replace("{number}",fetchedData&&fetchedData.uid);notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';//notification.touchedPropsToReplace = ["status"]; */
return _context.abrupt('break',448);case 447:return _context.abrupt('break',448);case 448:return _context.abrupt('break',451);case 449:// case "orden no entregada":
if((notification.update.status&(0x2000|0x18000))===(0x2000|0x18000)){notification.title=json_lang.firebase.order_not_delivered__title;notification.msg=json_lang.firebase.order_not_delivered__msg.replace("{number}",fetchedData.uid||fetchedData.id);notification.operation=hasListOfOrdersView?'replace-from-list':'replace';notification.url='/order-management/'+orderIdToUpdate;notification.storeKey=notification.operation==='replace'?'order':isMapView?'filteredMapOrders':'orders';notification.touchedPropsToReplace=["status","provider","provider_id","updated_at"];}// case dafault:
else{//notification.title = json_lang.firebase.default__title;
//notification.msg = json_lang.firebase.default__msg.replace("{type}", PAYLOAD.type);
}return _context.abrupt('break',451);case 451:if(!(notification&&notification.update&&notification.update.error)){_context.next=453;break;}throw notification.update.error;case 453:if(!(ignorePush&&userHigherAccess!==__WEBPACK_IMPORTED_MODULE_7__constants_general__["h" /* COMPANY_ACCESS */])){_context.next=455;break;}return _context.abrupt('return');case 455:if(notification.title){_context.next=457;break;}return _context.abrupt('return');case 457:return _context.abrupt('return',notification);case 458:case'end':return _context.stop();}}},_callee,_this);}));return function notificationOptionSetting(_x,_x2,_x3,_x4,_x5){return _ref.apply(this,arguments);};}();/* ONLINE STATUS API CALL */var ONLINE_STATUS_INTERVAL=void 0;var onlineStatusApiCall=function onlineStatusApiCall(){if(Boolean(localStorage.getItem('user'))&&__WEBPACK_IMPORTED_MODULE_3__store_store_js__["a" /* default */].getState().userIsOnline){__WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_3__store_store_js__["a" /* default */].getState().company.id+'/admins/'+__WEBPACK_IMPORTED_MODULE_3__store_store_js__["a" /* default */].getState().session.id+'/set-online').then(function(){localStorage.setItem('userIsOnline',true);}).catch(function(err){localStorage.setItem('userIsOnline',false);clearInterval(ONLINE_STATUS_INTERVAL);});}};// send this request every 12 minutes in case... slow connections
ONLINE_STATUS_INTERVAL=window.setInterval(onlineStatusApiCall,750000);//180000)

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(112);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * rc-datetime-picker v1.6.1
 * https://github.com/AllenWooooo/rc-datetime-picker
 *
 * (c) 2018 Allen Wu
 * License: MIT
 */


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var classNames = _interopDefault(__webpack_require__(635));
var blacklist = _interopDefault(__webpack_require__(636));
var moment = _interopDefault(__webpack_require__(26));
var ReactSlider = _interopDefault(__webpack_require__(637));
var ReactDOM = __webpack_require__(12);
var ReactDOM__default = _interopDefault(ReactDOM);

var WEEKS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var DAY_FORMAT = 'MMMM, YYYY';
var CONFIRM_BUTTON_TEXT = 'Confirm';
var START_DATE_TEXT = 'Start Date:';
var END_DATE_TEXT = 'End Date:';
var CUSTOM_BUTTON_TEXT = 'Custom';

var range = function range(start, end) {
  var length = Math.max(end - start, 0);
  var result = [];

  while (length--) {
    result[length] = start + length;
  }

  return result;
};

var chunk = function chunk(array, size) {
  var length = array.length;
  var index = 0;
  var resIndex = -1;
  var result = [];

  while (index < length) {
    result[++resIndex] = array.slice(index, index += size);
  }

  return result;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Day = function (_Component) {
  inherits(Day, _Component);

  function Day(props) {
    classCallCheck(this, Day);

    var _this = possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).call(this, props));

    _this.changeMonth = function (dir) {
      var _moment = _this.state.moment.clone();

      _this.setState({
        moment: _moment[dir === 'prev' ? 'subtract' : 'add'](1, 'month')
      });
    };

    _this.select = function (day, isSelected, isDisabled, isPrevMonth, isNextMonth) {
      if (isDisabled) return;
      var _this$props = _this.props,
          range$$1 = _this$props.range,
          onSelect = _this$props.onSelect;

      var _moment = _this.state.moment.clone();

      if (isPrevMonth) _moment.subtract(1, 'month');
      if (isNextMonth) _moment.add(1, 'month');

      _moment.date(day);

      _this.setState({
        moment: range$$1 ? _this.state.moment : _moment
      });
      onSelect(_moment);
    };

    _this._renderWeek = function (week) {
      return React__default.createElement(
        'th',
        { key: week },
        week
      );
    };

    _this._renderDay = function (week, day) {
      var _this$props2 = _this.props,
          maxDate = _this$props2.maxDate,
          minDate = _this$props2.minDate,
          range$$1 = _this$props2.range,
          rangeAt = _this$props2.rangeAt,
          selected = _this$props2.selected,
          dateLimit = _this$props2.dateLimit;

      var now = moment();
      var _moment = _this.state.moment;
      var isPrevMonth = week === 0 && day > 7;
      var isNextMonth = week >= 4 && day <= 14;
      var month = isNextMonth ? _moment.clone().add(1, 'month') : isPrevMonth ? _moment.clone().subtract(1, 'month') : _moment.clone();
      var currentDay = month.clone().date(day);
      var start = selected && range$$1 ? selected.start ? currentDay.isSame(selected.start, 'day') : false : false;
      var end = selected && range$$1 ? selected.end ? currentDay.isSame(selected.end, 'day') : false : false;
      var between = selected && range$$1 ? selected.start && selected.end ? currentDay.isBetween(selected.start, selected.end, 'day') : false : false;
      var isSelected = selected ? range$$1 ? rangeAt === 'start' && start || rangeAt === 'end' && end : currentDay.isSame(selected, 'day') : false;
      var disabledMax = maxDate ? currentDay.isAfter(maxDate, 'day') : false;
      var disabledMin = minDate ? currentDay.isBefore(minDate, 'day') : false;
      var disabled = false;
      var limited = false;

      if (range$$1) {
        if (rangeAt === 'start' && selected && selected.end) {
          disabled = currentDay.isAfter(selected.end, 'day');
        } else if (rangeAt === 'end' && selected && selected.start) {
          disabled = currentDay.isBefore(selected.start, 'day');
        }
      }

      if (dateLimit && range$$1) {
        var limitKey = Object.keys(dateLimit)[0];
        var limitValue = dateLimit[limitKey];
        var minLimitedDate = void 0,
            maxLimitedDate = void 0;

        if (selected) {

          if (rangeAt === 'start' && selected.end) {
            maxLimitedDate = selected.end.clone();
            minLimitedDate = maxLimitedDate.clone().subtract(limitValue, limitKey);
          } else if (rangeAt === 'end' && selected.start) {
            minLimitedDate = selected.start.clone();
            maxLimitedDate = minLimitedDate.clone().add(limitValue, limitKey);
          }

          if (minLimitedDate && maxLimitedDate) {
            limited = !currentDay.isBetween(minLimitedDate, maxLimitedDate, 'day', rangeAt === 'start' ? '(]' : '[)');
          }
        }
      }

      var isDisabled = disabledMax || disabledMin || disabled || limited;
      var className = classNames({
        prev: isPrevMonth,
        next: isNextMonth,
        selected: isSelected,
        now: now.isSame(currentDay, 'day'),
        disabled: isDisabled,
        start: start,
        end: end,
        between: between
      });

      return React__default.createElement(
        'td',
        {
          key: day,
          className: className,
          onClick: _this.select.bind(_this, day, isSelected, isDisabled, isPrevMonth, isNextMonth) },
        day
      );
    };

    _this.state = {
      moment: props.moment
    };
    return _this;
  }

  createClass(Day, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({
        moment: props.moment
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$weeks = _props.weeks,
          weeks = _props$weeks === undefined ? WEEKS : _props$weeks,
          _props$dayFormat = _props.dayFormat,
          dayFormat = _props$dayFormat === undefined ? DAY_FORMAT : _props$dayFormat,
          style = _props.style,
          changePanel = _props.changePanel;

      var _moment = this.state.moment;
      var firstDay = _moment.clone().date(1).day();
      var endOfThisMonth = _moment.clone().endOf('month').date();
      var endOfLastMonth = _moment.clone().subtract(1, 'month').endOf('month').date();
      var days = [].concat(range(endOfLastMonth - firstDay + 1, endOfLastMonth + 1), range(1, endOfThisMonth + 1), range(1, 42 - endOfThisMonth - firstDay + 1));

      return React__default.createElement(
        'div',
        { className: 'calendar-days', style: style },
        React__default.createElement(
          'div',
          { className: 'calendar-nav' },
          React__default.createElement(
            'button',
            { type: 'button', className: 'prev-month', onClick: this.changeMonth.bind(this, 'prev') },
            React__default.createElement('i', { className: 'fa fa-angle-left' })
          ),
          React__default.createElement(
            'span',
            { className: 'current-date', onClick: changePanel.bind(this, 'month', _moment) },
            _moment.format(dayFormat)
          ),
          React__default.createElement(
            'button',
            { type: 'button', className: 'next-month', onClick: this.changeMonth.bind(this, 'next') },
            React__default.createElement('i', { className: 'fa fa-angle-right' })
          )
        ),
        React__default.createElement(
          'table',
          null,
          React__default.createElement(
            'thead',
            null,
            React__default.createElement(
              'tr',
              null,
              weeks.map(function (week) {
                return _this2._renderWeek(week);
              })
            )
          ),
          React__default.createElement(
            'tbody',
            null,
            chunk(days, 7).map(function (week, idx) {
              return React__default.createElement(
                'tr',
                { key: idx },
                week.map(_this2._renderDay.bind(_this2, idx))
              );
            })
          )
        )
      );
    }
  }]);
  return Day;
}(React.Component);

var Month = function (_Component) {
  inherits(Month, _Component);

  function Month(props) {
    classCallCheck(this, Month);

    var _this = possibleConstructorReturn(this, (Month.__proto__ || Object.getPrototypeOf(Month)).call(this, props));

    _this.changeYear = function (dir) {
      var _moment = _this.state.moment.clone();

      _this.setState({
        moment: _moment[dir === 'prev' ? 'subtract' : 'add'](1, 'year')
      });
    };

    _this.select = function (month, isDisabled) {
      if (isDisabled) return;
      var onSelect = _this.props.onSelect;

      var _moment = _this.state.moment.clone();

      _moment.month(month);

      _this.setState({
        moment: _moment
      });
      onSelect(_moment);
    };

    _this._renderMonth = function (row, month, idx) {
      var now = moment();
      var _moment = _this.state.moment;
      var _this$props = _this.props,
          maxDate = _this$props.maxDate,
          minDate = _this$props.minDate,
          months = _this$props.months,
          selected = _this$props.selected,
          range$$1 = _this$props.range,
          rangeAt = _this$props.rangeAt,
          dateLimit = _this$props.dateLimit;

      var currentMonth = _moment.clone().month(month);
      var start = selected && range$$1 ? selected.start ? currentMonth.isSame(selected.start, 'month') : false : false;
      var end = selected && range$$1 ? selected.end ? currentMonth.isSame(selected.end, 'month') : false : false;
      var between = selected && range$$1 ? selected.start && selected.end ? currentMonth.isBetween(selected.start, selected.end, 'month') : false : false;
      var isSelected = selected ? range$$1 ? selected[rangeAt] ? currentMonth.isSame(selected[rangeAt], 'month') : false : currentMonth.isSame(selected, 'day') : false;
      var disabledMax = maxDate ? currentMonth.isAfter(maxDate, 'month') : false;
      var disabledMin = minDate ? currentMonth.isBefore(minDate, 'month') : false;
      var disabled = false;
      var limited = false;

      if (range$$1) {
        if (rangeAt === 'start' && selected && selected.end) {
          disabled = selected.end && currentMonth.isAfter(selected.end, 'day');
        } else if (rangeAt === 'end' && selected && selected.start) {
          disabled = selected.start && currentMonth.isBefore(selected.start, 'day');
        }
      }

      if (dateLimit && range$$1) {
        var limitKey = Object.keys(dateLimit)[0];
        var limitValue = dateLimit[limitKey];
        var minLimitedDate = void 0,
            maxLimitedDate = void 0;

        if (selected) {

          if (rangeAt === 'start' && selected.start && selected.end) {
            maxLimitedDate = selected.end.clone();
            minLimitedDate = maxLimitedDate.clone().subtract(limitValue, limitKey);
          } else if (rangeAt === 'end' && selected.start && selected.end) {
            minLimitedDate = selected.start.clone();
            maxLimitedDate = minLimitedDate.clone().add(limitValue, limitKey);
          }

          if (minLimitedDate && maxLimitedDate) {
            limited = !currentMonth.isBetween(minLimitedDate, maxLimitedDate, 'day', rangeAt === 'start' ? '(]' : '[)');
          }
        }
      }

      var isDisabled = disabledMax || disabledMin || disabled || limited;
      var className = classNames({
        selected: isSelected,
        now: now.isSame(currentMonth, 'month'),
        disabled: isDisabled,
        start: start,
        end: end,
        between: between
      });

      return React__default.createElement(
        'td',
        {
          key: month,
          className: className,
          onClick: _this.select.bind(_this, month, isDisabled) },
        months ? months[idx + row * 3] : month
      );
    };

    _this.state = {
      moment: props.moment
    };
    return _this;
  }

  createClass(Month, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({
        moment: props.moment
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _moment = this.state.moment;
      var months = MONTHS;
      var _props = this.props,
          changePanel = _props.changePanel,
          style = _props.style;


      return React__default.createElement(
        'div',
        { className: 'calendar-months', style: style },
        React__default.createElement(
          'div',
          { className: 'calendar-nav' },
          React__default.createElement(
            'button',
            { type: 'button', className: 'prev-month', onClick: this.changeYear.bind(this, 'prev') },
            React__default.createElement('i', { className: 'fa fa-angle-left' })
          ),
          React__default.createElement(
            'span',
            { className: 'current-date', onClick: changePanel.bind(this, 'year', _moment) },
            _moment.format('YYYY')
          ),
          React__default.createElement(
            'button',
            { type: 'button', className: 'next-month', onClick: this.changeYear.bind(this, 'next') },
            React__default.createElement('i', { className: 'fa fa-angle-right' })
          )
        ),
        React__default.createElement(
          'table',
          null,
          React__default.createElement(
            'tbody',
            null,
            chunk(months, 3).map(function (_months, idx) {
              return React__default.createElement(
                'tr',
                { key: idx },
                _months.map(_this2._renderMonth.bind(_this2, idx))
              );
            })
          )
        )
      );
    }
  }]);
  return Month;
}(React.Component);

var Year = function (_Component) {
  inherits(Year, _Component);

  function Year(props) {
    classCallCheck(this, Year);

    var _this = possibleConstructorReturn(this, (Year.__proto__ || Object.getPrototypeOf(Year)).call(this, props));

    _this.changePeriod = function (dir) {
      var _moment = _this.state.moment.clone();

      _this.setState({
        moment: _moment[dir === 'prev' ? 'subtract' : 'add'](10, 'year')
      });
    };

    _this.select = function (year, isDisabled) {
      if (isDisabled) return;
      var _moment = _this.state.moment.clone();

      _moment.year(year);

      _this.setState({
        moment: _moment,
        selected: _moment
      });
      _this.props.onSelect(_moment);
    };

    _this._renderYear = function (year) {
      var now = moment();
      var _moment = _this.state.moment;
      var firstYear = Math.floor(_moment.year() / 10) * 10;
      var _this$props = _this.props,
          maxDate = _this$props.maxDate,
          minDate = _this$props.minDate,
          selected = _this$props.selected,
          range$$1 = _this$props.range,
          rangeAt = _this$props.rangeAt,
          dateLimit = _this$props.dateLimit;

      var currentYear = _moment.clone().year(year);
      var start = selected && range$$1 ? selected.start ? currentYear.isSame(selected.start, 'year') : false : false;
      var end = selected && range$$1 ? selected.end ? currentYear.isSame(selected.end, 'year') : false : false;
      var between = selected && range$$1 ? selected.start && selected.end ? currentYear.isBetween(selected.start, selected.end, 'year') : false : false;
      var isSelected = selected ? range$$1 ? selected[rangeAt] ? selected[rangeAt].year() === year : false : selected.year() === year : false;
      var disabledMax = maxDate ? year > maxDate.year() : false;
      var disabledMin = minDate ? year < minDate.year() : false;
      var disabled = false;
      var limited = false;

      if (range$$1) {
        if (rangeAt === 'start' && selected && selected.end) {
          disabled = selected.end && currentYear.isAfter(selected.end, 'day');
        } else if (rangeAt === 'end' && selected && selected.start) {
          disabled = selected.start && currentYear.isBefore(selected.start, 'day');
        }
      }

      if (dateLimit && range$$1) {
        var limitKey = Object.keys(dateLimit)[0];
        var limitValue = dateLimit[limitKey];
        var minLimitedDate = void 0,
            maxLimitedDate = void 0;

        if (selected) {

          if (rangeAt === 'start' && selected.start && selected.end) {
            maxLimitedDate = selected.end.clone();
            minLimitedDate = maxLimitedDate.clone().subtract(limitValue, limitKey);
          } else if (rangeAt === 'end' && selected.start && selected.end) {
            minLimitedDate = selected.start.clone();
            maxLimitedDate = minLimitedDate.clone().add(limitValue, limitKey);
          }

          if (minLimitedDate && maxLimitedDate) {
            limited = !currentYear.isBetween(minLimitedDate, maxLimitedDate, 'day', rangeAt === 'start' ? '(]' : '[)');
          }
        }
      }

      var isDisabled = disabledMax || disabledMin || disabled || limited;
      var className = classNames({
        selected: isSelected,
        now: now.year() === year,
        prev: firstYear - 1 === year,
        next: firstYear + 10 === year,
        disabled: isDisabled,
        start: start,
        end: end,
        between: between
      });

      return React__default.createElement(
        'td',
        { key: year, className: className, onClick: _this.select.bind(_this, year, isDisabled) },
        year
      );
    };

    _this.state = {
      moment: props.moment
    };
    return _this;
  }

  createClass(Year, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({
        moment: props.moment
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _moment = this.state.moment;
      var style = this.props.style;

      var firstYear = Math.floor(_moment.year() / 10) * 10;
      var years = range(firstYear - 1, firstYear + 11);

      return React__default.createElement(
        'div',
        { className: 'calendar-years', style: style },
        React__default.createElement(
          'div',
          { className: 'calendar-nav' },
          React__default.createElement(
            'button',
            { type: 'button', className: 'prev-month', onClick: this.changePeriod.bind(this, 'prev') },
            React__default.createElement('i', { className: 'fa fa-angle-left' })
          ),
          React__default.createElement(
            'span',
            { className: 'current-date disabled' },
            firstYear,
            ' - ',
            firstYear + 9
          ),
          React__default.createElement(
            'button',
            { type: 'button', className: 'next-month', onClick: this.changePeriod.bind(this, 'next') },
            React__default.createElement('i', { className: 'fa fa-angle-right' })
          )
        ),
        React__default.createElement(
          'table',
          null,
          React__default.createElement(
            'tbody',
            null,
            chunk(years, 4).map(function (_years, idx) {
              return React__default.createElement(
                'tr',
                { key: idx },
                _years.map(_this2._renderYear)
              );
            })
          )
        )
      );
    }
  }]);
  return Year;
}(React.Component);

// import moment from 'moment';
var moment$1 = __webpack_require__(26);

var Calendar = function (_Component) {
  inherits(Calendar, _Component);

  function Calendar(props) {
    classCallCheck(this, Calendar);

    var _this = possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      moment: _this.getCurrentMoment(props),
      panel: props.minPanel || 'day'
    };
    return _this;
  }

  createClass(Calendar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({
        moment: this.getCurrentMoment(props)
      });

      if (!props.isOpen) {
        this.setState({
          panel: props.minPanel || 'day'
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          weeks = _props.weeks,
          months = _props.months,
          dayFormat = _props.dayFormat,
          style = _props.style,
          maxDate = _props.maxDate,
          minDate = _props.minDate,
          dateLimit = _props.dateLimit,
          range = _props.range,
          rangeAt = _props.rangeAt;

      var props = {
        moment: this.state.moment,
        selected: this.props.moment,
        onSelect: this.handleSelect,
        changePanel: this.changePanel,
        weeks: weeks,
        months: months,
        dayFormat: dayFormat,
        maxDate: maxDate,
        minDate: minDate,
        dateLimit: dateLimit,
        range: range,
        rangeAt: rangeAt
      };
      var panel = this.state.panel;

      var isDayPanel = panel === 'day';
      var isMonthPanel = panel === 'month';
      var isYearPanel = panel === 'year';

      return React__default.createElement(
        'div',
        { style: style },
        React__default.createElement(
          'div',
          { className: 'calendar' },
          React__default.createElement(Day, _extends({}, props, {
            style: { display: isDayPanel ? 'block' : 'none' } })),
          React__default.createElement(Month, _extends({}, props, {
            style: { display: isMonthPanel ? 'block' : 'none' } })),
          React__default.createElement(Year, _extends({}, props, {
            style: { display: isYearPanel ? 'block' : 'none' } }))
        )
      );
    }
  }]);
  return Calendar;
}(React.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getCurrentMoment = function (props) {
    var range = props.range,
        rangeAt = props.rangeAt;

    var now = _this2.state ? _this2.state.moment || moment$1() : moment$1();
    var result = props.moment;

    if (result) {
      if (range) {
        result = result[rangeAt] || now;
      }
    } else {
      result = now;
    }

    return result;
  };

  this.handleSelect = function (selected) {
    var panel = _this2.state.panel;
    var _props2 = _this2.props,
        onChange = _props2.onChange,
        range = _props2.range,
        rangeAt = _props2.rangeAt,
        minPanel = _props2.minPanel;

    var nextPanel = (panel === 'year' ? 'month' : 'day') === 'month' ? minPanel === 'year' ? 'year' : 'month' : minPanel === 'month' ? 'month' : 'day';
    var _selected = _this2.props.moment;
    var shouldChange = panel === minPanel;

    if (_selected && !shouldChange) {
      if (range) {
        shouldChange = rangeAt === 'start' ? _selected.start : _selected.end;
      } else {
        shouldChange = true;
      }
    }

    if (range) {
      var copyed = _selected ? _extends({}, _selected) : {};

      copyed[rangeAt] = selected;
      _selected = copyed;
    } else {
      _selected = selected;
    }

    _this2.changePanel(nextPanel, selected);

    if (shouldChange) {
      onChange && onChange(_selected, panel);
    }
  };

  this.changePanel = function (panel) {
    var moment$$1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this2.state.moment;

    _this2.setState({
      moment: moment$$1,
      panel: panel
    });
  };
};

var Time = function (_Component) {
  inherits(Time, _Component);

  function Time(props) {
    classCallCheck(this, Time);

    var _this = possibleConstructorReturn(this, (Time.__proto__ || Object.getPrototypeOf(Time)).call(this, props));

    _initialiseProps$1.call(_this);

    _this.state = {
      moment: _this.getCurrentMoment(props)
    };
    return _this;
  }

  createClass(Time, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({
        moment: this.getCurrentMoment(props)
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _moment = this.state.moment;
      var style = this.props.style;


      return React__default.createElement(
        'div',
        { style: style },
        React__default.createElement(
          'div',
          { className: 'time' },
          React__default.createElement(
            'div',
            { className: 'show-time' },
            React__default.createElement(
              'span',
              { className: 'text' },
              _moment.format('HH')
            ),
            React__default.createElement(
              'span',
              { className: 'separater' },
              ':'
            ),
            React__default.createElement(
              'span',
              { className: 'text' },
              _moment.format('mm')
            )
          ),
          React__default.createElement(
            'div',
            { className: 'sliders' },
            React__default.createElement(
              'span',
              { className: 'slider-text' },
              'Hours:'
            ),
            React__default.createElement(ReactSlider, { min: 0, max: 23, value: _moment.hour(), onChange: this.handleChange.bind(this, 'hours'), withBars: true }),
            React__default.createElement(
              'span',
              { className: 'slider-text' },
              'Minutes:'
            ),
            React__default.createElement(ReactSlider, { min: 0, max: 59, value: _moment.minute(), onChange: this.handleChange.bind(this, 'minutes'), withBars: true })
          )
        )
      );
    }
  }]);
  return Time;
}(React.Component);

var _initialiseProps$1 = function _initialiseProps() {
  var _this2 = this;

  this.getCurrentMoment = function (props) {
    var range = props.range,
        rangeAt = props.rangeAt;

    var result = props.moment;

    if (result) {
      if (range) {
        result = result[rangeAt] || moment().hours(0).minutes(0);
      }
    } else {
      result = moment().hours(0).minutes(0);
    }

    return result;
  };

  this.handleChange = function (type, value) {
    var _props = _this2.props,
        onChange = _props.onChange,
        range = _props.range,
        rangeAt = _props.rangeAt;

    var _moment = _this2.state.moment.clone();
    var selected = _this2.props.moment;

    _moment[type](value);

    if (range) {
      var copyed = selected ? Object.assign(selected, {}) : {};

      copyed[rangeAt] = _moment;
    } else {
      selected = _moment;
    }

    _this2.setState({
      moment: _moment
    });
    onChange && onChange(selected);
  };
};

var isSameRange = function isSameRange(current, value) {
  return current.start && current.end && current.start.isSame(value.start, 'day') && current.end.isSame(value.end, 'day');
};

var Shortcuts = function (_Component) {
  inherits(Shortcuts, _Component);

  function Shortcuts() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Shortcuts);

    for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Shortcuts.__proto__ || Object.getPrototypeOf(Shortcuts)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (value, isCustom) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          range = _this$props.range;


      if (range) {
        onChange && onChange(value, isCustom);
      } else {
        onChange && onChange(value, 'day');
      }
    }, _this._renderShortcut = function (key, value) {
      var _this$props2 = _this.props,
          range = _this$props2.range,
          shortcuts = _this$props2.shortcuts,
          _this$props2$customBu = _this$props2.customButtonText,
          customButtonText = _this$props2$customBu === undefined ? CUSTOM_BUTTON_TEXT : _this$props2$customBu;

      var current = _this.props.moment;
      var selected = range ? key !== 'custom' && isSameRange(current, value) : false;
      var isCustomSelected = range ? !Object.keys(shortcuts).some(function (_key) {
        return isSameRange(current, shortcuts[_key]);
      }) && key === 'custom' : false;
      var className = classNames('btn', {
        selected: selected || isCustomSelected
      });

      return React__default.createElement(
        'button',
        {
          className: className,
          key: key,
          type: 'button',
          onClick: _this.handleClick.bind(_this, value, key === 'custom') },
        key === 'custom' ? customButtonText : key
      );
    }, _this._renderShortcuts = function () {
      var _this$props3 = _this.props,
          shortcuts = _this$props3.shortcuts,
          showCustomButton = _this$props3.showCustomButton,
          customRange = _this$props3.customRange;

      var renderShortcuts = showCustomButton ? _extends({}, shortcuts, {
        custom: customRange || {
          start: moment().subtract(29, 'days'),
          end: moment().endOf('day')
        }
      }) : shortcuts;

      return Object.keys(renderShortcuts).map(function (key) {
        return _this._renderShortcut(key, renderShortcuts[key]);
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Shortcuts, [{
    key: 'render',
    value: function render() {

      return React__default.createElement(
        'div',
        { className: 'shortcuts-bar' },
        this._renderShortcuts()
      );
    }
  }]);
  return Shortcuts;
}(React.Component);

var Picker = function (_Component) {
  inherits(Picker, _Component);

  function Picker() {
    classCallCheck(this, Picker);

    var _this = possibleConstructorReturn(this, (Picker.__proto__ || Object.getPrototypeOf(Picker)).call(this));

    _this.changePanel = function (panel) {
      _this.setState({
        panel: panel
      });
    };

    _this.state = {
      panel: 'calendar'
    };
    return _this;
  }

  createClass(Picker, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$isOpen = _props.isOpen,
          isOpen = _props$isOpen === undefined ? true : _props$isOpen,
          shortcuts = _props.shortcuts,
          splitPanel = _props.splitPanel,
          _props$showTimePicker = _props.showTimePicker,
          showTimePicker = _props$showTimePicker === undefined ? true : _props$showTimePicker,
          _props$showCalendarPi = _props.showCalendarPicker,
          showCalendarPicker = _props$showCalendarPi === undefined ? true : _props$showCalendarPi;
      var panel = this.state.panel;

      var isTimePanel = panel === 'time';
      var isCalendarPanel = panel === 'calendar';
      var className = classNames('datetime-picker', this.props.className, {
        split: splitPanel
      });
      var props = blacklist(this.props, 'className', 'splitPanel', 'isOpen');

      return React__default.createElement(
        'div',
        { className: className, style: { display: isOpen ? 'block' : 'none' }, onClick: function onClick(evt) {
            return evt.stopPropagation();
          } },
        shortcuts ? React__default.createElement(Shortcuts, props) : undefined,
        splitPanel ? React__default.createElement(
          'div',
          { className: 'panel-nav' },
          React__default.createElement(
            'button',
            { type: 'button', onClick: this.changePanel.bind(this, 'calendar'), className: isCalendarPanel ? 'active' : '' },
            React__default.createElement('i', { className: 'fa fa-calendar-o' }),
            'Date'
          ),
          React__default.createElement(
            'button',
            { type: 'button', onClick: this.changePanel.bind(this, 'time'), className: isTimePanel ? 'active' : '' },
            React__default.createElement('i', { className: 'fa fa-clock-o' }),
            'Time'
          )
        ) : undefined,
        showCalendarPicker ? React__default.createElement(Calendar, _extends({}, props, { isOpen: isOpen, style: { display: isCalendarPanel || !splitPanel ? 'block' : 'none' } })) : undefined,
        showTimePicker ? React__default.createElement(Time, _extends({}, props, { style: { display: isTimePanel || !splitPanel ? 'block' : 'none' } })) : undefined
      );
    }
  }]);
  return Picker;
}(React.Component);

var Range = function (_Component) {
  inherits(Range, _Component);

  function Range(props) {
    classCallCheck(this, Range);

    var _this = possibleConstructorReturn(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, props));

    _this.handleChange = function (moment$$1) {
      _this.setState({
        moment: moment$$1
      });
    };

    _this.handleShortcutChange = function (moment$$1, isCustom) {
      var onChange = _this.props.onChange;


      if (isCustom) {
        _this.setState({
          moment: moment$$1
        });
      } else {
        onChange && onChange(moment$$1);
      }
    };

    _this.onConfirm = function () {
      var moment$$1 = _this.state.moment;
      var onChange = _this.props.onChange;


      onChange && onChange(moment$$1);
    };

    _this.state = {
      moment: props.moment
    };
    return _this;
  }

  createClass(Range, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({
        moment: props.moment
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var moment$$1 = this.state.moment;
      var _props = this.props,
          format = _props.format,
          _props$showTimePicker = _props.showTimePicker,
          showTimePicker = _props$showTimePicker === undefined ? false : _props$showTimePicker,
          _props$isOpen = _props.isOpen,
          isOpen = _props$isOpen === undefined ? true : _props$isOpen,
          shortcuts = _props.shortcuts,
          _props$confirmButtonT = _props.confirmButtonText,
          confirmButtonText = _props$confirmButtonT === undefined ? CONFIRM_BUTTON_TEXT : _props$confirmButtonT,
          _props$startDateText = _props.startDateText,
          startDateText = _props$startDateText === undefined ? START_DATE_TEXT : _props$startDateText,
          _props$endDateText = _props.endDateText,
          endDateText = _props$endDateText === undefined ? END_DATE_TEXT : _props$endDateText;

      var formatStyle = format || (showTimePicker ? 'YYYY/MM/DD HH:mm' : 'YYYY/MM/DD');
      var className = classNames('datetime-range-picker', this.props.className);
      var props = blacklist(this.props, 'className', 'isOpen', 'format', 'moment', 'showTimePicker', 'shortcuts', 'onChange');

      return React__default.createElement(
        'div',
        { className: className, style: { display: isOpen ? 'block' : 'none' } },
        React__default.createElement(
          'div',
          { className: 'tools-bar' },
          shortcuts ? React__default.createElement(Shortcuts, _extends({}, props, { moment: moment$$1 || {}, range: true, shortcuts: shortcuts, onChange: this.handleShortcutChange })) : undefined,
          React__default.createElement(
            'div',
            { className: 'buttons' },
            React__default.createElement(
              'button',
              { type: 'button', className: 'btn', onClick: this.onConfirm },
              confirmButtonText
            )
          )
        ),
        React__default.createElement(
          'div',
          { className: 'datetime-range-picker-panel' },
          React__default.createElement(
            'table',
            null,
            React__default.createElement(
              'tbody',
              null,
              React__default.createElement(
                'tr',
                null,
                React__default.createElement(
                  'td',
                  { className: 'datetime-text' },
                  React__default.createElement(
                    'span',
                    { className: 'text-label' },
                    startDateText
                  ),
                  React__default.createElement(
                    'span',
                    { className: 'text-value' },
                    moment$$1 && moment$$1.start ? moment$$1.start.format(formatStyle) : undefined
                  )
                ),
                React__default.createElement(
                  'td',
                  { className: 'datetime-text' },
                  React__default.createElement(
                    'span',
                    { className: 'text-label' },
                    endDateText
                  ),
                  React__default.createElement(
                    'span',
                    { className: 'text-value' },
                    moment$$1 && moment$$1.end ? moment$$1.end.format(formatStyle) : undefined
                  )
                )
              ),
              React__default.createElement(
                'tr',
                null,
                React__default.createElement(
                  'td',
                  null,
                  React__default.createElement(Picker, _extends({}, props, {
                    isOpen: isOpen,
                    className: 'range-start-picker',
                    showTimePicker: showTimePicker,
                    moment: moment$$1,
                    range: true,
                    rangeAt: 'start',
                    onChange: this.handleChange
                  }))
                ),
                React__default.createElement(
                  'td',
                  null,
                  React__default.createElement(Picker, _extends({}, props, {
                    isOpen: isOpen,
                    className: 'range-end-picker',
                    showTimePicker: showTimePicker,
                    moment: moment$$1,
                    range: true,
                    rangeAt: 'end',
                    onChange: this.handleChange
                  }))
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Range;
}(React.Component);

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

// var CSSProperty = require('./CSSProperty');

var warning = __webpack_require__(237);

var isUnitlessNumber$1 = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isNonNumeric || value === 0 || isUnitlessNumber$1.hasOwnProperty(name) && isUnitlessNumber$1[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

// var CSSProperty = require('./CSSProperty.js');
var ExecutionEnvironment = __webpack_require__(173);

var camelizeStyleName = __webpack_require__(640);
// var dangerousStyleValue = require('./dangerousStyleValue.js');
var hyphenateStyleName = __webpack_require__(642);
var memoizeStringOnly = __webpack_require__(644);
var warning$1 = __webpack_require__(237);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {

  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function createMarkupForStyles(styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var styleValue = styles[styleName];
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function setValueForStyles(node, styles, component) {
    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }

};

var Portal = function (_Component) {
  inherits(Portal, _Component);

  function Portal() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Portal.__proto__ || Object.getPrototypeOf(Portal)).call.apply(_ref, [this].concat(args))), _this), _this.applyClassNameAndStyle = function (props) {
      if (props.className) {
        _this.node.className = props.className;
      }

      if (props.style) {
        CSSPropertyOperations.setValueForStyles(_this.node, props.style, _this._reactInternalInstance);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderPortal(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.renderPortal(props);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.node) {
        ReactDOM__default.unmountComponentAtNode(this.node);
        document.body.removeChild(this.node);
      }

      this.portal = null;
      this.node = null;
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.node) {
        this.node = document.createElement('div');
        this.applyClassNameAndStyle(props);

        document.body.appendChild(this.node);
      } else {
        this.applyClassNameAndStyle(props);
      }

      var children = props.children;


      this.portal = ReactDOM__default.unstable_renderSubtreeIntoContainer(this, children, this.node);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return Portal;
}(React.Component);

var Trigger = function (_Component) {
  inherits(Trigger, _Component);

  function Trigger() {
    classCallCheck(this, Trigger);

    var _this = possibleConstructorReturn(this, (Trigger.__proto__ || Object.getPrototypeOf(Trigger)).call(this));

    _this.handleDocumentClick = function (evt) {
      if (!ReactDOM.findDOMNode(_this).contains(evt.target)) {
        _this.togglePicker(false);
      }
    };

    _this.handlePortalPosition = function () {
      if (_this.state.isOpen) {
        _this.setState({
          pos: _this.getPosition()
        });
      }
    };

    _this.handleChange = function (moment$$1, currentPanel) {
      var _this$props = _this.props,
          closeOnSelectDay = _this$props.closeOnSelectDay,
          onChange = _this$props.onChange;


      if (currentPanel === 'day' && closeOnSelectDay) {
        _this.setState({
          isOpen: false
        });
      }

      onChange && onChange(moment$$1);
    };

    _this.togglePicker = function (isOpen) {
      var disabled = _this.props.disabled;


      if (disabled) return;

      _this.setState({
        isOpen: isOpen,
        pos: _this.getPosition()
      });
    };

    _this.getPosition = function () {
      var elem = _this.refs.trigger;
      var elemBCR = elem.getBoundingClientRect();

      return {
        top: Math.round(elemBCR.top + elemBCR.height),
        left: Math.round(elemBCR.left)
      };
    };

    _this._renderPortal = function () {
      var _this$state = _this.state,
          pos = _this$state.pos,
          isOpen = _this$state.isOpen;

      var style = {
        display: isOpen ? 'block' : 'none',
        position: 'fixed',
        top: pos.top + 'px',
        left: pos.left + 'px'
      };

      return React__default.createElement(
        Portal,
        { style: style },
        _this._renderPicker(true)
      );
    };

    _this._renderPicker = function (isOpen) {
      var props = blacklist(_this.props, 'className', 'appendToBody', 'children', 'onChange');

      return React__default.createElement(Picker, _extends({}, props, {
        className: 'datetime-picker-popup',
        isOpen: isOpen,
        onChange: _this.handleChange }));
    };

    _this.state = {
      isOpen: false,
      pos: {}
    };
    return _this;
  }

  createClass(Trigger, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('click', this.handleDocumentClick, false);

      if (this.props.appendToBody) {
        window.addEventListener('scroll', this.handlePortalPosition, false);
        window.addEventListener('resize', this.handlePortalPosition, false);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.handleDocumentClick, false);

      if (this.props.appendToBody) {
        window.removeEventListener('scroll', this.handlePortalPosition, false);
        window.removeEventListener('resize', this.handlePortalPosition, false);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          appendToBody = _props.appendToBody,
          className = _props.className;
      var isOpen = this.state.isOpen;


      return React__default.createElement(
        'div',
        { className: 'datetime-trigger ' + className },
        React__default.createElement(
          'div',
          { onClick: this.togglePicker.bind(this, !isOpen), ref: 'trigger' },
          children
        ),
        appendToBody ? this._renderPortal() : this._renderPicker(isOpen)
      );
    }
  }]);
  return Trigger;
}(React.Component);

var RangeTrigger = function (_Component) {
  inherits(RangeTrigger, _Component);

  function RangeTrigger() {
    classCallCheck(this, RangeTrigger);

    var _this = possibleConstructorReturn(this, (RangeTrigger.__proto__ || Object.getPrototypeOf(RangeTrigger)).call(this));

    _this.handleDocumentClick = function (evt) {
      if (!ReactDOM.findDOMNode(_this).contains(evt.target)) {
        _this.togglePicker(false);
      }
    };

    _this.handlePortalPosition = function () {
      if (_this.state.isOpen) {
        _this.setState({
          pos: _this.getPosition()
        });
      }
    };

    _this.handleChange = function (moment$$1) {
      var onChange = _this.props.onChange;


      _this.setState({
        isOpen: false
      });
      onChange && onChange(moment$$1);
    };

    _this.togglePicker = function (isOpen) {
      var disabled = _this.props.disabled;


      if (disabled) return;

      _this.setState({
        isOpen: isOpen,
        pos: _this.getPosition()
      });
    };

    _this.getPosition = function () {
      var elem = _this.refs.trigger;
      var elemBCR = elem.getBoundingClientRect();

      return {
        top: Math.round(elemBCR.top + elemBCR.height),
        left: Math.round(elemBCR.left)
      };
    };

    _this._renderPortal = function () {
      var _this$state = _this.state,
          pos = _this$state.pos,
          isOpen = _this$state.isOpen;

      var style = {
        display: isOpen ? 'block' : 'none',
        position: 'fixed',
        top: pos.top + 'px',
        left: pos.left + 'px'
      };

      return React__default.createElement(
        Portal,
        { style: style },
        _this._renderPicker(true)
      );
    };

    _this._renderPicker = function (isOpen) {
      var props = blacklist(_this.props, 'className', 'appendToBody', 'children', 'onChange');

      return React__default.createElement(Range, _extends({}, props, {
        className: 'datetime-range-picker-popup',
        isOpen: isOpen,
        onChange: _this.handleChange }));
    };

    _this.state = {
      isOpen: false,
      pos: {}
    };
    return _this;
  }

  createClass(RangeTrigger, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('click', this.handleDocumentClick, false);

      if (this.props.appendToBody) {
        window.addEventListener('scroll', this.handlePortalPosition, false);
        window.addEventListener('resize', this.handlePortalPosition, false);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.handleDocumentClick, false);

      if (this.props.appendToBody) {
        window.removeEventListener('scroll', this.handlePortalPosition, false);
        window.removeEventListener('resize', this.handlePortalPosition, false);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          appendToBody = _props.appendToBody,
          className = _props.className;
      var isOpen = this.state.isOpen;


      return React__default.createElement(
        'div',
        { className: 'datetime-range-trigger ' + className },
        React__default.createElement(
          'div',
          { onClick: this.togglePicker.bind(this, !isOpen), ref: 'trigger' },
          children
        ),
        appendToBody ? this._renderPortal() : this._renderPicker(isOpen)
      );
    }
  }]);
  return RangeTrigger;
}(React.Component);

exports.DatetimePicker = Picker;
exports.DatetimeRangePicker = Range;
exports.DatetimePickerTrigger = Trigger;
exports.DatetimeRangePickerTrigger = RangeTrigger;


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getAllClients; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clearClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearClientAdvanceConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return setMainSeller; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assigmentSellers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return dettachAssigmentAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return attachAssigmentAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fetchAvailableSellers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return updateWithoutClear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fetchClients; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchArchivedClients; });
/* unused harmony export showC */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return register; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return restoreClient; });
/* unused harmony export searchQueryClients */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return destroy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return toggleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return update; });
/* unused harmony export autoComplete */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return block; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return disable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return statusAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getClientSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return setClientPayoutAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return payClientPm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateClientAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return updateClientAdvanceSettings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tableActions__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UtilsOperation__ = __webpack_require__(9);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var showC=function showC(){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/clients').then(function(res){dispatch({type:'FETCH_CLIENT',client:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_user_data});});};};var getAllClients=function getAllClients(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var query=arguments[1];return function(dispatch,getState){var _getState=getState(),company=_getState.company,json_lang=_getState.json_lang;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/clients?limit=10&page='+page+(query?'&name=ilike '+query:'')).then(function(res){dispatch({type:'FETCH_ALL_CLIENTS',allClients:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.retrieving_user_data});});};};var clearClient=function clearClient(){return function(dispatch,getState){dispatch({type:'CLEAR_CLIENT',client:{},dropzoneFiles:[]});};};var clearClientAdvanceConfig=function clearClientAdvanceConfig(){return function(dispatch){dispatch({type:"INVALID_ADVANCE_CONFIG",invalidConfig:{}});};};var fetchClients=function fetchClients(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var search_query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var filter_query=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var loader=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;return function(dispatch,getState){var _getState2=getState(),company=_getState2.company,json_lang=_getState2.json_lang;if(loader){dispatch({type:"WAIT_FOR_RESPONSE"});}var url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/clients?page='+page;url_host+=search_query!==''?'&search='+search_query:'';url_host+=filter_query!==''?'&'+filter_query:'';return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(url_host).then(function(res){dispatch({type:'FETCH_PAGINATED_CLIENTS',paginated_clients:res.data});}).catch(function(err){if(loader){dispatch({type:"REMOVE_LOADING"});}if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.retrieving_user_list});});};};var fetchArchivedClients=function fetchArchivedClients(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var search_query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var filter_query=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';return function(dispatch,getState){var _getState3=getState(),company=_getState3.company,json_lang=_getState3.json_lang;var url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/clients?mode=deleted&page='+page;url_host+=search_query!==''?'&search='+search_query:'';url_host+=filter_query!==''?'&'+filter_query:'';return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(url_host).then(function(res){dispatch({type:'FETCH_PAGINATED_CLIENTS',paginated_clients:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.user_delete_failed});});};};var autoComplete=function autoComplete(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/clients'+(query?"?search="+query:'')).then(function(res){dispatch({type:'AUTOCOMPLETE_CLIENT',clients:res.data.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_user_data});});};};var searchQueryClients=function searchQueryClients(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/clients'+(query?"?search="+query:'')).then(function(res){dispatch({type:'AUTOCOMPLETE_CLIENT',clients:res.data.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_user_data});});};};var find=function find(id){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/clients/'+id+'?with=addresses,account').then(function(res){dispatch({type:'FETCH_CLIENT',client:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_user_data});});};};var toggleData=function toggleData(value){return function(dispatch,getState){var data=Object.assign({},getState().client);data[value.name]=value.data;dispatch({type:'FETCH_CLIENT',client:data});};};var restoreClient=function restoreClient(id){return function(dispatch,getState){var _getState4=getState(),client=_getState4.client;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/accounts/'+id+'/restore').then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.restored_user});dispatch({type:'UPDATE_CLIENT',paginated_clients:Object(__WEBPACK_IMPORTED_MODULE_2__tableActions__["i" /* tableRemoveAcount */])(res,"paginated_clients"),client:Object.assign({account:Object.assign({},res.data,{status:res.data.status})},res.data.client)});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_restore_failed});});};};var register=function register(data){return function(dispatch,getState){if(Object(__WEBPACK_IMPORTED_MODULE_4__UtilsOperation__["F" /* regexValidateUserName */])(data.name)){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'',msg:'Error maldito'});return;}var client={name:data.name,email:data.email,phone:data.phone};return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/clients',client).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});dispatch({type:'REGISTER_CLIENT_SUCCESS',client:res.data});//dispatch(REGISTER_CLIENT_SUCCESS(client))
}).catch(function(err){if(err.data&&err.data.message.indexOf("already_exists")===0)__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:getState().json_lang.custom_errors.user_registration_failed,msg:getState().json_lang.custom_errors.client_already_exist});else if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_registration_failed});});};};var update=function update(data){return function(dispatch,getState){var _getState5=getState(),company=_getState5.company,json_lang=_getState5.json_lang;/* var client = new FormData();
        client.append('email', data.email)
        client.append('name', data.name)
		client.append('phone', data.phone) */var client={'name':data.name,'phone':data.phone/* if(getState().dropzoneFiles.length){
           client.append('avatar', getState().dropzoneFiles[0] )
        }else if(data.avatar_url && data.avatar_url.length ){
           client.append('avatar_url', data.avatar_url)
        }else{
            client.append('avatar_url', URLsmall+'assets/img/avatars/default.png')
        } */};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/clients/'+data.id,client).then(function(res){if(data.email!==res.data.email){__WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/accounts/'+res.data.account_id+'/update-email',{email:data.email}).then(function(resEmail){res.data.email=resEmail.data.email;dispatch({type:'UPDATE_CLIENT',paginated_clients:Object(__WEBPACK_IMPORTED_MODULE_2__tableActions__["g" /* tableClientsUpdate */])(res,"paginated_clients"),client:Object.assign({account:Object.assign({},getState().client.account,{status:res.data.status})},res.data)});dispatch({type:""});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.update_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.user_update_failed});});}else{dispatch({type:'UPDATE_CLIENT',paginated_clients:Object(__WEBPACK_IMPORTED_MODULE_2__tableActions__["g" /* tableClientsUpdate */])(res,"paginated_clients"),client:Object.assign({account:Object.assign({},getState().client.account,{status:res.data.status})},res.data)});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});}}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_update_failed});});};};var updateWithoutClear=function updateWithoutClear(data){return function(dispatch,getState){var client=new FormData();client.append('email',data.email);client.append('name',data.name);client.append('phone',data.phone);if(getState().dropzoneFiles.length){client.append('avatar',getState().dropzoneFiles[0]);}else if(data.avatar_url&&data.avatar_url.length){client.append('avatar_url',data.avatar_url);}dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/clients/'+data.id,client).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});dispatch({type:'UPDATE_CLIENT',clients:Object(__WEBPACK_IMPORTED_MODULE_2__tableActions__["j" /* tableUpdate */])(res,"clients"),client:Object.assign({account:Object.assign({},res.data,{status:res.data.status})},res.data.client)});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_delete_failed});});};};var destroy=function destroy(id){return function(dispatch,getState){var _getState6=getState(),client=_getState6.client;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/accounts/'+id).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.delete_successful});dispatch({type:'UPDATE_CLIENT',paginated_clients:Object(__WEBPACK_IMPORTED_MODULE_2__tableActions__["i" /* tableRemoveAcount */])(res,"paginated_clients"),client:Object.assign({account:Object.assign({},res.data,{status:res.data.status})},res.data.client),preloader:false});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_delete_failed});});};};var block=function block(id){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/accounts/'+id+'/block').then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});var client=getState().paginated_clients.data.find(function(client,key){return parseInt(client.account_id,10)===parseInt(id,10);});if(client){client.account.status=res.data.status;}dispatch({type:'UPDATE_CLIENT',paginated_clients:Object(__WEBPACK_IMPORTED_MODULE_2__tableActions__["g" /* tableClientsUpdate */])(res,"paginated_clients"),client:Object.assign({account:Object.assign({},res.data,{status:res.data.status})},res.data.client)});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_delete_failed});});};};var disable=function disable(id){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/accounts/'+id+'/disable').then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});var client=getState().paginated_clients.data.find(function(client,key){return parseInt(client.account_id,10)===parseInt(id,10);});if(client){client.account.status=res.data.status;}dispatch({type:'UPDATE_CLIENT',paginated_clients:Object(__WEBPACK_IMPORTED_MODULE_2__tableActions__["g" /* tableClientsUpdate */])(res,"paginated_clients"),client:Object.assign({account:Object.assign({},res.data,{status:res.data.status})},res.data.client)});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_delete_failed});});};};var statusAccount=function statusAccount(id,_statusAccount){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/accounts/'+id+'/'+_statusAccount).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.restored_user});var client=getState().paginated_clients.data.find(function(client,key){return parseInt(client.account_id,10)===parseInt(id,10);});if(client){client.account.status=res.data.status;}dispatch({type:'UPDATE_CLIENT',paginated_clients:Object(__WEBPACK_IMPORTED_MODULE_2__tableActions__["g" /* tableClientsUpdate */])(res,"paginated_clients"),client:Object.assign({account:Object.assign({},res.data,{status:res.data.status})},res.data.client)});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_restore_failed});});};};var fetchAvailableSellers=function fetchAvailableSellers(clientId){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/clients/'+clientId+'/admins').then(function(res){var adminsToAsing=[].concat(_toConsumableArray(getState().admins));var assinedAdmins=res.data.map(function(admin){return admin.id;});var avaliableToAsing=void 0;if(res.data&&res.data.length>0){avaliableToAsing=adminsToAsing.filter(function(admin){return!assinedAdmins.includes(admin.id);});}dispatch({type:'ATTACHABLE_ADMINS',adminsToAsing:res.data,admins:res.data&&res.data.length>0?avaliableToAsing:adminsToAsing});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:getState().json_lang.custom_errors.retrieving_user_list});});};};var attachAssigmentAdmin=function attachAssigmentAdmin(adminId){return function(dispatch,getState){var adminsToAsing=getState().adminsToAsing&&getState().adminsToAsing.length>0?[].concat(_toConsumableArray(getState().adminsToAsing)):[];var admins=[].concat(_toConsumableArray(getState().admins));var newAssing=admins.find(function(admin){return admin.id===adminId;});adminsToAsing.push(newAssing);var adminsUpdate=getState().admins.filter(function(admin){return admin.id!==adminId;});dispatch({type:'ATTACHABLE_ADMINS',adminsToAsing:adminsToAsing,admins:adminsUpdate});};};var dettachAssigmentAdmin=function dettachAssigmentAdmin(adminId){return function(dispatch,getState){var adminsToAsing=[].concat(_toConsumableArray(getState().adminsToAsing));var admins=[].concat(_toConsumableArray(getState().admins));var avaliableAssing=adminsToAsing.find(function(admin){return admin.id===adminId;});admins.push(avaliableAssing);var adminsUpdate=adminsToAsing.filter(function(admin){return admin.id!==adminId;});dispatch({type:'ATTACHABLE_ADMINS',adminsToAsing:adminsUpdate,admins:admins});};};var assigmentSellers=function assigmentSellers(adminId){return function(dispatch,getState){var assigmentSellers=[].concat(_toConsumableArray(getState().adminsToAsing)).map(function(seller){return seller.id;});dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].put(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/clients/'+adminId+'/admins',assigmentSellers).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});dispatch({type:'REMOVE_LOADING'});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var setMainSeller=function setMainSeller(clientId,adminId){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/clients/'+clientId+'/admins/'+adminId+'/set-main').then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});dispatch({type:'REMOVE_LOADING'});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var getClientSettings=function getClientSettings(clientId){return function(dispatch,getState){var _getState7=getState(),company=_getState7.company;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/clients/'+clientId+'/settings').then(function(res){dispatch({type:"FETCH_CLIENT_SETTINGS",clientSettings:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"Error al obtener los datos de pago del cliente"});});};};var setClientPayoutAccount=function setClientPayoutAccount(clientId,data,fromInvoice){return function(dispatch,getState){var _getState8=getState(),company=_getState8.company,json_lang=_getState8.json_lang,invoice=_getState8.invoice;var paymentData={payout_accounts:[].concat(_toConsumableArray(data))};return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/clients/'+clientId+'/settings',paymentData).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});if(fromInvoice){dispatch({type:'FETCH_INVOICE',invoice:Object.assign({},invoice,{payout_accounts:paymentData.payout_accounts})});}else{dispatch({type:'FETCH_CLIENT_SETTINGS',clientSettings:res.data});}}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"Error al guardar el método de pago"});});};};var payClientPm=function payClientPm(accountId,data){return function(dispatch,getState){var _getState9=getState(),company=_getState9.company,json_lang=_getState9.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/accounts/'+accountId+'/account-balances/withdraw',data).then(function(){dispatch({type:'REMOVE_LOADING'});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:"Pago enviado con éxito"});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"Error al realizar el pago"});});};};var updateClientAddress=function updateClientAddress(address){return function(dispatch,getState){var _getState10=getState(),company=_getState10.company,json_lang=_getState10.json_lang,client=_getState10.client;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/client-addresses/'+address.id,address).then(function(res){dispatch({type:'FETCH_CLIENT',client:Object.assign({},client,{addresses:client.addresses.map(function(item){return item.id===address.id?res.data:item;})})});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:"Dirección actualizada con éxito"});}).catch(function(err){dispatch({type:'REMOVE_LOADING'});if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"Error al actualizar la dirección"});});};};var updateClientAdvanceSettings=function updateClientAdvanceSettings(body,id){return function(dispatch,getState){var _getState11=getState(),company=_getState11.company,json_lang=_getState11.json_lang;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/clients/'+id+'/settings',Object.assign({},body)).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:"INVALID_ADVANCE_CONFIG",invalidConfig:{}});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err.data&&err.data.error_code){var error=err.data;switch(error.error_code){case'ER422':if(error.errors){var errors=Object.keys(error.errors).reduce(function(acc,key){var splitedKey=key.split(".");acc[splitedKey[1]]=json_lang.custom_errors[splitedKey[1]+"_format"];return acc;},{});dispatch({type:"INVALID_ADVANCE_CONFIG",invalidConfig:Object.assign({},errors)});}else{if(error.description){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:error.description});}else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:"Ocurrió un error inesperado al guardar los datos"});}}break;case'ER409':if(error.errors){var _errors=Object.keys(error.errors).reduce(function(acc,key){var splitedKey=key.split(".");acc[splitedKey[1]]=json_lang.custom_errors[splitedKey[1]+"_conflict"];return acc;},{});dispatch({type:"INVALID_ADVANCE_CONFIG",invalidConfig:Object.assign({},_errors)});}else{if(error.description){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:error.description});}else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:"Ocurrió un error inesperado al guardar los datos"});}}break;default:if(error.description){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:error.description});}else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.error_code,msg:"Error al guardar los datos"});}break;}}else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:"Error al guardar los datos"});}});};};

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clearCouponData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setFinishedCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setReadyCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return attachCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return editCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return editCouponEndDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return toggleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getCoupons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return copyCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deleteCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return unattachCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getCouponCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return replaceCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setBlacklist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setWhiteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return unSetBlacklist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return unSetWhiteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeCouponTargetType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handlers_Notification__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_general__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UtilsOperation__ = __webpack_require__(9);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}//import { b64toBlob } from './UtilsOperation';
var getCoupons=function getCoupons(promo,sort){var page=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;var search=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;return function(dispatch,getState){var _getState=getState(),company=_getState.company;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons?page='+page+'&with=branchGroup&'+(promo?'type=promo':'type=!=promo')+(sort?'&sort_by='+sort.columnName+','+sort.direction:'')+(search?'&name=ilike '+search:'')).then(function(res){//&sort_by=created_at,desc
dispatch({type:'FETCH_COUPONS',coupons:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.title});});};};var replaceCoupon=function replaceCoupon(coupon){return function(dispatch,getState){var coupons=getState().coupons;var found=coupons.findIndex(function(item){return item.id===coupon.id;});if(found>=0){coupons.splice(found,1,coupon);}dispatch({type:'FETCH_COUPONS',coupons:coupons});};};var getCoupon=function getCoupon(couponId,isPromo){return function(dispatch,getState){var _getState2=getState(),company=_getState2.company;dispatch({type:"WAIT_FOR_RESPONSE"});//.branchGroup
return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons/'+couponId+'?with=couponTargets.related,branchGroup').then(function(res){var update=res.data;if(update.total_count===0){update.unlimited=true;}if(update.config.max_discount_e2){update.config.max_discount_e2=parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(update.config.max_discount_e2/update.human_price_prc));}if(update.config.amount_limit_e2){update.config.amount_limit_e2=parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(update.config.amount_limit_e2/100));}if(isPromo){update.name='Double - '+update.name;}dispatch({type:'FETCH_COUPON',coupon:update});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.title});});};};var getCouponCodes=function getCouponCodes(couponId){return function(dispatch,getState){var _getState3=getState(),coupon=_getState3.coupon,company=_getState3.company;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons/'+couponId+'/codes').then(function(res){var update=Object.assign({},coupon,{available_codes:res.data.available_codes,used_codes:res.data.used_codes});dispatch({type:'FETCH_COUPON',coupon:update});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.title});});};};var toggleData=function toggleData(value,isType){return function(dispatch,getState){var data=Object.assign({},getState().coupon);if(isType){data.config.is_fixed=value.checked;}if(value.name==='unlimited'){data[value.name]=value.checked;data.total_count=data.unlimited===true?0:"";}else if(value.name==='limit'||value.name==="purchase_condition_mode"){data.config[value.name]=value.data;if(value.name==="purchase_condition_mode"&&value.checked!==undefined){data.config.min_purchase_count=value.checked?0:null;data.config.max_purchase_count=null;data.config.last_purchase_min_days=null;data.config.last_purchase_max_days=null;}}else if(value.name==='usable_in_promos'||value.name==='only_deliveries'||value.name==='avoid_same_target_promos'||value.name==='is_cashback'){data.config[value.name]=value.checked;}else if(value.name==='limit'||value.name==='company_assumption_prc'||value.name==='users_registered_until'||value.name==='users_registered_since'||value.name==='max_discount_e2'||value.name==="collision_slot"||value.name==="amount_limit_e2"||value.name==="min_purchase_count"||value.name==="max_purchase_count"||value.name==="last_purchase_min_days"||value.name==="last_purchase_max_days"){data.config[value.name]=value.data;}else if(value.name==='purchase_mode'){if(value.data==='custom'||value.data===''){data.config.min_purchase_count=null;data.config.max_purchase_count=null;}else{var newData=value.data;if(newData.includes(":")){newData=newData.split(":");console.log("newData ====> ",newData);data.config.min_purchase_count=newData[0]?Number(newData[0]):null;data.config.max_purchase_count=newData[1]?Number(newData[1]):null;}else{data.config.min_purchase_count=Number(newData);data.config.max_purchase_count=null;}}}else if(value.name==="enable_purchase_days"){data.config.last_purchase_min_days=null;data.config.last_purchase_max_days=null;}else{if(value.data==='base_price'){data.human_min_purchase_e2='0';}data[value.name]=value.data;}dispatch({type:'FETCH_COUPON',coupon:data});};};var clearCouponData=function clearCouponData(){return function(dispatch){dispatch({type:'CLEAR_COUPON_DATA'});};};var createCoupon=function createCoupon(promo,double){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState4=getState(),company=_getState4.company;var _getState5=getState(),coupon=_getState5.coupon,json_lang=_getState5.json_lang;var couponData=coupon;if(couponData.human_price_e2){couponData.human_price_e2=parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(couponData.human_price_e2));}if(couponData.human_price_prc){couponData.human_price_prc=parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(couponData.human_price_prc));}if(couponData.human_min_purchase_e2){couponData.human_min_purchase_e2=parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(couponData.human_min_purchase_e2));}if(couponData.config.amount_limit_e2===""){couponData.config.amount_limit_e2=null;}else if(couponData.config.amount_limit_e2){couponData.config.amount_limit_e2=parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(couponData.config.amount_limit_e2*100));}if(couponData.config.max_discount_e2){couponData.config.max_discount_e2=parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(couponData.config.max_discount_e2)*couponData.human_price_prc));}if(couponData.config.min_purchase_count===null){couponData.config.min_purchase_count=-1;}if(couponData.config.max_purchase_count===null){couponData.config.max_purchase_count=-1;}if(couponData.config.last_purchase_min_days===null){couponData.config.last_purchase_min_days=-1;}if(couponData.config.last_purchase_max_days===null){couponData.config.last_purchase_max_days=-1;}if(promo){couponData.type='promo';}if(double){couponData.name='Double - '+couponData.name;}return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons',couponData).then(function(res){dispatch({type:"REMOVE_LOADING"});__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:'FETCH_COUPON',coupon:res.data});return res.data;}).catch(function(err){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.title});});};};var copyCoupon=function copyCoupon(promo,double){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState6=getState(),coupon=_getState6.coupon,json_lang=_getState6.json_lang,company=_getState6.company;var couponData=coupon;if(couponData.human_price_e2){couponData.human_price_e2=parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(couponData.human_price_e2));}if(couponData.human_price_prc){couponData.human_price_prc=parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(couponData.human_price_prc));}if(couponData.human_min_purchase_e2){couponData.human_min_purchase_e2=parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(couponData.human_min_purchase_e2));}if(couponData.config.max_discount_e2){couponData.config.max_discount_e2=parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(couponData.config.max_discount_e2)*couponData.human_price_prc));}if(couponData.config.amount_limit_e2===""){couponData.config.amount_limit_e2=null;}else if(couponData.config.amount_limit_e2){couponData.config.amount_limit_e2=parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(couponData.config.amount_limit_e2*100));}if(couponData.config.min_purchase_count===null){couponData.config.min_purchase_count=-1;}if(couponData.config.max_purchase_count===null){couponData.config.max_purchase_count=-1;}if(couponData.config.last_purchase_min_days===null){couponData.config.last_purchase_min_days=-1;}if(couponData.config.last_purchase_max_days===null){couponData.config.last_purchase_max_days=-1;}if(promo){couponData.type='promo';}if(double){couponData.name='Double - '+couponData.name;}return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons',couponData).then(function(res){var counter=0;coupon.coupon_targets.forEach(function(target){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].put(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons/'+res.data.id+'/targets/'+target.related_id).then(function(res){}).catch(function(err){counter=counter+1;});});dispatch({type:"REMOVE_LOADING"});if(counter===0){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:'El cupon fue duplicado con exito'});}else{__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"warning",title:'El cupon fue duplicado, '+counter+' asociaciones fallon, favor verificar el cupon duplicado'});}return res.data;}).catch(function(err){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.title});});};};var deleteCoupon=function deleteCoupon(couponId){//Requiere: status!=running
return function(dispatch,getState){var _getState7=getState(),json_lang=_getState7.json_lang,company=_getState7.company;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons/'+couponId).then(function(res){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:"REMOVE_LOADING"});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.title});});};};var editCoupon=function editCoupon(couponId){//Requiere: status=pending
return function(dispatch,getState){var _getState8=getState(),coupon=_getState8.coupon,json_lang=_getState8.json_lang,company=_getState8.company;var update={name:coupon.name,type:coupon.type,target_type:coupon.target_type,applies_to:coupon.applies_to,promo_code:coupon.promo_code,typeCoupon:coupon.typeCoupon,total_count:coupon.total_count,human_price_e2:coupon.human_price_e2,human_price_prc:coupon.human_price_prc,human_min_purchase_e2:coupon.human_min_purchase_e2&&coupon.human_min_purchase_e2>0?parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(coupon.human_min_purchase_e2)):0,config:{limit:coupon.config.limit,is_cashback:coupon.config.is_cashback,is_fixed:coupon.config.is_fixed,collision_slot:coupon.config.collision_slot,min_purchase_count:coupon.config.min_purchase_count===null?-1:coupon.config.min_purchase_count,max_purchase_count:coupon.config.max_purchase_count===null?-1:coupon.config.max_purchase_count,last_purchase_min_days:coupon.config.last_purchase_min_days===null?-1:coupon.config.last_purchase_min_days,last_purchase_max_days:coupon.config.last_purchase_max_days===null?-1:coupon.config.last_purchase_max_days,purchase_condition_mode:coupon.config.purchase_condition_mode,max_discount_e2:coupon.config.max_discount_e2&&coupon.config.max_discount_e2>0?parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(coupon.config.max_discount_e2)):"",amount_limit_e2:coupon.config.amount_limit_e2===""?null:coupon.config.amount_limit_e2&&coupon.config.amount_limit_e2>0?parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(coupon.config.amount_limit_e2*100)):null}};if(coupon.human_price_e2&&coupon.human_price_e2>0){update.human_price_e2=parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(coupon.human_price_e2));}if(coupon.human_price_prc&&coupon.human_price_prc>0){update.human_price_prc=parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(coupon.human_price_prc));}if(coupon.config.max_discount_e2){update.config.max_discount_e2=parseFloat(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["a" /* FloatPrecision */])(update.config.max_discount_e2)*update.human_price_prc));}if(coupon.type==='batch'&&coupon.config&&coupon.config.limit){update.config=Object.assign({},update.config,{limit:parseInt(coupon.config.limit,10)});}if(coupon.config&&coupon.config.company_assumption_prc){update.config=Object.assign({},update.config,{company_assumption_prc:coupon.config.company_assumption_prc});}if(coupon.config&&(coupon.config.usable_in_promos||coupon.config.usable_in_promos===false)){update.config=Object.assign({},update.config,{usable_in_promos:coupon.config.usable_in_promos});}if(coupon.config&&(coupon.config.only_deliveries||coupon.config.only_deliveries===false)){update.config=Object.assign({},update.config,{only_deliveries:coupon.config.only_deliveries});}if(coupon.config&&(coupon.config.only_first_purchase||coupon.config.only_first_purchase===false)){update.config=Object.assign({},update.config,{only_first_purchase:coupon.config.only_first_purchase});}if(coupon.config&&(coupon.config.users_registered_since||coupon.config.users_registered_since===false)){update.config=Object.assign({},update.config,{users_registered_since:coupon.config.users_registered_since});}if(coupon.config&&(coupon.config.users_registered_until||coupon.config.users_registered_until===false)){update.config=Object.assign({},update.config,{users_registered_until:coupon.config.users_registered_until});}dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons/'+couponId,update).then(function(res){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:"REMOVE_LOADING"});return res.data;}).catch(function(err){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:err.data.description});});};};var editCouponEndDate=function editCouponEndDate(couponId){return function(dispatch,getState){var _getState9=getState(),coupon=_getState9.coupon,json_lang=_getState9.json_lang,company=_getState9.company;var update={ends_at:coupon.ends_at};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons/'+couponId+'/update-running',update).then(function(res){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:"REMOVE_LOADING"});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:err.data.description});});};};var attachCoupon=function attachCoupon(couponId,targetId,target_type){//Requiere: status=pending
return function(dispatch,getState){var _getState10=getState(),coupon=_getState10.coupon,json_lang=_getState10.json_lang,branchGroups=_getState10.branchGroups,goodsList=_getState10.goodsList,company=_getState10.company;var target=void 0;if(target_type==="branch_group"||target_type==="good"||target_type==="city"){target=targetId;}dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].put(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons/'+couponId+'/targets/'+targetId.id).then(function(res){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:"REMOVE_LOADING"});var newcupon=res.data;if(target_type==="branch_group"||target_type==="good"||target_type==="city"){newcupon.related={id:target.id,name:target.name};}var newtarget=coupon.coupon_targets.concat(newcupon);var update=coupon;update.coupon_targets=newtarget;dispatch({type:'FETCH_COUPON',coupon:update});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.title});});};};var unattachCoupon=function unattachCoupon(couponId,targetId){//Requiere: status=pending
return function(dispatch,getState){var _getState11=getState(),json_lang=_getState11.json_lang,coupon=_getState11.coupon,company=_getState11.company;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons/'+couponId+'/targets/'+targetId).then(function(res){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:"REMOVE_LOADING"});var find=coupon.coupon_targets.filter(function(coupon_target){return coupon_target.related_id!==targetId;});var update=coupon;update.coupon_targets=find;dispatch({type:'FETCH_COUPON',coupon:Object.assign({},update)});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.title});});};};var setBlacklist=function setBlacklist(couponId,list){//Requiere: status=pending
return function(dispatch,getState){var _getState12=getState(),coupon=_getState12.coupon,json_lang=_getState12.json_lang,company=_getState12.company;var newBlackList=[];if(list){newBlackList=[].concat(_toConsumableArray(coupon.config.target_blacklist),[list]);}var update={config:{target_blacklist:newBlackList}};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons/'+couponId,update).then(function(res){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:'FETCH_COUPON',coupon:Object.assign({},coupon,res.data)});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:err.data.description});});};};var unSetBlacklist=function unSetBlacklist(couponId,list){//Requiere: status=pending
return function(dispatch,getState){var _getState13=getState(),coupon=_getState13.coupon,json_lang=_getState13.json_lang,company=_getState13.company;var newBlackList=[].concat(_toConsumableArray(coupon.config.target_blacklist.filter(function(item){return item!==list;})));var update={config:{target_blacklist:newBlackList}};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons/'+couponId,update).then(function(res){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:'FETCH_COUPON',coupon:Object.assign({},coupon,res.data)});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:err.data.description});});};};var setWhiteList=function setWhiteList(couponId,list){//Requiere: status=pending
return function(dispatch,getState){var _getState14=getState(),coupon=_getState14.coupon,json_lang=_getState14.json_lang,company=_getState14.company;var newWhiteList=null;if(list){if(coupon.whitelist){newWhiteList=[].concat(_toConsumableArray(coupon.whitelist),[list]);}else{newWhiteList=[list];}}var update={whitelist:newWhiteList};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons/'+couponId,update).then(function(res){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:'FETCH_COUPON',coupon:Object.assign({},coupon,res.data)});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:err.data.description});});};};var unSetWhiteList=function unSetWhiteList(couponId,list){//Requiere: status=pending
return function(dispatch,getState){var _getState15=getState(),coupon=_getState15.coupon,json_lang=_getState15.json_lang,company=_getState15.company;var newWhiteList=[].concat(_toConsumableArray(coupon.whitelist.filter(function(item){return item!==list;})));var update={whitelist:newWhiteList.length>0?newWhiteList:null};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons/'+couponId,update).then(function(res){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:'FETCH_COUPON',coupon:Object.assign({},coupon,res.data)});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:err.data.description});});};};var changeCouponTargetType=function changeCouponTargetType(couponId,targetType){return function(dispatch,getState){var _getState16=getState(),coupon=_getState16.coupon,json_lang=_getState16.json_lang,company=_getState16.company;var update={target_type:targetType,config:{target_blacklist:coupon.target_type!==targetType?[]:coupon.config.target_blacklist}};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons/'+couponId,update).then(function(res){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:'FETCH_COUPON',coupon:Object.assign({},coupon,res.data)});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:err.data.description});});};};var setReadyCoupon=function setReadyCoupon(couponId){//Requiere: status=pending
return function(dispatch,getState){var _getState17=getState(),coupon=_getState17.coupon,json_lang=_getState17.json_lang,company=_getState17.company,coupons=_getState17.coupons;dispatch({type:"WAIT_FOR_RESPONSE"});coupon.timezone=company.time_zone_offset?company.time_zone_offset:__WEBPACK_IMPORTED_MODULE_4__constants_general__["k" /* DEFAULT_TIME_ZONE */];return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons/'+couponId+'/set-ready',coupon).then(function(res){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:"REMOVE_LOADING"});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});if(err&&err.data){var error=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["q" /* localizedErrorHandler */])(err.data);switch(error.code){case"EF314":var match=Object(__WEBPACK_IMPORTED_MODULE_5__UtilsOperation__["E" /* regexGetNumber */])(error.message);setTimeout(function(){var couponName=coupon.name;var conflictCouponName=coupons&&coupons.data.find(function(coupon){return coupon.id===match[1];});if(conflictCouponName){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:'Sin activar: '+couponName,msg:'No puede estar corriendo al mismo tiempo que: '+conflictCouponName.name});}else{return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons/'+match[1]).then(function(res){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:'Sin activar: '+couponName,msg:'No puede estar corriendo al mismo tiempo que: '+res.data.name});}).catch(function(){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:json_lang.two_steps_modal.default_error});});}},1);break;default:__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+error.code,msg:''+error.message});break;}}else{__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:json_lang.two_steps_modal.default_error});}});};};var setFinishedCoupon=function setFinishedCoupon(couponId){//Requiere: status=pending
return function(dispatch,getState){var _getState18=getState(),coupon=_getState18.coupon,json_lang=_getState18.json_lang,company=_getState18.company;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/coupons/'+couponId+'/set-finished',coupon).then(function(res){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});dispatch({type:"REMOVE_LOADING"});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.title});});};};var clearCoupon=function clearCoupon(){return function(dispatch){var coupon={name:"",type:"",promo_code:"",human_price_prc:"",human_price_e2:"",applies_to:"",total_count:"",unlimited:false,config:{limit:""}};dispatch({type:'FETCH_COUPON',coupon:coupon});};};

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getMonthPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getWeekPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getTodayPayment; });
/* unused harmony export getForms */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return toggleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return additem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return additemOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return removeitem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EnableDisableForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return findForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clearForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return clearPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return findCancelationReasons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return createCancelationReason; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return toggleCancelationReason; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return deleteCancelationReason; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return updateCancelationReason; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return acceptPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return duplicatedPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return invalidPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return refundPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return confirmCheckout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return storeProofDeliverySettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addDefaultForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getAllPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return storeForm; });
/* unused harmony export getCompanyEarningsReport */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getCompanyPaymentReport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tableActions__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__handlers_Notification__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_general__ = __webpack_require__(6);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var findForm=function findForm(type,isBranch){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(''+(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+getState().company.id)+(isBranch?'/branches/'+getState().branch.id:'')+'/forms/'+type).then(function(res){// TODO: currency no viene de aqui? en company no pero en forms no se...
dispatch({type:'GET_FORM',form:{answers:res.data.data,name:res.data.name,icon:res.data&&res.data.icon?res.data.icon:0,currency:{iso:res.data&&res.data.currency&&res.data.currency.iso?res.data.currency.iso:getState().company.currency_iso,tax_flat_e2:res.data&&res.data.currency&&res.data.currency.tax_flat_e2?res.data.currency.tax_flat_e2/100:0,tax_percent:res.data&&res.data.currency&&res.data.currency.tax_percent?res.data.currency.tax_percent*100:0},internal_name:res.data.internal_name}});}).catch(function(err){if(type===1){if(err.status===404){//no imprimir nada!
}else if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:getState().json_lang.custom_errors.retrieving_proof_of_delivery});}else{if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:getState().json_lang.custom_errors.retrieving_forms_list});}});};};var getForms=function getForms(){return function(dispatch){return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().company.id+'/forms').then(function(res){}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.custom_errors.retrieving_forms_list});});};};var storeForm=function storeForm(type,isBranch){return function(dispatch,getState){var form=getState().form;var storeUrl=''+(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+getState().company.id)+(isBranch?'/branches/'+getState().branch.id:'')+'/forms/'+(type?type:'payment');var actionUrl=type?'put':'post';var questions=form.answers.filter(function(form,key){if(form.option){var noEmptyChoise=form.option.choices.filter(function(choice,key){return choice!=="";});form.option.choices=noEmptyChoise;}if(form.file){form.file.allowed_types=["image/jpeg","image/png","application/pdf"];}return form;});form.answers=questions;form={form:questions,name:form.name,icon:form.icon,internal_name:form.internal_name?form.internal_name:null,type:form.type,currency:{iso:form.currency&&form.currency.iso?form.currency.iso:getState().currencies.local.iso,tax_flat_e2:form.currency&&form.currency.tax_flat_e2?form.currency.tax_flat_e2*100:0,tax_percent:form.currency&&form.currency.tax_percent?form.currency.tax_percent/100:0}};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */][actionUrl](storeUrl,form).then(function(res){__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});dispatch({type:'FORM_UPDATE_SUCCESS',table:Object(__WEBPACK_IMPORTED_MODULE_4__tableActions__["b" /* OLDtableUpdate */])(res),preloader:false});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:getState().json_lang.custom_errors.form_update_failed});});};};var storeProofDeliverySettings=function storeProofDeliverySettings(){return function(dispatch,getState){var form=getState().form;form.name="ProofDelivery";var questions=form.answers.filter(function(form,key){if(form.option){var noEmptyChoise=form.option.choices.filter(function(choice,key){return choice!=="";});form.option.choices=noEmptyChoise;}if(form.file){form.file.allowed_types=["image/jpeg","image/png","application/pdf"];}return form;});form.answers=questions;form={form:questions,name:form.name,icon:form.icon};return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].put(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+getState().company.id+'/forms/1',form).then(function(res){__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:getState().json_lang.custom_errors.form_registration_failed});});};};var EnableDisableForm=function EnableDisableForm(id,action,isBranch){return function(dispatch,getState){var form=getState().form.answers;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(''+(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+getState().company.id)+(isBranch?'/branches/'+getState().branch.id:'')+'/forms/'+id+'/'+action,form).then(function(res){var succesful=getState().json_lang.common.success;__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:getState().json_lang.custom_success.update_successful});dispatch({type:'FORM_UPDATE_SUCCESS',table:Object(__WEBPACK_IMPORTED_MODULE_4__tableActions__["b" /* OLDtableUpdate */])(res),preloader:false});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:getState().json_lang.custom_errors.form_update_failed});});};};var DeleteForm=function DeleteForm(id,isBranch){return function(dispatch,getState){var form=getState().form.answers;__WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].delete(''+(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+getState().company.id)+(isBranch?'/branches/'+getState().branch.id:'')+'/forms/'+id,form).then(function(res){var succesful=getState().json_lang.common.success;__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:getState().json_lang.custom_success.update_successful});dispatch({type:'FORM_UPDATE_SUCCESS',table:Object(__WEBPACK_IMPORTED_MODULE_4__tableActions__["a" /* OLDtableRemove */])(res),preloader:false});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:getState().json_lang.custom_errors.form_delete_failed});});};};var toggleData=function toggleData(value){var name=value.name.split('-')[0];var id=parseInt(value.name.split('-')[1],10);return function(dispatch,getState){var data=Object.assign({},getState().form);if(value.name==='name'||value.name==='icon'||value.name==='internal_name'){value.name==='internal_name'&&value.data==='Seleccione'?data[value.name]=null:data[value.name]=value.data;}else if(value.name.split('-')[0]==='currency'){if(!data.currency){data.currency={iso:'',tax_flat_e2:0,tax_percent:0};}data.currency[value.name.split('currency-')[1]]=value.data;}else{var update=data.answers.map(function(answer,i){var getType=Object.getOwnPropertyNames(answer)[0];if(answer.option&&answer.option.choices.indexOf(value.data)===-1&&i===0&&data.icon===1){answer.option.choices.push(value.data);}if(answer[getType]&&i===id){if(name==='choices'){var choicesKey=parseInt(value.name.split('-')[2],10);var updatechoise=answer.option.choices.map(function(choice,index){return index===choicesKey?choice=value.data:choice;});answer.option.choices=updatechoise;}else if(name==='required'){answer[getType].required=value.checked===true?true:false;}else{answer[getType][name]=value.data;}}return answer;});data.answers=update;}dispatch({type:'FORM_TYPE',form:data});};};var additemOption=function additemOption(index,i){return function(dispatch,getState){var itemsCont=getState().form.answers[i].option.choices.length;if(parseInt(index,10)+1===itemsCont){getState().form.answers[i].option.choices.push("");}};};var additem=function additem(item){return function(dispatch,getState){var data=Object.assign({},getState().form);var answer='';if(item==='boolean'){answer={boolean:{question:'',required:false}};}else if(item==='input'){answer={input:{question:'',required:false,hint:'',regex:''}};}else if(item==='option'){answer={option:{question:'',required:false,choices:['']}};}else if(item==='file'){answer={file:{question:'',required:false}};}else if(item==='text_button'){answer={text_button:{question:'',content:'',button_text:'',button_content:''}};}else{answer={text:{question:'',content:''}};}if(item){data.answers.push(answer);dispatch({type:'FORM_TYPE',form:data});}};};var addDefaultForm=function addDefaultForm(form){var DEFAULT=0;var TRANSFERENCIA_BANCARIA=1;var PAGO_MOVIL=2;//const PAGO_EFECTIVO = 3;
var ZELLE=4;var PAYPAL=5;var INSTORE=6;var RESERVE=7;var BINANCE=8;var HUMANIZ=9;var answers=[];return function(dispatch,getState){var data=Object.assign({},getState().form);var intForm=parseInt(form,10);if(intForm===PAGO_MOVIL){data.name='Pago Móvil';answers=[{text:{question:'Datos para hacer el pago',content:''}},{input:{question:getState().json_lang.common.operacion_number,required:true,hint:'0000000',regex:__WEBPACK_IMPORTED_MODULE_6__constants_general__["_42" /* TXT_REGEX_MIN4 */],type:'numeric'}}];}else if(intForm===TRANSFERENCIA_BANCARIA){data.name=getState().json_lang.common.wire_transfer;answers=[{text:{question:'Datos para hacer el pago',content:''}},/*{
                    option:{
                        question:getState().json_lang.common.banks_select,
                        required:true,
                        choices:[getState().json_lang.common.same, getState().json_lang.create_order.delivery_method_other],
                        type:'bank'
                    },
                },*/{input:{question:getState().json_lang.common.operacion_number,required:true,hint:'00000000',regex:__WEBPACK_IMPORTED_MODULE_6__constants_general__["_42" /* TXT_REGEX_MIN4 */],type:'numeric'}}];}else if(intForm===ZELLE){data.name='ZELLE';answers=[{input:{question:''+getState().json_lang.tooltips.name,required:true,hint:'Nombre y apellido',regex:__WEBPACK_IMPORTED_MODULE_6__constants_general__["_41" /* TXT_REGEX */],type:'text'}},{input:{question:getState().json_lang.common.email,required:true,hint:'Email@Email.com',regex:__WEBPACK_IMPORTED_MODULE_6__constants_general__["m" /* EMAIL_REGEX */],type:'text'}},{input:{question:getState().json_lang.common.confirmation_number,required:true,hint:'00000000',regex:__WEBPACK_IMPORTED_MODULE_6__constants_general__["_42" /* TXT_REGEX_MIN4 */],type:'numeric'}},{input:{question:getState().json_lang.common.last_digits_issuing_account,required:true,hint:'1234',regex:__WEBPACK_IMPORTED_MODULE_6__constants_general__["B" /* NUMBER_REGEX */],type:'numeric'}},{file:{question:getState().json_lang.common.screenshot,required:true,type:'file'}}];}else if(intForm===INSTORE){data.name='Pago en tienda';answers=[{option:{question:getState().json_lang.common.payment_type,required:true,choices:[getState().json_lang.common.cash,getState().json_lang.common.point_of_sale]}}];}else if(intForm===RESERVE){data.name='Reserve';answers=[{text:{question:'Usuario del comercio',content:''}},{input:{question:'# de transacción',required:true,hint:'Código',regex:__WEBPACK_IMPORTED_MODULE_6__constants_general__["_42" /* TXT_REGEX_MIN4 */],content:'',type:'text'}},{input:{question:'¿Quién envia el pago?',required:true,hint:'Coloca tu usuario de Reserve',regex:__WEBPACK_IMPORTED_MODULE_6__constants_general__["_41" /* TXT_REGEX */],type:'text'}}];}else if(intForm===HUMANIZ){data.name='Humaniz';answers=[{text:{question:'Datos del comercio',content:''}},{input:{question:'# de transacción',required:true,hint:'Código',regex:__WEBPACK_IMPORTED_MODULE_6__constants_general__["_42" /* TXT_REGEX_MIN4 */],content:'',type:'text'}},{input:{question:'¿Quién envia el pago?',required:true,hint:'Coloca tu usuario de Humaniz',regex:__WEBPACK_IMPORTED_MODULE_6__constants_general__["_41" /* TXT_REGEX */],type:'text'}}];}else if(intForm===BINANCE){data.name='Binance';answers=[{text:{question:'Usuario del comercio',content:''}},{input:{question:'# de transacción',required:true,hint:'Código',regex:__WEBPACK_IMPORTED_MODULE_6__constants_general__["_42" /* TXT_REGEX_MIN4 */],content:'',type:'text'}},{input:{question:'¿Quién envia el pago?',required:true,hint:'Coloca tu usuario de Binance',regex:__WEBPACK_IMPORTED_MODULE_6__constants_general__["_41" /* TXT_REGEX */],type:'text'}}];}else if(intForm===PAYPAL){data.name='Paypal';answers=[{text:{question:'Usuario del comercio',content:''}},{input:{question:'# de transacción',required:true,hint:'Código',regex:__WEBPACK_IMPORTED_MODULE_6__constants_general__["_42" /* TXT_REGEX_MIN4 */],content:'',type:'text'}},{input:{question:'¿Quién envia el pago?',required:true,hint:'Coloca tu usuario de Paypal',regex:__WEBPACK_IMPORTED_MODULE_6__constants_general__["m" /* EMAIL_REGEX */],type:'text'}}];}else if(intForm===DEFAULT){data.name='';answers=[];}data.answers=answers;data.icon=intForm;dispatch({type:'FORM_TYPE',form:data});};};var removeitem=function removeitem(key){return function(dispatch,getState){var update=getState().form.answers.filter(function(item,index){return index!==key;});var newdata=Object.assign({},getState().form);newdata.answers=update;dispatch({type:'FORM_TYPE',form:newdata});};};var clearForm=function clearForm(){return function(dispatch){dispatch({type:'GET_FORM',form:{answers:[]}});};};/////////////////////////////cancelation reazons
var findCancelationReasons=function findCancelationReasons(){var type=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'admin';return function(dispatch){var path=type==='admin'?'/cancellation-reasons?limit=0':'/client-cancellation-reasons?limit=0';return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().company.id+path).then(function(res){dispatch({type:'GET_CANCELATION_REASONS',cancelationReasons:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.custom_errors.form_delete_failed});});};};var createCancelationReason=function createCancelationReason(){var type=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'admin';var data={reason:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().newCancelationReason};return function(dispatch){var path=type==='admin'?'/cancellation-reasons':'/client-cancellation-reasons';__WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().company.id+path,data).then(function(res){var succesful=__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.common.success;__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.custom_success.saved_successful});dispatch({type:'UPDATE_CANCELATION_REASONS',cancelationReasons:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().cancelationReasons.concat(res.data)});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.custom_errors.cancelation_reason_registration_failed});});};};var updateCancelationReason=function updateCancelationReason(id,data){var type=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'admin';var newreason={reason:data};return function(dispatch){dispatch({type:"WAIT_FOR_RESPONSE"});var path=type==='admin'?'/cancellation-reasons':'/client-cancellation-reasons';__WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().company.id+path+'/'+id,newreason).then(function(res){var cancelationReasons=__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().cancelationReasons.map(function(cancelationReason){if(cancelationReason.id===parseInt(res.data.id,10)){cancelationReason.reason=res.data.reason;}return cancelationReason;});var succesful=__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.common.success;__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.custom_success.update_successful});dispatch({type:'UPDATE_CANCELATION_REASONS',cancelationReasons:cancelationReasons});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.custom_errors.cancelation_reason_update_failed});});};};var deleteCancelationReason=function deleteCancelationReason(id){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'admin';return function(dispatch){dispatch({type:"WAIT_FOR_RESPONSE"});var path=type==='admin'?'/cancellation-reasons':'/client-cancellation-reasons';__WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().company.id+path+'/'+id).then(function(res){var cancelationReasons=__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().cancelationReasons.filter(function(cancelationReason){return cancelationReason.id!==parseInt(res.data.id,10);});var succesful=__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.common.success;__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.custom_success.delete_successful});dispatch({type:'UPDATE_CANCELATION_REASONS',cancelationReasons:cancelationReasons});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.custom_errors.cancelation_reason_delete_failed});});};};var toggleCancelationReason=function toggleCancelationReason(value){return function(dispatch){var name=value.name.split('-')?value.name.split('-'):undefined;if(name[0]==='cancelReason'){var cancelationReasons=__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().cancelationReasons.map(function(cancelationReason,key){if(key===parseInt(name[1],10)){cancelationReason.reason=value.data;}return cancelationReason;});dispatch({type:'GET_CANCELATION_REASONS',cancelationReasons:cancelationReasons});}else{var data=__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().newCancelationReason=value.data;dispatch({type:'CANCELATION_REASON',newCancelationReason:data});}};};var getAllPayment=function getAllPayment(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var sort=arguments[1];var search_query=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"";//&portal=ilike paypal
return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){var _getState,company,branch,url_host;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch({type:"WAIT_FOR_RESPONSE"});_getState=getState(),company=_getState.company,branch=_getState.branch;/* options=flag 15,15& */// let url_host = `/payments?desc&options=flag 15,15&order-status=flag 1015808,163840&limit=10&with=branch&page=${page}${sort? `&sort_by=${sort.columnName},${sort.direction}` :``}`;
url_host='/payments?limit=40&with=branch&page='+page+(sort?'&sort_by='+sort.columnName+','+sort.direction:'');if(branch.id){url_host='/branches/'+branch.id+'/payments?limit=40&with=branch&page='+page+(sort?'&sort_by='+sort.columnName+','+sort.direction:'');}url_host+=search_query!==""?'&'+search_query:"";return _context.abrupt('return',__WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+url_host).then(function(res){dispatch({type:"GET_ALL_PAYMENT",allPayments:res.data});}).catch(function(err){if(err.message)__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});}));case 6:case'end':return _context.stop();}}},_callee,_this);}));return function(_x7,_x8){return _ref.apply(this,arguments);};}();};var getCompanyEarningsReport=function getCompanyEarningsReport(starDate,endDate){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState2=getState(),company=_getState2.company,branch=_getState2.branch;var url_host='/earnings-report';if(branch.id){url_host=url_host+'?branch_id='+branch.id;}if(starDate&&endDate){url_host=''+url_host+(branch.id?'&':'?')+'completed_at=between '+starDate+','+endDate;}return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(''+(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+url_host)).then(function(res){dispatch({type:'GET_COMPANY_EARNING',companyEarning:res.data});}).catch(function(err){if(err.message)__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});});};};var getCompanyPaymentReport=function getCompanyPaymentReport(type,date){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState3=getState(),company=_getState3.company;if(type==='today'){date='?created_at=between '+date.startOf+','+date.endOf;}if(type==='custom'){date='?created_at=between '+date.startOf+','+date.endOf;}if(type==='this_week'){date='?created_at=between '+date.startOf+','+date.endOf;}if(type==='this_month'){date='?created_at=month '+date;}return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/payments-report'+(type?date:'')).then(function(res){dispatch({type:'GET_PAYMENT_REPORT',companyPayment:res.data});}).catch(function(err){if(err.message)__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});});};};var getTodayPayment=function getTodayPayment(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var sort=arguments[1];var startDate=arguments[2];var endDate=arguments[3];var queryString=arguments[4];return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState4=getState(),company=_getState4.company;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/payments?limit=10&options=flag 15,15&with=branch&order-status=flag 1015808,163840&created_at=between '+startDate+','+endDate+'&page='+page+(sort?'&sort_by='+sort.columnName+','+sort.direction:'')+(queryString?'&'+queryString:'')).then(function(res){//return axios.get(`${URL + company.id}/payments?sort_by=id,desc&limit=0&created_at=${date}&options=flag 15,15&order-status=flag 1015808,163840`).then( (res) => {
dispatch({type:'GET_ALL_PAYMENT',allPayments:res.data});}).catch(function(err){if(err.message)__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});});};};var getWeekPayment=function getWeekPayment(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var sort=arguments[1];var starDate=arguments[2];var endDate=arguments[3];var queryString=arguments[4];return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState5=getState(),company=_getState5.company;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/payments?limit=10&page='+page+'&options=flag 15,15&with=branch&order-status=flag 1015808,163840&created_at=between '+starDate+','+endDate+(sort?'&sort_by='+sort.columnName+','+sort.direction:'')+(queryString?'&'+queryString:'')).then(function(res){dispatch({type:'GET_ALL_PAYMENT',allPayments:res.data});}).catch(function(err){if(err.message)__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});});};};var getMonthPayment=function getMonthPayment(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var sort=arguments[1];var month=arguments[2];var queryString=arguments[3];return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState6=getState(),company=_getState6.company;return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/payments?limit=10&options=flag 15,15&with=branch&order-status=flag 1015808,163840&created_at=month '+month+'&page='+page+(sort?'&sort_by='+sort.columnName+','+sort.direction:'')+(queryString?'&'+queryString:'')).then(function(res){dispatch({type:'GET_ALL_PAYMENT',allPayments:res.data});}).catch(function(err){if(err.message)__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});});};};var getPayment=function getPayment(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+getState().company.id+'/payments/'+id).then(function(res){dispatch({type:'GET_ONE_PAYMENT',onePayment:res.data});}).catch(function(err){if(err.message)__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});});};};var acceptPayment=function acceptPayment(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+getState().company.id+'/payments/'+id+'/accept').then(function(res){var newPay=Object.assign({},res.data,{admin:{display_name:getState().session.display_name}});var update=getState().payment_form.map(function(item){if(item.id===res.data.id)item=newPay;return item;});var succesful=getState().json_lang.common.success;__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:getState().json_lang.custom_success.saved_successful});dispatch({type:'UPDATE_PAYMENT_FORM',payment_form:update});}).catch(function(err){if(err.message){if(err.data.error_code==="EC516"){__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:'Esta orden tiene pago automatizado, debe esperar al menos 5 minutos para poder validarlo manualmente.'});}else{__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});}}});};};var clearPayment=function clearPayment(){return function(dispatch){dispatch({type:'GET_ONE_PAYMENT',onePayment:{}});};};var duplicatedPayment=function duplicatedPayment(id){return function(dispatch){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().company.id+'/payments/'+id+'/set-duplicated').then(function(res){var newPay=Object.assign({},res.data,{admin:{display_name:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().session.display_name}});var update=__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().payment_form.map(function(item){if(item.id===res.data.id)item=newPay;return item;});var succesful=__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.common.success;__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.custom_success.saved_successful});dispatch({type:'UPDATE_PAYMENT_FORM',payment_form:update});}).catch(function(err){if(err.data){if(err.data.error_code==="EC516"){__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:'Esta orden tiene pago automatizado, debe esperar al menos 5 minutos para poder validarlo manualmente.'});}else{__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.data.description});}}});};};var invalidPayment=function invalidPayment(id){return function(dispatch){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().company.id+'/payments/'+id+'/set-invalid').then(function(res){var newPay=Object.assign({},res.data,{admin:{display_name:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().session.display_name}});var update=__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().payment_form.map(function(item){if(item.id===res.data.id)item=newPay;return item;});var succesful=__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.common.success;__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getState().json_lang.custom_success.saved_successful});dispatch({type:'UPDATE_PAYMENT_FORM',payment_form:update});}).catch(function(err){if(err.data){if(err.data.error_code==="EC516"){__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:'Esta orden tiene pago automatizado, debe esperar al menos 5 minutos para poder validarlo manualmente.'});}else{__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.data.description});}}});};};var refundPayment=function refundPayment(id,orderId,note){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState7=getState(),json_lang=_getState7.json_lang,company=_getState7.company,session=_getState7.session,payment_form=_getState7.payment_form,orderDetails=_getState7.orderDetails;var adminNotes={admin_notes:note};return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(''+__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/orders/'+orderId,adminNotes).then(function(res){if(orderDetails){dispatch({type:'FETCH_ORDER_DETAILS',orderDetails:Object.assign({},orderDetails,res.data)});}return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+company.id+'/payments/'+id+'/set-refunded').then(function(res){var newPay=Object.assign({},res.data,{admin:{display_name:session.display_name}});var update=payment_form.map(function(item){if(item.id===res.data.id)item=newPay;return item;});var succesful=json_lang.common.success;__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"success",title:succesful,msg:json_lang.custom_success.saved_successful});dispatch({type:'UPDATE_PAYMENT_FORM',payment_form:update});}).catch(function(err){if(err.data){if(err.data.error_code==="EC507"){__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:'Este m\xE9todo de pago no soporta acciones manuales.'});}else{__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.data.description});}}else{__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error',msg:json_lang.two_steps_modal.default_error});}});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else __WEBPACK_IMPORTED_MODULE_5__handlers_Notification__["a" /* default */].show({type:"error",title:err.title,msg:getState().json_lang.custom_errors.order_confirm});});};};var confirmCheckout=function confirmCheckout(id,qs){var data={};qs.split('&').map(function(query,i){var a=query.split('=');data[a[0].toLowerCase()]=a[1];return query;});var param={payerId:data.payerid};return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_2__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_1__config_js__["c" /* URL */]+getState().company.id+'/payments/'+id+'/charge',param).then(function(res){dispatch({type:'GET_PAYMENT_RESPONSE',paymentResponse:res.data&&res.data.data});}).catch(function(err){dispatch({type:'GET_PAYMENT_RESPONSE',paymentResponse:err.data});});};};

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return findSetings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return addCompanyAccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return removeCompanyAccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return updatePreferences; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return disableAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return updateSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return updateSmsSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GetAllAdminTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return fetchSellerAdmins; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return assigmentClients; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return attachAssigmentClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return dettachAssigmentClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return fetchAvailableCLients; });
/* unused harmony export show */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return fetchArchivedAdmins; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return fetchAdmins; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return toggleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return restoreAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return update; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return register; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return destroy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return upgrade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return downgrade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return sendmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return clearAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetAdminType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return attachAdminTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return updateAdminType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return deleteAdminType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return createAdminType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return deleteAdminTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return activateAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return accountSettingUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return toggleNotification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tableActions__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__ = __webpack_require__(8);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}//import { b64toBlob } from './UtilsOperation';
var clearAdmin=function clearAdmin(){return function(dispatch){dispatch({type:'CLEAR_ADMIN',admin:{},dropzoneFiles:[]});};};var show=function show(){return function(dispatch,getState){__WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/admins').then(function(res){dispatch({type:'FETCH_ADMINS',admin:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_user_list});}});};};var find=function find(id,preloader){return function(dispatch,getState){if(preloader){dispatch({type:"WAIT_FOR_RESPONSE"});}return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/admins/'+id+'?with=accesses.related_access,city').then(function(res){dispatch({type:'FETCH_ADMIN',admin:res.data});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.retrieving_user_data});}});};};var findSetings=function findSetings(id){return function(dispatch,getState){var _getState=getState(),company=_getState.company,json_lang=_getState.json_lang,admin=_getState.admin;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/admins/'+id+'/settings').then(function(res){var update=admin;update.settings=res.data;dispatch({type:'FETCH_ADMIN',admin:update});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:json_lang.custom_errors.retrieving_user_data});}});};};var toggleNotification=function toggleNotification(value){return function(dispatch,getState){var data=getState().showNotification;dispatch({type:'TOOGLE_NOTIFICATIONS',showNotification:!data});};};var toggleData=function toggleData(value){return function(dispatch,getState){var data=Object.assign({},getState().admin);if(value.name==='enable_sms'||value.name==='enable_order_created_sms'||value.name==='enable_payment_registered_sms'||value.name==='enable_manual_payment_reported_sms'||value.name==='enable_order_canceled_sms'||value.name==='enable_support_sms'||value.name==='enable_telegram_rates'||value.name==='enable_telegram_orders'||value.name==='enable_telegram_reminders'||value.name==='enable_telegram_alerts'){data.settings[value.name]=!data.settings[value.name];}else{data[value.name]=value.data;}data.dataUpdated=true;dispatch({type:'FETCH_ADMIN',admin:data});};};var update=function update(clear,adminData){return function(dispatch,getState){var _getState2=getState(),company=_getState2.company,json_lang=_getState2.json_lang;var newAdmin=Object.assign({},adminData);dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/admins/'+newAdmin.id,newAdmin).then(function(res){if(newAdmin.email!==res.data.email){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/accounts/'+res.data.account_id+'/update-email',{email:newAdmin.email}).then(function(resEmail){dispatch({type:"REMOVE_LOADING"});res.data.email=resEmail.data.email;__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.admin_updated});res.data.accesses=newAdmin.accesses;dispatch({type:'ADMIN_UPDATE_SUCCESS',admin:newAdmin});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else{if(err.data&&err.data.request&&(err.data.request.name===null||err.data.request.phone===null)){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.empty_fields});}else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_update_failed});}}});}else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.admin_updated});dispatch({type:'ADMIN_UPDATE_SUCCESS',admin:newAdmin});}}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else{if(err.data&&err.data.request&&(err.data.request.name===null||err.data.request.phone===null)){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.empty_fields});}else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_update_failed});}}});};};var updatePreferences=function updatePreferences(admin_id,prefs){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/admins/'+admin_id+'/settings',prefs).then(function(res){// update redux store
dispatch({type:'ADMIN_UPDATE_PREFERENCES',preferences:res.data.preferences});// update localstorage in case user reload browser
var session=JSON.parse(localStorage.getItem('user'));session.settings.preferences=res.data.preferences;localStorage.setItem('user',JSON.stringify(session));__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.admin_updated});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_update_failed});}});};};var updateSettings=function updateSettings(settings){return function(dispatch,getState){var data=Object.assign({},getState().admin);var admin={enable_sms:data.settings.enable_sms,enable_order_created_sms:data.settings.enable_order_created_sms,// enable_payment_registered_sms: data.settings.enable_payment_registered_sms === true ? 1:0,
enable_manual_payment_reported_sms:data.settings.enable_manual_payment_reported_sms,enable_order_canceled_sms:data.settings.enable_order_canceled_sms,enable_telegram_rates:data.settings.enable_telegram_rates,enable_telegram_orders:data.settings.enable_telegram_orders,enable_telegram_reminders:data.settings.enable_telegram_reminders,enable_telegram_alerts:data.settings.enable_telegram_alerts// enable_support_sms:data.settings.enable_support_sms === true ? 1:0
};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/admins/'+data.id+'/settings',admin).then(function(res){dispatch({type:"REMOVE_LOADING"});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.admin_updated});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else{if(err.data&&err.data.request&&(err.data.request.name===null||err.data.request.phone===null)){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.empty_fields});}else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_update_failed});}}});};};var updateSmsSettings=function updateSmsSettings(sms,adminId){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/admins/'+adminId+'/settings',sms).then(function(res){dispatch({type:"REMOVE_LOADING"});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.admin_updated});}).catch(function(err){if(err.message&&err.message!=='generic')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else{if(err.data&&err.data.request&&(err.data.request.name===null||err.data.request.phone===null)){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.empty_fields});}else{__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:getState().json_lang.custom_errors.user_update_failed});}}});};};var register=function register(adminData){return function(dispatch,getState){var data=adminData;/*var admin = new FormData();

        admin.append('url', window.location.host)
        //admin.append('display_name', data.display_name)
        admin.append('email', data.email)
        admin.append('name', data.name)
        admin.append('phone', data.phone)
        admin.append('password',"secret")

        if(getState().dropzoneFiles.length){
            var block = getState().dropzoneFiles.split(";");
            var contentType = block[0].split(":")[1];
            var realData = block[1].split(",")[1];
            var blob = b64toBlob(realData, contentType);
            admin.append('avatar', blob);
        }else if(data.avatar_url && data.avatar_url.length ){
           admin.append('avatar_url', data.avatar_url)
        }*/var admin={name:data.name,email:data.email,phone:data.phone,password:"secret",city_id:parseInt(data.city_id,10)};dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/admins',admin).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});res.data.accesses=[];dispatch({type:'ADMIN_REGISTER_SUCCESS',admin:res.data});}).catch(function(err){console.log('error: ======================================================> ',err);if(err.data&&err.data.message.indexOf("already_exists")===0||err.message==='The entity already exists')__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:getState().json_lang.custom_errors.user_registration_failed,msg:getState().json_lang.custom_errors.user_already_exist});else __WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:getState().json_lang.custom_errors.user_registration_failed});});};};var destroy=function destroy(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/accounts/'+id).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.delete_successful});dispatch({type:'ADMIN_DELETED',admins:Object(__WEBPACK_IMPORTED_MODULE_2__tableActions__["i" /* tableRemoveAcount */])(res,"admins")});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:getState().json_lang.custom_errors.user_delete_failed});});};};var restoreAdmin=function restoreAdmin(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/accounts/'+id+'/restore').then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.restored_user});dispatch({type:'ADMIN_DELETED',admins:Object(__WEBPACK_IMPORTED_MODULE_2__tableActions__["i" /* tableRemoveAcount */])(res,"admins")});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:getState().json_lang.custom_errors.user_restore_failed});});};};var disableAdmin=function disableAdmin(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/accounts/'+id+'/disable').then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});dispatch({type:'ADMIN_UPDATE_SUCCESS',admins:Object(__WEBPACK_IMPORTED_MODULE_2__tableActions__["j" /* tableUpdate */])(res,"admins")});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:getState().json_lang.custom_errors.user_restore_failed});});};};var activateAdmin=function activateAdmin(id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/accounts/'+id+'/activate').then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});dispatch({type:'ADMIN_DELETED',admins:Object(__WEBPACK_IMPORTED_MODULE_2__tableActions__["i" /* tableRemoveAcount */])(res,"admins")});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:getState().json_lang.custom_errors.user_restore_failed});});};};var accountSettingUpdate=function accountSettingUpdate(id,telegram_id){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var data={telegram_id:''+telegram_id};return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/accounts/'+id+'/settings',data).then(function(res){}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:getState().json_lang.custom_errors.user_restore_failed});});};};var upgrade=function upgrade(id){var updatedTable=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"admins";return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});__WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/admins/'+id+'/upgrade').then(function(){dispatch(fetchAdmins());// dispatch({
//     type: 'ADMIN_UPDATE_SUCCESS',
//     admins: tableUpdate(res, updatedTable),
// });
__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:getState().json_lang.custom_errors.user_update_failed});});};};var downgrade=function downgrade(id){var updatedTable=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"admins";return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});__WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/admins/'+id+'/downgrade').then(function(){dispatch(fetchAdmins());// dispatch({
//     type: 'ADMIN_UPDATE_SUCCESS',
//     admins: tableUpdate(res, updatedTable),
// })
__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.update_successful});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:getState().json_lang.custom_errors.user_update_failed});});};};var sendmail=function sendmail(email){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/confirm/'+email+'?type=admin').then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.email_sent});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:getState().json_lang.custom_errors.email_not_sent});});};};var fetchAdmins=function fetchAdmins(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var sort=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';var loader=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;return function(dispatch,getState){var _getState3=getState(),company=_getState3.company;if(loader)dispatch({type:"WAIT_FOR_RESPONSE"});var url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/admins?limit=10&page='+page+'&with=account,accesses.related_access';url_host+=query!==''?'&'+query:'';url_host+=sort!==''?'&sort_by='+sort.columnName+','+sort.direction:'';return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(url_host).then(function(res){dispatch({type:'FETCH_ADMINS',admins:res.data});}).catch(function(err){if(loader)dispatch({type:"REMOVE_LOADING"});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:getState().json_lang.custom_errors.retrieving_user_list});});};};var fetchArchivedAdmins=function fetchArchivedAdmins(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var sort=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';return function(dispatch,getState){var _getState4=getState(),company=_getState4.company;var url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/admins?limit=10&page='+page+'&with=account,accesses.related_access&mode=deleted';url_host+=query!==''?'&'+query:'';url_host+=sort!==''?'&sort_by='+sort.columnName+','+sort.direction:'';return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(url_host).then(function(res){dispatch({type:'FETCH_ADMINS',admins:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:getState().json_lang.custom_errors.retrieving_user_list});});};};var fetchSellerAdmins=function fetchSellerAdmins(){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/admins?limit=0&account-type=48').then(function(res){dispatch({type:'FETCH_ADMINS',admins:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:getState().json_lang.custom_errors.retrieving_user_list});});};};var fetchAvailableCLients=function fetchAvailableCLients(adminId){return function(dispatch,getState){return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/admins/'+adminId+'/clients').then(function(res){var clientsToAsing=[].concat(_toConsumableArray(getState().allClients));var assinedClients=res.data.map(function(client){return client.id;});var avaliableToAsing=void 0;if(res.data&&res.data.length>0){avaliableToAsing=clientsToAsing.filter(function(client){return!assinedClients.includes(client.id);});}dispatch({type:'ATTACHABLE_CLIENS',clientsToAsing:res.data,allClients:res.data&&res.data.length>0?avaliableToAsing:clientsToAsing});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message&&err.message!=='generic'?err.message:getState().json_lang.custom_errors.retrieving_user_list});});};};var attachAssigmentClient=function attachAssigmentClient(clientId){return function(dispatch,getState){var clientsToAsing=[].concat(_toConsumableArray(getState().clientsToAsing));var allClients=[].concat(_toConsumableArray(getState().allClients));var newAssing=allClients.find(function(client){return client.id===clientId;});clientsToAsing.push(newAssing);var allClientsUpdate=getState().allClients.filter(function(client){return client.id!==clientId;});dispatch({type:'ATTACHABLE_CLIENS',clientsToAsing:clientsToAsing,allClients:allClientsUpdate});};};var dettachAssigmentClient=function dettachAssigmentClient(clientId){return function(dispatch,getState){var clientsToAsing=[].concat(_toConsumableArray(getState().clientsToAsing));var allClients=[].concat(_toConsumableArray(getState().allClients));var avaliableAssing=clientsToAsing.find(function(client){return client.id===clientId;});allClients.push(avaliableAssing);var allClientsUpdate=clientsToAsing.filter(function(client){return client.id!==clientId;});dispatch({type:'ATTACHABLE_CLIENS',clientsToAsing:allClientsUpdate,allClients:allClients});};};var assigmentClients=function assigmentClients(adminId){return function(dispatch,getState){var assigmentClients=getState().clientsToAsing.map(function(client){return client.id;});dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].put(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/admins/'+adminId+'/clients',assigmentClients).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:getState().json_lang.common.success,msg:getState().json_lang.custom_success.saved_successful});dispatch({type:'REMOVE_LOADING'});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var GetAdminType=function GetAdminType(adminId){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/admin-type/'+adminId).then(function(res){dispatch({type:'FETCH_ADMINTYPE',adminType:res.data});}).catch(function(err){});};};var GetAllAdminTypes=function GetAllAdminTypes(){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(''+__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+getState().company.id+'/admin-types?limit=0').then(function(res){/* let usern1 = {
                id: 11,
                name: "Administrador Ridery",
                default_key: "orders",
                content: [
                    {
                        key: "dashboard",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "map",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "orders",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "categories",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "goods",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "attributes",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "settings",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "clients",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "reports",
                        value: {
                            is_visible: true
                        }
                    }
                ],
                code: 11,
                roles: [],
                uid: 11
            };
            let usern2 = {
                id: 12,
                name: "Órdenes Ridery",
                default_key: "orders",
                content: [
                    {
                        key: "dashboard",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "map",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "orders",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "categories",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "goods",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "attributes",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "settings",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "clients",
                        value: {
                            is_visible: false
                        }
                    },
                    {
                        key: "reports",
                        value: {
                            is_visible: true
                        }
                    }
                ],
                code: 12,
                roles: [],
                uid: 12
            }
            res.data.push(otro)
            res.data.push(otro2)*/dispatch({type:'FETCH_ALLADMINTYPES',allAdminTypes:res.data});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var attachAdminTypes=function attachAdminTypes(adminId,adminTypeId){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState5=getState(),company=_getState5.company,json_lang=_getState5.json_lang,admins=_getState5.admins,allAdminTypes=_getState5.allAdminTypes;var prevAdminsData=Object.assign({},admins);return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].put(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/admins/'+adminId+'/admin-types/'+adminTypeId).then(function(res){var findIndex=prevAdminsData.data.findIndex(function(admin){return admin.id===adminId;});if(findIndex!==-1){var adminType=allAdminTypes.find(function(type){return type.uid===res.data.admin_type_id;});if(adminType){prevAdminsData.data[findIndex].admin_type=adminType;}}dispatch({type:'FETCH_ADMINS',admins:Object.assign({},prevAdminsData)});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){dispatch({type:'REMOVE_LOADING'});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var updateAdminType=function updateAdminType(adminType,adminRoles){return function(dispatch,getState){var _getState6=getState(),company=_getState6.company,json_lang=_getState6.json_lang,allAdminTypes=_getState6.allAdminTypes;var newAdminTypes=allAdminTypes;var newType=Object.assign({},adminType,{roles:adminRoles});dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].patch(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/admin-types/'+adminType.uid,newType).then(function(res){var index=newAdminTypes.findIndex(function(type){return type.uid===res.data.uid;});newAdminTypes[index]=res.data;newAdminTypes=[].concat(_toConsumableArray(newAdminTypes));dispatch({type:'FETCH_ALLADMINTYPES',allAdminTypes:newAdminTypes});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var deleteAdminType=function deleteAdminType(id){return function(dispatch,getState){var _getState7=getState(),company=_getState7.company,json_lang=_getState7.json_lang,allAdminTypes=_getState7.allAdminTypes;dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/admin-types/'+id).then(function(){dispatch({type:'FETCH_ALLADMINTYPES',allAdminTypes:allAdminTypes.filter(function(type){return type.uid!==id;})});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.delete_successful});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var createAdminType=function createAdminType(adminType,adminRoles){return function(dispatch,getState){var _getState8=getState(),company=_getState8.company,json_lang=_getState8.json_lang,allAdminTypes=_getState8.allAdminTypes;var newType=Object.assign({},adminType,{content:[],roles:adminRoles});dispatch({type:"WAIT_FOR_RESPONSE"});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/admin-types',newType).then(function(res){var _ref;var newAdminTypes=(_ref=[res.data]).concat.apply(_ref,_toConsumableArray(allAdminTypes));dispatch({type:'FETCH_ALLADMINTYPES',allAdminTypes:newAdminTypes});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var deleteAdminTypes=function deleteAdminTypes(adminId,adminTypeId){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState9=getState(),company=_getState9.company,json_lang=_getState9.json_lang,admins=_getState9.admins;var prevAdminsData=Object.assign({},admins);return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/admins/'+adminId+'/admin-types/'+adminTypeId).then(function(res){var findIndex=prevAdminsData.data.findIndex(function(admin){return admin.id===adminId;});if(findIndex!==-1){prevAdminsData.data[findIndex].admin_type=null;}dispatch({type:'FETCH_ADMINS',admins:Object.assign({},prevAdminsData)});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});}).catch(function(err){dispatch({type:'REMOVE_LOADING'});__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var addCompanyAccess=function addCompanyAccess(adminId){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState10=getState(),company=_getState10.company,json_lang=_getState10.json_lang;// creo un objeto en local porque el api solo retorna el Modelo de access, no tiene data sobre el admin
//!let admin = admins.data.find(a => a.id === adminId)
var access={"access_type":"company","access_id":company.id};return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/admins/'+adminId+'/admin-accesses',access).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.saved_successful});/*admin.accesses.push(res.data)
				dispatch({
					type: 'FETCH_ADMINS',
					admins: tableUpdate({data: admin}, "admins"),
				})*/dispatch({type:'REMOVE_LOADING'});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};var removeCompanyAccess=function removeCompanyAccess(adminId){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState11=getState(),company=_getState11.company,json_lang=_getState11.json_lang,admins=_getState11.admins;// creo un objeto en local porque el api solo retorna el Modelo de access, no tiene data sobre el admin
var admin=admins.data.find(function(a){return a.id===adminId;});var access_id=admin.accesses.find(function(a){return a.access_type==="company";}).id;// le quito el acceso a company
admin.accesses=admin.accesses.filter(function(a){return a.access_type!=="company";});return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].delete(__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/admin-accesses/'+access_id).then(function(res){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"success",title:json_lang.common.success,msg:json_lang.custom_success.delete_successful});/*dispatch({
					type: 'FETCH_ADMINS',
					admins: tableUpdate({data: admin}, "admins"),
				})*/dispatch({type:'REMOVE_LOADING'});}).catch(function(err){__WEBPACK_IMPORTED_MODULE_3__handlers_Notification__["a" /* default */].show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:""});});};};

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Errors;
function Errors(error){var errorsData={message:"error",errors:{}};/*if (error.response.status) {
        errorsData.errors = error.response.data.errors;
    }*//*if( error.response.hasOwnProperty('status') ) {
         switch(error.response.status) {
            case 401:
                errorsData.message = error.response.data.error.message;
            break;
            case 403:
                errorsData.message = error.response.data.message;
            break;
            case 422:
                errorsData = error.response.data;

            break;
         }
    }*/return errorsData;}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

/*! react-rating - 1.3.0 | (c) 2015, 2018  dreyescat | MIT | https://github.com/dreyescat/react-rating */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["ReactRating"] = factory(require("react"));
	else
		root["ReactRating"] = factory(root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/lib";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utilsStyle = __webpack_require__(13);
	
	var _utilsStyle2 = _interopRequireDefault(_utilsStyle);
	
	var _Rating = __webpack_require__(15);
	
	var _Rating2 = _interopRequireDefault(_Rating);
	
	var _utilsNoop = __webpack_require__(17);
	
	var _utilsNoop2 = _interopRequireDefault(_utilsNoop);
	
	var RatingAPILayer = (function (_React$PureComponent) {
	  _inherits(RatingAPILayer, _React$PureComponent);
	
	  function RatingAPILayer(props) {
	    _classCallCheck(this, RatingAPILayer);
	
	    _get(Object.getPrototypeOf(RatingAPILayer.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      value: props.initialRating
	    };
	    this.handleClick = this.handleClick.bind(this);
	    this.handleHover = this.handleHover.bind(this);
	  }
	
	  _createClass(RatingAPILayer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        value: nextProps.initialRating
	      });
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(value, e) {
	      var _this = this;
	
	      var newValue = this.translateDisplayValueToValue(value);
	      // Avoid calling setState if not necessary. Micro optimisation.
	      if (this.state.value !== newValue) {
	        // If we have a new value trigger onChange callback.
	        this.setState({
	          value: newValue
	        }, function () {
	          return _this.props.onChange(_this.state.value);
	        });
	      }
	    }
	  }, {
	    key: 'handleHover',
	    value: function handleHover(displayValue) {
	      var value = displayValue === undefined ? displayValue : this.translateDisplayValueToValue(displayValue);
	      this.props.onHover(value);
	    }
	  }, {
	    key: 'translateDisplayValueToValue',
	    value: function translateDisplayValueToValue(displayValue) {
	      var translatedValue = displayValue * this.props.step + this.props.start;
	      // minimum value cannot be equal to start, since it's exclusive
	      return translatedValue === this.props.start ? translatedValue + 1 / this.props.fractions : translatedValue;
	    }
	  }, {
	    key: 'tranlateValueToDisplayValue',
	    value: function tranlateValueToDisplayValue(value) {
	      if (value === undefined) {
	        return 0;
	      }
	      return (value - this.props.start) / this.props.step;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var step = _props.step;
	      var emptySymbol = _props.emptySymbol;
	      var fullSymbol = _props.fullSymbol;
	      var placeholderSymbol = _props.placeholderSymbol;
	      var readonly = _props.readonly;
	      var quiet = _props.quiet;
	      var fractions = _props.fractions;
	      var direction = _props.direction;
	      var start = _props.start;
	      var stop = _props.stop;
	      var id = _props.id;
	      var className = _props.className;
	      var style = _props.style;
	      var tabIndex = _props.tabIndex;
	
	      function calculateTotalSymbols(start, stop, step) {
	        return Math.floor((stop - start) / step);
	      }
	
	      return _react2['default'].createElement(_Rating2['default'], {
	        id: id,
	        style: style,
	        className: className,
	        tabIndex: tabIndex,
	        'aria-label': this.props['aria-label'],
	        totalSymbols: calculateTotalSymbols(start, stop, step),
	        value: this.tranlateValueToDisplayValue(this.state.value),
	        placeholderValue: this.tranlateValueToDisplayValue(this.props.placeholderRating),
	        readonly: readonly,
	        quiet: quiet,
	        fractions: fractions,
	        direction: direction,
	        emptySymbol: emptySymbol,
	        fullSymbol: fullSymbol,
	        placeholderSymbol: placeholderSymbol,
	        onClick: this.handleClick,
	        onHover: this.handleHover
	      });
	    }
	  }]);
	
	  return RatingAPILayer;
	})(_react2['default'].PureComponent);
	
	RatingAPILayer.defaultProps = {
	  start: 0,
	  stop: 5,
	  step: 1,
	  readonly: false,
	  quiet: false,
	  fractions: 1,
	  direction: 'ltr',
	  onChange: _utilsNoop2['default'],
	  onHover: _utilsNoop2['default'],
	  emptySymbol: _utilsStyle2['default'].empty,
	  fullSymbol: _utilsStyle2['default'].full,
	  placeholderSymbol: _utilsStyle2['default'].placeholder
	};
	
	// Define propTypes only in development.
	RatingAPILayer.propTypes = "boolean" !== 'undefined' && (true) && {
	  start: _propTypes2['default'].number,
	  stop: _propTypes2['default'].number,
	  step: _propTypes2['default'].number,
	  initialRating: _propTypes2['default'].number,
	  placeholderRating: _propTypes2['default'].number,
	  readonly: _propTypes2['default'].bool,
	  quiet: _propTypes2['default'].bool,
	  fractions: _propTypes2['default'].number,
	  direction: _propTypes2['default'].string,
	  emptySymbol: _propTypes2['default'].oneOfType([
	  // Array of class names and/or style objects.
	  _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object, _propTypes2['default'].element])),
	  // Class names.
	  _propTypes2['default'].string,
	  // Style objects.
	  _propTypes2['default'].object,
	  // React element
	  _propTypes2['default'].element]),
	  fullSymbol: _propTypes2['default'].oneOfType([
	  // Array of class names and/or style objects.
	  _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object, _propTypes2['default'].element])),
	  // Class names.
	  _propTypes2['default'].string,
	  // Style objects.
	  _propTypes2['default'].object,
	  // React element
	  _propTypes2['default'].element]),
	  placeholderSymbol: _propTypes2['default'].oneOfType([
	  // Array of class names and/or style objects.
	  _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object, _propTypes2['default'].element])),
	  // Class names.
	  _propTypes2['default'].string,
	  // Style objects.
	  _propTypes2['default'].object,
	  // React element
	  _propTypes2['default'].element]),
	  onHover: _propTypes2['default'].func,
	  onChange: _propTypes2['default'].func
	};
	
	exports['default'] = RatingAPILayer;
	module.exports = exports['default'];

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (process.env.NODE_ENV !== 'production') {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = __webpack_require__(5)(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(12)();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(6);
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(8);
	var assign = __webpack_require__(9);
	
	var ReactPropTypesSecret = __webpack_require__(10);
	var checkPropTypes = __webpack_require__(11);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (process.env.NODE_ENV !== 'production') {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(6);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (process.env.NODE_ENV !== 'production') {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (process.env.NODE_ENV !== 'production') {
	  var invariant = __webpack_require__(7);
	  var warning = __webpack_require__(8);
	  var ReactPropTypesSecret = __webpack_require__(10);
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(6);
	var invariant = __webpack_require__(7);
	var ReactPropTypesSecret = __webpack_require__(10);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var merge = __webpack_require__(14);
	
	var style = {
	  display: 'inline-block',
	  borderRadius: '50%',
	  border: '5px double white',
	  width: 30,
	  height: 30
	};
	
	module.exports = {
	  empty: merge(style, {
	    backgroundColor: '#ccc'
	  }),
	  full: merge(style, {
	    backgroundColor: 'black'
	  }),
	  placeholder: merge(style, {
	    backgroundColor: 'red'
	  })
	};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function () {
	  var res = {};
	  for (var i = 0; i < arguments.length; i++) {
	    var obj = arguments[i];
	    for (var k in obj) {
	      res[k] = obj[k];
	    }
	  }
	  return res;
	};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RatingSymbol = __webpack_require__(16);
	
	var _RatingSymbol2 = _interopRequireDefault(_RatingSymbol);
	
	var Rating = (function (_React$PureComponent) {
	  _inherits(Rating, _React$PureComponent);
	
	  function Rating(props) {
	    _classCallCheck(this, Rating);
	
	    _get(Object.getPrototypeOf(Rating.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      // Indicates the value that is displayed to the user in the form of symbols.
	      // It can be either 0 (for no displayed symbols) or (0, end]
	      displayValue: this.props.value,
	      // Indicates if the user is currently hovering over the rating element
	      interacting: false,
	      // Indicates if the rating element has been clicked even once
	      dirty: false
	    };
	    this.onMouseEnter = this.onMouseEnter.bind(this);
	    this.onMouseLeave = this.onMouseLeave.bind(this);
	    this.symbolMouseMove = this.symbolMouseMove.bind(this);
	    this.symbolClick = this.symbolClick.bind(this);
	  }
	
	  // Define propTypes only in development.
	
	  _createClass(Rating, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var valueChanged = this.props.value !== nextProps.value;
	      this.setState(function (prevState) {
	        return {
	          dirty: valueChanged || prevState.dirty,
	          displayValue: valueChanged ? nextProps.value : prevState.displayValue
	        };
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // Ensure we do not call this.props.onHover on clicks or on mouseLeave
	      if (prevState.displayValue !== this.state.displayValue && this.state.interacting) {
	        this.props.onHover(this.state.displayValue);
	      }
	      // When hover ends, call this.props.onHover with no value.
	      if (prevState.interacting && !this.state.interacting) {
	        this.props.onHover();
	      }
	    }
	  }, {
	    key: 'symbolClick',
	    value: function symbolClick(symbolIndex, event) {
	      var value = this.calculateDisplayValue(symbolIndex, event);
	      this.props.onClick(value, event);
	    }
	  }, {
	    key: 'symbolMouseMove',
	    value: function symbolMouseMove(symbolIndex, event) {
	      var value = this.calculateDisplayValue(symbolIndex, event);
	      if (value !== this.state.displayValue) {
	        this.setState({
	          displayValue: value
	        });
	      }
	    }
	  }, {
	    key: 'onMouseEnter',
	    value: function onMouseEnter() {
	      this.setState({
	        interacting: !this.props.readonly
	      });
	    }
	  }, {
	    key: 'onMouseLeave',
	    value: function onMouseLeave() {
	      this.setState({
	        displayValue: this.props.value,
	        interacting: false
	      });
	    }
	  }, {
	    key: 'calculateDisplayValue',
	    value: function calculateDisplayValue(symbolIndex, event) {
	      var percentage = this.calculateHoverPercentage(event);
	      // Get the closest top fraction.
	      var fraction = Math.ceil(percentage % 1 * this.props.fractions) / this.props.fractions;
	      // Truncate decimal trying to avoid float precission issues.
	      var precision = Math.pow(10, 3);
	      var displayValue = symbolIndex + (Math.floor(percentage) + Math.floor(fraction * precision) / precision);
	      // ensure the returned value is greater than 0 and lower than totalSymbols
	      return displayValue > 0 ? displayValue > this.props.totalSymbols ? this.props.totalSymbols : displayValue : 1 / this.props.fractions;
	    }
	  }, {
	    key: 'calculateHoverPercentage',
	    value: function calculateHoverPercentage(event) {
	      var clientX = event.nativeEvent.type.indexOf("touch") > -1 ? event.nativeEvent.type.indexOf("touchend") > -1 ? event.changedTouches[0].clientX : event.touches[0].clientX : event.clientX;
	
	      var targetRect = event.target.getBoundingClientRect();
	      var delta = this.props.direction === 'rtl' ? targetRect.right - clientX : clientX - targetRect.left;
	
	      // Returning 0 if the delta is negative solves the flickering issue
	      return delta < 0 ? 0 : delta / targetRect.width;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var readonly = _props.readonly;
	      var quiet = _props.quiet;
	      var totalSymbols = _props.totalSymbols;
	      var value = _props.value;
	      var placeholderValue = _props.placeholderValue;
	      var direction = _props.direction;
	      var emptySymbol = _props.emptySymbol;
	      var fullSymbol = _props.fullSymbol;
	      var placeholderSymbol = _props.placeholderSymbol;
	      var className = _props.className;
	      var id = _props.id;
	      var style = _props.style;
	      var tabIndex = _props.tabIndex;
	      var _state = this.state;
	      var displayValue = _state.displayValue;
	      var interacting = _state.interacting;
	
	      var symbolNodes = [];
	      var empty = [].concat(emptySymbol);
	      var full = [].concat(fullSymbol);
	      var placeholder = [].concat(placeholderSymbol);
	      var shouldDisplayPlaceholder = placeholderValue !== 0 && value === 0 && !interacting;
	
	      // The value that will be used as base for calculating how to render the symbols
	      var renderedValue = undefined;
	      if (shouldDisplayPlaceholder) {
	        renderedValue = placeholderValue;
	      } else {
	        renderedValue = quiet ? value : displayValue;
	      }
	
	      // The amount of full symbols
	      var fullSymbols = Math.floor(renderedValue);
	
	      for (var i = 0; i < totalSymbols; i++) {
	        var percent = undefined;
	        // Calculate each symbol's fullness percentage
	        if (i - fullSymbols < 0) {
	          percent = 100;
	        } else if (i - fullSymbols === 0) {
	          percent = (renderedValue - i) * 100;
	        } else {
	          percent = 0;
	        }
	
	        symbolNodes.push(_react2['default'].createElement(_RatingSymbol2['default'], _extends({
	          key: i,
	          index: i,
	          readonly: readonly,
	          inactiveIcon: empty[i % empty.length],
	          activeIcon: shouldDisplayPlaceholder ? placeholder[i % full.length] : full[i % full.length],
	          percent: percent,
	          direction: direction
	        }, !readonly && {
	          onClick: this.symbolClick,
	          onMouseMove: this.symbolMouseMove,
	          onTouchMove: this.symbolMouseMove,
	          onTouchEnd: this.symbolClick
	        })));
	      }
	
	      return _react2['default'].createElement(
	        'span',
	        _extends({
	          id: id,
	          style: _extends({}, style, { display: 'inline-block', direction: direction }),
	          className: className,
	          tabIndex: tabIndex,
	          'aria-label': this.props['aria-label']
	        }, !readonly && {
	          onMouseEnter: this.onMouseEnter,
	          onMouseLeave: this.onMouseLeave
	        }),
	        symbolNodes
	      );
	    }
	  }]);
	
	  return Rating;
	})(_react2['default'].PureComponent);
	
	Rating.propTypes = "boolean" !== 'undefined' && (true) && {
	  totalSymbols: _propTypes2['default'].number.isRequired,
	  value: _propTypes2['default'].number.isRequired, // Always >= 0
	  placeholderValue: _propTypes2['default'].number.isRequired,
	  readonly: _propTypes2['default'].bool.isRequired,
	  quiet: _propTypes2['default'].bool.isRequired,
	  fractions: _propTypes2['default'].number.isRequired,
	  direction: _propTypes2['default'].string.isRequired,
	  emptySymbol: _propTypes2['default'].oneOfType([
	  // Array of class names and/or style objects.
	  _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object, _propTypes2['default'].element])),
	  // Class names.
	  _propTypes2['default'].string,
	  // Style objects.
	  _propTypes2['default'].object,
	  // React element
	  _propTypes2['default'].element]).isRequired,
	  fullSymbol: _propTypes2['default'].oneOfType([
	  // Array of class names and/or style objects.
	  _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object, _propTypes2['default'].element])),
	  // Class names.
	  _propTypes2['default'].string,
	  // Style objects.
	  _propTypes2['default'].object,
	  // React element
	  _propTypes2['default'].element]).isRequired,
	  placeholderSymbol: _propTypes2['default'].oneOfType([
	  // Array of class names and/or style objects.
	  _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object, _propTypes2['default'].element])),
	  // Class names.
	  _propTypes2['default'].string,
	  // Style objects.
	  _propTypes2['default'].object,
	  // React element
	  _propTypes2['default'].element]),
	  onClick: _propTypes2['default'].func.isRequired,
	  onHover: _propTypes2['default'].func.isRequired
	};
	
	exports['default'] = Rating;
	module.exports = exports['default'];

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	// Return the corresponding React node for an icon.
	var _iconNode = function _iconNode(icon) {
	  // If it is already a React Element just return it.
	  if (_react2['default'].isValidElement(icon)) {
	    return icon;
	  }
	  // If it is an object, try to use it as a CSS style object.
	  if (typeof icon === 'object' && icon !== null) {
	    return _react2['default'].createElement('span', { style: icon });
	  }
	  // If it is a string, use it as class names.
	  if (Object.prototype.toString.call(icon) === '[object String]') {
	    return _react2['default'].createElement('span', { className: icon });
	  }
	};
	
	var RatingSymbol = (function (_React$PureComponent) {
	  _inherits(RatingSymbol, _React$PureComponent);
	
	  function RatingSymbol() {
	    _classCallCheck(this, RatingSymbol);
	
	    _get(Object.getPrototypeOf(RatingSymbol.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  // Define propTypes only in development. They will be void in production.
	
	  _createClass(RatingSymbol, [{
	    key: 'render',
	    value: function render() {
	      var _iconContainerStyle;
	
	      var _props = this.props;
	      var index = _props.index;
	      var inactiveIcon = _props.inactiveIcon;
	      var activeIcon = _props.activeIcon;
	      var percent = _props.percent;
	      var direction = _props.direction;
	      var readonly = _props.readonly;
	      var onClick = _props.onClick;
	      var onMouseMove = _props.onMouseMove;
	
	      var backgroundNode = _iconNode(inactiveIcon);
	      var iconNode = _iconNode(activeIcon);
	      var iconContainerStyle = (_iconContainerStyle = {
	        display: 'inline-block',
	        position: 'absolute',
	        overflow: 'hidden',
	        top: 0
	      }, _defineProperty(_iconContainerStyle, direction === 'rtl' ? 'right' : 'left', 0), _defineProperty(_iconContainerStyle, 'width', percent + '%'), _iconContainerStyle);
	      var style = {
	        cursor: !readonly ? 'pointer' : 'inherit',
	        display: 'inline-block',
	        position: 'relative'
	      };
	
	      function handleMouseMove(e) {
	        if (onMouseMove) {
	          onMouseMove(index, e);
	        }
	      }
	
	      function handleMouseClick(e) {
	        if (onClick) {
	          // [Supporting both TouchEvent and MouseEvent](https://developer.mozilla.org/en-US/docs/Web/API/Touch_events/Supporting_both_TouchEvent_and_MouseEvent)
	          // We must prevent firing click event twice on touch devices.
	          e.preventDefault();
	          onClick(index, e);
	        }
	      }
	
	      return _react2['default'].createElement(
	        'span',
	        {
	          style: style,
	          onClick: handleMouseClick,
	          onMouseMove: handleMouseMove,
	          onTouchMove: handleMouseMove,
	          onTouchEnd: handleMouseClick
	        },
	        backgroundNode,
	        _react2['default'].createElement(
	          'span',
	          { style: iconContainerStyle },
	          iconNode
	        )
	      );
	    }
	  }]);
	
	  return RatingSymbol;
	})(_react2['default'].PureComponent);
	
	RatingSymbol.propTypes = "boolean" !== 'undefined' && (true) && {
	  index: _propTypes2['default'].number.isRequired,
	  readonly: _propTypes2['default'].bool.isRequired,
	  inactiveIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object, _propTypes2['default'].element]).isRequired,
	  activeIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object, _propTypes2['default'].element]).isRequired,
	  percent: _propTypes2['default'].number.isRequired,
	  direction: _propTypes2['default'].string.isRequired,
	  onClick: _propTypes2['default'].func,
	  onMouseMove: _propTypes2['default'].func,
	  onTouchMove: _propTypes2['default'].func,
	  onTouchEnd: _propTypes2['default'].func
	};
	
	exports['default'] = RatingSymbol;
	module.exports = exports['default'];

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function noop() {}
	noop._name = 'react_rating_noop';
	
	exports['default'] = noop;
	module.exports = exports['default'];

/***/ })
/******/ ])
});
;
//# sourceMappingURL=react-rating.js.map

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ImageDetailsModal=function(_Component){_inherits(ImageDetailsModal,_Component);function ImageDetailsModal(props){_classCallCheck(this,ImageDetailsModal);var _this=_possibleConstructorReturn(this,(ImageDetailsModal.__proto__||Object.getPrototypeOf(ImageDetailsModal)).call(this,props));_this.toggleModal=function(){_this.setState({modal:!_this.state.modal});};_this.state={modal:false};return _this;}_createClass(ImageDetailsModal,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Modal"],{isOpen:this.state.modal,toggle:this.toggleModal,modalClassName:'custom-modal-container',contentClassName:'custom-modal-content',className:this.props.className?this.props.className+' custom-modal-body':"custom-modal-body",style:this.props.style?this.props.style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{ref:'image-details',onError:function onError(){return _this2.refs['image-details'].src='https://dondemand-dev.sfo3.cdn.digitaloceanspaces.com/static/default/avatar_admin.png';},className:'custom-modal-image',src:this.props.image,alt:'chat-image',onClick:this.toggleModal}),this.props.title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-white mt-2 text-center font-2xl'},this.props.title)));}}]);return ImageDetailsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ImageDetailsModal);

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(532),
    Map = __webpack_require__(121),
    Promise = __webpack_require__(533),
    Set = __webpack_require__(534),
    WeakMap = __webpack_require__(211),
    baseGetTag = __webpack_require__(43),
    toSource = __webpack_require__(207);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(32),
    now = __webpack_require__(480),
    toNumber = __webpack_require__(481);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(525),
    stubArray = __webpack_require__(264);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 249 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(204);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)(module)))

/***/ }),
/* 251 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(268),
    createBaseEach = __webpack_require__(551);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(210);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(255),
    eq = __webpack_require__(65);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(219);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 256 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handleNewMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchChatMembers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchChat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return postMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return messageActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return findUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearChats; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handlers_Notification__ = __webpack_require__(8);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var handleNewMessages=function handleNewMessages(payload,action){return function(dispatch,getState){var _getState=getState(),session=_getState.session,chatMembers=_getState.chatMembers,chats=_getState.chats,activeInbox=_getState.activeInbox;// console.log("payload ======> ",payload);
// console.log("session ======> ",session);
// console.log("chatMembers ======> ",chatMembers);
// console.log("chats ======> ",chats);
// console.log("action ======> ",action);
var sameChatroom=chats.data.find(function(chat){return chat.room_id===payload.room_id;});var chatMemberIndex=chatMembers.data.findIndex(function(chat){return chat.room_id===payload.room_id;});if(chatMembers.data.length===0&&action==="new"){if(chats.data.length===0){localStorage.setItem("hasUnreadMessages",JSON.stringify(true));window.dispatchEvent(new CustomEvent('hasUnreadMessages',{detail:{value:true}}));}else{if(!sameChatroom){localStorage.setItem("hasUnreadMessages",JSON.stringify(true));window.dispatchEvent(new CustomEvent('hasUnreadMessages',{detail:{value:true}}));}}}else if(activeInbox){if(chatMemberIndex!==-1){var prevChatMemberData=[].concat(_toConsumableArray(chatMembers.data));var updatedChatMember=prevChatMemberData.splice(chatMemberIndex,1)[0];updatedChatMember.room.last_message=Object.assign({},payload);prevChatMemberData.unshift(updatedChatMember);dispatch({type:"FETCH_CHAT_MEMBERS",chatMembers:Object.assign({},chatMembers,{data:[].concat(_toConsumableArray(prevChatMemberData))}),activeInbox:true});}else{dispatch({type:"NEW_CHAT_MEMBER",newChatMember:true});}}if(chats.data.length>0){if(sameChatroom){var prevMessageData=[].concat(_toConsumableArray(chats.data));var messageIndex=chats.data.findIndex(function(chat){return chat.id===payload.id;});if(messageIndex!==-1){prevMessageData[messageIndex]=Object.assign({},payload);if(payload.is_read&&payload.is_mine){prevMessageData.forEach(function(chat,index){if(chat.is_mine&&!chat.is_read){prevMessageData[index].is_delivered=true;prevMessageData[index].is_read=true;}});}}else{prevMessageData=[].concat(_toConsumableArray(prevMessageData)).concat(payload);}dispatch({type:"FETCH_CHATS",chats:Object.assign({},chats,{data:[].concat(_toConsumableArray(prevMessageData))})});}}};};var fetchChatMembers=function fetchChatMembers(){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState2=getState(),company=_getState2.company;var query="with=room.lastMessage,chatTarget";var url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/chat-members?'+query+'&limit=100&sort_by=updated_at,desc';return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(url_host).then(function(res){dispatch({type:"FETCH_CHAT_MEMBERS",chatMembers:res.data,activeInbox:true});dispatch({type:"NEW_CHAT_MEMBER",newChatMember:false});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});var message=err.data.description;var type="error";if(err.data.status_code===404){return;}__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:type,title:'Error '+(err&&err.data&&err.data.error_code),msg:message});});};};var fetchChat=function fetchChat(accountId){var limit=arguments.length>1&&arguments[1]!==undefined?arguments[1]:100;return function(dispatch,getState){var _getState3=getState(),company=_getState3.company;var url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/accounts/'+accountId+'/chat-messages?sort_by=id,desc&limit='+limit;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(url_host).then(function(res){dispatch({type:'FETCH_CHATS',chats:Object.assign({},res.data,{data:[].concat(_toConsumableArray(res.data.data.sort(function(a,b){return a.id-b.id;})))})});}).catch(function(err){var message=err.data.description;var type="error";if(err.data.status_code===404){return;}__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:type,title:'Error '+(err&&err.data&&err.data.error_code),msg:message});});};};var postMessage=function postMessage(accountId,message,initialData){var type=arguments.length>3&&arguments[3]!==undefined?arguments[3]:"text";return function(dispatch,getState){var _getState4=getState(),company=_getState4.company,chats=_getState4.chats;var data=void 0;if(type==="text"){data={message:message,type:type};}else{data=new FormData();data.append("image",message);data.append("type",type);}var url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/accounts/'+accountId+'/chat-messages';return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(url_host,data).then(function(res){if(initialData){var newChatData=chats.data;var index=newChatData.findIndex(function(chat){return chat.id===initialData.id;});if(index!==-1){newChatData[index]=Object.assign({},res.data);dispatch({type:"FETCH_CHATS",chats:Object.assign({},chats,{data:newChatData})});}else{dispatch({type:'FETCH_CHATS',chats:Object.assign({},chats,{data:[].concat(_toConsumableArray(chats.data),[res.data])})});}}else{dispatch({type:'FETCH_CHATS',chats:Object.assign({},chats,{data:[].concat(_toConsumableArray(chats.data),[res.data])})});}}).catch(function(err){if(initialData){var newChatData=chats.data;var index=newChatData.findIndex(function(chat){return chat.id===initialData.id;});if(index!==-1){newChatData[index]=Object.assign({},initialData,{is_sending:false,sending_error:true});dispatch({type:"FETCH_CHATS",chats:Object.assign({},chats,{data:newChatData})});}else{dispatch({type:'FETCH_CHATS',chats:Object.assign({},chats,{data:[].concat(_toConsumableArray(chats.data),[Object.assign({},initialData,{is_sending:false,sending_error:true})])})});}}else{var _message=err.data&&err.data.description;var _type="error";if(err.data&&err.data.status_code===404){_message="Chat no encontrado.";_type="warning";}__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:_type,title:'Error '+(err&&err.data&&err.data.error_code),msg:_message});}});};};var messageActions=function messageActions(messageId,action){return function(dispatch,getState){var _getState5=getState(),company=_getState5.company,chats=_getState5.chats;var url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/chat-messages/'+messageId+'/set-'+action;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].post(url_host).then(function(){var prevMessageData=[].concat(_toConsumableArray(chats.data));var messageIndex=chats.data.findIndex(function(chat){return chat.id===messageId;});if(messageIndex!==-1){if(action==="read"){prevMessageData[messageIndex].is_read=true;prevMessageData[messageIndex].is_mine=false;}else{prevMessageData[messageIndex].is_delivered=true;}}dispatch({type:'FETCH_CHATS',chats:Object.assign({},chats,{data:[].concat(_toConsumableArray(prevMessageData))})});}).catch(function(err){var message=err.data&&err.data.description;var type="error";if(err.data&&err.data.status_code===404){message="Chat no encontrado.";type="warning";}__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:type,title:'Error '+(err&&err.data&&err.data.error_code),msg:message});});};};var findUser=function findUser(accountId){return function(dispatch,getState){dispatch({type:"WAIT_FOR_RESPONSE"});var _getState6=getState(),company=_getState6.company;var url_host=__WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* URL */]+company.id+'/accounts/'+accountId;return __WEBPACK_IMPORTED_MODULE_1__handlers_RequestHandler__["a" /* axios */].get(url_host).then(function(res){var userType=res.data.type_name;dispatch({type:'FETCH_CHAT_USER',chatUser:res.data[userType]});}).catch(function(err){dispatch({type:"REMOVE_LOADING"});var message=err.data&&err.data.description;var type="error";if(err.data&&err.data.status_code===404){message="Usuario no encontrado.";type="warning";}__WEBPACK_IMPORTED_MODULE_2__handlers_Notification__["a" /* default */].show({type:type,title:'Error '+(err&&err.data&&err.data.error_code),msg:message});});};};var clearChats=function clearChats(onlyChat){return function(dispatch){var pagination={current_page:1,data:[],per_page:100,total:1,limit:100};if(onlyChat){dispatch({type:"FETCH_CHATS",chats:Object.assign({},pagination)});dispatch({type:"FETCH_CHAT_USER",chatUser:{}});}else{dispatch({type:'CLEAR_CHATS',chatUser:{},chats:Object.assign({},pagination),chatMembers:Object.assign({},pagination),activeInbox:false});}};};

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toLowerCase */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return exist; });
/* unused harmony export keyboardHotkeys */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mergeArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeFromArray; });
/* unused harmony export userIsUnconfirmed */
/* unused harmony export userIsCreatedByAdmin */
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var toLowerCase=function toLowerCase(value){return String(value).toLowerCase();};/**
 * Recibe un objeto con objetos internos (ejemplo this.props.stats.current) como cadena separada por puntos,
 * itera sobre este objeto preguntando si cada objeto interno existe y retorna el valor si existe, sino
 * retorna null o el valor especificado en defaultReturnValue
 *
 *
 * @param  {String} prop				La cadena con el/los objetos internos a buscar
 * @param  {Object} obj					El objeto en el cual va a buscar
 * @param  {Any} defaultReturnValue 	Un valor por defecto para retornar, en caso de q necesites algo distinto a null (ejm un 0, {}, [])
 * 
 * @return {Any}						El valor contenido en el objeto en el path especificado o null si no existe
 *
 * @example
 *
 * 		// La declaracion de la funcion se puede leer asi:
 * 		// Existe 'length' en 'this'? si no existe usa el array vacio como valor por defecto
 * 		exist('this.props.property.length', this, [])
 * 
 * 
 *		exist('good.picture_urls.0', this) 				// good.picture_urls[0]
 *		exist('this.props.json_lang.component.forgeted_trans', this, []).map( ... )
 *		exist(`this.props.properties.${'algo'+2}.otro`)	// is 'this.props.properties.algo2.otro'
 *
 */var exist=function exist(prop,obj){var defaultReturnValue=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var paths=prop?prop.split('.'):[];var value=obj;var idx=0;while(idx<paths.length){if(value==null||value[paths[idx]]==null)return defaultReturnValue?defaultReturnValue:null;value=value[paths[idx]];idx+=1;}return defaultReturnValue&&!value?defaultReturnValue:value;};/**
 * Function to hanlde the shortcuts or hotkeys in the admin application
 * 
 * WARNING: CAN NOT BE AN ARROW FUNCTION, since it requires the binding to this...
 * 			maybe tweaking a little more could make it work
 */var keyboardHotkeys=function keyboardHotkeys(e){if(e.keyCode===79&&e.altKey&&e.shiftKey){// Alt + shift + o  ---> "o" de orden
this.props.history.push('/order-management/create');}};// https://stackoverflow.com/a/27664971/11119545
var mergeArrays=function mergeArrays(){var _ref;return[].concat(_toConsumableArray(new Set((_ref=[]).concat.apply(_ref,arguments))));};//  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set#Iterating_Sets
//	https://stackoverflow.com/a/44204227/11119545
var removeFromArray=function removeFromArray(originalArray,removableOrders){return[].concat(_toConsumableArray(new Set(originalArray.filter(function(o){return!removableOrders.filter(function(ro){return ro.id===o.id;}).length;}))));};var userIsUnconfirmed=function userIsUnconfirmed(status){return status>20&&status<=127;};var userIsCreatedByAdmin=function userIsCreatedByAdmin(status){return status===0;};

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 260 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(25);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(263),
    getSymbols = __webpack_require__(248),
    keys = __webpack_require__(94);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(142),
    isArray = __webpack_require__(14);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 264 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(526),
    isArguments = __webpack_require__(96),
    isArray = __webpack_require__(14),
    isBuffer = __webpack_require__(139),
    isIndex = __webpack_require__(85),
    isTypedArray = __webpack_require__(143);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(43),
    isArray = __webpack_require__(14),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(536),
    baseMatchesProperty = __webpack_require__(539),
    identity = __webpack_require__(140),
    isArray = __webpack_require__(14),
    property = __webpack_require__(546);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(269),
    keys = __webpack_require__(94);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(550);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(65),
    isArrayLike = __webpack_require__(92),
    isIndex = __webpack_require__(85),
    isObject = __webpack_require__(32);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(569);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(570),
    shortOut = __webpack_require__(572);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_actions_orderActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_bitwiseOperations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_general__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Plugins_MainModals_ModalBase__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ModalDiscount__ = __webpack_require__(283);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalOrder=function(_Component){_inherits(ModalOrder,_Component);function ModalOrder(props,context){_classCallCheck(this,ModalOrder);var _this=_possibleConstructorReturn(this,(ModalOrder.__proto__||Object.getPrototypeOf(ModalOrder)).call(this,props));_this.open_modal_discounts=function(id,modal,tax){var _this$setState;_this.setState((_this$setState={},_defineProperty(_this$setState,modal,id),_defineProperty(_this$setState,'couponDetails',tax.coupon),_this$setState));_this.modalRef.current.toggleModal();};_this.onChange=function(target){var name=target.name,value=target.value,data={'name':name,'data':value};_this.props.toggleData(data);};_this.handleShowDeliveryFees=function(){_this.setState(function(prevState){return{showDeliveryFeeDetails:!prevState.showDeliveryFeeDetails};});};_this.handleShowServiceFees=function(){_this.setState(function(prevState){return{showServiceFeeDetails:!prevState.showServiceFeeDetails};});};_this.handleShowDiscountFees=function(){_this.setState(function(prevState){return{showDiscountDetails:!prevState.showDiscountDetails};});};_this.handleShowTaxFees=function(){_this.setState(function(prevState){return{showTaxDetails:!prevState.showTaxDetails};});};_this.handleShowCashbackFees=function(){_this.setState(function(prevState){return{showCashbackDetails:!prevState.showCashbackDetails};});};_this.handleShowAdjustFees=function(){_this.setState(function(prevState){return{showAdjustDetails:!prevState.showAdjustDetails};});};_this.calculatetotalPayment=function(totalOrder,discount){var successPayment=0;if(_this.props.payment_form&&_this.props.payment_form.length>0){var allPayments=[].concat(_toConsumableArray(_this.props.payment_form));allPayments.map(function(payment,j){var ordenStatus=parseInt(payment.options,10)&__WEBPACK_IMPORTED_MODULE_5__constants_bitwiseOperations__["p" /* MASK_STATUS */];if((parseInt(payment.options,10)&__WEBPACK_IMPORTED_MODULE_5__constants_bitwiseOperations__["n" /* MASK_AGENT */])===__WEBPACK_IMPORTED_MODULE_5__constants_bitwiseOperations__["G" /* WAITING_PAYMENT */]){if(ordenStatus>=10){successPayment=successPayment+payment.total_e2;}}else{if(ordenStatus>=10){successPayment=successPayment+payment.total_e2;}}return successPayment;});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,successPayment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'text-primary mb-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Total pagado: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,_this.props.currency,' '),Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])(successPayment/100))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'mb-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Total a pagar: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,_this.props.currency,' '),Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])((totalOrder-successPayment)/100))));};_this.state={showDeliveryFeeDetails:false,showServiceFeeDetails:false,showDiscountDetails:false,showTaxDetails:false,showCashbackDetails:false,showAdjustDetails:false,couponDetails:{}};_this.modalRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(ModalOrder,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.orderID){this.props.fetchOrderDetails(this.props.orderID);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(window.location.href.indexOf("order-management")!==-1&&parseInt(window.location.href.split("/").pop(),10)){}else{this.props.resetDataDetailsOrder();}}},{key:'render',value:function render(){var _this2=this;var orderTaxes=this.props.orderDetails.taxes?this.props.orderDetails.taxes:[];var totalAmountDelivery=orderTaxes?orderTaxes.reduce(function(acc,tax){if(tax.name==='delivery_fee'){acc+=tax.value_e2;}return acc;},0):0;var totalAmountService=orderTaxes?orderTaxes.reduce(function(acc,tax){if(tax.name==='service_fee'){acc+=tax.value_e2;}return acc;},0):0;var totalAmountDiscount=orderTaxes?orderTaxes.reduce(function(acc,tax){if(tax.name==='discount'){acc+=tax.value_e2;}return acc;},0):0;var totalAmountTax=orderTaxes?orderTaxes.reduce(function(acc,tax){if(tax.name==='tax'){acc+=tax.value_e2;}return acc;},0):0;var totalAmountCashback=orderTaxes?orderTaxes.reduce(function(acc,tax){if(tax.name==='cashback'){acc+=tax.value_e2;}return acc;},0):0;var totalAmountAdjust=orderTaxes?orderTaxes.reduce(function(acc,tax){if(tax.name==='adjust'){acc+=tax.value_e2;}return acc;},0):0;var deliveryFees=orderTaxes?orderTaxes.filter(function(tax){return tax.name==='delivery_fee';}):[];var serviceFees=orderTaxes?orderTaxes.filter(function(tax){return tax.name==='service_details';}):[];var paymentFee=orderTaxes?orderTaxes.filter(function(tax){return tax.name==='payment_fee';}):[];var taxDiscount=orderTaxes?orderTaxes.filter(function(tax){return tax.name==='discount';}):[];var taxTax=orderTaxes?orderTaxes.filter(function(tax){return tax.name==='tax';}):[];var taxCashback=orderTaxes?orderTaxes.filter(function(tax){return tax.name==='cashback';}):[];var taxAdjust=orderTaxes?orderTaxes.filter(function(tax){return tax.name==='adjust';}):[];var discount=0;discount=this.props.orderDetails&&this.props.orderDetails.taxes&&this.props.orderDetails.taxes.length>0&&this.props.orderDetails.taxes.filter(function(tax,key){return tax.desc&&tax.coupon&&(tax.coupon.applies_to==='subtotal'||tax.coupon.applies_to==='base_price')&&tax.value_e2;});//let status;
var order_distance=void 0;if(this.props.orderDetails&&this.props.orderDetails.status){var OrderIsPickUp=Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["p" /* isPickUp */])(this.props.orderDetails.client_latitude_e6,this.props.orderDetails.client_longitude_e6,this.props.orderDetails.client_address);//? no se usa: status = orderStatus(this.props.orderDetails.status,!OrderIsPickUp)
order_distance=this.props.orderDetails.order_providers.map(function(order_provider,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-motorcycle'}),' Distancia recorrida por el rider: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])(order_provider.tracking_statistics.branch_order_distance/1000,0)+' Km'));});}var asigned_provider=[];if(this.props.orderDetails.providers&&this.props.orderDetails.providers&&this.props.orderDetails.providers.length>0){asigned_provider=this.props.orderDetails.providers.filter(function(provider){return provider.pivot.unassigned_at===null;});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Plugins_MainModals_ModalBase__["a" /* default */],{ref:this.modalRef,title:'Detalles del cup\xF3n',html:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ModalDiscount__["a" /* default */],{coupon:this.state.couponDetails,dontClearData:true,clear:true,currency:this.props.currency,reference:function reference(){return _this2.open_modal_discounts(0,'modalDiscount',_this2.state.couponDetails);}})}),this.props.orderDetails&&this.props.orderDetails.status?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list-group'},this.props.orderDetails.scheduled_at?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item'},this.props.json_lang.modal_order.scheduled_at,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right'},' ',Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["M" /* utcDateFormat */])(this.props.orderDetails.scheduled_at,'DD-MM-YYYY h:mm a'))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item'},this.props.json_lang.common.client,' ',this.props.orderDetails.client.uuid&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'#',this.props.orderDetails.client.uuid),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'py-3 mr-3 float-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{ref:'client',onError:function onError(){return _this2.refs['client'].src='https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar-comprador.png';},className:'avatar_small',src:this.props.orderDetails.client&&this.props.orderDetails.client.avatar_url?this.props.orderDetails.client.avatar_url:'https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar-comprador.png',alt:this.props.orderDetails.client&&this.props.orderDetails.client.email?this.props.orderDetails.client.email:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'avatar-status badge-success'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.props.orderDetails.client&&this.props.orderDetails.client.name?this.props.orderDetails.client.name+'\n\n\t                            \t\t':null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'CI:'),' ',this.props.orderDetails.client.dni?this.props.orderDetails.client.dni:'No registrado',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'@'),' ',this.props.orderDetails.client&&this.props.orderDetails.client.email?this.props.orderDetails.client.email:'--',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.props.isZupperAdmind===true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-phone'}),' ',this.props.orderDetails.client&&this.props.orderDetails.client.phone?this.props.orderDetails.client.phone:'--',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)):null,this.props.orderDetails.client_address?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-location-pin'}),this.props.orderDetails.client_address,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.props.orderDetails.is_gift===true&&(this.props.orderDetails.status&__WEBPACK_IMPORTED_MODULE_5__constants_bitwiseOperations__["m" /* IS_DIGITAL */])===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'text-muted mt-2 w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Enviado como regalo a: '),this.props.orderDetails.receiver_name,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.props.orderDetails.receiver_phone&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-phone'}),' \xA0',this.props.orderDetails.receiver_phone)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{size:'sm',tag:'a',target:'_blank',className:'pull-right',color:'info',href:'https://www.google.com/maps/search/?api=1&query='+this.props.orderDetails.client_latitude_e6/__WEBPACK_IMPORTED_MODULE_7__constants_general__["q" /* GEO_DECIMAL_PLACES */]+','+this.props.orderDetails.client_longitude_e6/__WEBPACK_IMPORTED_MODULE_7__constants_general__["q" /* GEO_DECIMAL_PLACES */]},'Ver en mapa'))),asigned_provider&&asigned_provider.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item'},this.props.json_lang.common.provider,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'py-3 mr-3 float-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{ref:'provider',onError:function onError(){return _this2.refs['provider'].src=' https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar_rider-48x48.jpg';},className:'avatar_small',src:asigned_provider[0].avatar_url?asigned_provider[0].avatar_url:' https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar_rider-48x48.jpg',alt:asigned_provider[0].email?asigned_provider[0].email:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'avatar-status badge-success'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,asigned_provider[0].name,' '),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'text-muted'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'@'),' ',asigned_provider[0].email?asigned_provider[0].email:'--',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-phone'}),' ',asigned_provider[0].phone?asigned_provider[0].phone:'--',order_distance)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item'},this.props.json_lang.common.goods,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Row"],{className:'mr-0 ml-0 pt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Col"],{className:'text-center',style:{maxWidth:120}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.json_lang.create_order.quantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Col"],{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.json_lang.common.good)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Col"],{className:'text-center',style:{maxWidth:120}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.json_lang.common.price))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{style:{maxHeight:'200px',overflowY:'auto'}},this.props.orderDetails.ordered_goods?this.props.orderDetails.ordered_goods.map(function(good,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:key,className:'pl-3 pr-3 custom_detail_orden '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line_item_detail_orden text-center',style:{width:90}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'mb-0'},good.quantity,'x')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line_item_detail_orden',style:{width:'calc(100% - 90px)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',width:'100%',justifyContent:'space-between'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{style:{display:'inline-block',maxWidth:'83%'}},good.name,' (',good.sku||"N/A",')',good.name.toLowerCase().includes('combo')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'text-muted',style:{display:'block'}},good.details):null,good.notes?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'highlighted-notes'},good.notes):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,_this2.props.currency,' '),Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])(good.total_price_e2/100/good.quantity))),good.properties&&good.properties.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,good.properties.map(function(property,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',width:'100%',justifyContent:'space-between'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-muted'},'- ',property.name,': ',property.value),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,_this2.props.currency,' '),Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])(property.price_e2/100))),property.notes?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,property.notes):null);})):null));}):null)),this.props.orderDetails.notes?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item'},this.props.json_lang.modal_order.notes,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.props.orderDetails.notes):null,this.props.admin_type_id===2||this.props.userHigherAccess===__WEBPACK_IMPORTED_MODULE_7__constants_general__["h" /* COMPANY_ACCESS */]||discount.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item'},this.props.json_lang.common.subtotal,' :',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.currency),' ',Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])(this.props.orderDetails.subtotal_e2/100),' ')):null,(this.props.admin_type_id===2||this.props.userHigherAccess===__WEBPACK_IMPORTED_MODULE_7__constants_general__["h" /* COMPANY_ACCESS */])&&this.props.orderDetails.taxes?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,deliveryFees.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item',type:'button',onClick:this.handleShowDeliveryFees},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:this.state.showDeliveryFeeDetails?'icon-minus mr-2':'icon-plus mr-2',style:{color:'green'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.json_lang.payments.delivery_fee,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right'},Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])(totalAmountDelivery/100))),deliveryFees.map(function(tax,key){if(_this2.state.showDeliveryFeeDetails){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item',key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'ml-5'},tax.desc?tax.desc:_this2.props.json_lang.payments.delivery_details_fee),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right'},Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])(tax.value_e2/100)));}})):null,serviceFees.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item',type:'button',onClick:this.handleShowServiceFees},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:this.state.showServiceFeeDetails?'icon-minus mr-2':'icon-plus mr-2',style:{color:'green'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.json_lang.payments.service_fee,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right'},Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])(totalAmountService/100))),serviceFees.map(function(tax,key){if(_this2.state.showServiceFeeDetails){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item',key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'ml-5'},tax.desc?tax.desc:_this2.props.json_lang.payments.service_fee),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right'},Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])(tax.value_e2/100)));}})):null,paymentFee.length>0?paymentFee.map(function(tax,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item',key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{className:' ml-5'},tax.desc?tax.desc:_this2.props.json_lang.payments.payment_fee),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right'},Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])(tax.value_e2/100)));}):null,taxDiscount.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item',type:'button',onClick:this.handleShowDiscountFees},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:this.state.showDiscountDetails?'icon-minus mr-2':'icon-plus mr-2',style:{color:'green'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.json_lang.payments.discount,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right'},Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])(totalAmountDiscount/100))),taxDiscount.map(function(tax,key){if(_this2.state.showDiscountDetails){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item',key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'ml-5 text-info',style:{cursor:"pointer"},onClick:function onClick(e){e.stopPropagation();e.preventDefault();_this2.open_modal_discounts(0,'modalDiscount',tax);}},tax.desc?tax.desc:_this2.props.json_lang.payments.discount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right'},Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])(tax.value_e2/100)));}})):null,taxCashback.length>0&&totalAmountCashback!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item',type:'button',onClick:this.handleShowCashbackFees},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:this.state.showCashbackDetails?'icon-minus mr-2':'icon-plus mr-2',style:{color:'green'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',{className:'text-danger'},'Cashback:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right text-danger'},Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])(totalAmountCashback/100))),taxCashback.map(function(tax,key){if(_this2.state.showCashbackDetails){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item',key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'ml-5 text-info',style:{cursor:"pointer"},onClick:function onClick(e){e.stopPropagation();e.preventDefault();_this2.open_modal_discounts(0,'modalDiscount',tax);}},tax.desc?tax.desc:'Cashback'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right'},Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])(tax.value_e2/100)));}})):null,taxTax.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item',type:'button',onClick:this.handleShowTaxFees},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:this.state.showTaxDetails?'icon-minus mr-2':'icon-plus mr-2',style:{color:'green'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.json_lang.payments.taxes,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right'},Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])(totalAmountTax/100))),taxTax.map(function(tax,key){if(_this2.state.showTaxDetails){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item',key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'ml-5'},tax.desc?tax.desc:_this2.props.json_lang.payments.taxes),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right'},Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])(tax.value_e2/100)));}})):null,taxAdjust.length>0&&totalAmountAdjust!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item',type:'button',onClick:this.handleShowAdjustFees},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:this.state.showAdjustDetails?'icon-minus mr-2':'icon-plus mr-2',style:{color:'green'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.json_lang.payments.adjust,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right'},Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])(totalAmountAdjust/100))),taxAdjust.map(function(tax,key){if(_this2.state.showAdjustDetails){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item',key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'ml-5'},tax.desc?tax.desc:_this2.props.json_lang.payments.adjust),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right'},Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])(tax.value_e2/100)));}})):null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,this.props.orderDetails.taxes.map(function(tax,key){return tax.desc&&tax.coupon&&(tax.coupon.applies_to==='subtotal'||tax.coupon.applies_to==='base_price')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:key,className:'justify-content-between list-group-item'},_this2.props.json_lang.payments[tax.name],':',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,_this2.props.currency),' ',Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_UtilsOperation__["v" /* number_format */])(tax.value_e2/100)),tax.desc&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'w-100'},tax.desc));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'justify-content-between list-group-item'},this.calculatetotalPayment(this.props.orderDetails.total_e2,discount&&discount[0]?discount[0].value_e2:0)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'text-center list-group-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["b" /* Link */],{color:'info w-100',to:'/order-management/'+this.props.orderDetails.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.json_lang.common.more)))):null);}}]);return ModalOrder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var oDetailsTaxes=state.orderDetails.taxes.filter(function(tax,key){return tax.name!=='payment_fee';});state.orderDetails.taxes=oDetailsTaxes;var isZupperAdmind=false;if(state.session&&state.session.accesses.length>0){isZupperAdmind=state.session&&state.session.accesses.some(function($0){return $0.access_type==='company';});}return{errors:state.errors,orderDetails:state.orderDetails,json_lang:state.json_lang,isZupperAdmind:isZupperAdmind,currency:state.currencies.local.symbol,userHigherAccess:state.userHigherAccess,admin_type:state.session&&state.session.admin_type&&state.session.admin_type,session:state.session};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchOrderDetails:function fetchOrderDetails(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__store_actions_orderActions__["S" /* fetchOrderDetails */])(id));},resetDataDetailsOrder:function resetDataDetailsOrder(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__store_actions_orderActions__["_30" /* resetDataDetailsOrder */])());}//orderStatus: (status) => dispatch(orderStatus(status)),
};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalOrder));

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_rating__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_typeahead__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actions_orderActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_actions_providerActions__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_actions_branches_branchActions__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_actions_UtilsOperation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_general__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_bitwiseOperations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Spinner__ = __webpack_require__(62);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalAssignProvider=function(_Component){_inherits(ModalAssignProvider,_Component);function ModalAssignProvider(props){_classCallCheck(this,ModalAssignProvider);// this.state = ({
//     selected: 0,
//     userBranches: [...this.props.session.accesses].filter(e => e.access_type === "branch" && e.id !== String(this.props.branch.id))
// })
var _this=_possibleConstructorReturn(this,(ModalAssignProvider.__proto__||Object.getPrototypeOf(ModalAssignProvider)).call(this,props));_this.close=function(){if(_this.props.refresh){_this.props.refresh();}if(_this.props.reference){_this.props.reference();}_this._typeahead.getInstance().clear();};_this.assignAndClose=function(){if(_this.props.isMapViewModal){_this.props.updateMapProvider(_this.props.selectedOrder,_this.state.selected).then(function(res){_this.close();}).catch(function(err){console.log("error al acualizar form ",err);});}else{if(_this.props.order.status_data.is_shopper_allowed&&!_this.props.order.status_data.shopper_assigned){_this.props.updateShopper(_this.props.orderID,_this.state.selected,'put').then(function(){_this.props.fetchOrderBids(_this.props.orderID).then(function(){if(_this.props.bids&&_this.props.bids.length===0){_this.close();}});}).catch(function(err){console.log("error al acualizar form ",err);});}else{_this.props.updateProvider(_this.props.orderID,_this.state.selected).then(function(){_this.props.fetchOrderBids(_this.props.orderID).then(function(){if(_this.props.bids&&_this.props.bids.length===0){_this.close();}});}).catch(function(err){console.log("error al acualizar form ",err);});}}};_this.assignShopperAndClose=function(){if(_this.props.isMapViewModal){_this.props.updateMapProvider(_this.props.selectedOrder,_this.state.selected).then(function(res){_this.close();}).catch(function(err){console.log("error al acualizar form ",err);});}else{_this.props.updateShopper(_this.props.orderID,_this.state.selected,'put').then(function(res){_this.close();}).catch(function(err){console.log("error al acualizar form ",err);});}};_this.confirmAndClose=function(id){_this.props.confirmOrderBid(id).then(function(){if(!_this.props.errorBids){_this.close();}});};_this.changePoolAndClose=function(pool,id){_this.props[pool](id).then(function(res){_this.close();}).catch(function(err){console.log("error al acualizar form ",err);});};_this.onChange=function(target){var name=target.name,value=target.value,data={'name':name,'data':value};_this.setState({selected:data.data});};_this.handleFleetChange=function(_ref){var value=_ref.value;_this.setState({loadingProviders:true});if(value==="all"){_this.setState({fleetName:"Asignación manual"});if(_this.props.order.status_data.is_shopper_allowed&&!_this.props.order.status_data.shopper_assigned){_this.props.fetchProviders('is_shopper=1').then(function(){var providers=_this.props.providers;_this.setState({providers:providers.data||providers||[],loadingProviders:false});});}else{_this.props.fetchProviders('is_deliverer=1').then(function(){var providers=_this.props.providers;_this.setState({providers:providers.data||providers||[],loadingProviders:false});});}}else{_this.props.setOrderFleet(_this.props.orderID,value).then(function(){var fleet=_this.props.orderFleets.find(function(fleet){return fleet.id===Number(value);});_this.setState({fleetName:fleet.description||"Asignación manual"});if(_this.props.order.status_data.is_shopper_allowed&&!_this.props.order.status_data.shopper_assigned){_this.props.fetchProviders('order_id='+_this.props.orderID).then(function(){var providers=_this.props.providers;_this.setState({providers:providers.data||providers||[],loadingProviders:false});});}else{_this.props.fetchProviders('order_id='+_this.props.orderID).then(function(){var providers=_this.props.providers;_this.setState({providers:providers.data||providers||[],loadingProviders:false});});}});}};_this.state={loading:true,userBranches:[],selected:0,providers:[],loadingProviders:true,isShopperType:false,toggleFleetEdit:false,fleetName:""};if(_this.props.orderID){_this.loadOrderData();}return _this;}_createClass(ModalAssignProvider,[{key:'loadOrderData',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this2=this;var orderID,query,_query;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;orderID=this.props.orderID;_context.next=4;return this.props.find(orderID).then(function(){if(_this2.props.order&&_this2.props.order.service_charge){_this2.setState({fleetName:_this2.props.order.service_charge.description});}_this2.props.getOrderFleets(orderID);});case 4:_context.next=6;return this.props.fetchCompanyBranches(100).then(function(){return _this2.listOfUserBranches();});case 6:if(!(this.props.order.status_data.is_shopper_allowed&&!this.props.order.status_data.shopper_assigned)){_context.next=12;break;}query='is_shopper=1';_context.next=10;return this.props.fetchProviders(''+query).then(function(){var providers=_this2.props.providers;_this2.setState({providers:providers.data||providers||[],loadingProviders:false,isShopperType:true});});case 10:_context.next=16;break;case 12:_query='is_deliverer=1';if(this.props.orderFleets&&this.props.orderFleets.length>0){_query='order_id='+orderID;}_context.next=16;return this.props.fetchProviders(''+_query).then(function(){var providers=_this2.props.providers;_this2.setState({providers:providers.data||providers||[],loadingProviders:false,isShopperType:false});});case 16:this.props.fetchOrderBids(orderID);this.setState({loading:false});_context.next=23;break;case 20:_context.prev=20;_context.t0=_context['catch'](0);console.error("Error al cargar datos del orden: ",_context.t0);case 23:case'end':return _context.stop();}}},_callee,this,[[0,20]]);}));function loadOrderData(){return _ref2.apply(this,arguments);}return loadOrderData;}()},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var order=this.props.order;var isShopperType=this.state.isShopperType;if(prevProps.order!==order){if(order&&order.id){if(isShopperType){if(order.is_shopper_assigned||order.is_status_completed){if(this.props.reference){this.props.reference();}}}else{if(order.is_provider_assigned||order.is_status_completed){if(this.props.reference){this.props.reference();}}}}}}},{key:'listOfUserBranches',value:function listOfUserBranches(){var _this3=this;var newList=[];var _props=this.props,branches=_props.branches,userHigherAccess=_props.userHigherAccess,session=_props.session;if(userHigherAccess===__WEBPACK_IMPORTED_MODULE_10__constants_general__["h" /* COMPANY_ACCESS */]||session.account.type===__WEBPACK_IMPORTED_MODULE_11__constants_bitwiseOperations__["d" /* ADMIN_OWNER */]){newList=[].concat(_toConsumableArray(branches)).map(function(b){return{access_id:b.id,related_access:Object.assign({},b)};}).filter(function(b){return b.access_type!=='company';});}else{newList=[].concat(_toConsumableArray(branches)).map(function(b){var finded=_this3.state.userBranches.findIndex(function(ub){return ub.access_type==="branch"&&ub.access_id===b.id;});return finded!==-1?{access_id:b.id,related_access:Object.assign({},b)}:null;}).filter(function(b){return b;});// devuelve los que no son nulos
}this.setState({//loading: false,
userBranches:newList});}},{key:'componentWillUnmount',value:function componentWillUnmount(){//? vaciar los repartidores afectaba a los marcadores del mapa: this.props.clearProviders()
this.props.clearBids();this.setState({selected:0});}},{key:'render',value:function render(){var _this4=this;var _props2=this.props,company=_props2.company,json_lang=_props2.json_lang,admin_type=_props2.admin_type,branch=_props2.branch,order=_props2.order,orderFleets=_props2.orderFleets,companyColor=_props2.companyColor;var _state=this.state,providers=_state.providers,loadingProviders=_state.loadingProviders,toggleFleetEdit=_state.toggleFleetEdit,fleetName=_state.fleetName;var selected=this.state.selected;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,toggleFleetEdit?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'d-flex align-items-start'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-arrow-left text-primary font-2xl pointer mt-1',disabled:loadingProviders,onClick:function onClick(){return _this4.setState({toggleFleetEdit:false});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'d-flex flex-column w-100'},orderFleets&&orderFleets.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Row"],{className:' d-flex flex-column justify-content-center m-2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Label"],{'for':'fleets'},'Flotas'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Input"],{onChange:function onChange(e){return _this4.handleFleetChange(e.target);},id:'fleets',name:'fleets',type:'select',defaultValue:fleetName==="Asignación manual"?"all":order.service_charge.id},orderFleets.map(function(fleet){var label='Flota';if(fleet&&fleet.description){label=fleet.description;}else if(fleet&&fleet.service_supplier&&fleet.service_supplier.internal_name){label=fleet.service_supplier.internal_name;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:fleet.id,value:fleet.id},label);}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'text-muted'},'No existen flotas asignadas a este comercio'),providers.length>0&&!loadingProviders?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'text-muted'},'Se ',providers.length===1?'encontró':'encontraron',' ',providers.length,' ',providers.length===1?'repartidor':'repartidores'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'text-muted'},loadingProviders?"Cargando...":"No se encontraron repartidores con los parámetros actuales"))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Row"],{className:'justify-content-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Col"],null,this.props.bids&&this.props.bids.length>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',null,this.props.json_lang.order_details.waiting_confirmation_msg),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{style:{maxHeight:'200px',width:'100%',overflow:'auto'}},this.props.bids.map(function(bid,key){var BID_AVAILABLE=(bid.status&2)!==0;var MASK_NEEDS_CONFIRMATION=(bid.status&1092)!==0;var BID_ADMIN_CONFIRMS=(bid.status&4)!==0;var BID_PROVIDER_CONFIRMS=(bid.status&64)!==0;var BID_CLIENT_CONFIRMS=(bid.status&1024)!==0;var BID_REFUSED=(bid.status&1)!==0;var btn=void 0;if(BID_AVAILABLE&&MASK_NEEDS_CONFIRMATION){if(BID_PROVIDER_CONFIRMS){btn=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Button"],{color:'ghost-danger',className:'btn-sm float-right',title:'Cancelar posibilidad del proveedor de tomar esta orden',onClick:function onClick(){return _this4.props.cancelOrderBid(bid.id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-close'})));}else if(BID_ADMIN_CONFIRMS){btn=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Button"],{color:'ghost-success',className:'btn-sm float-right',title:'Asignarle la orden',onClick:function onClick(){return _this4.confirmAndClose(bid.id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-check'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Button"],{color:'ghost-danger',className:'btn-sm float-right',title:'Cancelar posibilidad del proveedor de tomar esta orden',onClick:function onClick(){return _this4.props.cancelOrderBid(bid.id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-close'})));}else if(BID_CLIENT_CONFIRMS){btn=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{color:'ghost-danger',className:'btn-sm float-right'},_this4.props.json_lang.order_details.bid_waiting_client_confirm_msg);}}if(BID_REFUSED){btn=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{color:'ghost-danger',className:'btn-sm float-right'},_this4.props.json_lang.order_details.bid_rejected_msg);}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:key,className:'custom_detail_orden'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',{className:'text-info',style:{display:'inline-block',width:'calc(100% - 180px)'}},'Asignado el ',Object(__WEBPACK_IMPORTED_MODULE_9__store_actions_UtilsOperation__["M" /* utcDateFormat */])(bid.created_at,'fromNow')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Button"],{color:'ghost-success',className:'btn-sm float-right',title:_this4.props.json_lang.order_details.bid_force_asignation_msg,onClick:function onClick(){return _this4.confirmAndClose(bid.id);}//confirmOrderBid
},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'icon-check'})),btn,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'py-3 mr-2 ml-2 float-left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{id:'provider-avatar-'+bid.provider.id,className:'avatar_small',src:bid.provider.avatar_url?Object(__WEBPACK_IMPORTED_MODULE_9__store_actions_UtilsOperation__["f" /* dimenImg */])(bid.provider.avatar_url,'36x36','jpg'):'https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar_rider-48x48.jpg',onError:function onError(){return document.getElementById('provider-avatar-'+bid.provider.id).src='https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar_rider-48x48.jpg';},alt:bid.provider.id})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,bid.provider.name,' '),'(',parseInt(bid.provider.status&18,10)!==0?_this4.props.json_lang.order_details.provider_busy_label:_this4.props.json_lang.order_details.provider_available_label,')'),bid.provider.email!=null?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('small',{className:'text-muted'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,_this4.props.json_lang.common.email,': '),bid.provider.email,' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)):'-',bid.provider.phone!=null?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('small',{className:'text-muted'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,_this4.props.json_lang.common.phone,': '),bid.provider.phone,' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)):'-',bid.provider_e2>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('small',{className:'text-muted',style:{display:'inline-block'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,_this4.props.json_lang.common.rating,': '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_rating___default.a,{emptySymbol:'fa fa-star-o',fullSymbol:'fa fa-star',initialRating:bid.provider_e2/100,readonly:true})):null);}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h6',{className:'text-muted'},providers.length>0&&(order.status_data&&order.status_data.is_shopper_allowed&&!order.status_data.shopper_assigned?this.props.json_lang.map_view.unassigned_shopper_msg:this.props.json_lang.map_view.unavaliable_shopper_messg)||this.props.json_lang.map_view.unassigned_provider_msg||this.props.json_lang.map_view.unavaliable_provider_msg,/*branch && branch.name?
                                            <span className="text-primary" style={{cursor: 'pointer'}}
                                                onClick={()=>this.changePoolAndClose( (order.status_data && order.status_data.pool_is_private ? 'setOrderPublicPool':'setOrderPrivatePool'),this.props.orderID)}>
                                                {` Enviar al pool de ${order.status_data && order.status_data.pool_is_private ? branch.name : company.name}`}
                                            </span>
                                        :setOrderPublicPool setOrderPrivatePool &&*/order&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'text-primary',style:{cursor:'pointer'},onClick:function onClick(){return _this4.changePoolAndClose(order&&order.status_data&&order.status_data.pool_is_private===true?'setOrderPublicPool':'setOrderPrivatePool',_this4.props.orderID);}},' Enviar al pool de '+(order&&order.status_data&&order.status_data.pool_is_private?company.name:branch.name?branch.name:'comercio'))))),this.state.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Row"],{className:'justify-content-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Spinner__["a" /* default */],{size:'34px',color:companyColor})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,this.props.order.status_data.is_shopper_allowed&&!this.props.order.status_data.shopper_assigned?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:'text-center font-weight-bold mt-2'},fleetName))),providers.length>0&&!loadingProviders?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Row"],{className:'justify-content-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["InputGroup"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_typeahead__["Typeahead"],{className:'iniline-select',labelKey:'name',multiple:false,ref:function ref(_ref3){return _this4._typeahead=_ref3;},emptyLabel:this.props.json_lang.common.no_results_msg,options:providers,onChange:function onChange(selected){return _this4.setState({selected:selected[0]&&selected[0].id?selected[0].id:0});},placeholder:this.props.order.status_data.is_shopper_allowed&&!this.props.order.status_data.shopper_assigned?this.props.json_lang.modal_assign_order.shopper_searchbox_placeholder:this.props.json_lang.modal_assign_order.provider_searchbox_placeholder,filterBy:['email','name','display_name','phone'],renderMenuItemChildren:function renderMenuItemChildren(option,props,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],{key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'mr-3 float-left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'avatar_small',src:option.avatar_url?Object(__WEBPACK_IMPORTED_MODULE_9__store_actions_UtilsOperation__["f" /* dimenImg */])(option.avatar_url,'36x36','jpg'):'https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar_rider-48x48.jpg',id:'avatar_small-'+option.id,onError:function onError(){return document.getElementById('avatar_small-'+option.id).src='https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar_rider-48x48.jpg';},alt:option.name?option.name:''})),option.distance_in_meters&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'float-right'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('small',{className:'badge badge-primary'},(option.distance_in_meters/1000).toFixed(1),' km')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'name'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b',null,option.name?option.name:'',option.is_busy?' ('+_this4.props.json_lang.order_details.provider_busy_label+')':""),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('small',{className:'text-muted',key:'email',style:{display:'block'}},option.email?option.email:''),option.orders_count?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'d-flex flex-row justify-content-start mt-1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'badge badge-primary position-relative',style:{position:'relative',right:'0',marginTop:'0'}},option.orders_count,' ',option.orders_count===1?_this4.props.json_lang.common.order.toLowerCase():_this4.props.json_lang.common.orders.toLowerCase())):null),option.accesses&&option.accesses.length>0?option.accesses.map(function(access,key){var bAcces=_this4.state.userBranches.find(function(b,i){return b.access_id===access.access_id;});var relatedAccessName=json_lang.common.branch+' : '+(bAcces&&bAcces.related_access&&bAcces.related_access.name);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:key},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'confirmed mt-1'},admin_type===2&&bAcces?relatedAccessName:access.access_type==='App\\Company'?company.name:relatedAccessName));}):null);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["InputGroupAddon"],{addonType:'append'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Button"],{color:'primary iniline-select-btn',style:this.props.bg_company?this.props.bg_company:undefined,title:this.props.json_lang.common.add,onClick:function onClick(){return _this4.assignAndClose();},disabled:selected===0},this.props.json_lang.common.add)))))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'d-flex justify-content-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'text-danger'},'No se encontraron providers con los par\xE1metros actuales')),this.props.order.status_data.is_shopper_allowed&&!this.props.order.status_data.shopper_assigned?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-center mt-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Button"],{onClick:function onClick(){return _this4.setState({toggleFleetEdit:true});},color:'primary'},'Cambiar flota')))));}}]);return ModalAssignProvider;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var allProviders=state.providers;var admin_type_ID=state.session&&state.session.admin_type&&state.session.admin_type.id?state.session.admin_type.id:"";//let alertt;
var asignables=[];if(allProviders&&allProviders.data&&allProviders.data.length){asignables=allProviders&&allProviders.data.filter(function(asignable,key){var found=void 0;var isAsignable=asignable;if(state.bids){found=state.bids.find(function(bidsProvider){return bidsProvider.provider_id===asignable.id;});//console.log('asignable0',asignable,state.bids)
if(found){isAsignable=asignable.id!==found.provider_id;}}return isAsignable;}).filter(function(asignable,key){return asignable&&asignable.accesses&&asignable.accesses.length>0;}).filter(function(asignable,key){return(parseInt(asignable&&asignable.account&&asignable.account.status,10)&255)===240;}).filter(function(asignable,key){return Object(__WEBPACK_IMPORTED_MODULE_9__store_actions_UtilsOperation__["D" /* providerOnline */])(asignable&&asignable.status);});}var filteredproviders=asignables.filter(function(asignable,key){return asignable.accesses.some(function(access){if(state.order&&state.order.status_data&&state.order.status_data.pool_is_private===false&&state.userHigherAccess===__WEBPACK_IMPORTED_MODULE_10__constants_general__["h" /* COMPANY_ACCESS */]){return access.access_type==='App\\Company';}else{return access.access_type!=='App\\Company';}});});if(state.hasFleets){filteredproviders=allProviders;}return{errors:state.errors,json_lang:state.json_lang,providers:filteredproviders,bids:state.bids,clearBids:state.clearBids,order:state.order,session:state.session,branches:state.branches,branch:state.branch,admin_type:admin_type_ID,company:state.company,userHigherAccess:state.userHigherAccess,orderFleets:state.orderFleets,errorBids:state.errorBids,companyColor:state.company.styles_json.styles.color_primary};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{updateProvider:function updateProvider(order,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_orderActions__["_46" /* updateProvider */])(order,id));},updateMapProvider:function updateMapProvider(order,id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_orderActions__["_43" /* updateMapProvider */])(order,id));},updateShopper:function updateShopper(order,id,action){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_orderActions__["_47" /* updateShopper */])(order,id,action));},fetchOrderBids:function fetchOrderBids(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_orderActions__["Q" /* fetchOrderBids */])(id));},fetchProviders:function fetchProviders(query){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__store_actions_providerActions__["o" /* fetchProviders */])(1,query));},fetchCompanyBranches:function fetchCompanyBranches(limit){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__store_actions_branches_branchActions__["H" /* fetchCompanyBranches */])(limit));},confirmOrderBid:function confirmOrderBid(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_orderActions__["F" /* confirmOrderBid */])(id));},setOrderPublicPool:function setOrderPublicPool(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_orderActions__["_35" /* setOrderPublicPool */])(id));},setOrderPrivatePool:function setOrderPrivatePool(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_orderActions__["_34" /* setOrderPrivatePool */])(id));},cancelOrderBid:function cancelOrderBid(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_orderActions__["j" /* cancelOrderBid */])(id));},clearProviders:function clearProviders(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__store_actions_providerActions__["f" /* clearProviders */])(id));},clearBids:function clearBids(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_orderActions__["n" /* clearBids */])(id));},findOrderWithAvaliableProviders:function findOrderWithAvaliableProviders(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_orderActions__["_12" /* findOrderWithAvaliableProviders */])());},find:function find(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_orderActions__["_11" /* find */])(id));},getOrderFleets:function getOrderFleets(orderId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_orderActions__["_17" /* getOrderFleets */])(orderId));},setOrderFleet:function setOrderFleet(orderId,serviceChargeId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_orderActions__["_32" /* setOrderFleet */])(orderId,serviceChargeId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalAssignProvider));

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__ = __webpack_require__(23);
/* harmony default export */ __webpack_exports__["a"] = ({items:[{lang_key:"dashboard",name:"Resumen",url:"/dashboard",icon:"icon-speedometer",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["b" /* ADMIN_HIGH */]},{lang_key:"map",name:"Mapa",icon:"icon-map",url:"/map",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["c" /* ADMIN_LOW */]},{lang_key:"orders",icon:"icon-bag",name:"Órdenes",url:"/order-management",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["c" /* ADMIN_LOW */]},{lang_key:"create-order",icon:"icon-basket-loaded",name:"Crear orden",url:"/create-order",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["d" /* ADMIN_OWNER */]},{lang_key:"clients",name:"Usuarios (Clientes)",icon:"icon-people",url:"/clients-management",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["b" /* ADMIN_HIGH */]},{lang_key:"",name:"Aliados",icon:"icon-layers icons",children:[{lang_key:"branchs-groups",name:"Grupos de comercios",url:"/branchs",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["b" /* ADMIN_HIGH */]},{lang_key:"branches",name:"Comercios",url:"/branchs-list",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["b" /* ADMIN_HIGH */]},{lang_key:"branchs-categories",name:"Categorías de comercio",url:"/branch-category-company",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["b" /* ADMIN_HIGH */]}]},{lang_key:"inventory",name:"Inventario",icon:"icon-book-open",children:[{lang_key:"goods",name:"Productos",url:"/goods-management",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["b" /* ADMIN_HIGH */]},{lang_key:"categories",name:"Categorías",url:"/categories-management",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["b" /* ADMIN_HIGH */]},{lang_key:"attributes",name:"Variantes",url:"/properties-management",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["b" /* ADMIN_HIGH */]},{lang_key:"goods-types",name:"Tipos de productos",url:"/good-type-management",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["b" /* ADMIN_HIGH */]},{lang_key:"eta",name:"Eta",url:"/eta",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["b" /* ADMIN_HIGH */]}]},{lang_key:"",name:"Roles",icon:"icon-people",children:[{lang_key:"admins",name:"Administradores",url:"/admins-management",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["b" /* ADMIN_HIGH */]},{lang_key:"providers",name:"Repartidores",url:"/provider-management",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["b" /* ADMIN_HIGH */]},{lang_key:"admin_types",name:"Tipos de administrador",url:"/admin-types-management",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["d" /* ADMIN_OWNER */]}]},{lang_key:"",name:"Marketing",icon:"icon-magic-wand",children:[{lang_key:"banners",name:"Banners",url:"/banners",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["c" /* ADMIN_LOW */]},{ang_key:"notifications",name:"Notificaciones masivas",url:"/list-send-notifications",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["c" /* ADMIN_LOW */]},{lang_key:"coupons",name:"Cupones",url:"/coupons",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["c" /* ADMIN_LOW */]},{lang_key:"promo",name:"Promociones",url:"/promos",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["c" /* ADMIN_LOW */]},{lang_key:"section",name:"Secciones",url:"/sections",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["c" /* ADMIN_LOW */]},{lang_key:"featured-products",name:"Productos destacados",url:"/featured-products",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["c" /* ADMIN_LOW */]}]},{lang_key:"reports",name:"Reportes",url:"/reports",icon:"icon-docs",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["c" /* ADMIN_LOW */]},{lang_key:"",name:"Finanzas",icon:"icon-wallet",children:[{lang_key:"billing",name:"Balance",url:"/company-billings",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["b" /* ADMIN_HIGH */]},{lang_key:"billing",name:"Mis cobros",url:"/company-charges",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["b" /* ADMIN_HIGH */]},{lang_key:"branch-invoices",name:"Facturas de comercio",url:"/branch-invoices",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["c" /* ADMIN_LOW */]}]},{lang_key:"",name:"Flotas",icon:"fa fa-car",children:[{lang_key:"fleets",name:"Flotas",url:"/fleets",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["d" /* ADMIN_OWNER */]},{lang_key:"service_suppliers",name:"Proveedores de servicio",url:"/service-suppliers",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["d" /* ADMIN_OWNER */]},{lang_key:"service_profiles",name:"Perfiles de servicio",url:"/service-profiles",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["d" /* ADMIN_OWNER */]},{lang_key:"service_charges",name:"Cargos de servicio",url:"/service-charges",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["d" /* ADMIN_OWNER */]},{lang_key:"fleet_associations",name:"Asociaciones",url:"/fleet-associations",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["d" /* ADMIN_OWNER */]}]},{lang_key:"webhooks",icon:"icon-globe",name:"Webhooks",url:"/webhooks",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["y" /* SUPER_ADMIN */]},{lang_key:"company",name:"Configuración",url:"/settings",icon:"fa fa-gears",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["b" /* ADMIN_HIGH */]},{lang_key:"",name:"Estadísticas",icon:"icon-speedometer icons",children:[{lang_key:"branch_group",name:"Comercios",url:"/branch-statistics",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["b" /* ADMIN_HIGH */]},{lang_key:"branch",name:"Grupos de comercio",url:"/branch-group-statistics",type:__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["b" /* ADMIN_HIGH */]}]}].filter(function(item){if("DEV".toUpperCase()==="PRODUCTION"){return item.lang_key!=="create-order";}return item.name!=="Estadísticas";})});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Validator_Validator__ = __webpack_require__(475);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InputNormal=function(_Component){_inherits(InputNormal,_Component);function InputNormal(props){_classCallCheck(this,InputNormal);var _this=_possibleConstructorReturn(this,(InputNormal.__proto__||Object.getPrototypeOf(InputNormal)).call(this,props));_this.validator=new __WEBPACK_IMPORTED_MODULE_2__Validator_Validator__["a" /* default */]();_this.toggle=_this.toggle.bind(_this);_this.state={invalidField:undefined,tooltipOpen:[false,false]};return _this;}_createClass(InputNormal,[{key:'toggle',value:function toggle(i){var newArray=this.state.tooltipOpen.map(function(element,index){return index===i?!element:false;});this.setState({tooltipOpen:newArray});}},{key:'isValid',value:function isValid(field){var valid=this.validator.fieldValid(field);this.setState({invalidField:!valid?true:undefined});if(!valid)this.validator.showMessages();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["FormGroup"],{className:this.props.className||''},this.props.labelName?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Label"],{htmlFor:this.props.name?this.props.name:'',className:this.props.labelclass?this.props.labelclass:'text-muted'},this.props.labelName,this.props.unrequired?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{style:{color:'red'}},' *')):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroup"],{className:this.props.mbClass?this.props.mbClass:'mb-3'},/* Coloca un icono o caracter antes del input*/this.props.iconPrepend?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupAddon"],{addonType:'prepend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupText"],null,this.props.iconPrepend)):null,/* Coloca un boton antes del input*/this.props.buttonPrepend?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupAddon"],{addonType:'prepend'},this.props.buttonPrepend):null,this.props.type&&this.props.type!=='email'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Input"],{id:this.props.tooltip?this.props.name:undefined// tooltip necesita ID
,type:this.props.type?this.props.type:'text',name:this.props.name?this.props.name:'',value:this.props.value?this.props.value:'',placeholder:this.props.placeholder?this.props.placeholder:'',onKeyUp:this.props.onKeyUp?this.props.onKeyUp:undefined,onKeyDown:this.props.onKeyDown?this.props.onKeyDown:undefined,onKeyPress:this.props.onKeyPress?this.props.onKeyPress:undefined,onChange:this.props.onChange?this.props.onChange:undefined,invalid:this.props.validation&&this.state.invalidField,disabled:this.props.disabled?this.props.disabled:false,maxLength:this.props.maxLength?this.props.maxLength:64,required:this.props.unrequired?false:true,min:this.props.min?this.props.min:0,max:this.props.max?this.props.max:0,style:this.props.style,onBlur:this.props.onBlur?this.props.onBlur:function(){return _this2.isValid(_this2.props.name);}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Input"],{id:this.props.tooltip?this.props.name:undefined// tooltip necesita ID
,type:this.props.type?this.props.type:'text',name:this.props.name?this.props.name:'',style:Object.assign({},this.props.style,{height:''+this.props.customHeight}),value:this.props.value?this.props.value:!Number.isNaN(this.props.value)// si es un numero, muestralo! los valores con 0 son falsos en js...
?this.props.value:'',placeholder:this.props.placeholder?this.props.placeholder:'',onKeyUp:this.props.onKeyUp?this.props.onKeyUp:undefined,onKeyDown:this.props.onKeyDown?this.props.onKeyDown:undefined,onKeyPress:this.props.onKeyPress?this.props.onKeyPress:undefined,onChange:this.props.onChange?this.props.onChange:undefined,invalid:this.props.validation&&this.state.invalidField,disabled:this.props.disabled?this.props.disabled:false,maxLength:this.props.maxLength?this.props.maxLength:64,required:this.props.unrequired?false:true,onBlur:this.props.onBlur?this.props.onBlur:function(){return _this2.isValid(_this2.props.name);}}),/* Coloca un icono o  despues del input*/this.props.iconAppend?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupAddon"],{addonType:'append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupText"],null,this.props.iconAppend)):null,/* Coloca un boton despues del input*/this.props.buttonAppend?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupAddon"],{addonType:'append'},this.props.buttonAppend):null,/*
							docs del plugin ---> https://github.com/dockwa/simple-react-validator

							@validation.rules = string, cadena separada por | con la lista de reglas definidas por el plugin
							@validation.classes = string, cadenas con las clases del Css para mostrar msj de error
							@validation.errorMessages = Object, objeto con los mensajes de error para cada regla definida
						*/this.props.validation?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["FormFeedback"],null,this.validator.message(this.props.name,this.props.value,this.props.validation.rules,this.props.validation.classes,this.props.validation.errorMessages)):null),/* Recibe arreglo  de posiciones  0 = contenido, 1 = id, ejemplo: tooltip = {['ejemplo de tooltip','id'}*/this.props.tooltip?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Tooltip"],{placement:this.props.tooltipPlacement?this.props.tooltipPlacement:'right',isOpen:this.state.tooltipOpen[0],target:/*this.props.tooltip[1] ? this.props.tooltip[1] :*/this.props.name,toggle:function toggle(){_this2.toggle(0);}},this.props.tooltip[0]):null);}}]);return InputNormal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (InputNormal);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_notificationsActions__ = __webpack_require__(66);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PreloaderBase=function(_React$Component){_inherits(PreloaderBase,_React$Component);function PreloaderBase(props){_classCallCheck(this,PreloaderBase);var _this=_possibleConstructorReturn(this,(PreloaderBase.__proto__||Object.getPrototypeOf(PreloaderBase)).call(this,props));_this.state={shown:false};_this.killClick=_this.killClick.bind(_this);_this.handleBackdropClick=_this.handleBackdropClick.bind(_this);return _this;}_createClass(PreloaderBase,[{key:'componentDidMount',value:function componentDidMount(){/*setTimeout(function(){
      document.getElementById("close").click();
    }, 9000);*/}},{key:'killClick',value:function killClick(e){// hace clic en el contenido no debe cerrar el modal
e.stopPropagation();}},{key:'handleBackdropClick',value:function handleBackdropClick(){// Al hacer clic en el fondo, el usuario solicita que el modal se cierra.
// Señalar que el modal tiene nada que decir sobre si realmente se cierra. el propietario de la
// Modal posee el estado. esto sólo "pide" que se cierre.
this.props.onRequestClose();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-loader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'preloader pls-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'pl-circular',viewBox:'25 25 50 50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{className:'plc-path',cx:50,cy:50,r:20}))));}}]);return PreloaderBase;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Preloader=function(_React$Component2){_inherits(Preloader,_React$Component2);function Preloader(props){_classCallCheck(this,Preloader);var _this2=_possibleConstructorReturn(this,(Preloader.__proto__||Object.getPrototypeOf(Preloader)).call(this,props));_this2.state={shown:false};_this2.handleRenderLayer=_this2.handleRenderLayer.bind(_this2);_this2.handleClick=_this2.handleClick.bind(_this2);_this2.renderLayer=_this2.renderLayer.bind(_this2);return _this2;}_createClass(Preloader,[{key:'componentDidUpdate',value:function componentDidUpdate(){this.handleRenderLayer();}},{key:'componentDidMount',value:function componentDidMount(){// Al añadir al cuerpo es más fácil que la gestión de la z-index de todo en la página.
// También es mejor para la accesibilidad y hace un broche de presión de apilamiento (ya que los componentes se apilarán
// Fin de montaje).
if(!document.getElementById("preloader")){this._target=document.createElement('div');this._target.setAttribute("id","preloader");document.body.appendChild(this._target);}else{this._target=document.getElementById("preloader");}this.handleRenderLayer();}},{key:'handleRenderLayer',value:function handleRenderLayer(){// Al llamar a este método en componentDidMount () y componentDidUpdate (), usted es efectivamente
// crear un "agujero de gusano" que canaliza cambios jerárquicos reacciona a través de un nodo DOM en una parte
// totalmente diferente de la página.
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(this.renderLayer(),this._target);}},{key:'handleClick',value:function handleClick(){this.props.clearNotification();}},{key:'renderLayer',value:function renderLayer(){if(!this.props.preloader){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PreloaderBase,null);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);}}]);return Preloader;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){return{preloader:state.preloader,json_lang:state.json_lang};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{clearNotification:function clearNotification(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_notificationsActions__["c" /* clearNotification */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Preloader));

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewModalConfirm=function(_Component){_inherits(NewModalConfirm,_Component);function NewModalConfirm(props){_classCallCheck(this,NewModalConfirm);var _this=_possibleConstructorReturn(this,(NewModalConfirm.__proto__||Object.getPrototypeOf(NewModalConfirm)).call(this,props));_this.state={modal:false};_this.toggleModal=_this.toggleModal.bind(_this);_this.actionModal=_this.actionModal.bind(_this);return _this;}_createClass(NewModalConfirm,[{key:'componentDidMount',value:function componentDidMount(){NewModalConfirm.modals.push(this);}},{key:'componentWillUnmount',value:function componentWillUnmount(){var _this2=this;NewModalConfirm.modals=NewModalConfirm.modals.filter(function(x){return x.props.id!==_this2.props.id;});}},{key:'acceptButton',value:function acceptButton(){if(this.props.confirmFunc){this.props.confirmFunc();NewModalConfirm.close(this.props.id);}else NewModalConfirm.close(this.props.id);}},{key:'toggleModal',value:function toggleModal(){this.setState({modal:!this.state.modal});}},{key:'actionModal',value:function actionModal(){if(this.props.confirmFunc){this.props.confirmFunc();this.toggleModal();}else{this.toggleModal();}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Modal"],{id:this.props.id,isOpen:this.state.modal,toggle:this.toggleModal,className:this.props.className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["ModalBody"],null,this.props.html),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{color:'primary',style:this.props.bg_company?this.props.bg_company:undefined,onClick:this.acceptButton.bind(this)},' ',this.props.json_lang.common.accept,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{color:'secondary',onClick:NewModalConfirm.eventClose(this.props.id)},' ',this.props.json_lang.common.cancel,' ')));}}]);return NewModalConfirm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NewModalConfirm.modals=[];NewModalConfirm.open=function(id){return function(e){e.preventDefault();var modal=NewModalConfirm.modals.find(function(x){return x.props.id===id;});modal&&modal.setState({modal:true});};};NewModalConfirm.eventClose=function(id){return function(e){e.preventDefault();var modal=NewModalConfirm.modals.find(function(x){return x.props.id===id;});modal.setState({modal:false});};};NewModalConfirm.close=function(id){var modal=NewModalConfirm.modals.find(function(x){return x.props.id===id;});modal.setState({modal:false});};var mapStateToProps=function mapStateToProps(state){return{errors:state.errors,admin:state.admin,json_lang:state.json_lang,bg_company:{background:state.company_styles_json.color_accent,borderColor:state.company_styles_json.color_accent},btn_link:{color:state.company_styles_json.color_accent}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(NewModalConfirm));

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports = [{"symbol":"Af","name":"Afgani afgano","symbol_native":"؋","decimal_digits":0,"rounding":0,"value":"AFN","name_plural":"Afganis afganos"},{"symbol":"MGA","name":"Ariary malgache","symbol_native":"MGA","decimal_digits":0,"rounding":0,"value":"MGA","name_plural":"Ariary malgaches"},{"symbol":"฿","name":"Baht tailandés","symbol_native":"฿","decimal_digits":2,"rounding":0,"value":"THB","name_plural":"Baht tailandeses"},{"symbol":"B/.","name":"Balboa panameño","symbol_native":"B/.","decimal_digits":2,"rounding":0,"value":"PAB","name_plural":"Balboas panameños"},{"symbol":"Br","name":"Birr etíope","symbol_native":"Br","decimal_digits":2,"rounding":0,"value":"ETB","name_plural":"Birr etíopes"},{"symbol":"Bs.S","name":"Bolívar soberano venezolano","symbol_native":"Bs.S","decimal_digits":2,"rounding":0,"value":"VES","name_plural":"Bolívares soberanos venezolanos"},{"symbol":"Bs","name":"Boliviano","symbol_native":"Bs","decimal_digits":2,"rounding":0,"value":"BOB","name_plural":"Bolivianos"},{"symbol":"GH₵","name":"Cedi ghanés","symbol_native":"GH₵","decimal_digits":2,"rounding":0,"value":"GHS","name_plural":"Cedis ghaneses"},{"symbol":"CFA","name":"CFA Franc BCEAO","symbol_native":"CFA","decimal_digits":0,"rounding":0,"value":"XOF","name_plural":"CFA francs BCEAO"},{"symbol":"Ksh","name":"Chelín keniano","symbol_native":"Ksh","decimal_digits":2,"rounding":0,"value":"KES","name_plural":"Chelines kenianos"},{"symbol":"Ssh","name":"Chelín somalí","symbol_native":"Ssh","decimal_digits":0,"rounding":0,"value":"SOS","name_plural":"Chelines somalíes"},{"symbol":"TSh","name":"Chelín tanzano","symbol_native":"TSh","decimal_digits":0,"rounding":0,"value":"TZS","name_plural":"Chelines tanzanos"},{"symbol":"USh","name":"Chelín ugandés","symbol_native":"USh","decimal_digits":0,"rounding":0,"value":"UGX","name_plural":"Chelines ugandeses"},{"symbol":"₡","name":"Colón costarricense","symbol_native":"₡","decimal_digits":0,"rounding":0,"value":"CRC","name_plural":"Colone costarricenses"},{"symbol":"C$","name":"Córdoba nicaragüense","symbol_native":"C$","decimal_digits":2,"rounding":0,"value":"NIO","name_plural":"Córdobas nicaragüenses"},{"symbol":"Kč","name":"Corona checa","symbol_native":"Kč","decimal_digits":2,"rounding":0,"value":"CZK","name_plural":"Coronas checas"},{"symbol":"Dkr","name":"Corona danesa","symbol_native":"kr","decimal_digits":2,"rounding":0,"value":"DKK","name_plural":"Coronas danesas"},{"symbol":"Ekr","name":"Corona estonia","symbol_native":"kr","decimal_digits":2,"rounding":0,"value":"EEK","name_plural":"Coronas estonias"},{"symbol":"Ikr","name":"Corona islandesa","symbol_native":"kr","decimal_digits":0,"rounding":0,"value":"ISK","name_plural":"Coronas islandesas"},{"symbol":"Nkr","name":"Corona noruega","symbol_native":"kr","decimal_digits":2,"rounding":0,"value":"NOK","name_plural":"Coronas noruegas"},{"symbol":"Skr","name":"Corona sueca","symbol_native":"kr","decimal_digits":2,"rounding":0,"value":"SEK","name_plural":"Coronas suecas"},{"symbol":"MKD","name":"Denar macedonio","symbol_native":"MKD","decimal_digits":2,"rounding":0,"value":"MKD","name_plural":"Denares macedonios"},{"symbol":"DA","name":"Dinar argelino","symbol_native":"د.ج.‏","decimal_digits":2,"rounding":0,"value":"DZD","name_plural":"Dinares argelinos"},{"symbol":"BD","name":"Dinar bareiní","symbol_native":"د.ب.‏","decimal_digits":3,"rounding":0,"value":"BHD","name_plural":"Dinares bareiníes"},{"symbol":"IQD","name":"Dinar iraquí","symbol_native":"د.ع.‏","decimal_digits":0,"rounding":0,"value":"IQD","name_plural":"Dinares iraquíes"},{"symbol":"JD","name":"Dinar jordano","symbol_native":"د.أ.‏","decimal_digits":3,"rounding":0,"value":"JOD","name_plural":"Dinares jordanos"},{"symbol":"KD","name":"Dinar kuwaití","symbol_native":"د.ك.‏","decimal_digits":3,"rounding":0,"value":"KWD","name_plural":"Dinares kuwaitíes"},{"symbol":"LD","name":"Dinar libio","symbol_native":"د.ل.‏","decimal_digits":3,"rounding":0,"value":"LYD","name_plural":"Dinares libios"},{"symbol":"din.","name":"Dinar serbio","symbol_native":"дин.","decimal_digits":0,"rounding":0,"value":"RSD","name_plural":"Dinares serbios"},{"symbol":"SDG","name":"Dinar sudanés","symbol_native":"SDG","decimal_digits":2,"rounding":0,"value":"SDG","name_plural":"Dinares sudaneses"},{"symbol":"DT","name":"Dinar tunecino","symbol_native":"د.ت.‏","decimal_digits":3,"rounding":0,"value":"TND","name_plural":"Dinares tunecinos"},{"symbol":"AED","name":"Dírham de los Emiratos Árabes Unidos","symbol_native":"د.إ.‏","decimal_digits":2,"rounding":0,"value":"AED","name_plural":"Dírhams de los Emiratos Árabes Unidos"},{"symbol":"MAD","name":"Dírham marroquí","symbol_native":"د.م.‏","decimal_digits":2,"rounding":0,"value":"MAD","name_plural":"Dírhams marroquíes"},{"symbol":"AU$","name":"Dólar australiano","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"AUD","name_plural":"Dólares australianos"},{"symbol":"BZ$","name":"Dólar beliceño","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"BZD","name_plural":"Dólares beliceños"},{"symbol":"CA$","name":"Dólar canadiense","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"CAD","name_plural":"Dólares canadienses"},{"symbol":"BN$","name":"Dólar de Brunéi","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"BND","name_plural":"Dólares de Brunéi"},{"symbol":"HK$","name":"Dólar de Hong Kong","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"HKD","name_plural":"Dólares de Hong Kong"},{"symbol":"S$","name":"Dólar de Singapur","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"SGD","name_plural":"Dólares de Singapur"},{"symbol":"TT$","name":"Dólar de Trinidad y Tobago","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"TTD","name_plural":"Dólares de Trinidad y Tobago"},{"symbol":"$","name":"Dólar estadounidense","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"USD","name_plural":"Dólares estadounidenses"},{"symbol":"J$","name":"Dólar jamaiquino","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"JMD","name_plural":"Dólares jamaiquinos"},{"symbol":"N$","name":"Dólar namibio","symbol_native":"N$","decimal_digits":2,"rounding":0,"value":"NAD","name_plural":"Dólares namibios"},{"symbol":"NZ$","name":"Dólar neozelandés","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"NZD","name_plural":"Dólares neozelandeses"},{"symbol":"₫","name":"Dong vietnamita","symbol_native":"₫","decimal_digits":0,"rounding":0,"value":"VND","name_plural":"Dong vietnamitas"},{"symbol":"AMD","name":"Dram armenio","symbol_native":"դր.","decimal_digits":0,"rounding":0,"value":"AMD","name_plural":"Drams armenios"},{"symbol":"CV$","name":"Escudo caboverdiano","symbol_native":"CV$","decimal_digits":2,"rounding":0,"value":"CVE","name_plural":"Escudos caboverdianos"},{"symbol":"zł","name":"Esloti polaco","symbol_native":"zł","decimal_digits":2,"rounding":0,"value":"PLN","name_plural":"Eslotis polacos"},{"symbol":"€","name":"Euro","symbol_native":"€","decimal_digits":2,"rounding":0,"value":"EUR","name_plural":"Euros"},{"symbol":"Ft","name":"Forinto húngaro","symbol_native":"Ft","decimal_digits":0,"rounding":0,"value":"HUF","name_plural":"Forintos húngaros"},{"symbol":"FBu","name":"Franco burundés","symbol_native":"FBu","decimal_digits":0,"rounding":0,"value":"BIF","name_plural":"Francos burundeses"},{"symbol":"FCFA","name":"Franco CFA de África Central","symbol_native":"FCFA","decimal_digits":0,"rounding":0,"value":"XAF","name_plural":"Francos CFA de África Central"},{"symbol":"CF","name":"Franco comorense","symbol_native":"FC","decimal_digits":0,"rounding":0,"value":"KMF","name_plural":"Francos comorenses"},{"symbol":"CDF","name":"Franco congoleño","symbol_native":"FrCD","decimal_digits":2,"rounding":0,"value":"CDF","name_plural":"Francos congoleños"},{"symbol":"FG","name":"Franco guineano","symbol_native":"FG","decimal_digits":0,"rounding":0,"value":"GNF","name_plural":"Francos guineanos"},{"symbol":"RWF","name":"Franco ruandés","symbol_native":"FR","decimal_digits":0,"rounding":0,"value":"RWF","name_plural":"Francos ruandeses"},{"symbol":"CHF","name":"Franco suizo","symbol_native":"CHF","decimal_digits":2,"rounding":0.05,"value":"CHF","name_plural":"Francos suizos"},{"symbol":"Fdj","name":"Franco yibutiano","symbol_native":"Fdj","decimal_digits":0,"rounding":0,"value":"DJF","name_plural":"Francos yibutianos"},{"symbol":"₴","name":"Grivna ucraniana","symbol_native":"₴","decimal_digits":2,"rounding":0,"value":"UAH","name_plural":"Grivnas ucranianas"},{"symbol":"₲","name":"Guaraní paraguayo","symbol_native":"₲","decimal_digits":0,"rounding":0,"value":"PYG","name_plural":"Guaraníes paraguayos"},{"symbol":"kn","name":"Kuna croata","symbol_native":"kn","decimal_digits":2,"rounding":0,"value":"HRK","name_plural":"Kunas croatas"},{"symbol":"ZK","name":"Kwacha zambiano","symbol_native":"ZK","decimal_digits":0,"rounding":0,"value":"ZMK","name_plural":"Kwacha zambianos"},{"symbol":"MMK","name":"Kyat birmano","symbol_native":"K","decimal_digits":0,"rounding":0,"value":"MMK","name_plural":"Kyats birmanos"},{"symbol":"GEL","name":"Lari georgiano","symbol_native":"GEL","decimal_digits":2,"rounding":0,"value":"GEL","name_plural":"Laris georgianos"},{"symbol":"Ls","name":"Lats letón","symbol_native":"Ls","decimal_digits":2,"rounding":0,"value":"LVL","name_plural":"Lati letones"},{"symbol":"ALL","name":"Lek albanés","symbol_native":"Lek","decimal_digits":0,"rounding":0,"value":"ALL","name_plural":"Lekë albaneses"},{"symbol":"HNL","name":"Lempira hondureña","symbol_native":"L","decimal_digits":2,"rounding":0,"value":"HNL","name_plural":"Lempiras hondureñas"},{"symbol":"MDL","name":"Leu moldavo","symbol_native":"MDL","decimal_digits":2,"rounding":0,"value":"MDL","name_plural":"Lei moldavos"},{"symbol":"RON","name":"Leu rumano","symbol_native":"RON","decimal_digits":2,"rounding":0,"value":"RON","name_plural":"Lei rumanos"},{"symbol":"BGN","name":"Lev búlgaro","symbol_native":"лв.","decimal_digits":2,"rounding":0,"value":"BGN","name_plural":"Leva búlgaros"},{"symbol":"EGP","name":"Libra egipcia","symbol_native":"ج.م.‏","decimal_digits":2,"rounding":0,"value":"EGP","name_plural":"Libras egipcias"},{"symbol":"£","name":"Libra esterlina británica","symbol_native":"£","decimal_digits":2,"rounding":0,"value":"GBP","name_plural":"Libras esterlinas británicas"},{"symbol":"LB£","name":"Libra libanesa","symbol_native":"ل.ل.‏","decimal_digits":0,"rounding":0,"value":"LBP","name_plural":"Libras libanesas"},{"symbol":"SY£","name":"Libra siria","symbol_native":"ل.س.‏","decimal_digits":0,"rounding":0,"value":"SYP","name_plural":"Libras sirias"},{"symbol":"TL","name":"Lira turca","symbol_native":"TL","decimal_digits":2,"rounding":0,"value":"TRY","name_plural":"Liras turcas"},{"symbol":"Lt","name":"Litas lituana","symbol_native":"Lt","decimal_digits":2,"rounding":0,"value":"LTL","name_plural":"Litai lituanas"},{"symbol":"man.","name":"Manat azerbaiyano","symbol_native":"ман.","decimal_digits":2,"rounding":0,"value":"AZN","name_plural":"Manats azerbaiyanos"},{"symbol":"KM","name":"Marco bosnioherzegovino","symbol_native":"KM","decimal_digits":2,"rounding":0,"value":"BAM","name_plural":"Marcos bosnioherzegovinos"},{"symbol":"MTn","name":"Metical mozambiqueño","symbol_native":"MTn","decimal_digits":2,"rounding":0,"value":"MZN","name_plural":"Meticales mozambiqueños"},{"symbol":"₦","name":"Naira nigeriano","symbol_native":"₦","decimal_digits":2,"rounding":0,"value":"NGN","name_plural":"Nairas nigerianos"},{"symbol":"Nfk","name":"Nakfa eritrea","symbol_native":"Nfk","decimal_digits":2,"rounding":0,"value":"ERN","name_plural":"Nakfas eritreas"},{"symbol":"NT$","name":"Nuevo dólar taiwanés","symbol_native":"NT$","decimal_digits":2,"rounding":0,"value":"TWD","name_plural":"Nuevos dólares taiwaneses"},{"symbol":"₪","name":"Nuevo séquel israelí","symbol_native":"₪","decimal_digits":2,"rounding":0,"value":"ILS","name_plural":"Nuevos séqueles israelíes"},{"symbol":"S/.","name":"Nuevo Sol peruano","symbol_native":"S/.","decimal_digits":2,"rounding":0,"value":"PEN","name_plural":"Nuevos Soles peruanos"},{"symbol":"T$","name":"Pa'anga tongano","symbol_native":"T$","decimal_digits":2,"rounding":0,"value":"TOP","name_plural":"Pa'anga tonganos"},{"symbol":"MOP$","name":"Pataca macaense","symbol_native":"MOP$","decimal_digits":2,"rounding":0,"value":"MOP","name_plural":"Patacas macaenses"},{"symbol":"AR$","name":"Peso argentino","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"ARS","name_plural":"Pesos argentinos"},{"symbol":"CL$","name":"Peso chileno","symbol_native":"$","decimal_digits":0,"rounding":0,"value":"CLP","name_plural":"Pesos chilenos"},{"symbol":"CO$","name":"Peso colombiano","symbol_native":"$","decimal_digits":0,"rounding":0,"value":"COP","name_plural":"Pesos colombianos"},{"symbol":"RD$","name":"Peso dominicano","symbol_native":"RD$","decimal_digits":2,"rounding":0,"value":"DOP","name_plural":"Pesos dominicanos"},{"symbol":"₱","name":"Peso filipino","symbol_native":"₱","decimal_digits":2,"rounding":0,"value":"PHP","name_plural":"Pesos filipinos"},{"symbol":"MX$","name":"Peso mexicano","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"MXN","name_plural":"Pesos mexicanos"},{"symbol":"$U","name":"Peso uruguayo","symbol_native":"$","decimal_digits":2,"rounding":0,"value":"UYU","name_plural":"Pesos uruguayos"},{"symbol":"BWP","name":"Pula","symbol_native":"P","decimal_digits":2,"rounding":0,"value":"BWP","name_plural":"Pulas"},{"symbol":"GTQ","name":"Quetzal guatemalteco","symbol_native":"Q","decimal_digits":2,"rounding":0,"value":"GTQ","name_plural":"Quetzales guatemaltecos"},{"symbol":"R","name":"Rand sudafricano","symbol_native":"R","decimal_digits":2,"rounding":0,"value":"ZAR","name_plural":"Rand sudafricanos"},{"symbol":"R$","name":"Real brasileño","symbol_native":"R$","decimal_digits":2,"rounding":0,"value":"BRL","name_plural":"Reales brasileños"},{"symbol":"IRR","name":"Rial iraní","symbol_native":"﷼","decimal_digits":0,"rounding":0,"value":"IRR","name_plural":"Riales iraníes"},{"symbol":"OMR","name":"Rial omaní","symbol_native":"ر.ع.‏","decimal_digits":3,"rounding":0,"value":"OMR","name_plural":"Riales omaníes"},{"symbol":"YR","name":"Rial yemení","symbol_native":"ر.ي.‏","decimal_digits":0,"rounding":0,"value":"YER","name_plural":"Riales yemeníes"},{"symbol":"KHR","name":"Riel camboyano","symbol_native":"៛","decimal_digits":2,"rounding":0,"value":"KHR","name_plural":"Rieles camboyanos"},{"symbol":"RM","name":"Ringgit malayo","symbol_native":"RM","decimal_digits":2,"rounding":0,"value":"MYR","name_plural":"Ringgit malayos"},{"symbol":"QR","name":"Riyal catarí","symbol_native":"ر.ق.‏","decimal_digits":2,"rounding":0,"value":"QAR","name_plural":"Riyales cataríes"},{"symbol":"SR","name":"Riyal saudí","symbol_native":"ر.س.‏","decimal_digits":2,"rounding":0,"value":"SAR","name_plural":"Riyales saudíes"},{"symbol":"BYR","name":"Rublo bielorruso","symbol_native":"BYR","decimal_digits":0,"rounding":0,"value":"BYR","name_plural":"Rublos bielorrusos"},{"symbol":"RUB","name":"Rublo ruso","symbol_native":"руб.","decimal_digits":2,"rounding":0,"value":"RUB","name_plural":"Rublos rusos"},{"symbol":"MURs","name":"Rupia de Mauricio","symbol_native":"MURs","decimal_digits":0,"rounding":0,"value":"MUR","name_plural":"Rupias de Mauricio"},{"symbol":"SLRs","name":"Rupia de Sri Lanka","symbol_native":"SL Re","decimal_digits":2,"rounding":0,"value":"LKR","name_plural":"Rupias de Sri Lanka"},{"symbol":"Rs","name":"Rupia india","symbol_native":"টকা","decimal_digits":2,"rounding":0,"value":"INR","name_plural":"Rupias indias"},{"symbol":"Rp","name":"Rupia indonesia","symbol_native":"Rp","decimal_digits":0,"rounding":0,"value":"IDR","name_plural":"Rupias indonesias"},{"symbol":"NPRs","name":"Rupia nepalí","symbol_native":"नेरू","decimal_digits":2,"rounding":0,"value":"NPR","name_plural":"Rupias nepalíes"},{"symbol":"PKRs","name":"Rupia pakistaní","symbol_native":"₨","decimal_digits":0,"rounding":0,"value":"PKR","name_plural":"Rupias pakistaníes"},{"symbol":"Tk","name":"Taka bangladesí","symbol_native":"৳","decimal_digits":2,"rounding":0,"value":"BDT","name_plural":"Takas bangladesíes"},{"symbol":"KZT","name":"Tenge kazajo","symbol_native":"тңг.","decimal_digits":2,"rounding":0,"value":"KZT","name_plural":"Tenges kazajos"},{"symbol":"UZS","name":"Uzbekistan Som","symbol_native":"UZS","decimal_digits":0,"rounding":0,"value":"UZS","name_plural":"Uzbekistan som"},{"symbol":"₩","name":"Won surcoreano","symbol_native":"₩","decimal_digits":0,"rounding":0,"value":"KRW","name_plural":"Wones surcoreanos"},{"symbol":"¥","name":"Yen japonés","symbol_native":"￥","decimal_digits":0,"rounding":0,"value":"JPY","name_plural":"Yenes japoneses"},{"symbol":"CN¥","name":"Yuan chino","symbol_native":"CN¥","decimal_digits":2,"rounding":0,"value":"CNY","name_plural":"Yuan chino"}]

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SelectNormal=function(_Component){_inherits(SelectNormal,_Component);function SelectNormal(){_classCallCheck(this,SelectNormal);return _possibleConstructorReturn(this,(SelectNormal.__proto__||Object.getPrototypeOf(SelectNormal)).apply(this,arguments));}_createClass(SelectNormal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroup"],{className:'mb-3 '+(this.props.className?this.props.className:'')},this.props.label_text?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Label"],{className:'text-muted w100'},this.props.label_text,this.props.required?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{style:{color:'red'}},' *'):null):null,/* Coloca un icono o caracter antes del input*/this.props.iconPrepend?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupAddon"],{addonType:'prepend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupText"],null,this.props.iconPrepend)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:this.props.name?this.props.name:undefined,disabled:this.props.disabled,className:'form-control',onChange:this.props.onchange,style:{height:''+this.props.customHeight},value:this.props.val?this.props.val:''},this.props.text_init?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},this.props.text_init):null,this.props.options?this.props.options.map(function(option,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:key,value:option.value?option.value:option.id},' ',option.name,' ');}):null),this.props.buttonAppend?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupAddon"],{addonType:'append'},this.props.buttonAppend):null);}}]);return SelectNormal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SelectNormal);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bitwise__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JSONObject__ = __webpack_require__(282);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__bitwise__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__JSONObject__["a"]; });
/* unused harmony reexport omit */


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pickMap; });
/* unused harmony export omit */
var pick=function pick(object){for(var _len=arguments.length,props=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){props[_key-1]=arguments[_key];}return props.reduce(function(result,prop){result[prop]=object[prop];return result;},{});};var pickMap=function pickMap(object,reducer){return reducer(Object.assign({},object));};var omit=function omit(object){for(var _len2=arguments.length,props=Array(_len2>1?_len2-1:0),_key2=1;_key2<_len2;_key2++){props[_key2-1]=arguments[_key2];}var result=Object.assign({},object);props.forEach(function(prop){delete result[prop];});return result;};

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chats_css__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chats_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__chats_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_UtilsOperation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actions_couponsActions__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Spinner__ = __webpack_require__(62);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalDiscount=function(_Component){_inherits(ModalDiscount,_Component);function ModalDiscount(props){_classCallCheck(this,ModalDiscount);return _possibleConstructorReturn(this,(ModalDiscount.__proto__||Object.getPrototypeOf(ModalDiscount)).call(this,props));}_createClass(ModalDiscount,[{key:'render',value:function render(){var _props=this.props,coupon=_props.coupon,currency=_props.currency,json_lang=_props.json_lang;var status=Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_UtilsOperation__["e" /* couponStatus */])(coupon.status);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{backgroundColor:"#ECE5DD",margin:"30px",padding:"10%",borderRadius:"20px",boxShadow:"rgb(0 0 0 / 47%) 0px 2px 5px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center mb-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Cup\xF3n: ',coupon.name),status&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:status.style},status.text)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],{md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:"flex",flexDirection:"column",marginLeft:"5px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'text-muted mb-2 w-100'},json_lang.common.details),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,coupon.config.is_cashback?"Cashback":json_lang.common.discount,': '),coupon.price_e2>0?Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_UtilsOperation__["v" /* number_format */])(coupon.price_e2/100)+' '+currency+' ':Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_UtilsOperation__["v" /* number_format */])(coupon.price_prc*100)+'%'),coupon.config.max_discount_e2>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,json_lang.common.max_discount+':'),Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_UtilsOperation__["v" /* number_format */])(coupon.config.max_discount_e2/coupon.price_prc/100)+' '+currency),coupon.config.max_discount_e2>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,json_lang.common.amount_limit+':'),Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_UtilsOperation__["v" /* number_format */])(coupon.config.max_discount_e2)+' '+currency),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,json_lang.order_details.applies_to,': '),json_lang.common[coupon.applies_to]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,json_lang.order_details.type,': '),json_lang.common[coupon.type]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,json_lang.common.target,': '),json_lang.common[coupon.target_type]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,json_lang.order_details.used,': '),coupon.spent_count,' / ',coupon.total_count===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Badge"],{color:'light'},json_lang.common.unlimited):coupon.total_count),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,json_lang.common.min_purchase,': '),' ',coupon.min_purchase_e2&&coupon.min_purchase_e2>0?Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_UtilsOperation__["v" /* number_format */])(coupon.min_purchase_e2/100)+' '+currency:json_lang.order_details.not_applicable),coupon.price_prc>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,json_lang.common.max_discount,': '),' ',coupon.config.max_discount_e2&&coupon.config.max_discount_e2>0?Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_UtilsOperation__["v" /* number_format */])(coupon.config.max_discount_e2/coupon.human_price_prc)+' '+currency:json_lang.order_details.not_applicable),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,json_lang.order_details.starts,': '),coupon.starts_at?Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_UtilsOperation__["M" /* utcDateFormat */])(coupon.starts_at,'YYYY-MM-DD HH:mm'):json_lang.common.undefined),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,json_lang.order_details.ends,': '),coupon.ends_at?Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_UtilsOperation__["M" /* utcDateFormat */])(coupon.ends_at,'YYYY-MM-DD HH:mm'):json_lang.common.undefined))),coupon.type==="batch"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],{md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'text-muted text-center w-100'},json_lang.common.used_code),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{style:{maxHeight:'150px',overflow:'auto',minHeight:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},coupon.promo_code?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,coupon.promo_code):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'A\xFAn no se han usado ning\xFAn c\xF3digo'))))));}}]);return ModalDiscount;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{json_lang:state.json_lang,couponCodes:state.coupon};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getCouponCodes:function getCouponCodes(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_couponsActions__["k" /* getCouponCodes */])(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_3__api__["withApiService"])(ModalDiscount)));

/***/ }),
/* 284 */,
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewModalBase=function(_Component){_inherits(NewModalBase,_Component);function NewModalBase(props){_classCallCheck(this,NewModalBase);var _this=_possibleConstructorReturn(this,(NewModalBase.__proto__||Object.getPrototypeOf(NewModalBase)).call(this,props));_this.state={modal:false};_this.toggleModal=_this.toggleModal.bind(_this);return _this;}_createClass(NewModalBase,[{key:'componentDidMount',value:function componentDidMount(){NewModalBase.modals.push(this);}},{key:'componentWillUnmount',value:function componentWillUnmount(){var _this2=this;NewModalBase.modals=NewModalBase.modals.filter(function(x){return x.props.id!==_this2.props.id;});}},{key:'acceptButton',value:function acceptButton(){if(this.props.confirmFunc){this.props.confirmFunc();NewModalBase.close(this.props.id);}else NewModalBase.close(this.props.id);}},{key:'toggleModal',value:function toggleModal(){this.setState({modal:!this.state.modal});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Modal"],{id:this.props.id,isOpen:this.state.modal,toggle:this.toggleModal,className:this.props.className?this.props.className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["ModalHeader"],{toggle:this.toggleModal},this.props.title?this.props.title:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["ModalBody"],null,this.props.html),this.props.confirmFunc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{color:'primary',style:this.props.bg_company?this.props.bg_company:undefined,disabled:this.props.preloader===true?true:false,onClick:this.acceptButton.bind(this)},this.props.json_lang.common.save),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{color:'secondary',onClick:NewModalBase.eventClose(this.props.id)},' ',this.props.json_lang.common.cancel,' ')):null);}}]);return NewModalBase;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NewModalBase.modals=[];NewModalBase.open=function(id){return function(e){e.preventDefault();var modal=NewModalBase.modals.find(function(x){return x.props.id===id;});modal.setState({modal:true});};};NewModalBase.eventClose=function(id){return function(e){e.preventDefault();var modal=NewModalBase.modals.find(function(x){return x.props.id===id;});modal.setState({modal:false});};};NewModalBase.close=function(id){var modal=NewModalBase.modals.find(function(x){return x.props.id===id;});modal.setState({modal:false});};var mapStateToProps=function mapStateToProps(state){return{errors:state.errors,admin:state.admin,json_lang:state.json_lang,preloader:state.preloader,bg_company:{background:state.company_styles_json.color_accent,borderColor:state.company_styles_json.color_accent},btn_link:{color:state.company_styles_json.color_accent}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(NewModalBase));

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(287);
module.exports = __webpack_require__(292);


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(288).enable();
  window.Promise = __webpack_require__(290);
}

// fetch() polyfill for making API calls.
__webpack_require__(291);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(67);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(146);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)))

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(146);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 291 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfill__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
//import {HandleErrors, CathTokenRenewal} from './handlers/RequestHandler';
// import * as Sentry from "@sentry/react";
// import { version } from "../package.json";
//import { BrowserTracing } from "@sentry/tracing";
/*

*/var retries=0;// Esta variable previene que se muestre varias veces el modal, en caso de dispararse varios errores consecutivos
// Sentry.init({
//     dsn:
//         window.location.hostname !== "localhost"
//             ? "https://910bc0b67107404e80ac9875eca94bd6@sentry.simgulary.io/19"
//             : null,
//     release: "dondemand-admin@" + version,
//     tracesSampleRate: 1.0,
//     beforeSend(event, hint) {
//         // let dialogTimeout;
//         // Check if it is an exception, and if so, show the report dialog
//         if (event.exception) {
//             if (retries === 0) {
//                 // && !dialogTimeout){
//                 retries = 1;
//                 //clearTimeout(this.dialogTimeout);
//                 /* dialogTimeout =  setTimeout...* /
// 				setTimeout(() => {
// 					Sentry.showReportDialog({
// 						eventId: event.event_id,
// 						lang: "es"
// 					});
// 					retries = 0;
// 				}, 250);
// 				/*if (dialogTimeout !== undefined) {
// 					clearTimeout(dialogTimeout);
// 				}*/
//             }
//         }
//         return event;
//     },
// });
// agregar dialogo para capturar error del usuario
// https://sentry.simgulary.io/settings/simgulary/projects/dondemand-dashboard/install/javascript-react/
__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["b" /* default */],null)),document.getElementById("root"));

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_array__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_es6_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_map__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_es6_set__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_es7_object__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_es7_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_es7_object__);
/*
* required polyfills
*//** IE9, IE10 and IE11 requires all of the following polyfills. **/// import 'core-js/es6/symbol'
// import 'core-js/es6/object'
// import 'core-js/es6/function'
// import 'core-js/es6/parse-int'
// import 'core-js/es6/parse-float'
// import 'core-js/es6/number'
// import 'core-js/es6/math'
// import 'core-js/es6/string'
// import 'core-js/es6/date'
// import 'core-js/es6/regexp'
// import 'core-js/es6/weak-map'
/** IE10 and IE11 requires the following for the Reflect API. */// import 'core-js/es6/reflect'
/** Evergreen browsers require these. **/// Used for reflect-metadata in JIT. If you use AOT (and only Angular decorators), you can remove.
// import 'core-js/es7/reflect'
// CustomEvent() constructor functionality in IE9, IE10, IE11
(function(){if(typeof window.CustomEvent==="function")return false;function CustomEvent(event,params){params=params||{bubbles:false,cancelable:false,detail:undefined};var evt=document.createEvent('CustomEvent');evt.initCustomEvent(event,params.bubbles,params.cancelable,params.detail);return evt;}CustomEvent.prototype=window.Event.prototype;window.CustomEvent=CustomEvent;})();

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(98);
__webpack_require__(299);
__webpack_require__(300);
__webpack_require__(301);
__webpack_require__(302);
__webpack_require__(303);
__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(308);
__webpack_require__(309);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(316);
__webpack_require__(318);
__webpack_require__(320);
__webpack_require__(321);
__webpack_require__(322);
__webpack_require__(161);
module.exports = __webpack_require__(35).Array;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(68);
var defined = __webpack_require__(99);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(102)('native-function-to-string', Function.toString);


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(149);
var descriptor = __webpack_require__(70);
var setToStringTag = __webpack_require__(106);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(46)(IteratorPrototype, __webpack_require__(16)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(27);
var anObject = __webpack_require__(41);
var getKeys = __webpack_require__(103);

module.exports = __webpack_require__(15) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(5);

$export($export.S, 'Array', { isArray: __webpack_require__(153) });


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(49);
var $export = __webpack_require__(5);
var toObject = __webpack_require__(20);
var call = __webpack_require__(154);
var isArrayIter = __webpack_require__(155);
var toLength = __webpack_require__(30);
var createProperty = __webpack_require__(108);
var getIterFn = __webpack_require__(156);

$export($export.S + $export.F * !__webpack_require__(158)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var createProperty = __webpack_require__(108);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(29)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(5);
var toIObject = __webpack_require__(36);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(72) != Object || !__webpack_require__(21)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var html = __webpack_require__(152);
var cof = __webpack_require__(73);
var toAbsoluteIndex = __webpack_require__(74);
var toLength = __webpack_require__(30);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(29)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var aFunction = __webpack_require__(54);
var toObject = __webpack_require__(20);
var fails = __webpack_require__(29);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(21)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $forEach = __webpack_require__(42)(0);
var STRICT = __webpack_require__(21)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(307);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
var isArray = __webpack_require__(153);
var SPECIES = __webpack_require__(16)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $map = __webpack_require__(42)(1);

$export($export.P + $export.F * !__webpack_require__(21)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $filter = __webpack_require__(42)(2);

$export($export.P + $export.F * !__webpack_require__(21)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $some = __webpack_require__(42)(3);

$export($export.P + $export.F * !__webpack_require__(21)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $every = __webpack_require__(42)(4);

$export($export.P + $export.F * !__webpack_require__(21)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $reduce = __webpack_require__(159);

$export($export.P + $export.F * !__webpack_require__(21)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $reduce = __webpack_require__(159);

$export($export.P + $export.F * !__webpack_require__(21)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $indexOf = __webpack_require__(151)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(21)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toIObject = __webpack_require__(36);
var toInteger = __webpack_require__(68);
var toLength = __webpack_require__(30);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(21)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(5);

$export($export.P, 'Array', { copyWithin: __webpack_require__(317) });

__webpack_require__(56)('copyWithin');


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(20);
var toAbsoluteIndex = __webpack_require__(74);
var toLength = __webpack_require__(30);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(5);

$export($export.P, 'Array', { fill: __webpack_require__(319) });

__webpack_require__(56)('fill');


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(20);
var toAbsoluteIndex = __webpack_require__(74);
var toLength = __webpack_require__(30);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(5);
var $find = __webpack_require__(42)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(56)(KEY);


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(5);
var $find = __webpack_require__(42)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(56)(KEY);


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(160)('Array');


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(163);
__webpack_require__(98);
__webpack_require__(164);
__webpack_require__(324);
module.exports = __webpack_require__(35).Map;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(165);
var validate = __webpack_require__(109);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(170)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
var setPrototypeOf = __webpack_require__(326).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(28);
var anObject = __webpack_require__(41);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(49)(Function.call, __webpack_require__(75).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(163);
__webpack_require__(98);
__webpack_require__(164);
__webpack_require__(328);
module.exports = __webpack_require__(35).Set;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(165);
var validate = __webpack_require__(109);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(170)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(330);
__webpack_require__(334);
__webpack_require__(335);
__webpack_require__(336);
__webpack_require__(337);
__webpack_require__(338);
__webpack_require__(339);
module.exports = __webpack_require__(35).Object;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(5);
var ownKeys = __webpack_require__(331);
var toIObject = __webpack_require__(36);
var gOPD = __webpack_require__(75);
var createProperty = __webpack_require__(108);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(332);
var gOPS = __webpack_require__(333);
var anObject = __webpack_require__(41);
var Reflect = __webpack_require__(19).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(150);
var hiddenKeys = __webpack_require__(105).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 333 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(5);
var $values = __webpack_require__(172)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(5);
var $entries = __webpack_require__(172)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toObject = __webpack_require__(20);
var aFunction = __webpack_require__(54);
var $defineProperty = __webpack_require__(27);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(15) && $export($export.P + __webpack_require__(76), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toObject = __webpack_require__(20);
var aFunction = __webpack_require__(54);
var $defineProperty = __webpack_require__(27);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(15) && $export($export.P + __webpack_require__(76), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toObject = __webpack_require__(20);
var toPrimitive = __webpack_require__(69);
var getPrototypeOf = __webpack_require__(107);
var getOwnPropertyDescriptor = __webpack_require__(75).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(15) && $export($export.P + __webpack_require__(76), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toObject = __webpack_require__(20);
var toPrimitive = __webpack_require__(69);
var getPrototypeOf = __webpack_require__(107);
var getOwnPropertyDescriptor = __webpack_require__(75).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(15) && $export($export.P + __webpack_require__(76), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(67),n=__webpack_require__(110),p=__webpack_require__(111),q=__webpack_require__(112),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.2
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(110),ba=__webpack_require__(0),m=__webpack_require__(173),p=__webpack_require__(67),v=__webpack_require__(112),da=__webpack_require__(342),ea=__webpack_require__(343),fa=__webpack_require__(344),ha=__webpack_require__(111);
function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ba?void 0:A("227");
function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var ec=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,fc="function"===typeof Symbol&&Symbol.for,gc=fc?Symbol.for("react.element"):60103,hc=fc?Symbol.for("react.portal"):60106,ic=fc?Symbol.for("react.fragment"):60107,jc=fc?Symbol.for("react.strict_mode"):60108,kc=fc?Symbol.for("react.profiler"):60114,lc=fc?Symbol.for("react.provider"):60109,mc=fc?Symbol.for("react.context"):60110,pc=fc?Symbol.for("react.async_mode"):60111,qc=fc?Symbol.for("react.forward_ref"):60112,rc=fc?Symbol.for("react.timeout"):
60113,sc="function"===typeof Symbol&&Symbol.iterator;function tc(a){if(null===a||"undefined"===typeof a)return null;a=sc&&a[sc]||a["@@iterator"];return"function"===typeof a?a:null}
function uc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case pc:return"AsyncMode";case mc:return"Context.Consumer";case ic:return"ReactFragment";case hc:return"ReactPortal";case kc:return"Profiler("+a.pendingProps.id+")";case lc:return"Context.Provider";case jc:return"StrictMode";case rc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case qc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=uc(a);var f=null;c&&(f=uc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc=Object.prototype.hasOwnProperty,zc={},Ac={};
function Bc(a){if(xc.call(Ac,a))return!0;if(xc.call(zc,a))return!1;if(wc.test(a))return Ac[a]=!0;zc[a]=!0;return!1}function Cc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Dc(a,b,c,d){if(null===b||"undefined"===typeof b||Cc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function I(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var J={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});
["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var Ec=/[\-:]([a-z])/g;function Fc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ec,
Fc);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ec,Fc);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ec,Fc);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);
function Gc(a,b,c,d){var e=J.hasOwnProperty(b)?J[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Dc(b,c,e,d)&&(c=null),d||null===e?Bc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Hc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Ic(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Jc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Kc(a,b){b=b.checked;null!=b&&Gc(a,"checked",b,!1)}
function Lc(a,b){Kc(a,b);var c=Jc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Mc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Mc(a,b.type,Jc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Nc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){b=""+a._wrapperState.initialValue;var d=a.value;c||b===d||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==c&&(a.name=c)}function Mc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Jc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Oc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Pc(a,b,c){a=H.getPooled(Oc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Qc=null,Rc=null;function Sc(a){Ia(a,!1)}function Tc(a){var b=Oa(a);if(dc(b))return a}
function Uc(a,b){if("change"===a)return b}var Vc=!1;m.canUseDOM&&(Vc=$b("input")&&(!document.documentMode||9<document.documentMode));function Wc(){Qc&&(Qc.detachEvent("onpropertychange",Xc),Rc=Qc=null)}function Xc(a){"value"===a.propertyName&&Tc(Rc)&&(a=Pc(Rc,a,Zb(a)),Wb(Sc,a))}function Yc(a,b,c){"focus"===a?(Wc(),Qc=b,Rc=c,Qc.attachEvent("onpropertychange",Xc)):"blur"===a&&Wc()}function Zc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Tc(Rc)}
function $c(a,b){if("click"===a)return Tc(b)}function ad(a,b){if("input"===a||"change"===a)return Tc(b)}
var bd={eventTypes:Oc,_isInputEventSupported:Vc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Uc:Yb(e)?Vc?f=ad:(f=Zc,g=Yc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=$c);if(f&&(f=f(a,b)))return Pc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Mc(e,"number",e.value)}},cd=H.extend({view:null,detail:null}),dd={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function ed(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=dd[a])?!!b[a]:!1}function fd(){return ed}
var gd=cd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:fd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),hd=gd.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),id={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},jd={eventTypes:id,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=gd,h=id.mouseLeave,k=id.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=hd,h=id.pointerLeave,k=id.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
c,f,b);return[h,c]}};function kd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){2!==kd(a)?A("188"):void 0}
function md(a){var b=a.alternate;if(!b)return b=kd(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return ld(e),a;if(g===d)return ld(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function nd(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function od(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var pd=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),qd=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),rd=cd.extend({relatedTarget:null});
function sd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var td={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},ud={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},vd=cd.extend({key:function(a){if(a.key){var b=td[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=sd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?ud[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:fd,charCode:function(a){return"keypress"===
a.type?sd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?sd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),wd=gd.extend({dataTransfer:null}),xd=cd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:fd}),yd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),zd=gd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Ad=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Bd={},Cd={};function Dd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Bd[a]=b;Cd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Dd(a,!0)});Ad.forEach(function(a){Dd(a,!1)});
var Ed={eventTypes:Bd,isInteractiveTopLevelEventType:function(a){a=Cd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Cd[a];if(!e)return null;switch(a){case "keypress":if(0===sd(c))return null;case "keydown":case "keyup":a=vd;break;case "blur":case "focus":a=rd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=gd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
wd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=xd;break;case fb:case gb:case hb:a=pd;break;case ib:a=yd;break;case "scroll":a=cd;break;case "wheel":a=zd;break;case "copy":case "cut":case "paste":a=qd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=hd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Fd=Ed.isInteractiveTopLevelEventType,
Gd=[];function Hd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Id=!0;function Kd(a){Id=!!a}function K(a,b){if(!b)return null;var c=(Fd(a)?Ld:Md).bind(null,a);b.addEventListener(a,c,!1)}
function Nd(a,b){if(!b)return null;var c=(Fd(a)?Ld:Md).bind(null,a);b.addEventListener(a,c,!0)}function Ld(a,b){Tb(Md,a,b)}function Md(a,b){if(Id){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(Gd.length){var d=Gd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Hd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Gd.length&&Gd.push(a)}}}
var Od={get _enabled(){return Id},setEnabled:Kd,isEnabled:function(){return Id},trapBubbledEvent:K,trapCapturedEvent:Nd,dispatchEvent:Md},Pd={},Qd=0,Rd="_reactListenersID"+(""+Math.random()).slice(2);function Sd(a){Object.prototype.hasOwnProperty.call(a,Rd)||(a[Rd]=Qd++,Pd[a[Rd]]={});return Pd[a[Rd]]}function Td(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Ud(a,b){var c=Td(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Td(c)}}function Vd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Wd=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Xd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Yd=null,Zd=null,$d=null,ae=!1;
function be(a,b){if(ae||null==Yd||Yd!==da())return null;var c=Yd;"selectionStart"in c&&Vd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return $d&&ea($d,c)?null:($d=c,a=H.getPooled(Xd.select,Zd,a,b),a.type="select",a.target=Yd,Ya(a),a)}
var ce={eventTypes:Xd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Sd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Yd=e,Zd=b,$d=null;break;case "blur":$d=Zd=Yd=null;break;case "mousedown":ae=!0;break;case "contextmenu":case "mouseup":return ae=!1,be(c,d);case "selectionchange":if(Wd)break;
case "keydown":case "keyup":return be(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:jd,ChangeEventPlugin:bd,SelectEventPlugin:ce,BeforeInputEventPlugin:Ib});
var de="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,ee=Date,fe=setTimeout,ge=clearTimeout,he=void 0;if("object"===typeof performance&&"function"===typeof performance.now){var ie=performance;he=function(){return ie.now()}}else he=function(){return ee.now()};var je=void 0,ke=void 0;
if(m.canUseDOM){var le="function"===typeof de?de:function(){A("276")},L=null,me=null,ne=-1,oe=!1,pe=!1,qe=0,re=33,se=33,te={didTimeout:!1,timeRemaining:function(){var a=qe-he();return 0<a?a:0}},ve=function(a,b){var c=a.scheduledCallback,d=!1;try{c(b),d=!0}finally{ke(a),d||(oe=!0,window.postMessage(ue,"*"))}},ue="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===ue&&(oe=!1,null!==L)){if(null!==L){var b=he();if(!(-1===
ne||ne>b)){a=-1;for(var c=[],d=L;null!==d;){var e=d.timeoutTime;-1!==e&&e<=b?c.push(d):-1!==e&&(-1===a||e<a)&&(a=e);d=d.next}if(0<c.length)for(te.didTimeout=!0,b=0,d=c.length;b<d;b++)ve(c[b],te);ne=a}}for(a=he();0<qe-a&&null!==L;)a=L,te.didTimeout=!1,ve(a,te),a=he();null===L||pe||(pe=!0,le(we))}},!1);var we=function(a){pe=!1;var b=a-qe+se;b<se&&re<se?(8>b&&(b=8),se=b<re?re:b):re=b;qe=a+se;oe||(oe=!0,window.postMessage(ue,"*"))};je=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=he()+
b.timeout);if(-1===ne||-1!==c&&c<ne)ne=c;a={scheduledCallback:a,timeoutTime:c,prev:null,next:null};null===L?L=a:(b=a.prev=me,null!==b&&(b.next=a));me=a;pe||(pe=!0,le(we));return a};ke=function(a){if(null!==a.prev||L===a){var b=a.next,c=a.prev;a.next=null;a.prev=null;null!==b?null!==c?(c.next=b,b.prev=c):(b.prev=null,L=b):null!==c?(c.next=null,me=c):me=L=null}}}else{var xe=new Map;je=function(a){var b={scheduledCallback:a,timeoutTime:0,next:null,prev:null},c=fe(function(){a({timeRemaining:function(){return Infinity},
didTimeout:!1})});xe.set(a,c);return b};ke=function(a){var b=xe.get(a.scheduledCallback);xe.delete(a);ge(b)}}function ye(a){var b="";ba.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function ze(a,b){a=p({children:void 0},b);if(b=ye(b.children))a.children=b;return a}
function Ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Be(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Ce(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function De(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Ee(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Fe(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Ge={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function He(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ie(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?He(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Je=void 0,Ke=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ge.svg||"innerHTML"in a)a.innerHTML=b;else{Je=Je||document.createElement("div");Je.innerHTML="<svg>"+b+"</svg>";for(b=Je.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Le(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Me={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ne=["Webkit","ms","Moz","O"];Object.keys(Me).forEach(function(a){Ne.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Me[b]=Me[a]})});
function Oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Me.hasOwnProperty(e)&&Me[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Pe=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Qe(a,b,c){b&&(Pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
function Re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Se=v.thatReturns("");
function Te(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Sd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Nd("scroll",a);break;case "focus":case "blur":Nd("focus",a);Nd("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Nd(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&K(e,a)}c[e]=!0}}}
function Ue(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Ge.html&&(d=He(a));d===Ge.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Ve(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function We(a,b,c,d){var e=Re(b,c);switch(b){case "iframe":case "object":K("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)K(jb[f],a);f=c;break;case "source":K("error",a);f=c;break;case "img":case "image":case "link":K("error",a);K("load",a);f=c;break;case "form":K("reset",a);K("submit",a);f=c;break;case "details":K("toggle",a);f=c;break;case "input":Ic(a,c);f=Hc(a,c);K("invalid",a);Te(d,"onChange");break;case "option":f=ze(a,c);break;case "select":Be(a,c);f=p({},c,{value:void 0});
K("invalid",a);Te(d,"onChange");break;case "textarea":De(a,c);f=Ce(a,c);K("invalid",a);Te(d,"onChange");break;default:f=c}Qe(b,f,Se);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Oe(a,k,Se):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Ke(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Le(a,k):"number"===typeof k&&Le(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Te(d,
h):null!=k&&Gc(a,h,k,e))}switch(b){case "input":cc(a);Nc(a,c,!1);break;case "textarea":cc(a);Fe(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Ae(a,!!c.multiple,b,!1):null!=c.defaultValue&&Ae(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
function Xe(a,b,c,d,e){var f=null;switch(b){case "input":c=Hc(a,c);d=Hc(a,d);f=[];break;case "option":c=ze(a,c);d=ze(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=Ce(a,c);d=Ce(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Qe(b,d,Se);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Te(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
function Ye(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Kc(a,e);Re(c,d);d=Re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Oe(a,h,Se):"dangerouslySetInnerHTML"===g?Ke(a,h):"children"===g?Le(a,h):Gc(a,g,h,d)}switch(c){case "input":Lc(a,e);break;case "textarea":Ee(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
Ae(a,!!e.multiple,e.defaultValue,!0):Ae(a,!!e.multiple,e.multiple?[]:"",!1))}}
function Ze(a,b,c,d,e){switch(b){case "iframe":case "object":K("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)K(jb[d],a);break;case "source":K("error",a);break;case "img":case "image":case "link":K("error",a);K("load",a);break;case "form":K("reset",a);K("submit",a);break;case "details":K("toggle",a);break;case "input":Ic(a,c);K("invalid",a);Te(e,"onChange");break;case "select":Be(a,c);K("invalid",a);Te(e,"onChange");break;case "textarea":De(a,c),K("invalid",a),Te(e,"onChange")}Qe(b,
c,Se);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Te(e,f)}switch(b){case "input":cc(a);Nc(a,c,!0);break;case "textarea":cc(a);Fe(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function $e(a,b){return a.nodeValue!==b}
var af={createElement:Ue,createTextNode:Ve,setInitialProperties:We,diffProperties:Xe,updateProperties:Ye,diffHydratedProperties:Ze,diffHydratedText:$e,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Lc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Lc(d,e)}}}break;case "textarea":Ee(a,c);break;case "select":b=c.value,null!=b&&Ae(a,!!c.multiple,b,!1)}}},bf=null,cf=null;function df(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function ef(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var ff=he,gf=je,hf=ke;function jf(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function kf(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var lf=[],mf=-1;function nf(a){return{current:a}}
function M(a){0>mf||(a.current=lf[mf],lf[mf]=null,mf--)}function N(a,b){mf++;lf[mf]=a.current;a.current=b}var of=nf(ha),O=nf(!1),pf=ha;function qf(a){return rf(a)?pf:of.current}
function sf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function rf(a){return 2===a.tag&&null!=a.type.childContextTypes}function tf(a){rf(a)&&(M(O,a),M(of,a))}function uf(a){M(O,a);M(of,a)}
function vf(a,b,c){of.current!==ha?A("168"):void 0;N(of,b,a);N(O,c,a)}function wf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",uc(a)||"Unknown",e);return p({},b,c)}function xf(a){if(!rf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;pf=of.current;N(of,b,a);N(O,O.current,a);return!0}
function yf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=wf(a,pf);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(of,a);N(of,d,a)}else M(O,a);N(O,b,a)}
function zf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function Af(a,b,c){var d=a.alternate;null===d?(d=new zf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Bf(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case ic:return Cf(a.children,b,c,e);case pc:f=11;b|=3;break;case jc:f=11;b|=2;break;case kc:return d=new zf(15,a,e,b|4),d.type=kc,d.expirationTime=c,d;case rc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case lc:f=13;break a;case mc:f=12;break a;case qc:f=14;break a;default:A("130",null==d?
d:typeof d,"")}f=void 0}}b=new zf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Cf(a,b,c,d){a=new zf(10,a,d,b);a.expirationTime=c;return a}function Df(a,b,c){a=new zf(6,a,null,b);a.expirationTime=c;return a}function Ef(a,b,c){b=new zf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Ff(a,b,c){b=new zf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Gf=null,Hf=null;function If(a){return function(b){try{return a(b)}catch(c){}}}
function Jf(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Gf=If(function(a){return b.onCommitFiberRoot(c,a)});Hf=If(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Kf(a){"function"===typeof Gf&&Gf(a)}function Lf(a){"function"===typeof Hf&&Hf(a)}var Mf=!1;
function Nf(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Of(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Pf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Qf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function Rf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=Nf(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=Nf(a.memoizedState),f=d.updateQueue=Nf(d.memoizedState)):e=a.updateQueue=Of(f):null===f&&(f=d.updateQueue=Of(e));null===f||e===f?Qf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Qf(e,b,c),Qf(f,b,c)):(Qf(e,b,c),f.lastUpdate=b)}
function Sf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=Nf(a.memoizedState):Tf(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Tf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Of(b));return b}
function Uf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Mf=!0}return d}
function Vf(a,b,c,d,e){Mf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Tf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Uf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
g&&(f=n)),0===h||h>w)h=w}else n=Uf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
function Wf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
function Xf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Wf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Wf(b,c)),a=a.nextEffect}
function Yf(a,b){return{value:a,source:b,stack:vc(b)}}var Zf=nf(null),$f=nf(null),ag=nf(0);function bg(a){var b=a.type._context;N(ag,b._changedBits,a);N($f,b._currentValue,a);N(Zf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function cg(a){var b=ag.current,c=$f.current;M(Zf,a);M($f,a);M(ag,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var dg={},eg=nf(dg),fg=nf(dg),gg=nf(dg);function hg(a){a===dg?A("174"):void 0;return a}
function jg(a,b){N(gg,b,a);N(fg,a,a);N(eg,dg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ie(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Ie(b,c)}M(eg,a);N(eg,b,a)}function kg(a){M(eg,a);M(fg,a);M(gg,a)}function lg(a){fg.current===a&&(M(eg,a),M(fg,a))}function mg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var qg={isMounted:function(a){return(a=a._reactInternalFiber)?2===kd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=ng();d=og(d,a);var e=Pf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Rf(a,e,d);pg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=ng();d=og(d,a);var e=Pf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Rf(a,e,d);pg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=ng();c=og(c,a);var d=Pf(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Rf(a,d,c);pg(a,c)}};function rg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
function sg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&qg.enqueueReplaceState(b,b.state,null)}
function tg(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=qf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=sf(a,f);f=a.updateQueue;null!==f&&(Vf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(mg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&qg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Vf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var ug=Array.isArray;
function vg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
function wg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function xg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Af(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Df(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=vg(a,b,c),d.return=a,d;d=Bf(c,a.mode,d);d.ref=vg(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Ef(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=Cf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Df(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case gc:return c=Bf(b,a.mode,c),c.ref=vg(a,null,b),c.return=a,c;case hc:return b=Ef(b,a.mode,c),b.return=a,b}if(ug(b)||tc(b))return b=Cf(b,a.mode,c,null),b.return=
a,b;wg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case gc:return c.key===e?c.type===ic?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case hc:return c.key===e?n(a,b,c,d):null}if(ug(c)||tc(c))return null!==e?null:r(a,b,c,d,null);wg(a,c)}return null}function nc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case gc:return a=a.get(null===d.key?c:d.key)||null,d.type===ic?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case hc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(ug(d)||tc(d))return a=a.get(c)||null,r(b,a,d,e,null);wg(b,d)}return null}function Jd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=nc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var u=tc(h);"function"!==typeof u?A("150"):void 0;h=u.call(h);null==h?A("151"):void 0;for(var t=u=null,n=g,x=
g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===t?u=r:t.sibling=r;t=r;n=y}if(l.done)return c(e,n),u;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===t?u=l:t.sibling=l,t=l);return u}for(n=d(e,n);!l.done;x++,l=h.next())l=nc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
t?u=l:t.sibling=l,t=l);a&&n.forEach(function(a){return b(e,a)});return u}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ic&&null===f.key;k&&(f=f.props.children);var n="object"===typeof f&&null!==f;if(n)switch(f.$$typeof){case gc:a:{n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===ic:k.type===f.type){c(a,k.sibling);d=e(k,f.type===ic?f.props.children:f.props,h);d.ref=vg(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===ic?(d=Cf(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=Bf(f,a.mode,h),h.ref=vg(a,d,f),h.return=a,a=h)}return g(a);case hc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Ef(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=Df(f,a.mode,h),d.return=a,a=d),g(a);if(ug(f))return Jd(a,d,f,h);if(tc(f))return E(a,d,f,h);n&&wg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var yg=xg(!0),zg=xg(!1),Ag=null,Bg=null,Cg=!1;function Dg(a,b){var c=new zf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Eg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Fg(a){if(Cg){var b=Bg;if(b){var c=b;if(!Eg(a,b)){b=jf(c);if(!b||!Eg(a,b)){a.effectTag|=2;Cg=!1;Ag=a;return}Dg(Ag,c)}Ag=a;Bg=kf(b)}else a.effectTag|=2,Cg=!1,Ag=a}}
function Gg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;Ag=a}function Hg(a){if(a!==Ag)return!1;if(!Cg)return Gg(a),Cg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!ef(b,a.memoizedProps))for(b=Bg;b;)Dg(a,b),b=jf(b);Gg(a);Bg=Ag?jf(a.stateNode):null;return!0}function Ig(){Bg=Ag=null;Cg=!1}function Q(a,b,c){Jg(a,b,c,b.expirationTime)}function Jg(a,b,c,d){b.child=null===a?zg(b,null,c,d):yg(b,a.child,c,d)}
function Kg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Lg(a,b,c,d,e){Kg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&yf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Jg(a,b,null,e),b.child=null);Jg(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&yf(b,!0);return b.child}
function Mg(a){var b=a.stateNode;b.pendingContext?vf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&vf(a,b.context,!1);jg(a,b.containerInfo)}
function Ng(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function Rg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,bg(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b)}else Ng(b,d,h,c)}b.stateNode=h;bg(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=Af(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Af(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Sg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Mg(b);break;case 2:xf(b);break;case 4:jg(b,b.stateNode.containerInfo);break;case 13:bg(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=qf(b);f=sf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&mg(b,f,e),e=xf(b),d.updater=qg,b.stateNode=d,d._reactInternalFiber=b,tg(b,c),a=Lg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=qf(b),d=sf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=xf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=qf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?sf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=qg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);tg(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=qf(b);g=sf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(k!==f||n!==g)&&sg(b,d,f,g);Mf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Vf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Mf?("function"===typeof r&&(mg(b,r,f),n=b.memoizedState),(k=Mf||rg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=qf(b),g=sf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==k||n!==g)&&sg(b,d,k,g),Mf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Vf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Mf?("function"===typeof r&&(mg(b,r,k),w=b.memoizedState),(r=Mf||rg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Lg(a,b,d,e,c);case 3:Mg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Vf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Ig(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)Bg=kf(b.stateNode.containerInfo),Ag=b,d=Cg=!0;d?(b.effectTag|=2,b.child=zg(b,null,e,c)):(Ig(),Q(a,b,e));a=b.child}else Ig(),a=R(a,b);return a;case 5:a:{hg(gg.current);e=hg(eg.current);d=Ie(e,
b.type);e!==d&&(N(fg,b,b),N(eg,d,b));null===a&&Fg(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;ef(e,d)?k=null:f&&ef(e,f)&&(b.effectTag|=16);Kg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Fg(b),b.memoizedProps=b.pendingProps,
null;case 16:return null;case 4:return jg(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=yg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Rg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Ng(b,d,g,c);else if(k===f){a=
R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Tg(a){a.effectTag|=4}var Ug=void 0,Vg=void 0,Wg=void 0;Ug=function(){};Vg=function(a,b,c){(b.updateQueue=c)&&Tg(b)};Wg=function(a,b,c,d){c!==d&&Tg(b)};
function Xg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return tf(b),null;case 3:kg(b);uf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Hg(b),b.effectTag&=-3;Ug(b);return null;case 5:lg(b);d=hg(gg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=hg(eg.current);g=Xe(g,e,f,c,d);Vg(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
A("166"):void 0,null;a=hg(eg.current);if(Hg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ze(c,e,f,a,d),b.updateQueue=d,null!==d&&Tg(b);else{a=Ue(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}We(a,e,c,d);df(e,c)&&Tg(b);b.stateNode=
a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Wg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=hg(gg.current);hg(eg.current);Hg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,$e(d,c)&&Tg(b)):(d=Ve(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return kg(b),Ug(b),null;case 13:return cg(b),null;case 12:return null;case 0:A("167");
default:A("156")}}function Yg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&uc(c);b=b.value;null!==a&&2===a.tag&&uc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Zg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){$g(a,c)}else b.current=null}
function ah(a){"function"===typeof Lf&&Lf(a);switch(a.tag){case 2:Zg(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){$g(a,c)}break;case 5:Zg(a);break;case 4:bh(a)}}function ch(a){return 5===a.tag||3===a.tag||4===a.tag}
function dh(a){a:{for(var b=a.return;null!==b;){if(ch(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Le(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||ch(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function bh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(ah(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:ah(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function eh(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Ye(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function fh(a,b,c){c=Pf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gh(d);Yg(a,b)};return c}
function hh(a,b,c){c=Pf(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===ih?ih=new Set([this]):ih.add(this);var c=b.value,d=b.stack;Yg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function jh(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Yf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=fh(a,d,f);Sf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===ih||!ih.has(c))){a.effectTag|=1024;d=hh(a,b,f);Sf(a,d,f);return}}a=a.return}while(null!==a)}
function kh(a){switch(a.tag){case 2:tf(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return kg(a),uf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return lg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return kg(a),null;case 13:return cg(a),null;default:return null}}var lh=ff(),mh=2,nh=lh,oh=0,ph=0,qh=!1,S=null,rh=null,T=0,sh=-1,th=!1,U=null,uh=!1,vh=!1,ih=null;
function wh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:tf(b);break;case 3:kg(b);uf(b);break;case 5:lg(b);break;case 4:kg(b);break;case 13:cg(b)}a=a.return}rh=null;T=0;sh=-1;th=!1;S=null;vh=!1}
function xh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Xg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{vh=!0;break}}else{a=kh(a,th,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function yh(a){var b=Sg(a.alternate,a,T);null===b&&(b=xh(a));ec.current=null;return b}
function zh(a,b,c){qh?A("243"):void 0;qh=!0;if(b!==T||a!==rh||null===S)wh(),rh=a,T=b,sh=-1,S=Af(rh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;th=!c||T<=mh;do{try{if(c)for(;null!==S&&!Ah();)S=yh(S);else for(;null!==S;)S=yh(S)}catch(f){if(null===S)d=!0,gh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;gh(f);break}jh(a,e,c,f,th,T,nh);S=xh(c)}}break}while(1);qh=!1;if(d)return null;if(null===S){if(vh)return a.pendingCommitExpirationTime=b,a.current.alternate;th?A("262"):
void 0;0<=sh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&Bh(a,b)},sh);Ch(a.current.expirationTime)}return null}
function $g(a,b){var c;a:{qh&&!uh?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===ih||!ih.has(d))){a=Yf(b,a);a=hh(c,a,1);Rf(c,a,1);pg(c,1);c=void 0;break a}break;case 3:a=Yf(b,a);a=fh(c,a,1);Rf(c,a,1);pg(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Yf(b,a),c=fh(a,c,1),Rf(a,c,1),pg(a,1));c=void 0}return c}
function Dh(){var a=2+25*(((ng()-2+500)/25|0)+1);a<=oh&&(a=oh+1);return oh=a}function og(a,b){a=0!==ph?ph:qh?uh?1:T:b.mode&1?Eh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;Eh&&(0===Fh||a>Fh)&&(Fh=a);return a}
function pg(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!qh&&0!==T&&b<T&&wh();var d=c.current.expirationTime;qh&&!uh&&rh===c||Bh(c,d);Gh>Hh&&A("185")}else break;a=a.return}}function ng(){nh=ff()-lh;return mh=(nh/10|0)+2}
function Ih(a){var b=ph;ph=2+25*(((ng()-2+500)/25|0)+1);try{return a()}finally{ph=b}}function Jh(a,b,c,d,e){var f=ph;ph=1;try{return a(b,c,d,e)}finally{ph=f}}var Kh=null,V=null,Lh=0,Mh=void 0,W=!1,X=null,Y=0,Fh=0,Nh=!1,Oh=!1,Ph=null,Qh=null,Z=!1,Rh=!1,Eh=!1,Sh=null,Hh=1E3,Gh=0,Th=1;function Uh(a){if(0!==Lh){if(a>Lh)return;null!==Mh&&hf(Mh)}var b=ff()-lh;Lh=a;Mh=gf(Vh,{timeout:10*(a-2)-b})}
function Bh(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Kh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Kh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Rh&&(X=a,Y=1,Wh(a,1,!1)):1===b?Xh():Uh(b))}
function Yh(){var a=0,b=null;if(null!==V)for(var c=V,d=Kh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Kh=V=d.nextScheduledRoot=null;break}else if(d===Kh)Kh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Kh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Gh++:Gh=0;X=b;Y=a}function Vh(a){Zh(0,!0,a)}function Xh(){Zh(1,!1,null)}function Zh(a,b,c){Qh=c;Yh();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Nh||ng()>=Y);)ng(),Wh(X,Y,!Nh),Yh();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Wh(X,Y,!1),Yh();null!==Qh&&(Lh=0,Mh=null);0!==Y&&Uh(Y);Qh=null;Nh=!1;$h()}function ai(a,b){W?A("253"):void 0;X=a;Y=b;Wh(a,b,!1);Xh();$h()}
function $h(){Gh=0;if(null!==Sh){var a=Sh;Sh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Oh||(Oh=!0,Ph=d)}}}if(Oh)throw a=Ph,Ph=null,Oh=!1,a;}function Wh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?bi(a,c,b):(c=zh(a,b,!0),null!==c&&(Ah()?a.finishedWork=c:bi(a,c,b)))):(c=a.finishedWork,null!==c?bi(a,c,b):(c=zh(a,b,!1),null!==c&&bi(a,c,b)));W=!1}
function bi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Sh?Sh=[d]:Sh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;uh=qh=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;ng();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;bf=Id;var f=da();if(Vd(f)){if("selectionStart"in
f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,nc=0,Jd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
++nc===k&&(w=r);t===n&&++Jd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;cf={focusedElem:f,selectionRange:g};Kd(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var ni=ja.getSnapshotBeforeUpdate(y,
D);ja.__reactInternalSnapshotBeforeUpdate=ni}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,$g(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Le(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:dh(U);U.effectTag&=-3;break;case 6:dh(U);U.effectTag&=-3;eh(U.alternate,
U);break;case 4:eh(U.alternate,U);break;case 8:D=U,bh(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,$g(U,y),null!==U&&(U=U.nextEffect))}l=cf;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){null!==u&&Vd(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Ud(q,l),D=Ud(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
top:l.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}cf=null;Kd(bf);bf=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var ig=U.effectTag;if(ig&36){var oc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ca=l.stateNode;if(l.effectTag&4)if(null===oc)ca.props=l.memoizedProps,ca.state=l.memoizedState,ca.componentDidMount();else{var xi=oc.memoizedProps,yi=oc.memoizedState;ca.props=l.memoizedProps;
ca.state=l.memoizedState;ca.componentDidUpdate(xi,yi,ca.__reactInternalSnapshotBeforeUpdate)}var Og=l.updateQueue;null!==Og&&(ca.props=l.memoizedProps,ca.state=l.memoizedState,Xf(l,Og,ca,u));break;case 3:var Pg=l.updateQueue;if(null!==Pg){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Xf(l,Pg,y,u)}break;case 5:var zi=l.stateNode;null===oc&&l.effectTag&4&&df(l.type,l.memoizedProps)&&zi.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;
default:A("163")}}if(ig&128){l=void 0;var yc=U.ref;if(null!==yc){var Qg=U.stateNode;switch(U.tag){case 5:l=Qg;break;default:l=Qg}"function"===typeof yc?yc(l):yc.current=l}}var Ai=U.nextEffect;U.nextEffect=null;U=Ai}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,$g(U,q),null!==U&&(U=U.nextEffect))}qh=uh=!1;"function"===typeof Kf&&Kf(b.stateNode);b=c.current.expirationTime;0===b&&(ih=null);a.remainingExpirationTime=b}function Ah(){return null===Qh||Qh.timeRemaining()>Th?!1:Nh=!0}
function gh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Oh||(Oh=!0,Ph=a)}function Ch(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function ci(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Xh()}}function di(a,b){if(Z&&!Rh){Rh=!0;try{return a(b)}finally{Rh=!1}}return a(b)}function ei(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Jh(a,b)}finally{Z=c,Xh()}}
function fi(a,b,c){if(Eh)return a(b,c);Z||W||0===Fh||(Zh(Fh,!1,null),Fh=0);var d=Eh,e=Z;Z=Eh=!0;try{return a(b,c)}finally{Eh=d,(Z=e)||W||Xh()}}function gi(a){var b=Z;Z=!0;try{Jh(a)}finally{(Z=b)||W||Zh(1,!1,null)}}
function hi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===kd(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(rf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=rf(c)?wf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Pf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Rf(f,e,d);pg(f,d);return d}
function ii(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=nd(b);return null===a?null:a.stateNode}function ji(a,b,c,d){var e=b.current,f=ng();e=og(f,e);return hi(a,b,c,e,d)}function ki(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
function li(a){var b=a.findFiberByHostInstance;return Jf(p({},a,{findHostInstanceByFiber:function(a){a=nd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
var mi={updateContainerAtExpirationTime:hi,createContainer:function(a,b,c){return Ff(a,b,c)},updateContainer:ji,flushRoot:ai,requestWork:Bh,computeUniqueAsyncExpiration:Dh,batchedUpdates:ci,unbatchedUpdates:di,deferredUpdates:Ih,syncUpdates:Jh,interactiveUpdates:fi,flushInteractiveUpdates:function(){W||0===Fh||(Zh(Fh,!1,null),Fh=0)},flushControlled:gi,flushSync:ei,getPublicRootInstance:ki,findHostInstance:ii,findHostInstanceWithNoPortals:function(a){a=od(a);return null===a?null:a.stateNode},injectIntoDevTools:li};
function oi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:hc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent(af);function pi(a){this._expirationTime=Dh();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}
pi.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new qi;hi(a,b,null,c,d._onCommit);return d};pi.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
pi.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;ai(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};pi.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function qi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}qi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
qi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function ri(a,b,c){this._internalRoot=Ff(a,b,c)}ri.prototype.render=function(a,b){var c=this._internalRoot,d=new qi;b=void 0===b?null:b;null!==b&&d.then(b);ji(a,c,null,d._onCommit);return d};
ri.prototype.unmount=function(a){var b=this._internalRoot,c=new qi;a=void 0===a?null:a;null!==a&&c.then(a);ji(null,b,null,c._onCommit);return c};ri.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new qi;c=void 0===c?null:c;null!==c&&e.then(c);ji(b,d,a,e._onCommit);return e};
ri.prototype.createBatch=function(){var a=new pi(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function si(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=mi.batchedUpdates;Tb=mi.interactiveUpdates;Ub=mi.flushInteractiveUpdates;
function ti(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new ri(a,!1,b)}
function ui(a,b,c,d,e){si(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ki(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=ti(c,d);if("function"===typeof e){var h=e;e=function(){var a=ki(f._internalRoot);h.call(a)}}di(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ki(f._internalRoot)}
function vi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;si(b)?void 0:A("200");return oi(a,b,null,c)}
var wi={createPortal:vi,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:ii(a)},hydrate:function(a,b,c){return ui(null,a,b,!0,c)},render:function(a,b,c){return ui(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return ui(a,b,c,!1,d)},unmountComponentAtNode:function(a){si(a)?void 0:A("40");return a._reactRootContainer?(di(function(){ui(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return vi.apply(void 0,
arguments)},unstable_batchedUpdates:ci,unstable_deferredUpdates:Ih,unstable_interactiveUpdates:fi,flushSync:ei,unstable_flushControlled:gi,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Od},unstable_createRoot:function(a,b){return new ri(a,!0,null!=b&&!0===b.hydrate)}};li({findFiberByHostInstance:Na,bundleType:0,version:"16.4.2",rendererPackageName:"react-dom"});
var Bi={default:wi},Ci=Bi&&wi||Bi;module.exports=Ci.default?Ci.default:Ci;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(345);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(346);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(114);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(349);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(176);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(176);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(113);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(114);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(357);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(115);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(177);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(361);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(363);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(181);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(365);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(115);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(367);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(116);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(181);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(116);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(371);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(179);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DefaultLayout__ = __webpack_require__(182);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DefaultLayout__["a"]; });


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(383);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 383 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared__ = __webpack_require__(78);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  display: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hidden: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  offCanvas: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps = {
  tag: 'aside',
  display: '',
  fixed: false,
  hidden: false,
  isOpen: false,
  offCanvas: true
};

var AppAside = function (_Component) {
  _inherits(AppAside, _Component);

  function AppAside(props) {
    _classCallCheck(this, AppAside);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.isFixed = _this.isFixed.bind(_this);
    _this.isHidden = _this.isHidden.bind(_this);
    _this.isOffCanvas = _this.isOffCanvas.bind(_this);
    _this.displayBreakpoint = _this.displayBreakpoint.bind(_this);
    return _this;
  }

  AppAside.prototype.componentDidMount = function componentDidMount() {
    this.isFixed(this.props.fixed);
    this.isHidden(this.props.hidden);
    this.isOffCanvas(this.props.offCanvas);
    this.displayBreakpoint(this.props.display);
  };

  AppAside.prototype.isHidden = function isHidden(hidden) {
    if (hidden) {
      document.body.classList.add('aside-menu-hidden');
    }
  };

  AppAside.prototype.isFixed = function isFixed(fixed) {
    if (fixed) {
      document.body.classList.add('aside-menu-fixed');
    }
  };

  AppAside.prototype.isOffCanvas = function isOffCanvas(offCanvas) {
    if (offCanvas) {
      document.body.classList.add('aside-menu-off-canvas');
    }
  };

  AppAside.prototype.displayBreakpoint = function displayBreakpoint(display) {
    var cssTemplate = 'aside-menu-' + display + '-show';
    var _asideMenuCssClasses$ = __WEBPACK_IMPORTED_MODULE_3__Shared__["a" /* asideMenuCssClasses */][0],
        cssClass = _asideMenuCssClasses$[0];

    if (display && __WEBPACK_IMPORTED_MODULE_3__Shared__["a" /* asideMenuCssClasses */].indexOf(cssTemplate) > -1) {
      cssClass = cssTemplate;
    }
    document.body.classList.add(cssClass);
  };

  AppAside.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        Tag = _props.tag,
        attributes = _objectWithoutProperties(_props, ['className', 'children', 'tag']);

    delete attributes.display;
    delete attributes.fixed;
    delete attributes.hidden;
    delete attributes.offCanvas;
    delete attributes.isOpen;

    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'aside-menu');

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({}, attributes, { className: classes }),
      children
    );
  };

  return AppAside;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AppAside.propTypes =  false ? propTypes : {};
AppAside.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (AppAside);

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sidebarCssClasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asideMenuCssClasses; });
var sidebarCssClasses = ['sidebar-show', 'sidebar-sm-show', 'sidebar-md-show', 'sidebar-lg-show', 'sidebar-xl-show'];

var asideMenuCssClasses = ['aside-menu-show', 'aside-menu-sm-show', 'aside-menu-md-show', 'aside-menu-lg-show', 'aside-menu-xl-show'];

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_index__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_toggle_classes__ = __webpack_require__(184);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  display: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  mobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps = {
  display: 'lg',
  mobile: false,
  tag: 'button',
  type: 'button'
};

var AppAsideToggler = function (_Component) {
  _inherits(AppAsideToggler, _Component);

  function AppAsideToggler(props) {
    _classCallCheck(this, AppAsideToggler);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.asideToggle = _this.asideToggle.bind(_this);

    _this.state = {};
    return _this;
  }

  AppAsideToggler.prototype.asideToggle = function asideToggle(e) {
    e.preventDefault();

    if (this.props.mobile) {
      document.body.classList.toggle('aside-menu-show');
    } else {
      var display = this.props.display;
      var cssTemplate = 'aside-menu-' + display + '-show';
      var _asideMenuCssClasses$ = __WEBPACK_IMPORTED_MODULE_3__Shared_index__["a" /* asideMenuCssClasses */][0],
          cssClass = _asideMenuCssClasses$[0];

      if (display && __WEBPACK_IMPORTED_MODULE_3__Shared_index__["a" /* asideMenuCssClasses */].indexOf(cssTemplate) > -1) {
        cssClass = cssTemplate;
      }
      Object(__WEBPACK_IMPORTED_MODULE_4__Shared_toggle_classes__["a" /* default */])(cssClass, __WEBPACK_IMPORTED_MODULE_3__Shared_index__["a" /* asideMenuCssClasses */]);
    }
  };

  AppAsideToggler.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        className = _props.className,
        children = _props.children,
        type = _props.type,
        Tag = _props.tag,
        attributes = _objectWithoutProperties(_props, ['className', 'children', 'type', 'tag']);

    delete attributes.display;
    delete attributes.mobile;
    delete attributes.display;

    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-toggler');

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({
        type: type,
        className: classes
      }, attributes, {
        onClick: function onClick(event) {
          return _this2.asideToggle(event);
        }
      }),
      children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'navbar-toggler-icon' })
    );
  };

  return AppAsideToggler;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AppAsideToggler.propTypes =  false ? propTypes : {};
AppAsideToggler.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (AppAsideToggler);

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var routes = void 0;

var getPaths = function getPaths(pathname) {
  var paths = ['/'];

  if (pathname === '/') return paths;

  pathname.split('/').reduce(function (prev, curr) {
    var currPath = prev + '/' + curr;
    paths.push(currPath);
    return currPath;
  });
  return paths;
};

var findRouteName = function findRouteName(url) {
  var aroute = routes.find(function (route) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* matchPath */])(url, { path: route.path, exact: route.exact });
  });
  return aroute && aroute.name ? aroute.name : null;
};

var BreadcrumbsItem = function BreadcrumbsItem(_ref) {
  var match = _ref.match;

  var routeName = findRouteName(match.url);
  if (routeName) {
    return match.isExact ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_reactstrap__["BreadcrumbItem"],
      { active: true },
      routeName
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_reactstrap__["BreadcrumbItem"],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],
        { to: match.url || '' },
        routeName
      )
    );
  }
  return null;
};

BreadcrumbsItem.propTypes =  false ? {
  match: PropTypes.shape({
    url: PropTypes.string
  })
} : {};

var Breadcrumbs = function Breadcrumbs(args) {
  var paths = getPaths(args.location.pathname);
  var items = paths.map(function (path, i) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { key: i.toString(), path: path, component: BreadcrumbsItem });
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_reactstrap__["Breadcrumb"],
    null,
    items
  );
};

var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  appRoutes: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
  tag: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string])
};

var defaultProps = {
  tag: 'div',
  className: '',
  appRoutes: [{ path: '/', exact: true, name: 'Home', component: null }]
};

var AppBreadcrumb = function (_Component) {
  _inherits(AppBreadcrumb, _Component);

  function AppBreadcrumb(props) {
    _classCallCheck(this, AppBreadcrumb);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = { routes: props.appRoutes };
    routes = _this.state.routes;
    return _this;
  }

  AppBreadcrumb.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        Tag = _props.tag,
        attributes = _objectWithoutProperties(_props, ['className', 'tag']);

    delete attributes.children;
    delete attributes.appRoutes;

    var classes = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      { className: classes },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], _extends({ path: '/:path', component: Breadcrumbs }, attributes))
    );
  };

  return AppBreadcrumb;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AppBreadcrumb.propTypes =  false ? propTypes : {};
AppBreadcrumb.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (AppBreadcrumb);

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    nullTag = '[object Null]',
    proxyTag = '[object Proxy]',
    undefinedTag = '[object Undefined]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isFunction;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)))

/***/ }),
/* 389 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Manager.childContextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Manager.propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Manager.defaultProps = {
  tag: 'div'
};


/* harmony default export */ __webpack_exports__["a"] = (Manager);

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Target.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* harmony default export */ __webpack_exports__["a"] = (Target);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return placements; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_popper_js__ = __webpack_require__(393);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var placements = __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */].placements;

var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      if (_this.props.target) {
        return _this.props.target;
      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
      }
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;


      if (!_this._popper || !data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      return _extends({
        position: data.offsets.popper.position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _this._handlePopperRef = function (node) {
      _this._popperNode = node;
      if (node) {
        _this._createPopper();
      } else {
        _this._destroyPopper();
      }
      if (_this.props.innerRef) {
        _this.props.innerRef(node);
      }
    }, _this._scheduleUpdate = function () {
      _this._popper && _this._popper.scheduleUpdate();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
        this._destroyPopper();
        this._createPopper();
      }
      if (lastProps.children !== this.props.children) {
        this._scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _this2 = this;

      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled,
          positionFixed = _props.positionFixed;

      var modifiers = _extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });
      if (this._arrowNode) {
        modifiers.arrow = _extends({}, this.props.modifiers.arrow || {}, {
          element: this._arrowNode
        });
      }
      this._popper = new __WEBPACK_IMPORTED_MODULE_2_popper_js__["a" /* default */](this._getTargetNode(), this._popperNode, {
        placement: placement,
        positionFixed: positionFixed,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
      setTimeout(function () {
        return _this2._scheduleUpdate();
      });
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          positionFixed = _props2.positionFixed,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'positionFixed', 'modifiers', 'children']);

      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var popperProps = {
          ref: this._handlePopperRef,
          style: popperStyle,
          'data-placement': popperPlacement,
          'data-x-out-of-boundaries': popperHide
        };
        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: this._scheduleUpdate
        });
      }

      var componentProps = _extends({}, restProps, {
        style: _extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = this._handlePopperRef;
      } else {
        componentProps.innerRef = this._handlePopperRef;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
    }
  }]);

  return Popper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Popper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
Popper.childContextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Popper.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(placements),
  eventsEnabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  positionFixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([
  // the following check is needed for SSR
  __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(typeof Element !== 'undefined' ? Element : Object), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    getBoundingClientRect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    clientWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    clientHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  positionFixed: false,
  modifiers: {}
};


/* harmony default export */ __webpack_exports__["a"] = (Popper);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.3
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
}

function getWindowSizes() {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && parent.nodeName === 'HTML') {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  boundaries.left += padding;
  boundaries.top += padding;
  boundaries.right -= padding;
  boundaries.bottom -= padding;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroy the popper
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger onUpdate callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // Avoid blurry text by using full pixel integers.
  // For pixel-perfect positioning, top/bottom prefers rounded
  // values, while left/right prefers floored values.
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.round(popper.top),
    bottom: Math.round(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    top = -offsetParentRect.height + offsets.bottom;
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    left = -offsetParentRect.width + offsets.right;
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjuction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-right` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unitless, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the height.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * An scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper this makes sure the popper has always a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier, can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near eachothers
   * without leaving any gap between the two. Expecially useful when the arrow is
   * enabled and you want to assure it to point to its reference element.
   * It cares only about the first axis, you can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjuction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations).
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position,
     * the popper will never be placed outside of the defined boundaries
     * (except if keepTogether is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define you own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the informations used by Popper.js
 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overriden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass as 3rd argument an object with the same
 * structure of this object, example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated, this callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Create a new Popper.js instance
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as popper.
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedule an update, it will run on the next UI update available
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(45)))

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps, {
    style: _extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

Arrow.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};

/* harmony default export */ __webpack_exports__["a"] = (Arrow);

/***/ }),
/* 395 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps = {
  tag: 'footer',
  fixed: false
};

var AppFooter = function (_Component) {
  _inherits(AppFooter, _Component);

  function AppFooter(props) {
    _classCallCheck(this, AppFooter);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.isFixed = _this.isFixed.bind(_this);
    return _this;
  }

  AppFooter.prototype.componentDidMount = function componentDidMount() {
    this.isFixed(this.props.fixed);
  };

  AppFooter.prototype.isFixed = function isFixed(fixed) {
    if (fixed) {
      document.body.classList.add('footer-fixed');
    }
  };

  AppFooter.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        Tag = _props.tag,
        attributes = _objectWithoutProperties(_props, ['className', 'children', 'tag']);

    delete attributes.fixed;

    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'app-footer');

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({ className: classes }, attributes),
      children
    );
  };

  return AppFooter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AppFooter.propTypes =  false ? propTypes : {};
AppFooter.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (AppFooter);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  fixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps = {
  tag: 'header',
  fixed: false
};

var AppHeader = function (_Component) {
  _inherits(AppHeader, _Component);

  function AppHeader() {
    _classCallCheck(this, AppHeader);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  AppHeader.prototype.componentDidMount = function componentDidMount() {
    this.isFixed(this.props.fixed);
  };

  AppHeader.prototype.isFixed = function isFixed(fixed) {
    if (fixed) {
      document.body.classList.add('header-fixed');
    }
  };

  // breakpoint(breakpoint) {
  //   return breakpoint || '';
  // }

  AppHeader.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        Tag = _props.tag,
        attributes = _objectWithoutProperties(_props, ['className', 'children', 'tag']);

    delete attributes.fixed;

    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'app-header', 'navbar');

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({ className: classes }, attributes),
      children
    );
  };

  return AppHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AppHeader.propTypes =  false ? propTypes : {};
AppHeader.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (AppHeader);

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
  direction: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var defaultProps = {
  direction: 'down'
};

var AppHeaderDropdown = function (_Component) {
  _inherits(AppHeaderDropdown, _Component);

  function AppHeaderDropdown(props) {
    _classCallCheck(this, AppHeaderDropdown);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.toggle = _this.toggle.bind(_this);
    _this.state = {
      dropdownOpen: false
    };
    return _this;
  }

  AppHeaderDropdown.prototype.toggle = function toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  };

  AppHeaderDropdown.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        attributes = _objectWithoutProperties(_props, ['children']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_reactstrap__["Dropdown"],
      _extends({ nav: true, isOpen: this.state.dropdownOpen, toggle: this.toggle }, attributes),
      children
    );
  };

  return AppHeaderDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AppHeaderDropdown.propTypes =  false ? propTypes : {};
AppHeaderDropdown.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (AppHeaderDropdown);

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  brand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  full: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  minimized: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps = {
  tag: 'a'
};

var AppNavbarBrand = function (_Component) {
  _inherits(AppNavbarBrand, _Component);

  function AppNavbarBrand() {
    _classCallCheck(this, AppNavbarBrand);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  AppNavbarBrand.prototype.imgSrc = function imgSrc(brand) {
    return brand.src ? brand.src : '';
  };

  AppNavbarBrand.prototype.imgWidth = function imgWidth(brand) {
    return brand.width ? brand.width : 'auto';
  };

  AppNavbarBrand.prototype.imgHeight = function imgHeight(brand) {
    return brand.height ? brand.height : 'auto';
  };

  AppNavbarBrand.prototype.imgAlt = function imgAlt(brand) {
    return brand.alt ? brand.alt : '';
  };

  AppNavbarBrand.prototype.navbarBrandImg = function navbarBrandImg(props, classBrand, key) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
      src: this.imgSrc(props),
      width: this.imgWidth(props),
      height: this.imgHeight(props),
      alt: this.imgAlt(props),
      className: classBrand,
      key: key.toString()
    });
  };

  AppNavbarBrand.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        Tag = _props.tag,
        attributes = _objectWithoutProperties(_props, ['className', 'children', 'tag']);

    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-brand');

    var img = [];
    if (this.props.brand) {
      var props = this.props.brand;
      var classBrand = 'navbar-brand';
      img.push(this.navbarBrandImg(props, classBrand, img.length + 1));
    }
    if (this.props.full) {
      var _props2 = this.props.full;
      var _classBrand = 'navbar-brand-full';
      img.push(this.navbarBrandImg(_props2, _classBrand, img.length + 1));
    }
    if (this.props.minimized) {
      var _props3 = this.props.minimized;
      var _classBrand2 = 'navbar-brand-minimized';
      img.push(this.navbarBrandImg(_props3, _classBrand2, img.length + 1));
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({}, attributes, { className: classes }),
      children || img
    );
  };

  return AppNavbarBrand;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AppNavbarBrand.propTypes =  false ? propTypes : {};
AppNavbarBrand.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (AppNavbarBrand);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared__ = __webpack_require__(78);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  compact: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  display: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  fixed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  minimized: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  offCanvas: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  staticContext: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  tag: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string])
};

var defaultProps = {
  tag: 'div',
  compact: false,
  display: '',
  fixed: false,
  minimized: false,
  isOpen: false,
  offCanvas: false
};

var AppSidebar = function (_Component) {
  _inherits(AppSidebar, _Component);

  function AppSidebar(props) {
    _classCallCheck(this, AppSidebar);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.isCompact = _this.isCompact.bind(_this);
    _this.isFixed = _this.isFixed.bind(_this);
    _this.isMinimized = _this.isMinimized.bind(_this);
    _this.isOffCanvas = _this.isOffCanvas.bind(_this);
    _this.displayBreakpoint = _this.displayBreakpoint.bind(_this);
    return _this;
  }

  AppSidebar.prototype.componentDidMount = function componentDidMount() {
    this.displayBreakpoint(this.props.display);
    this.isCompact(this.props.compact);
    this.isFixed(this.props.fixed);
    this.isMinimized(this.props.minimized);
    this.isOffCanvas(this.props.offCanvas);
  };

  AppSidebar.prototype.isCompact = function isCompact(compact) {
    if (compact) {
      document.body.classList.add('sidebar-compact');
    }
  };

  AppSidebar.prototype.isFixed = function isFixed(fixed) {
    if (fixed) {
      document.body.classList.add('sidebar-fixed');
    }
  };

  AppSidebar.prototype.isMinimized = function isMinimized(minimized) {
    if (minimized) {
      document.body.classList.add('sidebar-minimized');
    }
  };

  AppSidebar.prototype.isOffCanvas = function isOffCanvas(offCanvas) {
    if (offCanvas) {
      document.body.classList.add('sidebar-off-canvas');
    }
  };

  AppSidebar.prototype.displayBreakpoint = function displayBreakpoint(display) {
    var cssTemplate = 'sidebar-' + display + '-show';
    var _sidebarCssClasses$ = __WEBPACK_IMPORTED_MODULE_3__Shared__["b" /* sidebarCssClasses */][0],
        cssClass = _sidebarCssClasses$[0];

    if (display && __WEBPACK_IMPORTED_MODULE_3__Shared__["b" /* sidebarCssClasses */].indexOf(cssTemplate) > -1) {
      cssClass = cssTemplate;
    }
    document.body.classList.add(cssClass);
  };

  AppSidebar.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        Tag = _props.tag,
        attributes = _objectWithoutProperties(_props, ['className', 'children', 'tag']);

    delete attributes.compact;
    delete attributes.display;
    delete attributes.fixed;
    delete attributes.minimized;
    delete attributes.offCanvas;
    delete attributes.isOpen;
    delete attributes.staticContext;

    var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, 'sidebar');

    // sidebar-nav root
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({ className: classes }, attributes),
      children
    );
  };

  return AppSidebar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AppSidebar.propTypes =  false ? propTypes : {};
AppSidebar.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (AppSidebar);

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps = {
  tag: 'div'
};

var AppSidebarFooter = function (_Component) {
  _inherits(AppSidebarFooter, _Component);

  function AppSidebarFooter() {
    _classCallCheck(this, AppSidebarFooter);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  AppSidebarFooter.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        Tag = _props.tag,
        attributes = _objectWithoutProperties(_props, ['className', 'children', 'tag']);

    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'sidebar-footer');
    var footer = children ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({ className: classes }, attributes),
      children
    ) : null;

    return footer;
  };

  return AppSidebarFooter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AppSidebarFooter.propTypes =  false ? propTypes : {};
AppSidebarFooter.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (AppSidebarFooter);

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps = {
  tag: 'div'
};

var AppSidebarForm = function (_Component) {
  _inherits(AppSidebarForm, _Component);

  function AppSidebarForm() {
    _classCallCheck(this, AppSidebarForm);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  AppSidebarForm.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        Tag = _props.tag,
        attributes = _objectWithoutProperties(_props, ['className', 'children', 'tag']);

    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'sidebar-form');
    var form = children ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({ className: classes }, attributes),
      children
    ) : null;

    return form;
  };

  return AppSidebarForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AppSidebarForm.propTypes =  false ? propTypes : {};
AppSidebarForm.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (AppSidebarForm);

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps = {
  tag: 'div'
};

var AppSidebarHeader = function (_Component) {
  _inherits(AppSidebarHeader, _Component);

  function AppSidebarHeader() {
    _classCallCheck(this, AppSidebarHeader);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  AppSidebarHeader.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        Tag = _props.tag,
        attributes = _objectWithoutProperties(_props, ['className', 'children', 'tag']);

    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'sidebar-header');
    var header = children ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({ className: classes }, attributes),
      children
    ) : null;

    return header;
  };

  return AppSidebarHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AppSidebarHeader.propTypes =  false ? propTypes : {};
AppSidebarHeader.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (AppSidebarHeader);

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps = {
  tag: 'button',
  type: 'button'
};

var AppSidebarMinimizer = function (_Component) {
  _inherits(AppSidebarMinimizer, _Component);

  function AppSidebarMinimizer(props) {
    _classCallCheck(this, AppSidebarMinimizer);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  AppSidebarMinimizer.prototype.sidebarMinimize = function sidebarMinimize() {
    document.body.classList.toggle('sidebar-minimized');
    var sidebar = document.querySelector('.sidebar-nav');
    if (sidebar) {
      var toggleOn = sidebar.classList.toggle('ps');
      sidebar.classList.toggle('scrollbar-container', toggleOn);
      sidebar.classList.toggle('ps--active-y', toggleOn);
    }
  };

  AppSidebarMinimizer.prototype.brandMinimize = function brandMinimize() {
    document.body.classList.toggle('brand-minimized');
  };

  AppSidebarMinimizer.prototype.handleClick = function handleClick(e) {
    this.sidebarMinimize(e);
    this.brandMinimize(e);
  };

  AppSidebarMinimizer.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        className = _props.className,
        children = _props.children,
        Tag = _props.tag,
        type = _props.type,
        attributes = _objectWithoutProperties(_props, ['className', 'children', 'tag', 'type']);

    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'sidebar-minimizer', 'mt-auto');

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({ className: classes, type: type }, attributes, { onClick: function onClick(event) {
          return _this2.handleClick(event);
        } }),
      children
    );
  };

  return AppSidebarMinimizer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AppSidebarMinimizer.propTypes =  false ? propTypes : {};
AppSidebarMinimizer.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (AppSidebarMinimizer);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_perfect_scrollbar__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_perfect_scrollbar_dist_css_styles_css__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_perfect_scrollbar_dist_css_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_perfect_scrollbar_dist_css_styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  navConfig: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  navFunc: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
  isOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  staticContext: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  tag: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string])
};

var defaultProps = {
  tag: 'nav',
  navConfig: {
    items: [{
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: { variant: 'info', text: 'NEW' }
    }]
  },
  isOpen: false
};

var AppSidebarNav = function (_Component) {
  _inherits(AppSidebarNav, _Component);

  function AppSidebarNav(props) {
    _classCallCheck(this, AppSidebarNav);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.activeRoute = _this.activeRoute.bind(_this);
    _this.hideMobile = _this.hideMobile.bind(_this);
    return _this;
  }

  AppSidebarNav.prototype.handleClick = function handleClick(e) {
    e.preventDefault();
    e.target.parentElement.classList.toggle('open');
  };

  AppSidebarNav.prototype.activeRoute = function activeRoute(routeName, props) {
    return props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown';
  };

  AppSidebarNav.prototype.hideMobile = function hideMobile() {
    if (document.body.classList.contains('sidebar-show')) {
      document.body.classList.toggle('sidebar-show');
    }
  };

  // nav list


  AppSidebarNav.prototype.navList = function navList(items) {
    var _this2 = this;

    return items.map(function (item, index) {
      return _this2.navType(item, index);
    });
  };

  // nav type


  AppSidebarNav.prototype.navType = function navType(item, idx) {
    return item.title ? this.navTitle(item, idx) : item.divider ? this.navDivider(item, idx) : item.label ? this.navLabel(item, idx) : item.children ? this.navDropdown(item, idx) : this.navItem(item, idx);
  };

  // nav list section title


  AppSidebarNav.prototype.navTitle = function navTitle(title, key) {
    var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('nav-title', title.class);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'li',
      { key: key, className: classes },
      this.navWrapper(title),
      ' '
    );
  };

  // simple wrapper for nav-title item


  AppSidebarNav.prototype.navWrapper = function navWrapper(item) {
    return item.wrapper && item.wrapper.element ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(item.wrapper.element, item.wrapper.attributes, item.name) : item.name;
  };

  // nav list divider


  AppSidebarNav.prototype.navDivider = function navDivider(divider, key) {
    var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('divider', divider.class);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { key: key, className: classes });
  };

  // nav label with nav link


  AppSidebarNav.prototype.navLabel = function navLabel(item, key) {
    var classes = {
      item: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('hidden-cn', item.class),
      link: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('nav-label', item.class ? item.class : ''),
      icon: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('nav-icon', !item.icon ? 'fa fa-circle' : item.icon, item.label.variant ? 'text-' + item.label.variant : '', item.label.class ? item.label.class : '')
    };
    return this.navLink(item, key, classes);
  };

  // nav dropdown


  AppSidebarNav.prototype.navDropdown = function navDropdown(item, key) {
    var classIcon = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('nav-icon', item.icon);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'li',
      { key: key, className: this.activeRoute(item.url, this.props) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'nav-link nav-dropdown-toggle', href: '#', onClick: this.handleClick },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: classIcon }),
        item.name
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { className: 'nav-dropdown-items' },
        this.navList(item.children)
      )
    );
  };

  // nav item with nav link


  AppSidebarNav.prototype.navItem = function navItem(item, key) {
    var classes = {
      item: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(item.class),
      link: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('nav-link', item.variant ? 'nav-link-' + item.variant : ''),
      icon: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('nav-icon', item.icon)
    };
    return this.navLink(item, key, classes);
  };

  // nav link


  AppSidebarNav.prototype.navLink = function navLink(item, key, classes) {
    var url = item.url ? item.url : '';
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_reactstrap__["NavItem"],
      { key: key, className: classes.item },
      this.isExternal(url) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_reactstrap__["NavLink"],
        { href: url, className: classes.link, active: true },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: classes.icon }),
        item.name,
        this.navBadge(item.badge)
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],
        { to: url, className: classes.link, activeClassName: 'active', onClick: this.hideMobile },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: classes.icon }),
        item.name,
        this.navBadge(item.badge)
      )
    );
  };

  // badge addon to NavItem


  AppSidebarNav.prototype.navBadge = function navBadge(badge) {
    if (badge) {
      var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(badge.class);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_reactstrap__["Badge"],
        { className: classes, color: badge.variant },
        badge.text
      );
    }
    return null;
  };

  AppSidebarNav.prototype.isExternal = function isExternal(url) {
    var link = url ? url.substring(0, 4) : '';
    return link === 'http';
  };

  AppSidebarNav.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        navConfig = _props.navConfig,
        attributes = _objectWithoutProperties(_props, ['className', 'children', 'navConfig']);

    delete attributes.isOpen;
    delete attributes.staticContext;
    delete attributes.Tag;

    var navClasses = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, 'sidebar-nav');

    // sidebar-nav root
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_react_perfect_scrollbar___default.a,
      _extends({ className: navClasses }, attributes, { option: { suppressScrollX: true } }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_reactstrap__["Nav"],
        null,
        children || this.navList(navConfig.items)
      )
    );
  };

  return AppSidebarNav;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AppSidebarNav.propTypes =  false ? propTypes : {};
AppSidebarNav.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (AppSidebarNav);

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scrollbar = __webpack_require__(407);

var _scrollbar2 = _interopRequireDefault(_scrollbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _scrollbar2.default;
module.exports = exports['default'];

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _perfectScrollbar = __webpack_require__(408);

var _perfectScrollbar2 = _interopRequireDefault(_perfectScrollbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var handlerNameByEvent = {
    'ps-scroll-y': 'onScrollY',
    'ps-scroll-x': 'onScrollX',
    'ps-scroll-up': 'onScrollUp',
    'ps-scroll-down': 'onScrollDown',
    'ps-scroll-left': 'onScrollLeft',
    'ps-scroll-right': 'onScrollRight',
    'ps-y-reach-start': 'onYReachStart',
    'ps-y-reach-end': 'onYReachEnd',
    'ps-x-reach-start': 'onXReachStart',
    'ps-x-reach-end': 'onXReachEnd'
};
Object.freeze(handlerNameByEvent);

var ScrollBar = function (_Component) {
    _inherits(ScrollBar, _Component);

    function ScrollBar(props) {
        _classCallCheck(this, ScrollBar);

        var _this = _possibleConstructorReturn(this, (ScrollBar.__proto__ || Object.getPrototypeOf(ScrollBar)).call(this, props));

        _this.handleRef = _this.handleRef.bind(_this);
        _this._handlerByEvent = new Map();
        return _this;
    }

    _createClass(ScrollBar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this._ps = new _perfectScrollbar2.default(this._container, this.props.option);
            // hook up events
            Object.keys(handlerNameByEvent).forEach(function (key) {
                var callback = _this2.props[handlerNameByEvent[key]];
                if (callback) {
                    var handler = function handler() {
                        return callback(_this2._container);
                    };
                    _this2._handlerByEvent.set(key, handler);
                    _this2._container.addEventListener(key, handler, false);
                }
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this._ps.update();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var _this3 = this;

            // unhook up evens
            Object.keys(this._handlerByEvent).forEach(function (value, key) {
                _this3._container.removeEventListener(key, value, false);
            });
            this._handlerByEvent.clear();
            this._ps.destroy();
            this._ps = null;
        }
    }, {
        key: 'updateScroll',
        value: function updateScroll() {
            this._ps.update();
        }
    }, {
        key: 'handleRef',
        value: function handleRef(ref) {
            this._container = ref;
            this.props.containerRef(ref);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className;


            return _react2.default.createElement(
                'div',
                { className: 'scrollbar-container ' + className, ref: this.handleRef },
                children
            );
        }
    }]);

    return ScrollBar;
}(_react.Component);

exports.default = ScrollBar;


ScrollBar.defaultProps = {
    className: '',
    option: undefined,
    containerRef: function containerRef() {},
    onScrollY: undefined,
    onScrollX: undefined,
    onScrollUp: undefined,
    onScrollDown: undefined,
    onScrollLeft: undefined,
    onScrollRight: undefined,
    onYReachStart: undefined,
    onYReachEnd: undefined,
    onXReachStart: undefined,
    onXReachEnd: undefined
};

ScrollBar.propTypes = {
    children: _propTypes.PropTypes.node.isRequired,
    className: _propTypes.PropTypes.string,
    option: _propTypes.PropTypes.object,
    containerRef: _propTypes.PropTypes.func,
    onScrollY: _propTypes.PropTypes.func,
    onScrollX: _propTypes.PropTypes.func,
    onScrollUp: _propTypes.PropTypes.func,
    onScrollDown: _propTypes.PropTypes.func,
    onScrollLeft: _propTypes.PropTypes.func,
    onScrollRight: _propTypes.PropTypes.func,
    onYReachStart: _propTypes.PropTypes.func,
    onYReachEnd: _propTypes.PropTypes.func,
    onXReachStart: _propTypes.PropTypes.func,
    onXReachEnd: _propTypes.PropTypes.func
};
module.exports = exports['default'];

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/*!
 * perfect-scrollbar v1.4.0
 * (c) 2018 Hyunje Jun
 * @license MIT
 */
function get(element) {
  return getComputedStyle(element);
}

function set(element, obj) {
  for (var key in obj) {
    var val = obj[key];
    if (typeof val === 'number') {
      val = val + "px";
    }
    element.style[key] = val;
  }
  return element;
}

function div(className) {
  var div = document.createElement('div');
  div.className = className;
  return div;
}

var elMatches =
  typeof Element !== 'undefined' &&
  (Element.prototype.matches ||
    Element.prototype.webkitMatchesSelector ||
    Element.prototype.mozMatchesSelector ||
    Element.prototype.msMatchesSelector);

function matches(element, query) {
  if (!elMatches) {
    throw new Error('No element matching method supported');
  }

  return elMatches.call(element, query);
}

function remove(element) {
  if (element.remove) {
    element.remove();
  } else {
    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }
}

function queryChildren(element, selector) {
  return Array.prototype.filter.call(element.children, function (child) { return matches(child, selector); }
  );
}

var cls = {
  main: 'ps',
  element: {
    thumb: function (x) { return ("ps__thumb-" + x); },
    rail: function (x) { return ("ps__rail-" + x); },
    consuming: 'ps__child--consume',
  },
  state: {
    focus: 'ps--focus',
    clicking: 'ps--clicking',
    active: function (x) { return ("ps--active-" + x); },
    scrolling: function (x) { return ("ps--scrolling-" + x); },
  },
};

/*
 * Helper methods
 */
var scrollingClassTimeout = { x: null, y: null };

function addScrollingClass(i, x) {
  var classList = i.element.classList;
  var className = cls.state.scrolling(x);

  if (classList.contains(className)) {
    clearTimeout(scrollingClassTimeout[x]);
  } else {
    classList.add(className);
  }
}

function removeScrollingClass(i, x) {
  scrollingClassTimeout[x] = setTimeout(
    function () { return i.isAlive && i.element.classList.remove(cls.state.scrolling(x)); },
    i.settings.scrollingThreshold
  );
}

function setScrollingClassInstantly(i, x) {
  addScrollingClass(i, x);
  removeScrollingClass(i, x);
}

var EventElement = function EventElement(element) {
  this.element = element;
  this.handlers = {};
};

var prototypeAccessors = { isEmpty: { configurable: true } };

EventElement.prototype.bind = function bind (eventName, handler) {
  if (typeof this.handlers[eventName] === 'undefined') {
    this.handlers[eventName] = [];
  }
  this.handlers[eventName].push(handler);
  this.element.addEventListener(eventName, handler, false);
};

EventElement.prototype.unbind = function unbind (eventName, target) {
    var this$1 = this;

  this.handlers[eventName] = this.handlers[eventName].filter(function (handler) {
    if (target && handler !== target) {
      return true;
    }
    this$1.element.removeEventListener(eventName, handler, false);
    return false;
  });
};

EventElement.prototype.unbindAll = function unbindAll () {
    var this$1 = this;

  for (var name in this$1.handlers) {
    this$1.unbind(name);
  }
};

prototypeAccessors.isEmpty.get = function () {
    var this$1 = this;

  return Object.keys(this.handlers).every(
    function (key) { return this$1.handlers[key].length === 0; }
  );
};

Object.defineProperties( EventElement.prototype, prototypeAccessors );

var EventManager = function EventManager() {
  this.eventElements = [];
};

EventManager.prototype.eventElement = function eventElement (element) {
  var ee = this.eventElements.filter(function (ee) { return ee.element === element; })[0];
  if (!ee) {
    ee = new EventElement(element);
    this.eventElements.push(ee);
  }
  return ee;
};

EventManager.prototype.bind = function bind (element, eventName, handler) {
  this.eventElement(element).bind(eventName, handler);
};

EventManager.prototype.unbind = function unbind (element, eventName, handler) {
  var ee = this.eventElement(element);
  ee.unbind(eventName, handler);

  if (ee.isEmpty) {
    // remove
    this.eventElements.splice(this.eventElements.indexOf(ee), 1);
  }
};

EventManager.prototype.unbindAll = function unbindAll () {
  this.eventElements.forEach(function (e) { return e.unbindAll(); });
  this.eventElements = [];
};

EventManager.prototype.once = function once (element, eventName, handler) {
  var ee = this.eventElement(element);
  var onceHandler = function (evt) {
    ee.unbind(eventName, onceHandler);
    handler(evt);
  };
  ee.bind(eventName, onceHandler);
};

function createEvent(name) {
  if (typeof window.CustomEvent === 'function') {
    return new CustomEvent(name);
  } else {
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(name, false, false, undefined);
    return evt;
  }
}

var processScrollDiff = function(
  i,
  axis,
  diff,
  useScrollingClass,
  forceFireReachEvent
) {
  if ( useScrollingClass === void 0 ) useScrollingClass = true;
  if ( forceFireReachEvent === void 0 ) forceFireReachEvent = false;

  var fields;
  if (axis === 'top') {
    fields = [
      'contentHeight',
      'containerHeight',
      'scrollTop',
      'y',
      'up',
      'down' ];
  } else if (axis === 'left') {
    fields = [
      'contentWidth',
      'containerWidth',
      'scrollLeft',
      'x',
      'left',
      'right' ];
  } else {
    throw new Error('A proper axis should be provided');
  }

  processScrollDiff$1(i, diff, fields, useScrollingClass, forceFireReachEvent);
};

function processScrollDiff$1(
  i,
  diff,
  ref,
  useScrollingClass,
  forceFireReachEvent
) {
  var contentHeight = ref[0];
  var containerHeight = ref[1];
  var scrollTop = ref[2];
  var y = ref[3];
  var up = ref[4];
  var down = ref[5];
  if ( useScrollingClass === void 0 ) useScrollingClass = true;
  if ( forceFireReachEvent === void 0 ) forceFireReachEvent = false;

  var element = i.element;

  // reset reach
  i.reach[y] = null;

  // 1 for subpixel rounding
  if (element[scrollTop] < 1) {
    i.reach[y] = 'start';
  }

  // 1 for subpixel rounding
  if (element[scrollTop] > i[contentHeight] - i[containerHeight] - 1) {
    i.reach[y] = 'end';
  }

  if (diff) {
    element.dispatchEvent(createEvent(("ps-scroll-" + y)));

    if (diff < 0) {
      element.dispatchEvent(createEvent(("ps-scroll-" + up)));
    } else if (diff > 0) {
      element.dispatchEvent(createEvent(("ps-scroll-" + down)));
    }

    if (useScrollingClass) {
      setScrollingClassInstantly(i, y);
    }
  }

  if (i.reach[y] && (diff || forceFireReachEvent)) {
    element.dispatchEvent(createEvent(("ps-" + y + "-reach-" + (i.reach[y]))));
  }
}

function toInt(x) {
  return parseInt(x, 10) || 0;
}

function isEditable(el) {
  return (
    matches(el, 'input,[contenteditable]') ||
    matches(el, 'select,[contenteditable]') ||
    matches(el, 'textarea,[contenteditable]') ||
    matches(el, 'button,[contenteditable]')
  );
}

function outerWidth(element) {
  var styles = get(element);
  return (
    toInt(styles.width) +
    toInt(styles.paddingLeft) +
    toInt(styles.paddingRight) +
    toInt(styles.borderLeftWidth) +
    toInt(styles.borderRightWidth)
  );
}

var env = {
  isWebKit:
    typeof document !== 'undefined' &&
    'WebkitAppearance' in document.documentElement.style,
  supportsTouch:
    typeof window !== 'undefined' &&
    ('ontouchstart' in window ||
      (window.DocumentTouch && document instanceof window.DocumentTouch)),
  supportsIePointer:
    typeof navigator !== 'undefined' && navigator.msMaxTouchPoints,
  isChrome:
    typeof navigator !== 'undefined' &&
    /Chrome/i.test(navigator && navigator.userAgent),
};

var updateGeometry = function(i) {
  var element = i.element;
  var roundedScrollTop = Math.floor(element.scrollTop);

  i.containerWidth = element.clientWidth;
  i.containerHeight = element.clientHeight;
  i.contentWidth = element.scrollWidth;
  i.contentHeight = element.scrollHeight;

  if (!element.contains(i.scrollbarXRail)) {
    // clean up and append
    queryChildren(element, cls.element.rail('x')).forEach(function (el) { return remove(el); }
    );
    element.appendChild(i.scrollbarXRail);
  }
  if (!element.contains(i.scrollbarYRail)) {
    // clean up and append
    queryChildren(element, cls.element.rail('y')).forEach(function (el) { return remove(el); }
    );
    element.appendChild(i.scrollbarYRail);
  }

  if (
    !i.settings.suppressScrollX &&
    i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth
  ) {
    i.scrollbarXActive = true;
    i.railXWidth = i.containerWidth - i.railXMarginWidth;
    i.railXRatio = i.containerWidth / i.railXWidth;
    i.scrollbarXWidth = getThumbSize(
      i,
      toInt(i.railXWidth * i.containerWidth / i.contentWidth)
    );
    i.scrollbarXLeft = toInt(
      (i.negativeScrollAdjustment + element.scrollLeft) *
        (i.railXWidth - i.scrollbarXWidth) /
        (i.contentWidth - i.containerWidth)
    );
  } else {
    i.scrollbarXActive = false;
  }

  if (
    !i.settings.suppressScrollY &&
    i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight
  ) {
    i.scrollbarYActive = true;
    i.railYHeight = i.containerHeight - i.railYMarginHeight;
    i.railYRatio = i.containerHeight / i.railYHeight;
    i.scrollbarYHeight = getThumbSize(
      i,
      toInt(i.railYHeight * i.containerHeight / i.contentHeight)
    );
    i.scrollbarYTop = toInt(
      roundedScrollTop *
        (i.railYHeight - i.scrollbarYHeight) /
        (i.contentHeight - i.containerHeight)
    );
  } else {
    i.scrollbarYActive = false;
  }

  if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
    i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
  }
  if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
    i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
  }

  updateCss(element, i);

  if (i.scrollbarXActive) {
    element.classList.add(cls.state.active('x'));
  } else {
    element.classList.remove(cls.state.active('x'));
    i.scrollbarXWidth = 0;
    i.scrollbarXLeft = 0;
    element.scrollLeft = 0;
  }
  if (i.scrollbarYActive) {
    element.classList.add(cls.state.active('y'));
  } else {
    element.classList.remove(cls.state.active('y'));
    i.scrollbarYHeight = 0;
    i.scrollbarYTop = 0;
    element.scrollTop = 0;
  }
};

function getThumbSize(i, thumbSize) {
  if (i.settings.minScrollbarLength) {
    thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
  }
  if (i.settings.maxScrollbarLength) {
    thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
  }
  return thumbSize;
}

function updateCss(element, i) {
  var xRailOffset = { width: i.railXWidth };
  var roundedScrollTop = Math.floor(element.scrollTop);

  if (i.isRtl) {
    xRailOffset.left =
      i.negativeScrollAdjustment +
      element.scrollLeft +
      i.containerWidth -
      i.contentWidth;
  } else {
    xRailOffset.left = element.scrollLeft;
  }
  if (i.isScrollbarXUsingBottom) {
    xRailOffset.bottom = i.scrollbarXBottom - roundedScrollTop;
  } else {
    xRailOffset.top = i.scrollbarXTop + roundedScrollTop;
  }
  set(i.scrollbarXRail, xRailOffset);

  var yRailOffset = { top: roundedScrollTop, height: i.railYHeight };
  if (i.isScrollbarYUsingRight) {
    if (i.isRtl) {
      yRailOffset.right =
        i.contentWidth -
        (i.negativeScrollAdjustment + element.scrollLeft) -
        i.scrollbarYRight -
        i.scrollbarYOuterWidth;
    } else {
      yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
    }
  } else {
    if (i.isRtl) {
      yRailOffset.left =
        i.negativeScrollAdjustment +
        element.scrollLeft +
        i.containerWidth * 2 -
        i.contentWidth -
        i.scrollbarYLeft -
        i.scrollbarYOuterWidth;
    } else {
      yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
    }
  }
  set(i.scrollbarYRail, yRailOffset);

  set(i.scrollbarX, {
    left: i.scrollbarXLeft,
    width: i.scrollbarXWidth - i.railBorderXWidth,
  });
  set(i.scrollbarY, {
    top: i.scrollbarYTop,
    height: i.scrollbarYHeight - i.railBorderYWidth,
  });
}

var clickRail = function(i) {
  i.event.bind(i.scrollbarY, 'mousedown', function (e) { return e.stopPropagation(); });
  i.event.bind(i.scrollbarYRail, 'mousedown', function (e) {
    var positionTop =
      e.pageY -
      window.pageYOffset -
      i.scrollbarYRail.getBoundingClientRect().top;
    var direction = positionTop > i.scrollbarYTop ? 1 : -1;

    i.element.scrollTop += direction * i.containerHeight;
    updateGeometry(i);

    e.stopPropagation();
  });

  i.event.bind(i.scrollbarX, 'mousedown', function (e) { return e.stopPropagation(); });
  i.event.bind(i.scrollbarXRail, 'mousedown', function (e) {
    var positionLeft =
      e.pageX -
      window.pageXOffset -
      i.scrollbarXRail.getBoundingClientRect().left;
    var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;

    i.element.scrollLeft += direction * i.containerWidth;
    updateGeometry(i);

    e.stopPropagation();
  });
};

var dragThumb = function(i) {
  bindMouseScrollHandler(i, [
    'containerWidth',
    'contentWidth',
    'pageX',
    'railXWidth',
    'scrollbarX',
    'scrollbarXWidth',
    'scrollLeft',
    'x',
    'scrollbarXRail' ]);
  bindMouseScrollHandler(i, [
    'containerHeight',
    'contentHeight',
    'pageY',
    'railYHeight',
    'scrollbarY',
    'scrollbarYHeight',
    'scrollTop',
    'y',
    'scrollbarYRail' ]);
};

function bindMouseScrollHandler(
  i,
  ref
) {
  var containerHeight = ref[0];
  var contentHeight = ref[1];
  var pageY = ref[2];
  var railYHeight = ref[3];
  var scrollbarY = ref[4];
  var scrollbarYHeight = ref[5];
  var scrollTop = ref[6];
  var y = ref[7];
  var scrollbarYRail = ref[8];

  var element = i.element;

  var startingScrollTop = null;
  var startingMousePageY = null;
  var scrollBy = null;

  function mouseMoveHandler(e) {
    element[scrollTop] =
      startingScrollTop + scrollBy * (e[pageY] - startingMousePageY);
    addScrollingClass(i, y);
    updateGeometry(i);

    e.stopPropagation();
    e.preventDefault();
  }

  function mouseUpHandler() {
    removeScrollingClass(i, y);
    i[scrollbarYRail].classList.remove(cls.state.clicking);
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  }

  i.event.bind(i[scrollbarY], 'mousedown', function (e) {
    startingScrollTop = element[scrollTop];
    startingMousePageY = e[pageY];
    scrollBy =
      (i[contentHeight] - i[containerHeight]) /
      (i[railYHeight] - i[scrollbarYHeight]);

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    i[scrollbarYRail].classList.add(cls.state.clicking);

    e.stopPropagation();
    e.preventDefault();
  });
}

var keyboard = function(i) {
  var element = i.element;

  var elementHovered = function () { return matches(element, ':hover'); };
  var scrollbarFocused = function () { return matches(i.scrollbarX, ':focus') || matches(i.scrollbarY, ':focus'); };

  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = Math.floor(element.scrollTop);
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if (
        (scrollTop === 0 && deltaY > 0) ||
        (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)
      ) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if (
        (scrollLeft === 0 && deltaX < 0) ||
        (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)
      ) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  i.event.bind(i.ownerDocument, 'keydown', function (e) {
    if (
      (e.isDefaultPrevented && e.isDefaultPrevented()) ||
      e.defaultPrevented
    ) {
      return;
    }

    if (!elementHovered() && !scrollbarFocused()) {
      return;
    }

    var activeElement = document.activeElement
      ? document.activeElement
      : i.ownerDocument.activeElement;
    if (activeElement) {
      if (activeElement.tagName === 'IFRAME') {
        activeElement = activeElement.contentDocument.activeElement;
      } else {
        // go deeper if element is a webcomponent
        while (activeElement.shadowRoot) {
          activeElement = activeElement.shadowRoot.activeElement;
        }
      }
      if (isEditable(activeElement)) {
        return;
      }
    }

    var deltaX = 0;
    var deltaY = 0;

    switch (e.which) {
      case 37: // left
        if (e.metaKey) {
          deltaX = -i.contentWidth;
        } else if (e.altKey) {
          deltaX = -i.containerWidth;
        } else {
          deltaX = -30;
        }
        break;
      case 38: // up
        if (e.metaKey) {
          deltaY = i.contentHeight;
        } else if (e.altKey) {
          deltaY = i.containerHeight;
        } else {
          deltaY = 30;
        }
        break;
      case 39: // right
        if (e.metaKey) {
          deltaX = i.contentWidth;
        } else if (e.altKey) {
          deltaX = i.containerWidth;
        } else {
          deltaX = 30;
        }
        break;
      case 40: // down
        if (e.metaKey) {
          deltaY = -i.contentHeight;
        } else if (e.altKey) {
          deltaY = -i.containerHeight;
        } else {
          deltaY = -30;
        }
        break;
      case 32: // space bar
        if (e.shiftKey) {
          deltaY = i.containerHeight;
        } else {
          deltaY = -i.containerHeight;
        }
        break;
      case 33: // page up
        deltaY = i.containerHeight;
        break;
      case 34: // page down
        deltaY = -i.containerHeight;
        break;
      case 36: // home
        deltaY = i.contentHeight;
        break;
      case 35: // end
        deltaY = -i.contentHeight;
        break;
      default:
        return;
    }

    if (i.settings.suppressScrollX && deltaX !== 0) {
      return;
    }
    if (i.settings.suppressScrollY && deltaY !== 0) {
      return;
    }

    element.scrollTop -= deltaY;
    element.scrollLeft += deltaX;
    updateGeometry(i);

    if (shouldPreventDefault(deltaX, deltaY)) {
      e.preventDefault();
    }
  });
};

var wheel = function(i) {
  var element = i.element;

  function shouldPreventDefault(deltaX, deltaY) {
    var roundedScrollTop = Math.floor(element.scrollTop);
    var isTop = element.scrollTop === 0;
    var isBottom =
      roundedScrollTop + element.offsetHeight === element.scrollHeight;
    var isLeft = element.scrollLeft === 0;
    var isRight =
      element.scrollLeft + element.offsetWidth === element.scrollWidth;

    var hitsBound;

    // pick axis with primary direction
    if (Math.abs(deltaY) > Math.abs(deltaX)) {
      hitsBound = isTop || isBottom;
    } else {
      hitsBound = isLeft || isRight;
    }

    return hitsBound ? !i.settings.wheelPropagation : true;
  }

  function getDeltaFromEvent(e) {
    var deltaX = e.deltaX;
    var deltaY = -1 * e.deltaY;

    if (typeof deltaX === 'undefined' || typeof deltaY === 'undefined') {
      // OS X Safari
      deltaX = -1 * e.wheelDeltaX / 6;
      deltaY = e.wheelDeltaY / 6;
    }

    if (e.deltaMode && e.deltaMode === 1) {
      // Firefox in deltaMode 1: Line scrolling
      deltaX *= 10;
      deltaY *= 10;
    }

    if (deltaX !== deltaX && deltaY !== deltaY /* NaN checks */) {
      // IE in some mouse drivers
      deltaX = 0;
      deltaY = e.wheelDelta;
    }

    if (e.shiftKey) {
      // reverse axis with shift key
      return [-deltaY, -deltaX];
    }
    return [deltaX, deltaY];
  }

  function shouldBeConsumedByChild(target, deltaX, deltaY) {
    // FIXME: this is a workaround for <select> issue in FF and IE #571
    if (!env.isWebKit && element.querySelector('select:focus')) {
      return true;
    }

    if (!element.contains(target)) {
      return false;
    }

    var cursor = target;

    while (cursor && cursor !== element) {
      if (cursor.classList.contains(cls.element.consuming)) {
        return true;
      }

      var style = get(cursor);
      var overflow = [style.overflow, style.overflowX, style.overflowY].join(
        ''
      );

      // if scrollable
      if (overflow.match(/(scroll|auto)/)) {
        var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
        if (maxScrollTop > 0) {
          if (
            !(cursor.scrollTop === 0 && deltaY > 0) &&
            !(cursor.scrollTop === maxScrollTop && deltaY < 0)
          ) {
            return true;
          }
        }
        var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
        if (maxScrollLeft > 0) {
          if (
            !(cursor.scrollLeft === 0 && deltaX < 0) &&
            !(cursor.scrollLeft === maxScrollLeft && deltaX > 0)
          ) {
            return true;
          }
        }
      }

      cursor = cursor.parentNode;
    }

    return false;
  }

  function mousewheelHandler(e) {
    var ref = getDeltaFromEvent(e);
    var deltaX = ref[0];
    var deltaY = ref[1];

    if (shouldBeConsumedByChild(e.target, deltaX, deltaY)) {
      return;
    }

    var shouldPrevent = false;
    if (!i.settings.useBothWheelAxes) {
      // deltaX will only be used for horizontal scrolling and deltaY will
      // only be used for vertical scrolling - this is the default
      element.scrollTop -= deltaY * i.settings.wheelSpeed;
      element.scrollLeft += deltaX * i.settings.wheelSpeed;
    } else if (i.scrollbarYActive && !i.scrollbarXActive) {
      // only vertical scrollbar is active and useBothWheelAxes option is
      // active, so let's scroll vertical bar using both mouse wheel axes
      if (deltaY) {
        element.scrollTop -= deltaY * i.settings.wheelSpeed;
      } else {
        element.scrollTop += deltaX * i.settings.wheelSpeed;
      }
      shouldPrevent = true;
    } else if (i.scrollbarXActive && !i.scrollbarYActive) {
      // useBothWheelAxes and only horizontal bar is active, so use both
      // wheel axes for horizontal bar
      if (deltaX) {
        element.scrollLeft += deltaX * i.settings.wheelSpeed;
      } else {
        element.scrollLeft -= deltaY * i.settings.wheelSpeed;
      }
      shouldPrevent = true;
    }

    updateGeometry(i);

    shouldPrevent = shouldPrevent || shouldPreventDefault(deltaX, deltaY);
    if (shouldPrevent && !e.ctrlKey) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  if (typeof window.onwheel !== 'undefined') {
    i.event.bind(element, 'wheel', mousewheelHandler);
  } else if (typeof window.onmousewheel !== 'undefined') {
    i.event.bind(element, 'mousewheel', mousewheelHandler);
  }
};

var touch = function(i) {
  if (!env.supportsTouch && !env.supportsIePointer) {
    return;
  }

  var element = i.element;

  function shouldPrevent(deltaX, deltaY) {
    var scrollTop = Math.floor(element.scrollTop);
    var scrollLeft = element.scrollLeft;
    var magnitudeX = Math.abs(deltaX);
    var magnitudeY = Math.abs(deltaY);

    if (magnitudeY > magnitudeX) {
      // user is perhaps trying to swipe up/down the page

      if (
        (deltaY < 0 && scrollTop === i.contentHeight - i.containerHeight) ||
        (deltaY > 0 && scrollTop === 0)
      ) {
        // set prevent for mobile Chrome refresh
        return window.scrollY === 0 && deltaY > 0 && env.isChrome;
      }
    } else if (magnitudeX > magnitudeY) {
      // user is perhaps trying to swipe left/right across the page

      if (
        (deltaX < 0 && scrollLeft === i.contentWidth - i.containerWidth) ||
        (deltaX > 0 && scrollLeft === 0)
      ) {
        return true;
      }
    }

    return true;
  }

  function applyTouchMove(differenceX, differenceY) {
    element.scrollTop -= differenceY;
    element.scrollLeft -= differenceX;

    updateGeometry(i);
  }

  var startOffset = {};
  var startTime = 0;
  var speed = {};
  var easingLoop = null;

  function getTouch(e) {
    if (e.targetTouches) {
      return e.targetTouches[0];
    } else {
      // Maybe IE pointer
      return e;
    }
  }

  function shouldHandle(e) {
    if (e.pointerType && e.pointerType === 'pen' && e.buttons === 0) {
      return false;
    }
    if (e.targetTouches && e.targetTouches.length === 1) {
      return true;
    }
    if (
      e.pointerType &&
      e.pointerType !== 'mouse' &&
      e.pointerType !== e.MSPOINTER_TYPE_MOUSE
    ) {
      return true;
    }
    return false;
  }

  function touchStart(e) {
    if (!shouldHandle(e)) {
      return;
    }

    var touch = getTouch(e);

    startOffset.pageX = touch.pageX;
    startOffset.pageY = touch.pageY;

    startTime = new Date().getTime();

    if (easingLoop !== null) {
      clearInterval(easingLoop);
    }
  }

  function shouldBeConsumedByChild(target, deltaX, deltaY) {
    if (!element.contains(target)) {
      return false;
    }

    var cursor = target;

    while (cursor && cursor !== element) {
      if (cursor.classList.contains(cls.element.consuming)) {
        return true;
      }

      var style = get(cursor);
      var overflow = [style.overflow, style.overflowX, style.overflowY].join(
        ''
      );

      // if scrollable
      if (overflow.match(/(scroll|auto)/)) {
        var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
        if (maxScrollTop > 0) {
          if (
            !(cursor.scrollTop === 0 && deltaY > 0) &&
            !(cursor.scrollTop === maxScrollTop && deltaY < 0)
          ) {
            return true;
          }
        }
        var maxScrollLeft = cursor.scrollLeft - cursor.clientWidth;
        if (maxScrollLeft > 0) {
          if (
            !(cursor.scrollLeft === 0 && deltaX < 0) &&
            !(cursor.scrollLeft === maxScrollLeft && deltaX > 0)
          ) {
            return true;
          }
        }
      }

      cursor = cursor.parentNode;
    }

    return false;
  }

  function touchMove(e) {
    if (shouldHandle(e)) {
      var touch = getTouch(e);

      var currentOffset = { pageX: touch.pageX, pageY: touch.pageY };

      var differenceX = currentOffset.pageX - startOffset.pageX;
      var differenceY = currentOffset.pageY - startOffset.pageY;

      if (shouldBeConsumedByChild(e.target, differenceX, differenceY)) {
        return;
      }

      applyTouchMove(differenceX, differenceY);
      startOffset = currentOffset;

      var currentTime = new Date().getTime();

      var timeGap = currentTime - startTime;
      if (timeGap > 0) {
        speed.x = differenceX / timeGap;
        speed.y = differenceY / timeGap;
        startTime = currentTime;
      }

      if (shouldPrevent(differenceX, differenceY)) {
        e.preventDefault();
      }
    }
  }
  function touchEnd() {
    if (i.settings.swipeEasing) {
      clearInterval(easingLoop);
      easingLoop = setInterval(function() {
        if (i.isInitialized) {
          clearInterval(easingLoop);
          return;
        }

        if (!speed.x && !speed.y) {
          clearInterval(easingLoop);
          return;
        }

        if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
          clearInterval(easingLoop);
          return;
        }

        applyTouchMove(speed.x * 30, speed.y * 30);

        speed.x *= 0.8;
        speed.y *= 0.8;
      }, 10);
    }
  }

  if (env.supportsTouch) {
    i.event.bind(element, 'touchstart', touchStart);
    i.event.bind(element, 'touchmove', touchMove);
    i.event.bind(element, 'touchend', touchEnd);
  } else if (env.supportsIePointer) {
    if (window.PointerEvent) {
      i.event.bind(element, 'pointerdown', touchStart);
      i.event.bind(element, 'pointermove', touchMove);
      i.event.bind(element, 'pointerup', touchEnd);
    } else if (window.MSPointerEvent) {
      i.event.bind(element, 'MSPointerDown', touchStart);
      i.event.bind(element, 'MSPointerMove', touchMove);
      i.event.bind(element, 'MSPointerUp', touchEnd);
    }
  }
};

var defaultSettings = function () { return ({
  handlers: ['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch'],
  maxScrollbarLength: null,
  minScrollbarLength: null,
  scrollingThreshold: 1000,
  scrollXMarginOffset: 0,
  scrollYMarginOffset: 0,
  suppressScrollX: false,
  suppressScrollY: false,
  swipeEasing: true,
  useBothWheelAxes: false,
  wheelPropagation: true,
  wheelSpeed: 1,
}); };

var handlers = {
  'click-rail': clickRail,
  'drag-thumb': dragThumb,
  keyboard: keyboard,
  wheel: wheel,
  touch: touch,
};

var PerfectScrollbar = function PerfectScrollbar(element, userSettings) {
  var this$1 = this;
  if ( userSettings === void 0 ) userSettings = {};

  if (typeof element === 'string') {
    element = document.querySelector(element);
  }

  if (!element || !element.nodeName) {
    throw new Error('no element is specified to initialize PerfectScrollbar');
  }

  this.element = element;

  element.classList.add(cls.main);

  this.settings = defaultSettings();
  for (var key in userSettings) {
    this$1.settings[key] = userSettings[key];
  }

  this.containerWidth = null;
  this.containerHeight = null;
  this.contentWidth = null;
  this.contentHeight = null;

  var focus = function () { return element.classList.add(cls.state.focus); };
  var blur = function () { return element.classList.remove(cls.state.focus); };

  this.isRtl = get(element).direction === 'rtl';
  this.isNegativeScroll = (function () {
    var originalScrollLeft = element.scrollLeft;
    var result = null;
    element.scrollLeft = -1;
    result = element.scrollLeft < 0;
    element.scrollLeft = originalScrollLeft;
    return result;
  })();
  this.negativeScrollAdjustment = this.isNegativeScroll
    ? element.scrollWidth - element.clientWidth
    : 0;
  this.event = new EventManager();
  this.ownerDocument = element.ownerDocument || document;

  this.scrollbarXRail = div(cls.element.rail('x'));
  element.appendChild(this.scrollbarXRail);
  this.scrollbarX = div(cls.element.thumb('x'));
  this.scrollbarXRail.appendChild(this.scrollbarX);
  this.scrollbarX.setAttribute('tabindex', 0);
  this.event.bind(this.scrollbarX, 'focus', focus);
  this.event.bind(this.scrollbarX, 'blur', blur);
  this.scrollbarXActive = null;
  this.scrollbarXWidth = null;
  this.scrollbarXLeft = null;
  var railXStyle = get(this.scrollbarXRail);
  this.scrollbarXBottom = parseInt(railXStyle.bottom, 10);
  if (isNaN(this.scrollbarXBottom)) {
    this.isScrollbarXUsingBottom = false;
    this.scrollbarXTop = toInt(railXStyle.top);
  } else {
    this.isScrollbarXUsingBottom = true;
  }
  this.railBorderXWidth =
    toInt(railXStyle.borderLeftWidth) + toInt(railXStyle.borderRightWidth);
  // Set rail to display:block to calculate margins
  set(this.scrollbarXRail, { display: 'block' });
  this.railXMarginWidth =
    toInt(railXStyle.marginLeft) + toInt(railXStyle.marginRight);
  set(this.scrollbarXRail, { display: '' });
  this.railXWidth = null;
  this.railXRatio = null;

  this.scrollbarYRail = div(cls.element.rail('y'));
  element.appendChild(this.scrollbarYRail);
  this.scrollbarY = div(cls.element.thumb('y'));
  this.scrollbarYRail.appendChild(this.scrollbarY);
  this.scrollbarY.setAttribute('tabindex', 0);
  this.event.bind(this.scrollbarY, 'focus', focus);
  this.event.bind(this.scrollbarY, 'blur', blur);
  this.scrollbarYActive = null;
  this.scrollbarYHeight = null;
  this.scrollbarYTop = null;
  var railYStyle = get(this.scrollbarYRail);
  this.scrollbarYRight = parseInt(railYStyle.right, 10);
  if (isNaN(this.scrollbarYRight)) {
    this.isScrollbarYUsingRight = false;
    this.scrollbarYLeft = toInt(railYStyle.left);
  } else {
    this.isScrollbarYUsingRight = true;
  }
  this.scrollbarYOuterWidth = this.isRtl ? outerWidth(this.scrollbarY) : null;
  this.railBorderYWidth =
    toInt(railYStyle.borderTopWidth) + toInt(railYStyle.borderBottomWidth);
  set(this.scrollbarYRail, { display: 'block' });
  this.railYMarginHeight =
    toInt(railYStyle.marginTop) + toInt(railYStyle.marginBottom);
  set(this.scrollbarYRail, { display: '' });
  this.railYHeight = null;
  this.railYRatio = null;

  this.reach = {
    x:
      element.scrollLeft <= 0
        ? 'start'
        : element.scrollLeft >= this.contentWidth - this.containerWidth
          ? 'end'
          : null,
    y:
      element.scrollTop <= 0
        ? 'start'
        : element.scrollTop >= this.contentHeight - this.containerHeight
          ? 'end'
          : null,
  };

  this.isAlive = true;

  this.settings.handlers.forEach(function (handlerName) { return handlers[handlerName](this$1); });

  this.lastScrollTop = Math.floor(element.scrollTop); // for onScroll only
  this.lastScrollLeft = element.scrollLeft; // for onScroll only
  this.event.bind(this.element, 'scroll', function (e) { return this$1.onScroll(e); });
  updateGeometry(this);
};

PerfectScrollbar.prototype.update = function update () {
  if (!this.isAlive) {
    return;
  }

  // Recalcuate negative scrollLeft adjustment
  this.negativeScrollAdjustment = this.isNegativeScroll
    ? this.element.scrollWidth - this.element.clientWidth
    : 0;

  // Recalculate rail margins
  set(this.scrollbarXRail, { display: 'block' });
  set(this.scrollbarYRail, { display: 'block' });
  this.railXMarginWidth =
    toInt(get(this.scrollbarXRail).marginLeft) +
    toInt(get(this.scrollbarXRail).marginRight);
  this.railYMarginHeight =
    toInt(get(this.scrollbarYRail).marginTop) +
    toInt(get(this.scrollbarYRail).marginBottom);

  // Hide scrollbars not to affect scrollWidth and scrollHeight
  set(this.scrollbarXRail, { display: 'none' });
  set(this.scrollbarYRail, { display: 'none' });

  updateGeometry(this);

  processScrollDiff(this, 'top', 0, false, true);
  processScrollDiff(this, 'left', 0, false, true);

  set(this.scrollbarXRail, { display: '' });
  set(this.scrollbarYRail, { display: '' });
};

PerfectScrollbar.prototype.onScroll = function onScroll (e) {
  if (!this.isAlive) {
    return;
  }

  updateGeometry(this);
  processScrollDiff(this, 'top', this.element.scrollTop - this.lastScrollTop);
  processScrollDiff(
    this,
    'left',
    this.element.scrollLeft - this.lastScrollLeft
  );

  this.lastScrollTop = Math.floor(this.element.scrollTop);
  this.lastScrollLeft = this.element.scrollLeft;
};

PerfectScrollbar.prototype.destroy = function destroy () {
  if (!this.isAlive) {
    return;
  }

  this.event.unbindAll();
  remove(this.scrollbarX);
  remove(this.scrollbarY);
  remove(this.scrollbarXRail);
  remove(this.scrollbarYRail);
  this.removePsClasses();

  // unset elements
  this.element = null;
  this.scrollbarX = null;
  this.scrollbarY = null;
  this.scrollbarXRail = null;
  this.scrollbarYRail = null;

  this.isAlive = false;
};

PerfectScrollbar.prototype.removePsClasses = function removePsClasses () {
  this.element.className = this.element.className
    .split(' ')
    .filter(function (name) { return !name.match(/^ps([-_].+|)$/); })
    .join(' ');
};

/* harmony default export */ __webpack_exports__["default"] = (PerfectScrollbar);


/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_index__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_toggle_classes__ = __webpack_require__(184);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  display: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  mobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps = {
  display: 'lg',
  mobile: false,
  tag: 'button',
  type: 'button'
};

var AppSidebarToggler = function (_Component) {
  _inherits(AppSidebarToggler, _Component);

  function AppSidebarToggler(props) {
    _classCallCheck(this, AppSidebarToggler);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.sidebarToggle = _this.sidebarToggle.bind(_this);
    return _this;
  }

  AppSidebarToggler.prototype.sidebarToggle = function sidebarToggle(e) {
    e.preventDefault();

    if (this.props.mobile) {
      document.body.classList.toggle('sidebar-show');
    } else {
      var display = this.props.display;
      var cssTemplate = 'sidebar-' + display + '-show';
      var _sidebarCssClasses$ = __WEBPACK_IMPORTED_MODULE_3__Shared_index__["b" /* sidebarCssClasses */][0],
          cssClass = _sidebarCssClasses$[0];

      if (display && __WEBPACK_IMPORTED_MODULE_3__Shared_index__["b" /* sidebarCssClasses */].indexOf(cssTemplate) > -1) {
        cssClass = cssTemplate;
      }
      Object(__WEBPACK_IMPORTED_MODULE_4__Shared_toggle_classes__["a" /* default */])(cssClass, __WEBPACK_IMPORTED_MODULE_3__Shared_index__["b" /* sidebarCssClasses */]);
    }
  };

  AppSidebarToggler.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        className = _props.className,
        children = _props.children,
        Tag = _props.tag,
        attributes = _objectWithoutProperties(_props, ['className', 'children', 'tag']);

    delete attributes.mobile;
    delete attributes.display;

    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-toggler');

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({ type: 'button', className: classes }, attributes, { onClick: function onClick(event) {
          return _this2.sidebarToggle(event);
        } }),
      children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'navbar-toggler-icon' })
    );
  };

  return AppSidebarToggler;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AppSidebarToggler.propTypes =  false ? propTypes : {};
AppSidebarToggler.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (AppSidebarToggler);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var propTypes = {
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['', 'alt'])]),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['', 'lg', 'sm']),
  checked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  defaultChecked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  defaultValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  form: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['checkbox', 'radio']),
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['', '3d', 'pill']),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dataOn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dataOff: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps = {
  color: 'secondary',
  label: false,
  outline: false,
  size: '',
  checked: false,
  defaultChecked: false,
  disabled: false,
  required: false,
  type: 'checkbox',
  variant: '',
  dataOn: 'On',
  dataOff: 'Off'
};

var AppSwitch = function (_Component) {
  _inherits(AppSwitch, _Component);

  function AppSwitch(props) {
    _classCallCheck(this, AppSwitch);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.onChange = _this.onChange.bind(_this);
    _this.state = {
      checked: _this.props.defaultChecked || _this.props.checked,
      selected: []
    };
    return _this;
  }

  AppSwitch.prototype.onChange = function onChange(event) {
    var target = event.target;
    this.setState({
      checked: target.checked
    });

    if (this.props.onChange) {
      this.props.onChange(event);
    }
  };

  AppSwitch.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.checked !== prevProps.checked) {
      this.setState({
        checked: this.props.checked
      });
    }
  };

  AppSwitch.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        disabled = _props.disabled,
        color = _props.color,
        name = _props.name,
        label = _props.label,
        outline = _props.outline,
        size = _props.size,
        required = _props.required,
        type = _props.type,
        value = _props.value,
        dataOn = _props.dataOn,
        dataOff = _props.dataOff,
        variant = _props.variant,
        attributes = _objectWithoutProperties(_props, ['className', 'disabled', 'color', 'name', 'label', 'outline', 'size', 'required', 'type', 'value', 'dataOn', 'dataOff', 'variant']);

    delete attributes.checked;
    delete attributes.defaultChecked;
    delete attributes.onChange;

    var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'switch', label ? 'switch-label' : false, size ? 'switch-' + size : false, variant ? 'switch-' + variant : false, 'switch' + (outline ? '-outline' : '') + '-' + color + (outline === 'alt' ? '-alt' : ''), 'form-check-label');

    var inputClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('switch-input', 'form-check-input');

    var sliderClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('switch-slider');

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'label',
      { className: classes },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({ type: type, className: inputClasses, onChange: this.onChange, checked: this.state.checked, name: name, required: required, disabled: disabled, value: value }, attributes)),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: sliderClasses, 'data-checked': dataOn, 'data-unchecked': dataOff })
    );
  };

  return AppSwitch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AppSwitch.propTypes =  false ? propTypes : {};
AppSwitch.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (AppSwitch);

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);
var bind = __webpack_require__(186);
var Axios = __webpack_require__(414);
var defaults = __webpack_require__(117);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(190);
axios.CancelToken = __webpack_require__(429);
axios.isCancel = __webpack_require__(189);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(430);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 413 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(117);
var utils = __webpack_require__(17);
var InterceptorManager = __webpack_require__(424);
var dispatchRequest = __webpack_require__(425);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 415 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(188);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);
var transformData = __webpack_require__(426);
var isCancel = __webpack_require__(189);
var defaults = __webpack_require__(117);
var isAbsoluteURL = __webpack_require__(427);
var combineURLs = __webpack_require__(428);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(17);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(190);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(432);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(45), __webpack_require__(259)(module)))

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports = {"broadcast_message":{"abort_question_1":"Are you sure that you want to","abort_question_2":"this notification?","target_types":{"custom":"Custom","clients":"Clients","providers":"Providers","email":"Email","everyone":"Everyone","branch_admins":"Branch admins"},"table_columns":{"target_type":"Target type"}},"admin_details":{"edit_admin_info":"Edit information","email_sended":"It has been sent an email, please verify your inbox to change your password","sms_notifications":"Notification settings","password_change_msg":"To change your password, click","password_change_msg2":"here","security_settings_tab":"Security","security_title":"Change password","select_language":"Select your language"},"reports":{"generate":"Generate","type":"Type","reports":"Reports","goods_out_stock":"Goods out stock","in_queue":"In queue","generating":"Generating","failed":"Failed"},"app":{"confirm_token_route":"Confirm User Token","continue_route":"Continue with your sign up","login_route":"Login","password_reset":"Password Reset","register_route":"Signup","set_new_password":"Generate new password"},"calendar":{"week_days":"Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday","week_days_capitals":"S,M,T,W,T,F,S"},"client_details":{"ratings_made":"Califications","orders_made":"Orders","to":" to "},"notification_status":{"aborted":"Aborted","cancelled":"Cancelled"},"common":{"attention":"Attention","loading":"Loading...","this_featured_product":"Featured products","featured_product":"Featured product","is_visible":"Is visible","is_featured":"Is featured","provider_balance":"Provider balance","section":"Sections App","fixed":"Fixed","delay":"Delay","time_range":"Time range","time_available":"Time available","deleted":"Deleted","all":"All","not_visible":"Not visible","visible":"Visible","receiver_name":"Receiver name","created":"Created for","updated":"Updated for","max_quantity":"Max quantity","limit_type":"Limit type","per_order":"Per order","per_day":"Per day","per_week":"Per week","per_month":"Per month","base_price":"Base price","hour_beg":"Hour beging","hour_end":"Hour end","subtotal":"Subtotal","used":"Used","discount":"Discount","fixed_amount":"Fixed amount","available_code":"Available code","used_codes":"Used codes","used_code":"Used code","set_ready":"Set ready","branch_group":"Branch group","branch_groups":"Branch groups","attach":"Attach","amount":"Coupon amount","promo_code":"Promo code","applies_to":"Applies to","personal":"Personal","coupon":"Coupon","coupons":"Coupons","ready":"Ready","generating":"Generating","pending":"Pending","min_purchase":"Min purchase","max_discount":"Max discount limit","amount_limit":"Amount to reach the maximum discount limit","running":"Running","finished":"Finished","promo":"Promo","promos":"Promos","batch":"Batch","inventory":"Inventory","commercial_agreements":"Commercial agreements","tittle":"Tittle","invalid_target":"Invalid target","image_not_set":"Image required","in_order":"In numeric order","admin":"Admin","branch":"Branch","branches":"Branches","branch_good":"Branch Product","branch_goods":"Branch Products","enable_multi_providers":"Enable multiproviders","enable_multi_providers_des":"Allow an order to be served by more than one service provider.","assigned_provider":"Assigned provider","change_stock":"Change product cant","choose_clients":"Please choose a client","assing_client":"Asign clients","assing_company":"Assing company","select_vendor":"please select a vendor...","main_seller":"Main seller","asign_vendor":"Asign vendors","no_vendors_msg":"No hay vendedores anexados aun","no_clients_msg":"No hay clientes anexados aun","payment_approved":"Pago(s) aprobado(s)","payment_pending":"Pago(s) pendiente(s)","payment_reported":"Pago(s) reportado(s)","list_type":"List type","add_tag":"Add tag","delivery_fee":"Delivery fee","tag":"Tag","goods_tags_list":"Goods tags list","goods_tags":"Goods tags","temporary_email":"Temporary email","customize_form":"Customize form","point_of_sale":"Point of sale","payment_type":"Payment type","last_digits_issuing_account":"Last 4 digits of the issuing account","confirmation_number":"Confirmation No.","same":"The same","banks_transfer":"Which one do you transfer from?","banks_select":"Select one of our banks","screenshot":"Screenshot","payment_issuing_phone":"Payment Issuing Phone","operacion_number":"Operacion number","origin_bank":"Origin bank","wire_transfer":"wire transfer","required_skills":"Required skills","skill":"Skill","skills_group":"Skills group","skills_group_list":"Skills group list","attach_service_skills":"Attach service skills","socials":"Social networks","login":"Login","payment_date":"Payment date","form":"Form","form_type":"Form type","notifications":"Notifications","icon":"Icon","no_client_address_title":"No address","no_have_option_yet":"No have option yet","template":"Template","mandatories_properties":"The following characteristics are mandatories","units":"Units","actions":"Action","accept":"Accept","add":"Add","admins":"Admins","admin_types":"Admin types","admin_details_breadcrumb":"Profile","fleet":"Fleet","fleet_edit":"Edit Fleet","alert_int_service":"Company OUT OF SERVICE. At this time, you can NOT create or receive orders","alert_no_phone_company":"Important information missing, please configure: Company phone","alert_unconfigured_payment_methods":"Before setting up your payment methods, you must enter the conversion rate to US$","all_feminine":"All","allow_sms_notifications":"Allow SMS notifications","assign":"Assign","ativate_now":"Activate now!","available_by":"Available by","avatar":"Avatar","back_button":"Back","biggest_profit":"Profit","biggest_sales":"Sale","cancel":"Cancel","cash":"Cash","categories":"Categories","company_categories":"Company categories","branch_category":"Categoría de comercio","branch_categories":"Categorías de comercio","branch_subcategories":"Subcategorías de comercio","client":"Client","clients":"Clients","company_billings":"Company billings","invoices":"Invoices","invoices_lot":"Invoices lot","invoice":"Invoice","company_charges":"Mis cobros","company_settings":"Company settings","complete":"Complete","confirm":"Confirm","confirmation_question":"Are you sure you want to ","continue":"Continue","create":"Create","current":"Current","current_plan":"Current plan","daily":"Daily","days":"Day(s)","delete":"Delete","deliver":"Deliver","delivery":"Delivery","delivery_guy":"Delivery guy","deliverer":"Deliverer","description":"Description","details":"Details","disable":"Disable","disabled":"Disabled","display_name":"User","edit":"Edit","email":"Email","enable":"Enable","enabled":"Enabled","expired":"Expired","filter_placeholder":"Filter...","finance":"Finance","good":"Good","goods":"Goods","goods_list":"Goods list","hide":"Hide ","home":"Home","image":"Image","invoice_list":"Invoice list","list":"List","manual_payment":"Manual payment","manual_payment_report_of_order":"When receiving manual payment report of an order.","mixed":"Mixed","method":"Method","monthly":"Monthly","see_all":"See all","my_account":"My Account","name":"Name","next":"Next","no_results_msg":"No results","number":"Number","numeric":"Numeric","order":"Order","order_number_msg":"Order #","orders":"Orders","balance":"Balance","temporal_balance":"Temporal balance","payment_confirm":"Validate payment","payment_report_of_order":"Upon receiving payment report of an order.","phone":"Phone","pickup":"Pickup","pinned":"Pinned","prepaid":"Prepaid","price":"Price","pricelist":"Price list","property":"Feature","properties":"Features","provider":"Provider","providers":"Providers","rating":"Rating","refresh":"Refresh","restore":"Restore","save":"Save","search_button":"Search","search_placeholder":"Search...","select_placeholder":"Select...","select_type":"Select type","send_email":"Send email","send_sms":"Send SMS","send_notification":"Send notification","send_password_recovery":"Send password recovery","service":"Service","service_provider":"Service provider","services":"Services","settings":"Settings","shopper":"Shopper","show":"Show","show_completed":"Show completed","sold":"Sold","start":"Start","status":"Status","stock":"Stock","success":"Success!","this_table_not_have_data_yet":"This table not have data yet","to_file":"File","suspend":"Suspend","lay_off":"Lay off","today_uncompleted_orders":"Today uncompleted orders","today_unconfirmed_orders":"Today unconfirmed orders","total":"Total","trial":"Trial mode","trial_description":"To receive push notifications on desktop and have a better experience you must allow notifications. Thank you!","trial_description_fail":"Your subscription can not be activated","type":"Type","unlimited":"Unlimited","update":"Update","user":"User","user_id":"User ID","user_request_help":"When a user requests help.","verify":"Verify","waiting_message":"Loading...","when_cancels_an_order":"When a user or supplier cancels an order.","when_creating_order":"When creating an order.","target":"Target","gift_card":"Gift card","cities":"Cities","city":"City","access":"Access","default_view":"Default view","deductions":"Deductions","from":"From","to":"To","address":"Address","addresses":"Addresses","active":"Active","inactive":"Inactive","geofence":"GeoFence","valid":"Valid","invalid":"Invalid","fleets":"Fleets","service_suppliers":"Service suppliers","service_profiles":"Service profiles","service_charges":"Service charges","retry":"Retry","pay":"Pay","pos_serial":"POS","inbox":"Inbox","associations":"Associations","go_to_page":"Go to page","go":"Go","available":"Available","used_female":"Used","close":"Close","webhooks":"Webhooks","word":"Word","promotional_banners":"Promotional banners","special":"Special","try_again":"Try again"},"confirmation":{"back_button":"Back home","confirm_password":"Confirm password","error_description_msg":"Error at confirmation","error_explanation_title":"We're sorry!","password":"Password","password_recovery":"Password recovery","register_button":"Register"},"create_order":{"address_searchbox_placeholder":"E.g.: address, city, state, country","back_button":"Back","cart_tab_title":"Cart","client_address_title":"Client address","client_searchbox_placeholder":"Search by email, username, name or phone","client_tab_title":"Client","confirm_select_provider_btn":"Select one","delivery_method_asap":"ASAP","delivery_method_other":"Other","delivery_method_title":"Date and time of delivery","delivery_tab_title":"Delivery","error_category_unavailable":"Unknow category action.","error_property_unavailable":"Cannot map an input type for this feature.","filter_by":"Filter by","good_has_no_properties_msg":"This good has no features","modal_create_client_title":"Create a new client","no_provider_warning_msg":"Are your sure you don't want to assign a provider?","order_instructions_title":"Special instructions","order_title":"Order","pickup_option_title":"Type of delivery","place_order_button":"Place order","go_to_checkout_button":"Go to checkout","properties_panel_placeholder_msg":"Select an image item to display additional options...","properties_title":"Features","provider_searchbox_placeholder":"Search by email, username, name or phone","quantity":"Quantity","register_client_tooltip_msg":"Register new client","search_input_placeholder":"Search...","search_title":"Search","select_client_label":"Select client","select_placeholder":"Choose...","select_provider_title":"Select provider","start_price_hint_msg":"From","total":"Total","unknow_type_parameter":"Unknow type parameter.","loading_cart":"Loading cart...","articles":"Articles","delete_item":"Delete item","delete_item_confirmation":"The following product will be removed from the cart","delete_item_confirmation_2":"Are you sure you want to delete this item?","clear_cart":"Clear cart","empty_cart":"The cart is empty","add_articles":"Add articles to start","clear_cart_confirmation":"Are you sure you want to clear the cart?","clear_cart_confirmation_2":"All articles will be removed from the cart","get_back_to_cart":"Get back to cart","checkout_step_1":"Address","checkout_step_2":"Payment","checkout_step_3":"Summary","go_to_step_2":"Go to payment methods","go_to_step_3":"Go to summary","pickup_now":"Now","pickup_later":"Schedule","total_to_pay":"Total to pay","add_prom_code":"Add promotion code","prom_code_placeholder":"The promotion code must have between 5 and 20 characters","apply":"Apply","use_balance":"Use ZupperCredits","applied_prom_code":"Promotion code applied successfully","estimated_time_asap":"Estimated delivery time","estimated_time_later":"The order was scheduled for","delivery_address":"Delivery address","pickup_address":"Pickup address","is_a_gift":"Is a gift","order_success":"Order created successfully","order_success_2":"created successfully","order_success_3":"Do you want to go to the recently created order?","continue_cart":"Continue creating another order","select_payment_method":"Select payment method","recreate_order":"Recreate order","recreate_order_question":"Are you sure you want to recreate the order ","recreate_order_question_2":"This action will clear the current cart of the client {clientName} in the branch {branchName}","order_created_by":"Order created by the admin","delivery_schedule":"Delivery schedule","delivery_date":"Delivery date","delivery_hour":"Delivery hour","pickup_at":"Pickup at","client_incomplete_profile":"Incomplete profile","client_imcomplete_profile_info":"The user {name} is missing the following data:","cashback_message":"This purchase will have a cashback of {cashback}","no_payment_method":"Select after"},"custom_errors":{"conflict":"The entity already exists","attached_good":"Attached services/Goods","attached_goods":"Attached services","attached_properties":"Attached properties","app_status":"Failed to check mobile app status","attach_category_product":"Error attach this category","cancelation_reason_delete_failed":"Cancelation reason delete failed","cancelation_reason_registration_failed":"Cancelation reason registered failed","cancelation_reason_update_failed":"Cancelation reason update failed","category_delete_failed":"category delete failed","category_registration_failed":"Category registration failed","category_update_failed":"category update failed","client_addres_to_long":"The address must be less than 255 characters.","company_delete_failed":"company delete failed","company_update_failed":"company update failed","date_prior_today":"Date cannot be set before today, when it's not an annual holiday","email_not_sent":"Email not sent","empty_fields":"Write in the required fields","empty_shopping_cart":"Empty shopping cart","form_delete_failed":"form delete failed","form_registration_failed":"form registered failed","form_update_failed":"form update failed","good_delete_failed":"Goods delete failed","good_registration_failed":"Goods registered failed","good_update_failed":"Goods update failed","in_service_locked":"You cannot edit products or features while the company is 'In service'","insert_client":"You must enter a client","insert_client_addres":"You must enter client address","insufficient_stock_title":"Stock limits reached","insufficient_stock_msg":"Some product exceeds the limits in stock.","order_canceled":"Order canceled","order_cancel_failed":"Order cancel failed","order_complete":"Error completing order","order_confirm":"Error confirming order","order_delete_failed":"Order delete failed","order_deliver":"Error delivering order","order_registration_failed":"Order registered failed","order_start":"Error starting order","order_update_failed":"Order update failed","pament_accep":"Error accepting order payment","provider_attach_failed":"Failed provider update","required_fields":"This fields are required: {fields_list}","retrieving_cancelation_reason":"Error retrieving cancelation reason","retrieving_cancelation_reasons_list":"Error retrieving cancelation reasons list","retrieving_categories":"Error retrieving categories list","retrieving_categories_product":"Error listing product categories","retrieving_category":"Error retrieving category","retrieving_company":"Error retrieving company","retrieving_form":"Error retrieving form","retrieving_forms_list":"Error retrieving forms list","retrieving_goods":"Error retrieving good","retrieving_goods_list":"Error retrieving goods list","retrieving_order":"Error retrieving order","retrieving_order_list":"Error retrieving order list","retrieving_proof_of_delivery":"Error retrieving proof of delivery","retrieving_today_order_list":"Error retrieving today order list","retrieving_user_data":"Error retrieving user data","retrieving_user_list":"Error retrieving user list","select_complete_address":"You must select a complete address","unavailable_product__title":"Product unavailable","unavailable_product__msg":"The {type} {product} is not available","update_categories_product":"Error update product categories","user_delete_failed":"User delete failed","user_registration_failed":"User registration failed","user_already_exist":"User's email alredy exist","user_restore_failed":"User restored failed","user_update_failed":"User update failed","an_error_has_ocurred":"An error has ocurred while fetching data","pay_invoice_failed":"An error has ocurred while paying the invoice","delete_invoice_failed":"An error has ocurred while deleting the invoices","image_fail_default":"An error has occurred while loading the image","image_fail_message":"The image has invalid dimensions, please try again.","pos_serial_format":"The serial of the POS does not meet the required format","rif_format":"The rif does not meet the required format","pos_serial_conflict":"The serial of the POS is already assigned to another rider. Please verify and try again.","rif_conflict":"The rif is already registered. Please verify and try again.","default_error":"An error has occurred","target_invalid_payment_method":"{target} does not have valid payment methods configured"},"custom_success":{"admin_updated":"The admin user was updated","delete_successful":"Deleted data","email_sent":"Email sent","restored_user":"Restored user","saved_successful":"Saved data","saved_successful_product":"Saved product, please add categories and/or properties","update_successful":"Updated data","givechange_successful":"Successful refund","edit_order_successful":"Order edited","resend_pool_successful":"The order is back in the pool","pay_successful":"Payment successful"},"dashboard":{"activity":"Activity","all":"All","yesterday":"Yesterday","week":"This week","month":"Month","this_month":"This month","custom":"Custom","asap":"ASAP","average_title":"Average","buttons_menu_label":"Orders ongoing","canceled":"Canceled","consumption":"Consumption","completed":"Completed","filter_greater_profit":"Greater profit","filter_greater_sells":"Greater sells","filter_lower_profit":"Lower profit","filter_lower_sells":"Lower sells","filter_greater_frequency":"Greater frequency","filter_greater_consumption":"Greater consumption","filter_lower_frequency":"Lower frequency","filter_lower_consumption":"Lower consumption","frequency":"Frequency","last_time_bought_label":"Last time bought","less":"Less","more":"More","no_client_msg":"Your clients have not registered orders.","no_sells_msg":"There are no sales records","order_by":"Order by","orders_confirmed_today":"Confirmed","orders_created_today":"Received","orders_msg_warning":"Today orders will be added at the end of the day","orders_recived_today":"Active orders ","pendings":"Pending","report_selector":"Report","today":"Today","today_canceled_orders":"Canceled Orders","today_earnings":"Total earnings","today_ended_orders":"Ended Orders","today_orders":"Orders ongoing today","today_scheduled_orders":"Scheduled","tooltip_received_orders":"Amount of orders received until ","tooltip_daily_orders":"Show information from daily orders in the current month","tooltip_monthly_orders":"Show information from monthly orders in selected month","tooltip_current_orders":"Show information from orders until last fulfilled date","tooltip_completed_orders":"Amount of orders completed until date ","tooltip_uncompleted_orders":"% of uncompleted orders in ","tooltip_canceladas_orders":"% of canceled orders in ","tooltip_asap_orders":"Amount of uncompleted ASAP orders by ","tooltip_scheduled_orders":"Amount of uncompleted scheduled orders by ","tooltip_orders_earnings":"Total earnings from orders created until ","tooltip_orders_concilied":"Total earnings conciliated from orders created until ","ttoday_earnings":"Expected earnings","uncompleted":"Uncompleted","uncompleted_label":"Uncompleted","total":"Total","branch_statistics":"Branch statistics","branch_group_statistics":"Branch group statistics","select_branch":"Select a branch"},"default_aside":{"aside_menu_title":"Today Orders","aside_notifications_title":"Notifications","assgined_badge_tooltip":"Assigned Providers","confirm_unassign_modal_1":"Are you sure you want to ","confirm_unassign_modal_2":"this order?","delete_all_notifications":"Remove all","mark_notification_consumed":"Mark as read","modal_order_title":"Order ","no_pendings_msg":"No pending actions.","no_notifications_msg":"No notifications yet","pending_changes":"Pending changes","provider_assigned_msg":"Provider assigned","provider_unassigned_msg":"No provider assigned","shopper_unassigned_msg":"No shopper assigned","unassgined_badge_tooltip":"Providers Unassigned"},"default_header":{"company_dropdown_menu_title":"Company","create_order_button":"Create order","logout_button":"Log out","profile_button":"Profile","settings_button":"Settings"},"default_layout":{"accept_notifications_button":"Allow","notification_company_requires_payment":"Payment for Zupper services has expired, we recommend you contact our team.","notification_requirement_msg":"To enjoy of all the Zupper features, you'll need to allow notifications from our app. Thank you!"},"dropzone":{"change_image":"Add image","drag_drop_image_here":"Drag and drop your image here","files":"Images","image_fail_message":"Images can be a maximum of 1 MB and only .jpg and .png formats are allowed","upload_file_tip":"Place up to 4 images here or click to select files.","upload_file_tip2":"Consider that the images should weigh up to 1 MB and be .jpg or .png format"},"droznone_errors":{"maximum_quantity_allowed":"Maximum images quantity allowed"},"errors":{"missing_targets":"Please attach branch group / Goods","invalid_credentials":"Invalid username / password","network_error":"You have conectivity problems. Try again.","not_allowed":"Not allowed","already_completed":"Already completed","already_prepared_title":"Already prepared","already_prepared":"This order has already been prepared, please update","account_blocked_des":"Sorry, your account has been blocked","account_disabled_des":"Sorry, your account has been disabled","account_mismatches_des":"The account does not correspond with your data in our Database","account_unconfirmed_des":"You must confirm your account to be able to access","already_exists_des":"This resource already exists in Database","already_exists_title":"Permission error","bad_schedule_des":"The entered date is incorrect","company_disabled":"Company requires payment","company_in_service_title":"Company in service","company_in_service_msg":"To complete this operation, the company settings must be out of service.","des_429":"Request limit reached","feature_disabled_des":"The administrator has disabled this functionality","invalid_credentials_des":"Invalid username / password","invalid_data":"Validation errors","on_delete_des":"Could not be deleted correctly","on_restore_des":"The item could not be restored correctly","order_requires_auth_from_commerce":"This order requires authorization from the commerce to complete the preparation","target_too_high_des":"Your account does not have the privileges to perform this action","title_400":"Failed to process the request.","title_401":"Please login","title_403":"Access denied","title_404":"The resource was not found","title_405":"This resource already exists in Database","title_409":"In conflict with another resource.","title_422":"The given data is not valid","title_429":"The server has received many requests, if there is a lack of data you can try reloading the site","token_expired_des":"Session has expired","token_invalid_des":"You signed in with this account on another device","token_invalid_des2":"Invalid Token","token_not_provided_des":"Missing data in your request","unknown_error.":"Unknown Error","payment_error":"An error occurred while making the payment"},"firebase":{"accepted_bid__msg":"Provider has accepted order # {number}","accepted_bid__title":"Order accepted","accepted_default__msg":"It has been accepted {type}","accepted_default__title":"Admin Updates","accepted_order__msg":"Order # {number} has been accepted","accepted_order__title":"Order accepted","accepted_payment__msg":"Payment has been accepted successfully","accepted_payment__title":"Payment accepted","assigned_bid__msg":"There is an assigned order","assigned_bid__title":"Assigned order","assigned_default__msg":"There is a new assigned {type}","assigned_default__title":"Admin Updates","assigned_order__msg":"The order # {number} has been assigned to {provider}","assigned_order__title":"Assigned order","available_bid__msg":"There providers waiting for order","available_bid__title":"Order available","available_default__msg":"New {type} is available","available_default__title":"Admin Updates","available_good__title":"Available product/service","available_good__msg":"{name} it is available","available_order__msg":"Order # {number} is available","available_order__title":"Available order","available_payment__msg":"There is a new payment available","available_payment__title":"Payment available","available_provider__msg":"There is a new provider available","available_provider__title":"Provider available","canceled_default__msg":"The {type} was canceled","canceled_default__title":"Admin Updates","canceled_order__msg":"Order # {number} was canceled","canceled_order__title":"Order canceled","canceled_payment__msg":"There is a new payment that has been canceled","canceled_payment__title":"Payment canceled","changed_company__msg":"Modifications have been made to the configuration of the company","changed_company__title":"Company settings has been modified","changed_default__msg":"There are new changes in {type}","changed_default__title":"Admin Updates","client_denied_notification__alert":"So sad, but if you still want to get updates from new orders or new clients in real time, you can unblock notifications manually. Sincerely, Zupper","completed_default__msg":"New {type} was created","completed_default__title":"Admin Updates","completed_order__msg":"Order # {number} has been completed","completed_order__title":"Completed Order","default__msg":"There are new changes in the app, click to open the app.","default__title":"Admin Updates","for_delivery_default__msg":"On destination {type}","for_delivery_default__title":"Admin Updates","for_delivery_order__msg":"Order # {number} has arrived, waiting for client","for_delivery_pickup_order__msg":"Order # {number} is ready for pick up","for_delivery_order__title":"Order at destination","new_default__msg":"New {type} was created","new_default__title":"Admin Updates","new_order__msg":"There is a new order # {number}","new_order__title":"New order","new_bid__msg":"","new_bid__title":"New bid request from provider","new_payment__msg":"There is a new registered payment","new_payment__title":"New Payment","new_rating__msg":"There is a new rating","new_rating__title":"New Rating","new_clientrating__msg":"A client rated an order","new_clientrating__title":"New client rate","progress":"progress","refused_bid__msg":"Provider unassigned to order # {number}","refused_bid__title":"Order rejected","refused_default__msg":"It has been rejected {type}","refused_default__title":"Admin Updates","started_default__msg":"A {type} has been started","started_default__title":"Admin Updates","started_order__msg":"Order # {number} is in {status_type}","started_order__title":"Order in {status_type}","the_way":"way","unassigned_default__msg":"There is an unassigned {type}","unassigned_default__title":"Admin Updates","unassigned_order__msg":"Order # {number} has no provider","unassigned_order__title":"Unassigned order","unavailable_good__title":"Unavailable product/service","unavailable_good__msg":"{name} is unavailable","unavailable_default__msg":"The {type} is not available","unavailable_default__title":"Admin Updates","unavailable_order__msg":"Order # {number} is not available","unavailable_order__title":"Order not available","unavailable_provider__msg":"There is a provider not available","unavailable_provider__title":"Provider not available","unsupported_service_worker__alert":"Apparently, your browser is not suitable for all the features offered by Zupper, we recommend to update it and if that does not work use an alternative browser. Sincerely, Zupper","welcome_notification__msg":"Through these notifications we will keep you updated of everything about your Zupper app","welcome_notification__title":"Setup successful!"},"form_client":{"head_title_create":"Add provider","head_title_update":"Update provider"},"form_properties":{"add_item_button":"Add item","base_price_label":"Base price","decimates_label":"Decimals","default_label":"Default value","mandatory_label":"Mandatory","max_label":"Maximum","min_label":"Minimum","step_price_label":"Step price","steps_label":"Steps","text_label":"Text"},"good_details":{"available":"Available","categories_title":"Categories","comment":"Comment","details":"Details","disabled":"Disabled","eta":"ETA","in_stock":"In stock","no_categories_msg":"No categories have been added","no_properties_msg":"No features have been added","no_ratings_msg":"No ratings available","option":"Option","pinned":"Pinned","price":"Price","price_range":"Price range","properties_title":"Features","quantity_range":"Quantity range","rate":"Rate","sold_out":"Sold out","step_price":"Steps / Price by step","unavailable":"Unavailable","unpinned":"Unpinned","choose_up_to":"Choose up to {max} options.","choose_min":"Choose at least {min} options.","special_instructions":"Special instructions","special_instructions_disclaimer":"This field does not accept modifications that generate additional value in the invoice.","materials":"Materials","notes_enabled":"Notes enabled"},"http_codes":{"200":"Successful operation","201":"It has been created successfully","204":"Successful operation","400":"Server couldn't process the request","401":"You must login to access this resource","403":"Access denied","404":"We couldn't find what you are looking.","409":"Error! The resource your trying to modify can't be changed","422":"Validation error","400_error_deleting":"Error at deleting ","400_error_restoring":"Error at restoring ","400_token_invalid":"Invalid Token","401_token_expired":"Token is invalid. You must login to continue your session","401_token_not_provided":"There wasn't a header token in the request","403_account_blocked":"This account has been blocked to access this resource","403_account_disabled":"This account has been disabled","403_account_mismatches":"You are trying to access to a different company's account","403_account_unconfirmed":"This account must be confirmed before accessing this resource","403_feature_disabled":"This functionality has been disabled","403_target_too_high":"Error! You don't meet the privileges for this request","404_company_deleted":"Company doesn't exist in our database","404_company_disabled":"Company has been disabled","404_not_allowed":"You can't access this resource","404_not_found":"We couldn't find this resource","404_user_not_found":"User doesn't exist in our database","409_already_exists":"Error! This resource already exists","422_mismatch":"Error! Mismatch","action_already_performed":"Action already performed","general_error":"An unexpected error has occurred, we'll try it doesn't happen again.","general_success":"Successful operation"},"invalidate_email":{"back_button":"Back to home","error_description_msg":"","error_explanation_title":"We're sorry!","invalidate_button":"Invalidate"},"login":{"accept_notifications_button":"Allow Zupper notifications","forgot_password_link":"Forgot password?","login_button":"Login","login_subtitle":"Sign in to your account","login_title":"Welcome to","password_placeholder":"Password","reset_link":"Send password reset link"},"map_view":{"assign_order_msg":"Assign order","assign_provider_msg":"Assign provider","assign_providers_msg":"Assign providers","assign_shopper_msg":"Assign shopper","assigned_to_msg":"Assigned to:","client_title":"Client:","company_location_tooltip":"Company location","filter_providers":"Providers filters","geolocate_company":"Go home","geolocation_compatibility_error":"Your browser doesn't have geolocation capabilities, we recommend to update it. Zupper","map_filter_assigned":"Assigned","map_filter_goods":"Goods","map_filter_available_providers":"Available Providers","map_filter_offline_providers":"Offline Providers","tooltip_filter_dates":"Filter ordered by date","tooltip_filter_status_orders":"Filter by order status","tooltip_filter_branches_in_service":"Filter by branches in service","view_orders_at_date":"View orders by","order_type":"Order type","order_status":"Order status","day":"Day","week":"Week","month":"Month","map_filter_services":"Services","map_filter_unassigned":"Unassigned","map_filter_unavailable_providers":"Unavailable Providers","map_filter_today_orders":"Today orders","map_filter_this_week_orders":"Week orders","map_filter_this_month_orders":"Month orders","map_searchbox":"Search...","map_searchbox_order":"Find an order...","map_searchbox_provider":"Find a provider...","more_details_msg":"More details","order_list_modal_title":"Orders List","provider_list_modal_title":"Providers List","provider_list_modal_title_multi":"MultiProviders List","provider_title":"Assigned to:","unassigned":"Unassigned","unassigned_provider_msg":"No provider assigned","unassigned_shopper_msg":"No shopper assigned","unavaliable_provider_msg":"No providers Avaliables","unavaliable_shopper_msg":"No shoppers Avaliables","zoom_in":"Zoom In","zoom_out":"Zoom Out"},"modal_assign_order":{"address":"Address","assign":"Assign","cancelation_resons_title":"Please give a short description about the reasons for cancellation","no_provider_msg":"No provider assigned","manual_assignment":"Manual assignment","provider_searchbox_placeholder":"Search for providers...","shopper_searchbox_placeholder":"Search for shoppers..."},"modal_cancel_order":{"cancelation_resons_title":"Write the reasons for cancellation","cancelate_completed_order_resons_title":"Write the reasons why the order was not delivered","cancelation_resons_title2":"Select the reasons for cancellation"},"modal_categories":{"pinned":"Pinned"},"modal_categories_good":{"no_categories_msg":"No categories available","select_choose_category":"Choose a category..."},"modal_goods":{"available":"Available","details":"Description","eta":"Delivery time","is_service_boolean":"It is a service","picture":"Image","price":"Price","short_details":"Short description","unavailable":"Unavailable","warning_change_good_name":"Warning: Please beware that this change could affect negatively the user perception of this good, ratings, etc."},"modal_order":{"notes":"Notes","scheduled_at":"Scheduled for:","status_title":"Status:"},"modal_properties":{"add_item_button":"Add item","available":"Available","base_price_label":"Base price","custom_label":"Custom input","decimates_label":"Decimals","default_label":"Default value","disabled":"Disabled","mandatory_email_label":"Mandatory Email","email_label":"Email","hint_label":"Hint","max_label":"Maximum","min_label":"Minimum","number_label":"Number input","mandatory_number_label":"Mandatory number input","price_placeholder":"Price","sold_out":"Sold out","step_price_label":"Step price","steps_label":"Steps","texto_label":"Text input","mandatory_text_label":"Mandatory text input","type_label":"Feature type"},"modal_properties_good":{"choose_property_searchbox":"Select an ETA","display_name":"Display name","no_properties_msg":"No features available","property_arrows":"Arrows","property_checkbox":"Multiple selection","property_dropdwn":"Dropdown","property_input_numeric":"Input Numeric","property_radio":"Single selection","property_seek_bar":"Seek bar","property_spinner":"Spinner","property_switch":"Switch","property_toggle":"Toggle"},"order_details":{"addres":"Address","bid_rejected_msg":"Bid rejected","bid_waiting_client_confirm_msg":"Client must confirm","client_information_title":"Client Information","created_at":"Requested","delivery_method_asap":"ASAP","details":"Details","no_provider_assigned_msg":"No provider assigned","notes":"Notes","payment_modal_title":"Payment modal","download_order":"Download Order","download_invoice":"Download Invoice","phone":"Phone","property_title":"Feature","provider_available_label":"Available","provider_busy_label":"Busy","provider_off_label":"Offline","provider_information_title":"Provider Information","quantity":"Quantity","scheduled_at":"Schedule for","selection_title":"Selection","status":"Status","waiting_confirmation_msg":"Providers waiting for confirmation","applies_to":"Applies to","type":"Type","Used":"Used","total_limit":"Total limit","starts":"Starts","ends":"Ends","not_applicable":"Not applicable","admin_notes":"Admin notes","affect_provider_balance":"Affect {provider} balance","cancel_provider_earnings":"Cancel {provider} earnings","client_balance_warning":"This option will affect client's wallet","provider_balance_warning":"This option will affect the {provider} wallet","provider_earnings_warning":"This option will cancel the {provider} earnings","client_balance_warning_header":"this action will affect branch's invoice","unit_price":"Unit price","total_price":"Total price","edit_order":"Edit order","alert_modify_product":"You are about to {action} the following product:","alert_delete_product":"You are about to delete the following product:","action_not_reversible":"This action cannot be undone.","action_could_have_consecuences":"This action could affect discounts or special promotions.","original_goods":"Original goods","added":"Good added","updated":"Good updated","removed":"Good removed","generate_coupon":"Generate coupon","generate_order_coupon":"Generate coupon for order","generate_order_coupon_warning":"The coupon will be generated in base to the total amount paid and it will be sent to the client's email","total_paid":"Total paid","select_discount":"Select discount","select_reason":"Select reason","admin_note_content":"The coupon {couponName} was generated with the following reason:","order_coupon_name":"Coupon for client {clientName}","coupon_generated_success":"Coupon generated successfully!","coupon_generated_message":"The coupon has been created and is ready to be activated.","coupon_activation_hint":"You can activate it now or later from the coupons table. If you activate it now, the coupon will have a validity of 30 days, otherwise, it will not have an expiration date.","activate_now":"Activate now","activate_later":"Activate later","coupon_code_title":"The coupon is being activated","coupon_code_hint":"After activation, the client will receive an email with the coupon code.","order_coupon_additional_comments":"Additional comments"},"order_status":{"not_started":"Not started","started":"Started","all":"All","assigned":"Assigned","unassigned":"Unassigned","dispatched":"Dispatched","provider_arrived":"Provider arrived","expired":"Expired","payment_cash":"Payment cash","payment_pos":"Point of sale","not_delivered":"Not delivered","in_queue":"Confirmed","arrived":"Arrived","canceled":"Canceled","confirmed":"Paid","delayed":"Delayed","delivered":"Completed","not_completed":"Not completed","in_progress":"In progress","on_the_way":"On the way","payment_pending":"Pending payment","payment_to_validate":"Payment to validate","payment_refused_invalid":"Payment invalid","payment_refused_duplicated":"Payment duplicated","ready":"To deliver","scheduled":"Scheduled","uncompleted":"Uncompleted","unverified":"Unverified phone","unavailable":"Unavailable","unconfirmed":"Unconfirmed","start":"Start","not_apply":"Not apply","payment_mixed":"Mixed"},"page_404":{"message":"The page your looking for couldn't be found.","title":"Oops! You are lost."},"page_500":{"message":"The page your looking for is temporarily unavailable","title":"Houston, we have a problem!"},"payments":{"adjust":"Adjust","discount":"Discount","validate":"Validate","delivery_fee":"Delivery fee","delivery_details_fee":"Base delivery","service_fee":"Service fee","total_orden":"Total orden","approved_by":"Approved by","change":"Change","code":"Code","confirm_payment":"Confirm payment","confirmation_date":"Confirmation date","confirmed":"Confirmed","duplicated":"Duplicated","false":"False","invalidated":"Invalidated","refunded":"Refunded","mark_as_duplicated":"Mark as duplicated","mark_as_invalid":"Mark as invalid","mark_as_refunded":"Mark as refunded","no_payments_registered":"No payments registered yet","no_proof_of_delivery_registered":"There is not proof of delivery registered for this order.","no_registered_payments":"There are no registered payments yet","payment_canceled_by_client":"Payment canceled by client","payment_confirmed_by":"Payment confirmed by","payment_confirmed_by_custom":"Marked as paid by","payment_duplicated_by":"Payment marked as a duplicate by","payment_forms":"Payment report forms","payment_invalidated_by":"Payment invalidated by","payment_modal":"New payment form","payments_forms":"Payment information","payment_fee":"Payments fee","proof_of_delivery":"Proof of delivery","sub_total":"Subtotal","tax":"Tax","taxes":"Taxes","this_payment":" this payment?","payments_received":"Payments received","amount_owed":"Amount owed","tips":"Tips","total":"Total","true":"True","want_to_mark_as":"Are you sure you want to mark as ","without_approving":"Payment without approval","waiting":"Waiting","service_details":"Service details","report_payment":"Report payment","apply_payment_to_order":"Apply payment to this order","refunded_reason":"To continue, you must add a note explaining the reason for the refund","view_data":"View data","view_details":"View details","payment_details":"Payment details","amount":"Amount","date":"Date","source_account":"Source account","source_bank":"Source bank","source_phone":"Source phone","source_dni":"Source dni","transaction_id":"Transaction id","authorization_id":"Authorization id"},"plugins":{"calendar_months":"Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec","calendar_weeks":"Sun,Mon,Tue,Wed,Thu,Fri,Sat","next_week":"Next week","table":{"filterPlaceholder":"Filter...","contains":"Contains","notContains":"Not contains","startsWith":"Starts With","endsWith":"Ends With","equal":"Equal than","notEqual":"Not equal than","greaterThan":"Greater than","greaterThanOrEqual":"Greater or equal than","lessThan":"Less than","lessThanOrEqual":"Less or equal than","search_placeholder":"Search...","column_chooser":"Select columns","show_filters":"Filter data","clear_filters":"Clear all filters","archived_button":"Show archived","no_archived_button":"Show Actives"},"today":"Today","tomorrow":"Tomorrow"},"provider_details":{"active_orders_title":"Active orders","ratings":"Ratings","no_ratings_msg":"No ratings available","earnings":"Earnings","aborted_count":"Aborted orders","earnings_e2":"Earnings","longest_run":"Longest run","rating_count":"Rating count","rating_e2":"Average rating","successful_count":"Successful orders","total_count":"Total orders","total_run":"Total run","statistics":"Statistics"},"routes":{"app":"App","category":"Category","branch_goods":"Branch Goods","continue_register":"Continue Registration","create_layout":"Create Layout","create_template":"Create Template","custom_with_tour":"App Builder","customer_info":"Customer Information","dashboard":"Dashboard","default_layout":"Home","edit_app":"Edit App","edit_layout":"Update Layout","edit_template":"'Update Template","email_builder":"Email Templates","section":"Sections App","table_apps_views":"Apps","table_users_views":"Users","user_profile":"User Profile"},"select_normal":{"default_msg":"Please choose one"},"settings":{"geofences":"Geofences","text_config_title":"Text config","text_button":"text_button","payment_conf":"Payment settings","exchange_rate":"Exchange rate","date":"Date","payment":"payment","add_cancelation_reason":"Add new cancelation reason","add_holiday_button":"Add date","address":"Address","address2":"Address 2","address_searchbox_placeholder":"E.g.: avenue, city, state, country","admin_chooses_bid":"Choose among several providers","admin_chooses_bid_tooltip":"The administrator sends an order to several suppliers, the suppliers confirm and the administrator selects which one will make the order.","admin_confirm_first":"Confirm order","admin_confirm_first_tooltip":"Before accepting the order, it must be confirmed by the administrator. It does not apply to orders created by administrators.","admin_waits_confirmation_checker":"Wait for confirmation from a provider","admin_waits_confirmation_checker_tooltip":"The administrator sends an order to several suppliers, the order will be made by the first provider to confirm it.","allow_delivery_checker":"Allow delivery","allow_delivery_checker_tooltip":"Orders are delivered to the home by an assigned provider.","allow_pickup_checker":"Allow pickup","allow_pickup_checker_tooltip":"The client picks up the order at the store.","approved":"Approved","assigns_title":"Assigns","cancelation_reason":"Cancelation reasons","cancelation_reason_admin":"Cancelation reasons (admin)","cancelation_reason_users":"Cancelation reasons users","not_delivered_reason":"Not delivered reasons","city":"City","client_app_title":"Client App","client_chooses_provider_checker":"Allow provider choice","client_chooses_provider_checker_tooltip":"Customers select a supplier to service your order.","client_confirms_checker":"Allow provider confirmation","client_confirms_checker_tooltip":"Clients decide if they confirm or reject the provider.","client_message":"Client messages","code_proof_checker":"Use code","code_proof_checker_tooltip":"The provider must send the code given by the client to the company.","company_holidays":"Holidays","company_in_service":"Company in Service","company_in_service_des":"By having the company in service, you will not be able to edit your products or features. By disabling this option, you will not be able to create or receive orders.","company_location":"Location","company_work_schedule":"Work schedule","content":"Content","country":"Country","currency":"currency","currency_conf":"Currency config","international_currency":"International currency","custom_domain":"Custom Web domain","default_lang":"Default company language","delivery_type":"Delivery type","delivery_settings_title":"Delivery settings","dispatcher_config_title":"Dispatcher configuration","domain":"Web domain","draf":"Draft","email":"Reply to ","email_footer_tittle":"Confirmation order mail","expiration_date":"Expiration date","extension_days":"Extension days","field_type":"Field type","form_code_proof_checker":"Use form","form_code_proof_checker_tooltip":"The provider must complete and submit the form. The company must have the form enabled.","forms":"Forms","geo_address":"Search address","goods_matching_title":"Matching settings","head_title":"Update company","holidays_tooltip":"Select a date in the calendar and then click on Add to save new non-working holidays.","image":"Image","in_process":"In process","in_review":"In review","information_title":"Basic information","input":"Input","invoices":"Invoices","invoice_settings":"Configuración de Facturas","payments_data":"Datos para pagos","link_password_recovery":"Click to restore your password","term_of_service_tittle":"Terms of Service","term_of_service_label":"Your company Terms of Service","mandatory":"Mandatory","map_note":"Save your geolocation by moving the marker on the map or save the current geolocation from your computer by pressing the home icon","message_schedule_conflict":"The entered schedule collides with another already stored, if you wish, you can delete the conflicting schedule or correct the entered data","message_schedule_input_error":"Please check the entered data","movil_app_state":"Mobile app State","no_holidays_msg":"The company has not entered holidays","no_schedule_msg":"The company does not have assigned customer service hours","not_registered_yet":"Not registered yet","one_time_holiday":"(this year)","options":"Options","payment_methods":"Payment methods","picture_code_proof_checker":"Use pictures","picture_code_proof_checker_tooltip":"The provider must send the company a photo of the delivery to the customer","pricelist":"Price list","proof_delivery_settings":"Proof of delivery","provider_app_title":"Provider App","provider_chooses_order_checker":"Allow choice of orders","provider_chooses_order_checker_tooltip":"Providers can see the list of unassigned orders and auto-assign them.","provider_confirms_checker":"Allow confirmation of orders","provider_confirms_checker_tooltip":"Providers can confirm or reject orders assigned by customers.","provider_forfeit_checker":"Allow rejection of orders","provider_forfeit_checker_tooltip":"Providers may abandon assigned orders.","provider_message":"Provider messages","publish":"Publish","question":"Question","ready_for_publish":"Ready for publish","ready_to_send":"Ready to send","rejected":"Rejected","selected_holiday_msg":"Annual holiday?","sent":"Sent","service_matching_title":"Services-matching settings","service_notification_title":" Notifications services","set_current_location_tooltip":"Use current geolocation from your computer","signature_code_proof_checker":"Use signature","signature_code_proof_checker_tooltip":"It is allowed to use a signature as Proof of Delivery.","simple_selection":"Simple selection","state":"State","tax":"Tax","title_hour_from":"From","title_hour_to":"To","title_schedule_conflict":"Conflict in schedule","title_schedule_input_error":"Error in dates","title_week_days":"Day","true_false":"True/False","work_schedule_nav":"Attention schedule","work_schedule_title":"Customized Service Hours","work_schedule_title_2":"24 Hours a Day, 7 Days a Week","work_schedule_save":"Save Custom Schedule","monday":"Monday","tuesday":"Tuesday","wednesday":"Wednesday","thursday":"Thursday","friday":"Friday","saturday":"Saturday","sunday":"Sunday","remove":"Remove","repeat":"Repeat","holiday":"Holiday","holidays_title":"Non-working Days","holidays_text":"Annual","holidays_btn":"Save Calendar","holidays_Title_Modal":"Non-working days Selected","no_holidays":"{branch} has no configured non-working days yet","error_holidays":"An unexpected error has occurred","error_holidays_description":"An error has occurred while loading holidays","no_holidays_description":"Start to configure holidays here","create_holiday":"Create non-working day","edit_holiday":"Edit non-working day","repeat_annually":"Repeat annually","in_progress":"In progress","not_repeat":"Not repeat annually","delete_holiday_confirmation":"Are you sure you want to delete this holiday?","we_start":"We start","we_return":"We return","MONTHS":["January","February","March","April","May","June","July","August","September","October","November","December"],"WEEKDAYS_SHORT":["Su","Mo","Tu","We","Th","Fr","Sa"],"see_on_maps":"See on maps","latitude":"Latitude","longitude":"Longitude","the_city":"the city","city_branches":"These are the branches associated with","no_city_branches":"Currently there are no branches associated with","max_simultaneous_deliveries":"Maximum simultaneous deliveries","is_special_contributor":"Is special taxpayer","income_tax":"Income tax","tax_retention":"Tax retention","is_payment_deduction_disabled":"Disable payment deduction","branch_invoice_tax_name":"Tax name","branch_invoice_tax_prc":"Tax percentage","mark_too_busy_until":"Mark branch as busy","auto_busy_quantity":"Order limit to mark branch as busy","email_for_fiscal_docs":"Email for fiscal documents","address_for_fiscal_docs":"Address for fiscal documents","digital_invoice":"Digital invoice","is_digital_invoice_enabled":"Enable digital invoice","business_name":"Business name","legal_name_for_fiscal_docs":"Business name for tax documents","messages_list":"Messages list","params_list":"Parameters list","multi_orders":"Multi-orders","multi_orders_optimization":"Multi-orders optimization","auto_sync_work_schedules_warning":"{branch} does not have the schedule synchronization enabled, so it will have to be manually started once the holidays end."},"table_app":{"category":"Category","name":"User"},"table_categories":{"confirmation_question_1":"Are you sure you want to ","confirmation_question_2":" this category?","create_category_title":"Create new category","pinned":"Pinned","unpinned":"Unpinned","update_category_title":"Update category","visibility":"Visibility","visible":"Visible","hidden":"Hidden"},"table_client":{"avatar":"Avatar","confirmation_question_1":"Are you sure you want to ","confirmation_question_2":" this client user?","create_client_title":"Create new Client","update_client_title":"Update client","confirmed_counter":"Confirmed users","unconfirmed_counter":"Unconfirmed users","created_by_admin":"Users registered by Admin"},"table_admins":{"seller":"Seller","account":"Account","active":"Active","branchAdmins":"Branch's Admins","branchGroupsAdmins":"Groups's Admins","branchCompanyAdmins":"Company's Admins","blocked":"Blocked","block":"Block","confirmation_question_1":"Are you sure you want to ","confirmation_question_2":" this administrator user?","create_title":"Create new administrator","disabled":"Disabled","disable":"Disable","downgrade":"Downgrade","high":"High","low":"Low","off_line":"Offline","online":"Online","owner":"Owner","status":"Status","type":"Type","unconfirmed":"Unconfirmed","confirmed":"Confirmed","update_title":"Update administrator","unverified":"Unverified phone","upgrade":"Upgrade","hierarchy":"Hierarchy","special_permissions":"Special permissions"},"table_good":{"available":"Available","categories":"Categories","categories_of_msg":"Categories of ","confirmation_question_1":"Are you sure you want to ","confirmation_question_2":" this good?","create_title":"Create new good","details":"Details","duplicate_good":"Duplicate good/service","eta":"ETA","mark_as_available":"Mark as available","mark_as_unavailable":"Mark as unavailable","picture":"Picture","properties_of_msg":"Features of ","property":"Feature","type":"Type","turn_into_combo":"Turn into combo","edit_combo":"Edit combo","unavailable":"Unavailable","update_title":"Update good","minutes":"Minutes","show_all":"Show all goods","show_available_only":"Show goods in stock","show_unavailable_only":"Show goods out of stock","show_featured_only":"Show featured goods","featured":"Featured","remove_featured_question":"Remove featured configuration from this product?"},"table_orders":{"alert_third_party_provider":"This order is assigned to a third party fleet.","assign_provider_to":"Assign provider to","assign_shopper_to":"Assign shopper to","client_label":"Client","confirmation_question_1":"Are you sure you want to ","confirmation_question_2":"confirm","confirmation_question_3":"order # ","confirmation_question_A":"Cancel order # ","confirmation_question_B":"Mark as not delivered order ","delivery_method_asap":"ASAP","goods_carrier":"Goods Carrier","is_pickup_label":"Delivery","mixed":"Mixed","no_provider_msg":"No provider assigned","resend_pool":"Resend to the pool","send_to_pool":"Send to the pool","provider_label":"Attended by","requested_label":"Requested","restore_question1":"Are you sure you want to ","restore_question2":" this order?","schedule_label":"Schedule for","select_provider_placeholder":"Choose...","service_provider":"Service provider","status_label":"Status","total_label":"Total","unassing":"Unassing","show_all_cities":"Show all cities","cancel_prepared_order_question":"The order is ready, are you sure you want to cancel it?","cancel_completed_order_question":"The order is already completed, are you sure you want to cancel it?","add_note":"Add note","edit_note":"Edit note","invoice_unallowed":"Do not bill","invoice_allowed":"Enable billing","proof_of_shopper":"Proof of shopper","find_reference":"Find reference"},"table_properties":{"available":"Available","confirmation_question_1":"Are you sure you want to ","confirmation_question_2":" this feature?","create_title":"Create new feature","list":"List","numeric":"Numeric","state":"Status","text":"Text","type":"Type","unavailable":"Unavailable","update_title":"Update feature"},"table_provider_orders_views":{"show_completed":"Completed"},"table_providers":{"active":"Active","blocked":"Blocked","confirmation_question_1":"Are you sure you want to ","confirmation_question_2":"user?","create_new_provider":"Create new provider","disabled":"Disabled","off_line":"Off-line","restore_question1":"Are you sure you want to ","restore_question2":" this provider?","unconfirmed":"Unconfirmed","online":"Online","offline":"Offline","show_all":"Show all"},"fleets":{"association":"Association","cargo":"Cargo","confirmation_question_1":"Are you sure you want to ","confirmation_question_2":" this fleet?","confirmation_question_3":" this payment method?","create_fleet":"Create fleet","create_payment_method":"Create payment method","edit_fleet":"Edit fleet","fleet":"Fleet","fleets":"Fleets","invalid_name":"The name {name} already exists, please choose another name","invalid_code":"The code {code} already exists, please choose another code","no_fleets":"No fleets assigned to this provider","passengers":"Passengers","profiles":"Profiles","service_distance":"Service distance","service_distance_tooltip":"Maximum distance of the order route","service_radio":"Service radio","service_radio_tooltip":"Maximum distance between the driver and the business","code":"Code","code_placeholder":"Maximum 16 characters","binding_attribute":"Bind payment method","currency_iso":"Currency","tax_flat":"Base tax","tax_prc":"Tax percentage","tax_prc_placeholder":"Must be a number between 0 and 1","service_suppliers":"Service suppliers","pref_max_simultaneous_deliveries":"Max simultaneous deliveries","pref_allow_multi_delivery_by_self":"Allow simultaneous assignment from the pool","payment_methods":"Payment methods","payment_method":"Payment method","no_payment_methods":"No payment methods for this fleet","brand":"Brand","model":"Model","color":"Color","plate":"Plate","year":"Year"},"table_service_suppliers":{"confirmation_question_1":"Are you sure you want to ","confirmation_question_2":" this service supplier?"},"tooltips":{"details":"Description","display_name":"Username","email":"E.g.: user@domain.com","item_name":"Item name","name":"Name Last name","phone":"E.g.: 0293-123-4567","phone_alt":"Ej: 1234567","price":"Item price","sku":"Please enter SKU","eta":"Please enter estimated product delivery time","short_details":"Short description","stock":"Stock"},"user_nav":{"badge":"NEW","dashboard_link":"Dashboard","prototype_builder_link":"Prototype Generator"},"validation_errors":{"accepted":"The field must be accepted.","alpha":"The field may only contain letters.","alpha_num":"The field may only contain letters and numbers.","alpha_num_dash":"The field may only contain letters, numbers and dashes.","card_exp":"The field must be a valid expiration date.","card_num":"The field must be a valid credit card number.","currency":"The field must be a valid currency.","decimal":"The field must be a valid decimal.","email":"The field must be a valid email address.","gt":"The field must be greater than :gt.","gte":"The field must be greater than or equal to :gte.","in":"The selected field must be :values.","integer":"The field must be an integer.","lt":"The field must be less than :lt.","lte":"The field must be less than or equal to :lte.","max":"The field may not be greater than :max characters.","min":"The field must be at least :min characters.","not_in":"The selected field must not be :values.","numeric":"The field must be a number.","phone":"The field must be a valid phone number.","required":"The field is required.","url":"The field must be a valid URL. E.g.: https://subdomain.domain.something"},"two_steps_modal":{"title":"Two factor verification","default_message":"Please enter the verification code sent to your email","default_title":"This action requires two factor verification","send":"Send","wrong_two_steps_code":"Invalid verification code","not_found_signature":"Provider signature not found"},"coupons":{"modify_end_date":"Modify expiration date","ends_date":"Expiration date","is_cashback":"Is cashback?","cashback_config":"{type} of type cashback","cashback_config_tooltip_coupon":"If activated, when the coupon expires, the discount will be converted into available balance for the user","cashback_config_tooltip_promo":"If activated, when the promotion expires, the discount will be converted into available balance for the user","internal_code":"SKU","category_name":"Category name","sum_quantity":"Sum of goods"},"billings":{"adjustment_type":"Adjustment type","adjustment_type_placeholder":"Select an adjustment type","amount":"Amount","balance":"Balance","order":"Order","select_type_message":"Please, select an adjustment type to continue","search_order":"Search order","order_not_found":"Order not found","search_order_placeholder":"Enter the order number"},"webhooks":{"create_title":"Create webhook","create_block":"Create block","block":"Block","edit_title":"Edit webhook","delete_title":"Delete webhook","select_placeholder":"Select a webhook type","enable_config":"Enable {type} configuration","hook_name":"Hook name","select_handler":"Select a handler","select_hook":"Select a hook","configuration_of":"Configuration of {type}","auto_sync":"Auto sync","auto_sync_delay":"Sync delay","auto_sync_offset":"Sync offset","response_processor":"Response processor","check_in_service":"Check in service","order_status_mask":"Order status mask","ext":"Ext","appends":"Appends","category_ignored_words":"Ignored words for categories","category_mapping":"Category mapping","currency_mapping":"Currency mapping","csv_settings":"CSV settings","select_key":"Select a key type","delimiter":"Delimiter","enclosure":"Enclosure","line_ending":"Line ending","use_bom":"Use BOM","include_separator_line":"Include separator line","excel_compatibility":"Excel compatibility","escape_character":"Escape character","contiguous":"Contiguo","input_encoding":"Input encoding","output_encoding":"Output encoding","image_name_column":"Image name","data_accessor":"Data accessor","refresh_data":"Refresh data","clear_missing":"Clear missing","refresh_category":"Refresh categories","tax_included":"Tax included","tax_round_mode":"Tax round mode","tax_multiplier":"Tax multiplier","quantity_threshold":"Quantity threshold","quantity_reservation":"Quantity reservation","starting_cell":"Starting cell","separated_sku":"Separated SKU","currency":"Currency","debug":"Debug","vertical_image_name_column":"Vertical image name","image_url":"Image URL","vertical_image_url":"Vertical image URL","weight_config":"Weight config","bulk_upload":"Massive loading","config":"Configs","columns":"Columns","add_column":"Add column","conditions":"Conditions","use_body":"Use body","ttl":"TTL","backoff":"Backoff","tries":"Tries","select_type":"Select a type","display_name":"Custom name","method":"Method","select_method":"Select a method","no_data":"No webhooks","basic_config":"Basic configuration","advance_config":"Advance configuration","import_config":"Import configuration","additional_config":"Additional configuration","no_additional_config":"No additional configuration","auth_type":"Authentication type","auth":"Authentication","auth_none_msg":"No authentication required","user_name":"User name","user_password":"User password","confirmation_question_1":"Are you sure you want to ","confirmation_question_2":" this webhook?"}}

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports = {"broadcast_message":{"abort_question_1":"¿Está seguro de que quiere","abort_question_2":"esta notificación?","target_types":{"custom":"Usuarios particulares","clients":"Usuarios","providers":"Repartidores","email":"Correos electrónicos","everyone":"Todos","branch_admins":"Administradores de comercio"},"table_columns":{"target_type":"Objetivo"}},"admin_details":{"edit_admin_info":"Editar información","email_sended":"Se le ha enviado un correo electrónico, por favor revise su bandeja para cambiar la contraseña","sms_notifications_settings":"SMS","password_change_msg":"Para cambiar tu contraseña haz clic","password_change_msg2":"aquí","security_settings_tab":"Seguridad","security_title":"Cambiar contraseña","select_language":"Selecciona tu idioma"},"reports":{"generate":"Generar","type":"Tipo","reports":"Reportes","goods_out_stock":"Productos Agotados","in_queue":"En espera","generating":"Generando","failed":"Fallido","available":"Disponible"},"app":{"confirm_token_route":"Confirmar Registro de Usuario","continue_route":"Continuar con su registro","login_route":"Iniciar Sesión","password_reset":"Olvidó contraseña","register_route":"Registrar usuario","set_new_password":"Generar nueva contraseña"},"calendar":{"week_days":"Domingo,Lunes,Martes,Miércoles,Jueves,Viernes,Sábado","week_days_capitals":"D,L,M,M,J,V,S"},"client_details":{"ratings_made":"Calificaciones","orders_made":"Órdenes","to":" a "},"common":{"attention":"Atención","loading":"Cargando...","this_featured_product":"este producto destacado","featured_products":"Productos destacados","is_visible":"Es visible","is_featured":"Destacado","provider_balance":"Balance Riders","section":"Secciones App","fixed":"Dias fijos","delay":"Tiempo de espera","time_range":"Dias/Horas fijas","time_available":"Dias/Horas disponible","disabled":"Deshabilitado","deleted":"Borrado","all":"Todos","reports":"Reportes","sending":"Enviando...","undefined":"Sin definir","list_send_notifications":"Lista de notificaciones","not_visible":"No visible","visible":"Visible","receiver_name":"Nombre del destinatario","receiver_phone":"Teléfono del destinatario","created":"Creado por","updated":"Actualizado por","max_quantity":"Cantidad máxima","limit_type":"Tipo de límite","per_order":"Por orden","per_day":"Por día","per_week":"Por semana","per_month":"Por mes","base_price":"Precio base","hour_beg":"Hora inicio","hour_end":"Hora fin","subtotal":"Subtotal","used":"Usados","discount":"Descuento","fixed_amount":"Monto fijo","available_codes":"Códigos disponibles","used_codes":"Códigos usados","used_code":"Código usado","set_ready":"Activar","branch_group":"Grupo de comercio","branch_groups":"Grupos de comercio","attach":"Asociar","amount":"Monto del cupón","promo_code":"Código","schedule":"Horario","applies_to":"Aplicable a","personal":"Personal","coupons":"Cupones","coupon":"Cupón","ready":"Listo","generating":"Generando","pending":"Por activar","min_purchase":"Compra mínima","max_discount":"Límite máximo del descuento","amount_limit":"Monto para alcanzar el límite máximo del descuento","running":"Corriendo","finished":"Finalizada","promo":"Promoción","promos":"Promociones","batch":"Lote","inventory":"Inventario","commercial_agreements":"Acuerdos comerciales","company":"Compañía","company_categories":"Categorías de compañía","branch_category":"Categoría de comercio","branch_categories":"Categorías de comercio","branch_subcategories":"Subcategorías de comercio","tittle":"Título","invalid_target":"No se encontró el objetivo","image_not_set":"Requiere adjuntar una imagen","disable":"Deshabilitar","in_order":"Orden numérico","admin":"Administrador","branch":"Comercio","branches":"Comercios","branch_good":"Producto de Comercio","branch_goods":"Productos de Comercio","enable_multi_providers":"Habilitar Riders múltiples","enable_multi_providers_des":"Permitir que una orden pueda ser atendida por más de un Rider de servicio. ","assigned_provider":"Riders asignados","change_stock":"Actualizar cantidad de producto","choose_clients":"Por favor escoja un usuario...","assing_client":"Asignar usuario","assing_company":"Asignar compañía","no_vendors_msg":"No hay vendedores anexados aun","no_clients_msg":"No hay usuarios anexados aun","select_vendor":"por favor escoja un vendedor...","main_seller":"Vendedor principal","asign_vendor":"Asignar vendedores","payment_approved":"Pagadas ( Revisadas )","payment_pending":"Sin pagos","payment_reported":"Pagadas ( Sin revisar )","list_type":"Tipo lista","add_tag":"Añadir etiqueta","delivery_fee":"Gastos de envío","tag":"Etiqueta","goods_tags_list":"Lista de etiquetas de productos","goods_tags":"Etiquetas de productos","temporary_email":"Correo electrónico temporal","customize_form":"Personalizar formulario","point_of_sale":"Punto de venta","cash":"Efectivo","payment_type":"Tipo de pago","last_digits_issuing_account":"Últimos 4 dígitos de la cuenta emisora","confirmation_number":"Nro. de confirmación","same":"El mismo","banks_transfer":"¿Desde cuál transfieres?","banks_select":"Selecciona uno de nuestros bancos","screenshot":"Captura de pantalla","payment_issuing_phone":"Teléfono emisor del pago","operacion_number":"Número de operación","origin_bank":"Banco origen","wire_transfer":"Transferencia bancaria","required_skills":"Habilidades requeridas","skill":"Habilidad","skills_group":"Grupo de habilidades","skills_group_list":"Lista de grupos de habilidades","attach_service_skills":"Anexar habilidades requeridas","socials":"Redes Sociales","login":"Inicio de sesión","payment_date":"Fecha de pago","form":"Formulario","form_type":"Tipo de formulario","notifications":"Notificaciones","icon":"Icono","no_client_address_title":"Sin dirección","no_have_option_yet":"Sin campos agregados aun.","template":"Plantilla","mandatories_properties":"Las siguientes variantes son obligatorias","units":"Unidades","actions":"Acciones","accept":"Aceptar","add":"Agregar","admins":"Administradores","admin_types":"Tipos de administrador","admin_details_breadcrumb":"Perfil","fleet":"Flota","fleet_edit":"Editar flota","alert_int_service":"Compañía FUERA DE SERVICIO. En este momento NO puede crear ni recibir órdenes","alert_no_phone_company":"Información importante faltante, por favor configure: Teléfono de compañía","alert_unconfigured_payment_methods":"Antes de configurar sus métodos de pago, debe ingresar la tasa de conversión a US$","all_feminine":"Todas","allow_sms_notifications":"Permitir notificaciones de SMS","assign":"Asignar","ativate_now":"¡Activar ahora!","available_by":"Disponible por","avatar":"Avatar","back_button":"Atrás","biggest_profit":"Ingreso","biggest_sales":"Venta","cancel":"Cancelar","categories":"Categorías","client":"Usuario","clients":"Usuarios","companies":"Compañías","company_billings":"Finanzas de la compañía","invoices":"Facturas","invoices_lot":"Facturas en masa","invoice":"Factura","company_charges":"Mis cobros","company_settings":"Ajustes de la compañía","complete":"Completar","confirm":"Confirmar","confirmation_question":"¿Está seguro que desea ","continue":"Continuar","create":"Crear","current":"Actual","current_plan":"Plan actual","daily":"Diario","days":"Día(s)","delete":"Eliminar","deliver":"Orden Lista","delivery":"Delivery","deliverer":"Repartidor","delivery_guy":"Prestador de servicios","description":"Descripción","details":"Detalles","temporal_banned":"Bloquear temporalmente","permanent_banned":"Bloquear permanentemente","display_name":"Usuario","edit":"Editar","email":"Correo","enable":"Habilitar","enabled":"Habilitado","expired":"Expiró","filter_placeholder":"Filtrar...","finance":"Finanzas","good":"Producto","goods":"Productos","goods_list":"Lista de productos","hide":"Ocultar ","home":"Inicio","image":"Imagen","invoice_list":"Lista de factura","list":"Lista","manual_payment":"Efectivo","manual_payment_report_of_order":"Al recibir reporte de pago en efectivo de una orden.","mixed":"Mixto","method":"Método","monthly":"Mensual","more":"Ver más","see_all":"Ver todas","my_account":"Mi cuenta","name":"Nombre","next":"Siguiente","no":"No","no_results_msg":"No hay resultados","number":"Número","numeric":"Numérico","order":"Orden","order_number_msg":"Orden #","orders":"Órdenes","balance":"Balance","temporal_balance":"Balance temporal","payment_confirm":"Validar pago","payment_report_of_order":"Al recibir reporte de pago de una orden.","phone":"Teléfono","pickup":"En tienda","pinned":"Destacado","prepaid":"Prepagado","price":"Precio","pricelist":"Lista de Precios","property":"variante","properties":"Variantes","branch_properties":"variantes de Comercio","provider":"Repartidor","providers":"Repartidores","rating":"Calificación","ratings":"Calificaciones","refresh":"Refrescar","restore":"Restaurar","lay_off":"Activar","save":"Guardar","search_button":"Buscar","search_placeholder":"Buscar...","select_placeholder":"Seleccione...","select_type":"Seleccione el tipo","send_email":"Enviar correo","send_sms":"Enviar SMS","send_notification":"Enviar notificación","send_password_recovery":"Recuperación de contraseña","service":"Servicio","service_provider":"repartidor","services":"Servicios","settings":"Ajustes","shopper":"Shopper","show":"Mostrar ","show_completed":"Completados","sold":"Vendidos","start":"Iniciar","status":"Estado","stock":"En existencia","success":"¡Éxito!","this_table_not_have_data_yet":"Esta tabla aún no tiene datos.","to_file":"Borrar","suspend":"Suspender","today_uncompleted_orders":"Órdenes sin completar","today_unconfirmed_orders":"Órdenes de hoy sin confirmar","total":"Total","trial":"Modo pruebas","trial_description":"Para recibir las notificaciones en el escritorio y tener una mejor experiencia debes permitir el uso de notificaciones. ¡Gracias!","trial_description_fail":"Su subscripción no pudo ser activada","type":"Tipo","unlimited":"Ilimitado","update":"Actualizar","user":"Usuario","user_id":"ID Usuario","user_request_help":"Cuando un usuario solicite ayuda.","verify":"Verificar","waiting_message":"Por favor espere...","when_cancels_an_order":"Cuando un usuario o repartidor cancele una orden.","when_creating_order":"Al crear una orden.","yes":"Si","target":"Objetivo","available_coupons":"Cupones disponibles","used_coupons":"Cupones usados","gift_card":"Gift card","city":"Ciudad","cities":"Ciudades","access":"Accesos","default_view":"Vista por defecto","deductions":"Deducciones","from":"Desde","to":"Hasta","address":"Dirección","addresses":"Direcciones","active":"Activa","inactive":"Inactiva","geofence":"GeoCerca","valid":"Válida","invalid":"Inválida","fleets":"Flotas","service_suppliers":"Proveedores de servicio","service_profiles":"Perfiles de servicio","service_charges":"Cargos de servicio","retry":"Reintentar","pay":"Pagar","pos_serial":"POS","inbox":"Bandeja de entrada","associations":"Asociaciones","go_to_page":"Ir a la página","go":"Ir","available":"Disponible","used_female":"Usada","close":"Cerrar","webhooks":"Webhooks","word":"Palabra","promotional_banners":"Banners promocionales","special":"Especial","try_again":"Intentar nuevamente"},"confirmation":{"back_button":"Volver a Inicio","confirm_password":"Confirmar contraseña","error_description_msg":"Error al confirmar","error_explanation_title":"¡Lo sentimos!","password":"Contraseña","password_recovery":"Recuperar contraseña","register_button":"Registrar"},"companies":{"country_iso":"ISO País","currency_iso":"ISO Moneda","domain":"Dominio Url","in_service":"En servicio","expires_at":"Fecha expiración","extension_days":"Prórroga"},"create_order":{"address_searchbox_placeholder":"Ej.: avenida, ciudad, estado, país","back_button":"Volver","cart_tab_title":"Carrito","client_address_title":"Dirección del usuario","client_searchbox_placeholder":"Buscar por correo, nombre de usuario, nombre o teléfono","client_tab_title":"Usuario","confirm_select_provider_btn":"Seleccionar uno","delivery_method_asap":"Inmediata","delivery_method_other":"Otro","delivery_method_title":"Fecha y hora de la entrega","delivery_tab_title":"Entrega","error_category_unavailable":"Categoría desconocida.","error_property_unavailable":"No se puede asociar un tipo de campo para esta variante.","filter_by":"Filtrar","good_has_no_properties_msg":"Este producto no tiene variantes","modal_create_client_title":"Crear un nuevo usuario","no_provider_warning_msg":"¿Seguro que desea seguir sin seleccionar un repartidor?","order_instructions_title":"Instrucciones especiales","order_title":"Orden","pickup_option_title":"Tipo de entrega","place_order_button":"Realizar orden","go_to_checkout_button":"Ir al checkout","properties_panel_placeholder_msg":"Seleccione una imagen para mostrar variantes adicionales ...","properties_title":"Variantes","provider_searchbox_placeholder":"Buscar por correo, nombre de usuario, nombre o teléfono","quantity":"Cantidad","register_client_tooltip_msg":"o registra un nuevo usuario","search_input_placeholder":"Buscar...","search_title":"Buscar","select_client_label":"Seleccionar usuario","select_placeholder":"Seleccione...","select_provider_title":"Seleccionar repartidor","start_price_hint_msg":"Desde","total":"Total","unknow_type_parameter":"Parámetro de tipo desconocido.","loading_cart":"Cargando carrito...","articles":"Artículos","delete_item":"Eliminar producto","delete_item_confirmation":"El siguiente producto será eliminado de la cesta","delete_item_confirmation_2":"¿Está seguro de que desea eliminar el producto?","clear_cart":"Vaciar carrito","empty_cart":"El carrito está vacío","add_articles":"Agrega artículos para empezar","clear_cart_confirmation":"¿Está seguro de que desea vaciar el carrito?","clear_cart_confirmation_2":"Se eliminarán todos los artículos de la cesta","get_back_to_cart":"Volver al carrito","checkout_step_1":"Dirección","checkout_step_2":"Pago","checkout_step_3":"Resumen","go_to_step_2":"Ir a métodos de pago","go_to_step_3":"Ir al resumen","pickup_now":"Ahora","pickup_later":"Programar","total_to_pay":"Total a pagar","add_prom_code":"Agregar código promocional","prom_code_placeholder":"El código promocional debe tener entre 5 y 20 caracteres","apply":"Aplicar","use_balance":"Usar ZupperCredits","applied_prom_code":"Cupón aplicado correctamente","estimated_time_asap":"Tiempo estimado de entrega","estimated_time_later":"El pedido fue programado para","delivery_address":"Dirección de envío","pickup_address":"Dirección de recogida","is_a_gift":"Es un regalo","order_success":"Orden creada correctamente","order_success_2":"creada correctamente","order_success_3":"¿Desea ir a la orden recién creada?","continue_cart":"Continuar creando otra orden","select_payment_method":"Seleccione un método de pago","recreate_order":"Recrear orden","recreate_order_question":"¿Está seguro de que desea recrear la orden ","recreate_order_question_2":"Esta acción limpiará el carrito actual del cliente {clientName} en el comercio {branchName}","order_created_by":"Orden creada por el administrador","delivery_schedule":"Horario de entrega","delivery_date":"Fecha de entrega","delivery_hour":"Hora de entrega","pickup_at":"Recoger en","client_incomplete_profile":"Perfil incompleto","client_imcomplete_profile_info":"Al usuario {name} le faltan los siguientes datos:","cashback_message":"Esta compra tendrá un reintegro de {cashback}","no_payment_method":"Elegir después"},"custom_errors":{"conflict":"La entidad ya existe","attached_good":"Existen producto asociados.","attached_goods":"Existen productos asociados.","attached_properties":"Existen propiedades asociadas.","app_status":"Error al consultar estado de la aplicación móvil","attach_category_product":"Error al adjuntar esta categoría","cancelation_reason_delete_failed":"Error al borrar razón de cancelación","cancelation_reason_registration_failed":"Debe introducir una razón de cancelación","cancelation_reason_update_failed":"Error al actualizar razón de cancelación","category_delete_failed":"Error al eliminar categoría","category_registration_failed":"Error al registrar categoría","category_update_failed":"Error al actualizar categoría","client_addres_to_long":"La dirección debe ser menor a 255 caracteres.","company_delete_failed":"Error al eliminar compañía","company_update_failed":"Error al actualizar compañía","date_prior_today":"La fecha ingresada no puede ser antes de hoy cuando NO es una festividad anual","email_not_sent":"Correo no enviado","empty_fields":"Escriba en los campos requeridos","empty_shopping_cart":"No ha seleccionado productos en el carrito","form_delete_failed":"Error al borrar formulario","form_registration_failed":"Error al registrar formulario","form_update_failed":"Error al actualizar formulario","good_delete_failed":"Error al eliminar artículo","good_registration_failed":"Error al registrar artículo","good_update_failed":"Error al actualizar artículo","in_service_locked":"No es posible editar los productos ni variantes mientras la compañía está En Servicio","insert_client":"Debe ingresar un usuario","insert_client_addres":"Debes ingresar la dirección del usuario","insufficient_stock_title":"Límite de inventario alcanzado","insufficient_stock_msg":"Alguno de sus productos supera los límites en existencia.","order_canceled":"Orden cancelada","order_cancel_failed":"Error al cancelar orden","order_complete":"Error al completar orden","order_confirm":"Error al confirmar orden","order_delete_failed":"Error al eliminar orden","order_deliver":"Error al entregar orden","order_registration_failed":"Error al registrar orden","order_start":"Error al iniciar orden","order_update_failed":"Error al actualizar orden","pament_accep":"Error al aceptar el pago del pedido.","provider_attach_failed":"Actualización fallida del repartidor","required_fields":"Debe llenar el(los) campo(s): {fields_list}","retrieving_cancelation_reason":"Error al recuperar el motivo de cancelación","retrieving_cancelation_reasons_list":"Error al recuperar lista de motivos de cancelación","retrieving_categories":"Error al recuperar lista de categorías","retrieving_categories_product":"Error al listar categorías del producto","retrieving_category":"Error al recuperar categoría","retrieving_company":"Error al recuperar la compañía","retrieving_form":"Error al recuperar formulario","retrieving_forms_list":"Error al recuperar lista de formularios","retrieving_goods":"Error al recuperar artículo","retrieving_goods_list":"Error al recuperar listado de artículos","retrieving_order":"Error al recuperar orden","retrieving_order_list":"Error al recuperar listado de órdenes","retrieving_proof_of_delivery":"Error al recuperar prueba de entrega","retrieving_today_order_list":"Error al recuperar listado de órdenes de hoy","retrieving_user_data":"Error al recuperar datos del usuario","retrieving_user_list":"Error al recuperar listado de usuarios","select_complete_address":"Debes seleccionar una dirección completa","unavailable_product__title":"Producto no disponible","unavailable_product__msg":"Ha intentado superar el límite en existencia de: {type} {item}","update_categories_product":"Error al actualizar categorías del producto","user_delete_failed":"Error al eliminar usuario","user_registration_failed":"Error al registrar usuario","user_already_exist":"El email del usuario ya se encuentra registrado","client_already_exist":"El teléfono del usuario ya se encuentra registrado","user_restore_failed":"Error al restaurar usuario","user_update_failed":"Error al actualizar usuario","property_update_error":"Error al actualizar propiedad","an_error_has_ocurred":"Ha ocurrido un error al cargar los datos","delete_invoice_failed":"Ha ocurrido un error al eliminar las facturas","pay_invoices_failed":"Ha ocurrido un error al pagar las facturas","image_fail_default":"Ha ocurrido un error al cargar la imagen","image_fail_message":"La imagen tiene dimensiones inválidas, por favor intente nuevamente.","pos_serial_format":"El serial del POS no cumple con el formato requerido","rif_format":"El rif no cumple con el formato requerido","pos_serial_conflict":"Serial POS ingresado ya se encuentra asignado a otro repartidor. Por favor verificar e intentar nuevamente.","rif_conflict":"El rif ya se encuentra registrado. Por favor verificar e intentar nuevamente.","default_error":"Ha ocurrido un error inesperado","target_invalid_payment_method":"{target} no tiene métodos de pago válidos configurados"},"custom_success":{"admin_updated":"El usuario administrador fue actualizado","delete_successful":"Datos eliminados","email_sent":"Correo enviado","restored_user":"Usuario restaurado","saved_successful":"Datos guardados","saved_successful_product":"Producto guardado, por favor añada categorías y/o variantes","update_successful":"Datos actualizados","givechange_successful":"Reembolso realizado","edit_order_successful":"Orden editada","resend_pool_successful":"La orden está nuevamente en el pool","pay_successful":"Pago realizado con éxito"},"dashboard":{"activity":"Actividad","all":"Todas","yesterday":"Ayer","week":"Esta semana","this_month":"Este mes","custom":"Personalizada","month":"Mes","asap":"De inmediato","average_title":"Promedios","buttons_menu_label":"Órdenes en curso","canceled":"Cancelada","consumption":"Consumo","completed":"Completadas","filter_greater_profit":"Mayor ingreso","filter_greater_sells":"Mayor venta","filter_lower_profit":"Menor ingreso","filter_lower_sells":"Menor venta","filter_greater_frequency":"Mayor frecuencia","filter_greater_consumption":"Mayor consumo","filter_lower_frequency":"Menor frecuencia","filter_lower_consumption":"Menor consumo","frequency":"Frecuencia","last_time_bought_label":"Última compra","less":"Menos","more":"Más","no_client_msg":"Tus usuarios no han registrado órdenes.","no_sells_msg":"No existen registros de ventas","order_by":"Ordenar por","orders_confirmed_today":"Confirmadas","orders_created_today":"Recibidas","orders_msg_warning":" Las órdenes de hoy serán anexadas al finalizar el día","orders_recived_today":"Órdenes activas","pendings":"Pendientes","report_selector":"Ver reporte","today":"Hoy","today_canceled_orders":"Órdenes canceladas","today_earnings":"Total obtenido","today_ended_orders":"Órdenes finalizadas","today_orders":"Órdenes en curso hoy","today_scheduled_orders":"Programadas","tooltip_received_orders":"Cantidad de órdenes recibidas hasta el ","tooltip_daily_orders":"Muestra la información de las órdenes diarias en el mes actual","tooltip_monthly_orders":"Muestra la información de las órdenes en el mes seleccionado","tooltip_current_orders":"Muestra la información de las órdenes hasta la última fecha de realización","tooltip_completed_orders":"Cantidad de órdenes completadas hasta el ","tooltip_uncompleted_orders":"% de órdenes sin completar en ","tooltip_canceladas_orders":"% de órdenes canceladas en ","tooltip_asap_orders":"Cantidad de órdenes para entregar de inmediato sin completar el ","tooltip_scheduled_orders":"Cantidad de órdenes programadas sin completar el ","tooltip_orders_earnings":"Total de dinero en las órdenes creadas hasta ","tooltip_orders_concilied":"Total de dinero recibido de las órdenes creadas hasta ","ttoday_earnings":"Total en órdenes","uncompleted":"Por completar","uncompleted_label":"Sin completar","total":"Total","branch_statistics":"Estadísticas de comercio","branch_group_statistics":"Estadísticas de grupo de comercio","select_branch":"Seleccione un comercio"},"default_aside":{"aside_menu_title":"Órdenes del día","aside_notifications_title":"Notificaciones","assgined_badge_tooltip":"Repartidores asignados","confirm_unassign_modal_1":"¿Está seguro que quiere ","confirm_unassign_modal_2":" esta orden? ","mark_all_notifications_consumed":"Marcar todas como leídas","mark_notification_consumed":"Marcar como leída","modal_order_title":"Orden ","no_pendings_msg":"No tienes acciones pendientes.","no_notifications_msg":"No tienes notificaciones nuevas.","pending_changes":"Cambios pendientes","provider_assigned_msg":"repartidor asignado","shopper_assigned_msg":"shopper asignado","provider_unassigned_msg":"Sin repartidor asignado","shopper_unassigned_msg":"Sin shopper asignado","unassgined_badge_tooltip":"Repartidores sin asignar"},"default_header":{"company_dropdown_menu_title":"Compañía","create_order_button":"Orden","hotkeys":"Teclas","logout_button":"Cerrar sesión","profile_button":"Perfil","settings_button":"Ajustes"},"default_layout":{"accept_notifications_button":"Permitir","notification_company_requires_payment":"El pago por los servicios de Zupper ha expirado, le recomendamos ponerse en contacto con nuestro equipo.","notification_requirement_msg":"Mantente actualizado con las novedades de tu App Zupper activando las notificaciones"},"dropzone":{"change_image":"Adjuntar imagen","drag_drop_image_here":"Arrastra y suelta tu imagen aquí.","files":"Imágenes","image_fail_message":"Las imágenes pueden tener un máximo de 1 MB y sólo se permiten los formatos .jpg y .png","upload_file_tip":"Coloque aquí hasta 4 imágenes o haga clic para seleccionar archivos.","upload_file_tip2":"Considere que las imágenes deben pesar máximo 1 MB y ser formato .jpg o .png"},"droznone_errors":{"maximum_quantity_allowed":"Cantidad máxima de imágenes permitida"},"errors":{"missing_targets":"No tiene asocioado ningun grupo de comercio/producto","invalid_credentials":"Usuario/Contraseña incorrectos","network_error":"Problemas con tu conexión. Intente nuevamente","not_allowed":"No permitido","already_completed":"Orden completada","already_prepared_title":"Orden preparada","already_prepared":"Esta orden ya ha sido preparada, por favor actualiza","account_blocked_des":"Disculpe, su cuenta ha sido bloqueada","account_disabled_des":"Disculpe, su cuenta ha sido deshabilitada","account_mismatches_des":"La cuenta no corresponde con sus datos en nuestra Base de Datos","account_unconfirmed_des":"Debe confirmar su cuenta para poder acceder","already_exists_des":"Este recurso ya existe en Base de Datos","already_exists_title":"Recurso ya existe","bad_schedule_des":"La fecha ingresada es incorrecta","branch_does_not_have_address":"El comercio no tiene dirección. Diríjase a Configuración > Ajustes del Comercio","branch_not_enabled":"Comercio no está En Servicio","branch_enabled":"Comercio se encuentra En Servicio","branch_featured":"Comercio se encuentra Destacado","branch_does_not_have_stock":"El comercio no posee inventario","company_disabled":"Es requerido el pago para acceder a su sesión","branch_visible":"El comercio ya está Visible","branch_not_visible":"El comercio no se encuentra Visible","company_in_service_title":"Compañía en servicio","company_in_service_msg":"Para completar esta operación, la compañía debe estar fuera de servicio.","des_429":"Límite de peticiones alcanzado","branch_attached_to_group":"El Grupo {branch_group} que desea eliminar, tiene Comercios asociados","feature_disabled_des":"El administrador ha deshabilitado esta funcionalidad","invalid_credentials_des":"Usuario/Contraseña incorrectos","invalid_data":"Error de validación","on_delete_des":"No se pudo eliminar correctamente","on_restore_des":"No se pudo recuperar el elemento correctamente","order_requires_auth_from_commerce":"Esta orden requiere autorización del comercio para completar la preparación.","target_too_high_des":"Tu cuenta no posee los privilegios para realizar esta acción","title_400":"Error al procesar la solicitud","title_401":"Por favor inicia sesión","title_403":"Acceso denegado","title_404":"El recurso no fue encontrado","title_405":"Este recurso ya existe en Base de Datos","title_409":"En conflicto con otro recurso.","title_422":"Los datos dados no son válidos.","title_429":"El servidor ha recibido muchas peticiones, si faltan datos puede probar recargando el sitio","token_expired_des":"Su sesión ha expirado","token_invalid_des":"Se inició sesión con esta cuenta en otro dispositivo","token_invalid_des2":"Token invalido","token_not_provided_des":"Faltan datos en su solicitud","unknown_error.":"Error desconocido","payment_error":"Ha ocurrido un error al realizar el pago"},"firebase":{"accepted_bid__msg":"El repartidor {provider} ha aceptado la orden # {number}","accepted_bid__title":"Orden aceptada","accepted_default__msg":"Ha sido aceptada {type}","accepted_default__title":"Actualizaciones Admin","accepted_order__msg":"La orden ha sido pagada","accepted_order__title":"Orden pagada","accepted_payment__msg":"Orden pagada","accepted_payment__title":"Pago aceptado","assigned_bid__msg":"Hay una orden asignada","assigned_bid__title":"Orden asignada","assigned_default__msg":"Ha sido asignado(a) {type}","assigned_default__title":"Actualizaciones Admin","assigned_order__msg":"La orden # {number} ha sido asignada a {provider}","assigned_order__title":"Orden asignada","available_bid__msg":"Hay repartidores esperando por orden","available_bid__title":"Orden disponible","available_default__msg":"Está disponible nuevo(a) {type}","available_default__title":"Actualizaciones Admin","available_order__msg":"La orden # {number} está disponible","available_good__title":"Disponible producto","available_good__msg":"{name} está disponible","available_order__title":"Orden disponible","available_payment__msg":"Hay un nuevo pago disponible","available_payment__title":"Pago disponible","available_provider__msg":"El repartidor {provider} está disponible","available_provider__title":"Repartidor disponible","changed_branch__title":"Actualizada configuración de comercio","changed_branch__msg":"El comercio {branch} cambió su configuración","canceled_default__msg":"Fue cancelado(a) el/la {type}","canceled_default__title":"Actualizaciones Admin","canceled_order__msg":"La orden # {number} fue cancelada","canceled_order__title":"Orden Cancelada","canceled_payment__msg":"Hay un nuevo pago que ha sido cancelado","canceled_payment__title":"Pago Cancelado","changed_company__msg":"La configuración de la compañía ha cambiado","changed_company__title":"Ha sido actualizada","being_prepared_order__title":"Orden # {number} en preparación","being_prepared_order__msg":"La orden esta siendo preparada. Tiempo estimado: {eta} mins","prepared_order__title":"Orden # {number} lista","prepared_order__msg":"La orden está lista {provider}","in_destination_order__title":"Un Rider ha llegado","in_destination_order__msg":"El repartidor de la orden # {number} ha llegado","in_destination_order_provider__title":"Un Rider ha llegado","in_destination_order_provider__msg":"El repartidor de la orden # {number} ha llegado","collected_order_provider__title":"Orden lista para llevar","collected_order_provider__msg":"La orden # {number} fue recogida para entregarse","changed_coupon__title":"Cupón se ha actualizado","changed_order__title":"La orden se ha actualizado","changed_coupon__msg":"Cupón {name}: {status}","changed_order__msg":"La orden # {number} ha cambiado su estatus a {status}","changed_default__msg":"Hay nuevos cambios en {type}","changed_default__title":"Actualizaciones Admin","client_denied_notification__alert":"¡Qué lástima! Pero si todavía deseas recibir actualizaciones de nuevos pedidos o nuevos usuarios en tiempo real, puedes desbloquear las notificaciones en tu navegador manualmente. Atte.: Zupper","completed_default__msg":"Se completó {type}","completed_default__title":"Actualizaciones Admin","completed_order__msg":"La orden # {number} ha sido completada","completed_order__title":"Orden Completada","default__msg":"Hay nuevos cambios en el Admin. Haz clic para abrir el Admin.","default__title":"Actualizaciones Admin","for_delivery_default__msg":"En destino {type}","for_delivery_default__title":"Actualizaciones Admin","for_delivery_order__msg":"La orden # {number} ha llegado, esperando por el usuario","for_delivery_pickup_order__msg":"La orden # {number} está lista para ser entregada","for_delivery_order__title":"Orden en destino","inventory_outdated__msg":"El comercio {name} tiene el inventario desactualizado","inventory_outdated__title":"Inventario desactualizado","new_default__msg":"Se creó nuevo(a) {type}","new_default__title":"Actualizaciones Admin","new_bid__msg":"","new_bid__title":"Nueva solicitud de repartidor","new_order__msg":"Ha recibido una nueva orden","new_order__title":"Nueva Orden","new_payment__msg":"Tienes un pago por validar en la orden # {number}","new_payment__title":"Pago por validar","new_pending_action__msg":"Tienes un nuevo cambio pendiente por aprobar","new_pending_action__title":"Hay cambios que requieren tu aprobación","new_rating__msg":"Hay una nueva calificación","new_rating__title":"Nueva Calificación","new_clientrating__msg":"Un usuario dio una calificación a una orden","new_clientrating__title":"Nueva calificación de un usuario","paid_order__msg":"La orden ha sido pagada","paid_order__title":"La orden # {number} ha sido pagada","pool_changed__msg":"El pool de la orden # {number} ha cambiado","pool_changed__title":"El pool ha cambiado","progress":"progreso","order_not_delivered__title":"Orden no entregada","order_not_delivered__msg":"La orden # {number} no ha podido ser entregada","refused_bid__msg":"Repartidor desasignado de la orden # {number}","refused_bid__title":"Orden rechazada","refused_order__msg":"El pago por la orden # {number} ha sido rechazado","refused_order__title":"Pago rechazado","refused_default__msg":"Ha sido rechazado(a) {type}","refused_default__title":"Actualizaciones Admin","started_default__msg":"Se ha iniciado un(a) {type}","started_default__title":"Actualizaciones Admin","started_order__msg":"La orden # {number} está en {status_type}","started_order__title":"Orden en {status_type}","started_orderprovider__title":"Orden iniciada","started_orderprovider__msg":"Se ha iniciado la orden # {number}","started_orderprovider_branch__title":"Rider vía comercio","started_orderprovider_branch__msg":"Dentro de poco un Rider llegará al comercio","the_way":"camino","unassigned_default__msg":"Hay un(a) {type} sin asignar","unassigned_default__title":"Actualizaciones Admin","unassigned_order__msg":"La orden # {number} no tiene repartidor","unassigned_order_shopper__msg":"La orden # {number} no tiene shopper","unassigned_order__title":"Orden sin asignar","unassigned_provider__msg":"Repartidor desasignado a la orden # {number}","unassigned_provider__title":"Repartidor desasignado","unassigned_shopper__msg":"Shopper desasignado a la orden # {number}","unassigned_shopper__title":"Shopper desasignado","unavailable_default__msg":"No está disponible el/la {type}","unavailable_default__title":"Actualizaciones Admin","unavailable_good__title":"Producto no disponible","unavailable_good__msg":"{name} no está disponible","unavailable_order__msg":"La orden # {number} no está disponible","unavailable_order__title":"Orden no disponible","unavailable_provider__msg":"El repartidor {provider} no está disponible","unavailable_provider__title":"Repartidor no disponible","unsupported_service_worker__alert":"Aparentemente tu navegador no es apto para todas las funcionalidades que te ofrece Zupper, te recomendamos actualizar y si eso no funciona puedes intentar con Google Chrome en su última versión. Atte.: Zupper","welcome_notification__msg":"Mediante estas notificaciones te mantendremos al tanto de todo sobre tu app Zupper","welcome_notification__title":"¡Configuración exitosa!"},"form_client":{"head_title_create":"Agregar repartidor","head_title_update":"Actualizar repartidor"},"form_properties":{"add_item_button":"Agregar elemento","base_price_label":"Precio base","decimates_label":"Decimales","default_label":"Valor predeterminado","mandatory_label":"Obligatorio","max_label":"Máximo","min_label":"Mínimo","step_price_label":"Precio por escalón","steps_label":"Escalones","text_label":"Texto"},"good_details":{"available":"Disponible","categories_title":"Categorías","comment":"Comentario","details":"Detalles","disabled":"Deshabilitado","eta":"Llegada","in_stock":"En existencia","no_categories_msg":"No se han agregado categorías","no_properties_msg":"No se han agregado variantes","no_ratings_msg":"No hay calificaciones disponibles","option":"Opción","pinned":"Destacado","price":"Precio","price_range":"Rango de precios","properties_title":"Variantes","quantity_range":"Rango de cantidades","rate":"Tarifa","sold_out":"Agotado","step_price":"Escalón / Precio por escalón","unavailable":"No disponible","unpinned":"Sin fijar","choose_up_to":"Elige hasta {max} opciones.","choose_min":"Elige al menos {min} opciones.","special_instructions":"Instrucciones especiales","special_instructions_disclaimer":"En este campo no se aceptan modificaciones que generen valor adicional en la factura.","materials":"Materiales","notes_enabled":"Notas habilitadas"},"http_codes":{"200":"Operación exitosa","201":"Ha sido creado exitosamente.","204":"Operación exitosa","400":"El servidor no pudo procesar la petición.","401":"Debe iniciar sesión para acceder a este recurso.","403":"Acceso denegado","404":"No se pudo encontrar lo que busca","409":"¡Error! No puede modificar este recurso","422":"Error de validación","400_error_deleting":"Error al eliminar ","400_error_restoring":"Error al restaurar ","400_token_invalid":"El token no es válido","401_token_expired":"El token ya no es válido. Debes iniciar sesión nuevamente","401_token_not_provided":"Falta el token de Autorización en la Cabecera","403_account_blocked":"Este usuario ha sido bloqueado para acceder a este recurso","403_account_disabled":"Esta cuenta de usuario ha sido deshabilitada","403_account_mismatches":"Está intentando ingresar a la cuenta de una compañía diferente","403_account_unconfirmed":"Esta cuenta debe ser confirmada antes de acceder a este recurso","403_feature_disabled":"Esta funcionalidad ha sido deshabilitada","403_target_too_high":"¡Error! Está intentando modificar una cuenta que tiene más privilegios","404_company_deleted":"La compañía no existe en nuestra base de datos","404_company_disabled":"La compañía ha sido deshabilitada","404_not_allowed":"No puede acceder a este recurso","404_not_found":"No se pudo encontrar este recurso","404_user_not_found":"El usuario no existe en nuestra base de datos","409_already_exists":"¡Error! Ya existe este recurso","422_mismatch":"¡Error! No coinciden","action_already_performed":"Acción ya realizada","general_error":"Ha ocurrido un error inesperado, intentaremos que no suceda de nuevo.","general_success":"Operación exitosa"},"invalidate_email":{"back_button":"Volver al Inicio","error_description_msg":"","error_explanation_title":"¡Lo sentimos!","invalidate_button":"Invalidar"},"login":{"accept_notifications_button":"Permitir notificaciones Zupper","forgot_password_link":"¿Olvidó su contraseña?","login_button":"Iniciar sesión","login_subtitle":"Ingrese a su cuenta","login_title":"Bienvenido a","password_placeholder":"Contraseña","salute":"Saludos","reset_link":"Enviar vínculo para restaurar contraseña","select_branch":"Gestionar comercio","select_branch_group":"Gestionar una Lista de Comercios","select_company":"Gestionar Compañía"},"map_view":{"assign_order_msg":"Asignarle una orden","assign_provider_msg":"Asignar repartidor","assign_providers_msg":"Asignación de repartidores","assign_shopper_msg":"Asignar shopper","assigned_to_msg":"Asignado a","client_title":"Usuario","company_location_tooltip":"Ubicación de la empresa","filter_providers":"Filtrar repartidores","geolocate_company":"Ir a casa","geolocation_compatibility_error":"Su navegador no posee funcionalidad para geolocalización, le recomendamos actualizarlo o cambiar de navegador. Atte.: Zupper","map_filter_assigned":"Órdenes asignadas","map_filter_available_providers":"Repartidores disponibles","map_filter_goods":"Productos","map_filter_offline_providers":"Repartidores sin conexión","tooltip_filter_dates":"Filtrar órdenes por fecha","tooltip_filter_status_orders":"Filtrar estatus de órdenes","tooltip_filter_branches_in_service":"Filtrar comercios en servicio","view_orders_at_date":"Ver órdenes por","order_type":"Tipo de orden","order_status":"Estatus de orden","map_filter_services":"Servicios","day":"Día","week":"Semana","month":"Mes","assigned_orders":"Asignadas","unassigned_orders":"Sin asignar","map_filter_today_orders":"Órdenes del día","map_filter_this_week_orders":"Órdenes de la semana","map_filter_this_month_orders":"Órdenes del mes","map_filter_unassigned":"Órdenes sin asignar","map_filter_unavailable_providers":"Repartidores no disponibles","map_searchbox":"Buscar...","map_searchbox_order":"Buscar orden...","map_searchbox_provider":"Buscar repartidor conectado...","more_details_msg":"Más detalles","order_list_modal_title":"Lista de órdenes","provider_list_modal_title":"Lista de repartidores","provider_list_modal_title_multi":"Lista de asignación para múltiples repartidores","provider_title":"Asignada a:","unassigned":"Sin asignar","unassigned_provider_msg":"No tiene repartidor asignado","unassigned_shopper_msg":"No tiene shopper asignado","unavaliable_provider_msg":"Sin repartidores disponibles","unavaliable_shopper_msg":"Sin shoppers disponibles","zoom_in":"Acercar","zoom_out":"Alejar"},"modal_assign_order":{"address":"Dirección","assign":"Asignar","cancelation_resons_title":"Por favor, describa brevemente los motivos de la cancelación.","no_provider_msg":"No hay repartidores asignados","manual_assignment":"Asignación manual","provider_searchbox_placeholder":"Buscar repartidores...","shopper_searchbox_placeholder":"Buscar shoppers..."},"modal_cancel_order":{"cancelation_resons_title":"Escribe las razones de la cancelación","cancelate_completed_order_resons_title":"Escribe las razones por las que la orden no fue entregada","cancelation_resons_title2":"Selecciona las razones de la cancelación"},"modal_categories":{"pinned":"Destacada"},"modal_categories_good":{"no_categories_msg":"No hay categorías anexadas aun","select_choose_category":"Elija una categoría ..."},"modal_goods":{"available":"Disponible","details":"Descripción","eta":"Tiempo de entrega","is_service_boolean":"Es un servicio","picture":"Imagen","price":"Precio","short_details":"Breve descripción","unavailable":"No disponible","warning_change_good_name":"Advertencia: tenga en cuenta que este cambio podría afectar negativamente la percepción del usuario sobre este producto, las calificaciones, etc."},"modal_order":{"notes":"Notas","scheduled_at":"Programada para:","status_title":"Estado:"},"modal_properties":{"add_item_button":"Agregar elemento","available":"Disponible","base_price_label":"Precio base","custom_label":"Entrada personalizada","decimates_label":"Decimales","default_label":"Predeterminado","disabled":"Deshabilitado","email_label":"Correo","mandatory_email_label":"Correo obligatorio","hint_label":"Sugerencia","max_label":"Máximo","min_label":"Mínimo","number_label":"Numérico","mandatory_number_label":"Numérico obligatorio","price_placeholder":"Precio","sold_out":"Agotado","step_price_label":"Precio por escalón","steps_label":"Escalón","texto_label":"Texto","mandatory_text_label":"Texto obligatorio","type_label":"Tipo de variante"},"modal_properties_good":{"choose_property_searchbox":"Seleccione un ETA","display_name":"Nombre para mostrar","no_properties_msg":"No hay variantes anexadas aún","property_arrows":"Flechas","property_checkbox":"Selección múltiple","property_dropdwn":"Menú desplegable","property_input_numeric":"Campo numérico","property_radio":"Selección única","property_seek_bar":"Barra de búsqueda","property_spinner":"Spinner","property_switch":"Interruptor","property_toggle":"Toggle"},"order_details":{"addres":"Dirección","bid_rejected_msg":"Solicitud rechazada","bid_waiting_client_confirm_msg":"Usuario debe confirmar","client_information_title":"Información del usuario","created_at":"Fecha de solicitud","delivery_method_asap":"Inmediato","details":"Detalles","bid_force_asignation_msg":"Forzar asignación","download_order":"Descargar Orden","download_invoice":"Descargar Factura","no_provider_assigned_msg":"Sin repartidor","notes":"Notas","payment_modal_title":"Modal de pago","phone":"Teléfono","property_title":"variante","provider_available_label":"Disponible","provider_busy_label":"Ocupado","provider_off_label":"Sin conexión","provider_information_title":"Información del repartidor","quantity":"Cantidad","scheduled_at":"Fecha programada","selection_title":"Selección","status":"Estado","waiting_confirmation_msg":"Repartidores esperando confirmación","applies_to":"Aplica a","type":"Tipo","used":"Usados","total_limit":"Límite total","starts":"Empieza","ends":"Termina","not_applicable":"No aplica","admin_notes":"Notas del administrador","affect_provider_balance":"Afectar balance del {provider}","cancel_provider_earnings":"Anular ganancias del {provider}","client_balance_warning":"Esta opción afectará la wallet del cliente","provider_balance_warning":"Al activar esta opción, el monto reembolsado al cliente será descontado del pago del {provider}","provider_earnings_warning":"Al activar esta opción, se anularán las ganancias del {provider}","client_balance_warning_header":"Esta acción se verá reflejada en la facturación del comercio","unit_price":"Precio unitario","total_price":"Precio total","edit_order":"Editar orden","alert_modify_product":"Usted está a punto de {action} el siguiente producto de la orden:","alert_delete_product":"Usted está a punto de eliminar el siguiente producto de la orden:","action_not_reversible":"Esta acción no se puede deshacer.","action_could_have_consecuences":"Esta acción podría afectar descuentos o promociones especiales.","original_goods":"Productos originales","added":"Producto añadido","updated":"Producto editado","removed":"Producto eliminado","generate_coupon":"Generar cupón","generate_order_coupon":"Generar cupón para orden","generate_order_coupon_warning":"El cupón se generará en base al monto total pagado y se enviará al correo electrónico del cliente","total_paid":"Total pagado","select_discount":"Seleccione el descuento a aplicar","select_reason":"Seleccione la razón","admin_note_content":"Se generó el cupón {couponName} con el siguiente motivo:","order_coupon_name":"Cupón para cliente {clientName}","coupon_generated_success":"¡Cupón generado exitosamente!","coupon_generated_message":"El cupón ha sido creado y está listo para ser activado.","coupon_activation_hint":"Puedes activarlo ahora o más tarde desde la tabla de cupones. De activarlo ahora, el cupón tendrá validez por 30 días, de lo contrario, no tendrá fecha de expiración.","activate_now":"Activar ahora","activate_later":"Activar más tarde","coupon_code_title":"El cupón está en proceso de activación","coupon_code_hint":"Al finalizar el proceso, el cliente recibirá un correo electrónico con el código del cupón.","order_coupon_additional_comments":"Comentarios adicionales"},"order_status":{"not_started":"No iniciada","started":"Iniciada","all":"Todas","assigned":"Asignada","unassigned":"Desasignado","dispatched":"Despachada","provider_arrived":"Rider vía Comercio","expired":"Expirada","payment_cash":"Pago en efectivo","payment_pos":"Punto de venta","not_delivered":"No entregada","in_queue":"Confirmada","arrived":"En destino","canceled":"Cancelada","confirmed":"Pagada","delayed":"Retrasada","delivered":"Completada","not_completed":"No completadas","in_progress":"En progreso","in_commerce":"En comercio","on_the_way":"En camino","prepared":"Preparada","preparation_started":"Preparación iniciada","is_ready":"Lista","payment_pending":"Pago pendiente","payment_to_validate":"Pago por validar","payment_refused_invalid":"Pago inválido","payment_refused_duplicated":"Pago duplicado","ready":"Por entregar","scheduled":"Programada","uncompleted":"Sin completar","unavailable":"No disponible","unconfirmed":"Sin confirmar","not_apply":"No aplica","payment_mixed":"Mixto"},"notification_status":{"aborted":"Abortada","cancelled":"Cancelada"},"page_404":{"message":"La página que buscas no fue encontrada.","title":"¡Ups! Se ha perdido."},"page_500":{"message":"La página que buscas no está disponible temporalmente","title":"¡Houston, tenemos un problema!"},"payments":{"adjust":"Ajuste","discount":"Descuento","validate":"Validar","delivery_fee":"Gastos de envío","delivery_details_fee":"Envío base","service_fee":"Servicios App","total_orden":"Total orden","approved_by":"Aprobado por","change":"Modificar","code":"Código","confirm_payment":"Marcar como pagada","confirmation_date":"Fecha de confirmación","confirmed":"Confirmado","duplicated":"Duplicado","false":"Falso","invalidated":"Inválido","refunded":"Reembolsado","mark_as_duplicated":"Marcar como duplicado","mark_as_invalid":"Marcar como inválido","mark_as_refunded":"Marcar como reembolsado","no_payments_registered":"No se han registrado pagos","no_proof_of_delivery_registered":"No se registró una prueba de entrega para esta orden.","no_registered_payments":"Aún no hay pagos registrados","payment_canceled_by_client":"Pago cancelado por el usuario","payment_confirmed_by":"Pago confirmado por","payment_confirmed_by_custom":"Marcada como pagada por","payment_duplicated_by":"Pago marcado como duplicado por","payment_forms":"Reportes de pago","payment_invalidated_by":"Pago invalidado por","payment_modal":"Nuevo formulario de pago","payments_forms":"Información de pagos","payment_fee":"Comisión","payments_received":"Pagos recibidos","amount_owed":"Monto adeudado","proof_of_delivery":"Prueba de entrega","sub_total":"Subtotal","tax":"Impuesto","taxes":"Comisiones","this_payment":" este pago?","tips":"Propina","total":"Total","true":"Verdadero","want_to_mark_as":"¿Estás seguro que quieres marcar como ","without_approving":"Pago sin aprobación","waiting":"En espera","service_details":"Detalles del servicio","report_payment":"Reportar pago","apply_payment_to_order":"Aplicar pago a esta orden","refunded_reason":"Para continuar, debe agregar una nota explicando el motivo del reembolso","view_data":"Ver datos","view_details":"Ver detalles","payment_details":"Detalles del pago","amount":"Monto","date":"Fecha","source_account":"Cuenta origen","source_bank":"Banco origen","source_phone":"Teléfono origen","source_dni":"Cédula origen","transaction_id":"Referencia","authorization_id":"ID de autorización"},"plugins":{"calendar_months":"Ene,Feb,Mar,Abr,May,Jun,Jul,Ago,Sep,Oct,Nov,Dic","calendar_weeks":"Dom,Lun,Mar,Mié,Jue,Vie,Sáb","next_week":"Próx. sem.","table":{"filterPlaceholder":"Filtrar...","contains":"Contiene","notContains":"No contiene","startsWith":"Empieza con","endsWith":"Termina con","equal":"Igual a","notEqual":"No es igual a","greaterThan":"Mayor a","greaterThanOrEqual":"Mayor o igual a","lessThan":"Menor a","lessThanOrEqual":"Menor o igual a","search_placeholder":"Buscar...","column_chooser":"Seleccionar columnas","show_filters":"Filtrar datos","clear_filters":"Limpiar filtros","archived_button":"Mostrar los archivados(as)","no_archived_button":"Mostrar los activos(as)"},"today":"Hoy","tomorrow":"Mañana"},"provider_details":{"active_orders_title":"Órdenes activas","ratings":"Ratings","no_ratings_msg":"No hay calificaciones","earnings":"Ingresos","aborted_count":"Órdenes abortadas","earnings_e2":"Ganancias","longest_run":"Distancia más larga recorrida","rating_count":"Conteo de calificaciones","rating_e2":"Calificación promedio","successful_count":"Órdenes exitosas","total_count":"Total de órdenes","total_run":"Distancia total recorrida","statistics":"Estadísticas"},"routes":{"app":"Aplicación","category":"Categoría","branch_goods":"Productos de Comercio","continue_register":"Continuar registro","create_layout":"Crear Diseño","create_template":"Crear Plantilla","custom_with_tour":"Generador de Aplicaciones","customer_info":"Información del usuario","dashboard":"Panel Principal","default_layout":"Inicio","edit_app":"Actualizar Aplicación","edit_layout":"Actualizar Diseño","edit_template":"Actualizar Plantilla","email_builder":"Plantillas de Correo","section":"Secciones App","table_apps_views":"Tabla de Aplicaciones","table_users_views":"Usuarios","user_profile":"Perfil de Usuario"},"select_normal":{"default_msg":"Por favor elija uno..."},"settings":{"geofences":"GeoCercas","text_button":"Boton con texto","payment_conf":"Configuraciones de pago","exchange_rate":"Tasa de cambio","date":"Fecha","payment":"Pago","add_cancelation_reason":"Ingrese una razón para cancelar orden","add_holiday_button":"Agregar fecha","address":"Dirección","address2":"Dirección 2","address_searchbox_placeholder":"Ej.: avenida, ciudad, estado, país","admin_chooses_bid":"Elegir entre varios repartidores","admin_chooses_bid_tooltip":"El administrador envía una orden a varios repartidores, los repartidores confirman y el administrador selecciona cuál de ellos realizará la orden.","admin_confirm_first":"Confirmar orden","admin_confirm_first_tooltip":"Antes de aceptar la orden el administrador debe confirmarla. No aplica para órdenes creadas por administradores.","admin_waits_confirmation_checker":"Esperar confirmación de un repartidor","admin_waits_confirmation_checker_tooltip":"El administrador envía una orden a varios repartidores. La orden la realizará el primer repartidor que la confirme.","allow_delivery_checker":"A domicilio","allow_delivery_checker_tooltip":"Las órdenes son entregadas a domicilio por un repartidor asignado.","allow_pickup_checker":"En tienda","allow_pickup_checker_tooltip":"El usuario recoge la orden en la tienda.","approved":"Aprobado","assigns_title":"Asignaciones","branch_settings":"Ajustes del comercio","branch_group_settings":"Ajustes del grupo","cancelation_reason":"Razones de cancelación","cancelation_reason_admin":"Razones de cancelación (admin)","cancelation_reason_users":"Razones de cancelación a usuarios","not_delivered_reason":"Razones por las que no fue entregada","city":"Ciudad","client_app_title":"App del usuario","client_chooses_provider_checker":"Permitir elección del repartidor","client_chooses_provider_checker_tooltip":"Los usuarios seleccionan un repartidor para atender su orden.","client_confirms_checker":"Permitir confirmación de repartidor","client_confirms_checker_tooltip":"Los usuarios deciden si confirman o rechazan al repartidor.","client_message":"Mensajes para el usuario","code_proof_checker":"Usar código","code_proof_checker_tooltip":"El repartidor debe enviar a la compañía el código suministrado por el usuario.","company_holidays":"Días festivos","company_in_service":"Compañía en Servicio","company_in_service_des":"Al tener la compañía en servicio, no podrá editar sus productos o variantes. Al deshabilitar esta opción no podrá crear ni recibir órdenes.","branch_in_service":"Comercio en Servicio","branch_in_service_des":"Al tener el Comercio en servicio, no podrá editar sus productos o variantes. Al deshabilitar esta opción no podrá crear ni recibir órdenes.","company_location":"Ubicación","company_work_schedule":"Horarios de Atención","content":"Contenido","country":"País","currency":"Moneda","invoice_enabled_title":"Emisión de Facturas","invoice_enabled_msg":"Permitir a los admins generar un pdf con la factura de una orden","currency_conf":"Moneda internacional","custom_domain":"Dominio Web personalizado","default_lang":"Idioma por defecto de la compañía","delivery_type":"Tipo de entrega","delivery_settings_title":"Configuraciones de entrega","dispatcher_config_title":"Configuración de despacho","domain":"Dominio Web","draf":"Borrador","email":"Responder a ","text_config_title":"Configuraciones de texto","email_footer_tittle":" Pie del correo de confirmación de orden","expiration_date":"Fecha de expiración","extension_days":"Días de prórroga","field_type":"Tipo de campo","form_code_proof_checker":"Usar formulario","form_code_proof_checker_tooltip":"El repartidor debe completar y enviar el formulario. La compañía debe tener habilitado el formulario.","forms":"Formularios","geo_address":"Buscar dirección","goods_matching_title":"Asignación de órdenes","head_title":"Configurar datos de Compañía","holidays_tooltip":"Selecciona una fecha en el calendario y luego haz clic en Agregar para guardar nuevas festividades no laborables.","image":"Imagen","in_process":"En proceso","in_review":"En revisión","information_title":"General","extra_data_title":"Datos","input":"Campo","invoices":"Facturas","invoice_settings":"Configuración de Facturas","payments_data":"Datos para pagos","link_password_recovery":"Haz clic para restablecer tu contraseña","terms_of_service_title":"Términos del servicio","terms_of_service_label":"Términos de Servicio de tu compañía","invoice_paper_size":"Tamaño de la factura","invoice_paper_orientation":"Orientación de la factura","mandatory":"Requerido","map_note":"Guarda tu geolocalización moviendo el marcador en el mapa, luego presiona 'Guardar' o guarda la geolocalización actual de tu computadora al presionar en el icono de casa","message_schedule_conflict":"El horario ingresado choca con otro ya almacenado, si lo desea puede borrar el horario en conflicto o corregir los datos ingresados","message_schedule_input_error":"Por favor revise los datos ingresados","movil_app_state":"Estado de la aplicación móvil","no_holidays_msg":"La compañía no ha ingresado fechas festivas","no_schedule_msg":"La compañía no tiene horario de atención al público asignado","not_registered_yet":"No registradas aún","one_time_holiday":"(este año)","options":"Opciones","payment_methods":"Métodos de pago","picture_code_proof_checker":"Usar foto","picture_code_proof_checker_tooltip":"El repartidor debe enviar a la compañía una foto de la entrega al usuario.","pricelist":"Lista de precios","proof_delivery_settings":"Pruebas de entrega","provider_app_title":"App del repartidor","provider_chooses_order_checker":"Permitir elección de órdenes","provider_chooses_order_checker_tooltip":"Los repartidores pueden ver el listado de órdenes sin asignar y autoasignarse a ellas.","provider_confirms_checker":"Permitir confirmación de órdenes","provider_confirms_checker_tooltip":"Los repartidores pueden confirmar o rechazar las órdenes asignadas por los usuarios.","provider_forfeit_checker":"Permitir rechazo de órdenes","provider_forfeit_checker_tooltip":"Los repartidores pueden abandonar órdenes asignadas.","provider_message":"Mensajes para el repartidor","publish":"Publicada","question":"Pregunta","ready_for_publish":"Lista para publicarse","ready_to_send":"Lista para enviar","rejected":"Rechazada","selected_holiday_msg":"¿Festividad anual?","sent":"Enviada","service_matching_title":"Configuración de selección de servicios","service_notification_title":"Servicio de notificaciones","set_current_location_tooltip":"Usar geolocalización actual de tu computadora","signature_code_proof_checker":"Usar firma","signature_code_proof_checker_tooltip":"El usuario debe firmar la entrega al repartidor como prueba de confirmación.","simple_selection":"Selección simple","state":"Estado","tax":"Impuesto","title_hour_from":"Desde","title_hour_to":"Hasta","title_schedule_conflict":"Conflicto en horario","title_schedule_input_error":"Error en fechas","title_week_days":"Día","true_false":"Verdadero/Falso","work_schedule_nav":"Horarios de Atención","work_schedule_title":"Horarios de Atención Personalizado","work_schedule_title_2":"24 Horas al Día, 7 Días a la Semana","work_schedule_save":"Guardar Horario Personalizado","monday":"Lunes","tuesday":"Martes","wednesday":"Miércoles","thursday":"Jueves","friday":"Viernes","saturday":"Sábado","sunday":"Domingo","remove":"Quitar","repeat":"Repetir","holiday":"Dia no laborable","holidays_title":"Días no laborables","holidays_text":"Anual","holidays_btn":"Guardar Calendario","holidays_Title_Modal":"Días no laborables Seleccionados","no_holidays":"{branch} no tiene dias no laborables configurados","error_holidays":"Ha ocurrido un error inesperado","error_holidays_description":"Ha ocurrido un error al cargar los días feriados","no_holidays_description":"Empieza a configurar los dias no laborables aquí","create_holiday":"Crear dia no laborable","edit_holiday":"Editar dia no laborable","repeat_annually":"Repetir anualmente","in_progress":"En progreso","not_repeat":"No repetir anualmente","delete_holiday_confirmation":"¿Estás seguro de que deseas eliminar este día feriado?","we_start":"Empezamos","we_return":"Volvemos","MONTHS":["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],"WEEKDAYS_SHORT":["Lu","Ma","Mi","Ju","Vi","Sa","Do"],"see_on_maps":"Ver en mapa","latitude":"Latitud","longitude":"Longitud","the_city":"a la ciudad","city_branches":"Estos son los negocios que están asociados a","no_city_branches":"Actualmente no existen negocios asociados a","max_simultaneous_deliveries":"Máximo de envíos en simultáneo","is_special_contributor":"Es contribuyente especial","income_tax":"Impuesto sobre la renta","tax_retention":"Retención de impuesto","is_payment_deduction_disabled":"Deshabilitar deducción de pago","branch_invoice_tax_name":"Nombre del impuesto","branch_invoice_tax_prc":"Porcentaje del impuesto","mark_too_busy_until":"Marcar comercio como aboyado","auto_busy_quantity":"Límite de órdenes para marcar el comercio como aboyado","email_for_fiscal_docs":"Correo electrónico para documentos fiscales","address_for_fiscal_docs":"Dirección para documentos fiscales","digital_invoice":"Facturación digital","is_digital_invoice_enabled":"Habilitar facturación digital","business_name":"Razón social","legal_name_for_fiscal_docs":"Nombre del comercio para documentos fiscales","messages_list":"Lista de mensajes","params_list":"Lista de parámetros","multi_orders":"Multi-órdenes","multi_orders_optimization":"Optimización de multi-órdenes","auto_sync_work_schedules_warning":"{branch} no tiene la sincronizacion de horarios activada, por lo que deberá iniciarce manualmente una vez que acaben las vacaciones."},"table_app":{"category":"Categoría","name":"Usuario"},"table_categories":{"branch_categories":"Categorías de Comercio","confirmation_question_1":"¿Está seguro de que quiere ","confirmation_question_2":" esta categoría?","create_category_title":"Crear nueva categoría","pinned":"Destacado","unpinned":"No Destacado","update_category_title":"Actualizar categoría","update_subcategory_title":"Actualizar subcategoría","visibility":"Visibilidad","visible":"Visible","hidden":"Oculto"},"table_client":{"avatar":"Avatar","registration_date":"Fecha Registro","confirmation_question_1":"¿Está seguro de que quiere ","confirmation_question_2":" este usuario ?","create_client_title":"Crear nuevo usuario","update_client_title":"Actualizar usuario","confirmed_counter":"Usuarios confirmados","unconfirmed_counter":"Usuarios sin confirmar","created_by_admin":"Usuarios registrados por Admin"},"table_admins":{"disabled":"Suspendido","seller":"Vendedor","account":"Cuenta","active":"Activo","add_company_access":"Dar accesso Admin Zupper","remove_company_access":"Remover accesso Admin Zupper","add_company_access_long":"darle accesso como Admin Zupper a","remove_company_access_long":"remover el accesso como Admin Zupper a","branchAdmins":"Admins de Comercio","branchGroupsAdmins":"Admins Grupo","branchCompanyAdmins":"Admins Compañía","blocked":"Bloqueado","block":"Bloquear","confirmation_question_1":"¿Está seguro de que quiere ","confirmation_question_2":" este usuario administrador?","create_title":"Crear nuevo administrador","permanent_ban":"Bloquear permanentemente","temporal_ban":"Bloquear temporalmente","unblock":"desbloquear","permanently_banned":"Permanentemente bloqueado","temporarily_banned":"Temporalmente bloqueado","downgrade":"Bajar jerarquía","high":"Superior","low":"Inicial","confirmed":"Confirmado","off_line":"Desconectado","online":"Conectado","owner":"Propietario","status":"Estado","type":"Tipo","unconfirmed":"Sin confirmar","update_title":"Actualizar administrador","unverified":"Teléfono sin confirmar","upgrade":"Subir jerarquía","hierarchy":"Jerarquía","special_permissions":"Permisos Especiales"},"table_good":{"available":"Disponible","categories":"Categorías","categories_of_msg":"Categorías de","confirmation_question_1":"¿Está seguro de que quiere ","confirmation_question_2":" este producto?","create_title":"Crear nuevo producto","details":"Detalles","duplicate_good":"Duplicar producto","eta":"Tiempo de entrega","mark_as_available":"Marcar como disponible","mark_as_unavailable":"Marcar como no disponible","picture":"Imagen","properties_of_msg":"variantes de ","property":"Variantes","type":"Tipo","turn_into_combo":"Convertir en combo","edit_combo":"Editar combo","unavailable":"No disponible","update_title":"Actualizar producto","minutes":"Minutos","show_all":"Mostrar todos los productos","show_available_only":"Mostrar productos en existencia","show_unavailable_only":"Mostrar productos agotados","show_featured_only":"Mostrar productos destacados","featured":"Destacado","remove_featured_question":"quitar la configuración de destacado de este producto?"},"table_orders":{"alert_third_party_provider":"Esta orden está asignada a una flota de terceros.","assign_provider_to":"Asignar repartidor a","assign_shopper_to":"Asignar shopper a","client_label":"Usuario","confirmation_question_1":"¿Está seguro de que quiere ","confirmation_question_2":"confirmar","confirmation_question_3":"Orden # ","confirmation_question_A":"Cancelar orden # ","confirmation_question_B":"Marcar como no entregada orden ","branch_label":"Comercio","delivery_method_asap":"Inmediato","goods_carrier":"Prestador de servicios","is_pickup_label":"Entrega","mixed":"Mixto","no_provider_msg":"Sin repartidor","resend_pool":"Volver a enviar al pool","send_to_pool":"Enviar al pool","provider_label":"Atendida por","requested_label":"Solicitada","restore_question1":"¿Está seguro de que quiere","restore_question2":"esta orden?","schedule_label":"Programada","select_provider_placeholder":"Seleccione...","service_provider":"repartidor de servicios","status_label":"Estado","total_label":"Total","unassing":"Desasignar","cancel":"Cancelar","show_all_cities":"Todas las ciudades","cancel_prepared_order_question":"La orden está preparada, ¿Está seguro de querer cancelarla?","cancel_completed_order_question":"La orden está completada, ¿Está seguro de querer marcarla como no entregada?","add_note":"Agregar nota","edit_note":"Editar nota","invoice_unallowed":"No facturar","invoice_allowed":"Habilitar facturación","proof_of_shopper":"Comprobante de shopper","find_reference":"Buscar referencia"},"table_properties":{"available":"Disponible","confirmation_question_1":"¿Está seguro de que quiere ","confirmation_question_2":" esta variante?","create_title":"Crear nueva variante","list":"Lista","numeric":"Numérico","state":"Estado","text":"Texto","type":"Tipo","unavailable":"No disponible","update_title":"Actualizar variante"},"confirmation_question_2":" este producto?","table_provider_orders_views":{"show_completed":"Completados"},"table_providers":{"active":"Activo","blocked":"Bloqueado","confirmation_question_1":"¿Está seguro de que quiere ","confirmation_question_2":" este usuario?","create_new_provider":"Crear nuevo repartidor","disabled":"Deshabilitado","off_line":"Desconectado","restore_question1":"¿Está seguro de que quiere ","restore_question2":" este usuario repartidor?","unconfirmed":"Sin confirmar","online":"Conectados","offline":"Desconectados","show_all":"Mostrar todos"},"fleets":{"association":"Asociación","cargo":"Carga","confirmation_question_1":"¿Está seguro de que quiere ","confirmation_question_2":" esta flota?","confirmation_question_3":" este método de pago?","create_fleet":"Crear flota","create_payment_method":"Crear método de pago","edit_fleet":"Editar flota","fleet":"Flota","fleets":"Flotas","invalid_name":"El nombre {name} ya existe, por favor elija otro nombre","invalid_code":"El código {code} ya existe, por favor elija otro código","no_fleets":"No hay flotas asignadas a este proveedor","passengers":"Pasajeros","profiles":"Perfiles","service_distance":"Distancia del servicio","service_distance_tooltip":"Distancia máxima del recorrido de la orden","service_radio":"Radio del servicio","service_radio_tooltip":"Distancia máxima entre el repartidor y el comercio","service_suppliers":"Proveedores de servicio","pref_max_simultaneous_deliveries":"Máximo de envíos en simultáneo","pref_allow_multi_delivery_by_self":"Permitir asignación simultánea desde el pool","code":"Código","code_placeholder":"Máximo 16 caracteres","binding_attribute":"Enlazar método de pago","currency_iso":"Moneda","tax_flat":"Impuesto base","tax_prc":"Porcentaje de impuesto","tax_prc_placeholder":"Debe ser un número entre 0 y 1","payment_methods":"Métodos de pago","payment_method":"Método de pago","no_payment_methods":"No hay métodos de pagos para esta flota","brand":"Marca","model":"Modelo","color":"Color","plate":"Placa","year":"Año"},"table_service_suppliers":{"confirmation_question_1":"¿Está seguro de que quiere ","confirmation_question_2":" este proveedor de servicio?"},"tooltips":{"details":"Por favor ingrese más detalles","display_name":"Inserte nombre de usuario","email":"Ej.: usuario@dominio.com","item_name":"Por favor ingrese nombre","name":"Inserte nombre y apellido","phone":"Ej.: 0293-123-4567","phone_alt":"Ej: 1234567","price":"Por favor ingrese precio","short_details":"Por favor ingrese detalles cortos","sku":"Por favor ingrese SKU","eta":"Por favor ingrese tiempo de entrega estimado del producto","stock":"Por favor ingrese cantidad de variantes en existencia"},"user_nav":{"badge":"NUEVO","dashboard_link":"Panel Principal","prototype_builder_link":"Generador de Prototipos"},"validation_errors":{"accepted":"Este campo debe estar seleccionado.","alpha":"Este campo sólo puede contener letras.","alpha_num":"Este campo sólo puede contener letras y números.","alpha_num_dash":"Este campo sólo puede contener letras, números y guiones.","card_exp":"Este campo debe ser una fecha válida.","card_num":"Este campo no parece un número de tarjeta de crédito válida.","currency":"Este campo no es una moneda válida.","decimal":"Este campo debe ser un número decimal válido.","email":"Por favor ingrese un correo válido","gt":"Este campo debe ser mayor a :gt.","gte":"Este campo debe ser mayor o igual a :gte.","in":"Este campo seleccionado debe estar entre uno de éstos: :values.","integer":"Este campo debe ser un número entero.","lt":"Este campo debe ser un número menor que :lt.","lte":"Este campo debe ser menor o igual a :lte.","max":"Este campo no debe contener más de :max caracteres.","min":"Este campo no debe contener menos de :min caracteres.","not_in":"Este campo seleccionado no debe ser uno de éstos: :values.","numeric":"Este campo debe ser numérico.","phone":"Este campo debe ser un número de teléfono válido. 123-456-7890","required":"Este campo es obligatorio","url":"Este campo debe ser una URL válida. Ej.: https://subdominio.dominio.algo"},"two_steps_modal":{"title":"Verificación de dos factores","default_message":"Por favor, ingrese el código de verificación enviado al correo electrónico","default_title":"Esta acción requiere verificación de dos factores","send":"Enviar","wrong_two_steps_code":"Código de verificación incorrecto","not_found_signature":"El código ha expirado, por favor intente nuevamente.","default_error":"Ha ocurrido un error inesperado"},"coupons":{"modify_end_date":"Modificar fecha de expiración","ends_date":"Fecha de expiración","is_cashback":"¿Es cashback?","cashback_config":"{type} de tipo cashback","cashback_config_tooltip_coupon":"Si se activa, al finalizar el cupón, el descuento se convertirá en saldo disponible para el usuario","cashback_config_tooltip_promo":"Si se activa, al finalizar la promoción, el descuento se convertirá en saldo disponible para el usuario","internal_code":"SKU","category_name":"Nombre de la categoría","sum_quantity":"Suma de productos"},"billings":{"adjustment_type":"Tipo de ajuste","adjustment_type_placeholder":"Seleccione un tipo de ajuste","amount":"Monto","general_balance_adjustment":"Ajuste de balance general","order_balance_adjustment":"Ajuste de balance por orden","select_type_message":"Por favor, seleccione un tipo de ajuste de balance para continuar","search_order":"Buscar orden","order_not_found":"Orden no encontrada","search_order_placeholder":"Ingrese el número de la orden"},"webhooks":{"create_title":"Crear webhook","create_block":"Crear bloque","block":"Bloque","edit_title":"Editar webhook","delete_title":"Eliminar webhook","select_placeholder":"Seleccione un tipo de webhook","select_type":"Seleccione un tipo","display_name":"Nombre personalizado","enable_config":"Habilitar configuración de {type}","configuration_of":"Configuración de {type}","select_handler":"Seleccione un handler","select_hook":"Seleccione un hook","hook_name":"Nombre del hook","auto_sync":"Auto sincronización","auto_sync_delay":"Retraso de sincronización","auto_sync_offset":"Offset de sincronización","response_processor":"Procesador de respuesta","check_in_service":"Verificar en servicio","order_status_mask":"Mascara de estado de orden","ext":"Extensión","appends":"Anexos","category_ignored_words":"Ignorar palabras para categorías","category_mapping":"Mapeo de categoría","currency_mapping":"Mapeo de moneda","csv_settings":"Configuración de CSV","select_key":"Seleccione el tipo de key","delimiter":"Delimitador","enclosure":"Contenedor","line_ending":"Fin de línea","use_bom":"Usar BOM","include_separator_line":"Incluir línea separadora","excel_compatibility":"Compatibilidad con Excel","escape_character":"Carácter de escape","contiguous":"Contiguo","input_encoding":"Codificación de entrada","output_encoding":"Codificación de salida","image_name_column":"Nombre de imagen","data_accessor":"Acceso a datos","refresh_data":"Refrescar datos","clear_missing":"Eliminar faltantes","refresh_category":"Refrescar categorías","tax_included":"Impuesto incluido","tax_round_mode":"Modo de redondeo de impuestos","tax_multiplier":"Multiplicador de impuestos","quantity_threshold":"Umbral de cantidad","quantity_reservation":"Reserva de cantidad","starting_cell":"Celda inicial","separated_sku":"SKU separado","currency":"Moneda","debug":"Modo depuración","vertical_image_name_column":"Nombre de imagen vertical","image_url":"URL de imagen","vertical_image_url":"URL de imagen vertical","weight_config":"Configuración de peso","bulk_upload":"Carga masiva","config":"Configuraciones","columns":"Columnas","add_column":"Agregar columna","conditions":"Condiciones","ttl":"TTL","backoff":"Backoff","use_body":"Usar body","tries":"Intentos","method":"Método","select_method":"Seleccione un método","no_data":"No hay webhooks","basic_config":"Configuración básica","advance_config":"Configuración avanzada","import_config":"Configuración de importación","additional_config":"Configuración adicional","no_additional_config":"Sin configuración adicional","auth":"Autenticación","auth_type":"Tipo de autenticación","auth_none_msg":"No se requiere autenticación","user_name":"Nombre de usuario","user_password":"Contraseña","confirmation_question_1":"¿Está seguro de que quiere ","confirmation_question_2":" este webhook?"}}

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(119);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(453);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(194);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(450);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(447);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(445);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(45)))

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(196);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(449);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(194);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(195);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(454);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(119);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_companyActions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TwoStepsModal=function(_Component){_inherits(TwoStepsModal,_Component);function TwoStepsModal(props){_classCallCheck(this,TwoStepsModal);var _this=_possibleConstructorReturn(this,(TwoStepsModal.__proto__||Object.getPrototypeOf(TwoStepsModal)).call(this,props));_this.toggleModal=function(dispatchEvent){if(dispatchEvent){__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),document.getElementById("two-steps-verification"));}else{__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),document.getElementById("two-steps-verification"));}};_this.handleChange=function(value,index){if(!/^\d?$/.test(value))return;var code=[].concat(_toConsumableArray(_this.state.code));code[index]=value;_this.setState({code:code},function(){if(value&&index<5){_this.inputs[index+1].focus();}else if(value===""&&index>0){_this.inputs[index-1].focus();}});};_this.handleSubmit=function(){var _this$props=_this.props,data=_this$props.data,config=_this$props.config;var fullCode=_this.state.code.join("");_this.setState({loading:true});if(fullCode.length===6){_this.setState({errors:{},loading:false});var prevData={};if(config.data){prevData=JSON.parse(config.data);}var body=Object.assign({},prevData,{_two_step_verification_code:fullCode,_signature:data.signature});var url=config.url;var method=config.method;_this.props.sendTwoStepsVerification(url,method,body).then(function(){if(_this.props.twoSteps&&_this.props.twoSteps.error){if(_this.props.twoSteps.message){_this.setState({errors:{validation_code:_this.props.twoSteps.message},loading:false});}else{_this.toggleModal();}}else{_this.props.promiseResolver(_this.props.twoSteps.data);_this.toggleModal(true);}});}else{_this.setState({errors:{validation_code:"Por favor, completa el código de 6 dígitos."},loading:false});}};_this.state={modal:_this.props.toggleModal,code:["","","","","",""],errors:{validation_code:""},loading:false};_this.inputs=[];return _this;}_createClass(TwoStepsModal,[{key:'render',value:function render(){var _this2=this;var _props=this.props,json_lang=_props.json_lang,title=_props.title,message=_props.message;var _state=this.state,code=_state.code,errors=_state.errors,modal=_state.modal,loading=_state.loading;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Modal"],{isOpen:modal,toggle:this.toggleModal,className:this.props.className||'',style:this.props.style||{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["ModalHeader"],{toggle:this.toggleModal},json_lang.two_steps_modal.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["ModalBody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center mt-4 mb-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'text-danger'},json_lang.common.attention.toUpperCase()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,title||json_lang.two_steps_modal.default_title)),message&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'text-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,message)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,json_lang.two_steps_modal.default_message))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex flex-column justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["FormGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:"flex",gap:"10px",justifyContent:"center"}},code.map(function(digit,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Input"],{key:index,type:'text',maxLength:'1',value:digit,onChange:function onChange(e){return _this2.handleChange(e.target.value,index);},invalid:errors.validation_code!==""&&digit==="",innerRef:function innerRef(input){return _this2.inputs[index]=input;},style:{textAlign:"center",width:"40px"}});})),errors.validation_code&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["FormFeedback"],{style:{display:"flex",justifyContent:"center"}},errors.validation_code)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Button"],{disabled:loading,color:'primary',onClick:function onClick(){return _this2.handleSubmit();}},json_lang.two_steps_modal.send),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Button"],{color:'secondary',onClick:function onClick(){return _this2.toggleModal();}},json_lang.common.cancel)));}}]);return TwoStepsModal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{json_lang:state.json_lang,twoSteps:state.twoSteps};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{sendTwoStepsVerification:function sendTwoStepsVerification(url,method,body){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_companyActions__["_26" /* sendTwoStepsVerification */])(url,method,body));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(TwoStepsModal));

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(457));

var _Toast = _interopRequireDefault(__webpack_require__(459));

var _CloseButton = _interopRequireDefault(__webpack_require__(461));

var _Transitions = __webpack_require__(199);

var _constant = __webpack_require__(79);

var _eventManager = _interopRequireDefault(__webpack_require__(201));

var _propValidator = __webpack_require__(198);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ToastContainer =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(ToastContainer, _Component);

  function ToastContainer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      toast: []
    };
    _this.collection = {};

    _this.isToastActive = function (id) {
      return _this.state.toast.indexOf(id) !== -1;
    };

    return _this;
  }

  var _proto = ToastContainer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    _eventManager.default.on(_constant.ACTION.SHOW, function (content, options) {
      return _this2.show(content, options);
    }).on(_constant.ACTION.CLEAR, function (id) {
      return id !== null ? _this2.removeToast(id) : _this2.clear();
    }).emit(_constant.ACTION.DID_MOUNT, this);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    _eventManager.default.off(_constant.ACTION.SHOW).off(_constant.ACTION.CLEAR).emit(_constant.ACTION.WILL_UNMOUNT);
  };

  _proto.removeToast = function removeToast(id) {
    this.setState({
      toast: this.state.toast.filter(function (v) {
        return v !== id;
      })
    }, this.dispatchChange);
  };

  _proto.dispatchChange = function dispatchChange() {
    _eventManager.default.emit(_constant.ACTION.ON_CHANGE, this.state.toast.length);
  };

  _proto.makeCloseButton = function makeCloseButton(toastClose, toastId, type) {
    var _this3 = this;

    var closeButton = this.props.closeButton;

    if ((0, _react.isValidElement)(toastClose) || toastClose === false) {
      closeButton = toastClose;
    }

    return closeButton === false ? false : (0, _react.cloneElement)(closeButton, {
      closeToast: function closeToast() {
        return _this3.removeToast(toastId);
      },
      type: type
    });
  };

  _proto.getAutoCloseDelay = function getAutoCloseDelay(toastAutoClose) {
    return toastAutoClose === false || (0, _propValidator.isValidDelay)(toastAutoClose) ? toastAutoClose : this.props.autoClose;
  };

  _proto.canBeRendered = function canBeRendered(content) {
    return (0, _react.isValidElement)(content) || typeof content === 'string' || typeof content === 'number' || typeof content === 'function';
  };

  _proto.parseClassName = function parseClassName(prop) {
    if (typeof prop === 'string') {
      return prop;
    } else if (prop !== null && typeof prop === 'object' && 'toString' in prop) {
      return prop.toString();
    }

    return null;
  };

  _proto.show = function show(content, options) {
    var _this4 = this,
        _extends2;

    if (!this.canBeRendered(content)) {
      throw new Error("The element you provided cannot be rendered. You provided an element of type " + typeof content);
    }

    var toastId = options.toastId;

    var closeToast = function closeToast() {
      return _this4.removeToast(toastId);
    };

    var toastOptions = {
      id: toastId,
      type: options.type,
      closeToast: closeToast,
      updateId: options.updateId,
      rtl: this.props.rtl,
      position: options.position || this.props.position,
      transition: options.transition || this.props.transition,
      className: this.parseClassName(options.className || this.props.toastClassName),
      bodyClassName: this.parseClassName(options.bodyClassName || this.props.bodyClassName),
      closeButton: this.makeCloseButton(options.closeButton, toastId, options.type),
      pauseOnHover: typeof options.pauseOnHover === 'boolean' ? options.pauseOnHover : this.props.pauseOnHover,
      pauseOnFocusLoss: typeof options.pauseOnFocusLoss === 'boolean' ? options.pauseOnFocusLoss : this.props.pauseOnFocusLoss,
      draggable: typeof options.draggable === 'boolean' ? options.draggable : this.props.draggable,
      draggablePercent: typeof options.draggablePercent === 'number' && !isNaN(options.draggablePercent) ? options.draggablePercent : this.props.draggablePercent,
      closeOnClick: typeof options.closeOnClick === 'boolean' ? options.closeOnClick : this.props.closeOnClick,
      progressClassName: this.parseClassName(options.progressClassName || this.props.progressClassName),
      progressStyle: this.props.progressStyle,
      autoClose: this.getAutoCloseDelay(options.autoClose),
      hideProgressBar: typeof options.hideProgressBar === 'boolean' ? options.hideProgressBar : this.props.hideProgressBar
    };
    typeof options.onOpen === 'function' && (toastOptions.onOpen = options.onOpen);
    typeof options.onClose === 'function' && (toastOptions.onClose = options.onClose); // add closeToast function to react component only

    if ((0, _react.isValidElement)(content) && typeof content.type !== 'string' && typeof content.type !== 'number') {
      content = (0, _react.cloneElement)(content, {
        closeToast: closeToast
      });
    } else if (typeof content === 'function') {
      content = content({
        closeToast: closeToast
      });
    }

    this.collection = _extends({}, this.collection, (_extends2 = {}, _extends2[toastId] = {
      position: toastOptions.position,
      options: toastOptions,
      content: content
    }, _extends2));
    this.setState({
      toast: toastOptions.updateId ? _toConsumableArray(this.state.toast) : _toConsumableArray(this.state.toast).concat([toastId])
    }, this.dispatchChange);
  };

  _proto.makeToast = function makeToast(content, options) {
    return _react.default.createElement(_Toast.default, _extends({}, options, {
      isDocumentHidden: this.state.isDocumentHidden,
      key: "toast-" + options.id
    }), content);
  };

  _proto.clear = function clear() {
    this.setState({
      toast: []
    });
  };

  _proto.renderToast = function renderToast() {
    var _this5 = this;

    var toastToRender = {};
    var _this$props = this.props,
        className = _this$props.className,
        style = _this$props.style,
        newestOnTop = _this$props.newestOnTop;
    var collection = newestOnTop ? Object.keys(this.collection).reverse() : Object.keys(this.collection); // group toast by position

    collection.forEach(function (toastId) {
      var _this5$collection$toa = _this5.collection[toastId],
          position = _this5$collection$toa.position,
          options = _this5$collection$toa.options,
          content = _this5$collection$toa.content;
      toastToRender[position] || (toastToRender[position] = []);

      if (_this5.state.toast.indexOf(options.id) !== -1) {
        toastToRender[position].push(_this5.makeToast(content, options));
      } else {
        toastToRender[position].push(null);
        delete _this5.collection[toastId];
      }
    });
    return Object.keys(toastToRender).map(function (position) {
      var disablePointer = toastToRender[position].length === 1 && toastToRender[position][0] === null;
      var props = {
        className: (0, _classnames.default)('Toastify__toast-container', "Toastify__toast-container--" + position, {
          'Toastify__toast-container--rtl': _this5.props.rtl
        }, _this5.parseClassName(className)),
        style: disablePointer ? _extends({}, style, {
          pointerEvents: 'none'
        }) : _extends({}, style)
      };
      return _react.default.createElement(_TransitionGroup.default, _extends({}, props, {
        key: "container-" + position
      }), toastToRender[position]);
    });
  };

  _proto.render = function render() {
    return _react.default.createElement("div", {
      className: "Toastify"
    }, this.renderToast());
  };

  return ToastContainer;
}(_react.Component);

ToastContainer.propTypes = {
  /**
   * Set toast position
   */
  position: _propTypes.default.oneOf((0, _propValidator.objectValues)(_constant.POSITION)),

  /**
   * Disable or set autoClose delay
   */
  autoClose: _propValidator.falseOrDelay,

  /**
   * Disable or set a custom react element for the close button
   */
  closeButton: _propValidator.falseOrElement,

  /**
   * Hide or not progress bar when autoClose is enabled
   */
  hideProgressBar: _propTypes.default.bool,

  /**
   * Pause toast duration on hover
   */
  pauseOnHover: _propTypes.default.bool,

  /**
   * Dismiss toast on click
   */
  closeOnClick: _propTypes.default.bool,

  /**
   * Newest on top
   */
  newestOnTop: _propTypes.default.bool,

  /**
   * An optional className
   */
  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),

  /**
   * An optional style
   */
  style: _propTypes.default.object,

  /**
   * An optional className for the toast
   */
  toastClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),

  /**
   * An optional className for the toast body
   */
  bodyClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),

  /**
   * An optional className for the toast progress bar
   */
  progressClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),

  /**
   * An optional style for the toast progress bar
   */
  progressStyle: _propTypes.default.object,

  /**
   * Define enter and exit transition using react-transition-group
   */
  transition: _propTypes.default.func,

  /**
   * Support rtl display
   */
  rtl: _propTypes.default.bool,

  /**
   * Allow toast to be draggable
   */
  draggable: _propTypes.default.bool,

  /**
   * The percentage of the toast's width it takes for a drag to dismiss a toast
   */
  draggablePercent: _propTypes.default.number,

  /**
   * Pause the toast on focus loss
   */
  pauseOnFocusLoss: _propTypes.default.bool
};
ToastContainer.defaultProps = {
  position: _constant.POSITION.TOP_RIGHT,
  transition: _Transitions.Bounce,
  rtl: false,
  autoClose: 5000,
  hideProgressBar: false,
  closeButton: _react.default.createElement(_CloseButton.default, null),
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  closeOnClick: true,
  newestOnTop: false,
  draggable: true,
  draggablePercent: 80,
  className: null,
  style: null,
  toastClassName: null,
  bodyClassName: null,
  progressClassName: null,
  progressStyle: null
};
var _default = ToastContainer;
exports.default = _default;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactLifecyclesCompat = __webpack_require__(97);

var _ChildMapping = __webpack_require__(458);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }

  /**
   * The `<TransitionGroup>` component manages a set of `<Transition>` components
   * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
   * state machine for managing the mounting and unmounting of components over
   * time.
   *
   * Consider the example below using the `Fade` CSS transition from before.
   * As items are removed or added to the TodoList the `in` prop is toggled
   * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
   * component in a `<TransitionGroup>`, not just css.
   *
   * ## Example
   *
   * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual `<Transition>`
   * components. This means you can mix and match animations across different
   * list items.
   */
};
var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var handleExited = _this.handleExited.bind(_this);

    // Initial children should all be entering, dependent on appear
    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;

    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  TransitionGroup.prototype.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);

    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    this.setState(function (state) {
      var children = _extends({}, state.children);

      delete children[child.key];
      return { children: children };
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = values(this.state.children).map(childFactory);

    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
module.exports = exports['default'];

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);

  Object.keys(children).forEach(function (key) {
    var child = children[key];

    if (!(0, _react.isValidElement)(child)) return;

    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;

    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

    // item is new (entering)
    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, { in: false });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });

  return children;
}

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _ProgressBar = _interopRequireDefault(__webpack_require__(460));

var _constant = __webpack_require__(79);

var _propValidator = __webpack_require__(198);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function getX(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}

function getY(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}

var noop = function noop() {};

var Toast =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Toast, _Component);

  function Toast() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      isRunning: true,
      preventExitTransition: false
    };
    _this.flag = {
      canCloseOnClick: true,
      canDrag: false
    };
    _this.drag = {
      start: 0,
      x: 0,
      y: 0,
      deltaX: 0,
      removalDistance: 0
    };
    _this.ref = null;

    _this.pauseToast = function () {
      if (_this.props.autoClose) {
        _this.setState({
          isRunning: false
        });
      }
    };

    _this.playToast = function () {
      if (_this.props.autoClose) {
        _this.setState({
          isRunning: true
        });
      }
    };

    _this.onDragStart = function (e) {
      _this.flag.canCloseOnClick = true;
      _this.flag.canDrag = true;
      _this.ref.style.transition = '';
      _this.drag.start = _this.drag.x = getX(e.nativeEvent);
      _this.drag.removalDistance = _this.ref.offsetWidth * (_this.props.draggablePercent / 100);
    };

    _this.onDragMove = function (e) {
      if (_this.flag.canDrag) {
        if (_this.state.isRunning) {
          _this.pauseToast();
        }

        _this.drag.x = getX(e);
        _this.drag.deltaX = _this.drag.x - _this.drag.start; // prevent false positif during a toast click

        _this.drag.start !== _this.drag.x && (_this.flag.canCloseOnClick = false);
        _this.ref.style.transform = "translateX(" + _this.drag.deltaX + "px)";
        _this.ref.style.opacity = 1 - Math.abs(_this.drag.deltaX / _this.drag.removalDistance);
      }
    };

    _this.onDragEnd = function (e) {
      if (_this.flag.canDrag) {
        _this.flag.canDrag = false;

        if (Math.abs(_this.drag.deltaX) > _this.drag.removalDistance) {
          _this.setState({
            preventExitTransition: true
          }, _this.props.closeToast);

          return;
        }

        _this.drag.y = getY(e);
        _this.ref.style.transition = 'transform 0.2s, opacity 0.2s';
        _this.ref.style.transform = 'translateX(0)';
        _this.ref.style.opacity = 1;
      }
    };

    _this.onDragTransitionEnd = function () {
      var _this$ref$getBounding = _this.ref.getBoundingClientRect(),
          top = _this$ref$getBounding.top,
          bottom = _this$ref$getBounding.bottom,
          left = _this$ref$getBounding.left,
          right = _this$ref$getBounding.right;

      if (_this.props.pauseOnHover && _this.drag.x >= left && _this.drag.x <= right && _this.drag.y >= top && _this.drag.y <= bottom) {
        _this.pauseToast();
      } else {
        _this.playToast();
      }
    };

    return _this;
  }

  var _proto = Toast.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.onOpen(this.props.children.props);

    if (this.props.draggable) {
      this.bindDragEvents();
    } // Maybe I could bind the event in the ToastContainer and rely on delegation


    if (this.props.pauseOnFocusLoss) {
      this.bindFocusEvents();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.draggable !== this.props.draggable) {
      if (this.props.draggable) {
        this.bindDragEvents();
      } else {
        this.unbindDragEvents();
      }
    }

    if (prevProps.pauseOnFocusLoss !== this.props.pauseOnFocusLoss) {
      if (this.props.pauseOnFocusLoss) {
        this.bindFocusEvents();
      } else {
        this.unbindFocusEvents();
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.onClose(this.props.children.props);

    if (this.props.draggable) {
      this.unbindDragEvents();
    }

    if (this.props.pauseOnFocusLoss) {
      this.unbindFocusEvents();
    }
  };

  _proto.bindFocusEvents = function bindFocusEvents() {
    window.addEventListener('focus', this.playToast);
    window.addEventListener('blur', this.pauseToast);
  };

  _proto.unbindFocusEvents = function unbindFocusEvents() {
    window.removeEventListener('focus', this.playToast);
    window.removeEventListener('blur', this.pauseToast);
  };

  _proto.bindDragEvents = function bindDragEvents() {
    document.addEventListener('mousemove', this.onDragMove);
    document.addEventListener('mouseup', this.onDragEnd);
    document.addEventListener('touchmove', this.onDragMove);
    document.addEventListener('touchend', this.onDragEnd);
  };

  _proto.unbindDragEvents = function unbindDragEvents() {
    document.removeEventListener('mousemove', this.onDragMove);
    document.removeEventListener('mouseup', this.onDragEnd);
    document.removeEventListener('touchmove', this.onDragMove);
    document.removeEventListener('touchend', this.onDragEnd);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        closeButton = _this$props.closeButton,
        children = _this$props.children,
        autoClose = _this$props.autoClose,
        pauseOnHover = _this$props.pauseOnHover,
        closeOnClick = _this$props.closeOnClick,
        type = _this$props.type,
        hideProgressBar = _this$props.hideProgressBar,
        closeToast = _this$props.closeToast,
        Transition = _this$props.transition,
        position = _this$props.position,
        onExited = _this$props.onExited,
        className = _this$props.className,
        bodyClassName = _this$props.bodyClassName,
        progressClassName = _this$props.progressClassName,
        progressStyle = _this$props.progressStyle,
        updateId = _this$props.updateId,
        role = _this$props.role,
        rtl = _this$props.rtl;
    var toastProps = {
      className: (0, _classnames.default)('Toastify__toast', "Toastify__toast--" + type, {
        'Toastify__toast--rtl': rtl
      }, className)
    };

    if (autoClose && pauseOnHover) {
      toastProps.onMouseEnter = this.pauseToast;
      toastProps.onMouseLeave = this.playToast;
    } // prevent toast from closing when user drags the toast


    if (closeOnClick) {
      toastProps.onClick = function () {
        return _this2.flag.canCloseOnClick && closeToast();
      };
    }

    return _react.default.createElement(Transition, {
      in: this.props.in,
      appear: true,
      unmountOnExit: true,
      onExited: onExited,
      position: position,
      preventExitTransition: this.state.preventExitTransition
    }, _react.default.createElement("div", _extends({}, toastProps, {
      ref: function ref(_ref) {
        return _this2.ref = _ref;
      },
      onMouseDown: this.onDragStart,
      onTouchStart: this.onDragStart,
      onTransitionEnd: this.onDragTransitionEnd
    }), _react.default.createElement("div", _extends({}, this.props.in && {
      role: role
    }, {
      className: (0, _classnames.default)('Toastify__toast-body', bodyClassName)
    }), children), closeButton && closeButton, autoClose && _react.default.createElement(_ProgressBar.default, _extends({}, updateId ? {
      key: "pb-" + updateId
    } : {}, {
      rtl: rtl,
      delay: autoClose,
      isRunning: this.state.isRunning,
      closeToast: closeToast,
      hide: hideProgressBar,
      type: type,
      style: progressStyle,
      className: progressClassName
    }))));
  };

  return Toast;
}(_react.Component);

Toast.propTypes = {
  closeButton: _propValidator.falseOrElement.isRequired,
  autoClose: _propValidator.falseOrDelay.isRequired,
  children: _propTypes.default.node.isRequired,
  closeToast: _propTypes.default.func.isRequired,
  position: _propTypes.default.oneOf((0, _propValidator.objectValues)(_constant.POSITION)).isRequired,
  pauseOnHover: _propTypes.default.bool.isRequired,
  pauseOnFocusLoss: _propTypes.default.bool.isRequired,
  closeOnClick: _propTypes.default.bool.isRequired,
  transition: _propTypes.default.func.isRequired,
  rtl: _propTypes.default.bool.isRequired,
  hideProgressBar: _propTypes.default.bool.isRequired,
  draggable: _propTypes.default.bool.isRequired,
  draggablePercent: _propTypes.default.number.isRequired,
  in: _propTypes.default.bool,
  onExited: _propTypes.default.func,
  onOpen: _propTypes.default.func,
  onClose: _propTypes.default.func,
  type: _propTypes.default.oneOf((0, _propValidator.objectValues)(_constant.TYPE)),
  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  bodyClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  progressClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  progressStyle: _propTypes.default.object,
  updateId: _propTypes.default.number,
  ariaLabel: _propTypes.default.string
};
Toast.defaultProps = {
  type: _constant.TYPE.DEFAULT,
  in: true,
  onOpen: noop,
  onClose: noop,
  className: null,
  bodyClassName: null,
  progressClassName: null,
  updateId: null,
  role: 'alert'
};
var _default = Toast;
exports.default = _default;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _constant = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ProgressBar(_ref) {
  var delay = _ref.delay,
      isRunning = _ref.isRunning,
      closeToast = _ref.closeToast,
      type = _ref.type,
      hide = _ref.hide,
      className = _ref.className,
      userStyle = _ref.style,
      rtl = _ref.rtl;

  var style = _extends({}, userStyle, {
    animationDuration: delay + "ms",
    animationPlayState: isRunning ? 'running' : 'paused',
    opacity: hide ? 0 : 1
  });

  var classNames = (0, _classnames.default)('Toastify__progress-bar', "Toastify__progress-bar--" + type, {
    'Toastify__progress-bar--rtl': rtl
  }, className);
  return _react.default.createElement("div", {
    className: classNames,
    style: style,
    onAnimationEnd: closeToast
  });
}

ProgressBar.propTypes = {
  /**
   * The animation delay which determine when to close the toast
   */
  delay: _propTypes.default.number.isRequired,

  /**
   * Whether or not the animation is running or paused
   */
  isRunning: _propTypes.default.bool.isRequired,

  /**
   * Func to close the current toast
   */
  closeToast: _propTypes.default.func.isRequired,

  /**
   * Support rtl content
   */
  rtl: _propTypes.default.bool.isRequired,

  /**
   * Optional type : info, success ...
   */
  type: _propTypes.default.string,

  /**
   * Hide or not the progress bar
   */
  hide: _propTypes.default.bool,

  /**
   * Optionnal className
   */
  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])
};
ProgressBar.defaultProps = {
  type: _constant.TYPE.DEFAULT,
  hide: false
};
var _default = ProgressBar;
exports.default = _default;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CloseButton(_ref) {
  var closeToast = _ref.closeToast,
      type = _ref.type,
      ariaLabel = _ref.ariaLabel;
  return _react.default.createElement("button", {
    className: "Toastify__close-button Toastify__close-button--" + type,
    type: "button",
    onClick: closeToast,
    "aria-label": ariaLabel
  }, "\u2716");
}

CloseButton.propTypes = {
  closeToast: _propTypes.default.func,
  arialLabel: _propTypes.default.string
};
CloseButton.defaultProps = {
  ariaLabel: 'close'
};
var _default = CloseButton;
exports.default = _default;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(1);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(12);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactLifecyclesCompat = __webpack_require__(97);

var _PropTypes = __webpack_require__(463);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;

    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null // allows for nested Transitions
    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return { status: EXITED };
    }
    return null;
  };

  // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null

  //   if (prevProps !== this.props) {
  //     const { status } = this.state

  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }

  //   return { nextStatus }
  // }

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;


      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var nextStatus = arguments[1];

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func

  // Name the function so it is clearer in the documentation
} : {};function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = (0, _reactLifecyclesCompat.polyfill)(Transition);

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterDone: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitDone: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _eventManager = _interopRequireDefault(__webpack_require__(201));

var _constant = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var container = null;
var queue = [];
var toastId = 0;

var noop = function noop() {
  return false;
};
/**
 * Merge provided options with the defaults settings and generate the toastId
 */


function mergeOptions(options, type) {
  return _extends({}, options, {
    type: type,
    toastId: generateToastId(options)
  });
}
/**
 * Generate the toastId either automatically or by provided toastId
 */


function generateToastId(options) {
  if (options && (typeof options.toastId === 'number' && !isNaN(options.toastId) || typeof options.toastId === 'string')) {
    return options.toastId;
  }

  return ++toastId;
}
/**
 * Dispatch toast. If the container is not mounted, the toast is enqueued
 */


function emitEvent(content, options) {
  if (container !== null) {
    _eventManager.default.emit(_constant.ACTION.SHOW, content, options);
  } else {
    queue.push({
      action: _constant.ACTION.SHOW,
      content: content,
      options: options
    });
  }

  return options.toastId;
}

var toast = _extends(function (content, options) {
  return emitEvent(content, mergeOptions(options, options && options.type || _constant.TYPE.DEFAULT));
}, {
  success: function success(content, options) {
    return emitEvent(content, mergeOptions(options, _constant.TYPE.SUCCESS));
  },
  info: function info(content, options) {
    return emitEvent(content, mergeOptions(options, _constant.TYPE.INFO));
  },
  warn: function warn(content, options) {
    return emitEvent(content, mergeOptions(options, _constant.TYPE.WARNING));
  },
  warning: function warning(content, options) {
    return emitEvent(content, mergeOptions(options, _constant.TYPE.WARNING));
  },
  error: function error(content, options) {
    return emitEvent(content, mergeOptions(options, _constant.TYPE.ERROR));
  },
  dismiss: function dismiss(id) {
    if (id === void 0) {
      id = null;
    }

    return container && _eventManager.default.emit(_constant.ACTION.CLEAR, id);
  },
  isActive: noop,
  update: function update(toastId, options) {
    setTimeout(function () {
      if (container && typeof container.collection[toastId] !== 'undefined') {
        var _container$collection = container.collection[toastId],
            oldOptions = _container$collection.options,
            oldContent = _container$collection.content;
        var updateId = oldOptions.updateId ? oldOptions.updateId + 1 : 1;

        var nextOptions = _extends({}, oldOptions, options, {
          toastId: toastId,
          updateId: updateId
        });

        var content = typeof nextOptions.render !== 'undefined' ? nextOptions.render : oldContent;
        delete nextOptions.render;
        emitEvent(content, nextOptions);
      }
    }, 0);
  },
  onChange: function onChange(callback) {
    if (typeof callback === 'function') {
      _eventManager.default.on(_constant.ACTION.ON_CHANGE, callback);
    }
  },
  POSITION: _constant.POSITION,
  TYPE: _constant.TYPE
});
/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */


_eventManager.default.on(_constant.ACTION.DID_MOUNT, function (containerInstance) {
  container = containerInstance;

  toast.isActive = function (id) {
    return container.isToastActive(id);
  };

  queue.forEach(function (item) {
    _eventManager.default.emit(item.action, item.content, item.options);
  });
  queue = [];
}).on(_constant.ACTION.WILL_UNMOUNT, function () {
  container = null;
  toast.isActive = noop;
  toastId = 0;
});

var _default = toast;
exports.default = _default;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/notification.8072e82b.mp3";

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/notification-loud.dbf5950f.mp3";

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(26)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({items:[/*{
      lang_key: 'dashboard',
      name: 'Dashboard',
      url:  '/dashboard',
      icon: 'icon-speedometer',
    },*/{lang_key:"map",name:"Map",url:"/map",icon:"icon-map"},{lang_key:"orders",name:"Orders",url:"/order-management",icon:"icon-bag"},{lang_key:"billing",name:"My charges",//url:  '/company-billings',
url:"/company-charges",icon:"icon-wallet"},{lang_key:"categories",name:"Categories",url:"/categories-management",icon:"icon-list"},{lang_key:"branch_goods",name:"Branch Goods",url:"/goods-management/branch",icon:"icon-book-open"},{lang_key:"goods",name:"Goods",url:"/goods-management",icon:"icon-book-open"},{lang_key:"goods-types",name:"Goods-types",url:"/good-type-management",icon:"icon-book-open"},{lang_key:"eta",name:"Eta",url:"/eta",icon:"icon-book-open"},{lang_key:"tag",name:"tags",url:"/goods-tags",icon:"icon-tag text-secondary"},{lang_key:"attributes",name:"Features",url:"/properties-management",icon:"icon-tag"},{lang_key:"providers",name:"Drivers",url:"/provider-management",icon:"fa fa-motorcycle"},{lang_key:"providers_settings",name:"Habilidades",url:"/provider-settings",icon:"fa fa-clipboard text-secondary"},{lang_key:"admins",name:"Admins management",url:"/admins-management",icon:"icon-organization icons"},{lang_key:"clients",name:"Clients",url:"/clients-management",icon:"icon-people"},{lang_key:"company",name:"Settings",url:"/settings",icon:"fa fa-gears"},/*  {
            name: "Services Supplier (Alpha)",
            url: "/service-suppliers",
        },
        {
            name: "Fleets (Alpha)",
            url: "/fleets",
        }, */{lang_key:"section",name:"Section",url:"/sections",icon:"fa fa-print"},{lang_key:"reports",name:"Reports",url:"/reports",icon:"fa fa-print"}]});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ({items:[/*{
      lang_key: 'dashboard',
      name: 'Dashboard',
      url:  '/dashboard',
      icon: 'icon-speedometer',
    },*/{lang_key:"companies",name:"Companies",url:"/companies",icon:"fa fa-building-o"},{lang_key:"map",name:"Map",url:"/map",icon:"icon-map"},{lang_key:"orders",name:"Orders",url:"/order-management",icon:"icon-bag"},{lang_key:"providers",name:"Drivers",url:"/provider-management",icon:"fa fa-motorcycle"},{lang_key:"clients",name:"Clients",url:"/clients-management",icon:"icon-people"},{lang_key:"attributes",name:"Features",url:"/properties-management",icon:"icon-tag"},{lang_key:"branch_goods",name:"Branch Goods",url:"/goods-management/branch",icon:"icon-book-open"},{lang_key:"goods",name:"Goods",url:"/goods-management",icon:"icon-book-open"},{lang_key:"eta",name:"Eta",url:"/eta",icon:"icon-book-open"},{lang_key:"tag",name:"tags",url:"/goods-tags",icon:"icon-tag text-secondary"},{lang_key:"categories",name:"Categories",url:"/categories-management",icon:"icon-list"},{lang_key:"admins",name:"Admins management",url:"/admins-management",icon:"icon-organization icons"},{lang_key:"billing",name:"My charges",//url:  '/company-billings',
url:"/company-charges",icon:"icon-wallet"},{lang_key:"company",name:"Settings",url:"/settings",icon:"icon-settings"},/* {
            lang_key: "service_suppliers",
            name: "Service Suppliers (Alpha)",
            url: "/service-suppliers",
            icon: "icon-people",
        },
        {
            lang_key: "fleets",
            name: "Fleets (Alpha)",
            url: "/fleets",
            icon: "icon-directions",
        }, */{lang_key:"reports",name:"Reports",url:"/reports",icon:"fa fa-print"}]});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(10);
/* unused harmony default export */ var _unused_webpack_default_export = ({items:[/*{
      lang_key: 'dashboard',
      name: 'Resumen',
      url:  '/dashboard',
      icon: 'icon-speedometer',
    },*/{lang_key:"companies",name:"Compañías",url:"/companies",icon:"fa fa-building-o"},{lang_key:"map",name:"Mapa",url:"/map",icon:"icon-map"},{lang_key:"orders",name:"Órdenes",icon:"icon-bag",url:"/order-management/search-status=",children:[/*{
          name: store.getState().json_lang.dashboard.all,
        },*/{name:__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].getState().json_lang.order_status.canceled},{name:__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].getState().json_lang.order_status.delivered},{name:__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].getState().json_lang.order_status.in_progress},{name:__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].getState().json_lang.order_status.arrived},{name:__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].getState().json_lang.order_status.ready},{name:__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].getState().json_lang.order_status.on_the_way},{name:__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].getState().json_lang.order_status.delayed},{name:__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].getState().json_lang.order_status.scheduled},{name:__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].getState().json_lang.order_status.confirmed},{name:__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].getState().json_lang.order_status.payment_pending},{name:__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].getState().json_lang.order_status.payment_to_validate},{name:__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].getState().json_lang.order_status.unconfirmed}]},/*{
        lang_key: 'providers',
        name: 'Proveedores',
        url:  '/provider-management',
        icon: 'fa fa-motorcycle',
      },
      {
        lang_key: 'clients',
        name: 'Clientes',
        url:  '/clients-management',
        icon: 'icon-people',
      },
      {
        lang_key: 'attributes',
        name: 'Características',
        url:  '/properties-management',
        icon: 'icon-tag',
  	},*/{lang_key:"goods",name:"Productos",url:"/goods-management",icon:"icon-book-open"},/*{
      lang_key: 'eta',
      name: 'Eta',
      url:  '/eta',
      icon: 'icon-book-open',
    },
    {
      lang_key: 'branch_goods',
      name: 'Productos de Sucursal',
      url:  '/goods-management/branch',
      icon: 'icon-book-open',
    },*/{lang_key:"categories",name:"Categorías",url:"/categories-management",icon:"icon-list"},{lang_key:"admins",name:"Administradores",url:"/admins-management",icon:"icon-organization icons"},{lang_key:"billing",name:"Mis cobros",//url:  '/company-billings',
url:"/company-charges",icon:"icon-wallet"},{lang_key:"company",name:"Configuración",url:"/settings",icon:"icon-settings"},/* {
            name: "Services Supplier (Alpha)",
            url: "/service-suppliers",
        },
        {
            name: "Fleets (Alpha)",
            url: "/fleets",
        }, */{lang_key:"reports",name:"Reports",url:"/reports",icon:"fa fa-print"}]});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({items:[/* {
      lang_key: 'map',
      name: 'Mapa',
      url:  '/map',
      icon: 'icon-map',
    }, */{lang_key:'orders',name:'Órdenes',url:'/order-management',icon:'icon-bag'},/*
    {
      lang_key: 'dashboard',
      name: 'Dashboard',
      url:  '/dashboard',
      icon: 'icon-speedometer',
    },
    {
      lang_key: 'billing',
      name: 'Mis cobros',
      //url:  '/company-billings',
      url:  '/company-charges',
      icon: 'icon-wallet',
    },
    {
      lang_key: 'categories',
      name: 'Categorías',
      url:  '/categories-management',
      icon: 'icon-list'
    },
    
    {
      lang_key: 'goods',
      name: 'Productos',
      url:  '/goods-management',
      icon: 'icon-book-open',
    },*/{lang_key:'',name:'Finanzas',icon:'icon-wallet',children:[{lang_key:'billing',name:'Mis cobros',url:'/company-charges'},{lang_key:'reports',name:'Reportes',url:'/reports'}]}]});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({items:[/* {
      lang_key: 'map',
      name: 'Map',
      url:  '/map',
      icon: 'icon-map',
    }, */{lang_key:'orders',name:'Orders',url:'/order-management',icon:'icon-bag'},{lang_key:'goods',name:'Goods',url:'/goods-management',icon:'icon-book-open'}]});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routesHigh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return routesLow; });
/* unused harmony export routesSuper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_DefaultLayout__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__ = __webpack_require__(23);
function Loading(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-loader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'preloader pls-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'pl-circular',viewBox:'25 25 50 50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{className:'plc-path',cx:50,cy:50,r:20}),'12355')));}var Dashboard=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 202));},loading:Loading});var BranchDashboard=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 682));},loading:Loading});var Reports=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 235));},loading:Loading});var MapView=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 683));},loading:Loading});var CompanySettings=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){var userSession=JSON.parse(localStorage.getItem("user"));if(userSession&&userSession.account.type!==__WEBPACK_IMPORTED_MODULE_3__constants_bitwiseOperations__["c" /* ADMIN_LOW */]){return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 684));}else{//return import('./views/Dashboard');
return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 284));}},loading:Loading});var Sections=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 685));},loading:Loading});var CompanyBillings=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 686));},loading:Loading});var providerBillings=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 687));},loading:Loading});var providerInvoice=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 688));},loading:Loading});var providerInvoiceDetails=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 689));},loading:Loading});var clientInvoice=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 690));},loading:Loading});var Invoice=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 691));},loading:Loading});var BranchInvoice=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 692));},loading:Loading});var BranchInvoiceDetails=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 693));},loading:Loading});var InvoicesLot=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 694));},loading:Loading});var InvoiceDetails=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 681));},loading:Loading});var CompanyCharges=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 695));},loading:Loading});var Companies=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 696));},loading:Loading});var BranchGroupStatistics=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 697));},loading:Loading});var BranchStatistics=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 698));},loading:Loading});var AdminInbox=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 699));},loading:Loading});/**
 * ------------------------------------------------------
 * 							TABLE
 * ------------------------------------------------------
 */var AdminsManagement=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 700));},loading:Loading});var AdminTypesManagement=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 701));},loading:Loading});var OrderManagement=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 284));},loading:Loading});var ProviderManagement=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 702));},loading:Loading});var ProviderDetails=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 703));},loading:Loading});var ProviderSettings=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 704));},loading:Loading});var ClientsManagement=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 705));},loading:Loading});var BranchGoodsManagement=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 706));},loading:Loading});var GoodsTypesManagement=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 707));},loading:Loading});var featuredProducts=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 708));},loading:Loading});var GoodsManagement=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 709));},loading:Loading});var GoodsEtaManagement=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 710));},loading:Loading});var PropertiesManagement=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 711));},loading:Loading});var categoriesManagement=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 712));},loading:Loading});/**
 * ------------------------------------------------------
 * 						DETAILS VIEW
 * ------------------------------------------------------
 */var ClientDetails=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 713));},loading:Loading});var AdminDetails=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 714));},loading:Loading});var OrderDetails=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 715));},loading:Loading});var GoodDetails=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 716));},loading:Loading});var GoodTags=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 717));},loading:Loading});var Branchs=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 718));},loading:Loading});var BranchsTable=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 719));},loading:Loading});var TodayOrders=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 720));},loading:Loading});var NotificationsList=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 721));},loading:Loading});/**
 * ------------------------------------------------------
 * 							FORMS
 * ------------------------------------------------------
 */var CreateOrder=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 722));},loading:Loading});var BranchCategoryCompanyTable=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 723));},loading:Loading});var Banner=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 724));},loading:Loading});var sendNotification=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 725));},loading:Loading});var listsendNotification=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 726));},loading:Loading});var coupons=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 727));},loading:Loading});var coupon=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 728));},loading:Loading});var promo=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 729));},loading:Loading});/**
 * ------------------------------------------------------
 * 							FLEETS
 * ------------------------------------------------------
 */var Fleets=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 679));},loading:Loading});var ServiceSuppliers=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 680));},loading:Loading});var ServiceProfiles=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 730));},loading:Loading});var ServiceCharges=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 731));},loading:Loading});var ListAssociations=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 678));},loading:Loading});/**
 * ------------------------------------------------------
 * 							WEBHOOKS
 * ------------------------------------------------------
 */var Webhooks=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 732));},loading:Loading});// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
var routesLow=[{path:'/',exact:true,lang_key:'home',component:__WEBPACK_IMPORTED_MODULE_2__containers_DefaultLayout__["a" /* default */]},{path:'/settings',exact:true,lang_key:'company_settings',component:CompanySettings},{path:'/settings/:id',exact:true,lang_key:'company_settings',component:CompanySettings},{path:'/company-billings',exact:true,lang_key:'company_billings',component:CompanyBillings},{path:'/provider-management/billings-:id',exact:true,lang_key:'finance',component:providerBillings},{path:'/provider-management/invoices-:id',exact:true,lang_key:'invoices',component:providerInvoice},{path:'/provider-management/invoice-details-:id',exact:true,lang_key:'invoices',component:providerInvoiceDetails},{path:'/company-billings/invoices',exact:true,lang_key:'invoices',component:Invoice},{path:'/branch-invoices',exact:true,lang_key:'invoices',component:BranchInvoice},{path:'/branch-invoices/:id',exact:true,lang_key:'invoice',component:BranchInvoiceDetails},{path:'/company-billings/invoices/invoices-lot',exact:true,lang_key:'invoices_lot',component:InvoicesLot},{path:'/company-billings/invoices/:id',exact:true,lang_key:'invoice',component:InvoiceDetails},{path:'/company-charges',exact:true,lang_key:'company_charges',component:CompanyCharges},{path:'/charges/:search',exact:true,lang_key:'company_charges',component:CompanyCharges},{path:'/company-charges/:ordenid',exact:true,lang_key:'order',component:OrderDetails},{path:'/sections',exact:true,lang_key:'sections',component:Sections},{path:'/branch-category-company',exact:true,lang_key:'branch_categories',component:BranchCategoryCompanyTable},{path:'/profile/:id',exact:true,lang_key:'admin_details_breadcrumb',component:AdminDetails},{path:'/clients-management',exact:true,lang_key:'clients',component:ClientsManagement},{path:'/clients-management/:id',exact:true,lang_key:'details',component:ClientDetails},{path:'/clients-management/:id/:ordenid',exact:true,lang_key:'order',component:OrderDetails},{path:'/order-management',exact:true,lang_key:'orders',component:OrderManagement},{path:'/order-management/search-:search',exact:true,component:OrderManagement},{path:'/create-order',exact:true,lang_key:'create',component:CreateOrder,branchRequired:true},{path:'/order-management/edit-:id',exact:false,lang_key:'edit',component:CreateOrder},{path:'/order-management/:ordenid',exact:true,strict:true,lang_key:'details',component:OrderDetails},{path:'/provider-management',exact:true,lang_key:'providers',component:ProviderManagement},{path:'/provider-management/:id',exact:true,lang_key:'details',component:ProviderDetails},{path:'/provider-management/:id/:ordenid',exact:true,lang_key:'order',component:OrderDetails},{path:'/goods-management',exact:true,lang_key:'goods',component:GoodsManagement},{path:'/featured-products',exact:true,lang_key:'goods',component:featuredProducts},{path:'/eta',exact:true,lang_key:'eta',component:GoodsEtaManagement},{path:'/branchs',exact:true,lang_key:'branchs',component:Branchs},{path:'/goods-tags',exact:true,lang_key:'goods',component:GoodTags},{path:'/goods-management/:branchId/:id',exact:true,lang_key:'details',component:GoodDetails},{path:'/good-type-management',exact:true,lang_key:'branch_goods',component:GoodsTypesManagement},{path:'/categories-management',exact:true,lang_key:'categories',component:categoriesManagement},{path:'/properties-management',exact:true,lang_key:'properties',component:PropertiesManagement,branchRequired:true},{path:'/notifications',exact:true,lang_key:'notifications',component:NotificationsList},{path:'/dashboard',exact:true,component:Dashboard},{path:'/branchDashboard',exact:true,component:BranchDashboard},{path:'/reports',lang_key:'reports',exact:true,component:Reports},{path:'/map',exact:true,component:MapView},{path:'/today-orders',exact:true,component:TodayOrders},{path:'/inbox',exact:true,lang_key:"inbox",component:AdminInbox},{path:'/fleets',lang_key:'fleets',exact:true,component:Fleets},{path:'/service-suppliers',lang_key:'service_suppliers',exact:true,component:ServiceSuppliers},{path:'/service-profiles',lang_key:'service_profiles',exact:true,component:ServiceProfiles},{path:'/service-charges',lang_key:'service_charges',exact:true,component:ServiceCharges},{path:'/fleet-associations',lang_key:'associations',exact:true,component:ListAssociations},{path:'/branch-statistics',lang_key:'branches',exact:true,component:BranchStatistics},{path:'/branch-group-statistics',lang_key:'branch_groups',exact:true,component:BranchGroupStatistics},{path:'/webhooks',lang_key:'webhooks',exact:true,component:Webhooks}].map(function(route){if(route.branchRequired===undefined){route.branchRequired=false;}return route;});var routesHigh=[{path:"/",exact:true,lang_key:"home",component:__WEBPACK_IMPORTED_MODULE_2__containers_DefaultLayout__["a" /* default */]},{path:"/settings",exact:true,lang_key:"company_settings",component:CompanySettings},{path:"/settings/:id",exact:true,lang_key:"company_settings",component:CompanySettings},{path:"/company-billings",exact:true,lang_key:"company_billings",component:CompanyBillings},{path:"/company-billings",exact:true,lang_key:"company_billings",component:CompanyBillings},{path:"/provider-management/billings-:id",exact:true,lang_key:"finance",component:providerBillings},{path:"/provider-management/invoices-:id",exact:true,lang_key:"invoices",component:providerInvoice},{path:"/provider-management/invoice-details-:id",exact:true,lang_key:"invoices",component:providerInvoiceDetails},{path:"/branch-invoices",exact:true,lang_key:"invoices",component:BranchInvoice},{path:"/branch-invoices/:id",exact:true,lang_key:"invoice",component:BranchInvoiceDetails},{path:"/company-billings/invoices",exact:true,lang_key:"invoices",component:Invoice},{path:"/company-billings/invoices/invoices-lot",exact:true,lang_key:"invoices_lot",component:InvoicesLot},{path:"/company-billings/invoices/:id",exact:true,lang_key:"invoice",component:InvoiceDetails},{path:"/company-charges",exact:true,lang_key:"company_charges",component:CompanyCharges},{path:"/charges/:search",exact:true,lang_key:"company_charges",component:CompanyCharges},{path:"/company-charges/:ordenid",exact:true,lang_key:"order",component:OrderDetails},{path:"/admins-management",exact:true,lang_key:"admins",component:AdminsManagement},{path:"/admin-types-management",exact:true,lang_key:"admin_types",component:AdminTypesManagement},{path:"/profile/:id",exact:true,lang_key:"admin_details_breadcrumb",component:AdminDetails},{path:"/clients-management",exact:true,lang_key:"clients",component:ClientsManagement},{path:"/clients-management/billings-:id",exact:true,lang_key:"finance",component:clientInvoice},{path:"/clients-management/:id",exact:true,lang_key:"details",component:ClientDetails},{path:"/clients-management/:id/:ordenid",exact:true,lang_key:"order",component:OrderDetails},{path:"/order-management",exact:true,lang_key:"orders",component:OrderManagement},{path:"/order-management/search-:search",exact:true,component:OrderManagement},{path:"/create-order",exact:true,lang_key:"create",component:CreateOrder,branchRequired:true},{path:"/order-management/edit-:id",exact:true,lang_key:"edit_order",component:CreateOrder},{path:"/order-management/:ordenid",exact:true,strict:true,lang_key:"details",component:OrderDetails},{path:"/provider-management",exact:true,lang_key:"providers",component:ProviderManagement},{path:"/provider-settings",exact:true,lang_key:"order",component:ProviderSettings},{path:"/provider-management/:id",exact:true,lang_key:"details",component:ProviderDetails},{path:"/provider-management/:id/:ordenid",exact:true,lang_key:"order",component:OrderDetails},{path:"/branch-category-company",exact:true,lang_key:"branch_categories",component:BranchCategoryCompanyTable},{path:"/goods-management",exact:true,lang_key:"goods",component:GoodsManagement},{path:"/good-type-management",exact:true,lang_key:"branch_goods",component:GoodsTypesManagement},{path:"/goods-management/branch",exact:true,lang_key:"branch_goods",component:BranchGoodsManagement},{path:"/eta",exact:true,lang_key:"eta",component:GoodsEtaManagement},{path:"/branchs",exact:true,lang_key:"branchs",component:Branchs},{path:"/branchs-list",exact:true,lang_key:"branchs",component:BranchsTable},{path:"/goods-tags",exact:true,lang_key:"goods",component:GoodTags},{path:"/goods-management/:branchId/:id",exact:true,lang_key:"details",component:GoodDetails},{path:"/featured-products",exact:true,lang_key:"goods",component:featuredProducts},{path:"/categories-management",exact:true,lang_key:"categories",component:categoriesManagement},{path:"/properties-management",exact:true,lang_key:"properties",component:PropertiesManagement,branchRequired:true},{path:"/notifications",exact:true,lang_key:"notifications",component:NotificationsList},{path:"/dashboard",exact:true,component:Dashboard},{path:"/branchDashboard",exact:true,component:BranchDashboard},{path:"/reports",lang_key:"reports",exact:true,component:Reports},{path:"/sections",exact:true,lang_key:"sections",component:Sections},{path:"/map",exact:true,component:MapView},{path:"/today-orders",exact:true,component:TodayOrders},{path:"/banners",exact:true,lang_key:"promotional_banners",component:Banner},{path:"/list-send-notifications/send-notification",exact:true,lang_key:"send_notification",component:sendNotification},{path:"/list-send-notifications",exact:true,lang_key:"list_send_notifications",component:listsendNotification},{path:"/coupons",exact:true,lang_key:"coupons",component:coupons},{path:"/coupons/:id",exact:true,lang_key:"coupon",component:coupon},{path:"/promos",exact:true,lang_key:"promos",component:promo},{path:"/promos/:id",exact:true,lang_key:"promo",component:coupon},{path:'/inbox',exact:true,lang_key:"inbox",component:AdminInbox},{path:'/fleets',lang_key:'fleets',exact:true,component:Fleets},{path:'/service-suppliers',lang_key:'service_suppliers',exact:true,component:ServiceSuppliers},{path:'/service-profiles',lang_key:'service_profiles',exact:true,component:ServiceProfiles},{path:'/service-charges',lang_key:'service_charges',exact:true,component:ServiceCharges},{path:'/fleet-associations',lang_key:'associations',exact:true,component:ListAssociations},{path:'/branch-statistics',lang_key:'branches',exact:true,component:BranchStatistics},{path:'/branch-group-statistics',lang_key:'branch_groups',exact:true,component:BranchGroupStatistics},{path:'/webhooks',lang_key:'webhooks',exact:true,component:Webhooks}].map(function(route){if(route.branchRequired===undefined){route.branchRequired=false;}return route;});var routesSuper=[{path:"/",exact:true,lang_key:"home",component:__WEBPACK_IMPORTED_MODULE_2__containers_DefaultLayout__["a" /* default */]},{path:"/companies",exact:true,lang_key:"companies",component:Companies},{path:"/settings",exact:true,lang_key:"company_settings",component:CompanySettings},{path:"/settings/:id",exact:true,lang_key:"company_settings",component:CompanySettings},{path:"/company-billings",exact:true,lang_key:"company_billings",component:CompanyBillings},{path:"/provider-management/billings-:id",exact:true,lang_key:"finance",component:providerBillings},{path:"/provider-management/invoices-:id",exact:true,lang_key:"invoices",component:providerInvoice},{path:"/provider-management/invoice-details-:id",exact:true,lang_key:"invoices",component:providerInvoiceDetails},{path:"/branch-invoices",exact:true,lang_key:"invoices",component:BranchInvoice},{path:"/branch-invoices/:id",exact:true,lang_key:"invoice",component:BranchInvoiceDetails},{path:"/company-billings/invoices",exact:true,lang_key:"invoices",component:Invoice},{path:"/company-billings/invoices/invoices-lot",exact:true,lang_key:"invoices_lot",component:InvoicesLot},{path:"/company-billings/invoices/:id",exact:true,lang_key:"invoice",component:InvoiceDetails},{path:"/company-charges",exact:true,lang_key:"company_charges",component:CompanyCharges},{path:"/charges/:search",exact:true,lang_key:"company_charges",component:CompanyCharges},{path:"/company-charges/:ordenid",exact:true,lang_key:"order",component:OrderDetails},{path:"/admins-management",exact:true,lang_key:"admins",component:AdminsManagement},{path:"/admin-types-management",exact:true,lang_key:"admin_types",component:AdminTypesManagement},{path:"/profile/:id",exact:true,lang_key:"admin_details_breadcrumb",component:AdminDetails},{path:"/clients-management",exact:true,lang_key:"clients",component:ClientsManagement},{path:"/clients-management/billings-:id",exact:true,lang_key:"finance",component:clientInvoice},{path:"/clients-management/:id",exact:true,lang_key:"details",component:ClientDetails},{path:"/clients-management/:id/:ordenid",exact:true,lang_key:"order",component:OrderDetails},{path:"/order-management",exact:true,lang_key:"orders",component:OrderManagement},{path:"/order-management/search-:search",exact:true,component:OrderManagement},{path:"/order-management/create",exact:true,lang_key:"create",component:CreateOrder,branchRequired:true},{path:"/order-management/edit-:id",exact:true,lang_key:"edit_order",component:CreateOrder},{path:"/order-management/:ordenid",exact:true,strict:true,lang_key:"details",component:OrderDetails},{path:"/provider-management",exact:true,lang_key:"providers",component:ProviderManagement},{path:"/provider-settings",exact:true,lang_key:"order",component:ProviderSettings},{path:"/provider-management/:id",exact:true,lang_key:"details",component:ProviderDetails},{path:"/provider-management/:id/:ordenid",exact:true,lang_key:"order",component:OrderDetails},{path:"/goods-tags",exact:true,lang_key:"goods",component:GoodTags},{path:"/branchs",exact:true,lang_key:"branchs",component:Branchs},{path:"/branchs-list",exact:true,lang_key:"branchs",component:BranchsTable},{path:"/goods-management",exact:true,lang_key:"goods",component:GoodsManagement},{path:"/featured-products",exact:true,lang_key:"goods",component:featuredProducts},{path:"/eta",exact:true,lang_key:"eta",component:GoodsEtaManagement},{path:"/goods-management/branch",exact:true,lang_key:"branch_goods",component:BranchGoodsManagement},{path:"/branch-category-company",exact:true,lang_key:"branch_categories",component:BranchCategoryCompanyTable},{path:"/goods-management/:branchId/:id",exact:true,lang_key:"details",component:GoodDetails},{path:"/good-type-management",exact:true,lang_key:"branch_goods",component:GoodsTypesManagement},{path:"/categories-management",exact:true,lang_key:"categories",component:categoriesManagement},{path:"/properties-management",exact:true,lang_key:"properties",component:PropertiesManagement,branchRequired:true},{path:"/notifications",exact:true,lang_key:"notifications",component:NotificationsList},{path:"/dashboard",exact:true,component:Dashboard},{path:"/branchDashboard",exact:true,component:BranchDashboard},{path:"/reports",lang_key:"reports",exact:true,component:Reports},{path:"/map",exact:true,component:MapView},{path:"/today-orders",exact:true,component:TodayOrders},{path:"/banners",exact:true,lang_key:"promotional_banners",component:Banner},{path:"/list-send-notifications/send-notification",exact:true,lang_key:"send_notification",component:sendNotification},{path:"/list-send-notifications",exact:true,lang_key:"list_send_notifications",component:listsendNotification},{path:"/coupons",exact:true,lang_key:"coupons",component:coupons},{path:"/coupons/:id",exact:true,lang_key:"coupon",component:coupon},{path:"/promos",exact:true,lang_key:"promos",component:promo},{path:"/promos/:id",exact:true,lang_key:"promo",component:coupon},{path:"/sections",exact:true,lang_key:"sections",component:Sections},{path:'/inbox',exact:true,lang_key:"inbox",component:AdminInbox},{path:'/fleets',lang_key:'fleets',exact:true,component:Fleets},{path:'/service-suppliers',lang_key:'service_suppliers',exact:true,component:ServiceSuppliers},{path:'/service-profiles',lang_key:'service_profiles',exact:true,component:ServiceProfiles},{path:'/service-charges',lang_key:'service_charges',exact:true,component:ServiceCharges},{path:'/fleet-associations',lang_key:'associations',exact:true,component:ListAssociations},{path:'/branch-statistics',lang_key:'branches',exact:true,component:BranchStatistics},{path:'/branch-group-statistics',lang_key:'branch_groups',exact:true,component:BranchGroupStatistics},{path:'/webhooks',lang_key:'webhooks',exact:true,component:Webhooks}].map(function(route){if(route.branchRequired===undefined){route.branchRequired=false;}return route;});

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];

function isWebpackReady(getModuleIds) {
  if (( false ? 'undefined' : _typeof(__webpack_require__.m)) !== 'object') {
    return false;
  }

  return getModuleIds().every(function (moduleId) {
    return typeof moduleId !== 'undefined' && typeof __webpack_require__.m[moduleId] !== 'undefined';
  });
}

function load(loader) {
  var promise = loader();

  var state = {
    loading: true,
    loaded: null,
    error: null
  };

  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  }).catch(function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });

  return state;
}

function loadMap(obj) {
  var state = {
    loading: false,
    loaded: {},
    error: null
  };

  var promises = [];

  try {
    Object.keys(obj).forEach(function (key) {
      var result = load(obj[key]);

      if (!result.loading) {
        state.loaded[key] = result.loaded;
        state.error = result.error;
      } else {
        state.loading = true;
      }

      promises.push(result.promise);

      result.promise.then(function (res) {
        state.loaded[key] = res;
      }).catch(function (err) {
        state.error = err;
      });
    });
  } catch (err) {
    state.error = err;
  }

  state.promise = Promise.all(promises).then(function (res) {
    state.loading = false;
    return res;
  }).catch(function (err) {
    state.loading = false;
    throw err;
  });

  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}

function render(loaded, props) {
  return React.createElement(resolve(loaded), props);
}

function createLoadableComponent(loadFn, options) {
  var _class, _temp;

  if (!options.loading) {
    throw new Error('react-loadable requires a `loading` component');
  }

  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    render: render,
    webpack: null,
    modules: null
  }, options);

  var res = null;

  function init() {
    if (!res) {
      res = loadFn(opts.loader);
    }
    return res.promise;
  }

  ALL_INITIALIZERS.push(init);

  if (typeof opts.webpack === 'function') {
    READY_INITIALIZERS.push(function () {
      if (isWebpackReady(opts.webpack)) {
        return init();
      }
    });
  }

  return _temp = _class = function (_React$Component) {
    _inherits(LoadableComponent, _React$Component);

    function LoadableComponent(props) {
      _classCallCheck(this, LoadableComponent);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

      _this.retry = function () {
        _this.setState({ error: null, loading: true });
        res = loadFn(opts.loader);
        _this._loadModule();
      };

      init();

      _this.state = {
        error: res.error,
        pastDelay: false,
        timedOut: false,
        loading: res.loading,
        loaded: res.loaded
      };
      return _this;
    }

    LoadableComponent.preload = function preload() {
      return init();
    };

    LoadableComponent.prototype.componentWillMount = function componentWillMount() {
      this._mounted = true;
      this._loadModule();
    };

    LoadableComponent.prototype._loadModule = function _loadModule() {
      var _this2 = this;

      if (this.context.loadable && Array.isArray(opts.modules)) {
        opts.modules.forEach(function (moduleName) {
          _this2.context.loadable.report(moduleName);
        });
      }

      if (!res.loading) {
        return;
      }

      if (typeof opts.delay === 'number') {
        if (opts.delay === 0) {
          this.setState({ pastDelay: true });
        } else {
          this._delay = setTimeout(function () {
            _this2.setState({ pastDelay: true });
          }, opts.delay);
        }
      }

      if (typeof opts.timeout === 'number') {
        this._timeout = setTimeout(function () {
          _this2.setState({ timedOut: true });
        }, opts.timeout);
      }

      var update = function update() {
        if (!_this2._mounted) {
          return;
        }

        _this2.setState({
          error: res.error,
          loaded: res.loaded,
          loading: res.loading
        });

        _this2._clearTimeouts();
      };

      res.promise.then(function () {
        update();
      }).catch(function (err) {
        update();
      });
    };

    LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this._mounted = false;
      this._clearTimeouts();
    };

    LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    };

    LoadableComponent.prototype.render = function render() {
      if (this.state.loading || this.state.error) {
        return React.createElement(opts.loading, {
          isLoading: this.state.loading,
          pastDelay: this.state.pastDelay,
          timedOut: this.state.timedOut,
          error: this.state.error,
          retry: this.retry
        });
      } else if (this.state.loaded) {
        return opts.render(this.state.loaded, this.props);
      } else {
        return null;
      }
    };

    return LoadableComponent;
  }(React.Component), _class.contextTypes = {
    loadable: PropTypes.shape({
      report: PropTypes.func.isRequired
    })
  }, _temp;
}

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function LoadableMap(opts) {
  if (typeof opts.render !== 'function') {
    throw new Error('LoadableMap requires a `render(loaded, props)` function');
  }

  return createLoadableComponent(loadMap, opts);
}

Loadable.Map = LoadableMap;

var Capture = function (_React$Component2) {
  _inherits(Capture, _React$Component2);

  function Capture() {
    _classCallCheck(this, Capture);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  Capture.prototype.getChildContext = function getChildContext() {
    return {
      loadable: {
        report: this.props.report
      }
    };
  };

  Capture.prototype.render = function render() {
    return React.Children.only(this.props.children);
  };

  return Capture;
}(React.Component);

Capture.propTypes = {
  report: PropTypes.func.isRequired
};
Capture.childContextTypes = {
  loadable: PropTypes.shape({
    report: PropTypes.func.isRequired
  }).isRequired
};


Loadable.Capture = Capture;

function flushInitializers(initializers) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init());
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolve, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolve, reject);
  });
};

Loadable.preloadReady = function () {
  return new Promise(function (resolve, reject) {
    // We always will resolve, errors should be handled within loading UIs.
    flushInitializers(READY_INITIALIZERS).then(resolve, resolve);
  });
};

module.exports = Loadable;

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
	Fork from the plugin SimpleReactValidator --> https://github.com/dockwa/simple-react-validator
*/var Validator=function(){function Validator(){var _this=this;var customRules=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_classCallCheck(this,Validator);this.fields={};this.errorMessages={};this.messagesShown=false;this.rules=Object.assign({accepted:{message:'The :attribute must be accepted.',rule:function rule(val){return val===true;}},alpha:{message:'The :attribute may only contain letters.',rule:function rule(val){return _this._testRegex(val,/^[A-ZÑ]*$/i);}},alpha_space:{message:'The :attribute may only contain letters.',rule:function rule(val){return _this._testRegex(val,/^[A-ZÑ ]*$/i);}},alpha_num:{message:'The :attribute may only contain letters and numbers.',rule:function rule(val){return _this._testRegex(val,/^[A-ZÑ0-9]*$/i);}},username:{message:'The :attribute may only contain letters and numbers wihthout ñ.',rule:function rule(val){return _this._testRegex(val,/^[A-Z0-9]*$/i);}},alpha_num_dash:{message:'The :attribute may only contain letters, numbers, and dashes.',rule:function rule(val){return _this._testRegex(val,/^[A-ZÑ0-9_-]*$/i);}},card_exp:{message:'The :attribute must be a valid expiration date.',rule:function rule(val){return _this._testRegex(val,/^(([0]?[1-9]{1})|([1]{1}[0-2]{1}))\s?\/\s?(\d{2}|\d{4})$/);}},card_num:{message:'The :attribute must be a valid credit card number.',rule:function rule(val){return _this._testRegex(val,/^\d{4}\s?\d{4,6}\s?\d{4,5}\s?\d{0,8}$/);}},currency:{message:'The :attribute must be a valid currency.',rule:function rule(val){return _this._testRegex(val,/^\$?(\d{1,3}(\,?\d{3}))*\.?\d{0,2}$/);}},decimal:{message:'The :attribute must be a valid decimal.',rule:function rule(val){return _this._testRegex(val,/^\d*\.?\d*$/);}},email:{message:'The :attribute must be a valid email address.',rule:function rule(val){return _this._testRegex(val,/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);}},gt:{message:'The :attribute must be greater than :gt.',rule:function rule(val,options){return _this._testRegex(val,/^\d+.?\d*$/)?parseFloat(val)>parseFloat(options[0]):false;},messageReplace:function messageReplace(message,options){return message.replace(':gt',options[0]);}},gte:{message:'The :attribute must be greater than or equal to :gte.',rule:function rule(val,options){return _this._testRegex(val,/^\d+.?\d*$/)?parseFloat(val)>=parseFloat(options[0]):false;},messageReplace:function messageReplace(message,options){return message.replace(':gte',options[0]);}},in:{message:'The selected :attribute must be :values.',rule:function rule(val,options){return options.indexOf(val)>-1;},messageReplace:function messageReplace(message,options){return message.replace(':values',_this._toSentence(options));}},integer:{message:'The :attribute must be an integer.',rule:function rule(val){return _this._testRegex(val,/^\d+$/);}},lt:{message:'The :attribute must be less than :lt.',rule:function rule(val,options){return _this._testRegex(val,/^\d+.?\d*$/)?parseFloat(val)<parseFloat(options[0]):false;},messageReplace:function messageReplace(message,options){return message.replace(':lt',options[0]);}},lte:{message:'The :attribute must be less than or equal to :lte.',rule:function rule(val,options){return _this._testRegex(val,/^\d+.?\d*$/)?parseFloat(val)<=parseFloat(options[0]):false;},messageReplace:function messageReplace(message,options){return message.replace(':lte',options[0]);}},max:{message:'The :attribute may not be greater than :max characters.',rule:function rule(val,options){return val.length<=options[0];},messageReplace:function messageReplace(message,options){return message.replace(':max',options[0]);}},min:{message:'The :attribute must be at least :min characters.',rule:function rule(val,options){return val.length>=options[0];},messageReplace:function messageReplace(message,options){return message.replace(':min',options[0]);}},not_in:{message:'The selected :attribute must not be :values.',rule:function rule(val,options){return options.indexOf(val)===-1;},messageReplace:function messageReplace(message,options){return message.replace(':values',_this._toSentence(options));}},numeric:{message:'The :attribute must be a number.',rule:function rule(val){return _this._testRegex(val,/^\d+.?\d*$/);}},phone:{message:'The :attribute must be a valid phone number.',rule:function rule(val){return _this._testRegex(val,/(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)/);}},required:{message:'The :attribute field is required.',rule:function rule(val){return _this._testRegex(val,/.+/);}},url:{message:'The :attribute must be a url.',rule:function rule(val){return _this._testRegex(val,/^(https?|ftp):\/\/(-\.)?([^\s/?\.#-]+\.?)+(\/[^\s]*)?$/i);}},percent:{message:'The :attribute must be a number 0-100',rule:function rule(val){return _this._testRegex(val,/^((100(\.0{1,2})?)|(\d{1,2}(\.\d{1,2})?))$/);}}},customRules);}_createClass(Validator,[{key:'getErrorMessages',value:function getErrorMessages(){return this.errorMessages;}},{key:'showMessages',value:function showMessages(){this.messagesShown=true;}},{key:'hideMessages',value:function hideMessages(){this.messagesShown=false;}// return true if all fields cleared, false if there is a validation error
},{key:'allValid',value:function allValid(){for(var key in this.fields){if(this.fieldValid(key)===false){return false;}}return true;}// return true if the one field passed in is valid, false if there is an error
},{key:'fieldValid',value:function fieldValid(field){return this.fields.hasOwnProperty(field)&&this.fields[field]===true;}// if a message is present, generate a validation error react element
},{key:'customMessage',value:function customMessage(message,customClass){if(message&&this.messagesShown){return this._reactErrorElement(message,customClass);}}},{key:'message',value:function message(field,value,testString,customClass){var customErrors=arguments.length>4&&arguments[4]!==undefined?arguments[4]:{};this.errorMessages[field]=null;this.fields[field]=true;var tests=testString.split('|');var rule,options,message;for(var i=0;i<tests.length;i++){// if the validation does not pass the test
value=this._valueOrEmptyString(value);rule=this._getRule(tests[i]);options=this._getOptions(tests[i]);// test if the value passes validation
if(this.rules[rule].rule.call(this,value,options)===false){this.fields[field]=false;if(this.messagesShown){message=customErrors[rule]||customErrors.default||this.rules[rule].message.replace(':attribute',field.replace(/_/g,' '));this.errorMessages[field]=message;if(options.length>0&&this.rules[rule].hasOwnProperty('messageReplace')){return this._reactErrorElement(this.rules[rule].messageReplace(message,options));}else{return this._reactErrorElement(message,customClass);}}}}}// Private Methods
},{key:'_getRule',value:function _getRule(type){return type.split(':')[0];}},{key:'_getOptions',value:function _getOptions(type){var parts=type.split(':');return parts.length>1?parts[1].split(','):[];}},{key:'_valueOrEmptyString',value:function _valueOrEmptyString(value){return typeof value==='undefined'||value===null?'':value;}},{key:'_toSentence',value:function _toSentence(arr){return arr.slice(0,-2).join(', ')+(arr.slice(0,-2).length?', ':'')+arr.slice(-2).join(arr.length>2?', or ':' or ');}},{key:'_reactErrorElement',value:function _reactErrorElement(message,customClass){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:customClass||'validation-message'},message);}},{key:'_testRegex',value:function _testRegex(value,regex){return value.toString().match(regex)!==null;}}]);return Validator;}();/* harmony default export */ __webpack_exports__["a"] = (Validator);

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InfoCard=function(_Component){_inherits(InfoCard,_Component);function InfoCard(){_classCallCheck(this,InfoCard);return _possibleConstructorReturn(this,(InfoCard.__proto__||Object.getPrototypeOf(InfoCard)).apply(this,arguments));}_createClass(InfoCard,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'table',width:'100%',height:'60px'}},this.props.icon?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'text-left text-primary '+this.props.icon,style:{fontSize:'40px'}}):null,this.props.small?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'text-right text-muted text-uppercase font-weight-bold center_dash_label'},this.props.small):null),this.props.text?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-value text-right'},this.props.text):null));}}]);return InfoCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{json_lang:state.json_lang,currency:state.currencies.local.symbol,orders:state.orders};};/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(InfoCard));

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SimpleTooltip=function(_Component){_inherits(SimpleTooltip,_Component);function SimpleTooltip(props){_classCallCheck(this,SimpleTooltip);var _this=_possibleConstructorReturn(this,(SimpleTooltip.__proto__||Object.getPrototypeOf(SimpleTooltip)).call(this,props));_this.state={tooltipOpen:false};return _this;}_createClass(SimpleTooltip,[{key:'toggle',value:function toggle(){this.setState({tooltipOpen:!this.state.tooltipOpen});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Tooltip"],{placement:this.props.tooltipPlacement?this.props.tooltipPlacement:'right',isOpen:this.state.tooltipOpen,target:this.props.target,toggle:function toggle(){_this2.toggle();}},this.props.text);}}]);return SimpleTooltip;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SimpleTooltip);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_general__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_bitwiseOperations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_branches_branchActions__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_debouncer__ = __webpack_require__(89);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchBranchSelect=function(_Component){_inherits(SearchBranchSelect,_Component);function SearchBranchSelect(props){_classCallCheck(this,SearchBranchSelect);var _this=_possibleConstructorReturn(this,(SearchBranchSelect.__proto__||Object.getPrototypeOf(SearchBranchSelect)).call(this,props));_initialiseProps.call(_this);var _this$props=_this.props,session=_this$props.session,branch=_this$props.branch,fromReports=_this$props.fromReports,largerInput=_this$props.largerInput;_this.state={isLoading:false,openSearcher:_this.props.branch&&_this.props.branch.id?true:false,selected:"",fromReports:fromReports?true:false,largerInput:largerInput?true:false,typingTimeout:300,userBranches:session&&session.accesses?session.accesses.filter(function(e){return e.access_type==="branch"&&e.id!==String(branch.id);}).concat({access_id:null,related_access:{id:null,name:'Todos Los comercios'}}):[]};return _this;}_createClass(SearchBranchSelect,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this2=this;var newList=[];var _props=this.props,branches=_props.branches,userHigherAccess=_props.userHigherAccess,session=_props.session,branch=_props.branch;if(prevProps.branches!==branches&&userHigherAccess>__WEBPACK_IMPORTED_MODULE_3__constants_general__["e" /* BRANCH_ACCESS */]){// los usuarios al loguearse les llega el modelo de Access no el del Branch directamente, entonces como es mas frecuente q se
// loguee un usario tipo branch a uno tipo company, le agrego la estructura basica q necesito para q un modelo Branch se parezca a un
// modelo Access, es decir,
// es distinto lo q esta guardado en this.props.session.access a lo q esta en this.props.branches
if(userHigherAccess===__WEBPACK_IMPORTED_MODULE_3__constants_general__["h" /* COMPANY_ACCESS */]||session.account.type===__WEBPACK_IMPORTED_MODULE_4__constants_bitwiseOperations__["d" /* ADMIN_OWNER */]){if(branches.length>0){if(this.props.branchGruopIds&&this.props.branchGruopIds.length>0){newList=branches.filter(function(branch){return _this2.props.branchGruopIds.includes(branch.branch_group_id);}).map(function(b){return{access_id:b.id,related_access:Object.assign({},b)};});}else{newList=branches.map(function(b){return{access_id:b.id,related_access:Object.assign({},b)};});}}this.setState({userBranches:newList});}else{newList=this.props.branches.map(function(b){var finded=_this2.state.userBranches.findIndex(function(ub){return ub.access_type==="branch"&&ub.access_id===b.id;});return finded!==-1?{access_id:b.id,related_access:Object.assign({},b)}:null;}).filter(function(b){return b;});// devuelve los que no son nulos
}newList=newList.concat({access_id:-1,related_access:{id:-1,name:'Todos Los comercios'}});}if(prevProps.branch.id!==branch.id){this.setState({openSearcher:this.props.openSearcher?this.props.openSearcher:true});}}},{key:'SearchAction',value:function SearchAction(query){var _this3=this;var userHigherAccess=this.props.userHigherAccess;this.setState({isLoading:true});if(userHigherAccess>__WEBPACK_IMPORTED_MODULE_3__constants_general__["e" /* BRANCH_ACCESS */]&&query){this.debouncer.debounce(function(){_this3.props.fetchCompanyBranches(10,query).then(function(){_this3.setState({isLoading:false});}).catch(function(err){_this3.setState({isLoading:false});});});}}},{key:'clearform',value:function clearform(){this.setState({openSearcher:false});this._typeahead.getInstance().clear();this.props.clear?this.props.clear():null;}},{key:'find',value:function find(){var _this4=this;var userHigherAccess=this.props.userHigherAccess;if(userHigherAccess>__WEBPACK_IMPORTED_MODULE_3__constants_general__["e" /* BRANCH_ACCESS */]&&this.state.openSearcher===false){this.props.fetchCompanyBranches().then(function(){_this4.setState({isLoading:false});}).catch(function(err){_this4.setState({isLoading:false});});}this.setState({openSearcher:true,isLoading:true});}},{key:'render',value:function render(){var _this5=this;var _props2=this.props,company=_props2.company,userHigherAccess=_props2.userHigherAccess,session=_props2.session;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex'}},userHigherAccess===__WEBPACK_IMPORTED_MODULE_3__constants_general__["h" /* COMPANY_ACCESS */]||session.account.type===__WEBPACK_IMPORTED_MODULE_4__constants_bitwiseOperations__["d" /* ADMIN_OWNER */]?this.props.noClear===true?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custon_tap '+(this.state.openSearcher===false?'custon_active_tab':''),onClick:function onClick(){return _this5.clearform();},style:{padding:'0 5px 0 0',display:'flex',gap:'10px',alignItems:'center',cursor:"pointer"},title:company.name},this.state.fromReports?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mx-2'},'Limpiar filtro'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',height:'24',viewBox:'0 -960 960 960',width:'24',style:this.state.openSearcher===false?{fill:'white'}:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M201-120q-33 0-56.5-23.5T121-200v-318q-23-21-35.5-54t-.5-72l42-136q8-26 28.5-43t47.5-17h556q27 0 47 16.5t29 43.5l42 136q12 39-.5 71T841-518v318q0 33-23.5 56.5T761-120H201Zm368-440q27 0 41-18.5t11-41.5l-22-140h-78v148q0 21 14 36.5t34 15.5Zm-180 0q23 0 37.5-15.5T441-612v-148h-78l-22 140q-4 24 10.5 42t37.5 18Zm-178 0q18 0 31.5-13t16.5-33l22-154h-78l-40 134q-6 20 6.5 43t41.5 23Zm540 0q29 0 42-23t6-43l-42-134h-76l22 154q3 20 16.5 33t31.5 13ZM201-200h560v-282q-5 2-6.5 2H751q-27 0-47.5-9T663-518q-18 18-41 28t-49 10q-27 0-50.5-10T481-518q-17 18-39.5 28T393-480q-29 0-52.5-10T299-518q-21 21-41.5 29.5T211-480h-4.5q-2.5 0-5.5-2v282Zm560 0H201h560Z'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Todos los comercios'))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custon_tap '+(this.state.openSearcher===true?'custon_active_tab':'')+' '+(this.state.largerInput?"custom-larger-input":""),onClick:function onClick(){return _this5.find();},style:{borderRight:'none',borderTop:'none',borderBottom:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["AsyncTypeahead"],{className:'header_tap',ref:function ref(_ref){return _this5._typeahead=_ref;},labelKey:'name',options:this.state.userBranches.map(function($0){return $0.related_access;}),onChange:this.props.change?this.props.change:function(e){return _this5.setBranch(e[0]);}//onBlur={()=> this.setState({openSearcher:this.props.openSearcher ? this.props.openSearcher : true})}
,onSearch:function onSearch(query){return _this5.SearchAction(query);},isLoading:this.state.isLoading,value:this.state.selected//defaultSelected={[this.state.selected]}
,placeholder:this.props.placeholder?this.props.placeholder:'Seleccione un comercio'})));}}]);return SearchBranchSelect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this6=this;this.debouncer=new __WEBPACK_IMPORTED_MODULE_6__utils_debouncer__["a" /* Debouncer */]();this.setBranch=function(branch){_this6.props.updateSelectedBranch(branch?branch:{}).then(function(){return _this6._typeahead.getInstance().clear();});};};var mapStateToProps=function mapStateToProps(state){//console.log("dashboard",state.dashboardStatistics && state.dashboardStatistics.orders && state.dashboardStatistics.orders.ongoing && state.dashboardStatistics.orders.ongoing.hanging)
return{admin_type:state.session&&state.session.admin_type&&state.session.admin_type.name,admin_account_type:state.session&&state.session.account&&state.session.account.type,admin_type_id:state.session&&state.session.admin_type&&state.session.admin_type.id?state.session.admin_type.id:"",company:state.company,userHigherAccess:state.userHigherAccess,branch:state.branch,branches:state.branches,session:state.session,unseenNotifications:state.unseenNotifications,errors:state.errors,online:state.userIsOnline,json_lang:state.json_lang,defaultDashboard:state.company.options,//statsCurrent: state.dashboardStatistics && state.dashboardStatistics.orders && state.dashboardStatistics.orders.ongoing,
statsCurrent:state.dashboardStatistics&&state.dashboardStatistics.orders&&state.dashboardStatistics.orders.ongoing&&state.dashboardStatistics.orders.ongoing.unattended,unconfirmedOrders:state.dashboardStatistics&&state.dashboardStatistics.orders&&state.dashboardStatistics.orders.unattended&&state.dashboardStatistics.orders.unattended.unconfirmed};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchCompanyBranches:function fetchCompanyBranches(limit,query){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_branches_branchActions__["H" /* fetchCompanyBranches */])(limit,query));},updateSelectedBranch:function updateSelectedBranch(userBranch){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_branches_branchActions__["_16" /* updateSelectedBranch */])(userBranch));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SearchBranchSelect));

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asyncContainer = __webpack_require__(203);

var _asyncContainer2 = _interopRequireDefault(_asyncContainer);

var _Typeahead = __webpack_require__(218);

var _Typeahead2 = _interopRequireDefault(_Typeahead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _asyncContainer2.default)(_Typeahead2.default);

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(25);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(482),
    isObject = __webpack_require__(32),
    isSymbol = __webpack_require__(80);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(483);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 483 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(53);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 485 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _uniqueId = __webpack_require__(487);

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _index = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function addCustomOption(results, text, labelKey) {
  var exactMatchFound = results.some(function (o) {
    return (0, _index.getOptionLabel)(o, labelKey) === text;
  });

  if (!text.trim() || exactMatchFound) {
    return results;
  }

  var customOption = _defineProperty({
    customOption: true,
    id: (0, _uniqueId2.default)('new-id-')
  }, (0, _index.getStringLabelKey)(labelKey), text);

  return [].concat(_toConsumableArray(results), [customOption]);
}

exports.default = addCustomOption;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(205);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(53),
    arrayMap = __webpack_require__(260),
    isArray = __webpack_require__(14),
    isSymbol = __webpack_require__(80);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultFilterBy;

var _isEqual = __webpack_require__(206);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _isFunction = __webpack_require__(95);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isString = __webpack_require__(266);

var _isString2 = _interopRequireDefault(_isString);

var _some = __webpack_require__(535);

var _some2 = _interopRequireDefault(_some);

var _stripDiacritics = __webpack_require__(126);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

var _warn = __webpack_require__(37);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isMatch(input, string, props) {
  if (!props.caseSensitive) {
    input = input.toLowerCase();
    string = string.toLowerCase();
  }

  if (props.ignoreDiacritics) {
    input = (0, _stripDiacritics2.default)(input);
    string = (0, _stripDiacritics2.default)(string);
  }

  return string.indexOf(input) !== -1;
}

/**
 * Default algorithm for filtering results.
 */
function defaultFilterBy(option, props) {
  var filterBy = props.filterBy,
      labelKey = props.labelKey,
      multiple = props.multiple,
      selected = props.selected,
      text = props.text;

  // Don't show selected options in the menu for the multi-select case.

  if (multiple && selected.some(function (o) {
    return (0, _isEqual2.default)(o, option);
  })) {
    return false;
  }

  var fields = filterBy.slice();

  if ((0, _isFunction2.default)(labelKey) && isMatch(text, labelKey(option), props)) {
    return true;
  }

  if ((0, _isString2.default)(labelKey)) {
    // Add the `labelKey` field to the list of fields if it isn't already there.
    if (fields.indexOf(labelKey) === -1) {
      fields.unshift(labelKey);
    }
  }

  if ((0, _isString2.default)(option)) {
    (0, _warn2.default)(fields.length <= 1, 'You cannot filter by properties when `option` is a string.');

    return isMatch(text, option, props);
  }

  return (0, _some2.default)(fields, function (field) {
    var value = option[field];

    if (!(0, _isString2.default)(value)) {
      (0, _warn2.default)(false, 'Fields passed to `filterBy` should have string values. Value will ' + 'be converted to a string; results may be unexpected.');

      // Coerce to string since `toString` isn't null-safe.
      value = value + '';
    }

    return isMatch(text, value, props);
  });
}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(138),
    equalArrays = __webpack_require__(208),
    equalByTag = __webpack_require__(521),
    equalObjects = __webpack_require__(524),
    getTag = __webpack_require__(246),
    isArray = __webpack_require__(14),
    isBuffer = __webpack_require__(139),
    isTypedArray = __webpack_require__(143);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 491 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(82);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(82);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(82);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(82);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(81);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 497 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 498 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 499 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(81),
    Map = __webpack_require__(121),
    MapCache = __webpack_require__(122);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(95),
    isMasked = __webpack_require__(502),
    isObject = __webpack_require__(32),
    toSource = __webpack_require__(207);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(503);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(25);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 504 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(506),
    ListCache = __webpack_require__(81),
    Map = __webpack_require__(121);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(507),
    hashDelete = __webpack_require__(508),
    hashGet = __webpack_require__(509),
    hashHas = __webpack_require__(510),
    hashSet = __webpack_require__(511);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(83);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 508 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(83);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(83);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(83);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(84);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 513 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(84);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(84);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(84);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(122),
    setCacheAdd = __webpack_require__(518),
    setCacheHas = __webpack_require__(519);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 518 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 519 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 520 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(53),
    Uint8Array = __webpack_require__(261),
    eq = __webpack_require__(65),
    equalArrays = __webpack_require__(208),
    mapToArray = __webpack_require__(522),
    setToArray = __webpack_require__(523);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 522 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 523 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(262);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 525 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 526 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(43),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 528 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(43),
    isLength = __webpack_require__(123),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(251),
    nativeKeys = __webpack_require__(531);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(210);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(44),
    root = __webpack_require__(25);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(44),
    root = __webpack_require__(25);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(44),
    root = __webpack_require__(25);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(209),
    baseIteratee = __webpack_require__(267),
    baseSome = __webpack_require__(549),
    isArray = __webpack_require__(14),
    isIterateeCall = __webpack_require__(270);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(537),
    getMatchData = __webpack_require__(538),
    matchesStrictComparable = __webpack_require__(213);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(138),
    baseIsEqual = __webpack_require__(120);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(212),
    keys = __webpack_require__(94);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(120),
    get = __webpack_require__(540),
    hasIn = __webpack_require__(214),
    isKey = __webpack_require__(125),
    isStrictComparable = __webpack_require__(212),
    matchesStrictComparable = __webpack_require__(213),
    toKey = __webpack_require__(59);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(124);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(542);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(543);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(122);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 544 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(86),
    isArguments = __webpack_require__(96),
    isArray = __webpack_require__(14),
    isIndex = __webpack_require__(85),
    isLength = __webpack_require__(123),
    toKey = __webpack_require__(59);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(547),
    basePropertyDeep = __webpack_require__(548),
    isKey = __webpack_require__(125),
    toKey = __webpack_require__(59);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 547 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(124);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(252);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 550 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(92);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function getAccessibilityStatus(props) {
  var a11yNumResults = props.a11yNumResults,
      a11yNumSelected = props.a11yNumSelected,
      emptyLabel = props.emptyLabel,
      isMenuShown = props.isMenuShown,
      results = props.results,
      selected = props.selected;

  // If the menu is hidden, display info about the number of selections.

  if (!isMenuShown) {
    return a11yNumSelected(selected);
  }

  // Display info about the number of matches.
  if (results.length === 0) {
    return emptyLabel;
  }

  return a11yNumResults(results);
}

exports.default = getAccessibilityStatus;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDisplayName;
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getMatchBounds = __webpack_require__(215);

var _getMatchBounds2 = _interopRequireDefault(_getMatchBounds);

var _getOptionLabel = __webpack_require__(127);

var _getOptionLabel2 = _interopRequireDefault(_getOptionLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getHintText(_ref) {
  var activeItem = _ref.activeItem,
      initialItem = _ref.initialItem,
      isMenuShown = _ref.isMenuShown,
      labelKey = _ref.labelKey,
      multiple = _ref.multiple,
      selected = _ref.selected,
      text = _ref.text;

  // Don't display a hint under the following conditions:
  if (
  // No text entered.
  !text ||
  // The menu is hidden.
  !isMenuShown ||
  // No item in the menu.
  !initialItem ||
  // The initial item is a custom option.
  initialItem.customOption ||
  // One of the menu items is active.
  activeItem ||
  // There's already a selection in single-select mode.
  !!selected.length && !multiple) {
    return '';
  }

  var initialItemStr = (0, _getOptionLabel2.default)(initialItem, labelKey);
  var bounds = (0, _getMatchBounds2.default)(initialItemStr.toLowerCase(), text.toLowerCase());

  if (!(bounds && bounds.start === 0)) {
    return '';
  }

  // Text matching is case- and accent-insensitive, so to display the hint
  // correctly, splice the input string with the hint string.
  return text + initialItemStr.slice(bounds.end, initialItemStr.length);
}

exports.default = getHintText;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;

module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	return str.replace(matchOperatorsRe, '\\$&');
};


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _head = __webpack_require__(128);

var _head2 = _interopRequireDefault(_head);

var _getOptionLabel = __webpack_require__(127);

var _getOptionLabel2 = _interopRequireDefault(_getOptionLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getInputText(_ref) {
  var activeItem = _ref.activeItem,
      labelKey = _ref.labelKey,
      multiple = _ref.multiple,
      selected = _ref.selected,
      text = _ref.text;

  if (activeItem) {
    // Display the input value if the pagination item is active.
    return activeItem.paginationOption ? text : (0, _getOptionLabel2.default)(activeItem, labelKey);
  }

  var selectedItem = !multiple && !!selected.length && (0, _head2.default)(selected);
  if (selectedItem) {
    return (0, _getOptionLabel2.default)(selectedItem, labelKey);
  }

  return text;
}

exports.default = getInputText;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getMenuItemId;
function getMenuItemId(position) {
  return "rbt-menu-item-" + position;
}

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Truncates the result set based on `maxResults` and returns the new set.
 */
function getTruncatedOptions(options, maxResults) {
  if (!maxResults || maxResults >= options.length) {
    return options;
  }

  return options.slice(0, maxResults);
}

exports.default = getTruncatedOptions;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pluralize;
/**
 * Basic util for pluralizing words. By default, simply adds an 's' to the word.
 * Also allows for a custom plural version.
 */
function pluralize(text, count, plural) {
  plural = plural || text + "s";
  return count === 1 ? "1 " + text : count + " " + plural;
}

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = preventInputBlur;
/**
 * Prevent the main input from blurring when a menu item or the clear button is
 * clicked. (#226 & #310)
 */
function preventInputBlur(e) {
  e.preventDefault();
}

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Partial polyfill for webkit `scrollIntoViewIfNeeded()` method. Addresses
 * vertical scrolling only.
 *
 * Inspired by https://gist.github.com/hsablonniere/2581101, but uses
 * `getBoundingClientRect`.
 */
function scrollIntoViewIfNeeded(node) {
  // Webkit browsers
  if (Element.prototype.scrollIntoViewIfNeeded) {
    node.scrollIntoViewIfNeeded();
    return;
  }

  // FF, IE, etc.
  var rect = node.getBoundingClientRect();
  var parent = node.parentNode;
  var parentRect = parent.getBoundingClientRect();

  var parentComputedStyle = window.getComputedStyle(parent, null);
  var parentBorderTopWidth = parseInt(parentComputedStyle.getPropertyValue('border-top-width'));

  if (rect.top < parentRect.top || rect.bottom > parentRect.bottom) {
    parent.scrollTop = node.offsetTop - parent.offsetTop - parent.clientHeight / 2 - parentBorderTopWidth + node.clientHeight / 2;
  }
}

exports.default = scrollIntoViewIfNeeded;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(563),
    flatRest = __webpack_require__(220);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(564),
    hasIn = __webpack_require__(214);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(124),
    baseSet = __webpack_require__(565),
    castPath = __webpack_require__(86);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(254),
    castPath = __webpack_require__(86),
    isIndex = __webpack_require__(85),
    isObject = __webpack_require__(32),
    toKey = __webpack_require__(59);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(567);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(142),
    isFlattenable = __webpack_require__(568);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(53),
    isArguments = __webpack_require__(96),
    isArray = __webpack_require__(14);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 569 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(571),
    defineProperty = __webpack_require__(219),
    identity = __webpack_require__(140);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 571 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 572 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loader = function Loader(_ref) {
  var bsSize = _ref.bsSize;
  return _react2.default.createElement('div', {
    className: (0, _classnames2.default)('rbt-loader', {
      'rbt-loader-lg': bsSize === 'large' || bsSize === 'lg',
      'rbt-loader-sm': bsSize === 'small' || bsSize === 'sm'
    })
  });
};

Loader.propTypes = {
  bsSize: _propTypes2.default.oneOf(['large', 'lg', 'small', 'sm'])
};

exports.default = Loader;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(129);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _Portal = __webpack_require__(576);

var _Portal2 = _interopRequireDefault(_Portal);

var _reactPopper = __webpack_require__(185);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BODY_CLASS = 'rbt-body-container';

// When appending the overlay to `document.body`, clicking on it will register
// as an "outside" click and immediately close the overlay. This classname tells
// `react-onclickoutside` to ignore the click.
var IGNORE_CLICK_OUTSIDE = 'ignore-react-onclickoutside';

function getModifiers(_ref) {
  var align = _ref.align,
      flip = _ref.flip;

  return {
    computeStyles: {
      enabled: true,
      fn: function fn(data) {
        // Use the following condition instead of `align === 'justify'` since
        // it allows the component to fall back to justifying the menu width
        // even when `align` is undefined.
        if (align !== 'right' && align !== 'left') {
          // Set the popper width to match the target width.
          data.styles.width = data.offsets.reference.width;
        }
        return data;
      }
    },
    flip: {
      enabled: flip
    },
    preventOverflow: {
      escapeWithReference: true
    }
  };
}

function isBody(container) {
  return container === document.body;
}

/**
 * Custom `Overlay` component, since the version in `react-overlays` doesn't
 * work for our needs. Specifically, the `Position` component doesn't provide
 * the customized placement we need.
 */

var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Overlay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call.apply(_ref2, [this].concat(args))), _this), _this._update = function () {
      var _container$classList;

      var _this$props = _this.props,
          className = _this$props.className,
          container = _this$props.container,
          show = _this$props.show;

      // Positioning is only used when body is the container.

      if (!(show && isBody(container))) {
        return;
      }

      // Set a classname on the body for scoping purposes.
      container.classList.add(BODY_CLASS);
      !!className && (_container$classList = container.classList).add.apply(_container$classList, _toConsumableArray(className.split(' ')));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Overlay, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._update();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var onMenuHide = nextProps.onMenuHide,
          onMenuShow = nextProps.onMenuShow,
          show = nextProps.show;


      if (this.props.show && !show) {
        onMenuHide();
      }

      if (!this.props.show && show) {
        onMenuShow();
      }

      // Remove scoping classes if menu isn't being appended to document body.
      var _props = this.props,
          className = _props.className,
          container = _props.container;

      if (isBody(container) && !isBody(nextProps.container)) {
        var _container$classList2;

        container.classList.remove(BODY_CLASS);
        !!className && (_container$classList2 = container.classList).remove.apply(_container$classList2, _toConsumableArray(className.split(' ')));
      }

      this._update();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          align = _props2.align,
          children = _props2.children,
          container = _props2.container,
          dropup = _props2.dropup,
          show = _props2.show,
          target = _props2.target;


      if (!(show && _react.Children.count(children) && target)) {
        return null;
      }

      var child = _react.Children.only(children);

      var xPlacement = align === 'right' ? 'end' : 'start';
      var yPlacement = dropup ? 'top' : 'bottom';

      return _react2.default.createElement(
        _Portal2.default,
        { container: container },
        _react2.default.createElement(
          _reactPopper.Popper,
          {
            modifiers: getModifiers(this.props),
            placement: yPlacement + '-' + xPlacement,
            target: target },
          function (props) {
            var _props$popperProps = props.popperProps,
                ref = _props$popperProps.ref,
                popperProps = _objectWithoutProperties(_props$popperProps, ['ref']);

            return (0, _react.cloneElement)(child, _extends({}, child.props, popperProps, {
              className: (0, _classnames2.default)(child.props.className, _defineProperty({}, IGNORE_CLICK_OUTSIDE, isBody(container))),
              innerRef: ref
            }));
          }
        )
      );
    }
  }]);

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = {
  children: _propTypes2.default.element,
  container: _componentOrElement2.default.isRequired,
  onMenuHide: _propTypes2.default.func.isRequired,
  onMenuShow: _propTypes2.default.func.isRequired,
  show: _propTypes2.default.bool,
  target: _componentOrElement2.default
};

Overlay.defaultProps = {
  show: false
};

exports.default = Overlay;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(129);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(12);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(222);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(223);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _LegacyPortal = __webpack_require__(578);

var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
    }, _this.getMountNode = function () {
      return _this._portalContainerNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this.setContainer();
    this.forceUpdate(this.props.onRendered);
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.container !== this.props.container) {
      this.setContainer(nextProps);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._portalContainerNode = null;
  };

  Portal.prototype.render = function render() {
    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
module.exports = exports['default'];

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownerDocument;
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
module.exports = exports["default"];

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(129);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(12);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(222);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(223);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
      if (!_this._overlayTarget) {
        _this._overlayTarget = document.createElement('div');
        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
        _this._portalContainerNode.appendChild(_this._overlayTarget);
      }
    }, _this._unmountOverlayTarget = function () {
      if (_this._overlayTarget) {
        _this._portalContainerNode.removeChild(_this._overlayTarget);
        _this._overlayTarget = null;
      }
      _this._portalContainerNode = null;
    }, _this._renderOverlay = function () {
      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        _this._mountOverlayTarget();

        var initialRender = !_this._overlayInstance;

        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
          if (initialRender && _this.props.onRendered) {
            _this.props.onRendered();
          }
        });
      } else {
        // Unrender if the component is null for transitions to null
        _this._unrenderOverlay();
        _this._unmountOverlayTarget();
      }
    }, _this._unrenderOverlay = function () {
      if (_this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
        _this._overlayInstance = null;
      }
    }, _this.getMountNode = function () {
      return _this._overlayTarget;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._renderOverlay();
  };

  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
    this._renderOverlay();
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this._overlayTarget && nextProps.container !== this.props.container) {
      this._portalContainerNode.removeChild(this._overlayTarget);
      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
      this._portalContainerNode.appendChild(this._overlayTarget);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this._unrenderOverlay();
    this._unmountOverlayTarget();
  };

  Portal.prototype.render = function render() {
    return null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AutosizeInput = __webpack_require__(580);

var _AutosizeInput2 = _interopRequireDefault(_AutosizeInput);

var _Token = __webpack_require__(224);

var _Token2 = _interopRequireDefault(_Token);

var _utils = __webpack_require__(22);

var _hintContainer = __webpack_require__(227);

var _hintContainer2 = _interopRequireDefault(_hintContainer);

var _inputContainer = __webpack_require__(228);

var _inputContainer2 = _interopRequireDefault(_inputContainer);

var _keyCode = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HintedAutosizeInput = (0, _hintContainer2.default)(_AutosizeInput2.default);

var TypeaheadInputMulti = function (_React$Component) {
  _inherits(TypeaheadInputMulti, _React$Component);

  function TypeaheadInputMulti() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TypeaheadInputMulti);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TypeaheadInputMulti.__proto__ || Object.getPrototypeOf(TypeaheadInputMulti)).call.apply(_ref, [this].concat(args))), _this), _this._renderToken = function (option, idx) {
      var _this$props = _this.props,
          _onRemove = _this$props.onRemove,
          renderToken = _this$props.renderToken;

      var props = _extends({}, _this.props, {
        onRemove: function onRemove() {
          return _onRemove(option);
        }
      });

      return renderToken(option, props, idx);
    }, _this._handleContainerClickOrFocus = function (e) {
      // Don't focus the input if it's disabled.
      if (_this.props.disabled) {
        e.target.blur();
        return;
      }

      // Move cursor to the end if the user clicks outside the actual input.
      var inputNode = _this._input;
      if (e.target !== inputNode) {
        inputNode.selectionStart = inputNode.value.length;
      }

      inputNode.focus();
    }, _this._handleKeyDown = function (e) {
      var _this$props2 = _this.props,
          onKeyDown = _this$props2.onKeyDown,
          selected = _this$props2.selected,
          value = _this$props2.value;


      switch (e.keyCode) {
        case _keyCode.BACKSPACE:
          if (e.target === _this._input && selected.length && !value) {
            // If the input is selected and there is no text, focus the last
            // token when the user hits backspace.
            var children = _this._wrapper.children;
            var lastToken = children[children.length - 2];
            lastToken && lastToken.focus();
          }
          break;
      }

      onKeyDown(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TypeaheadInputMulti, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          inputClassName = _props.inputClassName,
          labelKey = _props.labelKey,
          onRemove = _props.onRemove,
          renderToken = _props.renderToken,
          selected = _props.selected,
          props = _objectWithoutProperties(_props, ['className', 'inputClassName', 'labelKey', 'onRemove', 'renderToken', 'selected']);

      return (
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        /* eslint-disable jsx-a11y/click-events-have-key-events */
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('form-control', 'rbt-input-multi', className),
            disabled: props.disabled,
            onClick: this._handleContainerClickOrFocus,
            onFocus: this._handleContainerClickOrFocus,
            tabIndex: -1 },
          _react2.default.createElement(
            'div',
            { className: 'rbt-input-wrapper', ref: function ref(el) {
                return _this2._wrapper = el;
              } },
            selected.map(this._renderToken),
            _react2.default.createElement(HintedAutosizeInput, _extends({}, props, {
              inputClassName: (0, _classnames2.default)('rbt-input-main', inputClassName),
              inputRef: function inputRef(input) {
                _this2._input = input;
                _this2.props.inputRef(input);
              },
              inputStyle: {
                backgroundColor: 'transparent',
                border: 0,
                boxShadow: 'none',
                cursor: 'inherit',
                outline: 'none',
                padding: 0
              },
              onKeyDown: this._handleKeyDown,
              style: {
                position: 'relative',
                zIndex: 1
              }
            }))
          )
        )
        /* eslint-enable jsx-a11y/no-static-element-interactions */
        /* eslint-enable jsx-a11y/click-events-have-key-events */

      );
    }

    /**
     * Forward click or focus events on the container element to the input.
     */

  }]);

  return TypeaheadInputMulti;
}(_react2.default.Component);

TypeaheadInputMulti.propTypes = {
  /**
   * Provides a hook for customized rendering of tokens when multiple
   * selections are enabled.
   */
  renderToken: _propTypes2.default.func
};

TypeaheadInputMulti.defaultProps = {
  renderToken: function renderToken(option, props, idx) {
    return _react2.default.createElement(
      _Token2.default,
      {
        disabled: props.disabled,
        key: idx,
        onRemove: props.onRemove,
        tabIndex: props.tabIndex },
      (0, _utils.getOptionLabel)(option, props.labelKey)
    );
  }
};

exports.default = (0, _inputContainer2.default)(TypeaheadInputMulti);

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SIZER_STYLE = {
  height: 0,
  left: 0,
  overflow: 'scroll',
  position: 'absolute',
  top: 0,
  visibility: 'hidden',
  whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['inputClassName', 'inputRef', 'inputStyle'];

var MIN_WIDTH = 1;

var cleanInputProps = function cleanInputProps(inputProps) {
  INPUT_PROPS_BLACKLIST.forEach(function (field) {
    return delete inputProps[field];
  });
  return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
  node.style.fontSize = styles.fontSize;
  node.style.fontFamily = styles.fontFamily;
  node.style.fontWeight = styles.fontWeight;
  node.style.fontStyle = styles.fontStyle;
  node.style.letterSpacing = styles.letterSpacing;
  node.style.textTransform = styles.textTransform;
};

var AutosizeInput = function (_React$Component) {
  _inherits(AutosizeInput, _React$Component);

  function AutosizeInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AutosizeInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      inputWidth: MIN_WIDTH
    }, _this._copyInputStyles = function () {
      var inputStyles = _this._input && window.getComputedStyle && window.getComputedStyle(_this._input);

      if (!inputStyles) {
        return;
      }

      copyStyles(inputStyles, _this._sizer);

      if (_this._placeHolderSizer) {
        copyStyles(inputStyles, _this._placeHolderSizer);
      }
    }, _this._updateInputWidth = function () {
      if (!_this._sizer || _this._sizer.scrollWidth === undefined) {
        return;
      }

      _this._copyInputStyles();

      var placeholderWidth = _this._placeHolderSizer && _this._placeHolderSizer.scrollWidth || MIN_WIDTH;

      var inputWidth = Math.max(_this._sizer.scrollWidth, placeholderWidth) + 2;

      if (inputWidth !== _this.state.inputWidth) {
        _this.setState({ inputWidth: inputWidth });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AutosizeInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._updateInputWidth();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this._updateInputWidth();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          defaultValue = _props.defaultValue,
          placeholder = _props.placeholder,
          value = _props.value;


      var wrapperStyle = _extends({}, this.props.style);
      if (!wrapperStyle.display) {
        wrapperStyle.display = 'inline-block';
      }

      var inputProps = cleanInputProps(_extends({}, this.props, {
        className: this.props.inputClassName,
        style: _extends({}, this.props.inputStyle, {
          boxSizing: 'content-box',
          width: this.state.inputWidth + 'px'
        })
      }));

      return _react2.default.createElement(
        'div',
        { className: className, style: wrapperStyle },
        _react2.default.createElement('input', _extends({}, inputProps, {
          ref: function ref(el) {
            _this2._input = el;
            if (typeof _this2.props.inputRef === 'function') {
              _this2.props.inputRef(el);
            }
          }
        })),
        _react2.default.createElement(
          'div',
          {
            ref: function ref(el) {
              return _this2._sizer = el;
            },
            style: SIZER_STYLE },
          defaultValue || value || ''
        ),
        placeholder ? _react2.default.createElement(
          'div',
          {
            ref: function ref(el) {
              return _this2._placeHolderSizer = el;
            },
            style: SIZER_STYLE },
          placeholder
        ) : null
      );
    }
  }]);

  return AutosizeInput;
}(_react2.default.Component);

AutosizeInput.propTypes = {
  /**
   * ClassName for the input element.
   */
  inputClassName: _propTypes2.default.string,
  /**
   * Ref callback for the input element.
   */
  inputRef: _propTypes2.default.func,
  /**
   * CSS styles for the input element.
   */
  inputStyle: _propTypes2.default.object
};

exports.default = AutosizeInput;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hintContainer = __webpack_require__(227);

var _hintContainer2 = _interopRequireDefault(_hintContainer);

var _inputContainer = __webpack_require__(228);

var _inputContainer2 = _interopRequireDefault(_inputContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TypeaheadInputSingle = function (_React$Component) {
  _inherits(TypeaheadInputSingle, _React$Component);

  function TypeaheadInputSingle() {
    _classCallCheck(this, TypeaheadInputSingle);

    return _possibleConstructorReturn(this, (TypeaheadInputSingle.__proto__ || Object.getPrototypeOf(TypeaheadInputSingle)).apply(this, arguments));
  }

  _createClass(TypeaheadInputSingle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          inputRef = _props.inputRef,
          props = _objectWithoutProperties(_props, ['className', 'inputRef']);

      return _react2.default.createElement('input', _extends({}, props, {
        className: (0, _classnames2.default)('rbt-input-main', 'form-control', className),
        ref: inputRef,
        type: 'text'
      }));
    }
  }]);

  return TypeaheadInputSingle;
}(_react2.default.Component);

exports.default = (0, _inputContainer2.default)((0, _hintContainer2.default)(TypeaheadInputSingle));

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}
module.exports = exports['default'];

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _flowRight = __webpack_require__(584);

var _flowRight2 = _interopRequireDefault(_flowRight);

var _head = __webpack_require__(128);

var _head2 = _interopRequireDefault(_head);

var _isEqual = __webpack_require__(206);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _noop = __webpack_require__(131);

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactOnclickoutside = __webpack_require__(226);

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _highlightOnlyResultContainer = __webpack_require__(591);

var _highlightOnlyResultContainer2 = _interopRequireDefault(_highlightOnlyResultContainer);

var _propTypes3 = __webpack_require__(592);

var _utils = __webpack_require__(22);

var _defaultLabelKey = __webpack_require__(217);

var _keyCode = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function genId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return prefix + Math.random().toString(36).substr(2, 12);
}

function getInitialState(props) {
  var defaultInputValue = props.defaultInputValue,
      defaultSelected = props.defaultSelected,
      maxResults = props.maxResults,
      multiple = props.multiple;


  var selected = props.selected ? props.selected.slice() : defaultSelected.slice();

  var text = defaultInputValue;

  if (!multiple && selected.length) {
    // Set the text if an initial selection is passed in.
    text = (0, _utils.getOptionLabel)((0, _head2.default)(selected), props.labelKey);

    if (selected.length > 1) {
      // Limit to 1 selection in single-select mode.
      selected = selected.slice(0, 1);
    }
  }

  return {
    activeIndex: -1,
    activeItem: null,
    initialItem: null,
    selected: selected,
    showMenu: false,
    shownResults: maxResults,
    text: text
  };
}

function typeaheadContainer(Typeahead) {
  // Nested HOCs to encapsulate behaviors. In order from outer to inner.
  Typeahead = (0, _flowRight2.default)(_highlightOnlyResultContainer2.default)(Typeahead);

  var WrappedTypeahead = function (_React$Component) {
    _inherits(WrappedTypeahead, _React$Component);

    function WrappedTypeahead(props) {
      _classCallCheck(this, WrappedTypeahead);

      var _this = _possibleConstructorReturn(this, (WrappedTypeahead.__proto__ || Object.getPrototypeOf(WrappedTypeahead)).call(this, props));

      _this.blur = function () {
        _this.getInput().blur();
        _this._hideMenu();
      };

      _this.clear = function () {
        _this.setState(_extends({}, getInitialState(_this.props), {
          selected: [],
          text: ''
        }));
      };

      _this.focus = function () {
        _this.getInput().focus();
      };

      _this.getInput = function () {
        return _this._input;
      };

      _this._handleActiveIndexChange = function (activeIndex) {
        var newState = { activeIndex: activeIndex };

        if (activeIndex === -1) {
          // Reset the active item if there is no active index.
          newState.activeItem = null;
        }

        _this.setState(newState);
      };

      _this._handleActiveItemChange = function (activeItem) {
        _this.setState({ activeItem: activeItem });
      };

      _this._handleClear = function () {
        _this.clear();
        _this._updateSelected([]);
      };

      _this._handleFocus = function (e) {
        _this.setState({ showMenu: true }, function () {
          return _this.props.onFocus(e);
        });
      };

      _this._handleInitialItemChange = function (initialItem) {
        var labelKey = _this.props.labelKey;

        var currentItem = _this.state.initialItem;

        // Don't update the initial item if it hasn't changed. For custom items,
        // compare the `labelKey` values since a unique id is generated each time,
        // causing the comparison to always return false otherwise.
        if ((0, _isEqual2.default)(initialItem, currentItem) || currentItem && initialItem && initialItem.customOption && initialItem[labelKey] === currentItem[labelKey]) {
          return;
        }

        _this.setState({ initialItem: initialItem });
      };

      _this._handleInputChange = function (e) {
        e.persist();
        var text = e.target.value;

        var _getInitialState = getInitialState(_this.props),
            activeIndex = _getInitialState.activeIndex,
            activeItem = _getInitialState.activeItem;

        var _this$props = _this.props,
            multiple = _this$props.multiple,
            onInputChange = _this$props.onInputChange;


        _this.setState({
          activeIndex: activeIndex,
          activeItem: activeItem,
          showMenu: true,
          text: text
        }, function () {
          return onInputChange(text, e);
        });

        // Clear any selections if text is entered in single-select mode.
        if (_this.state.selected.length && !multiple) {
          _this._updateSelected([]);
        }
      };

      _this._handleKeyDown = function (e, results, isMenuShown) {
        var activeItem = _this.state.activeItem;


        switch (e.keyCode) {
          case _keyCode.UP:
          case _keyCode.DOWN:
            if (!isMenuShown) {
              _this._showMenu();
              break;
            }

            var activeIndex = _this.state.activeIndex;

            // Prevents input cursor from going to the beginning when pressing up.

            e.preventDefault();

            // Increment or decrement index based on user keystroke.
            activeIndex += e.keyCode === _keyCode.UP ? -1 : 1;

            // Skip over any disabled options.
            while (results[activeIndex] && results[activeIndex].disabled) {
              activeIndex += e.keyCode === _keyCode.UP ? -1 : 1;
            }

            // If we've reached the end, go back to the beginning or vice-versa.
            if (activeIndex === results.length) {
              activeIndex = -1;
            } else if (activeIndex === -2) {
              activeIndex = results.length - 1;
            }

            _this._handleActiveIndexChange(activeIndex);
            break;
          case _keyCode.ESC:
            isMenuShown && _this._hideMenu();
            break;
          case _keyCode.RETURN:
            if (!isMenuShown) {
              break;
            }

            // Prevent form submission while menu is open.
            e.preventDefault();
            activeItem && _this._handleMenuItemSelect(activeItem, e);
            break;
          case _keyCode.RIGHT:
          case _keyCode.TAB:
            if (!isMenuShown) {
              break;
            }

            if (activeItem && !activeItem.paginationOption) {
              // Prevent blurring when selecting the active item.
              e.keyCode === _keyCode.TAB && e.preventDefault();
              _this._handleSelectionAdd(activeItem);
              break;
            }

            if (e.keyCode === _keyCode.TAB) {
              _this._hideMenu();
            }
            break;
        }

        _this.props.onKeyDown(e);
      };

      _this._handleMenuItemSelect = function (option, e) {
        if (option.paginationOption) {
          _this._handlePaginate(e);
        } else {
          _this._handleSelectionAdd(option);
        }
      };

      _this._handlePaginate = function (e) {
        e.persist();
        var _this$props2 = _this.props,
            maxResults = _this$props2.maxResults,
            onPaginate = _this$props2.onPaginate;


        _this.setState({
          shownResults: _this.state.shownResults + maxResults
        }, function () {
          return onPaginate(e);
        });
      };

      _this._handleSelectionAdd = function (selection) {
        var _this$props3 = _this.props,
            multiple = _this$props3.multiple,
            labelKey = _this$props3.labelKey;


        var selected = void 0;
        var text = void 0;

        if (multiple) {
          // If multiple selections are allowed, add the new selection to the
          // existing selections.
          selected = _this.state.selected.concat(selection);
          text = '';
        } else {
          // If only a single selection is allowed, replace the existing selection
          // with the new one.
          selected = [selection];
          text = (0, _utils.getOptionLabel)(selection, labelKey);
        }

        _this._hideMenu();
        _this.setState({
          initialItem: selection,
          text: text
        });

        // Text must be updated before the selection to fix #211.
        // TODO: Find a more robust way of solving the issue.
        _this._updateSelected(selected);
      };

      _this._handleSelectionRemove = function (selection) {
        var selected = _this.state.selected.filter(function (option) {
          return !(0, _isEqual2.default)(option, selection);
        });

        // Make sure the input stays focused after the item is removed.
        _this.focus();
        _this._hideMenu();
        _this._updateSelected(selected);
      };

      _this.handleClickOutside = function (e) {
        _this.state.showMenu && _this._hideMenu();
      };

      _this._hideMenu = function () {
        var _getInitialState2 = getInitialState(_this.props),
            activeIndex = _getInitialState2.activeIndex,
            activeItem = _getInitialState2.activeItem,
            showMenu = _getInitialState2.showMenu,
            shownResults = _getInitialState2.shownResults;

        _this.setState({
          activeIndex: activeIndex,
          activeItem: activeItem,
          showMenu: showMenu,
          shownResults: shownResults
        });
      };

      _this._showMenu = function () {
        _this.setState({ showMenu: true });
      };

      _this._updateSelected = function (selected) {
        _this.setState({ selected: selected }, function () {
          return _this.props.onChange(selected);
        });
      };

      _this.state = getInitialState(props);
      return _this;
    }

    _createClass(WrappedTypeahead, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          activeIndex: this.state.activeIndex,
          onActiveItemChange: this._handleActiveItemChange,
          onInitialItemChange: this._handleInitialItemChange,
          onMenuItemClick: this._handleMenuItemSelect
        };
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        // Generate random id here since doing it in defaultProps will generate
        // the same id for every instance.
        this._menuId = genId('rbt-menu-');
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.props.autoFocus && this.focus();
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var labelKey = nextProps.labelKey,
            multiple = nextProps.multiple,
            selected = nextProps.selected;

        // If new selections are passed via props, treat as a controlled input.

        if (selected && !(0, _isEqual2.default)(selected, this.state.selected)) {
          this.setState({ selected: selected });

          if (multiple) {
            return;
          }

          this.setState({
            text: selected.length ? (0, _utils.getOptionLabel)((0, _head2.default)(selected), labelKey) : ''
          });
        }

        // Truncate selections when in single-select mode.
        var newSelected = selected || this.state.selected;
        if (!multiple && newSelected.length > 1) {
          newSelected = newSelected.slice(0, 1);
          this.setState({
            selected: newSelected,
            text: (0, _utils.getOptionLabel)((0, _head2.default)(newSelected), labelKey)
          });
          return;
        }

        if (multiple !== this.props.multiple) {
          this.setState({ text: '' });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            allowNew = _props.allowNew,
            emptyLabel = _props.emptyLabel,
            filterBy = _props.filterBy,
            labelKey = _props.labelKey,
            minLength = _props.minLength,
            options = _props.options,
            paginate = _props.paginate,
            paginationText = _props.paginationText;
        var _state = this.state,
            shownResults = _state.shownResults,
            showMenu = _state.showMenu,
            text = _state.text;


        var results = [];
        if (text.length >= minLength) {
          var cb = Array.isArray(filterBy) ? _utils.defaultFilterBy : filterBy;
          results = options.filter(function (option) {
            return cb(option, _extends({}, _this2.props, _this2.state));
          });
        }

        // This must come before results are truncated.
        var shouldPaginate = paginate && results.length > shownResults;

        // Truncate results if necessary.
        results = (0, _utils.getTruncatedOptions)(results, shownResults);

        // Add the custom option.
        if (allowNew) {
          results = (0, _utils.addCustomOption)(results, text, labelKey);
        }

        // Add the pagination item.
        if (shouldPaginate) {
          var _results$push;

          results.push((_results$push = {}, _defineProperty(_results$push, (0, _utils.getStringLabelKey)(labelKey), paginationText), _defineProperty(_results$push, 'paginationOption', true), _results$push));
        }

        // This must come after the custom option is added, if applicable.
        var isMenuShown = !!(text.length >= minLength && showMenu && (results.length || emptyLabel));

        return _react2.default.createElement(Typeahead, _extends({}, this.props, this.state, {
          inputRef: function inputRef(input) {
            return _this2._input = input;
          },
          isMenuShown: isMenuShown,
          menuId: this.props.menuId || this._menuId,
          onAdd: this._handleSelectionAdd,
          onChange: this._handleInputChange,
          onClear: this._handleClear,
          onFocus: this._handleFocus,
          onInitialItemChange: this._handleInitialItemChange,
          onKeyDown: function onKeyDown(e) {
            return _this2._handleKeyDown(e, results, isMenuShown);
          },
          onRemove: this._handleSelectionRemove,
          results: results
        }));
      }

      /**
       * From `onClickOutside` HOC.
       */

    }]);

    return WrappedTypeahead;
  }(_react2.default.Component);

  WrappedTypeahead.displayName = 'TypeaheadContainer(' + (0, _utils.getDisplayName)(Typeahead) + ')';

  WrappedTypeahead.propTypes = {
    /**
     * For localized accessibility: Should return a string indicating the number
     * of results for screen readers. Receives the current results.
     */
    a11yNumResults: _propTypes2.default.func,
    /**
     * For localized accessibility: Should return a string indicating the number
     * of selections for screen readers. Receives the current selections.
     */
    a11yNumSelected: _propTypes2.default.func,
    /**
     * Specify menu alignment. The default value is `justify`, which makes the
     * menu as wide as the input and truncates long values. Specifying `left`
     * or `right` will align the menu to that side and the width will be
     * determined by the length of menu item values.
     */
    align: _propTypes2.default.oneOf(['justify', 'left', 'right']),
    /**
     * Allows the creation of new selections on the fly. Note that any new items
     * will be added to the list of selections, but not the list of original
     * options unless handled as such by `Typeahead`'s parent.
     */
    allowNew: _propTypes2.default.bool,
    /**
     * Autofocus the input when the component initially mounts.
     */
    autoFocus: _propTypes2.default.bool,
    /**
     * Whether to render the menu inline or attach to `document.body`.
     */
    bodyContainer: _propTypes2.default.bool,
    /**
     * Whether or not filtering should be case-sensitive.
     */
    caseSensitive: (0, _propTypes3.checkPropType)(_propTypes2.default.bool, _propTypes3.caseSensitiveType),
    /**
     * Displays a button to clear the input when there are selections.
     */
    clearButton: _propTypes2.default.bool,
    /**
     * The initial value displayed in the text input.
     */
    defaultInputValue: (0, _propTypes3.checkPropType)(_propTypes2.default.string, _propTypes3.defaultInputValueType),
    /**
     * Specify any pre-selected options. Use only if you want the component to
     * be uncontrolled.
     */
    defaultSelected: _propTypes3.optionType,
    /**
     * Whether to disable the component.
     */
    disabled: _propTypes2.default.bool,
    /**
     * Specify whether the menu should appear above the input.
     */
    dropup: _propTypes2.default.bool,
    /**
     * Message to display in the menu if there are no valid results.
     */
    emptyLabel: _propTypes2.default.node,
    /**
     * Either an array of fields in `option` to search, or a custom filtering
     * callback.
     */
    filterBy: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string.isRequired), _propTypes2.default.func]),
    /**
     * Whether or not to automatically adjust the position of the menu when it
     * reaches the viewport boundaries.
     */
    flip: _propTypes2.default.bool,
    /**
     * Highlights the menu item if there is only one result and allows selecting
     * that item by hitting enter. Does not work with `allowNew`.
     */
    highlightOnlyResult: (0, _propTypes3.checkPropType)(_propTypes2.default.bool, _propTypes3.highlightOnlyResultType),
    /**
     * Whether the filter should ignore accents and other diacritical marks.
     */
    ignoreDiacritics: (0, _propTypes3.checkPropType)(_propTypes2.default.bool, _propTypes3.ignoreDiacriticsType),
    /**
     * Props to be applied directly to the input. `onBlur`, `onChange`,
     * `onFocus`, and `onKeyDown` are ignored.
     */
    inputProps: (0, _propTypes3.checkPropType)(_propTypes2.default.object, _propTypes3.inputPropsType),
    /**
     * Indicate whether an asynchronous data fetch is happening.
     */
    isLoading: _propTypes2.default.bool,
    /**
     * Specify the option key to use for display or a function returning the
     * display string. By default, the selector will use the `label` key.
     */
    labelKey: (0, _propTypes3.checkPropType)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]), _propTypes3.labelKeyType),
    /**
     * Maximum number of results to display by default. Mostly done for
     * performance reasons so as not to render too many DOM nodes in the case of
     * large data sets.
     */
    maxResults: _propTypes2.default.number,
    /**
     * Id applied to the top-level menu element. Required for accessibility.
     */
    menuId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    /**
     * Number of input characters that must be entered before showing results.
     */
    minLength: _propTypes2.default.number,
    /**
     * Whether or not multiple selections are allowed.
     */
    multiple: _propTypes2.default.bool,
    /**
     * Invoked when the input is blurred. Receives an event.
     */
    onBlur: _propTypes2.default.func,
    /**
     * Invoked whenever items are added or removed. Receives an array of the
     * selected options.
     */
    onChange: _propTypes2.default.func,
    /**
     * Invoked when the input is focused. Receives an event.
     */
    onFocus: _propTypes2.default.func,
    /**
     * Invoked when the input value changes. Receives the string value of the
     * input.
     */
    onInputChange: _propTypes2.default.func,
    /**
     * Invoked when a key is pressed. Receives an event.
     */
    onKeyDown: _propTypes2.default.func,
    /**
     * Invoked when the menu is hidden.
     */
    onMenuHide: _propTypes2.default.func,
    /**
     * Invoked when the menu is shown.
     */
    onMenuShow: _propTypes2.default.func,
    /**
     * Invoked when the pagination menu item is clicked. Receives an event.
     */
    onPaginate: _propTypes2.default.func,
    /**
     * Full set of options, including pre-selected options. Must either be an
     * array of objects (recommended) or strings.
     */
    options: _propTypes3.optionType.isRequired,
    /**
     * Give user the ability to display additional results if the number of
     * results exceeds `maxResults`.
     */
    paginate: _propTypes2.default.bool,
    /**
     * Prompt displayed when large data sets are paginated.
     */
    paginationText: _propTypes2.default.string,
    /**
     * Placeholder text for the input.
     */
    placeholder: _propTypes2.default.string,
    /**
     * Callback for custom menu rendering.
     */
    renderMenu: _propTypes2.default.func,
    /**
     * The selected option(s) displayed in the input. Use this prop if you want
     * to control the component via its parent.
     */
    selected: _propTypes3.optionType,
    /**
     * Allows selecting the hinted result by pressing enter.
     */
    selectHintOnEnter: _propTypes2.default.bool
  };

  WrappedTypeahead.defaultProps = {
    a11yNumResults: function a11yNumResults(results) {
      var resultString = (0, _utils.pluralize)('result', results.length);
      return resultString + '. Use up and down arrow keys to navigate.';
    },
    a11yNumSelected: function a11yNumSelected(selected) {
      return (0, _utils.pluralize)('selection', selected.length);
    },
    align: 'justify',
    allowNew: false,
    autoFocus: false,
    bodyContainer: false,
    caseSensitive: false,
    clearButton: false,
    defaultInputValue: '',
    defaultSelected: [],
    disabled: false,
    dropup: false,
    emptyLabel: 'No matches found.',
    filterBy: [],
    flip: false,
    highlightOnlyResult: false,
    ignoreDiacritics: true,
    inputProps: {},
    isLoading: false,
    labelKey: _defaultLabelKey.DEFAULT_LABELKEY,
    maxResults: 100,
    minLength: 0,
    multiple: false,
    onBlur: _noop2.default,
    onChange: _noop2.default,
    onFocus: _noop2.default,
    onInputChange: _noop2.default,
    onKeyDown: _noop2.default,
    onMenuHide: _noop2.default,
    onMenuShow: _noop2.default,
    onPaginate: _noop2.default,
    paginate: true,
    paginationText: 'Display additional results...',
    placeholder: '',
    selectHintOnEnter: false
  };

  WrappedTypeahead.childContextTypes = {
    activeIndex: _propTypes2.default.number.isRequired,
    onActiveItemChange: _propTypes2.default.func.isRequired,
    onInitialItemChange: _propTypes2.default.func.isRequired,
    onMenuItemClick: _propTypes2.default.func.isRequired
  };

  return (0, _reactOnclickoutside2.default)(WrappedTypeahead);
}

exports.default = typeaheadContainer;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__(585);

/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */
var flowRight = createFlow(true);

module.exports = flowRight;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var LodashWrapper = __webpack_require__(132),
    flatRest = __webpack_require__(220),
    getData = __webpack_require__(233),
    getFuncName = __webpack_require__(234),
    isArray = __webpack_require__(14),
    isLaziable = __webpack_require__(588);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(211);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 587 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(134),
    getData = __webpack_require__(233),
    getFuncName = __webpack_require__(234),
    lodash = __webpack_require__(589);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(134),
    LodashWrapper = __webpack_require__(132),
    baseLodash = __webpack_require__(133),
    isArray = __webpack_require__(14),
    isObjectLike = __webpack_require__(34),
    wrapperClone = __webpack_require__(590);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(134),
    LodashWrapper = __webpack_require__(132),
    copyArray = __webpack_require__(256);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _head = __webpack_require__(128);

var _head2 = _interopRequireDefault(_head);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _keyCode = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function highlightOnlyResultContainer(Typeahead) {
  var WrappedTypeahead = function (_React$Component) {
    _inherits(WrappedTypeahead, _React$Component);

    function WrappedTypeahead() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WrappedTypeahead);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WrappedTypeahead.__proto__ || Object.getPrototypeOf(WrappedTypeahead)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        isOnlyResult: false
      }, _this._handleKeyDown = function (e) {
        var _this$props = _this.props,
            initialItem = _this$props.initialItem,
            onKeyDown = _this$props.onKeyDown,
            onAdd = _this$props.onAdd;


        switch (e.keyCode) {
          case _keyCode.RETURN:
            if (_this.state.isOnlyResult) {
              onAdd(initialItem);
            }
            break;
        }

        onKeyDown(e);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WrappedTypeahead, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var allowNew = nextProps.allowNew,
            highlightOnlyResult = nextProps.highlightOnlyResult,
            results = nextProps.results;


        if (!highlightOnlyResult || allowNew) {
          return;
        }

        if (results.length !== this.props.results.length) {
          this.setState({
            isOnlyResult: results.length === 1 && !(0, _head2.default)(results).disabled
          });
        }
      }
    }, {
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          isOnlyResult: this.state.isOnlyResult
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Typeahead, _extends({}, this.props, {
          onKeyDown: this._handleKeyDown
        }));
      }
    }]);

    return WrappedTypeahead;
  }(_react2.default.Component);

  WrappedTypeahead.childContextTypes = {
    isOnlyResult: _propTypes2.default.bool.isRequired
  };

  return WrappedTypeahead;
}

exports.default = highlightOnlyResultContainer;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optionType = exports.labelKeyType = exports.inputPropsType = exports.ignoreDiacriticsType = exports.highlightOnlyResultType = exports.defaultInputValueType = exports.checkPropType = exports.caseSensitiveType = undefined;

var _caseSensitiveType2 = __webpack_require__(593);

var _caseSensitiveType3 = _interopRequireDefault(_caseSensitiveType2);

var _checkPropType2 = __webpack_require__(594);

var _checkPropType3 = _interopRequireDefault(_checkPropType2);

var _defaultInputValueType2 = __webpack_require__(595);

var _defaultInputValueType3 = _interopRequireDefault(_defaultInputValueType2);

var _highlightOnlyResultType2 = __webpack_require__(596);

var _highlightOnlyResultType3 = _interopRequireDefault(_highlightOnlyResultType2);

var _ignoreDiacriticsType2 = __webpack_require__(597);

var _ignoreDiacriticsType3 = _interopRequireDefault(_ignoreDiacriticsType2);

var _inputPropsType2 = __webpack_require__(598);

var _inputPropsType3 = _interopRequireDefault(_inputPropsType2);

var _labelKeyType2 = __webpack_require__(599);

var _labelKeyType3 = _interopRequireDefault(_labelKeyType2);

var _optionType2 = __webpack_require__(600);

var _optionType3 = _interopRequireDefault(_optionType2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.caseSensitiveType = _caseSensitiveType3.default; /* eslint-disable object-curly-spacing */

exports.checkPropType = _checkPropType3.default;
exports.defaultInputValueType = _defaultInputValueType3.default;
exports.highlightOnlyResultType = _highlightOnlyResultType3.default;
exports.ignoreDiacriticsType = _ignoreDiacriticsType3.default;
exports.inputPropsType = _inputPropsType3.default;
exports.labelKeyType = _labelKeyType3.default;
exports.optionType = _optionType3.default;
/* eslint-enable object-curly-spacing */

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = caseSensitiveType;

var _warn = __webpack_require__(37);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function caseSensitiveType(props, propName, componentName) {
  var caseSensitive = props.caseSensitive,
      filterBy = props.filterBy;

  (0, _warn2.default)(!caseSensitive || typeof filterBy !== 'function', 'Your `filterBy` function will override the `caseSensitive` prop.');
}

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = checkPropType;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Allows additional warnings or messaging related to prop validation.
 */
function checkPropType(validator, callback) {
  return function (props, propName, componentName) {
    _propTypes2.default.checkPropTypes(_defineProperty({}, propName, validator), props, 'prop', componentName);

    typeof callback === 'function' && callback(props, propName, componentName);
  };
}

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultInputValueType;

var _warn = __webpack_require__(37);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultInputValueType(props, propName, componentName) {
  var defaultInputValue = props.defaultInputValue,
      defaultSelected = props.defaultSelected,
      multiple = props.multiple,
      selected = props.selected;

  var name = defaultSelected.length ? 'defaultSelected' : 'selected';

  (0, _warn2.default)(!(!multiple && defaultInputValue && (defaultSelected.length || selected && selected.length)), '`defaultInputValue` will be overridden by the value from `' + name + '`.');
}

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = highlightOnlyResultType;

var _warn = __webpack_require__(37);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function highlightOnlyResultType(props, propName, componentName) {
  var allowNew = props.allowNew,
      highlightOnlyResult = props.highlightOnlyResult;

  (0, _warn2.default)(!(highlightOnlyResult && allowNew), '`highlightOnlyResult` will not work with `allowNew`.');
}

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ignoreDiacriticsType;

var _warn = __webpack_require__(37);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ignoreDiacriticsType(props, propName, componentName) {
  var filterBy = props.filterBy,
      ignoreDiacritics = props.ignoreDiacritics;

  (0, _warn2.default)(ignoreDiacritics || typeof filterBy !== 'function', 'Your `filterBy` function will override the `ignoreDiacritics` prop.');
}

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = inputPropsType;

var _isPlainObject = __webpack_require__(141);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _warn = __webpack_require__(37);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BLACKLIST = [{ alt: 'onBlur', prop: 'onBlur' }, { alt: 'onInputChange', prop: 'onChange' }, { alt: 'onFocus', prop: 'onFocus' }, { alt: 'onKeyDown', prop: 'onKeyDown' }];

function inputPropsType(props, propName, componentName) {
  var inputProps = props.inputProps;

  if (!(inputProps && (0, _isPlainObject2.default)(inputProps))) {
    return;
  }

  // Blacklisted properties.
  BLACKLIST.forEach(function (_ref) {
    var alt = _ref.alt,
        prop = _ref.prop;

    var msg = alt ? ' Use the top-level `' + alt + '` prop instead.' : null;
    (0, _warn2.default)(!inputProps.hasOwnProperty(prop), 'The `' + prop + '` property of `inputProps` will be ignored.' + msg);
  });
}

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = labelKeyType;

var _warn = __webpack_require__(37);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function labelKeyType(props, propName, componentName) {
  var allowNew = props.allowNew,
      labelKey = props.labelKey;

  (0, _warn2.default)(!(typeof labelKey === 'function' && allowNew), '`labelKey` must be a string when `allowNew={true}`.');
}

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.object.isRequired), _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired)]);

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_general__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_branches_branchActions__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_debouncer__ = __webpack_require__(89);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchBranchGroupsSelect=function(_Component){_inherits(SearchBranchGroupsSelect,_Component);function SearchBranchGroupsSelect(props){_classCallCheck(this,SearchBranchGroupsSelect);var _this=_possibleConstructorReturn(this,(SearchBranchGroupsSelect.__proto__||Object.getPrototypeOf(SearchBranchGroupsSelect)).call(this,props));_this.debouncer=new __WEBPACK_IMPORTED_MODULE_5__utils_debouncer__["a" /* Debouncer */](500);_this.changeAction=function(selected){_this.props.change(selected);_this.props.dontClearInput?null:_this._typeahead.getInstance().clear();};_this.state={isLoading:false,openSearcher:true,selected:"",branchGroups:[],placeholder:'Buscar Grupo de comercio'};return _this;}_createClass(SearchBranchGroupsSelect,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var newList=[];var _props=this.props,branchGroups=_props.branchGroups,userHigherAccess=_props.userHigherAccess,_props$branchGroupsBy=_props.branchGroupsByIds,branchGroupsByIds=_props$branchGroupsBy===undefined?[]:_props$branchGroupsBy;if((prevProps.branchGroups&&prevProps.branchGroups.data&&prevProps.branchGroups.data.length)!==(branchGroups.data&&branchGroups.data.length)&&userHigherAccess>__WEBPACK_IMPORTED_MODULE_3__constants_general__["e" /* BRANCH_ACCESS */]){/* if(branchGroupsByIds.length > 0){
				newList = branchGroups.data.filter((objeto) =>
					branchGroupsByIds.some((id) => id.id === objeto.id)
				);
			} */newList=branchGroups.data.map(function(b){return{access_id:b.id,related_access:b};});newList=newList.concat({access_id:-1,related_access:{id:-1,name:this.state.placeholder}});this.setState({branchGroups:newList});}if(prevProps.selected!==this.props.selected){this.setState({selected:this.props.selected});}}},{key:'clearform',value:function clearform(){this.setState({openSearcher:false});this._typeahead.getInstance().clear();this.props.clear?this.props.clear():null;}},{key:'SearchAction',value:function SearchAction(query){var _this2=this;this.setState({searchValue:query,isLoading:true,openSearcher:true});var userHigherAccess=this.props.userHigherAccess;if(userHigherAccess>__WEBPACK_IMPORTED_MODULE_3__constants_general__["e" /* BRANCH_ACCESS */]){this.debouncer.debounce(function(){_this2.props.fetchBranchGroups(1,query).then(function(){_this2.setState({isLoading:false});}).catch(function(err){_this2.setState({isLoading:false});});});}}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,this.props.fromReports?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custon_tap custon_active_tab',onClick:function onClick(){return _this3.clearform();},style:{padding:'0 5px 0 0',display:'flex',gap:'10px',alignItems:'center',cursor:"pointer"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mx-2'},'Todos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["AsyncTypeahead"],{ref:function ref(_ref){return _this3._typeahead=_ref;}/*defaultSelected={this.props.branchGroupsByIds} */,multiple:this.props.multiple,labelKey:'name',options:this.state.branchGroups.map(function($0){return $0.related_access;}),onChange:this.changeAction,onSearch:function onSearch(query){return _this3.SearchAction(query);},isLoading:this.state.isLoading,defaultInputValue:this.props.selected,placeholder:this.state.placeholder}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["AsyncTypeahead"],{ref:function ref(_ref2){return _this3._typeahead=_ref2;}/*defaultSelected={this.props.branchGroupsByIds} */,multiple:this.props.multiple,labelKey:'name',options:this.state.branchGroups.map(function($0){return $0.related_access;}),onChange:this.changeAction,onSearch:function onSearch(query){return _this3.SearchAction(query);},isLoading:this.state.isLoading,defaultInputValue:this.props.selected,placeholder:this.state.placeholder}));}}]);return SearchBranchGroupsSelect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{admin_type:state.session&&state.session.admin_type&&state.session.admin_type.name,company:state.company,userHigherAccess:state.userHigherAccess,errors:state.errors,json_lang:state.json_lang,branchGroups:state.branchGroups};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchBranchGroups:function fetchBranchGroups(page,query){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_branches_branchActions__["C" /* fetchBranchGroups */])(page,query));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SearchBranchGroupsSelect));

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_general__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_clientActions__ = __webpack_require__(239);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchClient=function(_Component){_inherits(SearchClient,_Component);function SearchClient(props){_classCallCheck(this,SearchClient);var _this=_possibleConstructorReturn(this,(SearchClient.__proto__||Object.getPrototypeOf(SearchClient)).call(this,props));_this.state={isLoading:false,openSearcher:true,selected:"",clients:[],placeholder:'Buscar usuario'// this.props.getAllClients()
};return _this;}_createClass(SearchClient,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var newList=[];var _props=this.props,clients=_props.clients,userHigherAccess=_props.userHigherAccess;if((prevProps.clients&&prevProps.clients.data&&prevProps.clients.data.length)!==(clients.data&&clients.data.length)&&userHigherAccess>__WEBPACK_IMPORTED_MODULE_3__constants_general__["e" /* BRANCH_ACCESS */]){newList=clients.data.map(function(b){return{access_id:b.id,related_access:b};});newList=newList.concat({access_id:-1,related_access:{id:-1,name:this.state.placeholder}});this.setState({clients:newList});}}},{key:'SearchAction',value:function SearchAction(query){var userHigherAccess=this.props.userHigherAccess;if(userHigherAccess>__WEBPACK_IMPORTED_MODULE_3__constants_general__["e" /* BRANCH_ACCESS */]){this.props.getAllClients(1,query);}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["AsyncTypeahead"],{ref:function ref(_ref){return _this2._typeahead=_ref;},labelKey:'name',options:this.state.clients.map(function($0){return $0.related_access;}),onChange:this.props.change,onSearch:function onSearch(query){return _this2.SearchAction(query);},isLoading:this.state.isLoading,value:this.state.selected,placeholder:this.state.placeholder,renderMenuItemChildren:function renderMenuItemChildren(option,props,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'normaltext-autocomplete',style:{display:'flex',gap:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'avatar_small',src:option.avatar_url,ref:'avatar_url',onError:function onError(){return _this2.refs['avatar_url'].src='https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar-comprador.png';},alt:option.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'calc(100% - 40px)'}},option.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,option.email)));}}));}}]);return SearchClient;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){//console.log("dashboard",state.dashboardStatistics && state.dashboardStatistics.orders && state.dashboardStatistics.orders.ongoing && state.dashboardStatistics.orders.ongoing.hanging)
return{admin_type:state.session&&state.session.admin_type&&state.session.admin_type.name,company:state.company,userHigherAccess:state.userHigherAccess,errors:state.errors,json_lang:state.json_lang,clients:state.allClients};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getAllClients:function getAllClients(page,query){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_clientActions__["m" /* getAllClients */])(page,query));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SearchClient));

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_general__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_providerActions__ = __webpack_require__(90);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchProvider=function(_Component){_inherits(SearchProvider,_Component);function SearchProvider(props){_classCallCheck(this,SearchProvider);var _this=_possibleConstructorReturn(this,(SearchProvider.__proto__||Object.getPrototypeOf(SearchProvider)).call(this,props));_this.state={isLoading:false,openSearcher:true,selected:"",providers:[],placeholder:'Buscar rider'// this.props.fetchProviders()
};return _this;}_createClass(SearchProvider,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var newList=[];var _props=this.props,providers=_props.providers,userHigherAccess=_props.userHigherAccess;if((prevProps.providers&&prevProps.providers.data&&prevProps.providers.data.length)!==(providers.data&&providers.data.length)){newList=providers.data.map(function(b){return{access_id:b.id,related_access:b};});newList=newList.concat({access_id:-1,related_access:{id:-1,name:this.state.placeholder}});this.setState({providers:newList});}}},{key:'SearchAction',value:function SearchAction(query){var userHigherAccess=this.props.userHigherAccess;if(userHigherAccess>__WEBPACK_IMPORTED_MODULE_3__constants_general__["e" /* BRANCH_ACCESS */]){this.props.fetchProviders(1,'name=ilike '+query);}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["AsyncTypeahead"],{ref:function ref(_ref){return _this2._typeahead=_ref;},labelKey:'name',options:this.state.providers.map(function($0){return $0.related_access;}),onChange:this.props.change,onSearch:function onSearch(query){return _this2.SearchAction(query);},isLoading:this.state.isLoading,value:this.state.selected,placeholder:this.state.placeholder,renderMenuItemChildren:function renderMenuItemChildren(option,props,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'normaltext-autocomplete',style:{display:'flex',gap:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'avatar_small',src:option&&option.avatar_url,ref:'avatar_url',onError:function onError(){return _this2.refs['avatar_url'].src="https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar-comprador.png";},alt:option.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'calc(100% - 40px)'}},option.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,option.email)));}}));}}]);return SearchProvider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{admin_type:state.session&&state.session.admin_type&&state.session.admin_type.name,company:state.company,userHigherAccess:state.userHigherAccess,errors:state.errors,json_lang:state.json_lang,providers:state.providers};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchProviders:function fetchProviders(page,query){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_providerActions__["o" /* fetchProviders */])(page,query));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SearchProvider));

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_general__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_adminActions__ = __webpack_require__(242);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchAdmin=function(_Component){_inherits(SearchAdmin,_Component);function SearchAdmin(props){_classCallCheck(this,SearchAdmin);var _this=_possibleConstructorReturn(this,(SearchAdmin.__proto__||Object.getPrototypeOf(SearchAdmin)).call(this,props));_this.state={isLoading:false,openSearcher:true,selected:"",admins:[],placeholder:'Buscar admins'};_this.props.fetchAdmins();return _this;}_createClass(SearchAdmin,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var newList=[];var _props=this.props,admins=_props.admins,userHigherAccess=_props.userHigherAccess;console.log("componentDidUpdate",admins);if((prevProps.admins&&prevProps.admins.data&&prevProps.admins.data.length)!==(admins.data&&admins.data.length)){newList=admins.data.map(function(b){return{access_id:b.id,related_access:b};});newList=newList.concat({access_id:-1,related_access:{id:-1,name:this.state.placeholder}});console.log("admins",newList);this.setState({admins:newList});}}},{key:'SearchAction',value:function SearchAction(query){var _this2=this;var userHigherAccess=this.props.userHigherAccess;this.setState({isLoading:true});if(userHigherAccess>__WEBPACK_IMPORTED_MODULE_3__constants_general__["e" /* BRANCH_ACCESS */]){this.props.fetchAdmins(1,'name=ilike '+query).then(function(){_this2.setState({isLoading:false});}).catch(function(err){_this2.setState({isLoading:false});});}}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["AsyncTypeahead"],{ref:function ref(_ref){return _this3._typeahead=_ref;},className:'iniline-select',labelKey:'name',options:this.state.admins.map(function($0){return $0.related_access;}),onChange:this.props.change,onSearch:function onSearch(query){return _this3.SearchAction(query);},isLoading:this.state.isLoading,value:this.state.selected,placeholder:this.state.placeholder,renderMenuItemChildren:function renderMenuItemChildren(option,props,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'normaltext-autocomplete',style:{display:'flex',gap:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'avatar_small',src:option.avatar_url,ref:'avatar_url',onError:function onError(){return _this3.refs['avatar_url'].src='https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar-comprador.png';},alt:option.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'calc(100% - 40px)'}},option.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,option.email)));}});}}]);return SearchAdmin;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{admin_type:state.session&&state.session.admin_type&&state.session.admin_type.name,company:state.company,userHigherAccess:state.userHigherAccess,errors:state.errors,json_lang:state.json_lang,admins:state.admins};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchAdmins:function fetchAdmins(page,query){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_adminActions__["q" /* fetchAdmins */])(page,query));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SearchAdmin));

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_general__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_goodsActions__ = __webpack_require__(136);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchGoodsListSelect=function(_Component){_inherits(SearchGoodsListSelect,_Component);function SearchGoodsListSelect(props){_classCallCheck(this,SearchGoodsListSelect);var _this=_possibleConstructorReturn(this,(SearchGoodsListSelect.__proto__||Object.getPrototypeOf(SearchGoodsListSelect)).call(this,props));_this.state={isLoading:false,openSearcher:true,selected:"",goodsList:[],placeholder:'Buscar producto'//     if(this.props.branch_group){
//         this.props.fetchModalGoodsgroup(this.props.branch_group)
//     }else{
//         this.props.fetchGoods()
//     }
};return _this;}_createClass(SearchGoodsListSelect,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var newList=[];var _props=this.props,goodsList=_props.goodsList,userHigherAccess=_props.userHigherAccess;// console.log("prev",prevProps.goodsList  && prevProps.goodsList.data && prevProps.goodsList.data[0] && prevProps.goodsList.data[0].id)
// console.log("next",goodsList && goodsList.data && goodsList.data[0] && goodsList.data[0].id)
if((prevProps.goodsList&&prevProps.goodsList.data&&prevProps.goodsList.data[0]&&prevProps.goodsList.data[0].id)!==(goodsList&&goodsList.data&&goodsList.data[0]&&goodsList.data[0].id)&&userHigherAccess>__WEBPACK_IMPORTED_MODULE_3__constants_general__["e" /* BRANCH_ACCESS */]){if(goodsList&&goodsList.data){newList=goodsList.data.map(function(b){return{access_id:b.id,related_access:b};});this.setState({goodsList:newList});}}}},{key:'SearchAction',value:function SearchAction(query){var userHigherAccess=this.props.userHigherAccess;if(userHigherAccess>__WEBPACK_IMPORTED_MODULE_3__constants_general__["e" /* BRANCH_ACCESS */]){if(this.props.branch_group){this.props.fetchModalGoodsgroup(this.props.branch_group,1,query);}else{this.props.fetchGoods(1,query);}}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap_typeahead__["AsyncTypeahead"],{ref:function ref(_ref){return _this2._typeahead=_ref;},labelKey:'name',options:this.state.goodsList.map(function($0){return $0.related_access;}),onChange:this.props.change,onSearch:function onSearch(query){return _this2.SearchAction(query);},isLoading:this.state.isLoading,value:this.state.selected,placeholder:this.state.placeholder,renderMenuItemChildren:function renderMenuItemChildren(option,props,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'normaltext-autocomplete',style:{display:'flex',gap:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'avatar_small',src:option.picture_urls[0],ref:'avatar_url',onError:function onError(){return _this2.refs['avatar_url'].src='https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar-comprador.png';},alt:option.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'calc(100% - 40px)'}},option.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,option.email)));}});}}]);return SearchGoodsListSelect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{admin_type:state.session&&state.session.admin_type&&state.session.admin_type.name,company:state.company,userHigherAccess:state.userHigherAccess,errors:state.errors,json_lang:state.json_lang,goodsList:state.goodsList};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchGoods:function fetchGoods(page,query){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_goodsActions__["z" /* fetchGoods */])(page,query));},fetchModalGoodsgroup:function fetchModalGoodsgroup(branch_group,page,query){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_goodsActions__["B" /* fetchModalGoodsgroup */])(branch_group,page,query));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SearchGoodsListSelect));

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Paginate=function(_Component){_inherits(Paginate,_Component);function Paginate(){_classCallCheck(this,Paginate);return _possibleConstructorReturn(this,(Paginate.__proto__||Object.getPrototypeOf(Paginate)).apply(this,arguments));}_createClass(Paginate,[{key:'isFirstPage',/* Operational methods */value:function isFirstPage(){return this.props.list.current_page===1;}},{key:'isLastPage',value:function isLastPage(){return this.props.list.current_page===this.props.list.last_page;}/* Pagination methods */},{key:'showPreviusLink',value:function showPreviusLink(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["PaginationItem"],{onClick:function onClick(){return _this2.props.refreshList(1);},disabled:this.isFirstPage()?true:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["PaginationLink"],{previous:true,tag:'button'}));}},{key:'showNextLink',value:function showNextLink(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["PaginationItem"],{onClick:function onClick(){return _this3.props.refreshList(_this3.props.list.last_page);},disabled:this.isLastPage()?true:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["PaginationLink"],{next:true,tag:'button'}));}},{key:'iteratePagesLinks',value:function iteratePagesLinks(){var _this4=this;var linkList=[],limit=10,n=1;if(this.props.list.last_page<=10){limit=this.props.list.last_page;}if(this.props.list.current_page>limit){limit=this.props.list.last_page;n=this.props.list.current_page-3;}var _loop=function _loop(idx){if(_this4.props.list.current_page!==idx)linkList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["PaginationItem"],{key:idx,onClick:function onClick(){return _this4.props.refreshList(idx);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["PaginationLink"],{tag:'button'},idx)));else linkList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["PaginationItem"],{key:idx,onClick:function onClick(){return _this4.props.refreshList(idx);},className:'waves-effect',active:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["PaginationLink"],{tag:'button'},idx)));};for(var idx=n;idx<=limit;++idx){_loop(idx);}return linkList;}},{key:'render',value:function render(){var _this5=this;if(this.props.list&&this.props.list.last_page>1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Pagination"],null,this.showPreviusLink(),this.props.list.current_page>1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["PaginationItem"],{onClick:function onClick(){return _this5.props.refreshList(parseInt(_this5.props.list.current_page,10)-1);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["PaginationLink"],{tag:'button'},' ','<',' ')):null,this.iteratePagesLinks().map(function(page,key){return page;}),this.props.list.current_page<this.props.list.last_page?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["PaginationItem"],{onClick:function onClick(){return _this5.props.refreshList(parseInt(_this5.props.list.current_page,10)+1);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["PaginationLink"],{tag:'button'},' ','>',' ')):null,this.showNextLink());}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}}]);return Paginate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Paginate);

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__table_head__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__table_head_row__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__table_head_cell__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__table_body__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__table_row__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__table_cell__ = __webpack_require__(614);
__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */].Head=__WEBPACK_IMPORTED_MODULE_1__table_head__["a" /* default */];__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */].HeadRow=__WEBPACK_IMPORTED_MODULE_2__table_head_row__["a" /* default */];__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */].HeadCell=__WEBPACK_IMPORTED_MODULE_3__table_head_cell__["a" /* default */];__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */].Body=__WEBPACK_IMPORTED_MODULE_4__table_body__["a" /* default */];__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */].Row=__WEBPACK_IMPORTED_MODULE_5__table_row__["a" /* default */];__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */].Cell=__WEBPACK_IMPORTED_MODULE_6__table_cell__["a" /* default */];/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Table=function(_Component){_inherits(Table,_Component);function Table(){_classCallCheck(this,Table);return _possibleConstructorReturn(this,(Table.__proto__||Object.getPrototypeOf(Table)).apply(this,arguments));}_createClass(Table,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered'},this.props.children);}}]);return Table;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TableHead=function(_Component){_inherits(TableHead,_Component);function TableHead(){_classCallCheck(this,TableHead);return _possibleConstructorReturn(this,(TableHead.__proto__||Object.getPrototypeOf(TableHead)).apply(this,arguments));}_createClass(TableHead,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,this.props.children);}}]);return TableHead;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TableHead);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TableHeadRow=function(_Component){_inherits(TableHeadRow,_Component);function TableHeadRow(props){_classCallCheck(this,TableHeadRow);var _this=_possibleConstructorReturn(this,(TableHeadRow.__proto__||Object.getPrototypeOf(TableHeadRow)).call(this,props));_this.state={border:_this.props.border===false?false:true};return _this;}_createClass(TableHeadRow,[{key:'render',value:function render(){var border=this.state.border;var children=this.props.children;var childrenWithProps=__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children,function(child){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child,{border:border});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,childrenWithProps);}}]);return TableHeadRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TableHeadRow);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TableHeadCell=function(_Component){_inherits(TableHeadCell,_Component);function TableHeadCell(props){_classCallCheck(this,TableHeadCell);var _this=_possibleConstructorReturn(this,(TableHeadCell.__proto__||Object.getPrototypeOf(TableHeadCell)).call(this,props));_this.handleClick=function(){var _this$state=_this.state,column=_this$state.column,sort=_this$state.sort,ord=_this$state.ord;if(column===sort){ord=ord==='asc'?'desc':'asc';}else{ord='asc';}if(_this.props.onClick){_this.props.onClick(column,ord);}};_this.handleOver=function(){var _this$state2=_this.state,column=_this$state2.column,sort=_this$state2.sort,ord=_this$state2.ord;if(sort){if(sort===column){_this.setState({color:sessionStorage.getItem('color'),ord:ord});}else{_this.setState({color:sessionStorage.getItem('color'),ord:'asc'});}}};_this.handleOut=function(){var _this$state3=_this.state,column=_this$state3.column,sort=_this$state3.sort,color=_this$state3.color;if(sort&&sort===column){color=sessionStorage.getItem('color');}else{color='#363636';}_this.setState({color:color});};_this.state={column:_this.props.column,sort:_this.props.sort,ord:_this.props.ord,color:'#363636',border:_this.props.border};return _this;}_createClass(TableHeadCell,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps!==this.props){var _state=this.state,column=_state.column,color=_state.color;color=nextProps.sort&&nextProps.sort===column?sessionStorage.getItem('color'):'#363636';this.setState({sort:nextProps.sort,ord:nextProps.ord,color:color});}}},{key:'render',value:function render(){var _state2=this.state,column=_state2.column,sort=_state2.sort,ord=_state2.ord,border=_state2.border;var color=this.state.color;var symbol=ord==='asc'?'rotate(180deg)':'';var figure=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-Down'});var have_border=border===true?'':'no-border ';var hideOn=this.props.hideOn?this.props.hideOn:'';if(sort&&sort===column){figure=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{style:{color:sessionStorage.getItem('color'),transform:symbol},className:'icon-Down'});color=sessionStorage.getItem('color');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:have_border+hideOn,style:{color:color},onClick:this.handleClick,onMouseOver:this.handleOver,onMouseOut:this.handleOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:color!=='#363636'?{color:color}:{color:''}},this.props.children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:color,transform:symbol}},figure));}}]);return TableHeadCell;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TableHeadCell);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TableBody=function(_Component){_inherits(TableBody,_Component);function TableBody(){_classCallCheck(this,TableBody);return _possibleConstructorReturn(this,(TableBody.__proto__||Object.getPrototypeOf(TableBody)).apply(this,arguments));}_createClass(TableBody,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.props.children);}}]);return TableBody;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TableBody);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TableRow=function(_Component){_inherits(TableRow,_Component);function TableRow(props){_classCallCheck(this,TableRow);var _this=_possibleConstructorReturn(this,(TableRow.__proto__||Object.getPrototypeOf(TableRow)).call(this,props));_this.handleClick=function(){var _this$state=_this.state,item=_this$state.item,bgColor=_this$state.bgColor,selected=_this$state.selected,color=_this$state.color;selected=!selected?true:false;bgColor=selected?'#294C77':'#FFFFFF';color=selected?'#FFFFFF':'';_this.setState({bgColor:bgColor,selected:selected,color:color});_this.props.onClick(item);};_this.handleOver=function(){if(_this.state.pointer){var _this$state2=_this.state,item=_this$state2.item,selected=_this$state2.selected,hover=_this$state2.hover;if(!hover&&item&&!selected){_this.setState({bgColor:'#F2F8FC',hover:true});}}};_this.handleOut=function(){if(_this.state.pointer){var _this$state3=_this.state,item=_this$state3.item,selected=_this$state3.selected,hover=_this$state3.hover;if(hover&&item&&!selected){_this.setState({bgColor:'#FFFFFF',hover:false});}}};_this.state={item:_this.props.item,hover:false,selected:_this.props.selected,bgColor:_this.props.selected?'#294C77':'#FFFFFF',color:_this.props.selected?'#FFFFFF':'',border:_this.props.border===false?false:true,pointer:_this.props.pointer===false?false:true};return _this;}_createClass(TableRow,[{key:'render',value:function render(){var _this2=this;var _state=this.state,bgColor=_state.bgColor,color=_state.color,border=_state.border,pointer=_state.pointer;var children=this.props.children;var childrenWithProps=__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children,function(child){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child,{handleClick:_this2.props.onClick?_this2.handleClick:null,color:color,border:border,pointer:pointer});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{onMouseOver:this.handleOver,onMouseOut:this.handleOut,style:{backgroundColor:bgColor}},childrenWithProps);}}]);return TableRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TableRow);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TableCell=function(_Component){_inherits(TableCell,_Component);function TableCell(props){_classCallCheck(this,TableCell);var _this=_possibleConstructorReturn(this,(TableCell.__proto__||Object.getPrototypeOf(TableCell)).call(this,props));_this.state={disabled:_this.props.disabled,width:_this.props.width,color:_this.props.color,background:_this.props.background?_this.props.background:'',maxWidth:_this.props.maxWidth,overflow:_this.props.maxWidth?'hidden':'',textAlign:_this.props.textAlign};return _this;}_createClass(TableCell,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.color!==this.state.color){this.setState({color:nextProps.color});}}},{key:'render',value:function render(){var _state=this.state,disabled=_state.disabled,width=_state.width,color=_state.color,background=_state.background,maxWidth=_state.maxWidth,overflow=_state.overflow,textAlign=_state.textAlign;var td=void 0;var hideOn=this.props.hideOn?this.props.hideOn:'';if(disabled){if(width)td=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:hideOn,style:{width:width,color:color,background:background,maxWidth:maxWidth,overflow:overflow,textAlign:textAlign}},this.props.children);else td=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:hideOn,style:{color:color,background:background,maxWidth:maxWidth,overflow:overflow,textAlign:textAlign}},this.props.children);}else{if(width)td=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:hideOn,style:{width:width,color:color,background:background,maxWidth:maxWidth,overflow:overflow,textAlign:textAlign},onClick:this.props.handleClick},this.props.children);else td=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:hideOn,style:{color:color,background:background,maxWidth:maxWidth,overflow:overflow,textAlign:textAlign},onClick:this.props.handleClick},this.props.children);}return td;}}]);return TableCell;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TableCell);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_notificationsActions__ = __webpack_require__(66);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PreloaderBase=function(_React$Component){_inherits(PreloaderBase,_React$Component);function PreloaderBase(props){_classCallCheck(this,PreloaderBase);var _this=_possibleConstructorReturn(this,(PreloaderBase.__proto__||Object.getPrototypeOf(PreloaderBase)).call(this,props));_this.state={shown:false};_this.killClick=_this.killClick.bind(_this);_this.handleBackdropClick=_this.handleBackdropClick.bind(_this);return _this;}_createClass(PreloaderBase,[{key:'componentDidMount',value:function componentDidMount(){/*setTimeout(function(){
      document.getElementById("close").click();
    }, 9000);*/}},{key:'killClick',value:function killClick(e){// hace clic en el contenido no debe cerrar el modal
e.stopPropagation();}},{key:'handleBackdropClick',value:function handleBackdropClick(){// Al hacer clic en el fondo, el usuario solicita que el modal se cierra.
// Señalar que el modal tiene nada que decir sobre si realmente se cierra. el propietario de la
// Modal posee el estado. esto sólo "pide" que se cierre.
this.props.onRequestClose();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-loader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'preloader pls-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'pl-circular',viewBox:'25 25 50 50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{className:'plc-path',cx:50,cy:50,r:20}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:"white",left:'calc(50% - 125px)',position:'absolute',top:'50%'}},'Este proceso puede tardar unos minutos'));}}]);return PreloaderBase;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Preloader2=function(_React$Component2){_inherits(Preloader2,_React$Component2);function Preloader2(props){_classCallCheck(this,Preloader2);var _this2=_possibleConstructorReturn(this,(Preloader2.__proto__||Object.getPrototypeOf(Preloader2)).call(this,props));_this2.state={shown:false};_this2.handleRenderLayer=_this2.handleRenderLayer.bind(_this2);_this2.handleClick=_this2.handleClick.bind(_this2);_this2.renderLayer=_this2.renderLayer.bind(_this2);return _this2;}_createClass(Preloader2,[{key:'componentDidUpdate',value:function componentDidUpdate(){this.handleRenderLayer();}},{key:'componentDidMount',value:function componentDidMount(){// Al añadir al cuerpo es más fácil que la gestión de la z-index de todo en la página.
// También es mejor para la accesibilidad y hace un broche de presión de apilamiento (ya que los componentes se apilarán
// Fin de montaje).
if(!document.getElementById("preloader")){this._target=document.createElement('div');this._target.setAttribute("id","preloader");document.body.appendChild(this._target);}else{this._target=document.getElementById("preloader");}this.handleRenderLayer();}},{key:'handleRenderLayer',value:function handleRenderLayer(){// Al llamar a este método en componentDidMount () y componentDidUpdate (), usted es efectivamente
// crear un "agujero de gusano" que canaliza cambios jerárquicos reacciona a través de un nodo DOM en una parte
// totalmente diferente de la página.
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(this.renderLayer(),this._target);}},{key:'handleClick',value:function handleClick(){this.props.clearNotification();}},{key:'renderLayer',value:function renderLayer(){if(!this.props.preloader){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PreloaderBase,null);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);}}]);return Preloader2;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){return{preloader:state.preloader,json_lang:state.json_lang};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{clearNotification:function clearNotification(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_notificationsActions__["c" /* clearNotification */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Preloader2));

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { searchQuery } from '../../../store/actions/clientActions';
var InputAutocomplete=function(_Component){_inherits(InputAutocomplete,_Component);function InputAutocomplete(){_classCallCheck(this,InputAutocomplete);return _possibleConstructorReturn(this,(InputAutocomplete.__proto__||Object.getPrototypeOf(InputAutocomplete)).apply(this,arguments));}_createClass(InputAutocomplete,[{key:'handleKeyInput',/*constructor(props){
		super(props);

	}*/value:function handleKeyInput(input){//this.props.searchQuery(input);
}},{key:'filterSearch',value:function filterSearch(input){}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Input"],{onKeyUp:function onKeyUp(e){return _this2.props.handleKeyInput(e);},placeholder:this.props.placeholder,value:this.props.query});}}]);return InputAutocomplete;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/*const mapStateToProps = (state) => {
	return {
		query: state.query,
	};
}
*/var mapDispatchToProps=function mapDispatchToProps(dispatch){return{//searchQuery: (input) => dispatch(searchQuery(input))
};};/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapDispatchToProps)(InputAutocomplete));

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_general__ = __webpack_require__(6);
var _this=this;/* harmony default export */ __webpack_exports__["a"] = ({branches:{properties:{isList:function isList(type){return(parseInt(type,10)&256)!==0;},isNumeric:function isNumeric(type){return(parseInt(type,10)&512)!==0;},isText:function isText(type){return(parseInt(type,10)&1024)!==0;},isOneOf:function isOneOf(){var types=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var type=arguments[1];return types.some(function($0){return(parseInt(type,10)&$0)!==0;});},getType:function getType(type){if(this.isList(type))return'list';if(this.isText(type))return'text';if(this.isNumeric(type))return'numeric';return'undefined';}}},orders:{status:{isService:function isService(status){return(status&__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["o" /* MASK_SERVICE_TYPE */])===__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["A" /* TYPE_SERVICES */];},inServiceInProgress:function inServiceInProgress(status){return(_this.isService(status)&__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["k" /* FLAG_WORKING */])===__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["k" /* FLAG_WORKING */];}}},payments:{have:{stripe:function stripe(){var payments=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return payments.some(function($0){return(parseInt($0.options||0,10)&__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["n" /* MASK_AGENT */])===__WEBPACK_IMPORTED_MODULE_0__constants_bitwiseOperations__["E" /* VALUE_TYPE_STRIPE */];});}}},account:{isOneOf:function isOneOf(){var types=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var type=arguments[1];return types.some(function($0){return $0===type;});},is:function is(accountType,type){return accountType===type;},isProvider:function isProvider(type){return type===__WEBPACK_IMPORTED_MODULE_1__constants_general__["a" /* ACCOUNT_TYPES */].provider;},isClient:function isClient(type){return type===__WEBPACK_IMPORTED_MODULE_1__constants_general__["a" /* ACCOUNT_TYPES */].client;}}});

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./branchCategories.js": 619,
	"./branchGeofences.js": 620,
	"./branchGoodProperties.js": 621,
	"./branchGoods.js": 622,
	"./branchGoodsOrder.js": 623,
	"./branchGroupGoods.js": 624,
	"./branchGroupProperties.js": 625,
	"./branchProperties.js": 626,
	"./categories.js": 627,
	"./clients.js": 628,
	"./goodProperties.js": 629,
	"./index.js": 64,
	"./ondemand.js": 135,
	"./properties.js": 630,
	"./providers.js": 631,
	"./reports.js": 632,
	"./scheduledTasks.js": 633
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 618;

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function(_ref){var axios=_ref.axios,mapQueryString=_ref.mapQueryString;return{index:function index(branch){var query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return axios.get("/branches/"+branch+"/categories"+mapQueryString(query));},update:function update(branch,body){return axios.patch("/branch-categories/"+branch,body);}};});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function(_ref){var axios=_ref.axios,mapQueryString=_ref.mapQueryString;return{company:function company(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return axios.get("/branch-geofences"+mapQueryString(query));}};});

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function(_ref){var axios=_ref.axios;return{/**
     * @description id is a branchGoodPropertyId
     * @param id
     * @param body
     * @returns Promise<Property, Error>
     */update:function update(id,body){return axios.patch("/branch-good-properties/"+id,body);}};});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function(_ref){var axios=_ref.axios,mapQueryString=_ref.mapQueryString;return{index:function index(branch){var query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return axios.get("/branches/"+branch+"/goods"+mapQueryString(query));},import:function _import(branch,file){return axios.post("/branches/"+branch+"/goods/import",file);}};});

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function(_ref){var axios=_ref.axios,mapQueryString=_ref.mapQueryString;return{index:function index(branch){var query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return axios.get("/branches/"+branch+"/branch-goods"+mapQueryString(query));}};});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function(_ref){var axios=_ref.axios,mapQueryString=_ref.mapQueryString;return{index:function index(branchGroup){var query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return axios.get("/branch-groups/"+branchGroup+"/goods"+mapQueryString(query));}};});

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function(_ref){var axios=_ref.axios,mapQueryString=_ref.mapQueryString;return{index:function index(group_id){var filters=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return axios.get("/branch-groups/"+group_id+"/properties"+mapQueryString(filters));},show:function show(group_id,property_id){var filters=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};return axios.get("/branch-groups/"+group_id+"/properties/"+property_id+mapQueryString(filters));},update:function update(group_id,property_id,body){return axios.patch("/branch-groups/"+group_id+"/properties/"+property_id,body);}};});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function(_ref){var axios=_ref.axios,mapQueryString=_ref.mapQueryString;return{index:function index(branch_id){var filters=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return axios.get("/branches/"+branch_id+"/branch-properties"+mapQueryString(filters));},// show: (branch_id, property_id, filters = {}) => axios.get(`/branches/${branch_id}/properties/${property_id}${mapQueryString(filters)}`),
/**
     *
     * @param branch_id
     * @param property_id
     * @param body
     * @description expected body: {
     *       base_price_e2: "integer",
     *       step_price_e2: "integer",
     *       quantity: "integer",
     *       available: "boolean"
     *   }
     */update:function update(branch_id,property_id,body){return axios.patch("/branches/"+branch_id+"/properties/"+property_id,body);},branchPropertyUpdate:function branchPropertyUpdate(branch_property_id,body){return axios.patch("/branch-properties/"+branch_property_id,body);}};});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function(_ref){var axios=_ref.axios;return{update:function update(id,body){return axios.patch("/categories/"+id,body);}};});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function(_ref){var axios=_ref.axios,mapQueryString=_ref.mapQueryString;return{index:function index(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return axios.get("/clients"+mapQueryString(query));}};});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function(_ref){var axios=_ref.axios;return{update:function update(good_id,property_id,body){return axios.patch("/goods/"+good_id+"/properties/"+property_id,body);}};});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function(_ref){var axios=_ref.axios;return{update:function update(id,body){return axios.patch("/properties/"+id,body);},delete:function _delete(id){return axios.delete("/properties/"+id);}};});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function(_ref){var axios=_ref.axios,mapQueryString=_ref.mapQueryString;return{index:function index(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return axios.get("/providers"+mapQueryString(query));}};});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function(_ref){var baseURL=_ref.baseURL,mapQueryString=_ref.mapQueryString;return{admins:function admins(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/admins'+mapQueryString(query);},coupons:function coupons(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/coupons'+mapQueryString(query);},availableCoupons:function availableCoupons(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/coupons/available'+mapQueryString(query);},usedCoupons:function usedCoupons(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/coupons/used'+mapQueryString(query);},couponInvestments:function couponInvestments(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/coupon-investments'+mapQueryString(query);},branchGoods:function branchGoods(branch){var query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return baseURL+'/reports/branches/'+branch+'/goods'+mapQueryString(query);},branches:function branches(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/branches'+mapQueryString(query);},branchSales:function branchSales(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/branch-sales'+mapQueryString(query);},clientOrders:function clientOrders(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/client-orders'+mapQueryString(query);},userWithBalance:function userWithBalance(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/client-balance'+mapQueryString(query);},goods:function goods(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/goods'+mapQueryString(query);},orderedGoods:function orderedGoods(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/ordered-goods'+mapQueryString(query);},providerDetailedEarnings:function providerDetailedEarnings(){var provider=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return baseURL+'/reports/provider-detailed-earnings'+(provider?'/'+provider:'')+mapQueryString(query);},providerEarnings:function providerEarnings(){var provider=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return baseURL+'/reports/provider-earnings'+(provider?'/'+provider:'')+mapQueryString(query);},providerPaidInvoices:function providerPaidInvoices(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/provider-paid-invoices'+mapQueryString(query);},branchOrders:function branchOrders(){var branch=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return baseURL+'/reports/branch-orders'+(branch?'/'+branch:'')+mapQueryString(query);},companyOrders:function companyOrders(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/company-orders'+mapQueryString(query);},companyOrdersRevenue:function companyOrdersRevenue(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/company-orders-revenue'+mapQueryString(query);},companyOrdersRatings:function companyOrdersRatings(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/company-order-ratings'+mapQueryString(query);},companyAccesses:function companyAccesses(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/company-accesses'+mapQueryString(query);},branchAgreements:function branchAgreements(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/branch-agreements'+mapQueryString(query);},branchInvoices:function branchInvoices(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/branch-invoices'+mapQueryString(query);},branchPaidInvoices:function branchPaidInvoices(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/branch-paid-invoices'+mapQueryString(query);},branchInvoicesEarnings:function branchInvoicesEarnings(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/branch-invoice-earnings'+mapQueryString(query);},providersInvoices:function providersInvoices(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/provider-invoices'+mapQueryString(query);},clients:function clients(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/clients'+mapQueryString(query);},clientsSlim:function clientsSlim(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/clients-slim'+mapQueryString(query);},clientsSlimAll:function clientsSlimAll(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/clients-slim/all'+mapQueryString(query);},clientsSlimEmail:function clientsSlimEmail(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/clients-slim/login'+mapQueryString(query);},downloadSoldoutGoods:function downloadSoldoutGoods(branch){var query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return baseURL+'/branches/'+branch+'/download-soldout-goods'+mapQueryString(query);},//websiteReport: (query = {}) => `https://liveri.com.ve/getExcel${mapQueryString(query)}`,
promos:function promos(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/promos'+mapQueryString(query);},businessMovements:function businessMovements(){var branch=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return baseURL+'/reports/branches/'+branch+'/business-movements'+mapQueryString(query);},paymentDetails:function paymentDetails(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/payment-details'+mapQueryString(query);},companySales:function companySales(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/company-sales'+mapQueryString(query);},providerOnline:function providerOnline(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/provider-online'+mapQueryString(query);},providerBalance:function providerBalance(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/provider-balance'+mapQueryString(query);},clientMovements:function clientMovements(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/client-movements'+mapQueryString(query);},clientPaidInvoices:function clientPaidInvoices(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/client-paid-invoices'+mapQueryString(query);},citySummary:function citySummary(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/city-summary'+mapQueryString(query);},bancamigaReport:function bancamigaReport(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/bancamiga-report'+mapQueryString(query);},cityMovements:function cityMovements(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/city-movements'+mapQueryString(query);},branchGroupSaleDetails:function branchGroupSaleDetails(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/branch-sale-details'+mapQueryString(query);},providerStatus:function providerStatus(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/provider-status'+mapQueryString(query);},balanceModifiers:function balanceModifiers(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return baseURL+'/reports/balance-modifiers'+mapQueryString(query);},providerFees:function providerFees(){var branch=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var query=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return baseURL+'/reports/branches/'+branch+'/provider-fees'+mapQueryString(query);}};});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function(_ref){var axios=_ref.axios,mapQueryString=_ref.mapQueryString;return{index:function index(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return axios.get("/scheduled-tasks"+mapQueryString(query));},abort:function abort(id){return axios.post("/scheduled-tasks/"+id+"/abort");},send:function send(body){return axios.post("send-broadcast-message",body);}};});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_datetime_picker__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_datetime_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rc_datetime_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Plugins_MainModals_ModalBase__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ModalReport__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Plugins_SpecialForm__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { apiReport } from '../../store/actions/companyActions';
//import store from '../../store/store';
var hasBranch=function hasBranch(branch){return branch&&branch.id;};var ReportItemRow=function(_Component){_inherits(ReportItemRow,_Component);function ReportItemRow(props){_classCallCheck(this,ReportItemRow);var _this=_possibleConstructorReturn(this,(ReportItemRow.__proto__||Object.getPrototypeOf(ReportItemRow)).call(this,props));_this.handleSetStart=function(start){_this.setState(function(prevState){return{start:start,query:Object.assign({},prevState.query,{date_from:start.format('YYYY-MM-DD')+' 00:00:00'})};});};_this.handleSetEnd=function(end){_this.setState(function(prevState){return{end:end,query:Object.assign({},prevState.query,{date_to:end.add('minute').format('YYYY-MM-DD')+' 23:59:59'})};});};_this.prefetch=function(event,endpoint,p){event.persist();event.preventDefault();_this.toggleLoading();console.log('endpoint',endpoint);__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(endpoint).then(function(res){console.log("res prefetch",res);var a=document.createElement("a");var extension=res.headers['content-type'].split(";")[0];//asi se usaba antes
// a.href = URL.createObjectURL(new Blob([res.data], { type: this.getExtension(res.headers['content-type'])  }));
// a.download = `${this.props.company.name} ${this.props.title}.${this.getExtension(res.headers['content-type'])}`;
a.href=URL.createObjectURL(new Blob([res.data],{type:_this.getExtension(extension)}));a.download=_this.props.company.name+' '+_this.props.title+'.'+_this.getExtension(extension);a.click();}).catch(function(err){var errorCode=err&&err.response&&err.response.data&&err.response.data.error_code||"ER000";var errorMessage=err&&err.response&&err.response.data&&err.response.data.description||"Algo salio mal, por favor intente nuevamente";switch(errorCode){case"ER023":_this.props.notification.show({type:"error",title:'Error '+errorCode,msg:"No existen resultados para los parametros seleccionados"});break;default:_this.props.notification.show({type:"error",title:'Error '+errorCode,msg:errorMessage});break;}}).finally(function(){return _this.toggleLoading();});};_this.getExtension=function(header){var type=header.split('/').pop();var map={'vnd.openxmlformats-officedocument.spreadsheetml.sheet':'xlsx'};return map[type]||type;};_this.toggleLoading=function(){_this.setState(function(prevState){return{loading:!prevState.loading};});};_this.setBranch=function(_ref){var name=_ref.name,value=_ref.value;_this.setState(function(prevState){return{query:Object.assign({},prevState.query,_defineProperty({},name,value))};});setTimeout(function(){_this.props.logBranchSelection(_this.state);},1);};_this.setUserEntity=function(name,value){if(name==='branch_id'||name==='branch_group_id'?name:name&&value){_this.setState(function(prevState){return{query:Object.assign({},prevState.query,_defineProperty({},name,value))};});}};_this.isValidDateRange=function(_ref2){var end=_ref2.end,start=_ref2.start;var _this$props=_this.props,withDates=_this$props.withDates,maxDateRange=_this$props.maxDateRange;if(withDates||maxDateRange){if(!end||!start){return false;}return __WEBPACK_IMPORTED_MODULE_1_moment___default()(end.format('YYYY-MM-DD')).isSameOrAfter(start.format('YYYY-MM-DD'),'day');}return true;};_this.isGenerateButtonEnabled=function(dates,query,_ref3){var withBranches=_ref3.withBranches,withBranchGroups=_ref3.withBranchGroups,withClients=_ref3.withClients,withProviders=_ref3.withProviders,forceCity=_ref3.forceCity;var rules=[_this.isValidDateRange(dates)];if(withBranches){rules.push(query.branch_id);}if(withBranchGroups){rules.push(query.branch_group_id);}if(withClients){rules.push(query.client_id);}if(withProviders){rules.push(query.provider_id);}if(forceCity){if(_this.props.cityId){rules.push(_this.props.cityId);}else{rules.push(query.city_id);}}return rules.every(function($0){return $0;});};_this.buildQueryString=function(query,_ref4){var withDates=_ref4.withDates,withBranches=_ref4.withBranches,withBranchGroups=_ref4.withBranchGroups,branchAsParameter=_ref4.branchAsParameter,branchGroupAsParameter=_ref4.branchGroupAsParameter,withClients=_ref4.withClients,appendingQueryString=_ref4.appendingQueryString,withProviders=_ref4.withProviders,withoutToken=_ref4.withoutToken,autoBranch=_ref4.autoBranch,autoBranchGroup=_ref4.autoBranchGroup,branch=_ref4.branch,withoutTimezone=_ref4.withoutTimezone,withTimezone=_ref4.withTimezone,forceCity=_ref4.forceCity,cityId=_ref4.cityId;var object=Object.assign({},query);_this.props.logQueryBuildStart(object);if(!withDates){delete object.date_from;delete object.date_to;if(!withTimezone){delete object.tz;}}if(withoutTimezone||!withDates){if(!withTimezone){delete object.tz;}}if(!withBranches||branchAsParameter){delete object.branch_id;}if(!withBranchGroups||branchGroupAsParameter){delete object.branch_group_id;}if(!withClients){delete object.client_id;}if(!withProviders){delete object.provider_id;}if(withoutToken){delete object.token;}if(!withoutToken){object.token=localStorage.getItem('token');}if(autoBranch&&branch&&branch.id&&!branchAsParameter){object.branch_id=branch.id;_this.props.logQueryBuildAutoBranch({branch:branch,query:object});}if(autoBranchGroup&&branch&&branch.branch_group_id){object.branch_group_id=branch.branch_group_id;_this.props.logQueryBuildAutoBranchGroup({branch:branch,query:object});}if(forceCity){if(cityId){object.city_id=cityId;}}_this.props.logQueryBuildEnd(object);return Object(__WEBPACK_IMPORTED_MODULE_2__api__["mapQueryString"])(object,appendingQueryString);};_this.buildURL=function(dates,query){var url=_this.props.url;if(_this.isValidDateRange(dates)){if(typeof url==='function'){return''+url({query:query})+_this.buildQueryString(query,_this.props);}return''+url+_this.buildQueryString(query,_this.props);}return'#';};_this.buildTitle=function(){var title=_this.props.title;if(typeof title==='function'){return title(_this.state.query);}return title;};_this.open_modal=function(id,modal){_this.setState(_defineProperty({},modal,id));_this.refs[modal].toggleModal();};_this.render=function(){var shortcuts={Today:__WEBPACK_IMPORTED_MODULE_1_moment___default()(),Yesterday:__WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(1,'days'),Clear:__WEBPACK_IMPORTED_MODULE_1_moment___default()()};var _this$props2=_this.props,activateModal=_this$props2.activateModal,withDates=_this$props2.withDates,buttonText=_this$props2.buttonText,loadingText=_this$props2.loadingText,withBranches=_this$props2.withBranches,branches=_this$props2.branches,withClients=_this$props2.withClients,withCityFilter=_this$props2.withCityFilter,forceCity=_this$props2.forceCity,clients=_this$props2.clients,providers=_this$props2.providers,withProviders=_this$props2.withProviders,withoutPrefetch=_this$props2.withoutPrefetch,maxDateRange=_this$props2.maxDateRange,withBranchGroups=_this$props2.withBranchGroups,withFile=_this$props2.withFile,_this$state=_this.state,start=_this$state.start,end=_this$state.end,query=_this$state.query,loading=_this$state.loading;var cityLabel=_this.props.loadingText;if(forceCity&&_this.props.cityId&&_this.props.companyCities.length>0){cityLabel=_this.props.companyCities.find(function(city){return city.id===_this.props.cityId;}).name;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Label"],{className:'text-left',style:{width:'100%'}},_this.buildTitle()),withBranches&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Plugins_SpecialForm__["d" /* SearchBranchSelect */],{change:function change(e){return _this.setUserEntity('branch_id',e[0]&&e[0].id);},clear:function clear(){return _this.setUserEntity('branch_id',undefined&&undefined);},fromReports:_this.props.withAllBranches?false:true}),withBranchGroups&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Plugins_SpecialForm__["c" /* SearchBranchGroupsSelect */],{change:function change(e){return _this.setUserEntity('branch_group_id',e[0]&&e[0].id);},clear:function clear(){return _this.setUserEntity('branch_group_id',undefined&&undefined);},dontClearInput:true,fromReports:_this.props.withAllBranches?true:false}),withClients&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Plugins_SpecialForm__["e" /* SearchClient */],{change:function change(e){return _this.setUserEntity('client_id',e[0]&&e[0].id);}}),withProviders&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Plugins_SpecialForm__["g" /* SearchProvider */],{change:function change(e){return _this.setUserEntity('provider_id',e[0]&&e[0].id);}}),withCityFilter&&(forceCity&&_this.props.cityId?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,cityLabel):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Label"],{className:'text-muted text-left',style:{width:'100%'}},'Ciudad'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Plugins_SpecialForm__["h" /* SelectNormal */],{className:'mb-4',disabled:_this.props.companyCities.length===0,name:"city_select",text_init:_this.props.companyCities.length===0?_this.props.loadingText:forceCity?"Seleccione una ciudad":'Todas',refs:"city_select",options:_this.props.companyCities.map(function(city){return{name:city.name,id:city.id};}),val:_this.state[_this.props.title]?_this.state[_this.props.title]:'',onchange:function onchange(e){return _this.onCityChange(e.target);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-left'},withDates&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Label"],{className:'text-muted text-left',style:{width:'100%'}},'Desde'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_rc_datetime_picker__["DatetimePickerTrigger"],{shortcuts:shortcuts,moment:start||__WEBPACK_IMPORTED_MODULE_1_moment___default()(),minDate:maxDateRange?end?__WEBPACK_IMPORTED_MODULE_1_moment___default()(end).subtract(maxDateRange.time,maxDateRange.count):null:null,showTimePicker:false,onChange:_this.handleSetStart},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Input"],{type:'text',value:start?start.format('YYYY-MM-DD'):'Seleccione',readOnly:true})))),start?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-left'},withDates&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Label"],{className:'text-muted text-left',style:{width:'100%'}},'Hasta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_rc_datetime_picker__["DatetimePickerTrigger"],{shortcuts:shortcuts,minDate:start,maxDate:maxDateRange?start?__WEBPACK_IMPORTED_MODULE_1_moment___default()(start).add(maxDateRange.time,maxDateRange.count):null:null,moment:end||__WEBPACK_IMPORTED_MODULE_1_moment___default()(),showTimePicker:false,onChange:_this.handleSetEnd},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Input"],{type:'text',value:end?end.format('YYYY-MM-DD'):'Seleccione',readOnly:true})))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,activateModal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:_this.props.withAllBranches?false:_this.isGenerateButtonEnabled({start:start,end:end},query,_this.props)?false:true,className:["btn btn-primary pull-right"].join(' ')// onClick={()=> console.log(this.refs) }>
,onClick:function onClick(){return _this.refs['report'].toggleModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-file-pdf-o'}),' ',loading?loadingText:buttonText)/*<a
                        href={this.buildURL({ start, end }, query)}
                        target="_blank"
                        onClick={(e) => {
                            this.refs[`report`].toggleModal();
                            if (!withoutPrefetch) {
                                this.prefetch(e, this.buildURL({ start, end }, query))
                            }
                        }}
                        className={[
                            "btn btn-primary pull-right",
                            this.isGenerateButtonEnabled({ start, end }, query, this.props) ? '' : 'disabled'
                        ].join(' ')}
                        download>
                        <i className="fa fa-file-pdf-o" /> { loading ? loadingText : buttonText }
                    </a>*/:withFile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'btn btn-primary pull-right mx-2 mt-2',htmlFor:'file'},_this.state.uploading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:"relative",width:"50px",height:"20px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'preloader pls-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'pl-circular',viewBox:'25 25 50 50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{className:'plc-path',cx:50,cy:50,r:20})))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-upload mr-2'}),'Subir'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',className:'d-none',id:'file',accept:'.xlsx, .xlsm, .xltx, .xltm, .xls, .xlt, .ods, .ots, .slk, .xml, .gnumeric, .htm, .html, .csv, .tsv, .txt',onChange:function onChange(event){return _this.prepareUpload(event);}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{//href={this.buildURL({ start, end }, query)}
//target="_blank"
disabled:_this.props.withAllBranches?false:_this.isGenerateButtonEnabled({start:start,end:end},query,_this.props)?false:true,onClick:function onClick(e){if(!withoutPrefetch){_this.prefetch(e,_this.buildURL({start:start,end:end},query,_this.prop));}},className:["btn btn-primary pull-right"].join(' '),download:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-file-pdf-o'}),' ',loading?loadingText:buttonText)),activateModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Plugins_MainModals_ModalBase__["a" /* default */],{ref:'report'//confirmFunc={() => this.props.update(this.props.admin)}
,title:_this.buildTitle(),html:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ModalReport__["a" /* default */],{tittle:_this.buildTitle(),urlReport:_this.buildURL({start:start,end:end},query)})}));};_this.state={// start: moment().subtract(1, 'months'),
start:props.maxDateRange?undefined:__WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(1,'months'),end:props.maxDateRange?undefined:__WEBPACK_IMPORTED_MODULE_1_moment___default()(),query:{date_from:__WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(1,'months').format('YYYY-MM-DD')+' 00:00:00',date_to:__WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD')+' 23:59:59',token:localStorage.getItem('token'),branch_id:props.autoBranch&&props.branch?props.branch.id:undefined,branch_group_id:props.autoBranchGroup&&props.branch?props.branch.branch_group_id:undefined,client_id:undefined,provider_id:undefined,tz:props.company.time_zone_offset},loading:false,isLoading:false,selected:null,uploading:false};return _this;}_createClass(ReportItemRow,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this2=this;if(this.props.autoBranch&&this.props.branch.id!==prevProps.branch.id){this.setState(function(prevState){return{query:Object.assign({},prevState.query,{branch_id:_this2.props.branch.id})};});}if(this.props.autoBranchGroup&&this.props.branch.branch_group_id!==prevProps.branch.branch_group_id){this.setState(function(prevState){return{query:Object.assign({},prevState.query,{branch_group_id:_this2.props.branch.branch_group_id})};});}}},{key:'SearchAction',value:function SearchAction(query){this.getAllClients(1,query);}},{key:'onCityChange',value:function onCityChange(event){var _this3=this;this.setState(function(prevState){var _ref5;return _ref5={},_defineProperty(_ref5,_this3.props.title,event.value),_defineProperty(_ref5,'query',Object.assign({},prevState.query,{city_id:event.value})),_ref5;});}},{key:'prepareUpload',value:function prepareUpload(_ref6){var _this4=this;var target=_ref6.target;this.setState({uploading:true});var data=new FormData();data.append('file',target.files[0]);__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_10__config__["c" /* URL */]+this.props.company.id+'/bancamiga-report',data).then(function(){_this4.setState({uploading:false});_this4.props.notification.show({type:"success",title:"¡Éxito!",msg:"Archivo subido con éxito. En breves estará disponible en su correo electrónico"});}).catch(function(err){_this4.setState({uploading:false});if(err.message&&err.message!=='generic')_this4.props.notification.show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:err.message});else{_this4.props.notification.show({type:"error",title:'Error '+(err&&err.data&&err.data.error_code),msg:"Error al subir el archivo, por favor intente nuevamente"});}});}}]);return ReportItemRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ReportItemRow.defaultProps={title:'',withDates:false,withBranches:false,branchAsParameter:false,withClients:false,withoutPrefetch:false,withoutToken:false,withoutTimezone:false,withProviders:false,appendingQueryString:false,url:'',buttonText:'Generar',loadingText:'Cargando...',autoBranch:false,maxDateRange:undefined,logQueryBuildStart:function logQueryBuildStart(){},logQueryBuildEnd:function logQueryBuildEnd(){},logQueryBuildAutoBranch:function logQueryBuildAutoBranch(){},logQueryBuildAutoBranchGroup:function logQueryBuildAutoBranchGroup(){},logBranchSelection:function logBranchSelection(){}/*if(clients && clients.data){
    console.log("clients",clients.data.filter(client => (parseInt(client.account.status, 10) & 255) === 240))
}*/};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(function(_ref7){var branches=_ref7.branches,branch=_ref7.branch,allClients=_ref7.allClients,company=_ref7.company,providers=_ref7.providers,companyCities=_ref7.companyCities;return{branches:branches,branch:branch,company:company,companyCities:companyCities,clients:allClients&&allClients.data?allClients.data.filter(function(client){return(parseInt(client.account.status,10)&255)===240;}):[],// TODO: translate this bitwise operation into a helper function
providers:providers&&providers.data?providers.data.filter(function(provider){return(parseInt(provider.account.status,10)&255)===240;}):[],// TODO: translate this bitwise operation into a helper function
hasBranch:hasBranch(branch)};})(Object(__WEBPACK_IMPORTED_MODULE_2__api__["withApiService"])(ReportItemRow)));

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(this && this[key] || key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports = function blacklist (src) {
  var copy = {}
  var filter = arguments[1]

  if (typeof filter === 'string') {
    filter = {}
    for (var i = 1; i < arguments.length; i++) {
      filter[arguments[i]] = true
    }
  }

  for (var key in src) {
    // blacklist?
    if (filter[key]) continue

    copy[key] = src[key]
  }

  return copy
}


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0),__webpack_require__(1),__webpack_require__(638)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory(require('react'),require('prop-types'),require('create-react-class'));
  } else {
    root.ReactSlider = factory(root.React,root.PropTypes,root.createReactClass);
  }
}(this, function (React, PropTypes, createReactClass) {

  /**
   * To prevent text selection while dragging.
   * http://stackoverflow.com/questions/5429827/how-can-i-prevent-text-element-selection-with-cursor-drag
   */
  function pauseEvent(e) {
    if (e.stopPropagation) e.stopPropagation();
    if (e.preventDefault) e.preventDefault();
    return false;
  }

  function stopPropagation(e) {
    if (e.stopPropagation) e.stopPropagation();
  }

  /**
   * Spreads `count` values equally between `min` and `max`.
   */
  function linspace(min, max, count) {
    var range = (max - min) / (count - 1);
    var res = [];
    for (var i = 0; i < count; i++) {
      res.push(min + range * i);
    }
    return res;
  }

  function ensureArray(x) {
    return x == null ? [] : Array.isArray(x) ? x : [x];
  }

  function undoEnsureArray(x) {
    return x != null && x.length === 1 ? x[0] : x;
  }

  // undoEnsureArray(ensureArray(x)) === x

  var ReactSlider = createReactClass({
    displayName: 'ReactSlider',

    propTypes: {

      /**
       * The minimum value of the slider.
       */
      min: PropTypes.number,

      /**
       * The maximum value of the slider.
       */
      max: PropTypes.number,

      /**
       * Value to be added or subtracted on each step the slider makes.
       * Must be greater than zero.
       * `max - min` should be evenly divisible by the step value.
       */
      step: PropTypes.number,

      /**
       * The minimal distance between any pair of handles.
       * Must be positive, but zero means they can sit on top of each other.
       */
      minDistance: PropTypes.number,

      /**
       * Determines the initial positions of the handles and the number of handles if the component has no children.
       *
       * If a number is passed a slider with one handle will be rendered.
       * If an array is passed each value will determine the position of one handle.
       * The values in the array must be sorted.
       * If the component has children, the length of the array must match the number of children.
       */
      defaultValue: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.arrayOf(PropTypes.number)
      ]),

      /**
       * Like `defaultValue` but for [controlled components](http://facebook.github.io/react/docs/forms.html#controlled-components).
       */
      value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.arrayOf(PropTypes.number)
      ]),

      /**
       * Determines whether the slider moves horizontally (from left to right) or vertically (from top to bottom).
       */
      orientation: PropTypes.oneOf(['horizontal', 'vertical']),

      /**
       * The css class set on the slider node.
       */
      className: PropTypes.string,

      /**
       * The css class set on each handle node.
       *
       * In addition each handle will receive a numbered css class of the form `${handleClassName}-${i}`,
       * e.g. `handle-0`, `handle-1`, ...
       */
      handleClassName: PropTypes.string,

      /**
       * The css class set on the handle that is currently being moved.
       */
      handleActiveClassName: PropTypes.string,

      /**
       * If `true` bars between the handles will be rendered.
       */
      withBars: PropTypes.bool,

      /**
       * The css class set on the bars between the handles.
       * In addition bar fragment will receive a numbered css class of the form `${barClassName}-${i}`,
       * e.g. `bar-0`, `bar-1`, ...
       */
      barClassName: PropTypes.string,

      /**
       * If `true` the active handle will push other handles
       * within the constraints of `min`, `max`, `step` and `minDistance`.
       */
      pearling: PropTypes.bool,

      /**
       * If `true` the handles can't be moved.
       */
      disabled: PropTypes.bool,

      /**
       * Disables handle move when clicking the slider bar
       */
      snapDragDisabled: PropTypes.bool,

      /**
       * Inverts the slider.
       */
      invert: PropTypes.bool,

      /**
       * Callback called before starting to move a handle.
       */
      onBeforeChange: PropTypes.func,

      /**
       * Callback called on every value change.
       */
      onChange: PropTypes.func,

      /**
       * Callback called only after moving a handle has ended.
       */
      onAfterChange: PropTypes.func,

      /**
       *  Callback called when the the slider is clicked (handle or bars).
       *  Receives the value at the clicked position as argument.
       */
      onSliderClick: PropTypes.func
    },

    getDefaultProps: function () {
      return {
        min: 0,
        max: 100,
        step: 1,
        minDistance: 0,
        defaultValue: 0,
        orientation: 'horizontal',
        className: 'slider',
        handleClassName: 'handle',
        handleActiveClassName: 'active',
        barClassName: 'bar',
        withBars: false,
        pearling: false,
        disabled: false,
        snapDragDisabled: false,
        invert: false
      };
    },

    getInitialState: function () {
      var value = this._or(ensureArray(this.props.value), ensureArray(this.props.defaultValue));

      // reused throughout the component to store results of iterations over `value`
      this.tempArray = value.slice();

      // array for storing resize timeouts ids
      this.pendingResizeTimeouts = [];

      var zIndices = [];
      for (var i = 0; i < value.length; i++) {
        value[i] = this._trimAlignValue(value[i], this.props);
        zIndices.push(i);
      }

      return {
        index: -1,
        upperBound: 0,
        sliderLength: 0,
        value: value,
        zIndices: zIndices
      };
    },

    // Keep the internal `value` consistent with an outside `value` if present.
    // This basically allows the slider to be a controlled component.
    componentWillReceiveProps: function (newProps) {
      var value = this._or(ensureArray(newProps.value), this.state.value);

      // ensure the array keeps the same size as `value`
      this.tempArray = value.slice();

      for (var i = 0; i < value.length; i++) {
        this.state.value[i] = this._trimAlignValue(value[i], newProps);
      }
      if (this.state.value.length > value.length)
        this.state.value.length = value.length;

      // If an upperBound has not yet been determined (due to the component being hidden
      // during the mount event, or during the last resize), then calculate it now
      if (this.state.upperBound === 0) {
        this._handleResize();
      }
    },

    // Check if the arity of `value` or `defaultValue` matches the number of children (= number of custom handles).
    // If no custom handles are provided, just returns `value` if present and `defaultValue` otherwise.
    // If custom handles are present but neither `value` nor `defaultValue` are applicable the handles are spread out
    // equally.
    // TODO: better name? better solution?
    _or: function (value, defaultValue) {
      var count = React.Children.count(this.props.children);
      switch (count) {
        case 0:
          return value.length > 0 ? value : defaultValue;
        case value.length:
          return value;
        case defaultValue.length:
          return defaultValue;
        default:
          if (value.length !== count || defaultValue.length !== count) {
            console.warn(this.constructor.displayName + ": Number of values does not match number of children.");
          }
          return linspace(this.props.min, this.props.max, count);
      }
    },

    componentDidMount: function () {
      window.addEventListener('resize', this._handleResize);
      this._handleResize();
    },

    componentWillUnmount: function () {
      this._clearPendingResizeTimeouts();
      window.removeEventListener('resize', this._handleResize);
    },

    getValue: function () {
      return undoEnsureArray(this.state.value);
    },

    _handleResize: function () {
      // setTimeout of 0 gives element enough time to have assumed its new size if it is being resized
      var resizeTimeout = window.setTimeout(function() {
        // drop this timeout from pendingResizeTimeouts to reduce memory usage
        this.pendingResizeTimeouts.shift();

        var slider = this.refs.slider;
        var handle = this.refs.handle0;
        var rect = slider.getBoundingClientRect();

        var size = this._sizeKey();

        var sliderMax = rect[this._posMaxKey()];
        var sliderMin = rect[this._posMinKey()];

        this.setState({
          upperBound: slider[size] - handle[size],
          sliderLength: Math.abs(sliderMax - sliderMin),
          handleSize: handle[size],
          sliderStart: this.props.invert ? sliderMax : sliderMin
        });
      }.bind(this), 0);

      this.pendingResizeTimeouts.push(resizeTimeout);
    },

    // clear all pending timeouts to avoid error messages after unmounting
    _clearPendingResizeTimeouts: function() {
      do {
        var nextTimeout = this.pendingResizeTimeouts.shift();

        clearTimeout(nextTimeout);
      } while (this.pendingResizeTimeouts.length);
    },

    // calculates the offset of a handle in pixels based on its value.
    _calcOffset: function (value) {
      var range = this.props.max - this.props.min;
      if (range === 0) {
        return 0;
      }
      var ratio = (value - this.props.min) / range;
      return ratio * this.state.upperBound;
    },

    // calculates the value corresponding to a given pixel offset, i.e. the inverse of `_calcOffset`.
    _calcValue: function (offset) {
      var ratio = offset / this.state.upperBound;
      return ratio * (this.props.max - this.props.min) + this.props.min;
    },

    _buildHandleStyle: function (offset, i) {
      var style = {
        position: 'absolute',
        willChange: this.state.index >= 0 ? this._posMinKey() : '',
        zIndex: this.state.zIndices.indexOf(i) + 1
      };
      style[this._posMinKey()] = offset + 'px';
      return style;
    },

    _buildBarStyle: function (min, max) {
      var obj = {
        position: 'absolute',
        willChange: this.state.index >= 0 ? this._posMinKey() + ',' + this._posMaxKey() : ''
      };
      obj[this._posMinKey()] = min;
      obj[this._posMaxKey()] = max;
      return obj;
    },

    _getClosestIndex: function (pixelOffset) {
      var minDist = Number.MAX_VALUE;
      var closestIndex = -1;

      var value = this.state.value;
      var l = value.length;

      for (var i = 0; i < l; i++) {
        var offset = this._calcOffset(value[i]);
        var dist = Math.abs(pixelOffset - offset);
        if (dist < minDist) {
          minDist = dist;
          closestIndex = i;
        }
      }

      return closestIndex;
    },

    _calcOffsetFromPosition: function (position) {
      var pixelOffset = position - this.state.sliderStart;
      if (this.props.invert) pixelOffset = this.state.sliderLength - pixelOffset;
      pixelOffset -= (this.state.handleSize / 2);
      return pixelOffset;
    },

    // Snaps the nearest handle to the value corresponding to `position` and calls `callback` with that handle's index.
    _forceValueFromPosition: function (position, callback) {
      var pixelOffset = this._calcOffsetFromPosition(position);
      var closestIndex = this._getClosestIndex(pixelOffset);
      var nextValue = this._trimAlignValue(this._calcValue(pixelOffset));

      var value = this.state.value.slice(); // Clone this.state.value since we'll modify it temporarily
      value[closestIndex] = nextValue;

      // Prevents the slider from shrinking below `props.minDistance`
      for (var i = 0; i < value.length - 1; i += 1) {
        if (value[i + 1] - value[i] < this.props.minDistance) return;
      }

      this.setState({value: value}, callback.bind(this, closestIndex));
    },

    _getMousePosition: function (e) {
      return [
        e['page' + this._axisKey()],
        e['page' + this._orthogonalAxisKey()]
      ];
    },

    _getTouchPosition: function (e) {
      var touch = e.touches[0];
      return [
        touch['page' + this._axisKey()],
        touch['page' + this._orthogonalAxisKey()]
      ];
    },

    _getKeyDownEventMap: function () {
      return {
        'keydown': this._onKeyDown,
        'focusout': this._onBlur
      }
    },

    _getMouseEventMap: function () {
      return {
        'mousemove': this._onMouseMove,
        'mouseup': this._onMouseUp
      }
    },

    _getTouchEventMap: function () {
      return {
        'touchmove': this._onTouchMove,
        'touchend': this._onTouchEnd
      }
    },

    // create the `keydown` handler for the i-th handle
    _createOnKeyDown: function (i) {
      return function (e) {
        if (this.props.disabled) return;
        this._start(i);
        this._addHandlers(this._getKeyDownEventMap());
        pauseEvent(e);
      }.bind(this);
    },

    // create the `mousedown` handler for the i-th handle
    _createOnMouseDown: function (i) {
      return function (e) {
        if (this.props.disabled) return;
        var position = this._getMousePosition(e);
        this._start(i, position[0]);
        this._addHandlers(this._getMouseEventMap());
        pauseEvent(e);
      }.bind(this);
    },

    // create the `touchstart` handler for the i-th handle
    _createOnTouchStart: function (i) {
      return function (e) {
        if (this.props.disabled || e.touches.length > 1) return;
        var position = this._getTouchPosition(e);
        this.startPosition = position;
        this.isScrolling = undefined; // don't know yet if the user is trying to scroll
        this._start(i, position[0]);
        this._addHandlers(this._getTouchEventMap());
        stopPropagation(e);
      }.bind(this);
    },

    _addHandlers: function (eventMap) {
      for (var key in eventMap) {
        document.addEventListener(key, eventMap[key], false);
      }
    },

    _removeHandlers: function (eventMap) {
      for (var key in eventMap) {
        document.removeEventListener(key, eventMap[key], false);
      }
    },

    _start: function (i, position) {
      var activeEl = document.activeElement;
      var handleRef = this.refs['handle' + i];
      // if activeElement is body window will lost focus in IE9
      if (activeEl && activeEl != document.body && activeEl != handleRef) {
        activeEl.blur && activeEl.blur();
      }

      this.hasMoved = false;

      this._fireChangeEvent('onBeforeChange');

      var zIndices = this.state.zIndices;
      zIndices.splice(zIndices.indexOf(i), 1); // remove wherever the element is
      zIndices.push(i); // add to end

      this.setState({
        startValue: this.state.value[i],
        startPosition: position,
        index: i,
        zIndices: zIndices
      });
    },

    _onMouseUp: function () {
      this._onEnd(this._getMouseEventMap());
    },

    _onTouchEnd: function () {
      this._onEnd(this._getTouchEventMap());
    },

    _onBlur: function () {
      this._onEnd(this._getKeyDownEventMap());
    },

    _onEnd: function (eventMap) {
      this._removeHandlers(eventMap);
      this.setState({index: -1}, this._fireChangeEvent.bind(this, 'onAfterChange'));
    },

    _onMouseMove: function (e) {
      var position = this._getMousePosition(e);
      var diffPosition = this._getDiffPosition(position[0]);
      var newValue = this._getValueFromPosition(diffPosition);
      this._move(newValue);
    },

    _onTouchMove: function (e) {
      if (e.touches.length > 1) return;

      var position = this._getTouchPosition(e);

      if (typeof this.isScrolling === 'undefined') {
        var diffMainDir = position[0] - this.startPosition[0];
        var diffScrollDir = position[1] - this.startPosition[1];
        this.isScrolling = Math.abs(diffScrollDir) > Math.abs(diffMainDir);
      }

      if (this.isScrolling) {
        this.setState({index: -1});
        return;
      }

      pauseEvent(e);

      var diffPosition = this._getDiffPosition(position[0]);
      var newValue = this._getValueFromPosition(diffPosition);

      this._move(newValue);
    },

    _onKeyDown: function (e) {
      if (e.ctrlKey || e.shiftKey || e.altKey) return;
      switch (e.key) {
        case "ArrowLeft":
        case "ArrowUp":
          return this._moveDownOneStep();
        case "ArrowRight":
        case "ArrowDown":
          return this._moveUpOneStep();
        case "Home":
          return this._move(this.props.min);
        case "End":
          return this._move(this.props.max);
        default:
          return;
      }
    },

    _moveUpOneStep: function () {
      var oldValue = this.state.value[this.state.index];
      var newValue = oldValue + this.props.step;
      this._move(Math.min(newValue, this.props.max));
    },

    _moveDownOneStep: function () {
      var oldValue = this.state.value[this.state.index];
      var newValue = oldValue - this.props.step;
      this._move(Math.max(newValue, this.props.min));
    },

    _getValueFromPosition: function (position) {
      var diffValue = position / (this.state.sliderLength - this.state.handleSize) * (this.props.max - this.props.min);
      return this._trimAlignValue(this.state.startValue + diffValue);
    },

    _getDiffPosition: function (position) {
      var diffPosition = position - this.state.startPosition;
      if (this.props.invert) diffPosition *= -1;
      return diffPosition;
    },

    _move: function (newValue) {
      this.hasMoved = true;

      var props = this.props;
      var state = this.state;
      var index = state.index;

      var value = state.value;
      var length = value.length;
      var oldValue = value[index];

      var minDistance = props.minDistance;

      // if "pearling" (= handles pushing each other) is disabled,
      // prevent the handle from getting closer than `minDistance` to the previous or next handle.
      if (!props.pearling) {
        if (index > 0) {
          var valueBefore = value[index - 1];
          if (newValue < valueBefore + minDistance) {
            newValue = valueBefore + minDistance;
          }
        }

        if (index < length - 1) {
          var valueAfter = value[index + 1];
          if (newValue > valueAfter - minDistance) {
            newValue = valueAfter - minDistance;
          }
        }
      }

      value[index] = newValue;

      // if "pearling" is enabled, let the current handle push the pre- and succeeding handles.
      if (props.pearling && length > 1) {
        if (newValue > oldValue) {
          this._pushSucceeding(value, minDistance, index);
          this._trimSucceeding(length, value, minDistance, props.max);
        }
        else if (newValue < oldValue) {
          this._pushPreceding(value, minDistance, index);
          this._trimPreceding(length, value, minDistance, props.min);
        }
      }

      // Normally you would use `shouldComponentUpdate`, but since the slider is a low-level component,
      // the extra complexity might be worth the extra performance.
      if (newValue !== oldValue) {
        this.setState({value: value}, this._fireChangeEvent.bind(this, 'onChange'));
      }
    },

    _pushSucceeding: function (value, minDistance, index) {
      var i, padding;
      for (i = index, padding = value[i] + minDistance;
           value[i + 1] != null && padding > value[i + 1];
           i++, padding = value[i] + minDistance) {
        value[i + 1] = this._alignValue(padding);
      }
    },

    _trimSucceeding: function (length, nextValue, minDistance, max) {
      for (var i = 0; i < length; i++) {
        var padding = max - i * minDistance;
        if (nextValue[length - 1 - i] > padding) {
          nextValue[length - 1 - i] = padding;
        }
      }
    },

    _pushPreceding: function (value, minDistance, index) {
      var i, padding;
      for (i = index, padding = value[i] - minDistance;
           value[i - 1] != null && padding < value[i - 1];
           i--, padding = value[i] - minDistance) {
        value[i - 1] = this._alignValue(padding);
      }
    },

    _trimPreceding: function (length, nextValue, minDistance, min) {
      for (var i = 0; i < length; i++) {
        var padding = min + i * minDistance;
        if (nextValue[i] < padding) {
          nextValue[i] = padding;
        }
      }
    },

    _axisKey: function () {
      var orientation = this.props.orientation;
      if (orientation === 'horizontal') return 'X';
      if (orientation === 'vertical') return 'Y';
    },

    _orthogonalAxisKey: function () {
      var orientation = this.props.orientation;
      if (orientation === 'horizontal') return 'Y';
      if (orientation === 'vertical') return 'X';
    },

    _posMinKey: function () {
      var orientation = this.props.orientation;
      if (orientation === 'horizontal') return this.props.invert ? 'right' : 'left';
      if (orientation === 'vertical') return this.props.invert ? 'bottom' : 'top';
    },

    _posMaxKey: function () {
      var orientation = this.props.orientation;
      if (orientation === 'horizontal') return this.props.invert ? 'left' : 'right';
      if (orientation === 'vertical') return this.props.invert ? 'top' : 'bottom';
    },

    _sizeKey: function () {
      var orientation = this.props.orientation;
      if (orientation === 'horizontal') return 'clientWidth';
      if (orientation === 'vertical') return 'clientHeight';
    },

    _trimAlignValue: function (val, props) {
      return this._alignValue(this._trimValue(val, props), props);
    },

    _trimValue: function (val, props) {
      props = props || this.props;

      if (val <= props.min) val = props.min;
      if (val >= props.max) val = props.max;

      return val;
    },

    _alignValue: function (val, props) {
      props = props || this.props;

      var valModStep = (val - props.min) % props.step;
      var alignValue = val - valModStep;

      if (Math.abs(valModStep) * 2 >= props.step) {
        alignValue += (valModStep > 0) ? props.step : (-props.step);
      }

      return parseFloat(alignValue.toFixed(5));
    },

    _renderHandle: function (style, child, i) {
      var className = this.props.handleClassName + ' ' +
        (this.props.handleClassName + '-' + i) + ' ' +
        (this.state.index === i ? this.props.handleActiveClassName : '');

      return (
        React.createElement('div', {
            ref: 'handle' + i,
            key: 'handle' + i,
            className: className,
            style: style,
            onMouseDown: this._createOnMouseDown(i),
            onTouchStart: this._createOnTouchStart(i),
            onFocus: this._createOnKeyDown(i),
            tabIndex: 0,
            role: "slider",
            "aria-valuenow": this.state.value[i],
            "aria-valuemin": this.props.min,
            "aria-valuemax": this.props.max,
          },
          child
        )
      );
    },

    _renderHandles: function (offset) {
      var length = offset.length;

      var styles = this.tempArray;
      for (var i = 0; i < length; i++) {
        styles[i] = this._buildHandleStyle(offset[i], i);
      }

      var res = this.tempArray;
      var renderHandle = this._renderHandle;
      if (React.Children.count(this.props.children) > 0) {
        React.Children.forEach(this.props.children, function (child, i) {
          res[i] = renderHandle(styles[i], child, i);
        });
      } else {
        for (i = 0; i < length; i++) {
          res[i] = renderHandle(styles[i], null, i);
        }
      }
      return res;
    },

    _renderBar: function (i, offsetFrom, offsetTo) {
      return (
        React.createElement('div', {
          key: 'bar' + i,
          ref: 'bar' + i,
          className: this.props.barClassName + ' ' + this.props.barClassName + '-' + i,
          style: this._buildBarStyle(offsetFrom, this.state.upperBound - offsetTo)
        })
      );
    },

    _renderBars: function (offset) {
      var bars = [];
      var lastIndex = offset.length - 1;

      bars.push(this._renderBar(0, 0, offset[0]));

      for (var i = 0; i < lastIndex; i++) {
        bars.push(this._renderBar(i + 1, offset[i], offset[i + 1]));
      }

      bars.push(this._renderBar(lastIndex + 1, offset[lastIndex], this.state.upperBound));

      return bars;
    },

    _onSliderMouseDown: function (e) {
      if (this.props.disabled) return;
      this.hasMoved = false;
      if (!this.props.snapDragDisabled) {
        var position = this._getMousePosition(e);
        this._forceValueFromPosition(position[0], function (i) {
          this._fireChangeEvent('onChange');
          this._start(i, position[0]);
          this._addHandlers(this._getMouseEventMap());
        }.bind(this));
      }

      pauseEvent(e);
    },

    _onSliderClick: function (e) {
      if (this.props.disabled) return;

      if (this.props.onSliderClick && !this.hasMoved) {
        var position = this._getMousePosition(e);
        var valueAtPos = this._trimAlignValue(this._calcValue(this._calcOffsetFromPosition(position[0])));
        this.props.onSliderClick(valueAtPos);
      }
    },

    _fireChangeEvent: function (event) {
      if (this.props[event]) {
        this.props[event](undoEnsureArray(this.state.value));
      }
    },

    render: function () {
      var state = this.state;
      var props = this.props;

      var offset = this.tempArray;
      var value = state.value;
      var l = value.length;
      for (var i = 0; i < l; i++) {
        offset[i] = this._calcOffset(value[i], i);
      }

      var bars = props.withBars ? this._renderBars(offset) : null;
      var handles = this._renderHandles(offset);

      return (
        React.createElement('div', {
            ref: 'slider',
            style: {position: 'relative'},
            className: props.className + (props.disabled ? ' disabled' : ''),
            onMouseDown: this._onSliderMouseDown,
            onClick: this._onSliderClick
          },
          bars,
          handles
        )
      );
    }
  });

  return ReactSlider;
}));


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(639);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(67);

var emptyObject = __webpack_require__(111);
var _invariant = __webpack_require__(110);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(641);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(643);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_actions_companyActions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_datetime_picker_dist_picker_css__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_datetime_picker_dist_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rc_datetime_picker_dist_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner__ = __webpack_require__(62);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalReport=function(_Component){_inherits(ModalReport,_Component);function ModalReport(props){_classCallCheck(this,ModalReport);var _this=_possibleConstructorReturn(this,(ModalReport.__proto__||Object.getPrototypeOf(ModalReport)).call(this,props));_this.state={loading:true};return _this;}_createClass(ModalReport,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.props.apiReport(this.props.urlReport).then(function(){_this2.setState({loading:false});});}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.apiReport(null);}},{key:'render',value:function render(){var _props=this.props,session=_props.session,report=_props.report,json_lang=_props.json_lang,companyColor=_props.companyColor;var loading=this.state.loading;if(loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex justify-content-center align-items-center',style:{height:"40vh"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Spinner__["a" /* default */],{size:'100px',color:companyColor}));}if(!report){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex justify-content-center align-items-center',style:{height:"40vh"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'font-xl'},'El reporte no se gener\xF3 correctamente'));}var reportStatusStyle={in_queue:"secondary",generating:"warning",failed:"danger",available:"success"};var iconStatus={failed:"fa fa-times-circle",available:"fa fa-check-circle"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:"40vh"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-grow-0 d-flex flex-column justify-content-center align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'font-xl'},'El reporte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'font-weight-bold font-xl'},this.props.tittle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'font-xl'},'se generar\xE1 y enviar\xE1 al correo:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'font-weight-bold font-xl'},session.email)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-grow-1 d-flex flex-column justify-content-center align-items-center h-100'},report.status!=="generating"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,report.status==="in_queue"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Spinner__["a" /* default */],{size:'50px',color:companyColor}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:iconStatus[report.status]+' text-'+reportStatusStyle[report.status]+' font-4xl'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'font-lg mt-2 badge badge-'+reportStatusStyle[report.status]},json_lang.reports[report.status])):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress-bar-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress-bar-fill',style:{width:report.progress+'%'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'font-lg badge badge-warning mt-2'},report.progress.toFixed(2),'%'))));}}]);return ModalReport;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{session:state.session,json_lang:state.json_lang,report:state.report,companyColor:state.company.styles_json.styles.color_primary};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{apiReport:function apiReport(url){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__store_actions_companyActions__["i" /* apiReport */])(url));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalReport));

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_actions_companyActions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_datetime_picker_dist_picker_css__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_datetime_picker_dist_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rc_datetime_picker_dist_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalReportsHistories=function(_Component){_inherits(ModalReportsHistories,_Component);function ModalReportsHistories(props){_classCallCheck(this,ModalReportsHistories);var _this=_possibleConstructorReturn(this,(ModalReportsHistories.__proto__||Object.getPrototypeOf(ModalReportsHistories)).call(this,props));_this.handleNewReportHistories=function(){var newReportsList=_this.state.newReportsList;var querys=[];newReportsList.forEach(function(report){var query=_this.props.handleReportsQuery({},report.value);var splitedQuery=query.split("/");var newQuery=splitedQuery[splitedQuery.length-1];querys.push({query:newQuery,name:report.name});});var newReportHistories=_this.props.reportHistories&&_this.props.reportHistories.data||null;if(newReportHistories){newReportHistories=newReportHistories.filter(function(report){return querys.some(function(query){return report.name===query.query;});});}_this.setState({loading:false,reportsQuerys:querys,reportHistories:{data:newReportHistories}});};_this.handleReload=function(){_this.setState({loading:true});_this.props.apiReportHistories(_this.props.session.account_id).then(function(){_this.setState({loading:false});});};_this.state={reportsQuerys:[],newReportsList:_this.props.reportsList.map(function(item){return item.reports;}).flat(),loading:true,reportHistories:{}};return _this;}_createClass(ModalReportsHistories,[{key:'componentDidMount',value:function componentDidMount(){var session=this.props.session;this.props.apiReportHistories(session.account_id);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.reportHistories!==this.props.reportHistories){this.handleNewReportHistories();}}},{key:'render',value:function render(){var _this2=this;var _state=this.state,loading=_state.loading,reportsQuerys=_state.reportsQuerys,reportHistories=_state.reportHistories;var _props=this.props,companyColor=_props.companyColor,json_lang=_props.json_lang;if(loading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex justify-content-center',style:{margin:"20%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Spinner__["a" /* default */],{size:'100px',color:companyColor}));}if(reportHistories&&reportHistories.data){var reportStatusStyle={in_queue:"secondary",generating:"warning",failed:"danger"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{overflowY:"auto",maxHeight:"450px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Table"],{style:{border:'1px solid #c8ced3'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Reporte')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Fecha de solicitud')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Rango de fechas')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Acci\xF3n')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,reportHistories.data.length>0?reportHistories.data.map(function(report,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,reportsQuerys.find(function(data){return report.name===data.query;}).name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["M" /* utcDateFormat */])(report.created_at,"ll, h:mm:ss a")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,report.args&&report.args.parameters&&report.args.parameters.beg&&report.args.parameters.end?Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["M" /* utcDateFormat */])(report.args.parameters.beg)+' - '+Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["M" /* utcDateFormat */])(report.args.parameters.end):"No aplica"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,report.status==="available"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Button"],{color:'primary',onClick:function onClick(){return window.open(report.download_link,'_blank');}},'Descargar'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'font-lg badge badge-'+reportStatusStyle[report.status]},report.status!=="generating"?json_lang.reports[report.status]:report.progress.toFixed(2)+"%")));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:4,className:'text-center',style:{paddingBottom:"6rem",paddingTop:"6rem"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('big',{className:'text-muted'},json_lang.common.no_results_msg))))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex flex-column justify-content-center align-items-center',style:{margin:"20%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'text-muted'},'Ocurri\xF3 un error al cargar los datos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_reactstrap__["Button"],{color:'primary',onClick:function onClick(){return _this2.handleReload();}},'Recargar'));}}]);return ModalReportsHistories;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{session:state.session,json_lang:state.json_lang,reportHistories:state.reportHistories,companyColor:state.company.styles_json.styles.color_primary};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{apiReportHistories:function apiReportHistories(accountId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__store_actions_companyActions__["j" /* apiReportHistories */])(accountId));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ModalReportsHistories));

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { AppSidebarNav } from '@coreui/react';
var CustomSidebar=function(_Component){_inherits(CustomSidebar,_Component);function CustomSidebar(props){_classCallCheck(this,CustomSidebar);var _this=_possibleConstructorReturn(this,(CustomSidebar.__proto__||Object.getPrototypeOf(CustomSidebar)).call(this,props));var fullParamsSearch=window.location.href.split('=');var paramsSearch=fullParamsSearch&&fullParamsSearch[1]&&fullParamsSearch[1].length>0?fullParamsSearch[1].split(','):[];/*this.state = {
			includeRangeInput:paramsSearch,
			url:'/order-management/search-status=',
		}*/_this.state={navbar:[]};return _this;}_createClass(CustomSidebar,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;//console.log('componentDidMount newNavBar', this.props.navConfig)
var admin_type=this.props.session.admin_type;var newNavBar=this.props.navConfig.visibles==null?this.props.navConfig.items:this.props.navConfig.items//.filter((item,key) => item.name != "Inventario")
.filter(function(item,key){var a=[];if(item.children){a=item.children.filter(function(children,key){return _this2.props.navConfig.visibles.includes(children.lang_key);});item.children=a;}return item.lang_key!==''||item.lang_key==''&&item.children&&item.children.length>0;});//console.log('componentDidMount newNavBar',newNavBar)
//TODO ver por que esta redirgiendo a orders-management
var currentUrl=window.location.pathname;var splitUrl=currentUrl.split('/');var allowedUrls=new Set();allowedUrls.add('');allowedUrls.add('profile');allowedUrls.add('inbox');function collectAllowedUrls(items){items.forEach(function(item){if(item.url){var splitItemUrl=item.url.split('/');allowedUrls.add(splitItemUrl[1]);}if(item.children){collectAllowedUrls(item.children);}});}collectAllowedUrls(newNavBar);var defaultKey=null;if(admin_type){if(allowedUrls.has(admin_type.default)){defaultKey=admin_type.default_key;}}if(!allowedUrls.has(splitUrl[1])){window.location.href='/'+(defaultKey||"");}this.setState({navbar:newNavBar});}},{key:'render',value:function render(){var _this3=this;var items=[];/*if(this.props.navConfig && this.props.navConfig.items){
			items = this.props.navConfig.items.map( (item,key) => {
				if((item.name != "Inventario" && this.props.branch.id == undefined) || (this.props.branch.id)){

					var addItem = <Link className={`nav-link aside_link ${item.url === window.location.pathname ? `active`:`` } ${ this.props.isZupper ? `zupper` : ``}`} to={item.url||'#'}>
							<i className={`nav-icon ${item.icon}`}></i>
							{item.name}
						</Link>

					if( item.children){
						addItem = <UncontrolledDropdown className="aside_link">
							<DropdownToggle nav >
								<i className={`nav-icon ${item.icon}`}></i>
								{item.name}
							</DropdownToggle>
							<DropdownMenu className={`pl-3`}>
								{/*onClick={(e)=>this.urlBuilder()}
								{
									item.children.map( (children,key) => {
										var exist = this.state.includeRangeInput.findIndex(( item ) => item === children.name.toLowerCase() );
										return <CustomInput key={key} id={ `nav-${key}` }
											onChange={(e) => this.urlBuilder(e.target)}
											type="checkbox"
											value={children.name.toLowerCase()}
											name={item.name}
											label={children.name }
											checked={ exist !== -1 ? true : false }
											data-type="checkbox"/>
									})
								} * /}
								{
									item.children.map( (children,key) => {
										return <DropdownItem key={key}>
											<Link  to={children && children.url || "#"} style={{textDecoration: 'none', color: '#000'}}>
												{children.name}
											</Link>
										</DropdownItem>
									})
								}
							</DropdownMenu>
						</UncontrolledDropdown>
					}
					return <NavItem key={key}>{addItem}</NavItem>
				}
			})
		}*//*addItem;
				if(this.props.company && this.props.company.settings && this.props.company.settings.enable_multi_providers === true){
					if(item.lang_key !== 'providers_settings'){
						addItem = <Link className={`nav-link`} to={item.url}>
							<i className={`nav-icon ${item.icon}`}></i>
							{item.name}
						</Link>
					}
				}else{*//*<AppSidebarNav navConfig={ this.props.navConfig } /> */if(this.props.navConfig&&this.props.navConfig.items){items=this.state.navbar.map(function(item,key){if(item.name!="Inventario"&&item.lang_key!="create-order"&&_this3.props.branch.id==undefined||_this3.props.branch.id){var addItem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'nav-link aside_link '+(item.url===window.location.pathname?'active':'')+' '+(_this3.props.isZupper?'zupper':''),to:item.url||'#'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'nav-icon '+item.icon}),item.name);if(item.children){addItem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["UncontrolledDropdown"],{className:'aside_link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["DropdownToggle"],{nav:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'nav-icon '+item.icon}),item.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["DropdownMenu"],{className:'pl-3'},item.children.map(function(children,key){if(children.lang_key!="branch-invoices"&&!_this3.props.branch.id||_this3.props.branch.id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["DropdownItem"],{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:children&&children.url||"#",style:{textDecoration:'none',color:'#000'}},children.name));}})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["NavItem"],{key:key},addItem);}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scrollbar-container sidebar-nav ps ps--active-y'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Nav"],null,items));}}]);return CustomSidebar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//export default CustomSidebar;
var mapStateToProps=function mapStateToProps(state){var zupper=false;if(state.company){if(state.company.id===7||state.company.id===120){zupper=true;}}return{company:state.company,isZupper:zupper};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(CustomSidebar));

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_orderActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_notificationsActions__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_actions_companyActions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Plugins_MainModals_ModalBase__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Plugins_MainModals_NewModalBase__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Plugins_MainModals_NewModalConfirm__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Orders_modalOrder__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Orders_modalAssignProvider__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Provider_pendingAccionProvider__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_general__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral([","],[","]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultProps={};var DefaultAside=function(_Component){_inherits(DefaultAside,_Component);function DefaultAside(props){_classCallCheck(this,DefaultAside);var _this=_possibleConstructorReturn(this,(DefaultAside.__proto__||Object.getPrototypeOf(DefaultAside)).call(this,props));_this.open_modal_data=function(id,modal,name){_this.setState({selectedId:id,selectedName:name});_this.refs[modal].toggleModal();};_this.toggle=_this.toggle.bind(_this);_this.myAudio=new Audio(window.location.origin+"/assets/notification.mp3");_this.myAudio.preload=true;_this.state={activeTab:"1"};_this.props.fetchTodayOrders();//this.props.pendingActions();
_this.props.fetchNewNotifications();return _this;}_createClass(DefaultAside,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(prevProps){if((prevProps&&prevProps.branch&&prevProps.branch.id)!==(this.props.branch&&this.props.branch.id)){this.props.fetchTodayOrders();}}},{key:"unassignProvider",value:function unassignProvider(order_id,provider_id){this.props.removeProvider(order_id,provider_id);//if(this.props.history.location === "/map") /* TODO: actualizar solo en el mapa (quizas en la tabla ordenes) para que se vea el cambio */
//this.props.fetchOrders();
}},{key:"listNotifications",value:function listNotifications(){var _this2=this;return this.props.notifications&&this.props.notifications.length>0&&this.props.notifications.map(function(noti,key){var notiTitle=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,noti.title||"");var microcopy=_this2.props.json_lang.default_aside.mark_notification_consumed;var noti_id=noti.id||key;var isPush=noti.id?false:true;{/*if(noti.consumed){
				notiTitle = noti.title;
				microcopy = '';
			}*/}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["ListGroupItem"],{key:key,action:true,tag:"li",className:"list-group-item-divider d-flex flex-row notifications-list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:noti.url||"",className:"unsetlink flex-fill",onClick:function onClick(e){return noti.consumed?undefined:_this2.props.markNotificationConsumed(noti_id,isPush);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{width:"calc(100% - 25px)",display:"inline-block"}},notiTitle||"",noti.msg?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"text-muted btn-block"},noti.msg||""):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{id:key,className:"flex-fill align-self-stretch close","aria-label":"Close",title:microcopy||""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{"aria-hidden":"true",className:"fa "+(noti.consumed?"fa-circle-o":"fa-circle")}))));});}},{key:"toggle",value:function toggle(tab){if(this.state.activeTab!==tab){if(this.state.activeTab==="1"){this.props.fetchNewNotifications();}if(this.state.activeTab==="1"){this.props.pendingActions();}this.setState({activeTab:tab});}}},{key:"render",value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Nav"],{tabs:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["NavItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["NavLink"],{title:this.props.json_lang.default_aside.aside_menu_title,onClick:function onClick(){_this3.toggle("1");},className:this.state.activeTab==="1"?"active":""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon-bell"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["NavItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["NavLink"],{onClick:function onClick(){_this3.toggle("2");},className:this.state.activeTab==="2"?"active":""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon-bag"}))),this.props.userHigherAccess===__WEBPACK_IMPORTED_MODULE_14__constants_general__["h" /* COMPANY_ACCESS */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["NavItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["NavLink"],{onClick:function onClick(){_this3.toggle("3");},className:this.state.activeTab==="3"?"active":""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fa fa-motorcycle"}))):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["TabContent"],{activeTab:this.state.activeTab},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["TabPane"],{tabId:"1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["ListGroup"],{className:"list-group-accent"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["ListGroupItem"],{className:"list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small",style:{fontSize:"14px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{style:{display:"inline-block",float:"left"},className:"mr-2 mb-0"},this.props.notificationsCounter?// TODO: falta restarle si el usuario lee una notificacion y un endpoint para traer los que falta por leer
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Badge"],{color:"warning",size:"md",className:"ml-1 badge-pill"},this.props.notificationsCounter):null),this.props.json_lang.default_aside.aside_notifications_title,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{color:"secondary",title:"Configurar Notificaciones",to:"/profile/"+this.props.session.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{style:{fontWeight:"bolder",fontSize:"1.2em",display:"inline-block",float:"right"},className:"fa fa-cog mr-1 mb-0"}))),this.listNotifications(),this.props.notifications&&this.props.notifications.length>4?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["ListGroupItem"],{className:"list-group-item-divider d-flex flex-row notifications-list text-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{color:"info",to:"/notifications",style:{width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,this.props.json_lang.common.see_all))):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["TabPane"],{tabId:"2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["ListGroup"],{className:"list-group-accent"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["ListGroupItem"],{style:{fontSize:"14px"},className:"list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{style:{display:"inline-block",float:"left"},className:"mr-2 mb-0"}),this.props.json_lang.default_aside.aside_menu_title),this.props.todayOrders?this.props.todayOrders.map(function(order,key){var providerText=_this3.props.json_lang.default_aside.provider_unassigned_msg;if(order.is_shopper_allowed&&!order.is_shopper_assigned){providerText=_this3.props.json_lang.default_aside.shopper_unassigned_msg;}var action="list-group-item-accent-danger";var provider=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Button"],{color:"link",className:"text-danger btn-block text-left p-0",onClick:function onClick(e){e.stopPropagation();e.preventDefault();_this3.refs["order-assing-"+key].toggleModal();}},providerText,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)));if(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["p" /* isPickUp */])(order.client_latitude_e6,order.client_longitude_e6,order.client_address)){provider=null;}//console.log("order.order_providers",order.providers[0])
if(order&&order.providers&&order.providers[0]&&(order.is_shopper_allowed&&!order.is_status_prepared?order.is_shopper_assigned:order.is_provider_assigned)){action="list-group-item-accent-success";provider=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"py-3 mr-3 float-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"avatar_small",src:order.providers[0].avatar_url?order.providers[0].avatar_url:"https://api-dev.dondemand.io/storage/static/default/avatar_rider-48x48.jpg",alt:order.providers[0]&&order.providers[0].email?order.providers[0].email:""}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"avatar-status badge-success"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,order.is_shopper_allowed&&!order.is_provider_assigned?_this3.props.json_lang.default_aside.shopper_assigned_msg:_this3.props.json_lang.default_aside.provider_assigned_msg,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,order.providers[0].name?order.providers[0].name:""," ")));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["ListGroupItem"],{key:key,action:true,tag:"span",className:"list-group-item-divider "+action},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{onClick:function onClick(){return _this3.refs["details"+key].toggleModal();},className:"clearfix"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,_this3.props.json_lang.common.order_number_msg),order.uid?order.uid:_this3.props.json_lang.order_status.unconfirmed),order.provider?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Button"],{color:"ghost-danger",className:"btn-sm float-right",onClick:__WEBPACK_IMPORTED_MODULE_10__views_Plugins_MainModals_NewModalConfirm__["a" /* default */].open("unAssing-"+key)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon-user-unfollow"})):null,provider,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"text-muted"},Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["p" /* isPickUp */])(order.client_latitude_e6,order.client_longitude_e6,order.client_address)?_this3.props.json_lang.common.pickup:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,order.client_address?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon-location-pin"}),order.client_address):null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__views_Plugins_MainModals_NewModalConfirm__["a" /* default */],{id:"unAssing-"+key,confirmFunc:function confirmFunc(){return _this3.unassignProvider(order.id,order.provider.id);},html:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"text-center mb-0"},_this3.props.json_lang.default_aside.confirm_unassign_modal_1,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",{className:"text-danger"},_this3.props.json_lang.table_orders.unassing)," ",_this3.props.json_lang.default_aside.confirm_unassign_modal_2," ")}),order.uid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__views_Plugins_MainModals_ModalBase__["a" /* default */],{ref:"details"+key,title:_this3.props.json_lang.default_aside.modal_order_title+" #"+(order.uid?order.uid:_this3.props.json_lang.order_status.unconfirmed),reference:function reference(){return _this3.open_modal_data(0,"details"+key(_templateObject));},html:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__views_Orders_modalOrder__["a" /* default */],{orderID:order.id})}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__views_Plugins_MainModals_ModalBase__["a" /* default */],{ref:"details"+key,confirmFunc:function confirmFunc(){return _this3.props.confirmOrder(order.id);},reference:function reference(){return _this3.open_modal_data(0,"details"+key(_templateObject));},title:_this3.props.json_lang.default_aside.modal_order_title+" #"+(order.uid?order.uid:_this3.props.json_lang.order_status.unconfirmed),html:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__views_Orders_modalOrder__["a" /* default */],{orderID:order.id})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__views_Plugins_MainModals_ModalBase__["a" /* default */],{ref:"order-assing-"+key,id:"order-assing-"+key,title:_this3.props.json_lang.map_view.provider_list_modal_title,html:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__views_Orders_modalAssignProvider__["a" /* default */],{orderID:order.id,reference:function reference(){_this3.props.fetchTodayOrders();_this3.props.fetchOrders();_this3.open_modal_data(0,"order-assing-"+key//`providerAssingOrder`
);}})}));}):null)),this.props.userHigherAccess===__WEBPACK_IMPORTED_MODULE_14__constants_general__["h" /* COMPANY_ACCESS */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["TabPane"],{tabId:"3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["ListGroup"],{className:"list-group-accent"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["ListGroupItem"],{className:"list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small",style:{fontSize:"14px"}},this.props.json_lang.default_aside.pending_changes),this.props.actions&&this.props.actions&&this.props.actions.length>0?this.props.actions.map(function(action,key){var actionItem;if(action&&action.type===1&&action.data&&action.data.provider){actionItem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["ListGroupItem"],{key:key,action:true,tag:"span",className:"list-group-item-divider d-flex flex-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clearfix",style:{width:"calc(100% - 25px)"},onClick:function onClick(){return _this3.refs["pendingActions-"+key].toggleModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mr-3 float-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{id:"avatar_small-"+action.data.provider.id,onError:function onError(){return document.getElementById("avatar_small-"+action.data.provider.id).src="https://api-dev.dondemand.io/storage/static/default/avatar_rider-48x48.jpg";},className:"avatar_small",src:action.data.provider.avatar_url?action.data.provider.avatar_url:"https://api-dev.dondemand.io/storage/static/default/avatar_rider-48x48.jpg",alt:action.data.provider.email?action.data.provider.email:""}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"avatar-status badge-success"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,action.data.provider.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",{className:"text-muted btn-block"},"Ha hecho modificaciones que debes aprobar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["Button"],{color:"ghost-danger",className:"btn-sm float-right",onClick:__WEBPACK_IMPORTED_MODULE_10__views_Plugins_MainModals_NewModalConfirm__["a" /* default */].open("deleteAction-"+key)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{"aria-hidden":"true"},"\xD7")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__views_Plugins_MainModals_ModalBase__["a" /* default */],{ref:"pendingActions-"+key,title:"Actualizaci\xF3n proveedor",html:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__views_Provider_pendingAccionProvider__["a" /* default */],{data:action.data,refuse:function refuse(){return _this3.props.deletePendingAction(action.id);},confirm:function confirm(){return _this3.props.confirmPendingAction(action.id);}})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__views_Plugins_MainModals_NewModalConfirm__["a" /* default */],{id:"deleteAction-"+key,confirmFunc:function confirmFunc(){return _this3.props.deletePendingAction(action.id);},html:"¿Está seguro de que desea cancelar esta acción?"}));}return actionItem;}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactstrap__["ListGroupItem"],null,this.props.json_lang.default_aside.no_pendings_msg))):null));}}]);return DefaultAside;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DefaultAside.defaultProps=defaultProps;var mapStateToProps=function mapStateToProps(state){return{session:state.session,notifications:state.notifications,//(state.notifications && state.notifications.slice(0, 8)) || [],
todayOrders:state.todayOrders,branch:state.branch,ordersCounter:state.ordersCounter,notificationsCounter:state.notificationsCounter,json_lang:state.json_lang,//localUserSettings: state.localUserSettings,
actions:state.pendingActions,userHigherAccess:state.userHigherAccess};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchTodayOrders:function fetchTodayOrders(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_orderActions__["_3" /* fetchTodayOrders */])());},fetchOrders:function fetchOrders(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_orderActions__["V" /* fetchOrders */])());},fetchNewNotifications:function fetchNewNotifications(page){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_notificationsActions__["d" /* fetchNewNotifications */])(page));},//changeLocalUserSettings: (settings, value, data) => dispatch(changeLocalUserSettings(settings, value, data)),
markNotificationConsumed:function markNotificationConsumed(id,isPush){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_notificationsActions__["h" /* markNotificationConsumed */])(id,isPush));},removeProvider:function removeProvider(id,provider){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_orderActions__["_28" /* removeProvider */])(id,provider));},confirmOrder:function confirmOrder(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_orderActions__["E" /* confirmOrder */])(id));},setNotificationsListEmpty:function setNotificationsListEmpty(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__store_actions_notificationsActions__["i" /* setNotificationsListEmpty */])());},pendingActions:function pendingActions(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__store_actions_companyActions__["_22" /* pendingActions */])());},deletePendingAction:function deletePendingAction(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__store_actions_companyActions__["F" /* deletePendingAction */])(id));},confirmPendingAction:function confirmPendingAction(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__store_actions_companyActions__["t" /* confirmPendingAction */])(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(DefaultAside));

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Plugins_MainModals_ImageDetailsModal__ = __webpack_require__(245);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PendingAccionProvider=function(_Component){_inherits(PendingAccionProvider,_Component);function PendingAccionProvider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PendingAccionProvider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PendingAccionProvider.__proto__||Object.getPrototypeOf(PendingAccionProvider)).call.apply(_ref,[this].concat(args))),_this),_this.open_modal=function(modal){_this.refs[modal].toggleModal();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PendingAccionProvider,[{key:'render',value:function render(){var _this2=this;var data=this.props.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Row"],{className:'justify-content-center'},data&&data.provider&&data.values&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'py-3 mr-3 float-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{ref:'provider',onError:function onError(){return _this2.refs['provider'].src=' https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar-repartidor.png';},className:'avatar_lg',src:data.provider.avatar_url,alt:'actual_image'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'avatar-status badge-success'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,data.provider.name),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'text-muted'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'@'),' ',data.provider.email,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'text-muted'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-phone'}),' ',data.provider.phone),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'text-muted',style:{width:'70%',display:'inline-block'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-pencil-square-o'}),' ',data.provider.profile_data.extract)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Col"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Cambios a aprobar:  '),data.values.avatar_url&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'py-3 mr-3 float-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{ref:'provider',onError:function onError(){return _this2.refs['provider'].src='https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar-repartidor.png';},className:'avatar_lg updated pointer',src:data.values.avatar_url,alt:'new_image',onClick:function onClick(){return _this2.open_modal("imageDetail");}}))),data.values.profile_data&&data.values.profile_data.extract?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'text-info',style:{width:'70%',display:'inline-block'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-pencil-square-o'}),' ',data.values.profile_data.extract):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Plugins_MainModals_ImageDetailsModal__["a" /* default */],{ref:"imageDetail",reference:function reference(){return _this2.open_modal("imageDetail");},image:data.values.avatar_url,title:'Solicitud realizada por: '+data.provider.name}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["ModalFooter"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{color:'primary',onClick:function onClick(){return _this2.props.confirm();}},'Aprobar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{color:'danger',onClick:function onClick(){return _this2.props.refuse();}},'Rechazar')));}}]);return PendingAccionProvider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PendingAccionProvider);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var version="3.1.7";var propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node};var defaultProps={};var DefaultFooter=function(_Component){_inherits(DefaultFooter,_Component);function DefaultFooter(){_classCallCheck(this,DefaultFooter);return _possibleConstructorReturn(this,(DefaultFooter.__proto__||Object.getPrototypeOf(DefaultFooter)).apply(this,arguments));}_createClass(DefaultFooter,[{key:'render',value:function render(){// eslint-disable-next-line
var _props=this.props,children=_props.children,attributes=_objectWithoutProperties(_props,['children']);var date=new Date();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'v',version,' \xA9 ',date.getFullYear(),' Simgulary, LLC. All rights reserved '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ml-auto'}));}}]);return DefaultFooter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DefaultFooter.propTypes=propTypes;DefaultFooter.defaultProps=defaultProps;/* harmony default export */ __webpack_exports__["a"] = (DefaultFooter);

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__coreui_react__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actions_userActions__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_actions_branches_branchActions__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_actions_initialState__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_actions_UtilsOperation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_actions_orderActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants_general__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Plugins_SpecialForm__ = __webpack_require__(87);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={children:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node};var defaultProps={};var DefaultHeader=function(_Component){_inherits(DefaultHeader,_Component);function DefaultHeader(props){_classCallCheck(this,DefaultHeader);var _this=_possibleConstructorReturn(this,(DefaultHeader.__proto__||Object.getPrototypeOf(DefaultHeader)).call(this,props));_this.handleHasUnreadMessages=function(event){_this.setState({hasUnreadMessages:event.detail.value});};_this.activateBranch=function(_ref){var checked=_ref.checked;_this.setState({changingStatus:true},function(){_this.props.updateBranchInServiceStatus(checked).then(function(){_this.setState({changingStatus:false});});});};_this.setBranch=function(branch){_this.props.updateSelectedBranch(branch?branch:{});};_this.toggleNotification=function(_ref2){var checked=_ref2.checked;localStorage.setItem("enableNotification",JSON.stringify(checked));_this.setState({enableNotification:checked});};_this.handleCloseNotificationsBar=function(){if(document.body.classList.contains('aside-menu-lg-show')){document.body.classList.remove('aside-menu-lg-show');}};var enableNotification=JSON.parse(localStorage.getItem("enableNotification"));if(enableNotification===null||enableNotification===undefined){enableNotification=true;}var hasUnreadMessages=JSON.parse(localStorage.getItem("hasUnreadMessages"));if(hasUnreadMessages===null||hasUnreadMessages===undefined){hasUnreadMessages=false;}_this.state={enableNotification:enableNotification,hasUnreadMessages:hasUnreadMessages,changingStatus:false};var _this$props=_this.props,admin_type_id=_this$props.admin_type_id,userHigherAccess=_this$props.userHigherAccess;if(admin_type_id===2||userHigherAccess===__WEBPACK_IMPORTED_MODULE_12__constants_general__["h" /* COMPANY_ACCESS */]){_this.props.fillDashboardStatistics();}_this.asideTogglerRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.sidebarTogglerRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.sidebarMobileTogglerRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.sidebarMinimizer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.props.getCountries();/*if(userHigherAccess > BRANCH_ACCESS){
			this.props.fetchCompanyBranches();
		}*/return _this;}// addEventListener
_createClass(DefaultHeader,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.asideTogglerRef.current).addEventListener('click',this.handleContainerResize.bind(this));__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.sidebarMobileTogglerRef.current).addEventListener('click',this.handleContainerResize.bind(this));__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.sidebarTogglerRef.current).addEventListener('click',this.handleContainerResize.bind(this));window.addEventListener('hasUnreadMessages',this.handleHasUnreadMessages);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if((prevProps&&prevProps.branch&&prevProps.branch.id)!==(this.props.branch&&this.props.branch.id)){this.props.fillDashboardStatistics();}}// removeEventListener
},{key:'componentWillUnmount',value:function componentWillUnmount(){if(__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.sidebarMinimizer.current)){__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.asideTogglerRef.current).removeEventListener('click',this.handleContainerResize.bind(this));__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.sidebarMobileTogglerRef.current).removeEventListener('click',this.handleContainerResize.bind(this));__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.sidebarTogglerRef.current).removeEventListener('click',this.handleContainerResize.bind(this));__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.sidebarMinimizer.current).removeEventListener('click',this.handleContainerResize.bind(this));}window.removeEventListener('hasUnreadMessages',this.handleHasUnreadMessages);}},{key:'handleContainerResize',value:function handleContainerResize(target){// when its clicked it still needs time to end rendering the component with the class to find, thats why I use false if its found
if(target.currentTarget.id==="mobile-sidebar"){this.handleCloseNotificationsBar();this.props.onResize(document.body.classList.contains('sidebar-show'),// isSidebarActive
undefined);}else if(target.currentTarget.id==="sidebar"){this.props.onResize(document.body.classList.contains('sidebar-show'),// isSidebarActive
undefined);}else if(target.currentTarget.id==="aside"){this.props.onResize(undefined,document.body.classList.contains('aside-menu-lg-show')// isAsidemenuActive
);}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,json_lang=_props.json_lang,userHigherAccess=_props.userHigherAccess,branch=_props.branch,statsCurrent=_props.statsCurrent,unconfirmedOrders=_props.unconfirmedOrders,admin_type_id=_props.admin_type_id,admin_account_type=_props.admin_account_type,company=_props.company,company_logo=_props.company_logo,logoLink=_props.logoLink,admin_type=_props.admin_type,session=_props.session;var _state=this.state,enableNotification=_state.enableNotification,hasUnreadMessages=_state.hasUnreadMessages;var totalOngoing=statsCurrent?statsCurrent:0;//var totalOngoing = this.props.statsCurrent && this.props.statsCurrent.unattended ? parseInt(this.props.statsCurrent.unattended,10):0;
var totalunconfirmed=unconfirmedOrders?parseInt(unconfirmedOrders,10):0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,company&&!company.enabled?this.props.logout():null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__coreui_react__["l" /* AppSidebarToggler */],{id:'mobile-sidebar',ref:this.sidebarMobileTogglerRef,className:'d-lg-none',display:'md',mobile:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */],{onClick:function onClick(){return _this2.props.handleCloseCustomSidebar();},to:logoLink,id:'company-logo-admin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__coreui_react__["f" /* AppNavbarBrand */],{tag:'span',full:{src:company_logo?company_logo:'/assets/img/logo-default-180x64.svg',width:'auto',height:42,alt:'logo-default'},minimized:{src:'',width:0,height:62},onError:function onError(img){return img.target.src="/assets/img/logo-default-180x64.svg";}})),userHigherAccess!==__WEBPACK_IMPORTED_MODULE_12__constants_general__["e" /* BRANCH_ACCESS */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:function onClick(){return _this2.props.handleCloseCustomSidebar();},className:'responsive_heaer show-item ml-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex flex-column align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-primary mb-0 line_table '},Object(__WEBPACK_IMPORTED_MODULE_10__store_actions_UtilsOperation__["Q" /* zerofilled */])(totalOngoing,2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line_table pl-1'},json_lang.common.today_uncompleted_orders))),totalunconfirmed>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:function onClick(){return _this2.props.handleCloseCustomSidebar();},className:'header_unconfirmed hiden-on-600 show-item ml-2',style:{display:'inline-table'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex flex-column align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-danger mb-0 line_table'},Object(__WEBPACK_IMPORTED_MODULE_10__store_actions_UtilsOperation__["Q" /* zerofilled */])(totalunconfirmed,2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line_table pl-1'},json_lang.common.today_unconfirmed_orders)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__coreui_react__["l" /* AppSidebarToggler */],{id:'sidebar',ref:this.sidebarTogglerRef,className:'d-md-down-none',display:'lg'}),userHigherAccess!==__WEBPACK_IMPORTED_MODULE_12__constants_general__["e" /* BRANCH_ACCESS */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:function onClick(){return _this2.props.handleCloseCustomSidebar();},className:'responsive_heaer hide-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-primary mb-0 line_table '},Object(__WEBPACK_IMPORTED_MODULE_10__store_actions_UtilsOperation__["Q" /* zerofilled */])(totalOngoing,2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line_table pl-1'},json_lang.common.today_uncompleted_orders)),totalunconfirmed>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:function onClick(){return _this2.props.handleCloseCustomSidebar();},className:'header_unconfirmed hiden-on-600 hide-item',style:{display:'inline-table'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-danger mb-0 line_table'},Object(__WEBPACK_IMPORTED_MODULE_10__store_actions_UtilsOperation__["Q" /* zerofilled */])(totalunconfirmed,2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line_table pl-1'},json_lang.common.today_unconfirmed_orders)),admin_type!=='Shopper'&&admin_type!=='Gerente de administración'&&admin_type!=='cocinero'&&admin_type!=='Despachador'&&userHigherAccess<__WEBPACK_IMPORTED_MODULE_12__constants_general__["h" /* COMPANY_ACCESS */]?session&&session.account&&session.account.type>=119?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'header_unconfirmed text-muted'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line_table'},json_lang.settings.branch_in_service),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Label"],{className:'line_table pl-1 switch switch-3d switch-info form-check-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',className:'switch-input form-check-input hidden',name:'in_service',checked:branch&&branch.in_service,disabled:!(branch&&branch.enabled)||this.state.changingStatus,onChange:function onChange(e){return _this2.activateBranch(e.target);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'switch-slider','data-checked':'On','data-unchecked':'Off'}))):null:null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Nav"],{onClick:function onClick(){return _this2.props.handleCloseCustomSidebar();},className:'ml-auto',navbar:true},/*(admin_type !== 'Gerente de administración')
						&& this.state.userBranches.length > 1
						//&&   this.props.userHigherAccess > BRANCH_ACCESS
						&&
						if(userHigherAccess > BRANCH_ACCESS){
										this.props.fetchCompanyBranches(query)
									}
						*//*(this.props.admin_type !== 'Gerente de administración') && (userHigherAccess > BRANCH_ACCESS) ?
							<Input ref={`select_input`}
								style={{width: "fit-content"}}
								className="mr-1"
								type="select"
								value={this.props.branch && this.props.branch.id}
								onChange={(e) => this.setBranch(e.target)}
								name="branch-name" >
								{this.props.userHigherAccess === COMPANY_ACCESS ? <option value="">Todos los comercios</option> : null}

								{/*
									this.state.userBranches.map( b => <option key={b.access_id} value={b.access_id}>
										{b.related_access && b.related_access.name}
									</option>)
									*
							</Input>
						:*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-default-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__views_Plugins_SpecialForm__["d" /* SearchBranchSelect */],{placeholder:this.props.branch&&this.props.branch.name,clear:function clear(){return _this2.setBranch();},largerInput:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex flex-row align-items-center'},"DEV".toUpperCase()==="DEV"||"DEV".toUpperCase()==="DEVELOP"||"DEV".toUpperCase()==="LOCAL"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */],{style:{textDecoration:'unset'},className:'text-muted ml-3 mr-2 position-relative pointer',to:'/inbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-envelope font-xl'}),hasUnreadMessages&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-circle text-warning position-absolute font-xs',style:{marginLeft:"-5px"}})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__coreui_react__["b" /* AppAsideToggler */],{id:'aside',ref:this.asideTogglerRef,className:'text-muted',style:this.props.admin_type==='Gerente Comercial'||this.props.admin_type==='Reportes'?{display:'none'}:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-bell'}),this.props.unseenNotifications&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-circle text-warning'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__coreui_react__["e" /* AppHeaderDropdown */],{direction:'down',className:'pr-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["DropdownToggle"],{nav:true},this.props.session.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["DropdownMenu"],{right:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'dropdown-header'},this.props.json_lang.common.display_name),this.props.session?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */],{tag:'Button',to:'/profile/'+this.props.session.id,className:'dropdown-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-user'}),this.props.json_lang.common.my_account):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["DropdownItem"],{onClick:function onClick(){return _this2.props.logout();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-lock'}),this.props.json_lang.default_header.logout_button),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:' dropdown-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex flex-row align-items-center justify-content-between'},'Notificaciones',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Label"],{className:'switch switch-3d switch-info form-check-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',className:'switch-input form-check-input hidden',name:'enableNotification',onChange:function onChange(e){return _this2.toggleNotification(e.target);},value:enableNotification,checked:enableNotification}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'switch-slider','data-checked':'On','data-unchecked':'Off'}))))))))));}}]);return DefaultHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DefaultHeader.propTypes=propTypes;DefaultHeader.defaultProps=defaultProps;var mapStateToProps=function mapStateToProps(state){//console.log("dashboard",state.dashboardStatistics && state.dashboardStatistics.orders && state.dashboardStatistics.orders.ongoing && state.dashboardStatistics.orders.ongoing.hanging)
return{admin_type:state.session&&state.session.admin_type&&state.session.admin_type.name,admin_account_type:state.session&&state.session.account&&state.session.account.type,admin_type_id:state.session&&state.session.admin_type&&state.session.admin_type.id?state.session.admin_type.id:"",company:state.company,userHigherAccess:state.userHigherAccess,branch:state.branch,branches:state.branches,session:state.session,unseenNotifications:state.unseenNotifications,errors:state.errors,online:state.userIsOnline,json_lang:state.json_lang,defaultDashboard:state.company.options,company_logo:state.company&&state.company.styles_json&&state.company.styles_json.styles&&state.company.styles_json.styles.company_logo,company_logo_small:state.branches.logo_url,//statsCurrent: state.dashboardStatistics && state.dashboardStatistics.orders && state.dashboardStatistics.orders.ongoing,
statsCurrent:state.dashboardStatistics&&state.dashboardStatistics.orders&&state.dashboardStatistics.orders.ongoing&&state.dashboardStatistics.orders.ongoing.unattended,unconfirmedOrders:state.dashboardStatistics&&state.dashboardStatistics.orders&&state.dashboardStatistics.orders.unattended&&state.dashboardStatistics.orders.unattended.unconfirmed};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{logout:function logout(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_userActions__["i" /* logout */])());},onResize:function onResize(isSidebarActive,isAsidemenuActive){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__store_actions_initialState__["c" /* onResize */])(isSidebarActive,isAsidemenuActive));},toggleOnlineStatusApiCall:function toggleOnlineStatusApiCall(status){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_userActions__["q" /* toggleOnlineStatusApiCall */])(status));},fillDashboardStatistics:function fillDashboardStatistics(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__store_actions_orderActions__["_6" /* fillDashboardStatistics */])());},updateSelectedBranch:function updateSelectedBranch(userBranch){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__store_actions_branches_branchActions__["_16" /* updateSelectedBranch */])(userBranch));},updateBranchInServiceStatus:function updateBranchInServiceStatus(enabled){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__store_actions_branches_branchActions__["_9" /* updateBranchInServiceStatus */])(enabled));},fetchCompanyBranches:function fetchCompanyBranches(limit,query){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__store_actions_branches_branchActions__["H" /* fetchCompanyBranches */])(limit,query));},toggleData:function toggleData(input){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__store_actions_branches_branchActions__["Y" /* toggleData */])(input));},getCountries:function getCountries(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__store_actions_initialState__["b" /* getCountries */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(DefaultHeader));

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
var Breadcrumb=function Breadcrumb(_ref){var _ref$routes=_ref.routes,routes=_ref$routes===undefined?[]:_ref$routes,history=_ref.history,session=_ref.session;var getPaths=function getPaths(pathname){var paths=['/'];if(pathname==='/'){return paths;}pathname.split('/').reduce(function(previousPath,currentSegment){var newPath=previousPath+'/'+currentSegment;if(!currentSegment.includes('=')){paths.push(newPath);}return newPath;});return paths;};var findRouteName=function findRouteName(url,routesList){var route=routesList.find(function(_ref2){var path=_ref2.path,exact=_ref2.exact;return Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* matchPath */])(url,{path:path,exact:exact});})||{};return{name:route.name,path:route.path,url:route.url};};var breadcrumbs=function breadcrumbs(routeConfiguration){var currentPath=history.location.pathname;var paths=getPaths(currentPath);return paths.map(function(path){return findRouteName(path,routeConfiguration);});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',{className:'breadcrumb'},function(){var items=breadcrumbs(routes);var lastIndex=items.length-1;var adminType=session&&session.admin_type;var breads=items.filter(function($0){return $0.path;}).map(function(route,key){if(route.path){var disabled=adminType?adminType.id===12:key===lastIndex;if(disabled){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,route.name);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:route.path},route.name);}return null;}).filter(function($0){return $0;}).reduce(function(acc,child,index){var notLast=index<lastIndex;if(notLast){acc.push(child,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mx-2'},'/'));}else{acc.push(child);}return acc;},[]).map(function(item,key){return Object.assign({},item,{key:key});});return breads;}());};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(_ref3){var branch=_ref3.branch;return{branch:branch};})(Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["h" /* withRouter */])(Breadcrumb)));

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dashboard__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Login_Login__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Page404__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Page500__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Register_Register__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Password_Email__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Password_Password__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Reports_Reports_js__ = __webpack_require__(235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Page404__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__Page500__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__Register_Register__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Login_Login__["a"]; });
/* unused harmony reexport Dashboard */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__Password_Email__["a"]; });
/* unused harmony reexport Reports */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__Password_Password__["a"]; });


/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_userActions__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Plugins___ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hcaptcha_react_hcaptcha__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__handlers_Notification__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { COMPANY_ACCESS } from '../../constants/general';
//import ReCAPTCHA from "react-google-recaptcha";
/*import FacebookLogin from 'react-facebook-login';
const responseFacebook = (response) => {
  console.log(response);
}*/var data={'email':'','password':''};//const recaptchaRef = React.createRef();
var Login=function(_Component){_inherits(Login,_Component);function Login(props){_classCallCheck(this,Login);var _this=_possibleConstructorReturn(this,(Login.__proto__||Object.getPrototypeOf(Login)).call(this,props));_this.setUserAcess=function(id,type){var unit=void 0;if(type==="branch"){unit=_this.props.branches.find(function(b){return b.access_id===id;});// es la branch seleccionada x el usr (si puede ver varias)
localStorage.setItem('activeBranch',JSON.stringify(unit.related_access));window.location.href='/orders-managment';}else{unit=_this.props.branchGroups.find(function(b){return b.access_id===id;});// es el branch group seleccionado x el usr (si puede ver varias)
localStorage.setItem('activeBranchGroup',JSON.stringify(unit.related_access));}};_this.sendUserData=function(){/* this.setState({
			isLoading: true
		}) */if(_this.state.validCapta===true){_this.props.login(data);}else{console.log("Eres un robot?");__WEBPACK_IMPORTED_MODULE_7__handlers_Notification__["a" /* default */].show({type:"warning",title:"Eres un robot?",msg:'beeb... boob, beeb'});}};_this.render=function(){console.log("this.props.company_logo",_this.props.company_logo);var logo=_this.props.company_logo?_this.props.company_logo:'';var version="3.1.7"||'1.0.0';if(true){logo=_this.props.company_logo?_this.props.company_logo:'';}else if(process.env.REACT_APP_ENV==="STAGING"){logo=_this.props.company_logo?_this.props.company_logo:'';}var card=void 0,listBranchGroups=void 0,listBranches=void 0;if(_this.props.branchGroups&&_this.props.branchGroups.length>0)listBranchGroups=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["ListGroup"],{className:'mt-2',style:{maxHeight:"270px",overflow:"auto"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["ListGroupItem"],{tag:'button',className:'login-item-list-title',disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-list'}),' ',_this.props.json_lang.login.select_branch_group),_this.props.branchGroups.map(function(b,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["ListGroupItem"],{key:key,tag:'button',onClick:function onClick(e){return _this.setUserAcess(b.access_id,"branch_group");}},b.related_access&&b.related_access.name);}));if(_this.props.branches&&_this.props.branches.length>0)listBranches=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["ListGroup"],{className:'mt-2',style:{maxHeight:"270px",overflow:"auto"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["ListGroupItem"],{tag:'button',className:'login-item-list-title',disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-sitemap'}),' ',_this.props.json_lang.login.select_branch),_this.props.branches.map(function(b,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["ListGroupItem"],{key:key,tag:'button',onClick:function onClick(e){return _this.setUserAcess(b.access_id,"branch");}},b.related_access&&b.related_access.name);}));if(_this.state.activeStep!==1&&_this.props.adminWithoutAccess){card=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Card"],{className:'p-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["CardBody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{display:'block',margin:'0 auto',maxWidth:'100%',height:'90px'},ref:'provider-img',src:logo,onError:function onError(){return _this.refs['provider-img'].src='/assets/img/logo-default-180x64.svg';},alt:""}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{style:{textAlign:'center'}},_this.props.json_lang.login.login_title,' ',_this.props.company_name?_this.props.company_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Su usuario no ha recibido privilegios para entrar a este panel administrativo, por favor comun\xEDquese con alg\xFAn usuario administrativo que le otorgue acceso.')));}else if(_this.state.activeStep===1){card=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Card"],{className:'p-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["CardBody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{display:'block',margin:'0 auto',maxWidth:'100%',height:'90px'},ref:'provider-img',src:logo/*this.props.company_logo?this.props.company_logo:'/assets/img/logo-default-180x64.svg'*/,onError:function onError(){return _this.refs['provider-img'].src='/assets/img/logo-default-180x64.svg';},alt:""}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{style:{textAlign:'center'}},_this.props.json_lang.login.login_title,' ',_this.props.company_name?_this.props.company_name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-muted'},_this.props.json_lang.login.login_subtitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroup"],{className:'mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupAddon"],{addonType:'prepend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupText"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-user'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Input"],{type:'text',name:'email',placeholder:_this.props.json_lang.common.email,onKeyPress:function onKeyPress(_ref){var key=_ref.key;return key==="Enter"?_this.sendUserData():null;},onChange:function onChange(e){return data.email=e.target.value;}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroup"],{className:'mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupAddon"],{addonType:'prepend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupText"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-lock'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Input"],{type:'password',name:'password',placeholder:_this.props.json_lang.login.password_placeholder,onKeyPress:function onKeyPress(_ref2){var key=_ref2.key;return key==="Enter"?_this.sendUserData():null;},onChange:function onChange(e){return data.password=e.target.value;}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:"flex",justifyContent:"center",marginBottom:"1rem"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__hcaptcha_react_hcaptcha__["a" /* default */],{sitekey:_this.props.siteKey,onVerify:function onVerify(token,ekey){return _this.handleVerificationSuccess(token,ekey);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{style:{height:'55px',fontWeight:'bold'},color:'primary btn-block '+(!_this.state.validCapta?'disabled':''),onClick:function onClick(){return _this.sendUserData();}},_this.props.json_lang.login.login_button),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/password-reset',style:{textAlign:'center'},className:'mt-3 btn-block text-muted'},_this.props.json_lang.login.forgot_password_link)));}else if(_this.state.activeStep===2){card=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Card"],{className:'p-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["CardBody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{display:'block',margin:'0 auto',maxWidth:'100%',height:'90px'},ref:'provider-img',src:logo/*this.props.company_logo?this.props.company_logo:'/assets/img/logo-default-180x64.svg'*/,onError:function onError(){return _this.refs['provider-img'].src='/assets/img/logo-default-180x64.svg';},alt:""}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Hola ',_this.props.session.name,', deseas:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),listBranchGroups,listBranches));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app flex-row align-items-center custom_bg'},/* la fecha de exp de la compania es antes que hoy ==> ya se vencio */_this.props.company&&!_this.props.company.enabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:0,textAlign:'center',position:'absolute',top:0,width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Alert"],{color:'warning mb-0'},_this.props.json_lang.default_layout.notification_company_requires_payment)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Row"],{className:'justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Col"],{md:'5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["CardGroup"],null,card),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'p-3 text-center text-muted'},'v',version, false?'':'-'+"DEV")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Plugins___["b" /* Preloader */],null));};_this.state={activeStep:1,validCapta:false//isLoading: false
//captchaRef.current.execute();
};return _this;}_createClass(Login,[{key:'componentWillMount',value:function componentWillMount(){if(localStorage.getItem('user')){this.props.history.push('/');}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){/* if(prevProps.loginError !== this.props.loginError && this.props.loginError === true){
			this.setState({ isLoading: false })
		} */if(prevProps.branches.length!==this.props.branches.length){this.setState({activeStep:2});}/* // esto era para el owner... para el group servira?
			if (prevProps.userHigherAccess !== this.props.userHigherAccess && this.props.userHigherAccess === COMPANY_ACCESS) {
			this.setState({
				activeStep: 2
			})
		} */}},{key:'handleVerificationSuccess',/*ReCAPTCHAaction(){
		if(recaptchaRef.current.getValue()){
			this.setState({validCapta:true})
		}
	}*/value:function handleVerificationSuccess(token,ekey){if(token){this.setState({validCapta:true});}}}]);return Login;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{session:state.session,userHigherAccess:state.userHigherAccess,adminWithoutAccess:state.adminWithoutAccess,loginError:state.loginError,branches:state.branches,branchGroups:state.branchGroups,errors:state.errors,json_lang:state.json_lang,company:state.company,company_logo:state.company_styles_json.company_logo,company_name:state.company.name,//siteKey:'6Lc3MWUbAAAAAFprmTsOkIySY2rkKQDmIuREhbSQ'
siteKey:'e211dd04-09e9-4ba7-a0fd-d0e77fd87a9e'};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setValues:function setValues(target){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_userActions__["l" /* setValues */])(target));},login:function login(user){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_userActions__["h" /* login */])(user));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Login));

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_js__ = __webpack_require__(660);




var SCRIPT_ID = 'hcaptcha-api-script-id';
var HCAPTCHA_LOAD_FN_NAME = 'hcaptchaOnLoad'; // Prevent loading API script multiple times

var resolveFn;
var rejectFn;
var mountPromise = new Promise(function (resolve, reject) {
  resolveFn = resolve;
  rejectFn = reject;
}); // Generate hCaptcha API script

var mountCaptchaScript = function mountCaptchaScript(params) {
  if (params === void 0) {
    params = {};
  }

  if (document.getElementById(SCRIPT_ID)) {
    // API was already requested
    return mountPromise;
  } // Create global onload callback


  window[HCAPTCHA_LOAD_FN_NAME] = resolveFn;
  var domain = params.apihost || "https://js.hcaptcha.com";
  delete params.apihost;
  var script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.src = domain + "/1/api.js?render=explicit&onload=" + HCAPTCHA_LOAD_FN_NAME;
  script.async = true;

  script.onerror = function (event) {
    return rejectFn('script-error');
  };

  var query = Object(__WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* generateQuery */])(params);
  script.src += query !== "" ? "&" + query : "";
  document.head.appendChild(script);
  return mountPromise;
};

var HCaptcha = /*#__PURE__*/function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(HCaptcha, _React$Component);

  function HCaptcha(props) {
    var _this;

    _this = _React$Component.call(this, props) || this; // API Methods

    _this.renderCaptcha = _this.renderCaptcha.bind(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this));
    _this.resetCaptcha = _this.resetCaptcha.bind(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this));
    _this.removeCaptcha = _this.removeCaptcha.bind(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this));
    _this.isReady = _this.isReady.bind(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this)); // Event Handlers

    _this.loadCaptcha = _this.loadCaptcha.bind(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this));
    _this.handleOnLoad = _this.handleOnLoad.bind(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this));
    _this.handleSubmit = _this.handleSubmit.bind(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this));
    _this.handleExpire = _this.handleExpire.bind(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this));
    _this.handleError = _this.handleError.bind(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this));
    _this.handleOpen = _this.handleOpen.bind(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this));
    _this.handleClose = _this.handleClose.bind(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this));
    _this.handleChallengeExpired = _this.handleChallengeExpired.bind(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this));
    var isApiReady = typeof hcaptcha !== 'undefined';
    _this.ref = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createRef"]();
    _this.apiScriptRequested = false;
    _this.state = {
      isApiReady: isApiReady,
      isRemoved: false,
      elementId: props.id,
      captchaId: ''
    };
    return _this;
  }

  var _proto = HCaptcha.prototype;

  _proto.componentDidMount = function componentDidMount() {
    // Once captcha is mounted intialize hCaptcha - hCaptcha
    var isApiReady = this.state.isApiReady;
    /*
     * Check if hCaptcha has already been loaded,
     * If Yes, render the captcha
     * If No, create script tag and wait to render the captcha
     */

    if (isApiReady) {
      this.renderCaptcha();
      return;
    }

    this.loadCaptcha();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var captchaId = this.state.captchaId;

    if (!this.isReady()) {
      return;
    } // Reset any stored variables / timers when unmounting


    hcaptcha.reset(captchaId);
    hcaptcha.remove(captchaId);
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    // Prevent component re-rendering when these internal state variables are updated
    if (this.state.isApiReady !== nextState.isApiReady || this.state.isRemoved !== nextState.isRemoved) {
      return false;
    }

    return true;
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    // Prop Keys that could change
    var keys = ['sitekey', 'size', 'theme', 'tabindex', 'languageOverride', 'endpoint']; // See if any props changed during component update

    var match = keys.every(function (key) {
      return prevProps[key] === _this2.props[key];
    }); // If they have changed, remove current captcha and render a new one

    if (!match) {
      this.removeCaptcha(function () {
        _this2.renderCaptcha();
      });
    }
  };

  _proto.loadCaptcha = function loadCaptcha() {
    if (this.apiScriptRequested) {
      return;
    }

    var _this$props = this.props,
        apihost = _this$props.apihost,
        assethost = _this$props.assethost,
        endpoint = _this$props.endpoint,
        host = _this$props.host,
        imghost = _this$props.imghost,
        hl = _this$props.languageOverride,
        reCaptchaCompat = _this$props.reCaptchaCompat,
        reportapi = _this$props.reportapi,
        sentry = _this$props.sentry,
        custom = _this$props.custom;
    var mountParams = {
      apihost: apihost,
      assethost: assethost,
      endpoint: endpoint,
      hl: hl,
      host: host,
      imghost: imghost,
      recaptchacompat: reCaptchaCompat === false ? "off" : null,
      reportapi: reportapi,
      sentry: sentry,
      custom: custom
    };
    mountCaptchaScript(mountParams).then(this.handleOnLoad)["catch"](this.handleError);
    this.apiScriptRequested = true;
  };

  _proto.renderCaptcha = function renderCaptcha(onReady) {
    var isApiReady = this.state.isApiReady;
    if (!isApiReady) return;
    var renderParams = Object.assign({
      "open-callback": this.handleOpen,
      "close-callback": this.handleClose,
      "error-callback": this.handleError,
      "chalexpired-callback": this.handleChallengeExpired,
      "expired-callback": this.handleExpire,
      "callback": this.handleSubmit
    }, this.props, {
      hl: this.props.hl || this.props.languageOverride,
      languageOverride: undefined
    }); //Render hCaptcha widget and provide necessary callbacks - hCaptcha

    var captchaId = hcaptcha.render(this.ref.current, renderParams);
    this.setState({
      isRemoved: false,
      captchaId: captchaId
    }, function () {
      onReady && onReady();
    });
  };

  _proto.resetCaptcha = function resetCaptcha() {
    var captchaId = this.state.captchaId;

    if (!this.isReady()) {
      return;
    } // Reset captcha state, removes stored token and unticks checkbox


    hcaptcha.reset(captchaId);
  };

  _proto.removeCaptcha = function removeCaptcha(callback) {
    var captchaId = this.state.captchaId;

    if (!this.isReady()) {
      return;
    }

    this.setState({
      isRemoved: true
    }, function () {
      hcaptcha.remove(captchaId);
      callback && callback();
    });
  };

  _proto.handleOnLoad = function handleOnLoad() {
    var _this3 = this;

    this.setState({
      isApiReady: true
    }, function () {
      // render captcha and wait for captcha id
      _this3.renderCaptcha(function () {
        // trigger onLoad if it exists
        var onLoad = _this3.props.onLoad;
        if (onLoad) onLoad();
      });
    });
  };

  _proto.handleSubmit = function handleSubmit(event) {
    var onVerify = this.props.onVerify;
    var _this$state = this.state,
        isRemoved = _this$state.isRemoved,
        captchaId = _this$state.captchaId;
    if (typeof hcaptcha === 'undefined' || isRemoved) return;
    var token = hcaptcha.getResponse(captchaId); //Get response token from hCaptcha widget

    var ekey = hcaptcha.getRespKey(captchaId); //Get current challenge session id from hCaptcha widget

    onVerify(token, ekey); //Dispatch event to verify user response
  };

  _proto.handleExpire = function handleExpire() {
    var onExpire = this.props.onExpire;
    var captchaId = this.state.captchaId;

    if (!this.isReady()) {
      return;
    }

    hcaptcha.reset(captchaId); // If hCaptcha runs into error, reset captcha - hCaptcha

    if (onExpire) onExpire();
  };

  _proto.handleError = function handleError(event) {
    var onError = this.props.onError;
    var captchaId = this.state.captchaId;

    if (this.isReady()) {
      // If hCaptcha runs into error, reset captcha - hCaptcha
      hcaptcha.reset(captchaId);
    }

    if (onError) onError(event);
  };

  _proto.isReady = function isReady() {
    var _this$state2 = this.state,
        isApiReady = _this$state2.isApiReady,
        isRemoved = _this$state2.isRemoved;
    return isApiReady && !isRemoved;
  };

  _proto.handleOpen = function handleOpen() {
    if (!this.isReady() || !this.props.onOpen) {
      return;
    }

    this.props.onOpen();
  };

  _proto.handleClose = function handleClose() {
    if (!this.isReady() || !this.props.onClose) {
      return;
    }

    this.props.onClose();
  };

  _proto.handleChallengeExpired = function handleChallengeExpired() {
    if (!this.isReady() || !this.props.onChalExpired) {
      return;
    }

    this.props.onChalExpired();
  };

  _proto.execute = function execute(opts) {
    if (opts === void 0) {
      opts = null;
    }

    var captchaId = this.state.captchaId;

    if (!this.isReady()) {
      return;
    }

    if (opts && typeof opts !== "object") {
      opts = null;
    }

    return hcaptcha.execute(captchaId, opts);
  };

  _proto.setData = function setData(data) {
    var captchaId = this.state.captchaId;

    if (!this.isReady()) {
      return;
    }

    if (data && typeof data !== "object") {
      data = null;
    }

    hcaptcha.setData(captchaId, data);
  };

  _proto.getResponse = function getResponse() {
    return hcaptcha.getResponse(this.state.captchaId);
  };

  _proto.getRespKey = function getRespKey() {
    return hcaptcha.getRespKey(this.state.captchaId);
  };

  _proto.render = function render() {
    var elementId = this.state.elementId;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
      ref: this.ref,
      id: elementId
    });
  };

  return HCaptcha;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (HCaptcha);

/***/ }),
/* 657 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(659);
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}
module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 659 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateQuery; });
function generateQuery(params) {
  return Object.entries(params).filter(function (_ref) {
    var key = _ref[0],
        value = _ref[1];
    return value || value === false;
  }).map(function (_ref2) {
    var key = _ref2[0],
        value = _ref2[1];
    return encodeURIComponent(key) + "=" + encodeURIComponent(value);
  }).join("&");
}

;


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Page404=function(_Component){_inherits(Page404,_Component);function Page404(){_classCallCheck(this,Page404);return _possibleConstructorReturn(this,(Page404.__proto__||Object.getPrototypeOf(Page404)).apply(this,arguments));}_createClass(Page404,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app flex-row align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Row"],{className:'justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Col"],{md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'float-left display-3 mr-4'},'404'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'pt-3'},'Oops! You\'re lost.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-muted float-left'},'The page you are looking for was not found.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroup"],{className:'input-prepend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupAddon"],{addonType:'prepend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupText"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-search'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Input"],{size:'16',type:'text',placeholder:'What are you looking for?'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupAddon"],{addonType:'append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{color:'info'},'Search')))))));}}]);return Page404;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Page404);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Page500=function(_Component){_inherits(Page500,_Component);function Page500(){_classCallCheck(this,Page500);return _possibleConstructorReturn(this,(Page500.__proto__||Object.getPrototypeOf(Page500)).apply(this,arguments));}_createClass(Page500,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app flex-row align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Row"],{className:'justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Col"],{md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'float-left display-3 mr-4'},'500'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'pt-3'},'Houston, we have a problem!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-muted float-left'},'The page you are looking for is temporarily unavailable.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroup"],{className:'input-prepend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupAddon"],{addonType:'prepend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupText"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-search'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Input"],{size:'16',type:'text',placeholder:'What are you looking for?'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupAddon"],{addonType:'append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{color:'info'},'Search')))))));}}]);return Page500;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Page500);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_userActions__ = __webpack_require__(24);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var user={name:'',display_name:'',phone:'',Password:'',email:''};var Register=function(_Component){_inherits(Register,_Component);function Register(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Register);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Register.__proto__||Object.getPrototypeOf(Register)).call.apply(_ref,[this].concat(args))),_this),_this.has=function(field){if(_this.props.errors.errors.hasOwnProperty(field)){return true;}else{return false;}},_this.get=function(field){if(_this.props.errors.hasOwnProperty(field)){return _this.props.errors[field][0];}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Register,[{key:'componentWillMount',value:function componentWillMount(){if(localStorage.getItem('user')){this.props.history.push('/dashboard');}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app flex-row align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Row"],{className:'justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Col"],{md:'8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["CardGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Card"],{className:'p-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["CardBody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Get Started'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-muted'},'Fill your information to be part of us'),this.has('name')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'is-invalid'},this.get('name')):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroup"],{className:'mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupAddon"],{addonType:'prepend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupText"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-user'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Input"],{type:'text',className:this.has('name')?'is-invalid':'',placeholder:'Name',onKeyUp:function onKeyUp(e){return user.name=e.target.value;}})),this.has('display_name')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'is-invalid'},this.get('display_name')):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroup"],{className:'mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupAddon"],{addonType:'prepend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupText"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-user'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Input"],{type:'text',className:this.has('display_name')?'is-invalid':'',placeholder:'Display name',onKeyUp:function onKeyUp(e){return user.display_name=e.target.value;}})),this.has('phone')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'is-invalid'},this.get('phone')):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroup"],{className:'mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupAddon"],{addonType:'prepend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupText"],null,'@')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Input"],{type:'text',name:'phone',className:this.has('phone')?'is-invalid':'',placeholder:'phone',onKeyUp:function onKeyUp(e){return user.phone=e.target.value;}})),this.has('password')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'is-invalid'},this.get('password')):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroup"],{className:'mb-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupAddon"],{addonType:'prepend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupText"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-briefcase'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Input"],{type:'password',placeholder:'Password',className:this.has('name')?'is-invalid':'',onKeyUp:function onKeyUp(e){return user.Password=e.target.value;}})),this.has('email')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'is-invalid'},this.get('email')):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroup"],{className:'mb-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupAddon"],{addonType:'prepend'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["InputGroupText"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icon-briefcase'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Input"],{type:'email',placeholder:'email',className:this.has('email')?'is-invalid':'',onKeyUp:function onKeyUp(e){return user.email=e.target.value;}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Col"],{xs:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{color:'primary',className:'px-4',onClick:function onClick(){return _this2.props.register(user);}},'Continue'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Card"],{className:'text-white bg-primary py-5 d-md-down-none',style:{width:44+'%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["CardBody"],{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Sign up'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/login'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{color:'primary',className:'mt-3',active:true},'Sign in!'))))))))));}}]);return Register;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{user:state.user,errors:state.errors};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setValues:function setValues(target){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_userActions__["l" /* setValues */])(target));}//register: (data) => dispatch(register(data))
};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Register));

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_userActions__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(13);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Email=function(_Component){_inherits(Email,_Component);function Email(props){_classCallCheck(this,Email);var _this=_possibleConstructorReturn(this,(Email.__proto__||Object.getPrototypeOf(Email)).call(this,props));_this.onChange=function(target){var name=target.name,value=target.value;_this.setState(_defineProperty({},name,value));};_this.sendmail=function(email,type){_this.props.forgotPasword(email,'admin').then(function(res){_this.setState({email:'',selected:''});}).catch(function(err){console.log("error");});};_this.hexToRgbA=function(hex){var c;if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){c=hex.substring(1).split('');if(c.length===3){c=[c[0],c[0],c[1],c[1],c[2],c[2]];}c='0x'+c.join('');return'rgba('+[c>>16&255,c>>8&255,c&255].join(',')+',.7)';}throw new Error('Bad Hex');};_this.render=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app flex-row align-items-center custom_bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Row"],{className:'justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Col"],{xs:'12',sm:'12',md:'5',lg:'5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Card"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["CardHeader"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,_this.props.json_lang.login.forgot_password_link)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["CardBody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["FormGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Label"],{className:'text-muted mt-3',htmlFor:'email'},_this.props.json_lang.common.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Input"],{ref:'email',type:'text',name:'email',placeholder:_this.props.json_lang.common.email,value:_this.state.email,onChange:function onChange(e){return _this.onChange(e.target);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:'/login'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{color:'link',className:'px-0'},_this.props.json_lang.common.home)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{className:'pull-right',color:'primary',onClick:function onClick(){return _this.sendmail(_this.state.email,_this.state.selected);}},_this.props.json_lang.common.continue)))))));};_this.state={email:'',selected:''};return _this;}return Email;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{errors:state.errors,account:state.account,json_lang:state.json_lang};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{forgotPasword:function forgotPasword(email,type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_userActions__["d" /* forgotPasword */])(email,type));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Email));

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_userActions__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_companyActions__ = __webpack_require__(31);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Password=function(_Component){_inherits(Password,_Component);function Password(props){_classCallCheck(this,Password);var _this=_possibleConstructorReturn(this,(Password.__proto__||Object.getPrototypeOf(Password)).call(this,props));_this.onChange=function(target){var name=target.name,value=target.value,data={'name':name,'data':value};_this.props.toggleData(data);};_this.render=function(){var accountType='falta tipo de usuario';if(_this.props.account.client){accountType='client';}else if(_this.props.account.provider){accountType='provider';}else if(_this.props.account.admin){accountType='admin';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app flex-row align-items-center custom_bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Row"],{className:'justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],{xs:'12',sm:'12',md:'5',lg:'5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Card"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["CardHeader"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'text-center mb-0'},'Bienvenido - Crea tu contrase\xF1a')),_this.props.account&&_this.props.account.company_id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["CardBody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["FormGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Label"],null,'Nombre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Input"],{disabled:true,type:'name',name:'name',value:_this.props.account.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["FormGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Label"],null,'Tel\xE9fono'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Input"],{disabled:true,type:'phone',name:'phone',value:_this.props.account.phone})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["FormGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Label"],null,'Correo electr\xF3nico'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Input"],{disabled:true,type:'email',name:'email',value:_this.props.account.email})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["FormGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Label"],{htmlFor:'password'},_this.props.json_lang.confirmation.password),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Input"],{type:'password',name:'password',placeholder:_this.props.json_lang.confirmation.password,value:_this.props.account.password?_this.props.account.password:'',onChange:function onChange(e){return _this.onChange(e.target);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["FormGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Label"],{htmlFor:'password_confirmation'},_this.props.json_lang.confirmation.confirm_password),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Input"],{type:'password',name:'password_confirm',placeholder:_this.props.json_lang.confirmation.confirm_password,value:_this.props.account.password_confirm?_this.props.account.password_confirm:'',onChange:function onChange(e){return _this.onChange(e.target);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Button"],{color:'primary btn-block',className:'px-4',disabled:_this.props.account.company_id!==''&&_this.props.account.password!==''&&_this.props.account.password_confirm!==''&&_this.props.account.password===_this.props.account.password_confirm?false:true,style:{height:'55px',fontWeight:'bold'},onClick:function onClick(){return _this.props.recoverPasword(accountType);}},' ',_this.props.json_lang.common.save)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["CardBody"],null))))));};_this.state={};_this.props.find(_this.props.match.params.id,_this.props.match.params.token);return _this;}return Password;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{errors:state.errors,account:state.account,json_lang:state.json_lang,company:state.company};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{find:function find(id,token){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_userActions__["c" /* find */])(id,token));},toggleData:function toggleData(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_userActions__["p" /* toggleData */])(data));},recoverPasword:function recoverPasword(type){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_userActions__["j" /* recoverPasword */])(type));},findCompany:function findCompany(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_companyActions__["V" /* findCompany */])(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Password));

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_paymentActions__ = __webpack_require__(241);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Confirmation=function(_Component){_inherits(Confirmation,_Component);function Confirmation(props){_classCallCheck(this,Confirmation);var _this=_possibleConstructorReturn(this,(Confirmation.__proto__||Object.getPrototypeOf(Confirmation)).call(this,props));if(_this.props.match.params.id&&_this.props.location.search){_this.props.confirmCheckout(_this.props.match.params.id,_this.props.location.search.substring(1));}return _this;}_createClass(Confirmation,[{key:'render',value:function render(){var response=this.props.json_lang.http_codes.general_success;var responseColor='text-success';if(this.props.paymentResponse&&this.props.paymentResponse.message){response=this.props.json_lang.http_codes[this.props.paymentResponse&&this.props.paymentResponse.message];responseColor='text-danger';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app flex-row align-items-center custom_bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Row"],{className:'justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],{md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Card"],{className:'p-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["CardBody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:responseColor},response)))))));}}]);return Confirmation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{company:state.company,json_lang:state.json_lang,paymentResponse:state.paymentResponse};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{confirmCheckout:function confirmCheckout(id,qs){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_paymentActions__["i" /* confirmCheckout */])(id,qs));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Confirmation));

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_userActions__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_companyActions__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Plugins___ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__handlers_Notification__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__handlers_RequestHandler__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PayoutAccounts__ = __webpack_require__(668);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import GenericCropter from '../Plugins/Dropzone/GenericCropter';
var Confirmation=function(_Component){_inherits(Confirmation,_Component);function Confirmation(props){_classCallCheck(this,Confirmation);var _this=_possibleConstructorReturn(this,(Confirmation.__proto__||Object.getPrototypeOf(Confirmation)).call(this,props));_this.onChange=function(_ref){var name=_ref.name,value=_ref.value;var account=_this.state.account;var validPassword=_this.state.validPassword;var validConfirmPassword=_this.state.validConfirmPassword;var updatedAccount=Object.assign({},account,_defineProperty({},name,value));if(name==="password"){if(value.length>0&&value.length<5){validPassword=false;}else{validPassword=true;}if(updatedAccount.password_confirm!==""&&value!==updatedAccount.password_confirm){validConfirmPassword=false;}else{validConfirmPassword=true;}}if(name==="password_confirm"){if(updatedAccount.password.length!==0&&updatedAccount.password!==value){validConfirmPassword=false;}else{validConfirmPassword=true;}}if(name==="vehicle_type"||name==="service_type"){updatedAccount=Object.assign({},account,_defineProperty({},name,Number(value)));}_this.setState({account:updatedAccount,validPassword:validPassword,validConfirmPassword:validConfirmPassword});};_this.isFormValid=function(){var account=_this.state.account;var isNumber=function isNumber(value){return!isNaN(value)&&typeof value==='number';};return account.brand&&account.model&&account.color&&account.plate&&account.year&&isNumber(account.service_type)&&isNumber(account.vehicle_type);};_this.storeAccount=function(){var account=_this.state.account;var validname=Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["u" /* nameValidateRegex */])(account.name);if(!validname){__WEBPACK_IMPORTED_MODULE_7__handlers_Notification__["a" /* default */].show({type:"warning",title:_this.props.json_lang.custom_errors.user_registration_failed,msg:'Nombre con caracteres invalidos'});}else if(account.provider&&account.is_deliverer&&!_this.isFormValid()){__WEBPACK_IMPORTED_MODULE_7__handlers_Notification__["a" /* default */].show({type:"warning",title:_this.props.json_lang.custom_errors.user_registration_failed,msg:'Complete todos los campos por favor'});}else{_this.props.confirmRegister(account);}};_this.handleStoreAccount=function(){var _this$state=_this.state,step=_this$state.step,account=_this$state.account;if(account.provider&&step===1){if(account.is_deliverer){_this.setState({step:2});}else{_this.setState({step:3});}}else{_this.storeAccount();}};_this.handleDisabledFirstButton=function(){var _this$state2=_this.state,account=_this$state2.account,validPassword=_this$state2.validPassword,validConfirmPassword=_this$state2.validConfirmPassword,accept=_this$state2.accept;if(account.provider){return!(validPassword&&validConfirmPassword&&accept);}else{return!(validPassword&&validConfirmPassword);}};_this.imageRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])();_this.state={step:1,account:{password:"",password_confirm:""},validPassword:false,validConfirmPassword:false,validatePaymentForm:false,accept:false,vehicles:[],services:[],loadingVehicles:true,loadingServices:true};if(_this.props.match.params.id&&_this.props.match.params.token){_this.props.find(_this.props.match.params.id,_this.props.match.params.token).then(function(){if(_this.props.account&&_this.props.account.company_id){_this.props.findCompany(_this.props.account.company_id).then(function(){if(_this.props.account&&_this.props.account.client){_this.props.validateRegister(_this.props.account);}else{if(_this.props.account.provider){__WEBPACK_IMPORTED_MODULE_8__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_9__config__["d" /* URLsmall */]+'vehicle-types?limit=0').then(function(res){_this.setState(function(prevState){return{vehicles:res.data,loadingVehicles:false,account:Object.assign({},prevState.account,{vehicle_type:Number(res.data[0].id)})};});});__WEBPACK_IMPORTED_MODULE_8__handlers_RequestHandler__["a" /* axios */].get(__WEBPACK_IMPORTED_MODULE_9__config__["d" /* URLsmall */]+'service-types?limit=0').then(function(res){_this.setState(function(prevState){return{services:res.data,loadingServices:false,account:Object.assign({},prevState.account,{service_type:Number(res.data[0].id)})};});});}_this.setState(function(prevState){return{account:Object.assign({},prevState.account,_this.props.account)};});}}).catch(function(err){console.log("error en validar cliente",err);});}else{_this.props.history.push('/invalidate/'+_this.props.match.params.id+'/'+_this.props.match.params.token);}}).catch(function(err){console.log("error",err);});}return _this;}_createClass(Confirmation,[{key:'render',value:function render(){var _this2=this;var _props=this.props,companyLogo=_props.companyLogo,json_lang=_props.json_lang,dropzoneActive=_props.dropzoneActive;var _state=this.state,step=_state.step,account=_state.account,validPassword=_state.validPassword,validConfirmPassword=_state.validConfirmPassword,services=_state.services,vehicles=_state.vehicles,accept=_state.accept,validatePaymentForm=_state.validatePaymentForm,loadingServices=_state.loadingServices,loadingVehicles=_state.loadingVehicles;var invalidPasswordText="La contraseña debe ser mayor a 5 dígitos";var invalidConfirmPasswordText="Las contraseñas deben coincidir";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app flex-row align-items-center custom_bg'},account&&(account.provider||account.admin)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Row"],{className:'justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],{md:'5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Card"],{className:'p-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["CardBody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{display:'block',margin:'0 auto',maxWidth:'100%',height:'90px'},ref:this.imageRef,src:companyLogo||'/assets/img/logo-default-180x64.svg',onError:function onError(){return _this2.imageRef.src='/assets/img/logo-default-180x64.svg';},alt:"Company Logo"}),step===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'text-center mb-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Bienvenido, crea tu contrase\xF1a')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:dropzoneActive?'off-hidden':undefined},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["InputGroup"],{className:'mb-3',style:{height:'55px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Input"],{id:'name',type:'text',name:'name',placeholder:json_lang.common.name,value:account.name||'',onChange:function onChange(e){return _this2.onChange(e.target);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["InputGroup"],{className:'mb-3',style:{height:'55px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Input"],{type:'text',name:'phone',placeholder:json_lang.common.phone,value:account.phone||'',onChange:function onChange(e){return _this2.onChange(e.target);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["InputGroup"],{className:'mb-3',style:{height:'55px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Input"],{type:'email',name:'email',placeholder:json_lang.common.email,value:account.email||'',onChange:function onChange(e){return _this2.onChange(e.target);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["InputGroup"],{className:'mb-3 d-flex flex-column w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Input"],{type:'password',name:'password',className:'w-100',style:{height:'55px'},placeholder:json_lang.confirmation.password,value:account.password||'',onChange:function onChange(e){return _this2.onChange(e.target);}}),!validPassword&&account.password!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-danger d-inline-block'},invalidPasswordText)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["InputGroup"],{className:'mb-3 d-flex flex-column w-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Input"],{type:'password',name:'password_confirm',className:'w-100',style:{height:'55px'},placeholder:json_lang.confirmation.confirm_password,value:account.password_confirm||'',onChange:function onChange(e){return _this2.onChange(e.target);}}),!validConfirmPassword&&account.password_confirm!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-danger'},invalidConfirmPasswordText)),account.provider&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["InputGroup"],{className:'mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',className:'mr-2',onChange:function onChange(){return _this2.setState({accept:!accept});},checked:accept}),'Acepto los ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'ml-1',href:'https://rideryconductores.com/terminos-y-condiciones/',target:'_blank'},'t\xE9rminos y condiciones')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Button"],{color:'primary btn-block',className:'px-4',disabled:this.handleDisabledFirstButton(),style:{height:'55px',fontWeight:'bold'},onClick:function onClick(){return _this2.handleStoreAccount();}},account.provider?json_lang.common.continue:json_lang.common.save))),step===2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'text-center mb-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Completa los datos de tu veh\xEDculo')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Label"],{className:'text-muted'},'Tipo de servicio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control w-100 mb-2',style:{height:"50px"},name:'service_type',disabled:loadingServices||services.length===0,onChange:function onChange(e){return _this2.onChange(e.target);},value:loadingServices?"loading":account.service_type||"not_found"},loadingServices?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:"loading",disabled:true},'Cargando...'):services&&services.length!==0?services.map(function(service,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,name:'service_type',value:Number(service.id)},service.name);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:"not_found",disabled:true},'No hay servicios disponibles')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Label"],{className:'text-muted'},'Tipo de veh\xEDculo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control w-100 mb-2',style:{height:"50px"},name:'vehicle_type',disabled:loadingVehicles||vehicles.length===0,onChange:function onChange(e){return _this2.onChange(e.target);},value:loadingVehicles?"loading":account.vehicle_type||"not_found"},loadingVehicles?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:"loading",disabled:true},'Cargando...'):vehicles&&vehicles.length!==0?vehicles.map(function(vehicle,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,name:'vehicle_type',value:Number(vehicle.id)},vehicle.name);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:"not_found",disabled:true},'No hay veh\xEDculos disponibles')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Label"],{className:'text-muted mt-2'},'Datos de veh\xEDculo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["InputGroup"],{className:'mb-3',style:{height:'55px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Input"],{type:'text',name:'brand',placeholder:"Marca",value:account.brand||'',onChange:function onChange(e){return _this2.onChange(e.target);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["InputGroup"],{className:'mb-3',style:{height:'55px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Input"],{type:'text',name:'model',placeholder:"Modelo",value:account.model||'',onChange:function onChange(e){return _this2.onChange(e.target);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["InputGroup"],{className:'mb-3',style:{height:'55px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Input"],{type:'text',name:'color',placeholder:"Color",value:account.color||'',onChange:function onChange(e){return _this2.onChange(e.target);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["InputGroup"],{className:'mb-3',style:{height:'55px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Input"],{type:'text',name:'plate',placeholder:"Placa",value:account.plate||'',onChange:function onChange(e){return _this2.onChange(e.target);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["InputGroup"],{className:'mb-3',style:{height:'55px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Input"],{type:'number',name:'year',placeholder:"Año",value:account.year||'',onChange:function onChange(e){return _this2.onChange(e.target);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex flex-row justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Button"],{color:'ghost',className:'w-50 mr-2',style:{height:'55px',fontWeight:'bold'},onClick:function onClick(){return _this2.setState({step:1});}},'Volver'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Button"],{color:'primary',className:'w-50 ml-2',disabled:!this.isFormValid(),style:{height:'55px',fontWeight:'bold'},onClick:function onClick(){return _this2.setState({step:3});}},json_lang.common.continue))),step===3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'text-center mb-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Completa tus datos de pago')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__PayoutAccounts__["a" /* default */],{key:"payout_accounts",validatePaymentForm:function validatePaymentForm(validate){return _this2.setState({validatePaymentForm:validate});},appendPayoutAccount:function appendPayoutAccount(payoutData){return _this2.setState(function(prevState){return{account:Object.assign({},prevState.account,{payout_accounts:payoutData})};});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex flex-row justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Button"],{color:'ghost',className:'w-50 mr-2',style:{height:'55px',fontWeight:'bold'},onClick:function onClick(){return _this2.setState({step:account.is_deliverer?2:1});}},'Volver'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Button"],{color:'primary',className:'w-50 ml-2',disabled:!validatePaymentForm,style:{height:'55px',fontWeight:'bold'},onClick:function onClick(){return _this2.storeAccount();}},json_lang.common.save)))))))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Plugins___["b" /* Preloader */],null));}}]);return Confirmation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{errors:state.errors,account:state.account,company:state.company,json_lang:state.json_lang,dropzoneActive:state.dropzoneActive,dropzoneFiles:state.dropzoneFiles,companyLogo:state.company&&state.company.styles_json&&state.company.styles_json.styles&&state.company.styles_json.styles.company_logo};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{find:function find(id,token){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_userActions__["c" /* find */])(id,token));},confirmRegister:function confirmRegister(user){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_userActions__["b" /* confirmRegister */])(user));},toggleData:function toggleData(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_userActions__["p" /* toggleData */])(data));},findCompany:function findCompany(id){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__store_actions_companyActions__["V" /* findCompany */])(id));},validateRegister:function validateRegister(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_userActions__["r" /* validateRegister */])(data));},nameValidateRegex:function nameValidateRegex(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__store_actions_UtilsOperation__["u" /* nameValidateRegex */])(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Confirmation));

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Plugins_SpecialForm__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_general__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__handlers_Notification__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PayoutAccounts=function(_Component){_inherits(PayoutAccounts,_Component);function PayoutAccounts(props){_classCallCheck(this,PayoutAccounts);var _this=_possibleConstructorReturn(this,(PayoutAccounts.__proto__||Object.getPrototypeOf(PayoutAccounts)).call(this,props));_this.closeModal=function(){if(_this.props&&_this.props.reference){_this.props.reference();}};var banks=__WEBPACK_IMPORTED_MODULE_4__constants_general__["d" /* BANCOS_VENEZUELA */].map(function(bank){return{value:bank,name:bank};});_this.state={banks:banks,bankTransferForms:{},pmForms:{},paymentType:"bankTransferForms"};return _this;}_createClass(PayoutAccounts,[{key:'componentDidMount',value:function componentDidMount(){this.validateForm();}},{key:'onBankFormChange',value:function onBankFormChange(event){var _this2=this;var name=event.name,value=event.value;name==='account'||name==='document'?value=value.replace(/[^0-9]/g,''):null;this.setState(function(prevState){return{bankTransferForms:Object.assign({},prevState.bankTransferForms,_defineProperty({},name,value||""))};},function(){return _this2.validateForm();});}},{key:'onPmFormChange',value:function onPmFormChange(event){var _this3=this;var name=event.name,value=event.value;name==='phone'||name==='document'?value=value.replace(/[^0-9]/g,''):null;this.setState(function(prevState){return{pmForms:Object.assign({},prevState.pmForms,_defineProperty({},name,value||""))};},function(){return _this3.validateForm();});}},{key:'validateEmail',value:function validateEmail(email){if(email){var emailRegex=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;return emailRegex.test(email);}else{return true;}}},{key:'validateForm',value:function validateForm(){var _state=this.state,bankTransferForms=_state.bankTransferForms,pmForms=_state.pmForms,paymentType=_state.paymentType;var isValid=true;if(paymentType==="bankTransferForms"){isValid&=!!bankTransferForms.bank_name&&!!bankTransferForms.document_prefix&&!!bankTransferForms.document&&!!bankTransferForms.account&&!!bankTransferForms.name&&bankTransferForms.document.length>=6&&bankTransferForms.account.length>=20&&this.validateEmail(bankTransferForms.email);this.props.appendPayoutAccount(bankTransferForms);}if(paymentType==="pmForms"){isValid&=!!pmForms.bank_code&&!!pmForms.document_prefix&&!!pmForms.document&&!!pmForms.phone_prefix&&!!pmForms.phone&&pmForms.document.length>=6&&pmForms.phone.length>=7;this.props.appendPayoutAccount(pmForms);}this.props.validatePaymentForm(isValid===0?false:true);}},{key:'handleSavePaymentType',value:function handleSavePaymentType(){var _state2=this.state,bankTransferForms=_state2.bankTransferForms,pmForms=_state2.pmForms;var newBankTransferData=[];var newPmData=[];var data=[];if(bankTransferForms.bank_name){newBankTransferData=[{bank_name:bankTransferForms.bank_name,document:''+bankTransferForms.document_prefix+bankTransferForms.document,account:bankTransferForms.account,name:bankTransferForms.name,email:bankTransferForms.email||'',type:"national_bank_account"}];data=[].concat(_toConsumableArray(data),_toConsumableArray(newBankTransferData));}if(pmForms.bank_code){newPmData=[{bank_code:pmForms.bank_code,document:''+pmForms.document_prefix+pmForms.document,phone:''+pmForms.phone_prefix+pmForms.phone,type:"mobile_payment"}];data=[].concat(_toConsumableArray(data),_toConsumableArray(newPmData));}}},{key:'handleClearPaymentData',value:function handleClearPaymentData(type){var _this4=this;this.setState(_defineProperty({},type,{}),function(){return _this4.validateForm();});}},{key:'render',value:function render(){var _this5=this;var json_lang=this.props.json_lang;var _state3=this.state,banks=_state3.banks,bankTransferForms=_state3.bankTransferForms,pmForms=_state3.pmForms,paymentType=_state3.paymentType;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control w-100 mb-5',style:{height:"50px"},onChange:function onChange(e){return _this5.setState(_defineProperty({paymentType:e.target.value},e.target.value,{}));},value:paymentType},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'bankTransferForms'},'Transferencia bancaria'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'pmForms'},'Pago m\xF3vil')),paymentType==="bankTransferForms"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],{xs:'24',sm:'12',md:'12',lg:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Plugins_SpecialForm__["h" /* SelectNormal */],{name:"bank_name",label_text:"Banco",text_init:json_lang.common.select_placeholder,options:banks,val:bankTransferForms.bank_name||'',onchange:function onchange(e){return _this5.onBankFormChange(e.target);},className:'h-25',unrequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],{xs:'24',sm:'24',md:'12',lg:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Plugins_SpecialForm__["h" /* SelectNormal */],{name:"document_prefix",label_text:"Tipo",text_init:json_lang.common.select_placeholder,options:__WEBPACK_IMPORTED_MODULE_4__constants_general__["l" /* DNI */],val:bankTransferForms.document_prefix||'',onchange:function onchange(e){return _this5.onBankFormChange(e.target);},className:'w-25 h-25',unrequired:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Plugins_SpecialForm__["a" /* InputNormal */],{name:"document",labelName:"Cédula",maxLength:9,placeholder:'12345678',value:bankTransferForms.document||'',onChange:function onChange(e){return _this5.onBankFormChange(e.target);},className:'w-75 ml-2',unrequired:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],{xs:'12',sm:'12',md:'6',lg:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Plugins_SpecialForm__["a" /* InputNormal */],{name:"account",labelName:"Número de cuenta",placeholder:'01021234567891011121',maxLength:20,value:bankTransferForms.account||'',onChange:function onChange(e){return _this5.onBankFormChange(e.target);},unrequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],{xs:'12',sm:'12',md:'6',lg:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Plugins_SpecialForm__["a" /* InputNormal */],{name:"name",labelName:"Nombre del beneficiario",placeholder:'Pepito P\xE9rez',value:bankTransferForms.name||'',onChange:function onChange(e){return _this5.onBankFormChange(e.target);},unrequired:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],{xs:'24',sm:'24',md:'12',lg:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Plugins_SpecialForm__["a" /* InputNormal */],{name:"email",labelName:"Correo electrónico",placeholder:'nombre@email.com',value:bankTransferForms.email||'',onChange:function onChange(e){return _this5.onBankFormChange(e.target);},unrequired:true})))),paymentType==="pmForms"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],{xs:'24',sm:'24',md:'12',lg:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Plugins_SpecialForm__["h" /* SelectNormal */],{name:"bank_code",label_text:"Banco",text_init:json_lang.common.select_placeholder,options:__WEBPACK_IMPORTED_MODULE_4__constants_general__["K" /* PM_VENEZUELA */],val:pmForms.bank_code||'',onchange:function onchange(e){return _this5.onPmFormChange(e.target);},className:'h-25',unrequired:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],{xs:'24',sm:'24',md:'12',lg:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Plugins_SpecialForm__["h" /* SelectNormal */],{name:"document_prefix",label_text:"Tipo",text_init:json_lang.common.select_placeholder,options:__WEBPACK_IMPORTED_MODULE_4__constants_general__["l" /* DNI */],val:pmForms.document_prefix||'',onchange:function onchange(e){return _this5.onPmFormChange(e.target);},className:'w-25 h-25',unrequired:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Plugins_SpecialForm__["a" /* InputNormal */],{name:"document",labelName:"Cédula",maxLength:9,placeholder:'12345678',value:pmForms.document||'',onChange:function onChange(e){return _this5.onPmFormChange(e.target);},className:'w-75 ml-2',unrequired:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],{xs:'24',sm:'24',md:'12',lg:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Plugins_SpecialForm__["h" /* SelectNormal */],{name:"phone_prefix",label_text:"Operadora",text_init:json_lang.common.select_placeholder,options:__WEBPACK_IMPORTED_MODULE_4__constants_general__["J" /* PM_PREFIX */],val:pmForms.phone_prefix||'',onchange:function onchange(e){return _this5.onPmFormChange(e.target);},className:'w-25 h-25',unrequired:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Plugins_SpecialForm__["a" /* InputNormal */],{name:"phone",labelName:"Teléfono",placeholder:'1234567',maxLength:7,value:pmForms.phone||'',onChange:function onChange(e){return _this5.onPmFormChange(e.target);},className:'w-75 ml-2',unrequired:true}))))));}}]);return PayoutAccounts;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{json_lang:state.json_lang,branch:state.branch};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(PayoutAccounts));

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_initialState__ = __webpack_require__(60);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Confirmed=function(_Component){_inherits(Confirmed,_Component);function Confirmed(){_classCallCheck(this,Confirmed);return _possibleConstructorReturn(this,(Confirmed.__proto__||Object.getPrototypeOf(Confirmed)).apply(this,arguments));}_createClass(Confirmed,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app flex-row align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Row"],{className:'justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Col"],{md:'5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Card"],{className:'p-4 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["CardBody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{display:'block',margin:'0 auto',maxWidth:'100%',height:'90px'},ref:'provider-img',src:this.props.company&&this.props.company.styles_json&&this.props.company.styles_json.styles&&this.props.company.styles_json.styles.company_logo?this.props.company.styles_json.styles.company_logo:'/assets/img/logo-default-180x64.svg',onError:function onError(){return _this2.refs['provider-img'].src='/assets/img/logo-default-180x64.svg';},alt:""}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/assets/img/congratulation.svg',alt:'confirmed',style:{width:"220px",maxWidth:'100%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Felicitaciones!',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' tus datos han sido confirmados'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Button"],{color:'primary',onClick:function onClick(){return window.location.href='https://play.google.com/store/apps/details?id=io.dondemand.provider.zupper';}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-google'}),' Descargar en PlayStore')))))));}}]);return Confirmed;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{errors:state.errors,company:state.company,json_lang:state.json_lang,accountType:state.accountType};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getCompany:function getCompany(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_initialState__["a" /* getCompany */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Confirmed));

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_initialState__ = __webpack_require__(60);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConfirmedClient=function(_Component){_inherits(ConfirmedClient,_Component);function ConfirmedClient(){_classCallCheck(this,ConfirmedClient);return _possibleConstructorReturn(this,(ConfirmedClient.__proto__||Object.getPrototypeOf(ConfirmedClient)).apply(this,arguments));}_createClass(ConfirmedClient,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app flex-row align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Row"],{className:'justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Col"],{md:'5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Card"],{className:'p-4 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["CardBody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{display:'block',margin:'0 auto',maxWidth:'100%',height:'90px'},ref:'provider-img',src:this.props.company&&this.props.company.styles_json&&this.props.company.styles_json.styles&&this.props.company.styles_json.styles.company_logo?this.props.company.styles_json.styles.company_logo:'/assets/img/logo-default-180x64.svg',onError:function onError(){return _this2.refs['provider-img'].src='/assets/img/logo-default-180x64.svg';},alt:""}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/assets/img/congratulation.svg',alt:'confirmed',style:{width:"220px",maxWidth:'100%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Felicitaciones!',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' tus datos han sido confirmados'))))))));}}]);return ConfirmedClient;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{errors:state.errors,company:state.company,json_lang:state.json_lang,accountType:state.accountType};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getCompany:function getCompany(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_initialState__["a" /* getCompany */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ConfirmedClient));

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_userActions__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Confirmation=function(_Component){_inherits(Confirmation,_Component);function Confirmation(props){_classCallCheck(this,Confirmation);var _this=_possibleConstructorReturn(this,(Confirmation.__proto__||Object.getPrototypeOf(Confirmation)).call(this,props));_this.onChange=function(target){var name=target.name,value=target.value,data={'name':name,'data':value};_this.props.toggleData(data);};if(_this.props.match.params.id&&_this.props.match.params.token){_this.props.find(_this.props.match.params.id,_this.props.match.params.token);}return _this;}_createClass(Confirmation,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app flex-row align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Container"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Row"],{className:'justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],{md:'6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Card"],{className:'p-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["CardBody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,this.props.json_lang.invalidate_email.error_explanation_title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-muted justify-content-center'},this.props.account&&this.props.account.length?this.props.json_lang.invalidate_email.error_description_msg:'Token invalido/Usuario ya confirmado'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Row"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Col"],{xs:'12'},this.props.account&&this.props.account.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Button"],{color:'warning',className:'px-4 pull-right',onClick:function onClick(){return _this2.props.invalidateRegister(_this2.props.account);}},this.props.json_lang.invalidate_email.invalidate_button),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'px-4 pull-right btn btn-light mr-2',to:'/'},' ',this.props.json_lang.confirmation.back_button,' ')):null))))))));}}]);return Confirmation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{errors:state.errors,account:state.account,json_lang:state.json_lang};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{find:function find(id,token){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_userActions__["c" /* find */])(id,token));},invalidateRegister:function invalidateRegister(user){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_userActions__["g" /* invalidateRegister */])(user));},toggleData:function toggleData(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__store_actions_userActions__["p" /* toggleData */])(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Confirmation));

/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(1));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_12__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = warn;
function warn(s) {
  console.warn('[react-ga]', s);
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trim;
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().

function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.testModeAPI = exports.OutboundLink = exports.plugin = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.initialize = initialize;
exports.ga = ga;
exports.set = set;
exports.send = send;
exports.pageview = pageview;
exports.modalview = modalview;
exports.timing = timing;
exports.event = event;
exports.exception = exception;
exports.outboundLink = outboundLink;

var _format2 = __webpack_require__(3);

var _format3 = _interopRequireDefault(_format2);

var _removeLeadingSlash = __webpack_require__(6);

var _removeLeadingSlash2 = _interopRequireDefault(_removeLeadingSlash);

var _trim = __webpack_require__(1);

var _trim2 = _interopRequireDefault(_trim);

var _loadGA = __webpack_require__(7);

var _loadGA2 = _interopRequireDefault(_loadGA);

var _warn = __webpack_require__(0);

var _warn2 = _interopRequireDefault(_warn);

var _log = __webpack_require__(8);

var _log2 = _interopRequireDefault(_log);

var _testModeAPI = __webpack_require__(9);

var _testModeAPI2 = _interopRequireDefault(_testModeAPI);

var _OutboundLink = __webpack_require__(10);

var _OutboundLink2 = _interopRequireDefault(_OutboundLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
                                                                                                                                                                                                     * React Google Analytics Module
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * @package react-ga
                                                                                                                                                                                                     * @author  Adam Lofting <adam@mozillafoundation.org>
                                                                                                                                                                                                     *          Atul Varma <atul@mozillafoundation.org>
                                                                                                                                                                                                     */

/**
 * Utilities
 */


var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return _testModeAPI2.default.ga.apply(_testModeAPI2.default, arguments);
  if (!window.ga) return (0, _warn2.default)('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return (0, _format3.default)(s, _titleCase);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];
  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      (0, _warn2.default)('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(undefined, args);
    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(undefined, _toConsumableArray([name + '.' + command].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    (0, _warn2.default)('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (typeof window === 'undefined') {
      return false;
    }

    (0, _loadGA2.default)(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;

  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object') {
        (0, _warn2.default)('All configs must be an object');
        return;
      }
      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }
  return true;
}

/**
 * ga:
 * Returns the original GA object.
 */
function ga() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(undefined, args);
    if (_debug) {
      (0, _log2.default)('called ga(\'arguments\');');
      (0, _log2.default)('with arguments: ' + JSON.stringify(args));
    }
  }

  return window.ga;
}

/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    (0, _warn2.default)('`fieldsObject` is required in .set()');
    return;
  }

  if ((typeof fieldsObject === 'undefined' ? 'undefined' : _typeof(fieldsObject)) !== 'object') {
    (0, _warn2.default)('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    (0, _warn2.default)('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    (0, _log2.default)('called ga(\'set\', fieldsObject);');
    (0, _log2.default)('with fieldsObject: ' + JSON.stringify(fieldsObject));
  }
}

/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);
  if (_debug) {
    (0, _log2.default)('called ga(\'send\', fieldObject);');
    (0, _log2.default)('with fieldObject: ' + JSON.stringify(fieldObject));
    (0, _log2.default)('with trackers: ' + JSON.stringify(trackerNames));
  }
}

/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */
function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    (0, _warn2.default)('path is required in .pageview()');
    return;
  }

  var path = (0, _trim2.default)(rawPath);
  if (path === '') {
    (0, _warn2.default)('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};
  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', _extends({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
      var extraLog = '';
      if (title) {
        extraLog = ' and title: ' + title;
      }
      (0, _log2.default)('with path: ' + path + extraLog);
    }
  }
}

/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    (0, _warn2.default)('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = (0, _removeLeadingSlash2.default)((0, _trim2.default)(rawModalName));

  if (modalName === '') {
    (0, _warn2.default)('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = '/modal/' + modalName;
    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
      (0, _log2.default)('with path: ' + path);
    }
  }
}

/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments[1];

  if (typeof ga === 'function') {
    if (!category || !variable || !value || typeof value !== 'number') {
      (0, _warn2.default)('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    }

    // Required Fields
    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}

/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var trackerNames = arguments[1];

  var category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = _objectWithoutProperties(_ref2, ['category', 'action', 'label', 'value', 'nonInteraction', 'transport']);

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      (0, _warn2.default)('args.category AND args.action are required in event()');
      return;
    }

    // Required Fields
    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    };

    // Optional Fields
    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        (0, _warn2.default)('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        (0, _warn2.default)('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        (0, _warn2.default)('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          (0, _warn2.default)('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });

    // Send to GA
    send(fieldObject, trackerNames);
  }
}

/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */
function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    };

    // Optional Fields
    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        (0, _warn2.default)('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    }

    // Send to GA
    send(fieldObject, trackerNames);
  }
}

var plugin = exports.plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   */
  require: function require(rawName, options) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        (0, _warn2.default)('`name` is required in .require()');
        return;
      }

      var name = (0, _trim2.default)(rawName);
      if (name === '') {
        (0, _warn2.default)('`name` cannot be an empty string in .require()');
        return;
      }

      // Optional Fields
      if (options) {
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
          (0, _warn2.default)('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          (0, _warn2.default)('Empty `options` given to .require()');
        }

        ga('require', name, options);

        if (_debug) {
          (0, _log2.default)('called ga(\'require\', \'' + name + '\', ' + JSON.stringify(options));
        }
      } else {
        ga('require', name);

        if (_debug) {
          (0, _log2.default)('called ga(\'require\', \'' + name + '\');');
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload = void 0;
    var actionType = void 0;

    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
      payload = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      actionType = arguments.length <= 2 ? undefined : arguments[2];
      payload = arguments.length <= 3 ? undefined : arguments[3];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        (0, _warn2.default)('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        (0, _warn2.default)('Expected `action` arg to be a String.');
      } else {
        var command = pluginName + ':' + action;
        payload = payload || null;
        if (actionType && payload) {
          ga(command, actionType, payload);
          if (_debug) {
            (0, _log2.default)('called ga(\'' + command + '\');');
            (0, _log2.default)('actionType: "' + actionType + '" with payload: ' + JSON.stringify(payload));
          }
        } else if (payload) {
          ga(command, payload);
          if (_debug) {
            (0, _log2.default)('called ga(\'' + command + '\');');
            (0, _log2.default)('with payload: ' + JSON.stringify(payload));
          }
        } else {
          ga(command);
          if (_debug) {
            (0, _log2.default)('called ga(\'' + command + '\');');
          }
        }
      }
    }
  }
};

/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */
function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    (0, _warn2.default)('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      (0, _warn2.default)('args.label is required in outboundLink()');
      return;
    }

    // Required Fields
    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };

    var safetyCallbackCalled = false;
    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;

      hitCallback();
    };

    // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data

    // register safety net timeout:
    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);
      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA;

    // Send to GA
    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}

_OutboundLink2.default.origTrackLink = _OutboundLink2.default.trackLink;
_OutboundLink2.default.trackLink = outboundLink;
var OutboundLink = exports.OutboundLink = _OutboundLink2.default;
var testModeAPI = exports.testModeAPI = _testModeAPI2.default;

exports.default = {
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  OutboundLink: OutboundLink,
  testModeAPI: _testModeAPI2.default
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = format;

var _mightBeEmail = __webpack_require__(4);

var _mightBeEmail2 = _interopRequireDefault(_mightBeEmail);

var _toTitleCase = __webpack_require__(5);

var _toTitleCase2 = _interopRequireDefault(_toTitleCase);

var _warn = __webpack_require__(0);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var redacted = 'REDACTED (Potential Email Address)';

function format(s, titleCase) {
  if ((0, _mightBeEmail2.default)(s)) {
    (0, _warn2.default)('This arg looks like an email address, redacting.');
    return redacted;
  }

  if (titleCase) {
    return (0, _toTitleCase2.default)(s);
  }

  return s;
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mightBeEmail;
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return (/[^@]+@[^@]+/.test(s)
  );
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toTitleCase;

var _trim = __webpack_require__(1);

var _trim2 = _interopRequireDefault(_trim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; /**
                                                                                                * To Title Case 2.1 - http://individed.com/code/to-title-case/
                                                                                                * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
                                                                                                * https://github.com/gouch/to-title-case
                                                                                                */

function toTitleCase(string) {
  return (0, _trim2.default)(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeLeadingSlash;
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (options) {
  // https://developers.google.com/analytics/devguides/collection/analyticsjs/
  /* eslint-disable */
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', options && options.gaAddress ? options.gaAddress : 'https://www.google-analytics.com/analytics.js', 'ga');
  /* eslint-enable */
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = log;
function log(s) {
  console.info('[react-ga]', s);
}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var gaCalls = exports.gaCalls = [];

exports.default = {
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  }
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(12);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warn = __webpack_require__(0);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink = function (_Component) {
  _inherits(OutboundLink, _Component);

  function OutboundLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OutboundLink.__proto__ || Object.getPrototypeOf(OutboundLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick;

      var eventMeta = { label: eventLabel };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        });
      } else {
        OutboundLink.trackLink(eventMeta, function () {});
      }

      if (onClick) {
        onClick(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OutboundLink, [{
    key: 'render',
    value: function render() {
      var props = _extends({}, this.props, {
        href: this.props.to,
        onClick: this.handleClick
      });
      delete props.eventLabel;
      return _react2.default.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(_react.Component);

OutboundLink.propTypes = {
  eventLabel: _propTypes2.default.string.isRequired,
  target: _propTypes2.default.string,
  to: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};
OutboundLink.defaultProps = {
  target: null,
  to: null,
  onClick: null
};

OutboundLink.trackLink = function () {
  (0, _warn2.default)('ga tracking not enabled');
};

exports.default = OutboundLink;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

/***/ })
/******/ ]);
});

/***/ }),
/* 676 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(374);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.765aab2d.js